(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var _memoize = require(3);
var wrapper = require(4);

function memoize(getKey) {
  return _memoize(wrapper, getKey);
}

module.exports = memoize;

});
},{"3":3,"4":4,"8":8}],2:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var _retry = require(5);
var wrapper = require(4);

function retry(times, interval, error) {
  return _retry(wrapper, times, interval, error);
}

module.exports = retry;

});
},{"4":4,"5":5,"8":8}],3:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var defaultLogger = require(7);
var keyGetter = require(138);

function memoizeDecorator(wrapper, getKey) {
  getKey = keyGetter(getKey || function () { return '_default'; });
  return wrapper(function (func) {
    var cache = {};
    return function () {
      var context = this;
      var args = Array.prototype.slice.call(arguments, 0);
      var logger = defaultLogger.apply(context);
      var cb = args[args.length - 1];
      var cacheKey = getKey.apply(context, args);
      args[args.length - 1] = function (err, dep) {
        if (!err && cacheKey !== null) {
          cache[cacheKey] = dep;
        }
        cb(err, dep);
      };
      if (cacheKey !== null && cacheKey in cache) {
        logger('memoize-hit', {key: cacheKey, result: cache[cacheKey]});
        return cb(null, cache[cacheKey]);
      }
      else {
        func.apply(context, args);
      }
    };
  });
}

module.exports = memoizeDecorator;

});
},{"138":138,"7":7,"8":8}],4:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var promisify = require(135);
var callbackify = require(6);

// it works for decorator(f) and decorator([f1, f2, f3 ...])

function promiseTranslator(decorator) {
  return function (f) { // f returns a promise
    var cb;
    if (Array.isArray(f)) {
      cb = f.map(callbackify);
    } else {
      cb = callbackify(f);
    }

    return promisify(decorator(cb));
  };
}

module.exports = promiseTranslator;

});
},{"135":135,"6":6,"8":8}],5:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var defaultLogger = require(7);

function retryDecorator(wrapper, times, interval, error) {
  var condition;
  times = times || Infinity;
  error = error || Error;
  interval = interval || 0;
  var intervalFunc = typeof interval === 'function' ?
    interval :
    function () { return interval; };

  if (error === Error || Error.isPrototypeOf(error)) {
    condition = function (err, dep) { return err instanceof error; };
  }
  else {
    condition = error;
  }

  return wrapper(function (func) {
    return function () {
      var counter = 0;
      var context = this;
      var args = Array.prototype.slice.call(arguments, 0);
      var logger = defaultLogger.apply(context);
      var cb = args[args.length - 1];

      var retry = function () {
        if (counter++ && intervalFunc(counter) > 0) { // do not wait for counter === 0
          setTimeout(function () {
            func.apply(context, args);
          }, interval);
        }
        else {
          func.apply(context, args);
        }
      };

      args[args.length - 1] = function (err, dep) {
        if (condition(err, dep) && counter < times) {
          logger('retry', {
            times: counter,
            actualResult: {err: err, res: dep}
          });
          retry();
        }
        else {
          cb(err, dep);
        }
      };
      retry();
    };
  });
}

module.exports = retryDecorator;

});
},{"7":7,"8":8}],6:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
function isPromise(obj) {
  return typeof obj === 'object' && 'then' in obj;
}

function callbackify(func) {
  return function () {
    // get arguments
    var context = this;
    var args = Array.prototype.slice.call(arguments, 0, -1);
    var cb = arguments[arguments.length - 1];
    try {
      var output = func.apply(context, args);
    }
    catch (e) {
      return cb(e);
    }

    if (isPromise(output)) {
      output.then(function (res) { // onfulfilled
        cb(null, res);
      },
      function (error) { // onrejected
        cb(error);
      });
    }
    else {
      cb(null, output);
    }
  };
}

module.exports = callbackify;

});
},{"8":8}],7:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function () {
  if (typeof this === 'object' && '__log' in this) {
    return this.__log;
  }
  return function () {};
};

});
},{"8":8}],8:[function(require,module,exports){
(function (global){
(function (cb){
  var w;
  try {
    w = window;
  } catch (e) {
    w = global;
  }

  var queue = w._async_define_queue = '_async_define_queue' in w ? w._async_define_queue : [];
  var cached_dependencies = w._async_define_cached_dependencies = '_async_define_cached_dependencies' in w ? w._async_define_cached_dependencies : {};

  function getDepsArray(depNames) {
    var i,
      tmp, depNS, depProp,
      len = depNames.length,
      deps = [];

    for (i = 0; i < len; i++) {
      tmp = depNames[i].split('|');
      depNS = tmp[0];
      depProp = tmp[1];
      if (depNS in cached_dependencies){
        deps.push(depProp ? cached_dependencies[depNS][depProp] : cached_dependencies[depNS]);
      }
      else {
        return;
      }
    }
    return deps;
  }

  function runThroughQueue() {
    while (_runThroughQueue());
  }

  function _runThroughQueue() {
    var i = 0;
    var solvedDependency = false;
    while (i < queue.length){
      if (execute(queue[i])){
        if (queue[i].name){
          solvedDependency = true;
        }
        queue.splice(i, 1);
      }
      else {
        i++;
      }
    }
    return solvedDependency;
  }

  function execute (item){
    if (item.name in cached_dependencies) { // don't execute twice
      return true;
    }
    var deps = getDepsArray(item.depNames);
    var exp;
    if (deps){
      exp = item.func.apply(w, deps);
      if (item.name){
        cached_dependencies[item.name] = exp;
      }
      return true;
    }
    else {
      return;
    }
  }

  function wrapObj (o){
    if (typeof o === 'function'){
      return o;
    }
    else {
      return function (){
        return o;
      };
    }
  }

  function ad() {
    var item = {
        name:  typeof arguments[0] === 'string' ? arguments[0] : undefined,
        depNames: Array.isArray(arguments[0]) ? arguments[0] : Array.isArray(arguments[1]) ? arguments[1] : [],
        func: wrapObj(arguments[arguments.length - 1])
    };
    if (!execute(item)){
      queue.push(item);
    }
    else {
      if (item.name){
        runThroughQueue(); // executed straight away, try to resolve func that depends on this
      }
    }
  }
  cb.call(w, ad);
}(function (define) {
  if (typeof exports === 'object'){
  module.exports = define;
}
else{
  this.asyncDefine = define;
}

}));


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],9:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(31), __esModule: true };
});
},{"31":31,"8":8}],10:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(32), __esModule: true };
});
},{"32":32,"8":8}],11:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(33), __esModule: true };
});
},{"33":33,"8":8}],12:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(34), __esModule: true };
});
},{"34":34,"8":8}],13:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(35), __esModule: true };
});
},{"35":35,"8":8}],14:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(36), __esModule: true };
});
},{"36":36,"8":8}],15:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(37), __esModule: true };
});
},{"37":37,"8":8}],16:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(38), __esModule: true };
});
},{"38":38,"8":8}],17:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(39), __esModule: true };
});
},{"39":39,"8":8}],18:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(40), __esModule: true };
});
},{"40":40,"8":8}],19:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(41), __esModule: true };
});
},{"41":41,"8":8}],20:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = { "default": require(42), __esModule: true };
});
},{"42":42,"8":8}],21:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
});
},{"8":8}],22:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

exports.__esModule = true;

var _defineProperty = require(14);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
});
},{"14":14,"8":8}],23:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

exports.__esModule = true;

var _defineProperty = require(14);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};
});
},{"14":14,"8":8}],24:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

exports.__esModule = true;

var _assign = require(12);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
});
},{"12":12,"8":8}],25:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

exports.__esModule = true;

var _setPrototypeOf = require(17);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = require(13);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = require(28);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};
});
},{"13":13,"17":17,"28":28,"8":8}],26:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

exports.__esModule = true;

var _typeof2 = require(28);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};
});
},{"28":28,"8":8}],27:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

exports.__esModule = true;

var _isIterable2 = require(10);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = require(9);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
});
},{"10":10,"8":8,"9":9}],28:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

exports.__esModule = true;

var _iterator = require(20);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require(19);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};
});
},{"19":19,"20":20,"8":8}],29:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = require(155);

});
},{"155":155,"8":8}],30:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){

});
},{"8":8}],31:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(130);
require(126);
module.exports = require(115);
});
},{"115":115,"126":126,"130":130,"8":8}],32:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(130);
require(126);
module.exports = require(116);
});
},{"116":116,"126":126,"130":130,"8":8}],33:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var core  = require(50)
  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};
});
},{"50":50,"8":8}],34:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(118);
module.exports = require(50).Object.assign;
});
},{"118":118,"50":50,"8":8}],35:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(119);
var $Object = require(50).Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};
});
},{"119":119,"50":50,"8":8}],36:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(120);
var $Object = require(50).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};
});
},{"120":120,"50":50,"8":8}],37:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(121);
module.exports = require(50).Object.getPrototypeOf;
});
},{"121":121,"50":50,"8":8}],38:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(122);
module.exports = require(50).Object.keys;
});
},{"122":122,"50":50,"8":8}],39:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(123);
module.exports = require(50).Object.setPrototypeOf;
});
},{"123":123,"50":50,"8":8}],40:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(124);
require(126);
require(130);
require(125);
module.exports = require(50).Promise;
});
},{"124":124,"125":125,"126":126,"130":130,"50":50,"8":8}],41:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(127);
require(124);
require(128);
require(129);
module.exports = require(50).Symbol;
});
},{"124":124,"127":127,"128":128,"129":129,"50":50,"8":8}],42:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(126);
require(130);
module.exports = require(112).f('iterator');
});
},{"112":112,"126":126,"130":130,"8":8}],43:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};
});
},{"8":8}],44:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function(){ /* empty */ };
});
},{"8":8}],45:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};
});
},{"8":8}],46:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var isObject = require(69);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};
});
},{"69":69,"8":8}],47:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require(106)
  , toLength  = require(107)
  , toIndex   = require(104);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};
});
},{"104":104,"106":106,"107":107,"8":8}],48:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require(49)
  , TAG = require(113)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};
});
},{"113":113,"49":49,"8":8}],49:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};
});
},{"8":8}],50:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef
});
},{"8":8}],51:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// optional / simple context binding
var aFunction = require(43);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};
});
},{"43":43,"8":8}],52:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};
});
},{"8":8}],53:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// Thank's IE8 for his funny defineProperty
module.exports = !require(58)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});
});
},{"58":58,"8":8}],54:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var isObject = require(69)
  , document = require(60).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};
});
},{"60":60,"69":69,"8":8}],55:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');
});
},{"8":8}],56:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// all enumerable object keys, includes symbols
var getKeys = require(90)
  , gOPS    = require(87)
  , pIE     = require(91);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};
});
},{"8":8,"87":87,"90":90,"91":91}],57:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var global    = require(60)
  , core      = require(50)
  , ctx       = require(51)
  , hide      = require(62)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;
});
},{"50":50,"51":51,"60":60,"62":62,"8":8}],58:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};
});
},{"8":8}],59:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var ctx         = require(51)
  , call        = require(70)
  , isArrayIter = require(67)
  , anObject    = require(46)
  , toLength    = require(107)
  , getIterFn   = require(114)
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;
});
},{"107":107,"114":114,"46":46,"51":51,"67":67,"70":70,"8":8}],60:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef
});
},{"8":8}],61:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};
});
},{"8":8}],62:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var dP         = require(82)
  , createDesc = require(93);
module.exports = require(53) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};
});
},{"53":53,"8":8,"82":82,"93":93}],63:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = require(60).document && document.documentElement;
});
},{"60":60,"8":8}],64:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = !require(53) && !require(58)(function(){
  return Object.defineProperty(require(54)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});
});
},{"53":53,"54":54,"58":58,"8":8}],65:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};
});
},{"8":8}],66:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require(49);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};
});
},{"49":49,"8":8}],67:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// check on default Array iterator
var Iterators  = require(75)
  , ITERATOR   = require(113)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};
});
},{"113":113,"75":75,"8":8}],68:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 7.2.2 IsArray(argument)
var cof = require(49);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};
});
},{"49":49,"8":8}],69:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};
});
},{"8":8}],70:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// call something on iterator step with safe closing on error
var anObject = require(46);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};
});
},{"46":46,"8":8}],71:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
var create         = require(81)
  , descriptor     = require(93)
  , setToStringTag = require(98)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require(62)(IteratorPrototype, require(113)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};
});
},{"113":113,"62":62,"8":8,"81":81,"93":93,"98":98}],72:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
var LIBRARY        = require(77)
  , $export        = require(57)
  , redefine       = require(95)
  , hide           = require(62)
  , has            = require(61)
  , Iterators      = require(75)
  , $iterCreate    = require(71)
  , setToStringTag = require(98)
  , getPrototypeOf = require(88)
  , ITERATOR       = require(113)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};
});
},{"113":113,"57":57,"61":61,"62":62,"71":71,"75":75,"77":77,"8":8,"88":88,"95":95,"98":98}],73:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var ITERATOR     = require(113)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};
});
},{"113":113,"8":8}],74:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function(done, value){
  return {value: value, done: !!done};
};
});
},{"8":8}],75:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = {};
});
},{"8":8}],76:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var getKeys   = require(90)
  , toIObject = require(106);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};
});
},{"106":106,"8":8,"90":90}],77:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = true;
});
},{"8":8}],78:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var META     = require(110)('meta')
  , isObject = require(69)
  , has      = require(61)
  , setDesc  = require(82).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !require(58)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};
});
},{"110":110,"58":58,"61":61,"69":69,"8":8,"82":82}],79:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var global    = require(60)
  , macrotask = require(103).set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = require(49)(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};
});
},{"103":103,"49":49,"60":60,"8":8}],80:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = require(90)
  , gOPS     = require(87)
  , pIE      = require(91)
  , toObject = require(108)
  , IObject  = require(66)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require(58)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;
});
},{"108":108,"58":58,"66":66,"8":8,"87":87,"90":90,"91":91}],81:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = require(46)
  , dPs         = require(83)
  , enumBugKeys = require(55)
  , IE_PROTO    = require(99)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require(54)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  require(63).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

});
},{"46":46,"54":54,"55":55,"63":63,"8":8,"83":83,"99":99}],82:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var anObject       = require(46)
  , IE8_DOM_DEFINE = require(64)
  , toPrimitive    = require(109)
  , dP             = Object.defineProperty;

exports.f = require(53) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};
});
},{"109":109,"46":46,"53":53,"64":64,"8":8}],83:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var dP       = require(82)
  , anObject = require(46)
  , getKeys  = require(90);

module.exports = require(53) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};
});
},{"46":46,"53":53,"8":8,"82":82,"90":90}],84:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var pIE            = require(91)
  , createDesc     = require(93)
  , toIObject      = require(106)
  , toPrimitive    = require(109)
  , has            = require(61)
  , IE8_DOM_DEFINE = require(64)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = require(53) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};
});
},{"106":106,"109":109,"53":53,"61":61,"64":64,"8":8,"91":91,"93":93}],85:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require(106)
  , gOPN      = require(86).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

});
},{"106":106,"8":8,"86":86}],86:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = require(89)
  , hiddenKeys = require(55).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};
});
},{"55":55,"8":8,"89":89}],87:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
exports.f = Object.getOwnPropertySymbols;
});
},{"8":8}],88:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = require(61)
  , toObject    = require(108)
  , IE_PROTO    = require(99)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};
});
},{"108":108,"61":61,"8":8,"99":99}],89:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var has          = require(61)
  , toIObject    = require(106)
  , arrayIndexOf = require(47)(false)
  , IE_PROTO     = require(99)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};
});
},{"106":106,"47":47,"61":61,"8":8,"99":99}],90:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = require(89)
  , enumBugKeys = require(55);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};
});
},{"55":55,"8":8,"89":89}],91:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
exports.f = {}.propertyIsEnumerable;
});
},{"8":8}],92:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// most Object methods by ES6 should accept primitives
var $export = require(57)
  , core    = require(50)
  , fails   = require(58);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};
});
},{"50":50,"57":57,"58":58,"8":8}],93:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};
});
},{"8":8}],94:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var hide = require(62);
module.exports = function(target, src, safe){
  for(var key in src){
    if(safe && target[key])target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};
});
},{"62":62,"8":8}],95:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = require(62);
});
},{"62":62,"8":8}],96:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = require(69)
  , anObject = require(46);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = require(51)(Function.call, require(84).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};
});
},{"46":46,"51":51,"69":69,"8":8,"84":84}],97:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
var global      = require(60)
  , core        = require(50)
  , dP          = require(82)
  , DESCRIPTORS = require(53)
  , SPECIES     = require(113)('species');

module.exports = function(KEY){
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};
});
},{"113":113,"50":50,"53":53,"60":60,"8":8,"82":82}],98:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var def = require(82).f
  , has = require(61)
  , TAG = require(113)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};
});
},{"113":113,"61":61,"8":8,"82":82}],99:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var shared = require(100)('keys')
  , uid    = require(110);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};
});
},{"100":100,"110":110,"8":8}],100:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var global = require(60)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};
});
},{"60":60,"8":8}],101:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = require(46)
  , aFunction = require(43)
  , SPECIES   = require(113)('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};
});
},{"113":113,"43":43,"46":46,"8":8}],102:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var toInteger = require(105)
  , defined   = require(52);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};
});
},{"105":105,"52":52,"8":8}],103:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var ctx                = require(51)
  , invoke             = require(65)
  , html               = require(63)
  , cel                = require(54)
  , global             = require(60)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(require(49)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};
});
},{"49":49,"51":51,"54":54,"60":60,"63":63,"65":65,"8":8}],104:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var toInteger = require(105)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};
});
},{"105":105,"8":8}],105:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};
});
},{"8":8}],106:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require(66)
  , defined = require(52);
module.exports = function(it){
  return IObject(defined(it));
};
});
},{"52":52,"66":66,"8":8}],107:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 7.1.15 ToLength
var toInteger = require(105)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};
});
},{"105":105,"8":8}],108:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 7.1.13 ToObject(argument)
var defined = require(52);
module.exports = function(it){
  return Object(defined(it));
};
});
},{"52":52,"8":8}],109:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require(69);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};
});
},{"69":69,"8":8}],110:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};
});
},{"8":8}],111:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var global         = require(60)
  , core           = require(50)
  , LIBRARY        = require(77)
  , wksExt         = require(112)
  , defineProperty = require(82).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};
});
},{"112":112,"50":50,"60":60,"77":77,"8":8,"82":82}],112:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
exports.f = require(113);
});
},{"113":113,"8":8}],113:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var store      = require(100)('wks')
  , uid        = require(110)
  , Symbol     = require(60).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;
});
},{"100":100,"110":110,"60":60,"8":8}],114:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var classof   = require(48)
  , ITERATOR  = require(113)('iterator')
  , Iterators = require(75);
module.exports = require(50).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};
});
},{"113":113,"48":48,"50":50,"75":75,"8":8}],115:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var anObject = require(46)
  , get      = require(114);
module.exports = require(50).getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};
});
},{"114":114,"46":46,"50":50,"8":8}],116:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var classof   = require(48)
  , ITERATOR  = require(113)('iterator')
  , Iterators = require(75);
module.exports = require(50).isIterable = function(it){
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || Iterators.hasOwnProperty(classof(O));
};
});
},{"113":113,"48":48,"50":50,"75":75,"8":8}],117:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
var addToUnscopables = require(44)
  , step             = require(74)
  , Iterators        = require(75)
  , toIObject        = require(106);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require(72)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');
});
},{"106":106,"44":44,"72":72,"74":74,"75":75,"8":8}],118:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.3.1 Object.assign(target, source)
var $export = require(57);

$export($export.S + $export.F, 'Object', {assign: require(80)});
});
},{"57":57,"8":8,"80":80}],119:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var $export = require(57)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: require(81)});
});
},{"57":57,"8":8,"81":81}],120:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var $export = require(57);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require(53), 'Object', {defineProperty: require(82).f});
});
},{"53":53,"57":57,"8":8,"82":82}],121:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = require(108)
  , $getPrototypeOf = require(88);

require(92)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});
});
},{"108":108,"8":8,"88":88,"92":92}],122:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.2.14 Object.keys(O)
var toObject = require(108)
  , $keys    = require(90);

require(92)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});
});
},{"108":108,"8":8,"90":90,"92":92}],123:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require(57);
$export($export.S, 'Object', {setPrototypeOf: require(96).set});
});
},{"57":57,"8":8,"96":96}],124:[function(require,module,exports){
arguments[4][30][0].apply(exports,arguments)
},{"30":30,"8":8}],125:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
var LIBRARY            = require(77)
  , global             = require(60)
  , ctx                = require(51)
  , classof            = require(48)
  , $export            = require(57)
  , isObject           = require(69)
  , aFunction          = require(43)
  , anInstance         = require(45)
  , forOf              = require(59)
  , speciesConstructor = require(101)
  , task               = require(103).set
  , microtask          = require(79)()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[require(113)('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = require(94)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
require(98)($Promise, PROMISE);
require(97)(PROMISE);
Wrapper = require(50)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && require(73)(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});
});
},{"101":101,"103":103,"113":113,"43":43,"45":45,"48":48,"50":50,"51":51,"57":57,"59":59,"60":60,"69":69,"73":73,"77":77,"79":79,"8":8,"94":94,"97":97,"98":98}],126:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
var $at  = require(102)(true);

// 21.1.3.27 String.prototype[@@iterator]()
require(72)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});
});
},{"102":102,"72":72,"8":8}],127:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';
// ECMAScript 6 symbols shim
var global         = require(60)
  , has            = require(61)
  , DESCRIPTORS    = require(53)
  , $export        = require(57)
  , redefine       = require(95)
  , META           = require(78).KEY
  , $fails         = require(58)
  , shared         = require(100)
  , setToStringTag = require(98)
  , uid            = require(110)
  , wks            = require(113)
  , wksExt         = require(112)
  , wksDefine      = require(111)
  , keyOf          = require(76)
  , enumKeys       = require(56)
  , isArray        = require(68)
  , anObject       = require(46)
  , toIObject      = require(106)
  , toPrimitive    = require(109)
  , createDesc     = require(93)
  , _create        = require(81)
  , gOPNExt        = require(85)
  , $GOPD          = require(84)
  , $DP            = require(82)
  , $keys          = require(90)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  require(86).f = gOPNExt.f = $getOwnPropertyNames;
  require(91).f  = $propertyIsEnumerable;
  require(87).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !require(77)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require(62)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);
});
},{"100":100,"106":106,"109":109,"110":110,"111":111,"112":112,"113":113,"46":46,"53":53,"56":56,"57":57,"58":58,"60":60,"61":61,"62":62,"68":68,"76":76,"77":77,"78":78,"8":8,"81":81,"82":82,"84":84,"85":85,"86":86,"87":87,"90":90,"91":91,"93":93,"95":95,"98":98}],128:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(111)('asyncIterator');
});
},{"111":111,"8":8}],129:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(111)('observable');
});
},{"111":111,"8":8}],130:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
require(117);
var global        = require(60)
  , hide          = require(62)
  , Iterators     = require(75)
  , TO_STRING_TAG = require(113)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}
});
},{"113":113,"117":117,"60":60,"62":62,"75":75,"8":8}],131:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */

'use strict';

function assign(target, firstSource) {
  if (target === undefined || target === null) {
    throw new TypeError('Cannot convert first argument to object');
  }

  var to = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var nextSource = arguments[i];
    if (nextSource === undefined || nextSource === null) {
      continue;
    }

    var keysArray = Object.keys(Object(nextSource));
    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
      var nextKey = keysArray[nextIndex];
      var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
      if (desc !== undefined && desc.enumerable) {
        to[nextKey] = nextSource[nextKey];
      }
    }
  }
  return to;
}

function polyfill() {
  if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
      enumerable: false,
      configurable: true,
      writable: true,
      value: assign
    });
  }
}

module.exports = {
  assign: assign,
  polyfill: polyfill
};

});
},{"8":8}],132:[function(require,module,exports){
(function (global){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
(function(global){

//
// Check for native Promise and it has correct interface
//

var NativePromise = global['Promise'];
var nativePromiseSupported =
  NativePromise &&
  // Some of these methods are missing from
  // Firefox/Chrome experimental implementations
  'resolve' in NativePromise &&
  'reject' in NativePromise &&
  'all' in NativePromise &&
  'race' in NativePromise &&
  // Older version of the spec had a resolver object
  // as the arg rather than a function
  (function(){
    var resolve;
    new NativePromise(function(r){ resolve = r; });
    return typeof resolve === 'function';
  })();


//
// export if necessary
//

if (typeof exports !== 'undefined' && exports)
{
  // node.js
  exports.Promise = nativePromiseSupported ? NativePromise : Promise;
  exports.Polyfill = Promise;
}
else
{
  // AMD
  if (typeof define == 'function' && define.amd)
  {
    define(function(){
      return nativePromiseSupported ? NativePromise : Promise;
    });
  }
  else
  {
    // in browser add to global
    if (!nativePromiseSupported)
      global['Promise'] = Promise;
  }
}


//
// Polyfill
//

var PENDING = 'pending';
var SEALED = 'sealed';
var FULFILLED = 'fulfilled';
var REJECTED = 'rejected';
var NOOP = function(){};

function isArray(value) {
  return Object.prototype.toString.call(value) === '[object Array]';
}

// async calls
var asyncSetTimer = typeof setImmediate !== 'undefined' ? setImmediate : setTimeout;
var asyncQueue = [];
var asyncTimer;

function asyncFlush(){
  // run promise callbacks
  for (var i = 0; i < asyncQueue.length; i++)
    asyncQueue[i][0](asyncQueue[i][1]);

  // reset async asyncQueue
  asyncQueue = [];
  asyncTimer = false;
}

function asyncCall(callback, arg){
  asyncQueue.push([callback, arg]);

  if (!asyncTimer)
  {
    asyncTimer = true;
    asyncSetTimer(asyncFlush, 0);
  }
}


function invokeResolver(resolver, promise) {
  function resolvePromise(value) {
    resolve(promise, value);
  }

  function rejectPromise(reason) {
    reject(promise, reason);
  }

  try {
    resolver(resolvePromise, rejectPromise);
  } catch(e) {
    rejectPromise(e);
  }
}

function invokeCallback(subscriber){
  var owner = subscriber.owner;
  var settled = owner.state_;
  var value = owner.data_;  
  var callback = subscriber[settled];
  var promise = subscriber.then;

  if (typeof callback === 'function')
  {
    settled = FULFILLED;
    try {
      value = callback(value);
    } catch(e) {
      reject(promise, e);
    }
  }

  if (!handleThenable(promise, value))
  {
    if (settled === FULFILLED)
      resolve(promise, value);

    if (settled === REJECTED)
      reject(promise, value);
  }
}

function handleThenable(promise, value) {
  var resolved;

  try {
    if (promise === value)
      throw new TypeError('A promises callback cannot return that same promise.');

    if (value && (typeof value === 'function' || typeof value === 'object'))
    {
      var then = value.then;  // then should be retrived only once

      if (typeof then === 'function')
      {
        then.call(value, function(val){
          if (!resolved)
          {
            resolved = true;

            if (value !== val)
              resolve(promise, val);
            else
              fulfill(promise, val);
          }
        }, function(reason){
          if (!resolved)
          {
            resolved = true;

            reject(promise, reason);
          }
        });

        return true;
      }
    }
  } catch (e) {
    if (!resolved)
      reject(promise, e);

    return true;
  }

  return false;
}

function resolve(promise, value){
  if (promise === value || !handleThenable(promise, value))
    fulfill(promise, value);
}

function fulfill(promise, value){
  if (promise.state_ === PENDING)
  {
    promise.state_ = SEALED;
    promise.data_ = value;

    asyncCall(publishFulfillment, promise);
  }
}

function reject(promise, reason){
  if (promise.state_ === PENDING)
  {
    promise.state_ = SEALED;
    promise.data_ = reason;

    asyncCall(publishRejection, promise);
  }
}

function publish(promise) {
  var callbacks = promise.then_;
  promise.then_ = undefined;

  for (var i = 0; i < callbacks.length; i++) {
    invokeCallback(callbacks[i]);
  }
}

function publishFulfillment(promise){
  promise.state_ = FULFILLED;
  publish(promise);
}

function publishRejection(promise){
  promise.state_ = REJECTED;
  publish(promise);
}

/**
* @class
*/
function Promise(resolver){
  if (typeof resolver !== 'function')
    throw new TypeError('Promise constructor takes a function argument');

  if (this instanceof Promise === false)
    throw new TypeError('Failed to construct \'Promise\': Please use the \'new\' operator, this object constructor cannot be called as a function.');

  this.then_ = [];

  invokeResolver(resolver, this);
}

Promise.prototype = {
  constructor: Promise,

  state_: PENDING,
  then_: null,
  data_: undefined,

  then: function(onFulfillment, onRejection){
    var subscriber = {
      owner: this,
      then: new this.constructor(NOOP),
      fulfilled: onFulfillment,
      rejected: onRejection
    };

    if (this.state_ === FULFILLED || this.state_ === REJECTED)
    {
      // already resolved, call callback async
      asyncCall(invokeCallback, subscriber);
    }
    else
    {
      // subscribe
      this.then_.push(subscriber);
    }

    return subscriber.then;
  },

  'catch': function(onRejection) {
    return this.then(null, onRejection);
  }
};

Promise.all = function(promises){
  var Class = this;

  if (!isArray(promises))
    throw new TypeError('You must pass an array to Promise.all().');

  return new Class(function(resolve, reject){
    var results = [];
    var remaining = 0;

    function resolver(index){
      remaining++;
      return function(value){
        results[index] = value;
        if (!--remaining)
          resolve(results);
      };
    }

    for (var i = 0, promise; i < promises.length; i++)
    {
      promise = promises[i];

      if (promise && typeof promise.then === 'function')
        promise.then(resolver(i), reject);
      else
        results[i] = promise;
    }

    if (!remaining)
      resolve(results);
  });
};

Promise.race = function(promises){
  var Class = this;

  if (!isArray(promises))
    throw new TypeError('You must pass an array to Promise.race().');

  return new Class(function(resolve, reject) {
    for (var i = 0, promise; i < promises.length; i++)
    {
      promise = promises[i];

      if (promise && typeof promise.then === 'function')
        promise.then(resolve, reject);
      else
        resolve(promise);
    }
  });
};

Promise.resolve = function(value){
  var Class = this;

  if (value && typeof value === 'object' && value.constructor === Class)
    return value;

  return new Class(function(resolve){
    resolve(value);
  });
};

Promise.reject = function(reason){
  var Class = this;

  return new Class(function(resolve, reject){
    reject(reason);
  });
};

})(typeof window != 'undefined' ? window : typeof global != 'undefined' ? global : typeof self != 'undefined' ? self : this);

});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"8":8}],133:[function(require,module,exports){
(function (process,global){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   3.3.1
 */

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  return typeof x === 'function' || typeof x === 'object' && x !== null;
}

function isFunction(x) {
  return typeof x === 'function';
}

var _isArray = undefined;
if (!Array.isArray) {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
} else {
  _isArray = Array.isArray;
}

var isArray = _isArray;

var len = 0;
var vertxNext = undefined;
var customSchedulerFn = undefined;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  return function () {
    vertxNext(flush);
  };
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = r('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = undefined;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && typeof require === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var _arguments = arguments;

  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;

  if (_state) {
    (function () {
      var callback = _arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    })();
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  _resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then, value, fulfillmentHandler, rejectionHandler) {
  try {
    then.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        _resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      _reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      _reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    _reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return _resolve(promise, value);
    }, function (reason) {
      return _reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$) {
  if (maybeThenable.constructor === promise.constructor && then$$ === then && maybeThenable.constructor.resolve === resolve) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$ === GET_THEN_ERROR) {
      _reject(promise, GET_THEN_ERROR.error);
    } else if (then$$ === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$)) {
      handleForeignThenable(promise, maybeThenable, then$$);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function _resolve(promise, value) {
  if (promise === value) {
    _reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function _reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;

  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = undefined,
      callback = undefined,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = undefined,
      error = undefined,
      succeeded = undefined,
      failed = undefined;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      _reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
      _resolve(promise, value);
    } else if (failed) {
      _reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      _reject(promise, value);
    }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      _resolve(promise, value);
    }, function rejectPromise(reason) {
      _reject(promise, reason);
    });
  } catch (e) {
    _reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function Enumerator(Constructor, input) {
  this._instanceConstructor = Constructor;
  this.promise = new Constructor(noop);

  if (!this.promise[PROMISE_ID]) {
    makePromise(this.promise);
  }

  if (isArray(input)) {
    this._input = input;
    this.length = input.length;
    this._remaining = input.length;

    this._result = new Array(this.length);

    if (this.length === 0) {
      fulfill(this.promise, this._result);
    } else {
      this.length = this.length || 0;
      this._enumerate();
      if (this._remaining === 0) {
        fulfill(this.promise, this._result);
      }
    }
  } else {
    _reject(this.promise, validationError());
  }
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
};

Enumerator.prototype._enumerate = function () {
  var length = this.length;
  var _input = this._input;

  for (var i = 0; this._state === PENDING && i < length; i++) {
    this._eachEntry(_input[i], i);
  }
};

Enumerator.prototype._eachEntry = function (entry, i) {
  var c = this._instanceConstructor;
  var resolve$$ = c.resolve;

  if (resolve$$ === resolve) {
    var _then = getThen(entry);

    if (_then === then && entry._state !== PENDING) {
      this._settledAt(entry._state, i, entry._result);
    } else if (typeof _then !== 'function') {
      this._remaining--;
      this._result[i] = entry;
    } else if (c === Promise) {
      var promise = new c(noop);
      handleMaybeThenable(promise, entry, _then);
      this._willSettleAt(promise, i);
    } else {
      this._willSettleAt(new c(function (resolve$$) {
        return resolve$$(entry);
      }), i);
    }
  } else {
    this._willSettleAt(resolve$$(entry), i);
  }
};

Enumerator.prototype._settledAt = function (state, i, value) {
  var promise = this.promise;

  if (promise._state === PENDING) {
    this._remaining--;

    if (state === REJECTED) {
      _reject(promise, value);
    } else {
      this._result[i] = value;
    }
  }

  if (this._remaining === 0) {
    fulfill(promise, this._result);
  }
};

Enumerator.prototype._willSettleAt = function (promise, i) {
  var enumerator = this;

  subscribe(promise, undefined, function (value) {
    return enumerator._settledAt(FULFILLED, i, value);
  }, function (reason) {
    return enumerator._settledAt(REJECTED, i, reason);
  });
};

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  _reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {function} resolver
  Useful for tooling.
  @constructor
*/
function Promise(resolver) {
  this[PROMISE_ID] = nextId();
  this._result = this._state = undefined;
  this._subscribers = [];

  if (noop !== resolver) {
    typeof resolver !== 'function' && needsResolver();
    this instanceof Promise ? initializePromise(this, resolver) : needsNew();
  }
}

Promise.all = all;
Promise.race = race;
Promise.resolve = resolve;
Promise.reject = reject;
Promise._setScheduler = setScheduler;
Promise._setAsap = setAsap;
Promise._asap = asap;

Promise.prototype = {
  constructor: Promise,

  /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
  
    ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
  
    Chaining
    --------
  
    The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
  
    ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
  
    findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
  
    ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
  
    Assimilation
    ------------
  
    Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
  
    If the assimliated promise rejects, then the downstream promise will also reject.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
  
    Simple Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let result;
  
    try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
  
    Advanced Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let author, books;
  
    try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
  
    function foundBooks(books) {
  
    }
  
    function failure(reason) {
  
    }
  
    findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
  
    @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
  */
  then: then,

  /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
  
    ```js
    function findAuthor(){
      throw new Error('couldn't find that author');
    }
  
    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }
  
    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```
  
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
  */
  'catch': function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};

function polyfill() {
    var local = undefined;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise;
}

polyfill();
// Strange compat..
Promise.polyfill = polyfill;
Promise.Promise = Promise;

return Promise;

})));

});
}).call(this,require(141),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"141":141,"8":8}],134:[function(require,module,exports){
(function (global){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
/*jslint es6, node, browser, maxlen: 120 */
/*global self, window */

"use strict";

module.exports = (function () {

    "use strict";

    var globalObject = undefined;

    function isFunction(x) {
        return typeof x === "function";
    }

    // Seek the global object
    if (global !== undefined) {
        globalObject = global;
    } else if (window !== undefined && window.document) {
        globalObject = window;
    } else {
        globalObject = self;
    }

    // Test for any native promise implementation, and if that
    // implementation appears to conform to the specificaton.
    // This code mostly nicked from the es6-promise module polyfill
    // and then fooled with.
    var hasPromiseSupport = (function () {

        // No promise object at all, and it's a non-starter
        if (!globalObject.hasOwnProperty("Promise")) {
            return false;
        }

        // There is a Promise object. Does it conform to the spec?
        var P = globalObject.Promise;

        // Some of these methods are missing from
        // Firefox/Chrome experimental implementations
        if (!P.hasOwnProperty("resolve") || !P.hasOwnProperty("reject")) {
            return false;
        }

        if (!P.hasOwnProperty("all") || !P.hasOwnProperty("race")) {
            return false;
        }

        // Older version of the spec had a resolver object
        // as the arg rather than a function
        return (function () {

            var resolve = undefined,
                p = new globalObject.Promise(function (r) {
                resolve = r;
            });

            if (p) {
                return isFunction(resolve);
            }

            return false;
        })();
    })();

    // Export the native Promise implementation if it
    // looks like it matches the spec
    if (hasPromiseSupport) {
        return globalObject.Promise;
    }

    //  Otherwise, return the es6-promise polyfill by @jaffathecake.
    return require(133).Promise;
})();
});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"133":133,"8":8}],135:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
/*jslint node, this, es6, maxlen: 120 */
"use strict";

module.exports = (function () {

    "use strict";

    // Get a promise object. This may be native, or it may be polyfilled
    var ES6Promise = require(134);

    // Promise Context object constructor.
    function Context(resolve, reject, custom) {
        this.resolve = resolve;
        this.reject = reject;
        this.custom = custom;
    }

    // Default callback function - rejects on truthy error, otherwise resolves
    function callback() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var ctx = args.shift(),
            err = args.shift(),
            cust = undefined;

        args = args.length > 1 ? args : args[0];

        if (typeof ctx.custom === 'function') {
            cust = function () {
                for (var _len2 = arguments.length, custArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    custArgs[_key2] = arguments[_key2];
                }

                // Bind the callback to itself, so the resolve and reject
                // properties that we bound are available to the callback.
                // Then we push it onto the end of the arguments array.
                return ctx.custom.apply(cust, custArgs);
            };
            cust.resolve = ctx.resolve;
            cust.reject = ctx.reject;
            cust.call(null, err, args);
        } else {
            if (err) {
                return ctx.reject(err);
            }
            ctx.resolve(args);
        }
    }

    /**
     * promisify
     *
     * Transforms callback-based function -- func(arg1, arg2 .. argN, callback) -- into
     * an ES6-compatible Promise. User can provide their own callback function; otherwise
     * promisify provides a callback of the form (error, result) and rejects on truthy error.
     * If supplying your own callback function, use this.resolve() and this.reject().
     *
     * @param {function} original - The function to promisify
     * @param {function} callback - Optional custom callbac function
     *
     * @return {function} A promisified version of 'original'
     */
    return function (original, custom) {

        return function () {
            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
            }

            // Store original context
            var that = this;

            // Return the promisified function
            return new ES6Promise(function (resolve, reject) {

                // Create a Context object
                var ctx = new Context(resolve, reject, custom);

                // Append the callback bound to the context
                args.push(callback.bind(null, ctx));

                // Call the function
                original.apply(that, args);
            });
        };
    };
})();
});
},{"134":134,"8":8}],136:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
(function() {
	var testObject = {};

	if (!(Object.setPrototypeOf || testObject.__proto__)) {
		var nativeGetPrototypeOf = Object.getPrototypeOf;

		Object.getPrototypeOf = function(object) {
			if (object.__proto__) {
				return object.__proto__;
			} else {
				return nativeGetPrototypeOf.call(Object, object);
			}
		}
	}
})();

});
},{"8":8}],137:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

/**
 * Expose `md5omatic(str)`.
 */
 
module.exports = md5omatic;

/**
 * Hash any string using message digest.
 *
 * @param {String} str
 * @return {String}
 * @api public
 */
 
function md5omatic(str) {
    var x = str2blks_MD5(str);
    var a =  1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d =  271733878;

    for(var i=0; i<x.length; i += 16)
    {
        var olda = a;
        var oldb = b;
        var oldc = c;
        var oldd = d;

        a = ff(a, b, c, d, x[i+ 0], 7 , -680876936);
        d = ff(d, a, b, c, x[i+ 1], 12, -389564586);
        c = ff(c, d, a, b, x[i+ 2], 17,  606105819);
        b = ff(b, c, d, a, x[i+ 3], 22, -1044525330);
        a = ff(a, b, c, d, x[i+ 4], 7 , -176418897);
        d = ff(d, a, b, c, x[i+ 5], 12,  1200080426);
        c = ff(c, d, a, b, x[i+ 6], 17, -1473231341);
        b = ff(b, c, d, a, x[i+ 7], 22, -45705983);
        a = ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
        d = ff(d, a, b, c, x[i+ 9], 12, -1958414417);
        c = ff(c, d, a, b, x[i+10], 17, -42063);
        b = ff(b, c, d, a, x[i+11], 22, -1990404162);
        a = ff(a, b, c, d, x[i+12], 7 ,  1804603682);
        d = ff(d, a, b, c, x[i+13], 12, -40341101);
        c = ff(c, d, a, b, x[i+14], 17, -1502002290);
        b = ff(b, c, d, a, x[i+15], 22,  1236535329);
        a = gg(a, b, c, d, x[i+ 1], 5 , -165796510);
        d = gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
        c = gg(c, d, a, b, x[i+11], 14,  643717713);
        b = gg(b, c, d, a, x[i+ 0], 20, -373897302);
        a = gg(a, b, c, d, x[i+ 5], 5 , -701558691);
        d = gg(d, a, b, c, x[i+10], 9 ,  38016083);
        c = gg(c, d, a, b, x[i+15], 14, -660478335);
        b = gg(b, c, d, a, x[i+ 4], 20, -405537848);
        a = gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
        d = gg(d, a, b, c, x[i+14], 9 , -1019803690);
        c = gg(c, d, a, b, x[i+ 3], 14, -187363961);
        b = gg(b, c, d, a, x[i+ 8], 20,  1163531501);
        a = gg(a, b, c, d, x[i+13], 5 , -1444681467);
        d = gg(d, a, b, c, x[i+ 2], 9 , -51403784);
        c = gg(c, d, a, b, x[i+ 7], 14,  1735328473);
        b = gg(b, c, d, a, x[i+12], 20, -1926607734);
        a = hh(a, b, c, d, x[i+ 5], 4 , -378558);
        d = hh(d, a, b, c, x[i+ 8], 11, -2022574463);
        c = hh(c, d, a, b, x[i+11], 16,  1839030562);
        b = hh(b, c, d, a, x[i+14], 23, -35309556);
        a = hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
        d = hh(d, a, b, c, x[i+ 4], 11,  1272893353);
        c = hh(c, d, a, b, x[i+ 7], 16, -155497632);
        b = hh(b, c, d, a, x[i+10], 23, -1094730640);
        a = hh(a, b, c, d, x[i+13], 4 ,  681279174);
        d = hh(d, a, b, c, x[i+ 0], 11, -358537222);
        c = hh(c, d, a, b, x[i+ 3], 16, -722521979);
        b = hh(b, c, d, a, x[i+ 6], 23,  76029189);
        a = hh(a, b, c, d, x[i+ 9], 4 , -640364487);
        d = hh(d, a, b, c, x[i+12], 11, -421815835);
        c = hh(c, d, a, b, x[i+15], 16,  530742520);
        b = hh(b, c, d, a, x[i+ 2], 23, -995338651);
        a = ii(a, b, c, d, x[i+ 0], 6 , -198630844);
        d = ii(d, a, b, c, x[i+ 7], 10,  1126891415);
        c = ii(c, d, a, b, x[i+14], 15, -1416354905);
        b = ii(b, c, d, a, x[i+ 5], 21, -57434055);
        a = ii(a, b, c, d, x[i+12], 6 ,  1700485571);
        d = ii(d, a, b, c, x[i+ 3], 10, -1894986606);
        c = ii(c, d, a, b, x[i+10], 15, -1051523);
        b = ii(b, c, d, a, x[i+ 1], 21, -2054922799);
        a = ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
        d = ii(d, a, b, c, x[i+15], 10, -30611744);
        c = ii(c, d, a, b, x[i+ 6], 15, -1560198380);
        b = ii(b, c, d, a, x[i+13], 21,  1309151649);
        a = ii(a, b, c, d, x[i+ 4], 6 , -145523070);
        d = ii(d, a, b, c, x[i+11], 10, -1120210379);
        c = ii(c, d, a, b, x[i+ 2], 15,  718787259);
        b = ii(b, c, d, a, x[i+ 9], 21, -343485551);

        a = addme(a, olda);
        b = addme(b, oldb);
        c = addme(c, oldc);
        d = addme(d, oldd);
    }

    return rhex(a) + rhex(b) + rhex(c) + rhex(d);
};

var hex_chr = "0123456789abcdef";

function bitOR(a, b)
{
    var lsb = (a & 0x1) | (b & 0x1);
    var msb31 = (a >>> 1) | (b >>> 1);

    return (msb31 << 1) | lsb;
}

function bitXOR(a, b)
{
    var lsb = (a & 0x1) ^ (b & 0x1);
    var msb31 = (a >>> 1) ^ (b >>> 1);

    return (msb31 << 1) | lsb;
}

function bitAND(a, b)
{
    var lsb = (a & 0x1) & (b & 0x1);
    var msb31 = (a >>> 1) & (b >>> 1);

    return (msb31 << 1) | lsb;
}

function addme(x, y)
{
    var lsw = (x & 0xFFFF)+(y & 0xFFFF);
    var msw = (x >> 16)+(y >> 16)+(lsw >> 16);

    return (msw << 16) | (lsw & 0xFFFF);
}

function rhex(num)
{
    var str = "";
    var j;

    for(j=0; j<=3; j++)
        str += hex_chr.charAt((num >> (j * 8 + 4)) & 0x0F) + hex_chr.charAt((num >> (j * 8)) & 0x0F);

    return str;
}

function str2blks_MD5(str)
{
    var nblk = ((str.length + 8) >> 6) + 1;
    var blks = new Array(nblk * 16);
    var i;

    for(i=0; i<nblk * 16; i++)
        blks[i] = 0;

    for(i=0; i<str.length; i++)
        blks[i >> 2] |= str.charCodeAt(i) << (((str.length * 8 + i) % 4) * 8);

    blks[i >> 2] |= 0x80 << (((str.length * 8 + i) % 4) * 8);

    var l = str.length * 8;
    blks[nblk * 16 - 2] = (l & 0xFF);
    blks[nblk * 16 - 2] |= ((l >>> 8) & 0xFF) << 8;
    blks[nblk * 16 - 2] |= ((l >>> 16) & 0xFF) << 16;
    blks[nblk * 16 - 2] |= ((l >>> 24) & 0xFF) << 24;

    return blks;
}

function rol(num, cnt)
{
    return (num << cnt) | (num >>> (32 - cnt));
}

function cmn(q, a, b, x, s, t)
{
    return addme(rol((addme(addme(a, q), addme(x, t))), s), b);
}

function ff(a, b, c, d, x, s, t)
{
    return cmn(bitOR(bitAND(b, c), bitAND((~b), d)), a, b, x, s, t);
}

function gg(a, b, c, d, x, s, t)
{
    return cmn(bitOR(bitAND(b, d), bitAND(c, (~d))), a, b, x, s, t);
}

function hh(a, b, c, d, x, s, t)
{
    return cmn(bitXOR(bitXOR(b, c), d), a, b, x, s, t);
}

function ii(a, b, c, d, x, s, t)
{
    return cmn(bitXOR(c, bitOR(b, (~d))), a, b, x, s, t);
}
});
},{"8":8}],138:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
var md5omatic = require(137);

module.exports = function (func, prefix) {
  prefix = prefix || '';
  func = func || function () { return '_default'; };
  return function () {
    var args = Array.prototype.slice.call(arguments);
    var k = func.apply(undefined, args);
    if (k === null) {
      return null;
    }
    if (typeof k === 'undefined' ||
      (typeof k === 'number' && isNaN(k)) ||
      k === '' ||
      (typeof k === 'object' && Object.keys(k).length === 0)) {
      throw new Error('Not a valid key');
    }
    if (typeof k !== 'string') {
      k = md5omatic(JSON.stringify(k));
    }
    return prefix + k;
  };
};

});
},{"137":137,"8":8}],139:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
function isObj(v) {
  return typeof v === 'object';
}

function isStr(v) {
  return typeof v === 'string';
}

function isBool(v) {
  return typeof v === 'boolean';
}

function isUndef(v) {
  if (typeof v === 'string') {
    return v.length === 0;
  }
  return typeof v === 'undefined';
}

function flatten(arr) {
  return [].concat.apply([], arr);
}

var emailRE = /.+\@.+\..+/;

var _validatorFactories = {
  object: function () { return function (value) { return (isUndef(value) || isObj(value) ? [] : ['object.base']); }; },
  string: function () { return function (value) { return (isUndef(value) || isStr(value) ? [] : ['string.base']); }; },
  boolean: function () { return function (value) { return (isUndef(value) || isBool(value) ? [] : ['boolean.base']); }; },
  min: function (minValue) { return function (value) { return (isUndef(value) || value.length >= minValue ? [] : ['string.min']); }; },
  max: function (maxValue) { return function (value) { return (isUndef(value) || value.length <= maxValue ? [] : ['string.max']); }; },
  email: function () { return function (value) { return (isUndef(value) || emailRE.test(value) ? [] : ['string.email']); }; },
  required: function () { return function (value) { return (!isUndef(value) ? [] : ['any.empty']); }; },
  regex: function (re) { return function (value) { return (isUndef(value) || re.test(value) ? [] : ['string.regex.base']); }; },
  keys: function (obj) { return function (value) { return (isUndef(value) ? [] : flatten(Object.keys(obj).map(function (attr) { return obj[attr]._validate(value[attr], attr); }))); }; },
};

function _joi() {
  this._validators = [];
}

var joi = {};

Object.keys(_validatorFactories).forEach(function (k) {
  _joi.prototype[k] = function unnamed(arg) {
    this._validators.push(_validatorFactories[k](arg));
    return this;
  };

  joi[k] = function (arg) {
    var j = new _joi();
    return j[k](arg);
  };
});

_joi.prototype._validate = function _validate(value, path) {
  return flatten(this._validators.map(function (func) { return func(value); }))
  .map(function (e) {
    var out = {
      type: typeof e === 'string' ? e : e.type,
    };
    var paths = [];
    if (path) {
      paths.push(path);
    }
    if (typeof e !== 'string' && 'path' in e) {
      paths.push(e.path);
    }

    if (paths.length) {
      out.path = paths.join('.');
    }
    return out;
  });
};

joi.validate = function validate(data, schema, options, callback) {
  // const abortEarly = options.abortEarly;
  var errors = schema._validate(data);
  var out = errors.length ? {
    error: {
      details: errors,
    },
    value: data,
  } : { error: null, value: data };

  if (callback) {
    callback(out.error, out.value);
  }
  return out;
};

module.exports = joi;

});
},{"8":8}],140:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleDate = undefined;

var _defineProperty2 = require(23);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(26);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(25);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function selectAll(node) {
  setTimeout(function () {
    node.setSelectionRange(0, node.value.length);
  }, 5);
}

function setFocus(node) {
  node.focus();
  selectAll(node);
}

function getDateItem(s) {
  // undefined and null should return an empty string (invalid date)
  var d = new Date(s || '');
  var inValid = isNaN(d.getDate());
  var day = inValid ? '' : d.getDate().toString();
  var month = inValid ? '' : (d.getMonth() + 1).toString();
  var year = inValid ? '' : d.getFullYear().toString();
  return { day: day, month: month, year: year };
}

function inputBuilder(context, name, placeholder, maxLength, label) {
  var controlName = context.props.name;
  var id = controlName + '-' + name;
  var description = label + ' - ' + name;
  return _react2.default.createElement(
    'span',
    null,
    _react2.default.createElement(
      'label',
      { className: 'tes-simple-date__label', htmlFor: id },
      description
    ),
    _react2.default.createElement('input', {
      id: id,
      className: 'tes-simple-date__item tes-simple-date__' + name,
      onClick: function onClick(e) {
        return context.onClick(e);
      },
      onKeyDown: function onKeyDown(e) {
        return context.focusNext(e, name);
      },
      ref: name,
      onChange: function onChange(e) {
        return context.onChange(e, name, maxLength);
      },
      size: maxLength,
      value: context.state[name],
      placeholder: placeholder
    })
  );
}

var SimpleDate = exports.SimpleDate = function (_Component) {
  (0, _inherits3.default)(SimpleDate, _Component);

  function SimpleDate(props) {
    (0, _classCallCheck3.default)(this, SimpleDate);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SimpleDate.__proto__ || (0, _getPrototypeOf2.default)(SimpleDate)).call(this, props));

    _this.sequence = _this.props.sequence || ['day', 'month', 'year'];
    _this.nextItems = _this.sequence.reduce(function (obj, cur, index, arr) {
      obj[cur] = arr[index + 1];
      return obj;
    }, {});

    _this.previousItems = _this.sequence.reduce(function (obj, cur, index, arr) {
      obj[cur] = arr[index - 1];
      return obj;
    }, {});
    _this.state = getDateItem(_this.props.value);
    return _this;
  }

  (0, _createClass3.default)(SimpleDate, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _state = this.state,
          year = _state.year,
          month = _state.month,
          day = _state.day;

      if (prevState.day === day && prevState.month === month && prevState.year === year) {
        return;
      }
      this.props.onChange(year + '-' + month + '-' + day);
    }
  }, {
    key: 'onChange',
    value: function onChange(evt, current, maxLength) {
      var nextItem = this.nextItems[current];
      // const previousItem = this.previousItems[current];
      var currentValue = this.refs[current].value;

      if (new RegExp('^[0-9]{0,' + maxLength + '}$').test(currentValue)) {
        this.setState((0, _defineProperty3.default)({}, current, currentValue));
        if (nextItem && currentValue.length >= maxLength) {
          setFocus(this.refs[nextItem]);
        }
      }
    }
  }, {
    key: 'onClick',
    value: function onClick(evt) {
      selectAll(evt.target);
    }
  }, {
    key: 'focusNext',
    value: function focusNext(evt, current) {
      var nextItem = this.nextItems[current];
      var previousItem = this.previousItems[current];
      var currentValue = this.refs[current].value;

      if (nextItem) {
        if (evt.key === '/' || evt.key === '-' || evt.key === 'ArrowRight' && evt.target.selectionStart === currentValue.length) {
          setFocus(this.refs[nextItem]);
        }
      }

      if (previousItem) {
        if (evt.key === 'ArrowLeft' && evt.target.selectionStart === 0) {
          setFocus(this.refs[previousItem]);
        } else if (currentValue.length === 0 && evt.key === 'Backspace') {
          setFocus(this.refs[previousItem]);
          evt.preventDefault();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var day = inputBuilder(this, 'day', 'DD', 2, this.props.label);
      var month = inputBuilder(this, 'month', 'MM', 2, this.props.label);
      var year = inputBuilder(this, 'year', 'YYYY', 4, this.props.label);

      var dateComponents = { day: day, month: month, year: year };
      var sequence = this.props.sequence || ['day', 'month', 'year'];

      return _react2.default.createElement(
        'div',
        { className: 'tes-simple-date' },
        _react2.default.createElement('input', { type: 'hidden', name: this.props.name, value: this.props.value }),
        dateComponents[sequence[0]],
        '/',
        dateComponents[sequence[1]],
        '/',
        dateComponents[sequence[2]]
      );
    }
  }]);
  return SimpleDate;
}(_react.Component);

SimpleDate.propTypes = {
  name: _react.PropTypes.string.isRequired,
  label: _react.PropTypes.string.isRequired,
  value: _react.PropTypes.string.isRequired,
  onChange: _react.PropTypes.func.isRequired,
  sequence: _react.PropTypes.array
};

exports.default = SimpleDate;
});
},{"15":15,"21":21,"22":22,"23":23,"25":25,"26":26,"8":8}],141:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

});
},{"8":8}],142:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
module.exports = require(143)
});
},{"143":143,"8":8}],143:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _io = require(148);

Object.defineProperty(exports, 'take', {
  enumerable: true,
  get: function get() {
    return _io.take;
  }
});
Object.defineProperty(exports, 'takem', {
  enumerable: true,
  get: function get() {
    return _io.takem;
  }
});
Object.defineProperty(exports, 'put', {
  enumerable: true,
  get: function get() {
    return _io.put;
  }
});
Object.defineProperty(exports, 'race', {
  enumerable: true,
  get: function get() {
    return _io.race;
  }
});
Object.defineProperty(exports, 'call', {
  enumerable: true,
  get: function get() {
    return _io.call;
  }
});
Object.defineProperty(exports, 'apply', {
  enumerable: true,
  get: function get() {
    return _io.apply;
  }
});
Object.defineProperty(exports, 'cps', {
  enumerable: true,
  get: function get() {
    return _io.cps;
  }
});
Object.defineProperty(exports, 'fork', {
  enumerable: true,
  get: function get() {
    return _io.fork;
  }
});
Object.defineProperty(exports, 'spawn', {
  enumerable: true,
  get: function get() {
    return _io.spawn;
  }
});
Object.defineProperty(exports, 'join', {
  enumerable: true,
  get: function get() {
    return _io.join;
  }
});
Object.defineProperty(exports, 'cancel', {
  enumerable: true,
  get: function get() {
    return _io.cancel;
  }
});
Object.defineProperty(exports, 'select', {
  enumerable: true,
  get: function get() {
    return _io.select;
  }
});
Object.defineProperty(exports, 'actionChannel', {
  enumerable: true,
  get: function get() {
    return _io.actionChannel;
  }
});
Object.defineProperty(exports, 'cancelled', {
  enumerable: true,
  get: function get() {
    return _io.cancelled;
  }
});
Object.defineProperty(exports, 'flush', {
  enumerable: true,
  get: function get() {
    return _io.flush;
  }
});
});
},{"148":148,"8":8}],144:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.utils = exports.effects = exports.CANCEL = exports.delay = exports.throttle = exports.takeLatest = exports.takeEvery = exports.buffers = exports.channel = exports.eventChannel = exports.END = exports.runSaga = undefined;

var _runSaga = require(151);

Object.defineProperty(exports, 'runSaga', {
  enumerable: true,
  get: function get() {
    return _runSaga.runSaga;
  }
});

var _channel = require(147);

Object.defineProperty(exports, 'END', {
  enumerable: true,
  get: function get() {
    return _channel.END;
  }
});
Object.defineProperty(exports, 'eventChannel', {
  enumerable: true,
  get: function get() {
    return _channel.eventChannel;
  }
});
Object.defineProperty(exports, 'channel', {
  enumerable: true,
  get: function get() {
    return _channel.channel;
  }
});

var _buffers = require(146);

Object.defineProperty(exports, 'buffers', {
  enumerable: true,
  get: function get() {
    return _buffers.buffers;
  }
});

var _sagaHelpers = require(152);

Object.defineProperty(exports, 'takeEvery', {
  enumerable: true,
  get: function get() {
    return _sagaHelpers.takeEvery;
  }
});
Object.defineProperty(exports, 'takeLatest', {
  enumerable: true,
  get: function get() {
    return _sagaHelpers.takeLatest;
  }
});
Object.defineProperty(exports, 'throttle', {
  enumerable: true,
  get: function get() {
    return _sagaHelpers.throttle;
  }
});

var _utils = require(153);

Object.defineProperty(exports, 'delay', {
  enumerable: true,
  get: function get() {
    return _utils.delay;
  }
});
Object.defineProperty(exports, 'CANCEL', {
  enumerable: true,
  get: function get() {
    return _utils.CANCEL;
  }
});

var _middleware = require(149);

var _middleware2 = _interopRequireDefault(_middleware);

var _effects = require(143);

var effects = _interopRequireWildcard(_effects);

var _utils2 = require(154);

var utils = _interopRequireWildcard(_utils2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _middleware2.default;
exports.effects = effects;
exports.utils = utils;
});
},{"143":143,"146":146,"147":147,"149":149,"151":151,"152":152,"153":153,"154":154,"8":8}],145:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = asap;
var queue = [];
var isSuspended = false;

function asap(task) {
  if (!isSuspended) {
    isSuspended = true;
    queue.push(task);
    asap.flush();
  } else {
    queue.push(task);
  }
}

asap.suspend = function () {
  return isSuspended = true;
};
asap.flush = function () {
  var nextTask = void 0;
  while (nextTask = queue.shift()) {
    nextTask();
  }
  isSuspended = false;
};
});
},{"8":8}],146:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buffers = exports.BUFFER_OVERFLOW = undefined;

var _utils = require(153);

var BUFFER_OVERFLOW = exports.BUFFER_OVERFLOW = 'Channel\'s Buffer overflow!';

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: _utils.kTrue, put: _utils.noop, take: _utils.noop };

function ringBuffer() {
  var limit = arguments.length <= 0 || arguments[0] === undefined ? 10 : arguments[0];
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take, flush: flush
  };
}

var buffers = exports.buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};
});
},{"153":153,"8":8}],147:[function(require,module,exports){
(function (process){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNDEFINED_INPUT_ERROR = exports.INVALID_BUFFER = exports.isEnd = exports.END = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.emitter = emitter;
exports.channel = channel;
exports.eventChannel = eventChannel;
exports.stdChannel = stdChannel;

var _utils = require(153);

var _buffers = require(146);

var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = exports.END = { type: CHANNEL_END_TYPE };
var isEnd = exports.isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return (0, _utils.remove)(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = exports.INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = exports.UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (process.env.NODE_ENV !== 'production') {
  exports.UNDEFINED_INPUT_ERROR = UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length <= 0 || arguments[0] === undefined ? _buffers.buffers.fixed() : arguments[0];

  var closed = false;
  var takers = [];

  (0, _utils.check)(buffer, _utils.is.buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw (0, _utils.internalErr)('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw (0, _utils.internalErr)('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    (0, _utils.check)(input, _utils.is.notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[_utils.MATCH] || cb[_utils.MATCH](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    (0, _utils.check)(cb, _utils.is.func, 'channel.take\'s callback must be a function');

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return (0, _utils.remove)(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    (0, _utils.check)(cb, _utils.is.func, 'channel.flush\' callback must be a function');
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return { take: take, put: put, flush: flush, close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length <= 1 || arguments[1] === undefined ? _buffers.buffers.none() : arguments[1];
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    (0, _utils.check)(matcher, _utils.is.func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      chan.close();
    } else if (!matcher || matcher(input)) {
      chan.put(input);
    }
  });

  if (!_utils.is.func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: function close() {
      if (!chan.__closed__) {
        chan.close();
        unsubscribe();
      }
    }
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(subscribe);

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        (0, _utils.check)(matcher, _utils.is.func, 'channel.take\'s matcher argument must be a function');
        cb[_utils.MATCH] = matcher;
      }
      chan.take(cb);
    }
  });
}
});
}).call(this,require(141))

},{"141":141,"146":146,"153":153,"8":8}],148:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asEffect = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.take = take;
exports.takem = takem;
exports.put = put;
exports.race = race;
exports.call = call;
exports.apply = apply;
exports.cps = cps;
exports.fork = fork;
exports.spawn = spawn;
exports.join = join;
exports.cancel = cancel;
exports.select = select;
exports.actionChannel = actionChannel;
exports.cancelled = cancelled;
exports.flush = flush;

var _utils = require(153);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var IO = (0, _utils.sym)('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, IO, true), _defineProperty(_ref, type, payload), _ref;
};

function take() {
  var patternOrChannel = arguments.length <= 0 || arguments[0] === undefined ? '*' : arguments[0];

  if (arguments.length) {
    (0, _utils.check)(arguments[0], _utils.is.notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (_utils.is.pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (_utils.is.channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

function takem() {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
}

function put(channel, action) {
  if (arguments.length > 1) {
    (0, _utils.check)(channel, _utils.is.notUndef, 'put(channel, action): argument channel is undefined');
    (0, _utils.check)(channel, _utils.is.channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    (0, _utils.check)(action, _utils.is.notUndef, 'put(channel, action): argument action is undefined');
  } else {
    (0, _utils.check)(channel, _utils.is.notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.sync = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].sync = true;
  return eff;
};

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  (0, _utils.check)(fn, _utils.is.notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (_utils.is.array(fn)) {
    var _fn = fn;

    var _fn2 = _slicedToArray(_fn, 2);

    context = _fn2[0];
    fn = _fn2[1];
  } else if (fn.fn) {
    var _fn3 = fn;
    context = _fn3.context;
    fn = _fn3.fn;
  }
  (0, _utils.check)(fn, _utils.is.func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  var eff = fork.apply(undefined, [fn].concat(args));
  eff[FORK].detached = true;
  return eff;
}

var isForkedTask = function isForkedTask(task) {
  return task[_utils.TASK];
};

function join(task) {
  (0, _utils.check)(task, _utils.is.notUndef, 'join(task): argument task is undefined');
  if (!isForkedTask(task)) {
    throw new Error('join(task): argument ' + task + ' is not a valid Task object \n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)');
  }

  return effect(JOIN, task);
}

function cancel(task) {
  (0, _utils.check)(task, _utils.is.notUndef, 'cancel(task): argument task is undefined');
  if (!isForkedTask(task)) {
    throw new Error('cancel(task): argument ' + task + ' is not a valid Task object \n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)');
  }

  return effect(CANCEL, task);
}

function select(selector) {
  for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }

  if (arguments.length === 0) {
    selector = _utils.ident;
  } else {
    (0, _utils.check)(selector, _utils.is.notUndef, 'select(selector,[...]): argument selector is undefined');
    (0, _utils.check)(selector, _utils.is.func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  (0, _utils.check)(pattern, _utils.is.notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  (0, _utils.check)(channel, _utils.is.channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

var asEffect = exports.asEffect = {
  take: function take(effect) {
    return effect && effect[IO] && effect[TAKE];
  },
  put: function put(effect) {
    return effect && effect[IO] && effect[PUT];
  },
  race: function race(effect) {
    return effect && effect[IO] && effect[RACE];
  },
  call: function call(effect) {
    return effect && effect[IO] && effect[CALL];
  },
  cps: function cps(effect) {
    return effect && effect[IO] && effect[CPS];
  },
  fork: function fork(effect) {
    return effect && effect[IO] && effect[FORK];
  },
  join: function join(effect) {
    return effect && effect[IO] && effect[JOIN];
  },
  cancel: function cancel(effect) {
    return effect && effect[IO] && effect[CANCEL];
  },
  select: function select(effect) {
    return effect && effect[IO] && effect[SELECT];
  },
  actionChannel: function actionChannel(effect) {
    return effect && effect[IO] && effect[ACTION_CHANNEL];
  },
  cancelled: function cancelled(effect) {
    return effect && effect[IO] && effect[CANCELLED];
  },
  flush: function flush(effect) {
    return effect && effect[IO] && effect[FLUSH];
  }
};
});
},{"153":153,"8":8}],149:[function(require,module,exports){
(function (process){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sagaMiddlewareFactory;

var _utils = require(153);

var _proc = require(150);

var _proc2 = _interopRequireDefault(_proc);

var _channel = require(147);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sagaMiddlewareFactory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var runSagaDynamically = void 0;

  if (_utils.is.func(options)) {
    if (process.env.NODE_ENV === 'production') {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (options.logger && !_utils.is.func(options.logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (options.onerror && !_utils.is.func(options.onerror)) {
    throw new Error('`options.onerror` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref) {
    var getState = _ref.getState;
    var dispatch = _ref.dispatch;

    runSagaDynamically = runSaga;
    var sagaEmitter = (0, _channel.emitter)();

    function runSaga(saga) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (0, _proc2.default)(saga.apply(undefined, args), sagaEmitter.subscribe, dispatch, getState, options, 0, saga.name);
    }

    return function (next) {
      return function (action) {
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function (saga) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    (0, _utils.check)(runSagaDynamically, _utils.is.notUndef, 'Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
    (0, _utils.check)(saga, _utils.is.func, 'sagaMiddleware.run(saga, ...args): saga argument must be a Generator function!');
    return runSagaDynamically.apply(undefined, [saga].concat(args));
  };

  return sagaMiddleware;
}
});
}).call(this,require(141))

},{"141":141,"147":147,"150":150,"153":153,"8":8}],150:[function(require,module,exports){
(function (process){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TASK_CANCEL = exports.CHANNEL_END = exports.NOT_ITERATOR_ERROR = undefined;
exports.default = proc;

var _utils = require(153);

var _asap = require(145);

var _asap2 = _interopRequireDefault(_asap);

var _io = require(148);

var _channel = require(147);

var _buffers = require(146);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isDev = process.env.NODE_ENV === 'development';

var NOT_ITERATOR_ERROR = exports.NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var nextEffectId = (0, _utils.autoInc)();
var CHANNEL_END = exports.CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = exports.TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return _utils.kTrue;
  },
  default: function _default(pattern) {
    return function (input) {
      return input.type === pattern;
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return p === input.type;
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  return (pattern === '*' ? matchers.wildcard : _utils.is.array(pattern) ? matchers.array : _utils.is.func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes iff all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      (0, _utils.remove)(tasks, task);
      task.cont = _utils.noop;
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = _utils.noop;
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context;
  var fn = _ref.fn;
  var args = _ref.args;

  if (_utils.is.iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (_utils.is.iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? (0, _utils.makeIterator)(function () {
    throw error;
  }) : (0, _utils.makeIterator)(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

function wrapHelper(helper) {
  return {
    fn: helper
  };
}

function proc(iterator) {
  var subscribe = arguments.length <= 1 || arguments[1] === undefined ? function () {
    return _utils.noop;
  } : arguments[1];
  var dispatch = arguments.length <= 2 || arguments[2] === undefined ? _utils.noop : arguments[2];
  var getState = arguments.length <= 3 || arguments[3] === undefined ? _utils.noop : arguments[3];
  var options = arguments.length <= 4 || arguments[4] === undefined ? {} : arguments[4];
  var parentEffectId = arguments.length <= 5 || arguments[5] === undefined ? 0 : arguments[5];
  var name = arguments.length <= 6 || arguments[6] === undefined ? 'anonymous' : arguments[6];
  var cont = arguments[7];

  (0, _utils.check)(iterator, _utils.is.iterator, NOT_ITERATOR_ERROR);

  var sagaMonitor = options.sagaMonitor;
  var logger = options.logger;
  var onError = options.onError;

  var log = logger || _utils.log;
  var stdChannel = (0, _channel.stdChannel)(subscribe);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = _utils.noop;

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL autoamtically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          Thill will jump to the finally block
        **/
        result = _utils.is.func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = _utils.is.func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        log('error', 'uncaught at ' + name, error.message);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      if (result === TASK_CANCEL && isDev) {
        log('info', name + ' has been cancelled', '');
      }
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        result.sagaStack = 'at ' + name + ' \n ' + (result.sagaStack || result.stack);
      }
      if (!task.cont) {
        log('error', 'uncaught', result.sagaStack || result.stack);
        if (result instanceof Error && onError) {
          onError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
    var cb = arguments[3];

    var effectId = nextEffectId();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = _utils.noop; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }

      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = _utils.noop;

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        log('error', 'uncaught at ' + name, err.message);
      }
      currCb.cancel = _utils.noop; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    return (
      // Non declarative effect
      _utils.is.promise(effect) ? resolvePromise(effect, currCb) : _utils.is.helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : _utils.is.iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : _utils.is.array(effect) ? runParallelEffect(effect, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.take(effect)) ? runTakeEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.put(effect)) ? runPutEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.race(effect)) ? runRaceEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.call(effect)) ? runCallEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.cps(effect)) ? runCPSEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.fork(effect)) ? runForkEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.join(effect)) ? runJoinEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.cancel(effect)) ? runCancelEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.select(effect)) ? runSelectEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.actionChannel(effect)) ? runChannelEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.flush(effect)) ? runFlushEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.cancelled(effect)) ? runCancelledEffect(data, currCb) : /* anything else returned as is        */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[_utils.CANCEL];
    if (typeof cancelPromise === 'function') {
      cb.cancel = cancelPromise;
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel;
    var pattern = _ref2.pattern;
    var maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : (0, _channel.isEnd)(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel;
    var action = _ref3.action;
    var sync = _ref3.sync;

    /*
      Use a reentrant lock `asap` to flatten all nested dispatches
      If this put cause another Saga to take this action an then immediately
      put an action that will be taken by this Saga. Then the outer Saga will miss
      the action from the inner Saga b/c this put has not yet returned.
    */
    (0, _asap2.default)(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.sync` was used then bubble up the error.
        if (channel || sync) return cb(error, true);
        log('error', 'uncaught at ' + name, error.stack || error.message || error);
      }

      if (sync && _utils.is.promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context;
    var fn = _ref4.fn;
    var args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return _utils.is.promise(result) ? resolvePromise(result, cb) : _utils.is.iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context;
    var fn = _ref5.fn;
    var args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      (function () {
        var cpsCb = function cpsCb(err, res) {
          return _utils.is.undef(err) ? cb(res) : cb(err, true);
        };
        fn.apply(context, args.concat(cpsCb));
        if (cpsCb.cancel) {
          cb.cancel = function () {
            return cpsCb.cancel();
          };
        }
      })();
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context;
    var fn = _ref6.fn;
    var args = _ref6.args;
    var detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    _asap2.default.suspend();
    var task = proc(taskIterator, subscribe, dispatch, getState, options, effectId, fn.name, detached ? null : _utils.noop);

    if (detached) {
      cb(task);
    } else {
      if (taskIterator._isRunning) {
        taskQueue.addTask(task);
        cb(task);
      } else if (taskIterator._error) {
        taskQueue.abort(taskIterator._error);
      } else {
        cb(task);
      }
    }
    _asap2.default.flush();
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      (function () {
        var joiner = { task: task, cb: cb };
        cb.cancel = function () {
          return (0, _utils.remove)(t.joiners, joiner);
        };
        t.joiners.push(joiner);
      })();
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(task, cb) {
    if (task.isRunning()) {
      task.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runParallelEffect(effects, effectId, cb) {
    if (!effects.length) {
      return cb([]);
    }

    var completedCount = 0;
    var completed = void 0;
    var results = Array(effects.length);

    function checkEffectEnd() {
      if (completedCount === results.length) {
        completed = true;
        cb(results);
      }
    }

    var childCbs = effects.map(function (eff, idx) {
      var chCbAtIdx = function chCbAtIdx(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || (0, _channel.isEnd)(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[idx] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtIdx.cancel = _utils.noop;
      return chCbAtIdx;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        childCbs.forEach(function (chCb) {
          return chCb.cancel();
        });
      }
    };

    effects.forEach(function (eff, idx) {
      return runEffect(eff, effectId, idx, childCbs[idx]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!(0, _channel.isEnd)(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          cb.cancel();
          completed = true;
          cb(_defineProperty({}, key, res));
        }
      };
      chCbAtKey.cancel = _utils.noop;
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector;
    var args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(_toConsumableArray(args)));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern;
    var buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb((0, _channel.eventChannel)(subscribe, buffer || _buffers.buffers.fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _defineProperty(_ref9, _utils.TASK, true), _defineProperty(_ref9, 'id', id), _defineProperty(_ref9, 'name', name), _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = (0, _utils.deferred)();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _defineProperty(_ref9, 'cont', cont), _defineProperty(_ref9, 'joiners', []), _defineProperty(_ref9, 'cancel', cancel), _defineProperty(_ref9, 'isRunning', function isRunning() {
      return iterator._isRunning;
    }), _defineProperty(_ref9, 'isCancelled', function isCancelled() {
      return iterator._isCancelled;
    }), _defineProperty(_ref9, 'isAborted', function isAborted() {
      return iterator._isAborted;
    }), _defineProperty(_ref9, 'result', function result() {
      return iterator._result;
    }), _defineProperty(_ref9, 'error', function error() {
      return iterator._error;
    }), _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}
});
}).call(this,require(141))

},{"141":141,"145":145,"146":146,"147":147,"148":148,"153":153,"8":8}],151:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.runSaga = runSaga;

var _utils = require(153);

var _proc = require(150);

var _proc2 = _interopRequireDefault(_proc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function runSaga(iterator, _ref) {
  var subscribe = _ref.subscribe;
  var dispatch = _ref.dispatch;
  var getState = _ref.getState;
  var sagaMonitor = _ref.sagaMonitor;
  var logger = _ref.logger;


  (0, _utils.check)(iterator, _utils.is.iterator, "runSaga must be called on an iterator");

  return (0, _proc2.default)(iterator, subscribe, dispatch, getState, { sagaMonitor: sagaMonitor, logger: logger });
}
});
},{"150":150,"153":153,"8":8}],152:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.takeEvery = takeEvery;
exports.takeLatest = takeLatest;
exports.throttle = throttle;

var _channel = require(147);

var _utils = require(153);

var _io = require(148);

var _buffers = require(146);

var done = { done: true, value: undefined };
var qEnd = {};

function fsmIterator(fsm, q0) {
  var name = arguments.length <= 2 || arguments[2] === undefined ? 'iterator' : arguments[2];

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext]();

      var _fsm$qNext2 = _slicedToArray(_fsm$qNext, 3);

      var q = _fsm$qNext2[0];
      var output = _fsm$qNext2[1];
      var _updateState = _fsm$qNext2[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return (0, _utils.makeIterator)(next, function (error) {
    return next(null, error);
  }, name, true);
}

function safeName(pattern) {
  if (Array.isArray(pattern)) {
    return String(pattern.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(pattern);
  }
}

function takeEvery(pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: (0, _io.take)(pattern) };
  var yFork = function yFork(ac) {
    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === _channel.END ? [qEnd] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + safeName(pattern) + ', ' + worker.name + ')');
}

function takeLatest(pattern, worker) {
  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  var yTake = { done: false, value: (0, _io.take)(pattern) };
  var yFork = function yFork(ac) {
    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: (0, _io.cancel)(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === _channel.END ? [qEnd] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + safeName(pattern) + ', ' + worker.name + ')');
}

function throttle(delayLength, pattern, worker) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: (0, _io.actionChannel)(pattern, _buffers.buffers.sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: (0, _io.take)(channel, pattern) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: (0, _io.call)(_utils.delay, delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return fsmIterator({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === _channel.END ? [qEnd] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + safeName(pattern) + ', ' + worker.name + ')');
}
});
},{"146":146,"147":147,"148":148,"153":153,"8":8}],153:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.check = check;
exports.remove = remove;
exports.deferred = deferred;
exports.arrayOfDeffered = arrayOfDeffered;
exports.delay = delay;
exports.createMockTask = createMockTask;
exports.autoInc = autoInc;
exports.makeIterator = makeIterator;
exports.log = log;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var sym = exports.sym = function sym(id) {
  return '@@redux-saga/' + id;
};
var TASK = exports.TASK = sym('TASK');
var HELPER = exports.HELPER = sym('HELPER');
var MATCH = exports.MATCH = sym('MATCH');
var CANCEL = exports.CANCEL = sym('cancelPromise');
var konst = exports.konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = exports.kTrue = konst(true);
var kFalse = exports.kFalse = konst(false);
var noop = exports.noop = function noop() {};
var ident = exports.ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var is = exports.is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  array: Array.isArray,
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (typeof pat === 'string' || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

function deferred() {
  var props = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _defineProperty(_ref, TASK, true), _defineProperty(_ref, 'isRunning', function isRunning() {
    return running;
  }), _defineProperty(_ref, 'result', function result() {
    return _result;
  }), _defineProperty(_ref, 'error', function error() {
    return _error;
  }), _defineProperty(_ref, 'setRunning', function setRunning(b) {
    return running = b;
  }), _defineProperty(_ref, 'setResult', function setResult(r) {
    return _result = r;
  }), _defineProperty(_ref, 'setError', function setError(e) {
    return _error = e;
  }), _ref;
}

function autoInc() {
  var seed = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];

  return function () {
    return ++seed;
  };
}

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length <= 1 || arguments[1] === undefined ? kThrow : arguments[1];
  var name = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message, error) {
  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

var internalErr = exports.internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};
});
},{"8":8}],154:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require(153);

Object.defineProperty(exports, 'TASK', {
  enumerable: true,
  get: function get() {
    return _utils.TASK;
  }
});
Object.defineProperty(exports, 'noop', {
  enumerable: true,
  get: function get() {
    return _utils.noop;
  }
});
Object.defineProperty(exports, 'is', {
  enumerable: true,
  get: function get() {
    return _utils.is;
  }
});
Object.defineProperty(exports, 'deferred', {
  enumerable: true,
  get: function get() {
    return _utils.deferred;
  }
});
Object.defineProperty(exports, 'arrayOfDeffered', {
  enumerable: true,
  get: function get() {
    return _utils.arrayOfDeffered;
  }
});
Object.defineProperty(exports, 'createMockTask', {
  enumerable: true,
  get: function get() {
    return _utils.createMockTask;
  }
});

var _io = require(148);

Object.defineProperty(exports, 'asEffect', {
  enumerable: true,
  get: function get() {
    return _io.asEffect;
  }
});
});
},{"148":148,"153":153,"8":8}],155:[function(require,module,exports){
(function (global){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = require(156);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"156":156,"8":8}],156:[function(require,module,exports){
(function (global){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"8":8}],157:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
/*!
  * Reqwest! A general purpose XHR connection manager
  * license MIT (c) Dustin Diaz 2015
  * https://github.com/ded/reqwest
  */

!function (name, context, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (typeof define == 'function' && define.amd) define(definition)
  else context[name] = definition()
}('reqwest', this, function () {

  var context = this

  if ('window' in context) {
    var doc = document
      , byTag = 'getElementsByTagName'
      , head = doc[byTag]('head')[0]
  } else {
    var XHR2
    try {
      XHR2 = require(30)
    } catch (ex) {
      throw new Error('Peer dependency `xhr2` required! Please npm install xhr2')
    }
  }


  var httpsRe = /^http/
    , protocolRe = /(^\w+):\/\//
    , twoHundo = /^(20\d|1223)$/ //http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
    , readyState = 'readyState'
    , contentType = 'Content-Type'
    , requestedWith = 'X-Requested-With'
    , uniqid = 0
    , callbackPrefix = 'reqwest_' + (+new Date())
    , lastValue // data stored by the most recent JSONP callback
    , xmlHttpRequest = 'XMLHttpRequest'
    , xDomainRequest = 'XDomainRequest'
    , noop = function () {}

    , isArray = typeof Array.isArray == 'function'
        ? Array.isArray
        : function (a) {
            return a instanceof Array
          }

    , defaultHeaders = {
          'contentType': 'application/x-www-form-urlencoded'
        , 'requestedWith': xmlHttpRequest
        , 'accept': {
              '*':  'text/javascript, text/html, application/xml, text/xml, */*'
            , 'xml':  'application/xml, text/xml'
            , 'html': 'text/html'
            , 'text': 'text/plain'
            , 'json': 'application/json, text/javascript'
            , 'js':   'application/javascript, text/javascript'
          }
      }

    , xhr = function(o) {
        // is it x-domain
        if (o['crossOrigin'] === true) {
          var xhr = context[xmlHttpRequest] ? new XMLHttpRequest() : null
          if (xhr && 'withCredentials' in xhr) {
            return xhr
          } else if (context[xDomainRequest]) {
            return new XDomainRequest()
          } else {
            throw new Error('Browser does not support cross-origin requests')
          }
        } else if (context[xmlHttpRequest]) {
          return new XMLHttpRequest()
        } else if (XHR2) {
          return new XHR2()
        } else {
          return new ActiveXObject('Microsoft.XMLHTTP')
        }
      }
    , globalSetupOptions = {
        dataFilter: function (data) {
          return data
        }
      }

  function succeed(r) {
    var protocol = protocolRe.exec(r.url)
    protocol = (protocol && protocol[1]) || context.location.protocol
    return httpsRe.test(protocol) ? twoHundo.test(r.request.status) : !!r.request.response
  }

  function handleReadyState(r, success, error) {
    return function () {
      // use _aborted to mitigate against IE err c00c023f
      // (can't read props on aborted request objects)
      if (r._aborted) return error(r.request)
      if (r._timedOut) return error(r.request, 'Request is aborted: timeout')
      if (r.request && r.request[readyState] == 4) {
        r.request.onreadystatechange = noop
        if (succeed(r)) success(r.request)
        else
          error(r.request)
      }
    }
  }

  function setHeaders(http, o) {
    var headers = o['headers'] || {}
      , h

    headers['Accept'] = headers['Accept']
      || defaultHeaders['accept'][o['type']]
      || defaultHeaders['accept']['*']

    var isAFormData = typeof FormData !== 'undefined' && (o['data'] instanceof FormData);
    // breaks cross-origin requests with legacy browsers
    if (!o['crossOrigin'] && !headers[requestedWith]) headers[requestedWith] = defaultHeaders['requestedWith']
    if (!headers[contentType] && !isAFormData) headers[contentType] = o['contentType'] || defaultHeaders['contentType']
    for (h in headers)
      headers.hasOwnProperty(h) && 'setRequestHeader' in http && http.setRequestHeader(h, headers[h])
  }

  function setCredentials(http, o) {
    if (typeof o['withCredentials'] !== 'undefined' && typeof http.withCredentials !== 'undefined') {
      http.withCredentials = !!o['withCredentials']
    }
  }

  function generalCallback(data) {
    lastValue = data
  }

  function urlappend (url, s) {
    return url + (/\?/.test(url) ? '&' : '?') + s
  }

  function handleJsonp(o, fn, err, url) {
    var reqId = uniqid++
      , cbkey = o['jsonpCallback'] || 'callback' // the 'callback' key
      , cbval = o['jsonpCallbackName'] || reqwest.getcallbackPrefix(reqId)
      , cbreg = new RegExp('((^|\\?|&)' + cbkey + ')=([^&]+)')
      , match = url.match(cbreg)
      , script = doc.createElement('script')
      , loaded = 0
      , isIE10 = navigator.userAgent.indexOf('MSIE 10.0') !== -1

    if (match) {
      if (match[3] === '?') {
        url = url.replace(cbreg, '$1=' + cbval) // wildcard callback func name
      } else {
        cbval = match[3] // provided callback func name
      }
    } else {
      url = urlappend(url, cbkey + '=' + cbval) // no callback details, add 'em
    }

    context[cbval] = generalCallback

    script.type = 'text/javascript'
    script.src = url
    script.async = true
    if (typeof script.onreadystatechange !== 'undefined' && !isIE10) {
      // need this for IE due to out-of-order onreadystatechange(), binding script
      // execution to an event listener gives us control over when the script
      // is executed. See http://jaubourg.net/2010/07/loading-script-as-onclick-handler-of.html
      script.htmlFor = script.id = '_reqwest_' + reqId
    }

    script.onload = script.onreadystatechange = function () {
      if ((script[readyState] && script[readyState] !== 'complete' && script[readyState] !== 'loaded') || loaded) {
        return false
      }
      script.onload = script.onreadystatechange = null
      script.onclick && script.onclick()
      // Call the user callback with the last value stored and clean up values and scripts.
      fn(lastValue)
      lastValue = undefined
      head.removeChild(script)
      loaded = 1
    }

    // Add the script to the DOM head
    head.appendChild(script)

    // Enable JSONP timeout
    return {
      abort: function () {
        script.onload = script.onreadystatechange = null
        err({}, 'Request is aborted: timeout', {})
        lastValue = undefined
        head.removeChild(script)
        loaded = 1
      }
    }
  }

  function getRequest(fn, err) {
    var o = this.o
      , method = (o['method'] || 'GET').toUpperCase()
      , url = typeof o === 'string' ? o : o['url']
      // convert non-string objects to query-string form unless o['processData'] is false
      , data = (o['processData'] !== false && o['data'] && typeof o['data'] !== 'string')
        ? reqwest.toQueryString(o['data'])
        : (o['data'] || null)
      , http
      , sendWait = false

    // if we're working on a GET request and we have data then we should append
    // query string to end of URL and not post data
    if ((o['type'] == 'jsonp' || method == 'GET') && data) {
      url = urlappend(url, data)
      data = null
    }

    if (o['type'] == 'jsonp') return handleJsonp(o, fn, err, url)

    // get the xhr from the factory if passed
    // if the factory returns null, fall-back to ours
    http = (o.xhr && o.xhr(o)) || xhr(o)

    http.open(method, url, o['async'] === false ? false : true)
    setHeaders(http, o)
    setCredentials(http, o)
    if (context[xDomainRequest] && http instanceof context[xDomainRequest]) {
        http.onload = fn
        http.onerror = err
        // NOTE: see
        // http://social.msdn.microsoft.com/Forums/en-US/iewebdevelopment/thread/30ef3add-767c-4436-b8a9-f1ca19b4812e
        http.onprogress = function() {}
        sendWait = true
    } else {
      http.onreadystatechange = handleReadyState(this, fn, err)
    }
    o['before'] && o['before'](http)
    if (sendWait) {
      setTimeout(function () {
        http.send(data)
      }, 200)
    } else {
      http.send(data)
    }
    return http
  }

  function Reqwest(o, fn) {
    this.o = o
    this.fn = fn

    init.apply(this, arguments)
  }

  function setType(header) {
    // json, javascript, text/plain, text/html, xml
    if (header === null) return undefined; //In case of no content-type.
    if (header.match('json')) return 'json'
    if (header.match('javascript')) return 'js'
    if (header.match('text')) return 'html'
    if (header.match('xml')) return 'xml'
  }

  function init(o, fn) {

    this.url = typeof o == 'string' ? o : o['url']
    this.timeout = null

    // whether request has been fulfilled for purpose
    // of tracking the Promises
    this._fulfilled = false
    // success handlers
    this._successHandler = function(){}
    this._fulfillmentHandlers = []
    // error handlers
    this._errorHandlers = []
    // complete (both success and fail) handlers
    this._completeHandlers = []
    this._erred = false
    this._responseArgs = {}

    var self = this

    fn = fn || function () {}

    if (o['timeout']) {
      this.timeout = setTimeout(function () {
        timedOut()
      }, o['timeout'])
    }

    if (o['success']) {
      this._successHandler = function () {
        o['success'].apply(o, arguments)
      }
    }

    if (o['error']) {
      this._errorHandlers.push(function () {
        o['error'].apply(o, arguments)
      })
    }

    if (o['complete']) {
      this._completeHandlers.push(function () {
        o['complete'].apply(o, arguments)
      })
    }

    function complete (resp) {
      o['timeout'] && clearTimeout(self.timeout)
      self.timeout = null
      while (self._completeHandlers.length > 0) {
        self._completeHandlers.shift()(resp)
      }
    }

    function success (resp) {
      var type = o['type'] || resp && setType(resp.getResponseHeader('Content-Type')) // resp can be undefined in IE
      resp = (type !== 'jsonp') ? self.request : resp
      // use global data filter on response text
      var filteredResponse = globalSetupOptions.dataFilter(resp.responseText, type)
        , r = filteredResponse
      try {
        resp.responseText = r
      } catch (e) {
        // can't assign this in IE<=8, just ignore
      }
      if (r) {
        switch (type) {
        case 'json':
          try {
            resp = context.JSON ? context.JSON.parse(r) : eval('(' + r + ')')
          } catch (err) {
            return error(resp, 'Could not parse JSON in response', err)
          }
          break
        case 'js':
          resp = eval(r)
          break
        case 'html':
          resp = r
          break
        case 'xml':
          resp = resp.responseXML
              && resp.responseXML.parseError // IE trololo
              && resp.responseXML.parseError.errorCode
              && resp.responseXML.parseError.reason
            ? null
            : resp.responseXML
          break
        }
      }

      self._responseArgs.resp = resp
      self._fulfilled = true
      fn(resp)
      self._successHandler(resp)
      while (self._fulfillmentHandlers.length > 0) {
        resp = self._fulfillmentHandlers.shift()(resp)
      }

      complete(resp)
    }

    function timedOut() {
      self._timedOut = true
      self.request.abort()
    }

    function error(resp, msg, t) {
      resp = self.request
      self._responseArgs.resp = resp
      self._responseArgs.msg = msg
      self._responseArgs.t = t
      self._erred = true
      while (self._errorHandlers.length > 0) {
        self._errorHandlers.shift()(resp, msg, t)
      }
      complete(resp)
    }

    this.request = getRequest.call(this, success, error)
  }

  Reqwest.prototype = {
    abort: function () {
      this._aborted = true
      this.request.abort()
    }

  , retry: function () {
      init.call(this, this.o, this.fn)
    }

    /**
     * Small deviation from the Promises A CommonJs specification
     * http://wiki.commonjs.org/wiki/Promises/A
     */

    /**
     * `then` will execute upon successful requests
     */
  , then: function (success, fail) {
      success = success || function () {}
      fail = fail || function () {}
      if (this._fulfilled) {
        this._responseArgs.resp = success(this._responseArgs.resp)
      } else if (this._erred) {
        fail(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t)
      } else {
        this._fulfillmentHandlers.push(success)
        this._errorHandlers.push(fail)
      }
      return this
    }

    /**
     * `always` will execute whether the request succeeds or fails
     */
  , always: function (fn) {
      if (this._fulfilled || this._erred) {
        fn(this._responseArgs.resp)
      } else {
        this._completeHandlers.push(fn)
      }
      return this
    }

    /**
     * `fail` will execute when the request fails
     */
  , fail: function (fn) {
      if (this._erred) {
        fn(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t)
      } else {
        this._errorHandlers.push(fn)
      }
      return this
    }
  , 'catch': function (fn) {
      return this.fail(fn)
    }
  }

  function reqwest(o, fn) {
    return new Reqwest(o, fn)
  }

  // normalize newline variants according to spec -> CRLF
  function normalize(s) {
    return s ? s.replace(/\r?\n/g, '\r\n') : ''
  }

  function serial(el, cb) {
    var n = el.name
      , t = el.tagName.toLowerCase()
      , optCb = function (o) {
          // IE gives value="" even where there is no value attribute
          // 'specified' ref: http://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-862529273
          if (o && !o['disabled'])
            cb(n, normalize(o['attributes']['value'] && o['attributes']['value']['specified'] ? o['value'] : o['text']))
        }
      , ch, ra, val, i

    // don't serialize elements that are disabled or without a name
    if (el.disabled || !n) return

    switch (t) {
    case 'input':
      if (!/reset|button|image|file/i.test(el.type)) {
        ch = /checkbox/i.test(el.type)
        ra = /radio/i.test(el.type)
        val = el.value
        // WebKit gives us "" instead of "on" if a checkbox has no value, so correct it here
        ;(!(ch || ra) || el.checked) && cb(n, normalize(ch && val === '' ? 'on' : val))
      }
      break
    case 'textarea':
      cb(n, normalize(el.value))
      break
    case 'select':
      if (el.type.toLowerCase() === 'select-one') {
        optCb(el.selectedIndex >= 0 ? el.options[el.selectedIndex] : null)
      } else {
        for (i = 0; el.length && i < el.length; i++) {
          el.options[i].selected && optCb(el.options[i])
        }
      }
      break
    }
  }

  // collect up all form elements found from the passed argument elements all
  // the way down to child elements; pass a '<form>' or form fields.
  // called with 'this'=callback to use for serial() on each element
  function eachFormElement() {
    var cb = this
      , e, i
      , serializeSubtags = function (e, tags) {
          var i, j, fa
          for (i = 0; i < tags.length; i++) {
            fa = e[byTag](tags[i])
            for (j = 0; j < fa.length; j++) serial(fa[j], cb)
          }
        }

    for (i = 0; i < arguments.length; i++) {
      e = arguments[i]
      if (/input|select|textarea/i.test(e.tagName)) serial(e, cb)
      serializeSubtags(e, [ 'input', 'select', 'textarea' ])
    }
  }

  // standard query string style serialization
  function serializeQueryString() {
    return reqwest.toQueryString(reqwest.serializeArray.apply(null, arguments))
  }

  // { 'name': 'value', ... } style serialization
  function serializeHash() {
    var hash = {}
    eachFormElement.apply(function (name, value) {
      if (name in hash) {
        hash[name] && !isArray(hash[name]) && (hash[name] = [hash[name]])
        hash[name].push(value)
      } else hash[name] = value
    }, arguments)
    return hash
  }

  // [ { name: 'name', value: 'value' }, ... ] style serialization
  reqwest.serializeArray = function () {
    var arr = []
    eachFormElement.apply(function (name, value) {
      arr.push({name: name, value: value})
    }, arguments)
    return arr
  }

  reqwest.serialize = function () {
    if (arguments.length === 0) return ''
    var opt, fn
      , args = Array.prototype.slice.call(arguments, 0)

    opt = args.pop()
    opt && opt.nodeType && args.push(opt) && (opt = null)
    opt && (opt = opt.type)

    if (opt == 'map') fn = serializeHash
    else if (opt == 'array') fn = reqwest.serializeArray
    else fn = serializeQueryString

    return fn.apply(null, args)
  }

  reqwest.toQueryString = function (o, trad) {
    var prefix, i
      , traditional = trad || false
      , s = []
      , enc = encodeURIComponent
      , add = function (key, value) {
          // If value is a function, invoke it and return its value
          value = ('function' === typeof value) ? value() : (value == null ? '' : value)
          s[s.length] = enc(key) + '=' + enc(value)
        }
    // If an array was passed in, assume that it is an array of form elements.
    if (isArray(o)) {
      for (i = 0; o && i < o.length; i++) add(o[i]['name'], o[i]['value'])
    } else {
      // If traditional, encode the "old" way (the way 1.3.2 or older
      // did it), otherwise encode params recursively.
      for (prefix in o) {
        if (o.hasOwnProperty(prefix)) buildParams(prefix, o[prefix], traditional, add)
      }
    }

    // spaces should be + according to spec
    return s.join('&').replace(/%20/g, '+')
  }

  function buildParams(prefix, obj, traditional, add) {
    var name, i, v
      , rbracket = /\[\]$/

    if (isArray(obj)) {
      // Serialize array item.
      for (i = 0; obj && i < obj.length; i++) {
        v = obj[i]
        if (traditional || rbracket.test(prefix)) {
          // Treat each array item as a scalar.
          add(prefix, v)
        } else {
          buildParams(prefix + '[' + (typeof v === 'object' ? i : '') + ']', v, traditional, add)
        }
      }
    } else if (obj && obj.toString() === '[object Object]') {
      // Serialize object item.
      for (name in obj) {
        buildParams(prefix + '[' + name + ']', obj[name], traditional, add)
      }

    } else {
      // Serialize scalar item.
      add(prefix, obj)
    }
  }

  reqwest.getcallbackPrefix = function () {
    return callbackPrefix
  }

  // jQuery and Zepto compatibility, differences can be remapped here so you can call
  // .ajax.compat(options, callback)
  reqwest.compat = function (o, fn) {
    if (o) {
      o['type'] && (o['method'] = o['type']) && delete o['type']
      o['dataType'] && (o['type'] = o['dataType'])
      o['jsonpCallback'] && (o['jsonpCallbackName'] = o['jsonpCallback']) && delete o['jsonpCallback']
      o['jsonp'] && (o['jsonpCallback'] = o['jsonp'])
    }
    return new Reqwest(o, fn)
  }

  reqwest.ajaxSetup = function (options) {
    options = options || {}
    for (var k in options) {
      globalSetupOptions[k] = options[k]
    }
  }

  return reqwest
});

});
},{"30":30,"8":8}],158:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
/*! http://mths.be/startswith v0.2.0 by @mathias */
if (!String.prototype.startsWith) {
	(function() {
		'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
		var defineProperty = (function() {
			// IE 8 only supports `Object.defineProperty` on DOM elements
			try {
				var object = {};
				var $defineProperty = Object.defineProperty;
				var result = $defineProperty(object, object, object) && $defineProperty;
			} catch(error) {}
			return result;
		}());
		var toString = {}.toString;
		var startsWith = function(search) {
			if (this == null) {
				throw TypeError();
			}
			var string = String(this);
			if (search && toString.call(search) == '[object RegExp]') {
				throw TypeError();
			}
			var stringLength = string.length;
			var searchString = String(search);
			var searchLength = searchString.length;
			var position = arguments.length > 1 ? arguments[1] : undefined;
			// `ToInteger`
			var pos = position ? Number(position) : 0;
			if (pos != pos) { // better `isNaN`
				pos = 0;
			}
			var start = Math.min(Math.max(pos, 0), stringLength);
			// Avoid the `indexOf` call if no match is possible
			if (searchLength + start > stringLength) {
				return false;
			}
			var index = -1;
			while (++index < searchLength) {
				if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) {
					return false;
				}
			}
			return true;
		};
		if (defineProperty) {
			defineProperty(String.prototype, 'startsWith', {
				'value': startsWith,
				'configurable': true,
				'writable': true
			});
		} else {
			String.prototype.startsWith = startsWith;
		}
	}());
}

});
},{"8":8}],159:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require(12);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var errors = {
  /* signin */
  'signin.generic.error': {
    'signin.password': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.denied.error': {
    'signin.password': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.unauthorized': {
    'signin.password': {
      msg: 'Sorry, we don\'t recognise your username or password.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.generic.banned': {
    'signin.password': {
      msg: 'This user has been banned for an unspecified reason.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.banned': {
    'signin.password': {
      msg: 'This user has been banned.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.disapproved': {
    'signin.password': {
      msg: 'This user has been disapproved.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.possible spam activity': {
    'signin.password': {
      msg: 'This user has been identified as possible spammer.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.locked out': {
    'signin.password': {
      msg: 'This user has been locked out.',
      state: 'error'
    },
    'signin.userName': {
      msg: '',
      state: 'error'
    }
  },
  'signin.identification.any.empty': {
    'signin.userName': {
      msg: 'Please enter your username.',
      state: 'error'
    }
  },
  'signin.password.any.empty': {
    'signin.password': {
      msg: 'Please enter your password.',
      state: 'error'
    }
  },
  'signin.guardianEmail.notYetGranted': {
    'signin.password': {
      msg: 'Your parent / guardian has not yet granted you access.',
      state: 'error'
    }
  },
  'signin.guardianEmail.denied': {
    'signin.password': {
      msg: 'Your parent / guardian has denied you access.',
      state: 'error'
    }
  },
  /* registration */
  'registration.generic.error': {
    'registration.password': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    }
  },
  'registration.denied.error': {
    'registration.password': {
      msg: 'This user is not allowed to register. Please contact customer support.',
      state: 'error'
    }
  },
  'registration..spam': {
    'registration.password': {
      msg: 'Contact customer support',
      state: 'error'
    }
  },
  'registration.username.any.empty': {
    'registration.username': {
      msg: 'Please choose a username.',
      state: 'error'
    }
  },
  'registration.username.string.min': {
    'registration.username': {
      msg: 'Usernames must be at least three characters long.',
      state: 'error'
    }
  },
  'registration.username.string.max': {
    'registration.username': {
      msg: 'Usernames must be no more than 30 characters long.',
      state: 'error'
    }
  },
  'registration.email.duplicate': {
    'registration.email': {
      msg: 'This email address has already been registered.',
      state: 'error'
    }
  },
  'registration.email.string.email': {
    'registration.email': {
      msg: 'Please enter a valid email address.',
      state: 'error'
    }
  },
  'registration.email.any.empty': {
    'registration.email': {
      msg: 'Please enter an email address.',
      state: 'error'
    }
  },
  'registration.username.string.regex.base': {
    'registration.username': {
      msg: 'Usernames can only contain letters, numbers and the characters _ or -.',
      state: 'error'
    }
  },
  'registration.username.duplicate': {
    'registration.username': {
      msg: 'This username has already been taken.',
      state: 'error'
    }
  },
  'registration.password.any.empty': {
    'registration.password': {
      msg: 'Please choose a password.',
      state: 'error'
    }
  },
  'registration.password.string.min': {
    'registration.password': {
      msg: 'Your password must be at least six characters long.',
      state: 'error'
    }
  },
  'registration.firstName.any.empty': {
    'registration.firstName': {
      msg: 'Please tell us your first name.',
      state: 'error'
    }
  },
  'registration.lastName.any.empty': {
    'registration.lastName': {
      msg: 'Please tell us your last name.',
      state: 'error'
    }
  },
  'registration.dateOfBirth.incomplete': {
    // necessary for a invalid date
  },
  'registration.dateOfBirth.invalid': {
    'registration.dateOfBirth': {
      msg: 'The date is not valid.',
      state: 'error'
    }
  },
  'registration.dateOfBirth.future': {
    'registration.dateOfBirth': {
      msg: 'The date of birth should be set in the past.',
      state: 'error'
    }
  },
  'registration.dateOfBirth.tooYoung': {
    'registration.dateOfBirth': {
      msg: 'You should be at least 2 years old.',
      state: 'error'
    }
  },
  'registration.dateOfBirth.tooOld': {
    'registration.dateOfBirth': {
      msg: 'Are you really older than 120 years old?',
      state: 'error'
    }
  },
  'registration.guardianEmail.string.email': {
    'registration.guardianEmail': {
      msg: 'The guardian email should be a valid email.',
      state: 'error'
    }
  },
  'registration.guardianEmail.any.empty': {
    'registration.guardianEmail': {
      msg: 'The guardian email or Tes Teach class code should not be empty.',
      state: 'error'
    }
  },
  'registration.classCode.any.empty': {
    'registration.classCode': {
      msg: 'Either the Tes Teach class code or guardian email must be filled in.',
      state: 'error'
    }
  },
  'registration.classCode.invalid': {
    'registration.classCode': {
      msg: 'The Tes Teach class code is not valid.',
      state: 'error'
    }
  },
  /* google */
  'google.generic.error': {
    'generic.googlebutton': {
      msg: 'Google error.',
      state: 'error'
    }
  },
  'google.unauthorized': {
    'generic.googlebutton': {
      msg: 'Sorry, Google couldn\'t authorise this user.',
      state: 'error'
    }
  },
  'facebook.unauthorized': {
    'generic.googlebutton': {
      msg: 'Sorry, Facebook couldn\'t authorise this user.',
      state: 'error'
    }
  },
  'google.popup.closed': {
    'generic.googlebutton': {
      msg: 'The Google popup has been closed.',
      state: 'error'
    }
  },
  'facebook.popup.closed': {
    'generic.googlebutton': {
      msg: 'The Facebook popup has been closed.',
      state: 'error'
    }
  },
  'google.popup.blocked': {
    'generic.googlebutton': {
      msg: 'The Google popup may have been blocked by your browser. Please check your settings.',
      state: 'error'
    }
  },
  'facebook.popup.blocked': {
    'generic.googlebutton': {
      msg: 'The Facebook popup may have been blocked by your browser. Please check your settings.',
      state: 'error'
    }
  },
  'google.usererror': {
    'generic.googlebutton': {
      msg: 'Sorry, Google couldn\'t register or log in this user.',
      state: 'error'
    }
  },
  'facebook.usererror': {
    'generic.googlebutton': {
      msg: 'Sorry, Facebook couldn\'t register or log in this user.',
      state: 'error'
    }
  },
  /* forgot-password */
  'forgot-password.generic.error': {
    'forgot-password.identification': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    }
  },
  'forgot-password.denied.error': {
    'forgot-password.identification': {
      msg: 'This user is not allowed to reset the password. Please contact customer support.',
      state: 'error'
    }
  },
  'forgot-password.email.string.email': {
    'forgot-password.identification': {
      msg: 'Please enter your email address.',
      state: 'error'
    }
  },
  'forgot-password.email.any.empty': {
    'forgot-password.identification': {
      msg: 'Please enter your email address.',
      state: 'error'
    }
  },
  'forgot-password.user.not-found': {
    'forgot-password.identification': {
      msg: 'Sorry, we don\'t recognise that email address.',
      state: 'error'
    }
  },
  'forgot-password.generic.banned': {
    'forgot-password.identification': {
      msg: 'This user has been banned for an unspecified reason.',
      state: 'error'
    }
  },
  'forgot-password.banned': {
    'forgot-password.identification': {
      msg: 'This user has been banned.',
      state: 'error'
    }
  },
  'forgot-password.disapproved': {
    'forgot-password.identification': {
      msg: 'This user has been disapproved.',
      state: 'error'
    }
  },
  'forgot-password.possible spam activity': {
    'forgot-password.identification': {
      msg: 'This user has been identified as possible spammer.',
      state: 'error'
    }
  },
  'forgot-password.locked out': {
    'forgot-password.identification': {
      msg: 'This user has been locked out.',
      state: 'error'
    }
  },
  /* resend-confirmation-email */
  'resend-confirmation-email.generic.error': {
    submitted: true,
    'resend-confirmation-email': {
      msg: 'Server error. Please try again later.',
      state: 'error'
    }
  },
  'resend-confirmation-email.email.any.empty': {
    submitted: true,
    'resend-confirmation-email': {
      msg: 'Please enter an email address.',
      state: 'error'
    }
  },
  'resend-confirmation-email.email.string.email': {
    submitted: true,
    'resend-confirmation-email': {
      msg: 'Please enter a valid email address.',
      state: 'error'
    }
  },
  'resend-confirmation-email.generic-success': {
    submitted: true,
    success: true
  },
  'reset-password.invalid-token': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, that reset link didn\'t work. Please try a new one.',
      state: 'error'
    }
  },
  /* reset-password */
  'reset-password.generic.error': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, we weren\'t able to change your password. Please try again later.',
      state: 'error'
    }
  },
  'reset-password.server-error': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, we weren\'t able to change your password. Please try again later.',
      state: 'error'
    }
  },
  'reset-password.token-error': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, this link is not valid any more. Can you ask for a new one?',
      state: 'error'
    }
  },
  'reset-password.unable': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, We are unable to change the password, have you already changed it?',
      state: 'error'
    }
  },
  'reset-password.blocked': {
    submitted: true,
    'reset-password': {
      msg: 'Sorry, This user is blocked/banned. Contact customer support.',
      state: 'error'
    }
  },
  'reset-password.generic-success': {
    submitted: true,
    success: true
  },
  'edit-account.generic.error': {
    'edit-account.userType': {
      msg: 'Sorry, we weren\'t able to update your account. Please try again later.',
      state: 'error'
    },
    'edit-account.message': {
      msg: 'Sorry, we weren\'t able to update your account. Please try again later.',
      state: 'error'
    }
  },
  'edit-account.userType.any.allowOnly': {
    'edit-account.userType': {
      msg: 'The user type is not correct, please pick one',
      state: 'error'
    }
  },
  'edit-account.firstName.any.empty': {
    'edit-account.firstName': {
      msg: 'Please tell us your first name.',
      state: 'error'
    }
  },
  'edit-account.lastName.any.empty': {
    'edit-account.lastName': {
      msg: 'Please tell us your last name.',
      state: 'error'
    }
  },
  'edit-account.email.duplicate': {
    'edit-account.email': {
      msg: 'This email address has already been registered.',
      state: 'error'
    }
  },
  'edit-account.email.string.email': {
    'edit-account.email': {
      msg: 'Please enter a valid email address.',
      state: 'error'
    }
  },
  'edit-account.email.any.empty': {
    'edit-account.email': {
      msg: 'Please enter your email address.',
      state: 'error'
    }
  },
  'change-password.generic.error': {
    'change-password.password': {
      msg: 'Sorry, we weren\'t able to update your account. Please try again later.',
      state: 'error'
    }
  },
  'change-password.password.string.min': {
    'change-password.password': {
      msg: 'Your password must be at least six characters long.',
      state: 'error'
    }
  },
  'change-password.oldpassword.wrong': {
    'change-password.oldPassword': {
      msg: 'Your password is not correct, please try entering it again.',
      state: 'error'
    }
  },
  'change-password.samepassword': {
    'change-password.password': {
      msg: 'The new password is the same as the previous password.',
      state: 'error'
    }
  },
  'change-password.ok': {
    'change-password.message': {
      msg: 'You have succesfully changed your password.',
      state: 'success'
    }
  }
};

exports.default = function (codes) {
  if (!codes) return {};
  var errorCodes = codes.split(',');
  var validErrorCodes = errorCodes.filter(function (code) {
    return code in errors;
  });

  if (validErrorCodes.length === 0) {
    var prefix = errorCodes[0].split('.', 1);
    validErrorCodes.push(prefix + '.generic.error');
  }

  return validErrorCodes.map(function (code) {
    return errors[code];
  }).reduce(function (previous, current) {
    return (0, _assign2.default)({}, previous, current);
  }, {});
};

});
},{"12":12,"8":8}],160:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = undefined;

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(26);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(25);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _Signin = require(167);

var _Signin2 = _interopRequireDefault(_Signin);

var _ForgotPassword = require(161);

var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);

var _SelectPosition = require(166);

var _SelectPosition2 = _interopRequireDefault(_SelectPosition);

var _LoggedInUpdate = require(163);

var _LoggedInUpdate2 = _interopRequireDefault(_LoggedInUpdate);

var _LoggedInSelectPosition = require(162);

var _LoggedInSelectPosition2 = _interopRequireDefault(_LoggedInSelectPosition);

var _Register = require(164);

var _Register2 = _interopRequireDefault(_Register);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require(181);

var actionCreators = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TesModalContainer(_ref) {
  var hasWrapper = _ref.hasWrapper,
      noWrapperStyle = _ref.noWrapperStyle,
      children = _ref.children;

  if (!hasWrapper) return _react2.default.createElement(
    'div',
    { style: noWrapperStyle },
    children
  );
  return _react2.default.createElement(
    'div',
    { className: 'tes-modal__body' },
    children
  );
}

TesModalContainer.propTypes = {
  hasWrapper: _react.PropTypes.bool,
  noWrapperStyle: _react.PropTypes.object
};

var App = exports.App = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    (0, _classCallCheck3.default)(this, App);
    return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).apply(this, arguments));
  }

  (0, _createClass3.default)(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actions.trackDisplay(this.props.common.formType);
      if (!this.props.common.isModal && !this.props.common.isInline) {
        this.props.actions.failRegister(this.props.errors);
        this.props.actions.failSignIn(this.props.errors);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var isModal = this.props.common.isModal;

      var borderStyle = {};
      var components = {
        'sign-in': _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: isModal },
          _react2.default.createElement(_Signin2.default, null)
        ),
        register: _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: isModal },
          _react2.default.createElement(_Register2.default, null)
        ),
        'forgot-password': _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: isModal },
          _react2.default.createElement(_ForgotPassword2.default, null)
        ),
        select: _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: false, noWrapperStyle: isModal ? {} : borderStyle },
          _react2.default.createElement(_SelectPosition2.default, { onClick: function onClick() {}, action: '', method: '' })
        ),
        'logged-in-select': _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: false },
          _react2.default.createElement(_LoggedInSelectPosition2.default, null)
        ),
        'logged-in-update': _react2.default.createElement(
          TesModalContainer,
          { hasWrapper: isModal },
          _react2.default.createElement(_LoggedInUpdate2.default, null)
        )
      };
      var component = components[this.props.common.formType];
      return component;
    }
  }]);
  return App;
}(_react.Component);

App.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  signIn: _react.PropTypes.object.isRequired,
  register: _react.PropTypes.object.isRequired,
  forgotPassword: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    signIn: state.signIn,
    register: state.register,
    forgotPassword: state.forgotPassword
  };
}, mapDispatchToProps)(App);

});
},{"15":15,"161":161,"162":162,"163":163,"164":164,"166":166,"167":167,"181":181,"21":21,"22":22,"25":25,"26":26,"8":8}],161:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ForgotPassword = undefined;

var _keys = require(16);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(26);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(25);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _getErrorFromPrefix = require(177);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require(181);

var actionCreators = _interopRequireWildcard(_actions);

var _WidgetLink = require(173);

var _WidgetLink2 = _interopRequireDefault(_WidgetLink);

var _HiddenInputs = require(171);

var _HiddenInputs2 = _interopRequireDefault(_HiddenInputs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('forgot-password');
var getErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('forgot-password');

var ForgotPassword = exports.ForgotPassword = function (_Component) {
  (0, _inherits3.default)(ForgotPassword, _Component);

  function ForgotPassword() {
    (0, _classCallCheck3.default)(this, ForgotPassword);
    return (0, _possibleConstructorReturn3.default)(this, (ForgotPassword.__proto__ || (0, _getPrototypeOf2.default)(ForgotPassword)).apply(this, arguments));
  }

  (0, _createClass3.default)(ForgotPassword, [{
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      this.props.actions.initForgotPassword();
    }
  }, {
    key: 'handleContinue',
    value: function handleContinue(e) {
      e.preventDefault();
      this.props.actions.successForgotPassword();
    }
  }, {
    key: 'hasError',
    value: function hasError() {
      return this.props.errors ? (0, _keys2.default)(this.props.errors).filter(function (n) {
        return n.startsWith('forgot-password.');
      }).length > 0 : false;
    }
  }, {
    key: 'changeField',
    value: function changeField(namepar, depspar) {
      var _this2 = this;

      var name = 'forgot-password.' + namepar;
      var deps = depspar.map(function (n) {
        return 'forgotpassword.' + n;
      }) || [];
      return function (e) {
        var target = e.target;
        _this2.props.actions.setField('forgotPassword', target.name, target.value);
        _this2.props.actions.changeField(name, deps);
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var err = this.props.errors;

      var content = void 0;
      if (this.props.forgotPassword.state === 'sent') {
        content = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'Email sent! Please now check your inbox'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'These emails can get caught in spam - please also check your spam folder.'
          ),
          _react2.default.createElement(
            'button',
            { onClick: function onClick(e) {
                return _this3.handleContinue(e);
              }, className: 'tes-btn tes-btn--lg tes-btn--icon tes-btn--block tes-btn--primary' },
            'Continue',
            _react2.default.createElement('span', { 'aria-hidden': 'true' })
          )
        );
      } else {
        content = _react2.default.createElement(
          'form',
          { onSubmit: function onSubmit(e) {
              return _this3.handleSubmit(e);
            }, role: 'form', method: 'post', className: 't-forgot-password-form' },
          _react2.default.createElement(_HiddenInputs2.default, null),
          _react2.default.createElement(
            'div',
            { className: getErrorCls('identification')(err) },
            _react2.default.createElement(
              'div',
              { className: 'tes-input-group' },
              _react2.default.createElement(
                'span',
                { className: 'tes-input-group__addon' },
                _react2.default.createElement('i', { className: 'icon icon-user' })
              ),
              _react2.default.createElement('input', { type: 'text', onChange: this.changeField('identification', []),
                name: 'identification',
                autoFocus: 'true',
                placeholder: 'email',
                value: this.props.forgotPassword.identification,
                className: 'tes-control tes-control--group identification-field t-identification'
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'tes-help-block' },
              getErrorMsg('identification')(err)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'margin-top-md margin-bottom-sm' },
            _react2.default.createElement(
              'button',
              { disabled: this.props.forgotPassword.state === 'wait' ? 'disabled' : null, type: 'submit', className: 'tes-btn tes-btn--lg tes-btn--icon tes-btn--block tes-btn--primary forgot-password-submit' },
              this.props.forgotPassword.state === 'wait' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner icon-white' }) : 'Send'
            )
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { id: 'sign-in', className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
        _react2.default.createElement(
          'div',
          { className: 'heading-main margin-bottom-md text-center' },
          _react2.default.createElement(
            'h3',
            { className: 'tes-modal__heading margin-bottom-sm' },
            'Recover your password'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Send us your email and we will send you instructions to reset your password.'
          )
        ),
        content,
        _react2.default.createElement(
          'div',
          { className: 'clearfix' },
          _react2.default.createElement(
            'div',
            { className: 'more-info text-center text--sm padding-top-sm border-top' },
            _react2.default.createElement(
              'span',
              null,
              'Remember your password?'
            ),
            _react2.default.createElement(
              'span',
              null,
              ' '
            ),
            _react2.default.createElement(
              _WidgetLink2.default,
              { formType: 'signIn' },
              'Log in now!'
            )
          )
        )
      );
    }
  }]);
  return ForgotPassword;
}(_react.Component);

ForgotPassword.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  signIn: _react.PropTypes.object.isRequired,
  register: _react.PropTypes.object.isRequired,
  forgotPassword: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    signIn: state.signIn,
    register: state.register,
    forgotPassword: state.forgotPassword
  };
}, mapDispatchToProps)(ForgotPassword);

});
},{"15":15,"16":16,"171":171,"173":173,"177":177,"181":181,"21":21,"22":22,"25":25,"26":26,"8":8}],162:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoggedInSelectPosition;

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _SelectFormPosition = require(165);

var _SelectFormPosition2 = _interopRequireDefault(_SelectFormPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LoggedInSelectPosition() {
  return _react2.default.createElement(_SelectFormPosition2.default, {
    isStandAlone: true,
    action: '/api/authn/edit-account',
    method: 'post'
  });
}

});
},{"165":165,"8":8}],163:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoggedInUpdate = undefined;

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(26);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(25);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _getErrorFromPrefix = require(177);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require(181);

var actionCreators = _interopRequireWildcard(_actions);

var _InputField = require(172);

var _InputField2 = _interopRequireDefault(_InputField);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('edit-account');
var getErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('edit-account');

var LoggedInUpdate = exports.LoggedInUpdate = function (_Component) {
  (0, _inherits3.default)(LoggedInUpdate, _Component);

  function LoggedInUpdate(props) {
    (0, _classCallCheck3.default)(this, LoggedInUpdate);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LoggedInUpdate.__proto__ || (0, _getPrototypeOf2.default)(LoggedInUpdate)).call(this, props));

    _this.state = {
      firstName: '',
      lastName: '',
      email: '',
      userType: _this.props.common.userType
    };
    return _this;
  }

  (0, _createClass3.default)(LoggedInUpdate, [{
    key: 'onChange',
    value: function onChange(e, name) {
      var data = {};
      data[name] = e.target.value;
      this.setState(data);
    }
  }, {
    key: 'getActiveFields',
    value: function getActiveFields() {
      var variants = {
        fullname: {
          title: 'Please add your full name',
          helpLink: 'Why are you being asked for your name?',
          helpText: 'This section of our site requires your name as you will be interacting with schools, institutions or other members of TES in a professional context. Using your actual name here improves the service and will allow you to interact with others with greater transparency and trust.',
          validFields: ['firstName', 'lastName']
        },
        email: {
          title: 'Please add your email',
          validFields: ['email', 'userType']
        }
      };

      if (!variants[this.props.common.variant]) {
        return variants.fullname;
      }
      return variants[this.props.common.variant];
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      if (!this.props.common.isModal && !this.props.common.isInline) return;
      e.preventDefault();

      var activeFields = this.getActiveFields();
      var hasField = function hasField(name) {
        return activeFields.validFields.indexOf(name) !== -1;
      };

      var data = {};
      if (hasField('firstName')) {
        data.firstName = this.state.firstName;
      }
      if (hasField('lastName')) {
        data.lastName = this.state.lastName;
      }
      if (hasField('email')) {
        data.email = this.state.email;
      }
      if (hasField('userType')) {
        data.userType = this.state.userType;
      }
      this.props.actions.resetErrors();
      this.props.actions.updateUserData(data);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var err = this.props.errors;
      var activeFields = this.getActiveFields();
      var hasField = function hasField(name) {
        return activeFields.validFields.indexOf(name) !== -1;
      };

      return _react2.default.createElement(
        'div',
        { id: 'logged-in-update', className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
        _react2.default.createElement(
          'div',
          { className: 'heading-main margin-bottom-md text-center' },
          _react2.default.createElement(
            'h3',
            { className: 'tes-modal__heading margin-bottom-sm' },
            activeFields.title
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'form',
            { autoComplete: 'off', role: 'form', onSubmit: function onSubmit(e) {
                return _this2.handleSubmit(e);
              }, className: 't-logged-in-update margin-bottom-md', method: 'post', action: '/api/authn/edit-account' },
            this.props.common.rtn ? _react2.default.createElement('input', { type: 'hidden', name: 'rtn', value: encodeURIComponent(this.props.common.rtn) }) : null,
            hasField('userType') && this.props.common.userType ? _react2.default.createElement('input', { className: 't-user-type', type: 'hidden', name: 'userType', ref: 'userType', value: this.props.common.userType }) : null,
            _react2.default.createElement('input', { type: 'hidden', name: 'appId', value: this.props.common.appId }),
            _react2.default.createElement('input', { type: 'hidden', name: '_CSRF_TOKEN', value: this.props.common.csrfToken }),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-6' },
                hasField('firstName') ? _react2.default.createElement(_InputField2.default, {
                  name: 'firstName', label: 'First name', value: this.state.firstName,
                  errorClass: getErrorCls('firstName')(err),
                  errorMessage: getErrorMsg('firstName')(err),
                  onChange: function onChange(e) {
                    return _this2.onChange(e, 'firstName');
                  },
                  autoFocus: 'true'
                }) : null
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-xs-12 col-sm-6' },
                hasField('lastName') ? _react2.default.createElement(_InputField2.default, {
                  name: 'firstName', label: 'Last name', value: this.state.lastName,
                  errorClass: getErrorCls('lastName')(err),
                  errorMessage: getErrorMsg('lastName')(err),
                  onChange: function onChange(e) {
                    return _this2.onChange(e, 'lastName');
                  }
                }) : null
              )
            ),
            hasField('email') ? _react2.default.createElement(_InputField2.default, {
              name: 'email',
              label: this.props.common.userType === 'student' ? 'Email (optional)' : 'Email',
              value: this.state.email,
              errorClass: getErrorCls('email')(err),
              errorMessage: getErrorMsg('email')(err),
              onChange: function onChange(e) {
                return _this2.onChange(e, 'email');
              }
            }) : null,
            activeFields.helpLink ? _react2.default.createElement(
              'div',
              { className: 'margin-bottom-xs' },
              _react2.default.createElement(
                'span',
                { className: 'link link--colored text--xs', title: activeFields.helpText },
                activeFields.helpLink
              )
            ) : null,
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'button',
                { type: 'submit', className: 'tes-btn tes-btn--icon tes-btn--lg tes-btn--block tes-btn--primary' },
                'Confirm'
              )
            )
          )
        )
      );
    }
  }]);
  return LoggedInUpdate;
}(_react.Component);

LoggedInUpdate.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors
  };
}, mapDispatchToProps)(LoggedInUpdate);

});
},{"15":15,"172":172,"177":177,"181":181,"21":21,"22":22,"25":25,"26":26,"8":8}],164:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Register = undefined;

var _extends2 = require(24);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require(16);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(26);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(25);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _getErrorFromPrefix = require(177);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require(181);

var actionCreators = _interopRequireWildcard(_actions);

var _WidgetLink = require(173);

var _WidgetLink2 = _interopRequireDefault(_WidgetLink);

var _HiddenInputs = require(171);

var _HiddenInputs2 = _interopRequireDefault(_HiddenInputs);

var _InputField = require(172);

var _InputField2 = _interopRequireDefault(_InputField);

var _dateHelper = require(175);

var _SimpleDate = require(140);

var _SimpleDate2 = _interopRequireDefault(_SimpleDate);

var _errorMessages = require(159);

var _errorMessages2 = _interopRequireDefault(_errorMessages);

var _Branding = require(168);

var _Branding2 = _interopRequireDefault(_Branding);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('registration');
var getErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('registration');
var getGenericErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('generic');
var getGenericErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('generic');

var Register = exports.Register = function (_Component) {
  (0, _inherits3.default)(Register, _Component);

  function Register(props) {
    (0, _classCallCheck3.default)(this, Register);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Register.__proto__ || (0, _getPrototypeOf2.default)(Register)).call(this, props));

    var isStudent = props.common.userType === 'student';
    _this.state = { expandPanel: !isStudent };
    return _this;
  }

  (0, _createClass3.default)(Register, [{
    key: 'onChangeDoB',
    value: function onChangeDoB(d) {
      var errorMessage = (0, _dateHelper.isInvalidDateOfBirth)(d);
      if (errorMessage) {
        this.setDateDoB(null);
        this.props.actions.validationErrors((0, _errorMessages2.default)(errorMessage));
      } else {
        this.props.actions.changeField('registration.dateOfBirth', []);
        this.setDateDoB(d);
      }
    }
  }, {
    key: 'setDateDoB',
    value: function setDateDoB(dob) {
      this.setState({ expandPanel: Boolean(dob) });
      this.props.actions.setField('register', 'dateOfBirth', dob);
    }
  }, {
    key: 'getGoogleLogoURL',
    value: function getGoogleLogoURL() {
      return this.props.common.cdnUrl + 'img/google-logo-g.png';
    }
  }, {
    key: 'getFacebookLogoURL',
    value: function getFacebookLogoURL() {
      return this.props.common.cdnUrl + 'img/facebook-logo.png';
    }
  }, {
    key: 'changeField',
    value: function changeField(namepar, depspar) {
      var _this2 = this;

      var name = 'registration.' + namepar;
      var deps = depspar.map(function (n) {
        return 'registration.' + n;
      }) || [];
      return function (e) {
        var target = e.target;
        _this2.props.actions.setField('register', target.name, target.type === 'checkbox' || target.type === 'radio' ? target.checked : target.value);
        _this2.props.actions.changeField(name, deps);
        _this2.props.actions.validateField(name);
      };
    }
  }, {
    key: 'hasError',
    value: function hasError() {
      return this.props.errors ? (0, _keys2.default)(this.props.errors).filter(function (n) {
        return n.startsWith('registration.');
      }).length > 0 : false;
    }
  }, {
    key: 'handleGoogle',
    value: function handleGoogle() {
      this.props.actions.initOauthSignIn('google');
    }
  }, {
    key: 'handleFacebook',
    value: function handleFacebook() {
      this.props.actions.initOauthSignIn('facebook');
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      var target = e.target;
      this.props.actions.initRegister(function () {
        target.submit(); // only called for pages
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var dateOfBirth = this.props.register.dateOfBirth;

      var err = this.props.errors;
      var hasName = !this.props.common.omitName;
      var isStudent = this.props.common.userType === 'student';
      var under13 = (0, _dateHelper.isUnder13)(dateOfBirth);
      var under18 = under13 || (0, _dateHelper.isUnder18)(dateOfBirth);
      var expandPanel = this.state.expandPanel;

      var wrapperStyle = {
        overflow: 'hidden',
        transition: expandPanel ? 'max-height 280ms linear, transform 200ms cubic-bezier(0.7, 0.54, 0.66, 1.20), opacity 200ms ease-out' : 'none',
        maxHeight: expandPanel ? '520px' : '0',
        transform: expandPanel ? 'scale(1,1)' : 'scale(1.15,0)',
        opacity: expandPanel ? '1' : '0'
      };

      return _react2.default.createElement(
        'div',
        { id: 'sign-in', className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
        this.props.common.branding ? _react2.default.createElement(_Branding2.default, (0, _extends3.default)({}, this.props.common.branding, { cdnUrl: this.props.common.cdnUrl })) : _react2.default.createElement(
          'div',
          { className: 'heading-main margin-bottom-md text-center' },
          _react2.default.createElement(
            'h3',
            { className: 'tes-modal__heading margin-bottom-sm' },
            'Join Tes for free'
          )
        ),
        isStudent ? _react2.default.createElement(
          'div',
          { className: getErrorCls('dateOfBirth')(err) },
          _react2.default.createElement(
            'label',
            { className: 'padding-right-xs', htmlFor: 'dateOfBirth-month' },
            'What is your date of birth?'
          ),
          _react2.default.createElement(_SimpleDate2.default, {
            name: 'dateOfBirth',
            value: this.props.register.dateOfBirth,
            onChange: function onChange(d) {
              return _this3.onChangeDoB(d);
            },
            label: 'Date of birth',
            sequence: this.props.common.dateLocale
          }),
          _react2.default.createElement(
            'div',
            { className: 'tes-help-block' },
            getErrorMsg('dateOfBirth')(err)
          )
        ) : null,
        _react2.default.createElement(
          'div',
          { style: wrapperStyle },
          _react2.default.createElement(
            'div',
            null,
            !isStudent || !under18 ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-12' },
                  _react2.default.createElement(
                    'button',
                    {
                      disabled: this.props.register.state === 'wait' || this.props.common.oauthState ? 'disabled' : null,
                      onClick: function onClick(e) {
                        return _this3.handleGoogle(e);
                      },
                      className: 'tes-btn tes-btn--secondary tes-btn--icon tes-btn--block tes-btn--social'
                    },
                    this.props.common.oauthState === 'google' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner tes-btn__icon' }) : _react2.default.createElement(
                      'span',
                      { className: 'text--sm' },
                      _react2.default.createElement('img', { style: { padding: '0 6px 2px 0', verticalAlign: 'middle' }, src: this.getGoogleLogoURL() }),
                      ' Register with Google'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'row margin-top-sm' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-12' },
                  _react2.default.createElement(
                    'button',
                    {
                      disabled: this.props.register.state === 'wait' || this.props.common.oauthState ? 'disabled' : null,
                      onClick: function onClick(e) {
                        return _this3.handleFacebook(e);
                      },
                      className: 'tes-btn tes-btn--secondary tes-btn--icon tes-btn--block tes-btn--social'
                    },
                    this.props.common.oauthState === 'facebook' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner tes-btn__icon' }) : _react2.default.createElement(
                      'span',
                      { className: 'text--sm' },
                      _react2.default.createElement('img', { style: { padding: '0 6px 2px 0', verticalAlign: 'middle' }, src: this.getFacebookLogoURL() }),
                      ' Register with Facebook'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'separator' },
                _react2.default.createElement(
                  'span',
                  { className: 'separator--text bg-white' },
                  'or'
                )
              )
            ) : null,
            _react2.default.createElement(
              'form',
              { autoComplete: 'off', role: 'form', onSubmit: function onSubmit(e) {
                  return _this3.handleSubmit(e);
                }, className: 't-register-form margin-bottom-md', method: 'post', action: '/api/authn/register-redirect' },
              _react2.default.createElement(_HiddenInputs2.default, null),
              isStudent ? _react2.default.createElement('input', { type: 'hidden', name: 'dateOfBirth', value: this.props.register.dateOfBirth }) : null,
              hasName ? _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-12 col-sm-6' },
                  _react2.default.createElement(_InputField2.default, {
                    name: 'firstName', label: 'First name', value: this.props.register.firstName,
                    errorClass: getErrorCls('firstName')(err),
                    errorMessage: getErrorMsg('firstName')(err),
                    onChange: this.changeField('firstName', [])
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'col-xs-12 col-sm-6' },
                  _react2.default.createElement(_InputField2.default, {
                    name: 'lastName', label: 'Last name', value: this.props.register.lastName,
                    errorClass: getErrorCls('lastName')(err),
                    errorMessage: getErrorMsg('lastName')(err),
                    onChange: this.changeField('lastName', [])
                  })
                )
              ) : null,
              !isStudent || !under13 ? _react2.default.createElement(_InputField2.default, {
                name: 'email',
                label: this.props.common.userType === 'student' && under18 ? 'Email (optional)' : 'Email',
                value: this.props.register.email,
                errorClass: getErrorCls('email')(err),
                errorMessage: getErrorMsg('email')(err),
                onChange: this.changeField('email', []),
                type: 'email'
              }) : null,
              _react2.default.createElement(_InputField2.default, {
                name: 'username',
                label: 'Username',
                value: this.props.register.username,
                errorClass: getErrorCls('username')(err),
                errorMessage: getErrorMsg('username')(err),
                onChange: this.changeField('username', [])
              }),
              _react2.default.createElement(_InputField2.default, {
                name: 'password',
                label: 'password',
                value: this.props.register.password,
                errorClass: getErrorCls('password')(err),
                errorMessage: getErrorMsg('password')(err),
                onChange: this.changeField('password', []),
                type: 'password'
              }),
              isStudent && under13 ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_InputField2.default, {
                  name: 'classCode',
                  label: 'Class code from Tes Teach',
                  value: this.props.register.classCode,
                  errorClass: getErrorCls('classCode')(err),
                  errorMessage: getErrorMsg('classCode')(err),
                  onChange: this.changeField('classCode', [])
                }),
                _react2.default.createElement(
                  'div',
                  { className: 'separator' },
                  _react2.default.createElement(
                    'span',
                    { className: 'separator--text bg-white' },
                    'or'
                  )
                ),
                _react2.default.createElement(_InputField2.default, {
                  name: 'guardianEmail',
                  label: 'Parent / Guardian\'s email address',
                  value: this.props.register.guardianEmail,
                  errorClass: getErrorCls('guardianEmail')(err),
                  errorMessage: getErrorMsg('guardianEmail')(err),
                  onChange: this.changeField('guardianEmail', []),
                  type: 'email'
                })
              ) : null,
              this.props.common.userType !== 'student' ? _react2.default.createElement(
                'div',
                { className: 'tes-checkbox tes-checkbox--inline text--sm margin-bottom-sm' },
                _react2.default.createElement(
                  'label',
                  { className: 'tes-control-label text--xs' },
                  _react2.default.createElement('input', { onChange: this.changeField('newsletter', []),
                    type: 'checkbox', name: 'newsletter',
                    className: 't-newsletter',
                    value: 'true',
                    checked: this.props.register.newsletter
                  }),
                  _react2.default.createElement(
                    'span',
                    { className: 'text--xs' },
                    ' Receive news and updates from TES'
                  )
                )
              ) : null,
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'button',
                  { disabled: this.props.register.state === 'wait' || this.props.common.googleState === 'wait' ? 'disabled' : null,
                    type: 'submit', className: 'tes-btn tes-btn--icon tes-btn--lg sign-up-submit tes-btn--block tes-btn--primary'
                  },
                  this.props.register.state === 'wait' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner icon-white tes-btn__icon' }) : 'Register'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'text--secondary col-xs-12', style: { paddingRight: 0 } },
                _react2.default.createElement(
                  'div',
                  { className: 'margin-bottom-md' },
                  'By registering, you are agreeing to our ',
                  _react2.default.createElement(
                    'a',
                    { target: '_blank', className: 'link link--colored', href: 'https://www.tes.com/content/terms-and-conditions' },
                    'terms and conditions'
                  ),
                  ' and ',
                  _react2.default.createElement(
                    'a',
                    { target: '_blank', className: 'link link--colored', href: 'https://www.tes.com/us/privacy-policy' },
                    'privacy policy'
                  )
                )
              )
            ),
            getGenericErrorCls('googlebutton')(err) ? _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'tes-has-error col-xs-12' },
                _react2.default.createElement(
                  'div',
                  { className: 'tes-help-block' },
                  getGenericErrorMsg('googlebutton')(err)
                )
              )
            ) : null
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'clearfix' },
          _react2.default.createElement(
            'div',
            { className: 'more-info text-center text--sm padding-top-md border-top' },
            _react2.default.createElement(
              'span',
              null,
              'Already have a Tes account?'
            ),
            _react2.default.createElement(
              'span',
              null,
              ' '
            ),
            _react2.default.createElement(
              _WidgetLink2.default,
              { formType: 'signIn' },
              'Log in now!'
            )
          )
        )
      );
    }
  }]);
  return Register;
}(_react.Component);

Register.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  register: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    register: state.register
  };
}, mapDispatchToProps)(Register);

});
},{"140":140,"15":15,"159":159,"16":16,"168":168,"171":171,"172":172,"173":173,"175":175,"177":177,"181":181,"21":21,"22":22,"24":24,"25":25,"26":26,"8":8}],165:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectFormPosition = undefined;

var _extends2 = require(24);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(26);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(25);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require(181);

var actionCreators = _interopRequireWildcard(_actions);

var _HiddenInputs = require(171);

var _HiddenInputs2 = _interopRequireDefault(_HiddenInputs);

var _WidgetLink = require(173);

var _WidgetLink2 = _interopRequireDefault(_WidgetLink);

var _CustomSelect = require(170);

var _CustomSelect2 = _interopRequireDefault(_CustomSelect);

var _ButtonSelect = require(169);

var _ButtonSelect2 = _interopRequireDefault(_ButtonSelect);

var _positionFilter = require(178);

var _Branding = require(168);

var _Branding2 = _interopRequireDefault(_Branding);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectFormPosition = exports.SelectFormPosition = function (_Component) {
  (0, _inherits3.default)(SelectFormPosition, _Component);

  function SelectFormPosition(props) {
    (0, _classCallCheck3.default)(this, SelectFormPosition);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SelectFormPosition.__proto__ || (0, _getPrototypeOf2.default)(SelectFormPosition)).call(this, props));

    var positions = props.refdata.positions;
    var careers = props.refdata.careers;
    var currentPosition = props.common.position;
    var currentCareerObj = (0, _positionFilter.careerFinder)(positions, careers, currentPosition);

    _this.state = { currentCareerObj: currentCareerObj };
    return _this;
  }

  (0, _createClass3.default)(SelectFormPosition, [{
    key: 'onChangeCareer',
    value: function onChangeCareer(currentCareer) {
      var _this2 = this;

      var filteredCareers = this.props.refdata.careers.filter(function (item) {
        return currentCareer === item.name;
      });
      var currentCareerObj = filteredCareers.length ? filteredCareers[0] : { name: '', groupLabel: null };

      this.setState({ currentCareerObj: currentCareerObj });

      var positions = this.props.refdata.positions;
      var validPosition = (0, _positionFilter.filterPosition)(positions, currentCareerObj);

      var newPosition = validPosition.length === 1 ? validPosition[0].name : '';
      var newUserType = validPosition.length === 1 ? validPosition[0].userType : 'other';
      this.props.actions.setPosition(newPosition, newUserType);
      if (!currentCareerObj.groupLabel) {
        setTimeout(function () {
          return _this2.refs.submit.click();
        }, 50); // wait to render the interface with the correct field
      }
    }
  }, {
    key: 'onChangePosition',
    value: function onChangePosition(newPosition) {
      var _this3 = this;

      var positions = this.props.refdata.positions;
      var filteredPositions = positions.filter(function (p) {
        return newPosition === p.name;
      });

      var newUserType = filteredPositions.length ? filteredPositions[0].userType : 'other';
      this.props.actions.setPosition(newPosition, newUserType);
      setTimeout(function () {
        return _this3.refs.submit.click();
      }, 50); // wait to render the interface with the correct field
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit(e) {
      if (!this.props.common.isModal && !this.props.common.isInline) return;
      e.preventDefault();
      var position = this.props.common.position;
      var userType = (0, _positionFilter.getUserTypePosition)(this.props.refdata.positions, position);

      this.props.actions.setUserType(userType);

      if (this.props.isStandAlone) {
        this.props.actions.updateUserData({ userType: userType, position: position });
      } else {
        this.props.actions.initSetFormType('register');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props$refdata = this.props.refdata,
          positions = _props$refdata.positions,
          careers = _props$refdata.careers;

      var currentPosition = this.props.common.position;
      var currentCareerObj = this.state.currentCareerObj;

      var positionOptions = (0, _positionFilter.filterPosition)(positions, currentCareerObj).map(function (pos) {
        return {
          label: pos.name,
          value: pos.name
        };
      });

      var careerOptions = careers.map(function (pos) {
        return {
          label: pos.name,
          value: pos.name
        };
      });

      return _react2.default.createElement(
        'div',
        { id: 'select-position' },
        this.props.common.branding ? _react2.default.createElement(
          'div',
          { className: 'padding-left-md padding-right-md' },
          _react2.default.createElement(_Branding2.default, (0, _extends3.default)({}, this.props.common.branding, { cdnUrl: this.props.common.cdnUrl, margin: false }))
        ) : _react2.default.createElement(
          'div',
          { className: 'tes-modal__body_top' },
          _react2.default.createElement(
            'div',
            { className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
            _react2.default.createElement(
              'div',
              { className: 'heading-main text-center' },
              _react2.default.createElement(
                'h3',
                { className: 'tes-modal__heading margin-bottom-sm' },
                'Join Tes for free'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'tes-modal__body_middle' },
          _react2.default.createElement(
            'div',
            { className: 'padding-md' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h4',
                { className: 'tes-modal__heading text--white text-white margin-bottom-sm' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'I am a ...'
                )
              )
            ),
            _react2.default.createElement(
              'form',
              { autoComplete: 'off', className: 't-student-form app-authentication-select-form',
                action: this.props.action, method: this.props.method,
                onSubmit: this.props.onSubmit
              },
              _react2.default.createElement(_HiddenInputs2.default, { isGetRequest: this.props.method.toLowerCase() === 'get', noPosition: true }),
              _react2.default.createElement(
                'div',
                { className: 'padding-bottom-md' },
                _react2.default.createElement(_ButtonSelect2.default, {
                  id: 'career-selector',
                  onChange: function onChange(v) {
                    return _this4.onChangeCareer(v);
                  },
                  value: currentCareerObj.name,
                  options: careerOptions,
                  emptyOptionLabel: 'Choose your role'
                })
              ),
              currentCareerObj.groupLabel ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'padding-bottom-md' },
                  _react2.default.createElement(_CustomSelect2.default, {
                    id: 'position-selector',
                    className: 'tes-control tes-select',
                    name: 'position',
                    onChange: function onChange(v) {
                      return _this4.onChangePosition(v);
                    },
                    value: currentPosition,
                    options: positionOptions,
                    emptyOptionLabel: 'Choose a position'
                  })
                )
              ) : _react2.default.createElement('input', { type: 'hidden', name: 'position', value: currentPosition }),
              _react2.default.createElement(
                'button',
                { ref: 'submit', onClick: function onClick(e) {
                    return _this4.onSubmit(e);
                  }, type: 'submit', className: 'tes-btn tes-btn--lg tes-btn--icon tes-btn--block tes-btn--primary hidden' },
                'Ok'
              )
            )
          )
        ),
        !this.props.isStandAlone ? _react2.default.createElement(
          'div',
          { className: 'tes-modal__body_bottom' },
          _react2.default.createElement(
            'div',
            { className: 'more-info text-center text--sm padding-top-md border-top' },
            _react2.default.createElement(
              'span',
              null,
              'Already have a Tes account?'
            ),
            _react2.default.createElement(
              'span',
              null,
              ' '
            ),
            _react2.default.createElement(
              _WidgetLink2.default,
              { formType: 'signIn' },
              'Log in now!'
            )
          )
        ) : null
      );
    }
  }]);
  return SelectFormPosition;
}(_react.Component);

SelectFormPosition.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  refdata: _react.PropTypes.object.isRequired,
  isStandAlone: _react.PropTypes.bool,
  action: _react.PropTypes.string.isRequired,
  method: _react.PropTypes.string.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    refdata: state.refdata
  };
}, mapDispatchToProps)(SelectFormPosition);

});
},{"15":15,"168":168,"169":169,"170":170,"171":171,"173":173,"178":178,"181":181,"21":21,"22":22,"24":24,"25":25,"26":26,"8":8}],166:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SelectPosition;

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _SelectFormPosition = require(165);

var _SelectFormPosition2 = _interopRequireDefault(_SelectFormPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SelectPosition() {
  return _react2.default.createElement(_SelectFormPosition2.default, {
    action: '/authn/register',
    method: 'get'
  });
}

});
},{"165":165,"8":8}],167:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Signin = undefined;

var _extends2 = require(24);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require(16);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(26);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(25);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _getErrorFromPrefix = require(177);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require(181);

var actionCreators = _interopRequireWildcard(_actions);

var _WidgetLink = require(173);

var _WidgetLink2 = _interopRequireDefault(_WidgetLink);

var _HiddenInputs = require(171);

var _HiddenInputs2 = _interopRequireDefault(_HiddenInputs);

var _InputField = require(172);

var _InputField2 = _interopRequireDefault(_InputField);

var _Branding = require(168);

var _Branding2 = _interopRequireDefault(_Branding);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('signin');
var getErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('signin');
var getGenericErrorMsg = (0, _getErrorFromPrefix.getErrorMsgFromPrefix)('generic');
var getGenericErrorCls = (0, _getErrorFromPrefix.getErrorClsFromPrefix)('generic');

var Signin = exports.Signin = function (_Component) {
  (0, _inherits3.default)(Signin, _Component);

  function Signin() {
    (0, _classCallCheck3.default)(this, Signin);
    return (0, _possibleConstructorReturn3.default)(this, (Signin.__proto__ || (0, _getPrototypeOf2.default)(Signin)).apply(this, arguments));
  }

  (0, _createClass3.default)(Signin, [{
    key: 'getGoogleLogoURL',
    value: function getGoogleLogoURL() {
      return this.props.common.cdnUrl + 'img/google-logo-g.png';
    }
  }, {
    key: 'getFacebookLogoURL',
    value: function getFacebookLogoURL() {
      return this.props.common.cdnUrl + 'img/facebook-logo.png';
    }
  }, {
    key: 'handleGoogle',
    value: function handleGoogle() {
      this.props.actions.initOauthSignIn('google');
    }
  }, {
    key: 'handleFacebook',
    value: function handleFacebook() {
      this.props.actions.initOauthSignIn('facebook');
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      var target = e.target;

      this.props.actions.initSignIn(function () {
        target.submit();
      });
    }
  }, {
    key: 'hasError',
    value: function hasError() {
      return this.props.errors ? (0, _keys2.default)(this.props.errors).filter(function (n) {
        return n.startsWith('signin.');
      }).length > 0 : false;
    }
  }, {
    key: 'changeField',
    value: function changeField(namepar, depspar) {
      var _this2 = this;

      var name = 'signin.' + namepar;
      var deps = depspar.map(function (n) {
        return 'signin.' + n;
      }) || [];
      return function (e) {
        var target = e.target;
        _this2.props.actions.setField('signIn', target.name, target.type === 'checkbox' || target.type === 'radio' ? target.checked : target.value);
        _this2.props.actions.changeField(name, deps);
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var err = this.props.errors;

      return _react2.default.createElement(
        'div',
        { id: 'sign-in', className: 'padding-left-md padding-right-md padding-bottom-xs margin-bottom-xs' },
        this.props.common.branding ? _react2.default.createElement(_Branding2.default, (0, _extends3.default)({}, this.props.common.branding, { cdnUrl: this.props.common.cdnUrl })) : _react2.default.createElement(
          'div',
          { className: 'heading-main margin-bottom-md text-center' },
          _react2.default.createElement(
            'h3',
            { className: 'tes-modal__heading margin-bottom-sm' },
            'Please log in'
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(
                'button',
                {
                  disabled: this.props.signIn.state === 'wait' || this.props.common.oauthState ? 'disabled' : null,
                  onClick: function onClick(e) {
                    return _this3.handleGoogle(e);
                  },
                  className: 'tes-btn tes-btn--secondary tes-btn--icon tes-btn--block tes-btn--social'
                },
                this.props.common.oauthState === 'google' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner tes-btn__icon' }) : _react2.default.createElement(
                  'span',
                  { className: 'text--sm' },
                  _react2.default.createElement('img', { style: { padding: '0 6px 2px 0', verticalAlign: 'middle' }, src: this.getGoogleLogoURL() }),
                  ' Log in with Google'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row margin-top-sm' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12' },
              _react2.default.createElement(
                'button',
                {
                  disabled: this.props.signIn.state === 'wait' || this.props.common.oauthState ? 'disabled' : null,
                  onClick: function onClick(e) {
                    return _this3.handleFacebook(e);
                  },
                  className: 'tes-btn tes-btn--secondary tes-btn--icon tes-btn--block tes-btn--social'
                },
                this.props.common.oauthState === 'facebook' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner tes-btn__icon' }) : _react2.default.createElement(
                  'span',
                  { className: 'text--sm' },
                  _react2.default.createElement('img', { style: { padding: '0 6px 2px 0', verticalAlign: 'middle' }, src: this.getFacebookLogoURL() }),
                  ' Log in with Facebook'
                )
              )
            )
          ),
          _react2.default.createElement(
            'form',
            { autoComplete: 'off', onSubmit: function onSubmit(e) {
                return _this3.handleSubmit(e);
              }, role: 'form', className: 't-sign-in-form margin-bottom-sm', method: 'post', action: '/api/authn/sign-in-redirect' },
            _react2.default.createElement(_HiddenInputs2.default, null),
            _react2.default.createElement(
              'div',
              { className: 'separator' },
              _react2.default.createElement(
                'span',
                { className: 'separator--text bg-white' },
                'or'
              )
            ),
            _react2.default.createElement(_InputField2.default, {
              name: 'identification',
              label: 'Username or email',
              icon: 'user',
              value: this.props.signIn.identification,
              errorClass: getErrorCls('userName')(err),
              errorMessage: getErrorMsg('userName')(err),
              onChange: this.changeField('userName', ['password']),
              autoFocus: 'true',
              autoComplete: 'off'
            }),
            _react2.default.createElement(_InputField2.default, {
              name: 'password',
              label: 'Password',
              icon: 'lock',
              value: this.props.signIn.password,
              errorClass: getErrorCls('password')(err),
              errorMessage: getErrorMsg('password')(err),
              onChange: this.changeField('password', ['userName']),
              type: 'password',
              autoComplete: 'off'
            }),
            _react2.default.createElement(
              'div',
              { className: 'text--sm margin-bottom-md margin-top-md' },
              _react2.default.createElement(
                'div',
                { className: 'tes-checkbox tes-checkbox--inline' },
                _react2.default.createElement(
                  'label',
                  { className: 'tes-control-label', title: 'This shouldn\'t be used on a shared computer' },
                  _react2.default.createElement('input', { type: 'checkbox',
                    name: 'trustedComputer',
                    value: 'true',
                    checked: this.props.signIn.trustedComputer,
                    onChange: this.changeField('trustedComputer', [])
                  }),
                  _react2.default.createElement(
                    'span',
                    { className: 'text--sm' },
                    'Stay logged in'
                  )
                )
              ),
              _react2.default.createElement(
                _WidgetLink2.default,
                { formType: 'forgotPassword' },
                'Forgot password?'
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'button',
                {
                  disabled: this.props.signIn.state === 'wait' || this.props.common.googleState === 'wait' ? 'disabled' : null,
                  type: 'submit', className: 'tes-btn tes-btn--lg sign-in-submit tes-btn--icon tes-btn--block tes-btn--primary'
                },
                this.props.signInstate === 'wait' ? _react2.default.createElement('i', { className: 'icon-spin icon-spinner icon-white tes-btn__icon' }) : 'Log in'
              )
            )
          ),
          getGenericErrorCls('googlebutton')(err) ? _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 tes-has-error' },
              _react2.default.createElement(
                'div',
                { className: 'tes-help-block' },
                getGenericErrorMsg('googlebutton')(err)
              )
            )
          ) : null
        ),
        _react2.default.createElement(
          'div',
          { className: 'clearfix' },
          _react2.default.createElement(
            'div',
            { className: 'more-info text-center text--sm padding-top-sm' },
            _react2.default.createElement(
              'span',
              null,
              'Not a member yet?'
            ),
            _react2.default.createElement(
              'span',
              null,
              ' '
            ),
            _react2.default.createElement(
              _WidgetLink2.default,
              { formType: 'register' },
              'Join us for free'
            )
          )
        )
      );
    }
  }]);
  return Signin;
}(_react.Component);

Signin.propTypes = {
  common: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object.isRequired,
  signIn: _react.PropTypes.object.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common,
    errors: state.errors,
    signIn: state.signIn
  };
}, mapDispatchToProps)(Signin);

});
},{"15":15,"16":16,"168":168,"171":171,"172":172,"173":173,"177":177,"181":181,"21":21,"22":22,"24":24,"25":25,"26":26,"8":8}],168:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __react;

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Branding(_ref) {
  var logo = _ref.logo,
      name = _ref.name,
      text = _ref.text,
      cdnUrl = _ref.cdnUrl,
      _ref$margin = _ref.margin,
      margin = _ref$margin === undefined ? true : _ref$margin;

  var classes = ['text-center', margin ? 'margin-bottom-lg' : '', 'auth-brand-' + name, 'heading--sm', 'heading--bold', 'text--white', 'padding-sm'];

  return _react2.default.createElement(
    'div',
    { className: classes.join(' ') },
    _react2.default.createElement('img', { src: cdnUrl + 'img/' + logo, height: '39' }),
    _react2.default.createElement(
      'p',
      null,
      text
    )
  );
}

Branding.propTypes = {
  logo: _react.PropTypes.string.isRequired,
  name: _react.PropTypes.string.isRequired,
  text: _react.PropTypes.string.isRequired,
  cdnUrl: _react.PropTypes.string.isRequired,
  margin: _react.PropTypes.bool
};

exports.default = Branding;

});
},{"8":8}],169:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(26);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(25);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonSelect = function (_Component) {
  (0, _inherits3.default)(ButtonSelect, _Component);

  function ButtonSelect(props) {
    (0, _classCallCheck3.default)(this, ButtonSelect);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ButtonSelect.__proto__ || (0, _getPrototypeOf2.default)(ButtonSelect)).call(this, props));

    _this.state = { value: props.value || '' };
    return _this;
  }

  (0, _createClass3.default)(ButtonSelect, [{
    key: 'onClick',
    value: function onClick(e, value) {
      e.preventDefault();
      var newValue = value;
      if (newValue !== this.state.value) {
        this.setState({ value: newValue });
        this.props.onChange(newValue);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var options = this.props.options;

      return _react2.default.createElement(
        'div',
        {
          id: this.props.id,
          className: this.props.className
        },
        this.props.name ? _react2.default.createElement('input', { type: 'hidden', value: this.state.value, name: this.props.name }) : null,
        options.map(function (p, index) {
          return p.value === _this2.state.value ? _react2.default.createElement(
            'div',
            { key: 'select-button-' + index, className: 'margin-top-sm margin-bottom-sm' },
            _react2.default.createElement(
              'button',
              { className: 'tes-btn tes-btn--secondary-gray-text tes-btn--block', disabled: true },
              p.label
            )
          ) : _react2.default.createElement(
            'div',
            { key: 'select-button-' + index, className: 'margin-top-sm margin-bottom-sm' },
            _react2.default.createElement(
              'button',
              { className: 'tes-btn tes-btn--primary tes-btn--block', onClick: function onClick(e) {
                  return _this2.onClick(e, p.value);
                } },
              p.label
            )
          );
        })
      );
    }
  }]);
  return ButtonSelect;
}(_react.Component);

exports.default = ButtonSelect;


ButtonSelect.propTypes = {
  id: _react.PropTypes.string,
  className: _react.PropTypes.string,
  options: _react.PropTypes.array.isRequired,
  onChange: _react.PropTypes.func,
  value: _react.PropTypes.string,
  name: _react.PropTypes.string
};

});
},{"15":15,"21":21,"22":22,"25":25,"26":26,"8":8}],170:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require(15);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require(26);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require(25);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomSelect = function (_Component) {
  (0, _inherits3.default)(CustomSelect, _Component);

  function CustomSelect(props) {
    (0, _classCallCheck3.default)(this, CustomSelect);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CustomSelect.__proto__ || (0, _getPrototypeOf2.default)(CustomSelect)).call(this, props));

    _this.state = { value: props.value || '' };
    return _this;
  }

  (0, _createClass3.default)(CustomSelect, [{
    key: 'onChange',
    value: function onChange(e) {
      var newValue = e.target.value;
      if (newValue !== this.state.value) {
        this.setState({ value: newValue });
        this.props.onChange(newValue);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var options = [];
      if (this.props.emptyOptionLabel) {
        options.push({
          label: this.props.emptyOptionLabel,
          value: ''
        });
      }
      options = options.concat(this.props.options);

      return _react2.default.createElement(
        'select',
        {
          autoComplete: 'off',
          id: this.props.id,
          className: this.props.className,
          onChange: function onChange(e) {
            return _this2.onChange(e);
          },
          value: this.state.value,
          name: this.props.name
        },
        options.map(function (p, index) {
          return _react2.default.createElement(
            'option',
            { key: 'select-' + index, value: p.value },
            p.label
          );
        })
      );
    }
  }]);
  return CustomSelect;
}(_react.Component);

exports.default = CustomSelect;


CustomSelect.propTypes = {
  id: _react.PropTypes.string,
  className: _react.PropTypes.string,
  options: _react.PropTypes.array.isRequired,
  emptyOptionLabel: _react.PropTypes.string,
  onChange: _react.PropTypes.func,
  value: _react.PropTypes.string,
  name: _react.PropTypes.string
};

});
},{"15":15,"21":21,"22":22,"25":25,"26":26,"8":8}],171:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HiddenInputs = HiddenInputs;

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __react_redux;

var _tracking = require(179);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HiddenInputs(_ref) {
  var common = _ref.common,
      isGetRequest = _ref.isGetRequest,
      noUserType = _ref.noUserType,
      noPosition = _ref.noPosition;

  var pageContext = (0, _tracking.getPageContext)(common.pageMz, common.overrideMz);

  var pageContextInputs = ['pageId', 'pageType', 'pageSection', 'pageSubSection'].filter(function (name) {
    return pageContext && pageContext[name];
  }).map(function (name) {
    return _react2.default.createElement('input', { type: 'hidden', key: name, name: name, value: pageContext[name] });
  });

  return _react2.default.createElement(
    'span',
    null,
    pageContextInputs,
    common.rtn ? _react2.default.createElement('input', { type: 'hidden', name: 'rtn', value: common.rtn }) : null,
    !noUserType ? _react2.default.createElement('input', { className: 't-user-type', type: 'hidden', name: 'userType', value: common.userType || 'other' }) : null,
    !noPosition && common.position ? _react2.default.createElement('input', { className: 't-position', type: 'hidden', name: 'position', value: common.position }) : null,
    common.regUrl ? _react2.default.createElement('input', { className: 't-reg-url', type: 'hidden', name: 'regUrl', value: common.regUrl }) : null,
    _react2.default.createElement('input', { type: 'hidden', name: 'appId', value: common.appId }),
    !isGetRequest ? _react2.default.createElement('input', { type: 'hidden', name: '_CSRF_TOKEN', value: common.csrfToken }) : null,
    common.doSelectUserType ? _react2.default.createElement('input', { className: 't-select', type: 'hidden', name: 'select', value: 'true' }) : null,
    common.hasOwnProperty('omitName') ? _react2.default.createElement('input', { type: 'hidden', name: 'omitName', value: common.omitName }) : null
  );
}

HiddenInputs.propTypes = {
  common: _react.PropTypes.object.isRequired,
  isGetRequest: _react.PropTypes.bool,
  noUserType: _react.PropTypes.bool,
  noPosition: _react.PropTypes.bool
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common
  };
})(HiddenInputs);

});
},{"179":179,"8":8}],172:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __react;

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function InputGroup(_ref) {
  var icon = _ref.icon,
      children = _ref.children;

  if (!icon) return _react2.default.createElement(
    "div",
    null,
    children
  );
  return _react2.default.createElement(
    "div",
    { className: "tes-input-group" },
    _react2.default.createElement(
      "span",
      { className: "tes-input-group__addon" },
      _react2.default.createElement("i", { className: "icon icon-" + icon })
    ),
    children
  );
}

InputGroup.propTypes = {
  icon: _react.PropTypes.string
};

function InputField(_ref2) {
  var errorClass = _ref2.errorClass,
      errorMessage = _ref2.errorMessage,
      label = _ref2.label,
      value = _ref2.value,
      name = _ref2.name,
      onChange = _ref2.onChange,
      type = _ref2.type,
      icon = _ref2.icon,
      autoFocus = _ref2.autoFocus,
      autoComplete = _ref2.autoComplete;

  var id = "auth-" + name;
  var widgetType = type || 'text';
  return _react2.default.createElement(
    "div",
    { className: errorClass },
    _react2.default.createElement(
      InputGroup,
      { icon: icon },
      _react2.default.createElement(
        "label",
        { className: "tes-control-label tes-control-label--hidden", htmlFor: id },
        label
      ),
      _react2.default.createElement("input", { onChange: onChange, id: id, type: widgetType,
        name: name,
        placeholder: label,
        className: "tes-control tes-input-group__control-last",
        value: value,
        autoFocus: autoFocus,
        autoComplete: autoComplete
      })
    ),
    _react2.default.createElement(
      "div",
      { className: "tes-help-block" },
      errorMessage
    )
  );
}

InputField.propTypes = {
  errorClass: _react.PropTypes.string.isRequired,
  errorMessage: _react.PropTypes.string.isRequired,
  label: _react.PropTypes.string.isRequired,
  icon: _react.PropTypes.string,
  value: _react.PropTypes.string.isRequired,
  name: _react.PropTypes.string.isRequired,
  type: _react.PropTypes.string,
  onChange: _react.PropTypes.func.isRequired,
  autoFocus: _react.PropTypes.string,
  autoComplete: _react.PropTypes.string
};

exports.default = InputField;

});
},{"8":8}],173:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetLink = WidgetLink;

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __react_redux;

var _redux = __redux;

var _actions = require(181);

var actionCreators = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function WidgetLink(_ref) {
  var common = _ref.common,
      formType = _ref.formType,
      children = _ref.children,
      actions = _ref.actions;

  var registerPages = {
    signIn: 'sign-in',
    forgotPassword: 'forgot-password',
    register: common.doSelectUserType ? 'select' : 'register'
  };

  var registerPage = registerPages[formType];

  var switchTo = function switchTo(e) {
    if (!common.isModal && !common.isInline) return;
    e.preventDefault();
    actions.initSetFormType(registerPage);
  };

  var encodedRtn = encodeURIComponent(common.rtn);
  var encodedRegUrl = encodeURIComponent(common.regUrl);

  var qs = [];
  if (common.rtn) {
    qs.push('rtn=' + encodedRtn);
  }
  if (common.doSelectUserType) {
    qs.push('select=true');
  }
  if ('id' in common.overrideMz) {
    qs.push('pageId=' + common.overrideMz.id);
  }
  if ('type' in common.overrideMz) {
    qs.push('pageType=' + common.overrideMz.type);
  }
  if ('section' in common.overrideMz) {
    qs.push('pageSection=' + common.overrideMz.section);
  }
  if ('subsection' in common.overrideMz) {
    qs.push('pageSubSection=' + common.overrideMz.subsection);
  }
  if (common.regUrl) {
    qs.push('regUrl=' + encodedRegUrl);
  }
  if (common.hasOwnProperty('omitName')) {
    qs.push('omitName=' + common.omitName);
  }
  if (common.appId) {
    qs.push('appId=' + common.appId);
  }

  var baseURLs = {
    signIn: '/authn/sign-in',
    forgotPassword: '/authn/forgot-password',
    register: '/authn/' + registerPage
  };

  var baseURL = baseURLs[formType];
  var url = qs.length ? baseURL + '?' + qs.join('&') : baseURL;
  var extraClass = formType === 'forgotPassword' ? ' pull-right' : '';
  return _react2.default.createElement(
    'a',
    { onClick: switchTo, href: url, className: 't-switch-form link link--colored' + extraClass },
    children
  );
}

WidgetLink.propTypes = {
  common: _react.PropTypes.object.isRequired,
  actions: _react.PropTypes.object.isRequired,
  formType: _react.PropTypes.string.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actionCreators, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    common: state.common
  };
}, mapDispatchToProps)(WidgetLink);

});
},{"181":181,"8":8}],174:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require(28);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require(16);

var _keys2 = _interopRequireDefault(_keys);

var _promise = require(18);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require(11);

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require(12);

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = require(27);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _reqwest = require(157);

var _reqwest2 = _interopRequireDefault(_reqwest);

var _retry = require(2);

var _retry2 = _interopRequireDefault(_retry);

var _memoize = require(1);

var _memoize2 = _interopRequireDefault(_memoize);

var _es6PromisePolyfill = require(132);

var _es6PromisePolyfill2 = _interopRequireDefault(_es6PromisePolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-console */
try {
  window.Promise = _es6PromisePolyfill2.default.Promise;
} catch (e) {
  // nothing
}

var getOrigin = function getOrigin() {
  if (window.location.origin) {
    return window.location.origin;
  }
  var port = window.location.port ? ':' + window.location.port : '';
  var protocol = window.location.protocol;
  var hostname = window.location.hostname;
  return protocol + '//' + hostname + port;
};

var XHRTIMEOUT_WITH_RETRY = 9000;
var XHRTIMEOUT_WITHOUT_RETRY = 20000;

var defaultParams = {
  type: 'json',
  contentType: 'application/json',
  headers: {
    accept: 'application/json',
    'x-auth-api-version': '2'
  }
};

function postRequest(endpoint, data, times) {
  var requestFunction = void 0;
  var timeout = void 0;
  if (times) {
    var t0 = new Date();
    var retry = (0, _retry2.default)(times, 100, function (err) {
      return err && err.status === 0;
    }, function () {
      return function (t, o) {
        var t1 = new Date();
        console.log('app-authentication: api trying ' + o.times + ' after ' + (t1 - t0) + ' ms');
      };
    });
    requestFunction = retry(_reqwest2.default);
    timeout = XHRTIMEOUT_WITH_RETRY;
  } else {
    requestFunction = _reqwest2.default;
    timeout = XHRTIMEOUT_WITHOUT_RETRY;
  }

  var _ref = document.cookie.match(/csrf=([^;]*)/) || [],
      _ref2 = (0, _slicedToArray3.default)(_ref, 2),
      match = _ref2[0],
      csrfToken = _ref2[1];

  return requestFunction((0, _assign2.default)({}, defaultParams, {
    url: endpoint,
    method: 'POST',
    timeout: timeout,
    data: (0, _stringify2.default)(data),
    headers: (0, _assign2.default)({}, defaultParams.headers, match && csrfToken ? {
      'x-csrf-token': match && csrfToken
    } : {})
  }));
}

var memoize = (0, _memoize2.default)(function (d) {
  try {
    return d.data.email ? d.data.email : null;
  } catch (e) {
    return null;
  }
});
var cachedReqwest = memoize(_reqwest2.default);

function getRequest(endpoint, data) {
  var timeout = XHRTIMEOUT_WITHOUT_RETRY;

  return cachedReqwest((0, _assign2.default)({}, defaultParams, {
    url: endpoint,
    method: 'GET',
    timeout: timeout,
    data: data
  }));
}

var events = function getEvents() {
  try {
    return window.TES.events;
  } catch (e) {
    return {
      on: function on() {},
      trigger: function trigger() {}
    };
  }
}();

var api = {
  verifyUsername: function verifyUsername(username) {
    return getRequest('/api/authn/find-user', { username: username });
  },
  verifyEmail: function verifyEmail(email) {
    return getRequest('/api/authn/find-user', { email: email });
  },
  signIn: function signIn(data) {
    return postRequest('/api/authn/sign-in-redirect', data, 4);
  },
  register: function register(data) {
    return postRequest('/api/authn/register-redirect', data);
  },
  oauthSignIn: function oauthSignIn(provider, data) {
    return new _promise2.default(function (resolve, reject) {
      var params = (0, _keys2.default)(data).filter(function (k) {
        return !!data[k];
      }).map(function (k) {
        return [k, encodeURIComponent(data[k])];
      }).map(function (t) {
        return t[0] + '=' + t[1];
      }).join('&');

      var path = '/oauth/' + provider + '?' + params;

      if (!data.isModal) {
        return window.location.assign(path);
      }

      var done = false;

      var googlePopup = window.open(path, '', 'location=0,status=0,width=600,height=500');

      function onMessage(evt) {
        var msg = void 0;
        if (evt.origin !== getOrigin()) return;
        try {
          msg = (0, _typeof3.default)(evt.data) === 'object' ? evt.data : JSON.parse(evt.data);
        } catch (e) {
          // ie9 returns evt.data === undefined, but I won't care!!!!
          // this is also the case of non JSON messages
          return;
        }
        if (msg.sender !== 'googlepopup') {
          return;
        }
        if (msg.status === 'ok' || msg.status === 'error') {
          done = true;
          window.removeEventListener('message', onMessage);
          googlePopup.close();
        }
        if (msg.status === 'ok') {
          /* Comes from close-modal page */
          if (msg.needsPosition) {
            var err = new Error('Needs position data');
            err.needsPosition = true;
            return reject(err);
          }
          resolve();
        }
        if (msg.status === 'error') {
          reject(new Error(msg.errorCode));
        }
      }

      window.addEventListener('message', onMessage);

      var _oauthInterval = window.setInterval(function () {
        var fireError = function fireError(errorCode) {
          if (!done) {
            reject(new Error(errorCode));
          }
          window.removeEventListener('message', onMessage);
          window.clearInterval(_oauthInterval);
        };
        try {
          if (!googlePopup) {
            fireError(provider + '.popup.blocked');
          } else if (googlePopup.closed) {
            fireError(provider + '.popup.closed');
          }
        } catch (e) {
          // ie fires error here
        }
      }, 1000);
    });
  },
  forgotPassword: function forgotPassword(data) {
    return postRequest('/api/authn/forgot-password', data);
  },
  updateUserData: function updateUserData(data) {
    return postRequest('/api/authn/edit-account', data);
  },
  reload: function reload(url) {
    if (url) {
      window.location.assign(url);
    } else {
      window.location.reload(true);
    }
  },
  loggedInEvent: function loggedInEvent() {
    events.trigger('logged-in');
  },
  closeModalEvent: function closeModalEvent() {
    events.trigger('modal-close', 'authapp');
  }
};

exports.default = api;

});
},{"1":1,"11":11,"12":12,"132":132,"157":157,"16":16,"18":18,"2":2,"27":27,"28":28,"8":8}],175:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require(27);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.isInvalidDateOfBirth = isInvalidDateOfBirth;
exports.dateDiff = dateDiff;
exports.isUnder18 = isUnder18;
exports.isUnder13 = isUnder13;
exports.locale = locale;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function deltayears(delta, today) {
  var d = today ? new Date(today) : new Date();
  d.setFullYear(d.getFullYear() + delta);
  return d;
}

function isInvalidDateOfBirth(d, today) {
  if (!d) return true;

  var _d$split$map = d.split('-').map(function (s) {
    return parseInt(s, 10);
  }),
      _d$split$map2 = (0, _slicedToArray3.default)(_d$split$map, 3),
      year = _d$split$map2[0],
      month = _d$split$map2[1],
      day = _d$split$map2[2];

  var date = new Date(year, month - 1, day);
  var twoyearsago = deltayears(-2, today);
  var onehundredandtwentyyearsago = deltayears(-120, today);
  var now = deltayears(0, today);

  if (year < 1000 || isNaN(date.getMonth())) {
    return 'registration.dateOfBirth.incomplete';
  } else if (!(date.getMonth() === month - 1 && date.getDate() === day && date.getFullYear() === year)) {
    return 'registration.dateOfBirth.invalid';
  } else if (now < date) {
    return 'registration.dateOfBirth.future';
  } else if (twoyearsago < date) {
    return 'registration.dateOfBirth.tooYoung';
  } else if (onehundredandtwentyyearsago > date) {
    return 'registration.dateOfBirth.tooOld';
  }
}

function dateDiff(date, today) {
  var _date$split$map = date.split('-').map(function (item) {
    return parseInt(item, 10);
  }),
      _date$split$map2 = (0, _slicedToArray3.default)(_date$split$map, 3),
      year = _date$split$map2[0],
      month = _date$split$map2[1],
      day = _date$split$map2[2];

  var d = today ? new Date(today) : new Date();
  var deltaYear = d.getFullYear() - year;
  var deltaMonth = d.getMonth() + 1 - month;
  var deltaDay = d.getDate() - day;
  if (deltaDay < 0) {
    deltaMonth -= 1;
    deltaDay += 30;
  }
  if (deltaMonth < 0) {
    deltaYear -= 1;
    deltaMonth += 12;
  }
  return { deltaYear: deltaYear, deltaMonth: deltaMonth, deltaDay: deltaDay };
}

function isUnder18(dob) {
  return !isInvalidDateOfBirth(dob) && dateDiff(dob).deltaYear < 18;
}

function isUnder13(dob) {
  return !isInvalidDateOfBirth(dob) && dateDiff(dob).deltaYear < 13;
}

function locale(siteCountry) {
  switch (siteCountry) {
    case 'CA':
    case 'US':
      return ['month', 'day', 'year'];
    default:
      return ['day', 'month', 'year'];
  }
}

});
},{"27":27,"8":8}],176:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authDenied = authDenied;
exports.forgotPasswordDenied = forgotPasswordDenied;
var bannedStates = {
  2: 'banned',
  3: 'disapproved',
  4: 'possible spam activity',
  5: 'locked out'
};

var guardianEmailDenyStates = {
  CREATED: 'notYetGranted',
  DENIED: 'denied'
};

function getResponse(err) {
  if ('response' in err || 'responseText' in err) {
    try {
      return JSON.parse(err.response || err.responseText);
    } catch (e) {
      return undefined;
    }
  } else {
    return err;
  }
}

function authDenied(err) {
  if (err.status === 401) {
    return 'signin.unauthorized';
  }
  if (err.status === 403) {
    var response = getResponse(err);
    if (response && 'data' in response && response.data.code) {
      if (response.data.code in bannedStates) {
        return 'signin.' + bannedStates[response.data.code];
      } else if (response.data.code in guardianEmailDenyStates) {
        return 'signin.guardianEmail.' + guardianEmailDenyStates[response.data.code];
      }
    }
    return 'signin.generic.banned';
  }
}

function forgotPasswordDenied(err) {
  if (err.status === 404) {
    return 'forgot-password.user.not-found';
  }
  if (err.status === 403) {
    var response = getResponse(err);
    if (response && 'data' in response && response.data.code && response.data.code in bannedStates) {
      return 'forgot-password.' + bannedStates[response.data.code];
    }
    return 'forgot-password.generic.banned';
  }
}

});
},{"8":8}],177:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getErrorMsgFromPrefix = getErrorMsgFromPrefix;
exports.getErrorClsFromPrefix = getErrorClsFromPrefix;
function getErrorMsgFromPrefix(prefix) {
  return function (_field) {
    var field = prefix + '.' + _field;
    return function (err) {
      return err && field in err ? err[field].msg : '';
    };
  };
}

function getErrorClsFromPrefix(prefix) {
  return function (_field) {
    var field = prefix + '.' + _field;
    return function (err) {
      return err && field in err && err[field].state === 'error' ? ' tes-has-error' : '';
    };
  };
}

});
},{"8":8}],178:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.careerFinder = careerFinder;
exports.filterPosition = filterPosition;
exports.getUserTypePosition = getUserTypePosition;
function careerFinder(positions, careers, currentPosition) {
  var careerMatch = careers.filter(function (item) {
    return item.name === currentPosition;
  });
  if (careerMatch.length) {
    return { name: careerMatch[0].name, groupLabel: null };
  }
  var positionMatch = positions.filter(function (item) {
    return item.name === currentPosition;
  });
  if (positionMatch.length) {
    var groupLabel = positionMatch[0].groupLabel;
    var groupMatch = careers.filter(function (item) {
      return item.groupLabel === groupLabel;
    });
    if (groupMatch.length) {
      return { name: groupMatch[0].name, groupLabel: groupLabel };
    }
  }
  return { name: '', groupLabel: null };
}

function filterPosition(positions, currentCareerObj) {
  return positions.filter(function (pos) {
    if (currentCareerObj.groupLabel) {
      return pos.groupLabel === currentCareerObj.groupLabel;
    }
    return pos.name === currentCareerObj.name;
  });
}

function getUserTypePosition(positions, currentPosition) {
  // const posObj = positions.find((pos) => pos.name === currentPosition);
  var posIndex = positions.map(function (pos) {
    return pos.name === currentPosition;
  }).indexOf(true);
  var posObj = positions[posIndex];
  return posObj ? posObj.userType : 'other';
}

});
},{"8":8}],179:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackClick = trackClick;
exports.trackDisplay = trackDisplay;
exports.trackError = trackError;
exports.trackForgotPassword = trackForgotPassword;
exports.trackLogin = trackLogin;
exports.trackRegister = trackRegister;
exports.getTrackingType = getTrackingType;
exports.getPageContext = getPageContext;
/* global _mz:false, _mze:false */

function hasMz() {
  try {
    return !!_mz;
  } catch (e) {
    return false;
  }
}

function trackClick(formType) {
  if (!hasMz()) return;
  var eventTitle = void 0;
  if (formType === 'sign-in') {
    eventTitle = 'login';
  } else if (formType === 'register' || formType === 'select') {
    eventTitle = 'register';
  }
  if (eventTitle) {
    _mz.emit(_mze.CLICK, {
      module: {
        type: 'auth-links'
      },
      eventTitle: eventTitle
    });
  }
}

function trackDisplay(formType, type, userType, doSelectUserType) {
  if (!hasMz()) return;
  var eventTitle = {
    'sign-in': 'tes-login',
    register: 'register',
    'forgot-password': 'forgot-password',
    select: 'tes-account-type'
  };
  var event = {
    id: eventTitle[formType] || 'tes-login',
    module: {
      id: doSelectUserType ? 'useSelect' : null,
      type: type
    }
  };

  if (formType === 'select') {
    event.variant = 'position-selector';
  } else if (userType) {
    event.variant = userType;
  }

  _mz.emit(_mze.DISPLAY, event);
}

function trackError(id, msg, type) {
  if (!hasMz()) return;
  var evt = id === 'register-fail' ? _mze.REGISTER_FAIL : _mze.LOGIN_FAIL;
  _mz.emit(evt, {
    id: id,
    payload: {
      message: msg
    },
    module: {
      type: type
    }
  });
}

function trackForgotPassword(type, cb) {
  if (!hasMz()) return cb && cb();
  _mz.emit(_mze.SUBMIT, {
    id: 'forgot-password',
    module: {
      type: type
    }
  }, cb);
}

function trackLogin(id, type, cb) {
  if (!hasMz()) return cb && cb();
  _mz.emit(_mze.LOGIN, {
    id: id,
    module: {
      type: type
    }
  }, cb);
}

function trackRegister(type, cb) {
  if (!hasMz()) return cb && cb();
  _mz.emit(_mze.REGISTER, {
    id: 'register',
    module: {
      type: type
    },
    tags: ['funnel']
  }, cb);
}

function getTrackingType(isModal, isInline) {
  if (isModal) {
    return 'modal';
  } else if (isInline) {
    return 'embed';
  }
  return 'standalone';
}

function getPageContext(pageMetadata, overridePageMetadata) {
  var meta = {};

  if ('id' in overridePageMetadata || 'id' in pageMetadata) {
    meta.pageId = overridePageMetadata.id || pageMetadata.id;
  }

  if ('type' in overridePageMetadata || 'type' in pageMetadata) {
    meta.pageType = overridePageMetadata.type || pageMetadata.type;
  }

  if ('section' in overridePageMetadata || 'section' in pageMetadata) {
    meta.pageSection = overridePageMetadata.section || pageMetadata.section;
  }

  if ('subsection' in overridePageMetadata || 'subsection' in pageMetadata) {
    meta.pageSubSection = overridePageMetadata.subsection || pageMetadata.subsection;
  }

  return meta;
}

});
},{"8":8}],180:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require(28);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = traverseObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function traverseObject(obj, key) {
  if ((typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) !== 'object') {
    return undefined;
  }
  for (var k in obj) {
    if (key === k) {
      return obj[key];
    }
    var value = traverseObject(obj[k], key);
    if (value) {
      return value;
    }
  }
  return undefined;
}

});
},{"28":28,"8":8}],181:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reset = reset;
exports.initSetFormType = initSetFormType;
exports.setFormType = setFormType;
exports.setPosition = setPosition;
exports.updateUserData = updateUserData;
exports.validationErrors = validationErrors;
exports.setUserType = setUserType;
exports.successOauthSignIn = successOauthSignIn;
exports.successSignIn = successSignIn;
exports.successRegister = successRegister;
exports.failSignIn = failSignIn;
exports.failRegister = failRegister;
exports.failForgotPassword = failForgotPassword;
exports.failOauthSignIn = failOauthSignIn;
exports.initSignIn = initSignIn;
exports.initRegister = initRegister;
exports.initOauthSignIn = initOauthSignIn;
exports.initForgotPassword = initForgotPassword;
exports.sentForgotPassword = sentForgotPassword;
exports.successForgotPassword = successForgotPassword;
exports.validateField = validateField;
exports.changeField = changeField;
exports.setField = setField;
exports.resetErrors = resetErrors;
exports.suggestUserName = suggestUserName;
exports.trackClick = trackClick;
exports.trackDisplay = trackDisplay;

var _constants = require(182);

var constant = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Action Creators
function reset() {
  return { type: constant.RESET };
}

function initSetFormType(formType) {
  return { type: constant.INIT_SET_FORM_TYPE, formType: formType };
}

function setFormType(formType) {
  return { type: constant.SET_FORM_TYPE, formType: formType };
}

function setPosition(position, userType) {
  return { type: constant.SET_POSITION, position: position, userType: userType };
}

function updateUserData(data) {
  return { type: constant.UPDATE_USER_DATA, data: data };
}

function validationErrors(errors) {
  return { type: constant.VALIDATION_ERRORS, errors: errors };
}

function setUserType(userType) {
  return { type: constant.SET_USER_TYPE, userType: userType };
}

function successOauthSignIn() {
  return { type: constant.SUCCESS_OAUTH_SIGN_IN };
}

function successSignIn() {
  return { type: constant.SUCCESS_SIGN_IN };
}

function successRegister() {
  return { type: constant.SUCCESS_REGISTER };
}

function failSignIn(errors) {
  return { type: constant.FAIL_SIGN_IN, errors: errors };
}

function failRegister(errors) {
  return { type: constant.FAIL_REGISTER, errors: errors };
}

function failForgotPassword(errors) {
  return { type: constant.FAIL_FORGOT_PASSWORD, errors: errors };
}

function failOauthSignIn(errors) {
  return { type: constant.FAIL_OAUTH_SIGN_IN, errors: errors };
}

function initSignIn(callback) {
  return { type: constant.INIT_SIGN_IN, callback: callback };
}

function initRegister(callback) {
  return { type: constant.INIT_REGISTER, callback: callback };
}

function initOauthSignIn(provider) {
  return { type: constant.INIT_OAUTH_SIGN_IN, provider: provider };
}

function initForgotPassword() {
  return { type: constant.INIT_FORGOT_PASSWORD };
}

function sentForgotPassword() {
  return { type: constant.SENT_FORGOT_PASSWORD };
}

function successForgotPassword() {
  return { type: constant.SUCCESS_FORGOT_PASSWORD };
}

function validateField(name) {
  return { type: constant.VALIDATE_FIELD, name: name };
}

function changeField(name, deps) {
  return { type: constant.CHANGE_FIELD, name: name, deps: deps };
}

function setField(form, name, value) {
  return { type: constant.SET_FIELD, form: form, name: name, value: value };
}

function resetErrors() {
  return { type: constant.RESET_ERRORS };
}

function suggestUserName(username) {
  return { type: constant.SUGGEST_USER_NAME, username: username };
}

function trackClick(formType) {
  return { type: constant.TRACK_CLICK, formType: formType };
}

function trackDisplay(formType) {
  return { type: constant.TRACK_DISPLAY, formType: formType };
}

});
},{"182":182,"8":8}],182:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var RESET = exports.RESET = 'RESET';
var INIT_SET_FORM_TYPE = exports.INIT_SET_FORM_TYPE = 'INIT_SET_FORM_TYPE';
var SET_FORM_TYPE = exports.SET_FORM_TYPE = 'SET_FORM_TYPE';
var SET_USER_TYPE = exports.SET_USER_TYPE = 'SET_USER_TYPE';
var SET_POSITION = exports.SET_POSITION = 'SET_POSITION';
var UPDATE_USER_DATA = exports.UPDATE_USER_DATA = 'UPDATE_USER_DATA';

var VALIDATION_ERRORS = exports.VALIDATION_ERRORS = 'VALIDATION_ERRORS';

var SUCCESS_OAUTH_SIGN_IN = exports.SUCCESS_OAUTH_SIGN_IN = 'SUCCESS_OAUTH_SIGN_IN';
var SUCCESS_SIGN_IN = exports.SUCCESS_SIGN_IN = 'SUCCESS_SIGN_IN';
var SUCCESS_REGISTER = exports.SUCCESS_REGISTER = 'SUCCESS_REGISTER';
var SUCCESS_FORGOT_PASSWORD = exports.SUCCESS_FORGOT_PASSWORD = 'SUCCESS_FORGOT_PASSWORD';

var INIT_SIGN_IN = exports.INIT_SIGN_IN = 'INIT_SIGN_IN';
var INIT_REGISTER = exports.INIT_REGISTER = 'INIT_REGISTER';
var INIT_OAUTH_SIGN_IN = exports.INIT_OAUTH_SIGN_IN = 'INIT_OAUTH_SIGN_IN';

var FAIL_SIGN_IN = exports.FAIL_SIGN_IN = 'FAIL_SIGN_IN';
var FAIL_REGISTER = exports.FAIL_REGISTER = 'FAIL_REGISTER';
var FAIL_FORGOT_PASSWORD = exports.FAIL_FORGOT_PASSWORD = 'FAIL_FORGOT_PASSWORD';
var FAIL_OAUTH_SIGN_IN = exports.FAIL_OAUTH_SIGN_IN = 'FAIL_OAUTH_SIGN_IN';

var INIT_FORGOT_PASSWORD = exports.INIT_FORGOT_PASSWORD = 'INIT_FORGOT_PASSWORD';
var SENT_FORGOT_PASSWORD = exports.SENT_FORGOT_PASSWORD = 'SENT_FORGOT_PASSWORD';

var VALIDATE_FIELD = exports.VALIDATE_FIELD = 'VALIDATE_FIELD';
var CHANGE_FIELD = exports.CHANGE_FIELD = 'CHANGE_FIELD';
var SET_FIELD = exports.SET_FIELD = 'SET_FIELD';

var RESET_ERRORS = exports.RESET_ERRORS = 'RESET_ERRORS';
var SUGGEST_USER_NAME = exports.SUGGEST_USER_NAME = 'SUGGEST_USER_NAME';

var TRACK_DISPLAY = exports.TRACK_DISPLAY = 'TRACK_DISPLAY';
var TRACK_CLICK = exports.TRACK_CLICK = 'TRACK_CLICK';

});
},{"8":8}],183:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require(12);

var _assign2 = _interopRequireDefault(_assign);

var _keys = require(16);

var _keys2 = _interopRequireDefault(_keys);

exports.default = reducer;

var _constants = require(182);

var constant = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  common: {},
  register: {
    firstName: '',
    lastName: '',
    email: '',
    username: '',
    password: '',
    newsletter: false,
    autoFillUsername: true,
    state: null
  },
  signIn: {
    identification: '',
    password: '',
    trustedComputer: false,
    state: null
  },
  forgotPassword: {
    identification: '',
    state: null
  },
  errors: {}
};

function extend(state, obj) {
  var s = {};
  (0, _keys2.default)(obj).forEach(function (attr) {
    s[attr] = (0, _assign2.default)({}, state[attr], obj[attr]);
  });
  return (0, _assign2.default)({}, state, s);
}

// Reducer
function reset(state) {
  var newState = {
    errors: {},
    common: (0, _assign2.default)({}, state.common, { oauthState: null }),
    register: initialState.register,
    signIn: initialState.signIn,
    forgotPassword: initialState.forgotPassword
  };
  newState.signIn.trustedComputer = state.common.isMobile;
  return (0, _assign2.default)({}, state, newState);
}

function resetErrors(state) {
  return (0, _assign2.default)({}, state, { errors: {} });
}

function setFormType(state, action) {
  return extend(state, { common: { formType: action.formType } });
}

function setUserType(state, action) {
  return extend(state, { common: { userType: action.userType } });
}

function setPosition(state, action) {
  return extend(state, { common: { userType: action.userType, position: action.position } });
}

function validationErrors(state, action) {
  return extend(state, { errors: action.errors });
}

function initSignIn(state) {
  return extend(resetErrors(state), { signIn: { state: 'wait' } });
}

function initRegister(state) {
  return extend(resetErrors(state), { register: { state: 'wait' } });
}

function initOauthSignIn(state, action) {
  return extend(resetErrors(state), { common: { oauthState: action.provider } });
}

function initForgotPassword(state) {
  return extend(resetErrors(state), { forgotPassword: { state: 'wait' } });
}

function failSignIn(state) {
  return extend(state, { signIn: { state: null } });
}

function failRegister(state) {
  return extend(state, { register: { state: null } });
}

function failOauthSignIn(state) {
  return extend(state, { common: { oauthState: null } });
}

function failForgotPassword(state) {
  return extend(state, { forgotPassword: { state: null } });
}

function sentForgotPassword(state) {
  return extend(resetErrors(state), { forgotPassword: { state: 'sent' } });
}

function validateField(state, action) {
  if (action.name === 'registration.email' && state.register.username === '') {
    return extend(state, { register: { autoFillUsername: true } });
  }
  if (action.name === 'registration.username') {
    return extend(state, { register: { autoFillUsername: false } });
  }
  return state;
}

function changeField(state, action) {
  var newErrors = (0, _assign2.default)({}, state.errors);
  delete newErrors[action.name];
  action.deps.forEach(function (d) {
    return delete newErrors[d];
  });
  return (0, _assign2.default)({}, state, { errors: newErrors });
}

function setField(state, action) {
  var obj = {};
  obj[action.form] = {};
  obj[action.form][action.name] = action.value;
  if (action.form === 'signIn' && action.name === 'identification') {
    (0, _assign2.default)(obj, { forgotPassword: { identification: action.value } });
  }
  return extend(state, obj);
}

function suggestUserName(state, action) {
  if (!state.register.autoFillUsername) {
    return state;
  }
  var newErrors = (0, _assign2.default)({}, state.errors);
  delete newErrors['registration.username'];
  var newState = (0, _assign2.default)({}, state, { errors: newErrors });
  return extend(newState, { register: { username: action.username } });
}

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case constant.RESET:
      return reset(state, action);
    case constant.SET_FORM_TYPE:
      return setFormType(state, action);
    case constant.SET_USER_TYPE:
      return setUserType(state, action);
    case constant.SET_POSITION:
      return setPosition(state, action);
    case constant.VALIDATION_ERRORS:
      return validationErrors(state, action);
    case constant.INIT_SIGN_IN:
      return initSignIn(state, action);
    case constant.INIT_REGISTER:
      return initRegister(state, action);
    case constant.INIT_OAUTH_SIGN_IN:
      return initOauthSignIn(state, action);
    case constant.INIT_FORGOT_PASSWORD:
      return initForgotPassword(state, action);
    case constant.FAIL_SIGN_IN:
      return failSignIn(state, action);
    case constant.FAIL_REGISTER:
      return failRegister(state, action);
    case constant.FAIL_OAUTH_SIGN_IN:
      return failOauthSignIn(state, action);
    case constant.FAIL_FORGOT_PASSWORD:
      return failForgotPassword(state, action);
    case constant.SENT_FORGOT_PASSWORD:
      return sentForgotPassword(state, action);
    case constant.VALIDATE_FIELD:
      return validateField(state, action);
    case constant.CHANGE_FIELD:
      return changeField(state, action);
    case constant.SET_FIELD:
      return setField(state, action);
    case constant.RESET_ERRORS:
      return resetErrors(state, action);
    case constant.SUGGEST_USER_NAME:
      return suggestUserName(state, action);

    default:
      return state;
  }
}

});
},{"12":12,"16":16,"182":182,"8":8}],184:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require(16);

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = require(29);

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.initSignIn = initSignIn;
exports.initRegister = initRegister;
exports.initOauthSignIn = initOauthSignIn;
exports.initForgotPassword = initForgotPassword;
exports.successSignIn = successSignIn;
exports.successForgotPassword = successForgotPassword;
exports.updateUserData = updateUserData;
exports.validateField = validateField;
exports.suggestUserName = suggestUserName;
exports.initSetFormType = initSetFormType;
exports.failSignIn = failSignIn;
exports.failRegister = failRegister;
exports.trackClickSaga = trackClickSaga;
exports.trackDisplaySaga = trackDisplaySaga;
exports.default = rootSaga;

var _reduxSaga = require(144);

var _effects = require(142);

var _minijoi = require(139);

var _minijoi2 = _interopRequireDefault(_minijoi);

var _deniedErrorcode = require(176);

var _actions = require(181);

var actions = _interopRequireWildcard(_actions);

var _tracking = require(179);

var _traverseObject = require(180);

var _traverseObject2 = _interopRequireDefault(_traverseObject);

var _errorMessages = require(159);

var _errorMessages2 = _interopRequireDefault(_errorMessages);

var _constants = require(182);

var constant = _interopRequireWildcard(_constants);

var _api = require(174);

var _api2 = _interopRequireDefault(_api);

var _utils = require(185);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [initSignIn, initRegister, initOauthSignIn, initForgotPassword, successSignIn, successForgotPassword, updateUserData, validateField, suggestUserName, initSetFormType, failSignIn, failRegister, trackClickSaga, trackDisplaySaga, takeLatestWithName, rootSaga].map(_regenerator2.default.mark);

/*
  utilities
*/
function getWindow() {
  try {
    return window;
  } catch (e) {
    return {};
  }
}

function getErrorCode(xhr, prefix) {
  var genericErrorCode = xhr.status >= 400 && xhr.status < 500 ? 'denied' : 'generic';
  try {
    var response = JSON.parse(xhr.response || xhr.responseText);
    // assembling the error code
    var errorCodes = response.errors.map(function (e) {
      return prefix + '.' + e.field + '.' + e.types[0];
    });
    return errorCodes.length ? errorCodes.join(',') : prefix + '.' + genericErrorCode + '.error';
  } catch (e) {
    if (getWindow()._airbrake) {
      var errorObj = void 0;
      if (xhr.status === 0) {
        errorObj = { error: { message: 'app-authentication: api timing out (' + prefix + ') readystate ' + xhr.readyState, fileName: 'restapi.js', lineNumber: 0, columnNumber: 0 } };
      } else {
        errorObj = { error: { message: 'app-authentication: api returning unexpected ' + genericErrorCode + ' (' + prefix + '): ' + xhr.status + ' - ' + xhr.response, fileName: 'api.js', lineNumber: 0, columnNumber: 0 } };
      }
      getWindow()._airbrake.push(errorObj);
    }
    return prefix + '.' + genericErrorCode + '.error';
  }
}

var userNameValidation = _minijoi2.default.string().min(3).max(30).regex(/^[A-Za-z0-9_\-]*$/).required();
var emailValidation = _minijoi2.default.string().email();

// const schemas = {
//   registration: Joi.object().keys({
//     username: userNameValidation,
//     email: emailValidation,
//     password: Joi.string().min(6).required(),
//     firstName: Joi.string(),
//     lastName: Joi.string(),
//     newsletter: Joi.boolean(),
//   }),
// };

/*
  sagas
*/
function initSignIn(action) {
  var isInline, isModal, credentials, errorCode, errors;
  return _regenerator2.default.wrap(function initSignIn$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(actions.resetErrors());

        case 2:
          _context.next = 4;
          return (0, _effects.select)(_utils.getIsInline);

        case 4:
          isInline = _context.sent;
          _context.next = 7;
          return (0, _effects.select)(_utils.getIsModal);

        case 7:
          isModal = _context.sent;

          if (!(!isInline && !isModal)) {
            _context.next = 20;
            break;
          }

          _context.prev = 9;
          _context.next = 12;
          return (0, _effects.cps)(_tracking.trackLogin, 'tes-login', (0, _tracking.getTrackingType)(isModal, isInline));

        case 12:
          _context.next = 17;
          break;

        case 14:
          _context.prev = 14;
          _context.t0 = _context['catch'](9);

          console.log('Tracking Login error', _context.t0.message); // eslint-disable-line no-console

        case 17:
          _context.next = 19;
          return (0, _effects.call)(action.callback);

        case 19:
          return _context.abrupt('return');

        case 20:
          _context.prev = 20;
          _context.next = 23;
          return (0, _effects.call)(_tracking.trackLogin, 'tes-login', (0, _tracking.getTrackingType)(isModal, isInline));

        case 23:
          _context.next = 25;
          return (0, _effects.select)(_utils.getSignInData);

        case 25:
          credentials = _context.sent;
          _context.next = 28;
          return (0, _effects.call)(_api2.default.signIn, credentials);

        case 28:
          _context.next = 30;
          return (0, _effects.put)(actions.successSignIn());

        case 30:
          _context.next = 40;
          break;

        case 32:
          _context.prev = 32;
          _context.t1 = _context['catch'](20);
          errorCode = (0, _deniedErrorcode.authDenied)(_context.t1) || getErrorCode(_context.t1, 'signin');
          errors = (0, _errorMessages2.default)(errorCode);
          _context.next = 38;
          return (0, _effects.put)(actions.validationErrors(errors));

        case 38:
          _context.next = 40;
          return (0, _effects.put)(actions.failSignIn(errors));

        case 40:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[9, 14], [20, 32]]);
}

function initRegister(action) {
  var isInline, isModal, info, errorCode, errors;
  return _regenerator2.default.wrap(function initRegister$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)(actions.resetErrors());

        case 2:
          _context2.next = 4;
          return (0, _effects.select)(_utils.getIsInline);

        case 4:
          isInline = _context2.sent;
          _context2.next = 7;
          return (0, _effects.select)(_utils.getIsModal);

        case 7:
          isModal = _context2.sent;

          if (!(!isInline && !isModal)) {
            _context2.next = 20;
            break;
          }

          _context2.prev = 9;
          _context2.next = 12;
          return (0, _effects.cps)(_tracking.trackRegister, (0, _tracking.getTrackingType)(isModal, isInline));

        case 12:
          _context2.next = 17;
          break;

        case 14:
          _context2.prev = 14;
          _context2.t0 = _context2['catch'](9);

          console.log('Tracking Registration error', _context2.t0.message); // eslint-disable-line no-console

        case 17:
          _context2.next = 19;
          return (0, _effects.call)(action.callback);

        case 19:
          return _context2.abrupt('return');

        case 20:
          _context2.prev = 20;
          _context2.next = 23;
          return (0, _effects.call)(_tracking.trackRegister, (0, _tracking.getTrackingType)(isModal, isInline));

        case 23:
          _context2.next = 25;
          return (0, _effects.select)(_utils.getRegistrationData);

        case 25:
          info = _context2.sent;
          _context2.next = 28;
          return (0, _effects.call)(_api2.default.register, info);

        case 28:
          _context2.next = 30;
          return (0, _effects.put)(actions.successRegister());

        case 30:
          _context2.next = 40;
          break;

        case 32:
          _context2.prev = 32;
          _context2.t1 = _context2['catch'](20);
          errorCode = getErrorCode(_context2.t1, 'registration');
          errors = (0, _errorMessages2.default)(errorCode);
          _context2.next = 38;
          return (0, _effects.put)(actions.validationErrors(errors));

        case 38:
          _context2.next = 40;
          return (0, _effects.put)(actions.failRegister(errors));

        case 40:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[9, 14], [20, 32]]);
}

function initOauthSignIn(_ref) {
  var provider = _ref.provider;
  var isInline, isModal, info, errorCode, errors;
  return _regenerator2.default.wrap(function initOauthSignIn$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.put)(actions.resetErrors());

        case 3:
          _context3.next = 5;
          return (0, _effects.select)(_utils.getIsInline);

        case 5:
          isInline = _context3.sent;
          _context3.next = 8;
          return (0, _effects.select)(_utils.getIsModal);

        case 8:
          isModal = _context3.sent;
          _context3.next = 11;
          return (0, _effects.select)(_utils.getGoogleSignInData);

        case 11:
          info = _context3.sent;

          if (!(!isModal && !isInline)) {
            _context3.next = 24;
            break;
          }

          _context3.prev = 13;
          _context3.next = 16;
          return (0, _effects.cps)(_tracking.trackLogin, provider + '-login', (0, _tracking.getTrackingType)(isModal, isInline));

        case 16:
          _context3.next = 21;
          break;

        case 18:
          _context3.prev = 18;
          _context3.t0 = _context3['catch'](13);

          console.log('Tracking ' + provider + ' Login error', _context3.t0.message); // eslint-disable-line no-console

        case 21:
          _context3.next = 23;
          return (0, _effects.call)(_api2.default.oauthSignIn, provider, info);

        case 23:
          return _context3.abrupt('return');

        case 24:
          _context3.next = 26;
          return (0, _effects.call)(_tracking.trackLogin, provider + '-login', (0, _tracking.getTrackingType)(isModal, isInline));

        case 26:
          _context3.next = 28;
          return (0, _effects.call)(_api2.default.oauthSignIn, provider, info);

        case 28:
          _context3.next = 30;
          return (0, _effects.put)(actions.successOauthSignIn());

        case 30:
          _context3.next = 44;
          break;

        case 32:
          _context3.prev = 32;
          _context3.t1 = _context3['catch'](0);

          if (!_context3.t1.needsPosition) {
            _context3.next = 38;
            break;
          }

          _context3.next = 37;
          return (0, _effects.put)(actions.setFormType('logged-in-select'));

        case 37:
          return _context3.abrupt('return');

        case 38:
          errorCode = _context3.t1.message;
          errors = (0, _errorMessages2.default)(errorCode);
          _context3.next = 42;
          return (0, _effects.put)(actions.validationErrors(errors));

        case 42:
          _context3.next = 44;
          return (0, _effects.put)(actions.failOauthSignIn(errors));

        case 44:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[0, 32], [13, 18]]);
}

function initForgotPassword() {
  var isInline, isModal, info, errorCode, errors;
  return _regenerator2.default.wrap(function initForgotPassword$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)(actions.resetErrors());

        case 2:
          _context4.next = 4;
          return (0, _effects.select)(_utils.getIsInline);

        case 4:
          isInline = _context4.sent;
          _context4.next = 7;
          return (0, _effects.select)(_utils.getIsModal);

        case 7:
          isModal = _context4.sent;
          _context4.prev = 8;
          _context4.next = 11;
          return (0, _effects.cps)(_tracking.trackForgotPassword, (0, _tracking.getTrackingType)(isModal, isInline));

        case 11:
          _context4.next = 16;
          break;

        case 13:
          _context4.prev = 13;
          _context4.t0 = _context4['catch'](8);

          console.log('Tracking forgot password error', _context4.t0.message); // eslint-disable-line no-console

        case 16:
          _context4.prev = 16;
          _context4.next = 19;
          return (0, _effects.select)(_utils.getForgotPasswordData);

        case 19:
          info = _context4.sent;
          _context4.next = 22;
          return (0, _effects.call)(_api2.default.forgotPassword, info);

        case 22:
          _context4.next = 24;
          return (0, _effects.put)(actions.sentForgotPassword());

        case 24:
          _context4.next = 26;
          return (0, _effects.put)(actions.setField('forgotPassword', 'identification', ''));

        case 26:
          _context4.next = 36;
          break;

        case 28:
          _context4.prev = 28;
          _context4.t1 = _context4['catch'](16);
          errorCode = (0, _deniedErrorcode.forgotPasswordDenied)(_context4.t1) || getErrorCode(_context4.t1, 'forgot-password');
          errors = (0, _errorMessages2.default)(errorCode);
          _context4.next = 34;
          return (0, _effects.put)(actions.validationErrors(errors));

        case 34:
          _context4.next = 36;
          return (0, _effects.put)(actions.failForgotPassword(errors));

        case 36:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this, [[8, 13], [16, 28]]);
}

function successSignIn() {
  var onSuccess, regInfo, reloadURL;
  return _regenerator2.default.wrap(function successSignIn$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.select)(_utils.getOnSuccess);

        case 2:
          onSuccess = _context5.sent;

          if (!(onSuccess === 'reload')) {
            _context5.next = 14;
            break;
          }

          _context5.next = 6;
          return (0, _effects.select)(_utils.getRegistrationData);

        case 6:
          regInfo = _context5.sent;
          _context5.next = 9;
          return (0, _effects.select)(_utils.getReloadURL, regInfo);

        case 9:
          reloadURL = _context5.sent;
          _context5.next = 12;
          return (0, _effects.call)(_api2.default.reload, reloadURL);

        case 12:
          _context5.next = 22;
          break;

        case 14:
          _context5.next = 16;
          return (0, _effects.call)(_api2.default.closeModalEvent);

        case 16:
          _context5.next = 18;
          return (0, _effects.call)(_api2.default.loggedInEvent);

        case 18:
          _context5.next = 20;
          return (0, _effects.call)(_reduxSaga.delay, 200);

        case 20:
          _context5.next = 22;
          return (0, _effects.put)(actions.reset());

        case 22:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function successForgotPassword() {
  return _regenerator2.default.wrap(function successForgotPassword$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.put)(actions.setField('forgotPassword', 'identification', ''));

        case 2:
          _context6.next = 4;
          return (0, _effects.call)(_api2.default.closeModalEvent);

        case 4:
          _context6.next = 6;
          return (0, _effects.call)(_reduxSaga.delay, 200);

        case 6:
          _context6.next = 8;
          return (0, _effects.put)(actions.reset());

        case 8:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this);
}

function updateUserData(action) {
  var errorCode;
  return _regenerator2.default.wrap(function updateUserData$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.call)(_api2.default.updateUserData, action.data);

        case 3:
          _context7.next = 5;
          return (0, _effects.put)(actions.successSignIn());

        case 5:
          _context7.next = 12;
          break;

        case 7:
          _context7.prev = 7;
          _context7.t0 = _context7['catch'](0);
          errorCode = getErrorCode(_context7.t0, 'edit-account');
          _context7.next = 12;
          return (0, _effects.put)(actions.validationErrors((0, _errorMessages2.default)(errorCode)));

        case 12:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this, [[0, 7]]);
}

function validateField(action) {
  var userData, response, _response;

  return _regenerator2.default.wrap(function validateField$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.call)(_reduxSaga.delay, 1200);

        case 2:
          _context8.next = 4;
          return (0, _effects.select)(_utils.getRegistrationData);

        case 4:
          userData = _context8.sent;
          _context8.prev = 5;

          if (!(action.name === 'registration.username' && userData.username && !_minijoi2.default.validate(userData.username, userNameValidation).error)) {
            _context8.next = 15;
            break;
          }

          _context8.next = 9;
          return (0, _effects.call)(_api2.default.verifyUsername, userData.username);

        case 9:
          response = _context8.sent;

          if (!response.length) {
            _context8.next = 13;
            break;
          }

          _context8.next = 13;
          return (0, _effects.put)(actions.validationErrors((0, _errorMessages2.default)('registration.username.duplicate')));

        case 13:
          _context8.next = 25;
          break;

        case 15:
          if (!(action.name === 'registration.email' && userData.email && !_minijoi2.default.validate(userData.email, emailValidation).error)) {
            _context8.next = 25;
            break;
          }

          _context8.next = 18;
          return (0, _effects.call)(_api2.default.verifyEmail, userData.email);

        case 18:
          _response = _context8.sent;

          if (!_response.length) {
            _context8.next = 22;
            break;
          }

          _context8.next = 22;
          return (0, _effects.put)(actions.validationErrors((0, _errorMessages2.default)('registration.email.duplicate')));

        case 22:
          if (!_response.suggestedUsername) {
            _context8.next = 25;
            break;
          }

          _context8.next = 25;
          return (0, _effects.put)(actions.suggestUserName(_response.suggestedUsername));

        case 25:
          _context8.next = 30;
          break;

        case 27:
          _context8.prev = 27;
          _context8.t0 = _context8['catch'](5);

          console.log('Error validate field', action.name, _context8.t0.message); // eslint-disable-line no-console

        case 30:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this, [[5, 27]]);
}

function suggestUserName() {
  var userData, response;
  return _regenerator2.default.wrap(function suggestUserName$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.select)(_utils.getRegistrationData);

        case 2:
          userData = _context9.sent;
          _context9.prev = 3;

          if (!(userData.email && !_minijoi2.default.validate(userData.email, emailValidation).error)) {
            _context9.next = 11;
            break;
          }

          _context9.next = 7;
          return (0, _effects.call)(_api2.default.verifyEmail, userData.email);

        case 7:
          response = _context9.sent;

          if (!response.suggestedUsername) {
            _context9.next = 11;
            break;
          }

          _context9.next = 11;
          return (0, _effects.put)(actions.suggestUserName(response.suggestedUsername));

        case 11:
          _context9.next = 16;
          break;

        case 13:
          _context9.prev = 13;
          _context9.t0 = _context9['catch'](3);

          console.log('Error suggest username', _context9.t0.message); // eslint-disable-line no-console

        case 16:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this, [[3, 13]]);
}

function initSetFormType(action) {
  var isInline, isModal, oldFormType;
  return _regenerator2.default.wrap(function initSetFormType$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.select)(_utils.getIsInline);

        case 2:
          isInline = _context10.sent;
          _context10.next = 5;
          return (0, _effects.select)(_utils.getIsModal);

        case 5:
          isModal = _context10.sent;

          if (!(!isModal && !isInline)) {
            _context10.next = 8;
            break;
          }

          return _context10.abrupt('return');

        case 8:
          _context10.next = 10;
          return (0, _effects.select)(_utils.getFormType);

        case 10:
          oldFormType = _context10.sent;

          if (!(oldFormType === action.formType)) {
            _context10.next = 13;
            break;
          }

          return _context10.abrupt('return');

        case 13:
          _context10.next = 15;
          return (0, _effects.put)(actions.setFormType(action.formType));

        case 15:
          _context10.next = 17;
          return (0, _effects.put)(actions.trackClick(action.formType));

        case 17:
          _context10.next = 19;
          return (0, _effects.put)(actions.trackDisplay(action.formType));

        case 19:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this);
}

function failSignIn(action) {
  var filteredErrors, msg, id, isInline, isModal;
  return _regenerator2.default.wrap(function failSignIn$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          if (action.errors) {
            _context11.next = 2;
            break;
          }

          return _context11.abrupt('return');

        case 2:
          filteredErrors = (0, _keys2.default)(action.errors).filter(function (e) {
            return e.startsWith('signin.') || e.startsWith('generic.googlebutton');
          });

          if (!filteredErrors.length) {
            _context11.next = 14;
            break;
          }

          msg = (0, _traverseObject2.default)(action.errors[filteredErrors[0]], 'msg') || 'unknown error';
          id = filteredErrors[0] === 'generic.googlebutton' ? 'google-login-fail' : 'login-fail';
          _context11.next = 8;
          return (0, _effects.select)(_utils.getIsInline);

        case 8:
          isInline = _context11.sent;
          _context11.next = 11;
          return (0, _effects.select)(_utils.getIsModal);

        case 11:
          isModal = _context11.sent;
          _context11.next = 14;
          return (0, _effects.call)(_tracking.trackError, id, msg, (0, _tracking.getTrackingType)(isModal, isInline));

        case 14:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this);
}

function failRegister(action) {
  var filteredErrors, msg, isInline, isModal;
  return _regenerator2.default.wrap(function failRegister$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          if (action.errors) {
            _context12.next = 2;
            break;
          }

          return _context12.abrupt('return');

        case 2:
          filteredErrors = (0, _keys2.default)(action.errors).filter(function (e) {
            return e.startsWith('registration.');
          });

          if (!filteredErrors.length) {
            _context12.next = 13;
            break;
          }

          msg = (0, _traverseObject2.default)(action.errors[filteredErrors[0]], 'msg') || 'unknown error';
          _context12.next = 7;
          return (0, _effects.select)(_utils.getIsInline);

        case 7:
          isInline = _context12.sent;
          _context12.next = 10;
          return (0, _effects.select)(_utils.getIsModal);

        case 10:
          isModal = _context12.sent;
          _context12.next = 13;
          return (0, _effects.call)(_tracking.trackError, 'register-fail', msg, (0, _tracking.getTrackingType)(isModal, isInline));

        case 13:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this);
}

function trackClickSaga(action) {
  return _regenerator2.default.wrap(function trackClickSaga$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.call)(_tracking.trackClick, action.formType);

        case 2:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this);
}

function trackDisplaySaga(action) {
  var isInline, isModal, userType, doSelectUserType;
  return _regenerator2.default.wrap(function trackDisplaySaga$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.select)(_utils.getIsInline);

        case 2:
          isInline = _context14.sent;
          _context14.next = 5;
          return (0, _effects.select)(_utils.getIsModal);

        case 5:
          isModal = _context14.sent;
          _context14.next = 8;
          return (0, _effects.select)(_utils.getUserType);

        case 8:
          userType = _context14.sent;
          _context14.next = 11;
          return (0, _effects.select)(_utils.getDoSelectUserType);

        case 11:
          doSelectUserType = _context14.sent;

          if (isInline) {
            _context14.next = 15;
            break;
          }

          _context14.next = 15;
          return (0, _effects.call)(_tracking.trackDisplay, action.formType, (0, _tracking.getTrackingType)(isModal, isInline), userType, doSelectUserType);

        case 15:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this);
}

function takeLatestWithName(pattern, saga) {
  var task;
  return _regenerator2.default.wrap(function takeLatestWithName$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.fork)(_regenerator2.default.mark(function newSaga() {
            var lastTask, action;
            return _regenerator2.default.wrap(function newSaga$(_context15) {
              while (1) {
                switch (_context15.prev = _context15.next) {
                  case 0:
                    lastTask = {};

                  case 1:
                    if (!true) {
                      _context15.next = 13;
                      break;
                    }

                    _context15.next = 4;
                    return (0, _effects.take)(pattern);

                  case 4:
                    action = _context15.sent;

                    if (!(action.name in lastTask)) {
                      _context15.next = 8;
                      break;
                    }

                    _context15.next = 8;
                    return (0, _effects.cancel)(lastTask[action.name]);

                  case 8:
                    _context15.next = 10;
                    return (0, _effects.fork)(saga, action);

                  case 10:
                    lastTask[action.name] = _context15.sent;
                    _context15.next = 1;
                    break;

                  case 13:
                  case 'end':
                    return _context15.stop();
                }
              }
            }, newSaga, this);
          }));

        case 2:
          task = _context16.sent;
          return _context16.abrupt('return', task);

        case 4:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked[14], this);
}

function isEmail(action) {
  return action.type === constant.VALIDATE_FIELD && action.name === 'registration.email';
}

function rootSaga() {
  return _regenerator2.default.wrap(function rootSaga$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return [(0, _reduxSaga.takeEvery)(constant.INIT_SIGN_IN, initSignIn), (0, _reduxSaga.takeEvery)(constant.INIT_REGISTER, initRegister), (0, _reduxSaga.takeEvery)(constant.INIT_OAUTH_SIGN_IN, initOauthSignIn), (0, _reduxSaga.takeEvery)(constant.INIT_FORGOT_PASSWORD, initForgotPassword), (0, _reduxSaga.takeEvery)(constant.SUCCESS_OAUTH_SIGN_IN, successSignIn), (0, _reduxSaga.takeEvery)(constant.SUCCESS_SIGN_IN, successSignIn), (0, _reduxSaga.takeEvery)(constant.SUCCESS_REGISTER, successSignIn), (0, _reduxSaga.takeEvery)(constant.SUCCESS_FORGOT_PASSWORD, successForgotPassword), (0, _reduxSaga.takeEvery)(constant.UPDATE_USER_DATA, updateUserData), (0, _reduxSaga.takeEvery)(constant.INIT_SET_FORM_TYPE, initSetFormType), (0, _reduxSaga.takeEvery)(constant.FAIL_SIGN_IN, failSignIn), (0, _reduxSaga.takeEvery)(constant.FAIL_OAUTH_SIGN_IN, failSignIn), (0, _reduxSaga.takeEvery)(constant.FAIL_REGISTER, failRegister), (0, _reduxSaga.takeEvery)(constant.TRACK_CLICK, trackClickSaga), (0, _reduxSaga.takeEvery)(constant.TRACK_DISPLAY, trackDisplaySaga), takeLatestWithName(constant.VALIDATE_FIELD, validateField), (0, _reduxSaga.throttle)(800, isEmail, suggestUserName)];

        case 2:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked[15], this);
}

});
},{"139":139,"142":142,"144":144,"159":159,"16":16,"174":174,"176":176,"179":179,"180":180,"181":181,"182":182,"185":185,"29":29,"8":8}],185:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDoSelectUserType = getDoSelectUserType;
exports.getOnSuccess = getOnSuccess;
exports.getFormType = getFormType;
exports.getIsInline = getIsInline;
exports.getIsModal = getIsModal;
exports.getUserType = getUserType;
exports.getForgotPasswordData = getForgotPasswordData;
exports.getReloadURL = getReloadURL;
exports.getSignInData = getSignInData;
exports.getRegistrationData = getRegistrationData;
exports.getGoogleSignInData = getGoogleSignInData;

var _tracking = require(179);

var _dateHelper = require(175);

function getDoSelectUserType(state) {
  return state.common.doSelectUserType;
}

function getOnSuccess(state) {
  return state.common.onSuccess;
}

function getFormType(state) {
  return state.common.formType;
}

function getIsInline(state) {
  return state.common.isInline;
}

function getIsModal(state) {
  return state.common.isModal;
}

function getUserType(state) {
  return state.common.userType;
}

function getForgotPasswordData(state) {
  return { email: state.forgotPassword.identification };
}

function getReloadURL(state, regInfo) {
  if (regInfo.userType === 'student' && !regInfo.classCode && regInfo.guardianEmail) {
    return state.common.guardianEmailReload;
  }
  return state.common.reloadURL;
}

function getSignInData(state) {
  var common = state.common;
  var signIn = state.signIn;
  var pageContext = (0, _tracking.getPageContext)(common.pageMz, common.overrideMz);

  var identification = signIn.identification;
  var password = signIn.password;
  var trustedComputer = signIn.trustedComputer;
  var appId = common.appId;

  var pageId = pageContext.pageId;
  var pageType = pageContext.pageType;
  var pageSection = pageContext.pageSection;
  var pageSubSection = pageContext.pageSubSection;

  var data = {
    appId: appId,
    identification: identification,
    password: password,
    trustedComputer: trustedComputer,
    pageId: pageId,
    pageType: pageType,
    pageSection: pageSection,
    pageSubSection: pageSubSection
  };

  return data;
}

function getRegistrationData(state) {
  var common = state.common;
  var register = state.register;
  var pageContext = (0, _tracking.getPageContext)(common.pageMz, common.overrideMz);

  var isModal = common.isModal;
  var isInline = common.isInline;
  var isStudent = common.userType === 'student';

  var hasDoB = !!register.dateOfBirth;
  var under13 = (0, _dateHelper.isUnder13)(register.dateOfBirth);

  var pageId = pageContext.pageId;
  var pageType = pageContext.pageType;
  var pageSection = pageContext.pageSection;
  var pageSubSection = pageContext.pageSubSection;

  var data = {
    username: register.username,
    email: register.email || '',
    password: register.password,
    userType: common.userType || null,
    newsletter: isStudent ? false : register.newsletter,
    regUrl: !isModal && !isInline ? common.rtn : window && window.location.href,
    pageId: pageId,
    pageType: pageType,
    pageSection: pageSection,
    pageSubSection: pageSubSection,
    appId: common.appId
  };

  data.position = common.position || '';

  if (!common.omitName) {
    data.firstName = register.firstName;
    data.lastName = register.lastName;
  }

  if (isStudent && hasDoB) {
    data.dateOfBirth = register.dateOfBirth;
  }

  if (isStudent && under13) {
    data.classCode = register.classCode;
    data.guardianEmail = register.guardianEmail;
  }

  return data;
}

function getGoogleSignInData(state) {
  var common = state.common;
  var register = state.register;
  var pageContext = (0, _tracking.getPageContext)(common.pageMz, common.overrideMz);

  var isStudent = common.userType === 'student';
  var isModal = common.isModal;
  var isInline = common.isInline;

  var pageId = pageContext.pageId;
  var pageType = pageContext.pageType;
  var pageSection = pageContext.pageSection;
  var pageSubSection = pageContext.pageSubSection;
  var regUrl = void 0;
  if (common.regUrl) {
    regUrl = common.regUrl;
  } else if (!isModal && !isInline) {
    regUrl = common.rtn;
  } else {
    regUrl = window && window.location.href;
  }

  var data = {
    isModal: isModal || isInline,
    userType: common.userType,
    newsletter: isStudent ? false : register.newsletter,
    regUrl: regUrl,
    appId: common.appId,
    pageId: pageId,
    pageType: pageType,
    pageSection: pageSection,
    pageSubSection: pageSubSection,
    trustedComputer: state.signIn.trustedComputer,
    rtn: isModal || isInline ? '/oauth/close-modal' : common.rtn || window.location.href
  };

  data.position = common.position || '';

  return data;
}

});
},{"175":175,"179":179,"8":8}],186:[function(require,module,exports){
require(8)(["react-15.3","reactdom-15.3","redux-3.6","reactredux-4.4"],function(__react,__react_dom,__redux,__react_redux){
'use strict';

require(136);

var _es6ObjectAssign = require(131);

var _es6ObjectAssign2 = _interopRequireDefault(_es6ObjectAssign);

require(158);

var _reduxSaga = require(144);

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _react = __react;

var _react2 = _interopRequireDefault(_react);

var _reactDom = __react_dom;

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __react_redux;

var _redux = __redux;

var _reducers = require(183);

var _reducers2 = _interopRequireDefault(_reducers);

var _App = require(160);

var _App2 = _interopRequireDefault(_App);

var _sagas = require(184);

var _sagas2 = _interopRequireDefault(_sagas);

var _actions = require(181);

var actions = _interopRequireWildcard(_actions);

var _utils = require(185);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var events = window.TES.events; // polyfills


_es6ObjectAssign2.default.polyfill();

var mountPointCls = 'app-auth-mountpoint';
var mountPoint = '.' + mountPointCls;

var bootstrap = function bootstrap() {
  var sagaMiddleware = (0, _reduxSaga2.default)();

  var mountElement = document.querySelector(mountPoint);
  mountElement.className = mountPointCls + '-loaded';
  var initialState = JSON.parse(mountElement.getAttribute('data-init-state'));

  var enhancer = (0, _redux.compose)((0, _redux.applyMiddleware)(sagaMiddleware));

  var store = (0, _redux.createStore)(_reducers2.default, initialState, enhancer);
  // then run the saga
  sagaMiddleware.run(_sagas2.default);

  var app = _react2.default.createElement(_App2.default);
  var provider = _react2.default.createElement(_reactRedux.Provider, { store: store }, app);

  _reactDom2.default.render(provider, mountElement);

  events.on('modal-switch', function (eventType, data) {
    if (data.appId === 'authapp') {
      store.dispatch(actions.initSetFormType(data.msg));
    }
  });
  // // this sends an event only when I am NOT changing the form type
  events.on(/modal-(switch|init)/, function (eventType, data) {
    var form = data.msg;
    if (data.appId === 'authapp' && form === (0, _utils.getFormType)(store.getState())) {
      store.dispatch(actions.trackClick(form));
    }
  });
};

if (document.querySelector(mountPoint)) {
  bootstrap(); // page init
} else {
  events.one('modal-init', bootstrap); // modal init
}

});
},{"131":131,"136":136,"144":144,"158":158,"160":160,"181":181,"183":183,"184":184,"185":185,"8":8}]},{},[186])
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm5vZGVfbW9kdWxlcy9icm93c2VyLXBhY2svX3ByZWx1ZGUuanMiLCJub2RlX21vZHVsZXMvYXN5bmMtZGVjby9wcm9taXNlL21lbW9pemUuanMiLCJub2RlX21vZHVsZXMvYXN5bmMtZGVjby9wcm9taXNlL3JldHJ5LmpzIiwibm9kZV9tb2R1bGVzL2FzeW5jLWRlY28vc3JjL21lbW9pemUuanMiLCJub2RlX21vZHVsZXMvYXN5bmMtZGVjby9zcmMvcHJvbWlzZS10cmFuc2xhdG9yLmpzIiwibm9kZV9tb2R1bGVzL2FzeW5jLWRlY28vc3JjL3JldHJ5LmpzIiwibm9kZV9tb2R1bGVzL2FzeW5jLWRlY28vdXRpbHMvY2FsbGJhY2tpZnkuanMiLCJub2RlX21vZHVsZXMvYXN5bmMtZGVjby91dGlscy9kZWZhdWx0LWxvZ2dlci5qcyIsIm5vZGVfbW9kdWxlcy9hc3luYy1kZWZpbmUvbGliL2FzeW5jRGVmaW5lLmpzIiwibm9kZV9tb2R1bGVzL2JhYmVsLXJ1bnRpbWUvY29yZS1qcy9nZXQtaXRlcmF0b3IuanMiLCJub2RlX21vZHVsZXMvYmFiZWwtcnVudGltZS9jb3JlLWpzL2lzLWl0ZXJhYmxlLmpzIiwibm9kZV9tb2R1bGVzL2JhYmVsLXJ1bnRpbWUvY29yZS1qcy9qc29uL3N0cmluZ2lmeS5qcyIsIm5vZGVfbW9kdWxlcy9iYWJlbC1ydW50aW1lL2NvcmUtanMvb2JqZWN0L2Fzc2lnbi5qcyIsIm5vZGVfbW9kdWxlcy9iYWJlbC1ydW50aW1lL2NvcmUtanMvb2JqZWN0L2NyZWF0ZS5qcyIsIm5vZGVfbW9kdWxlcy9iYWJlbC1ydW50aW1lL2NvcmUtanMvb2JqZWN0L2RlZmluZS1wcm9wZXJ0eS5qcyIsIm5vZGVfbW9kdWxlcy9iYWJlbC1ydW50aW1lL2NvcmUtanMvb2JqZWN0L2dldC1wcm90b3R5cGUtb2YuanMiLCJub2RlX21vZHVsZXMvYmFiZWwtcnVudGltZS9jb3JlLWpzL29iamVjdC9rZXlzLmpzIiwibm9kZV9tb2R1bGVzL2JhYmVsLXJ1bnRpbWUvY29yZS1qcy9vYmplY3Qvc2V0LXByb3RvdHlwZS1vZi5qcyIsIm5vZGVfbW9kdWxlcy9iYWJlbC1ydW50aW1lL2NvcmUtanMvcHJvbWlzZS5qcyIsIm5vZGVfbW9kdWxlcy9iYWJlbC1ydW50aW1lL2NvcmUtanMvc3ltYm9sLmpzIiwibm9kZV9tb2R1bGVzL2JhYmVsLXJ1bnRpbWUvY29yZS1qcy9zeW1ib2wvaXRlcmF0b3IuanMiLCJub2RlX21vZHVsZXMvYmFiZWwtcnVudGltZS9oZWxwZXJzL2NsYXNzQ2FsbENoZWNrLmpzIiwibm9kZV9tb2R1bGVzL2JhYmVsLXJ1bnRpbWUvaGVscGVycy9jcmVhdGVDbGFzcy5qcyIsIm5vZGVfbW9kdWxlcy9iYWJlbC1ydW50aW1lL2hlbHBlcnMvZGVmaW5lUHJvcGVydHkuanMiLCJub2RlX21vZHVsZXMvYmFiZWwtcnVudGltZS9oZWxwZXJzL2V4dGVuZHMuanMiLCJub2RlX21vZHVsZXMvYmFiZWwtcnVudGltZS9oZWxwZXJzL2luaGVyaXRzLmpzIiwibm9kZV9tb2R1bGVzL2JhYmVsLXJ1bnRpbWUvaGVscGVycy9wb3NzaWJsZUNvbnN0cnVjdG9yUmV0dXJuLmpzIiwibm9kZV9tb2R1bGVzL2JhYmVsLXJ1bnRpbWUvaGVscGVycy9zbGljZWRUb0FycmF5LmpzIiwibm9kZV9tb2R1bGVzL2JhYmVsLXJ1bnRpbWUvaGVscGVycy90eXBlb2YuanMiLCJub2RlX21vZHVsZXMvYmFiZWwtcnVudGltZS9yZWdlbmVyYXRvci9pbmRleC5qcyIsIm5vZGVfbW9kdWxlcy9icm93c2VyLXJlc29sdmUvZW1wdHkuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L2ZuL2dldC1pdGVyYXRvci5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvZm4vaXMtaXRlcmFibGUuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L2ZuL2pzb24vc3RyaW5naWZ5LmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9mbi9vYmplY3QvYXNzaWduLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9mbi9vYmplY3QvY3JlYXRlLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9mbi9vYmplY3QvZGVmaW5lLXByb3BlcnR5LmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9mbi9vYmplY3QvZ2V0LXByb3RvdHlwZS1vZi5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvZm4vb2JqZWN0L2tleXMuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L2ZuL29iamVjdC9zZXQtcHJvdG90eXBlLW9mLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9mbi9wcm9taXNlLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9mbi9zeW1ib2wvaW5kZXguanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L2ZuL3N5bWJvbC9pdGVyYXRvci5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9fYS1mdW5jdGlvbi5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9fYWRkLXRvLXVuc2NvcGFibGVzLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL19hbi1pbnN0YW5jZS5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9fYW4tb2JqZWN0LmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL19hcnJheS1pbmNsdWRlcy5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9fY2xhc3NvZi5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9fY29mLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL19jb3JlLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL19jdHguanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX2RlZmluZWQuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX2Rlc2NyaXB0b3JzLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL19kb20tY3JlYXRlLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL19lbnVtLWJ1Zy1rZXlzLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL19lbnVtLWtleXMuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX2V4cG9ydC5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9fZmFpbHMuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX2Zvci1vZi5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9fZ2xvYmFsLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL19oYXMuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX2hpZGUuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX2h0bWwuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX2llOC1kb20tZGVmaW5lLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL19pbnZva2UuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX2lvYmplY3QuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX2lzLWFycmF5LWl0ZXIuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX2lzLWFycmF5LmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL19pcy1vYmplY3QuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX2l0ZXItY2FsbC5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9faXRlci1jcmVhdGUuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX2l0ZXItZGVmaW5lLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL19pdGVyLWRldGVjdC5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9faXRlci1zdGVwLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL19pdGVyYXRvcnMuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX2tleW9mLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL19saWJyYXJ5LmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL19tZXRhLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL19taWNyb3Rhc2suanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX29iamVjdC1hc3NpZ24uanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX29iamVjdC1jcmVhdGUuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX29iamVjdC1kcC5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9fb2JqZWN0LWRwcy5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9fb2JqZWN0LWdvcGQuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX29iamVjdC1nb3BuLWV4dC5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9fb2JqZWN0LWdvcG4uanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX29iamVjdC1nb3BzLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL19vYmplY3QtZ3BvLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL19vYmplY3Qta2V5cy1pbnRlcm5hbC5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9fb2JqZWN0LWtleXMuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX29iamVjdC1waWUuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX29iamVjdC1zYXAuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX3Byb3BlcnR5LWRlc2MuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX3JlZGVmaW5lLWFsbC5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9fcmVkZWZpbmUuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX3NldC1wcm90by5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9fc2V0LXNwZWNpZXMuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX3NldC10by1zdHJpbmctdGFnLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL19zaGFyZWQta2V5LmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL19zaGFyZWQuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX3NwZWNpZXMtY29uc3RydWN0b3IuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX3N0cmluZy1hdC5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9fdGFzay5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9fdG8taW5kZXguanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX3RvLWludGVnZXIuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX3RvLWlvYmplY3QuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX3RvLWxlbmd0aC5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9fdG8tb2JqZWN0LmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL190by1wcmltaXRpdmUuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvX3VpZC5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9fd2tzLWRlZmluZS5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9fd2tzLWV4dC5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9fd2tzLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL2NvcmUuZ2V0LWl0ZXJhdG9yLW1ldGhvZC5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9jb3JlLmdldC1pdGVyYXRvci5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9jb3JlLmlzLWl0ZXJhYmxlLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL2VzNi5hcnJheS5pdGVyYXRvci5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9lczYub2JqZWN0LmFzc2lnbi5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9lczYub2JqZWN0LmNyZWF0ZS5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9lczYub2JqZWN0LmRlZmluZS1wcm9wZXJ0eS5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9lczYub2JqZWN0LmdldC1wcm90b3R5cGUtb2YuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvZXM2Lm9iamVjdC5rZXlzLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL2VzNi5vYmplY3Quc2V0LXByb3RvdHlwZS1vZi5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9lczYucHJvbWlzZS5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9lczYuc3RyaW5nLml0ZXJhdG9yLmpzIiwibm9kZV9tb2R1bGVzL2NvcmUtanMvbGlicmFyeS9tb2R1bGVzL2VzNi5zeW1ib2wuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvZXM3LnN5bWJvbC5hc3luYy1pdGVyYXRvci5qcyIsIm5vZGVfbW9kdWxlcy9jb3JlLWpzL2xpYnJhcnkvbW9kdWxlcy9lczcuc3ltYm9sLm9ic2VydmFibGUuanMiLCJub2RlX21vZHVsZXMvY29yZS1qcy9saWJyYXJ5L21vZHVsZXMvd2ViLmRvbS5pdGVyYWJsZS5qcyIsIm5vZGVfbW9kdWxlcy9lczYtb2JqZWN0LWFzc2lnbi9pbmRleC5qcyIsIm5vZGVfbW9kdWxlcy9lczYtcHJvbWlzZS1wb2x5ZmlsbC9wcm9taXNlLmpzIiwibm9kZV9tb2R1bGVzL2VzNi1wcm9taXNlL2Rpc3QvZXM2LXByb21pc2UuanMiLCJub2RlX21vZHVsZXMvZXM2LXByb21pc2lmeS9kaXN0L3Byb21pc2UuanMiLCJub2RlX21vZHVsZXMvZXM2LXByb21pc2lmeS9kaXN0L3Byb21pc2lmeS5qcyIsIm5vZGVfbW9kdWxlcy9pbWEuanMtYmFiZWw2LXBvbHlmaWxsL2luZGV4LmpzIiwibm9kZV9tb2R1bGVzL21kNS1vLW1hdGljL2xpYi9tZDVvbWF0aWMuanMiLCJub2RlX21vZHVsZXMvbWVtb2l6ZS1jYWNoZS11dGlscy9rZXktZ2V0dGVyLmpzIiwibm9kZV9tb2R1bGVzL21vZHVsZS10c2wtZXJyb3ItbWlkZGxld2FyZXMvc3JjL21pbmlqb2kuanMiLCJub2RlX21vZHVsZXMvbW9kdWxlLXRzbC11aS1jb21wb25lbnRzL2VzNS9jb21wb25lbnRzL3NpbXBsZS1kYXRlL1NpbXBsZURhdGUuanMiLCJub2RlX21vZHVsZXMvcHJvY2Vzcy9icm93c2VyLmpzIiwibm9kZV9tb2R1bGVzL3JlZHV4LXNhZ2EvZWZmZWN0cy5qcyIsIm5vZGVfbW9kdWxlcy9yZWR1eC1zYWdhL2xpYi9lZmZlY3RzLmpzIiwibm9kZV9tb2R1bGVzL3JlZHV4LXNhZ2EvbGliL2luZGV4LmpzIiwibm9kZV9tb2R1bGVzL3JlZHV4LXNhZ2EvbGliL2ludGVybmFsL2FzYXAuanMiLCJub2RlX21vZHVsZXMvcmVkdXgtc2FnYS9saWIvaW50ZXJuYWwvYnVmZmVycy5qcyIsIm5vZGVfbW9kdWxlcy9yZWR1eC1zYWdhL2xpYi9pbnRlcm5hbC9jaGFubmVsLmpzIiwibm9kZV9tb2R1bGVzL3JlZHV4LXNhZ2EvbGliL2ludGVybmFsL2lvLmpzIiwibm9kZV9tb2R1bGVzL3JlZHV4LXNhZ2EvbGliL2ludGVybmFsL21pZGRsZXdhcmUuanMiLCJub2RlX21vZHVsZXMvcmVkdXgtc2FnYS9saWIvaW50ZXJuYWwvcHJvYy5qcyIsIm5vZGVfbW9kdWxlcy9yZWR1eC1zYWdhL2xpYi9pbnRlcm5hbC9ydW5TYWdhLmpzIiwibm9kZV9tb2R1bGVzL3JlZHV4LXNhZ2EvbGliL2ludGVybmFsL3NhZ2FIZWxwZXJzLmpzIiwibm9kZV9tb2R1bGVzL3JlZHV4LXNhZ2EvbGliL2ludGVybmFsL3V0aWxzLmpzIiwibm9kZV9tb2R1bGVzL3JlZHV4LXNhZ2EvbGliL3V0aWxzLmpzIiwibm9kZV9tb2R1bGVzL3JlZ2VuZXJhdG9yLXJ1bnRpbWUvcnVudGltZS1tb2R1bGUuanMiLCJub2RlX21vZHVsZXMvcmVnZW5lcmF0b3ItcnVudGltZS9ydW50aW1lLmpzIiwibm9kZV9tb2R1bGVzL3JlcXdlc3QvcmVxd2VzdC5qcyIsIm5vZGVfbW9kdWxlcy9zdHJpbmcucHJvdG90eXBlLnN0YXJ0c3dpdGgvc3RhcnRzd2l0aC5qcyIsInNyYy9hcHAvZG9tYWluL2Vycm9yTWVzc2FnZXMuanMiLCJzcmMvdWkvY29tcG9uZW50cy9BcHAuanN4Iiwic3JjL3VpL2NvbXBvbmVudHMvRm9yZ290UGFzc3dvcmQuanN4Iiwic3JjL3VpL2NvbXBvbmVudHMvTG9nZ2VkSW5TZWxlY3RQb3NpdGlvbi5qc3giLCJzcmMvdWkvY29tcG9uZW50cy9Mb2dnZWRJblVwZGF0ZS5qc3giLCJzcmMvdWkvY29tcG9uZW50cy9SZWdpc3Rlci5qc3giLCJzcmMvdWkvY29tcG9uZW50cy9TZWxlY3RGb3JtUG9zaXRpb24uanN4Iiwic3JjL3VpL2NvbXBvbmVudHMvU2VsZWN0UG9zaXRpb24uanN4Iiwic3JjL3VpL2NvbXBvbmVudHMvU2lnbmluLmpzeCIsInNyYy91aS9jb21wb25lbnRzL2xpYi9CcmFuZGluZy5qc3giLCJzcmMvdWkvY29tcG9uZW50cy9saWIvQnV0dG9uU2VsZWN0LmpzeCIsInNyYy91aS9jb21wb25lbnRzL2xpYi9DdXN0b21TZWxlY3QuanN4Iiwic3JjL3VpL2NvbXBvbmVudHMvbGliL0hpZGRlbklucHV0cy5qc3giLCJzcmMvdWkvY29tcG9uZW50cy9saWIvSW5wdXRGaWVsZC5qc3giLCJzcmMvdWkvY29tcG9uZW50cy9saWIvV2lkZ2V0TGluay5qc3giLCJzcmMvdWkvbGliL2FwaS5qcyIsInNyYy91aS9saWIvZGF0ZS1oZWxwZXIuanMiLCJzcmMvdWkvbGliL2RlbmllZC1lcnJvcmNvZGUuanMiLCJzcmMvdWkvbGliL2dldEVycm9yRnJvbVByZWZpeC5qcyIsInNyYy91aS9saWIvcG9zaXRpb24tZmlsdGVyLmpzIiwic3JjL3VpL2xpYi90cmFja2luZy5qcyIsInNyYy91aS9saWIvdHJhdmVyc2Utb2JqZWN0LmpzIiwic3JjL3VpL3JlZHVjZXJzL2FjdGlvbnMuanMiLCJzcmMvdWkvcmVkdWNlcnMvY29uc3RhbnRzLmpzIiwic3JjL3VpL3JlZHVjZXJzL2luZGV4LmpzIiwic3JjL3VpL3NhZ2FzL2luZGV4LmpzIiwic3JjL3VpL3NhZ2FzL3V0aWxzLmpzIiwic3JjL3VpL3dpZGdldHMvd2lkZ2V0LWF1dGhhcHAuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7QUNBQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ1ZBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDVkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDakNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ3JCQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUN6REE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNsQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOzs7QUNSQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7Ozs7QUMzR0E7QUFDQTtBQUNBOztBQ0ZBO0FBQ0E7QUFDQTs7QUNGQTtBQUNBO0FBQ0E7O0FDRkE7QUFDQTtBQUNBOztBQ0ZBO0FBQ0E7QUFDQTs7QUNGQTtBQUNBO0FBQ0E7O0FDRkE7QUFDQTtBQUNBOztBQ0ZBO0FBQ0E7QUFDQTs7QUNGQTtBQUNBO0FBQ0E7O0FDRkE7QUFDQTtBQUNBOztBQ0ZBO0FBQ0E7QUFDQTs7QUNGQTtBQUNBO0FBQ0E7O0FDRkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNWQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQzVCQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ3pCQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUN4QkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNsQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDbEJBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDcERBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDdEJBO0FBQ0E7QUFDQTtBQUNBOztBQ0hBO0FBQ0E7QUFDQTs7QUNGQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ0pBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDSkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDTkE7QUFDQTtBQUNBO0FBQ0E7O0FDSEE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDTkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDTkE7QUFDQTtBQUNBO0FBQ0E7O0FDSEE7QUFDQTtBQUNBO0FBQ0E7O0FDSEE7QUFDQTtBQUNBO0FBQ0E7O0FDSEE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDTkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDTkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNKQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDTEE7QUFDQTtBQUNBOztBQ0ZBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ05BO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ05BO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDdEJBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ3hCQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNOQTtBQUNBO0FBQ0E7QUFDQTs7QUNIQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNyQkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDTkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ0xBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNSQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDTEE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNoQkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQzlEQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDUkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQzFCQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDTEE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ0xBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ1RBO0FBQ0E7QUFDQTs7QUNGQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ0pBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNqQkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDTkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDVEE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDTkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNKQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ2JBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNkQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDdkVBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDdEJBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDSkE7QUFDQTtBQUNBOztBQ0ZBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNYQTtBQUNBO0FBQ0E7O0FDRkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDdERBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ3JFQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ2xDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQzNDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDakJBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNkQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDakJBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ3JCQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDUkE7QUFDQTtBQUNBOztBQ0ZBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNkQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNsQkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ1JBO0FBQ0E7QUFDQTs7QUNGQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDWEE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDVEE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ1JBO0FBQ0E7QUFDQTs7QUNGQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDMUJBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ2ZBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNSQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNOQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ1BBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ1RBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ2xCQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQzVFQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDUkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNQQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ1BBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDUEE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDTkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNiQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNOQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ1ZBO0FBQ0E7QUFDQTs7QUNGQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNaQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNUQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDUkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNWQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDbkNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNMQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ0pBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDSkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUNWQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ1ZBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7Ozs7QUNKQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUM1U0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDbEJBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUM1T0E7QUFDQTtBQUNBOztBQ0ZBO0FBQ0E7QUFDQTs7QUNGQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDZEE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7OztBQ2hEQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7Ozs7QUM1VkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7Ozs7O0FDbm9DQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7OztBQzNFQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUMxRkE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ2pCQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQzFNQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ3pCQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDL0ZBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ3pNQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUMxTEE7QUFDQTtBQUNBOztBQ0ZBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ25HQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUN0R0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FDOUJBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7OztBQzdHQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOzs7O0FDOUxBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7OztBQzFQQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7Ozs7QUMzRUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOzs7O0FDcHVCQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQzVCQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQ3pLQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUM1TUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7OztBQ3REQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7Ozs7QUNqQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7Ozs7QUNsdUJBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUN4bkJBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOzs7Ozs7Ozs7Ozs7OztBQ3pEQSxJQUFNLFNBQVM7QUFDYjtBQUNBLDBCQUF3QjtBQUN0Qix1QkFBbUI7QUFDakIsV0FBSyx1Q0FEWTtBQUVqQixhQUFPO0FBRlUsS0FERztBQUt0Qix1QkFBbUI7QUFDakIsV0FBSyxFQURZO0FBRWpCLGFBQU87QUFGVTtBQUxHLEdBRlg7QUFZYix5QkFBdUI7QUFDckIsdUJBQW1CO0FBQ2pCLFdBQUssdUNBRFk7QUFFakIsYUFBTztBQUZVLEtBREU7QUFLckIsdUJBQW1CO0FBQ2pCLFdBQUssRUFEWTtBQUVqQixhQUFPO0FBRlU7QUFMRSxHQVpWO0FBc0JiLHlCQUF1QjtBQUNyQix1QkFBbUI7QUFDakIsV0FBSyx1REFEWTtBQUVqQixhQUFPO0FBRlUsS0FERTtBQUtyQix1QkFBbUI7QUFDakIsV0FBSyxFQURZO0FBRWpCLGFBQU87QUFGVTtBQUxFLEdBdEJWO0FBZ0NiLDJCQUF5QjtBQUN2Qix1QkFBbUI7QUFDakIsV0FBSyxzREFEWTtBQUVqQixhQUFPO0FBRlUsS0FESTtBQUt2Qix1QkFBbUI7QUFDakIsV0FBSyxFQURZO0FBRWpCLGFBQU87QUFGVTtBQUxJLEdBaENaO0FBMENiLG1CQUFpQjtBQUNmLHVCQUFtQjtBQUNqQixXQUFLLDRCQURZO0FBRWpCLGFBQU87QUFGVSxLQURKO0FBS2YsdUJBQW1CO0FBQ2pCLFdBQUssRUFEWTtBQUVqQixhQUFPO0FBRlU7QUFMSixHQTFDSjtBQW9EYix3QkFBc0I7QUFDcEIsdUJBQW1CO0FBQ2pCLFdBQUssaUNBRFk7QUFFakIsYUFBTztBQUZVLEtBREM7QUFLcEIsdUJBQW1CO0FBQ2pCLFdBQUssRUFEWTtBQUVqQixhQUFPO0FBRlU7QUFMQyxHQXBEVDtBQThEYixtQ0FBaUM7QUFDL0IsdUJBQW1CO0FBQ2pCLFdBQUssb0RBRFk7QUFFakIsYUFBTztBQUZVLEtBRFk7QUFLL0IsdUJBQW1CO0FBQ2pCLFdBQUssRUFEWTtBQUVqQixhQUFPO0FBRlU7QUFMWSxHQTlEcEI7QUF3RWIsdUJBQXFCO0FBQ25CLHVCQUFtQjtBQUNqQixXQUFLLGdDQURZO0FBRWpCLGFBQU87QUFGVSxLQURBO0FBS25CLHVCQUFtQjtBQUNqQixXQUFLLEVBRFk7QUFFakIsYUFBTztBQUZVO0FBTEEsR0F4RVI7QUFrRmIscUNBQW1DO0FBQ2pDLHVCQUFtQjtBQUNqQixXQUFLLDZCQURZO0FBRWpCLGFBQU87QUFGVTtBQURjLEdBbEZ0QjtBQXdGYiwrQkFBNkI7QUFDM0IsdUJBQW1CO0FBQ2pCLFdBQUssNkJBRFk7QUFFakIsYUFBTztBQUZVO0FBRFEsR0F4RmhCO0FBOEZiLHdDQUFzQztBQUNwQyx1QkFBbUI7QUFDakIsV0FBSyx3REFEWTtBQUVqQixhQUFPO0FBRlU7QUFEaUIsR0E5RnpCO0FBb0diLGlDQUErQjtBQUM3Qix1QkFBbUI7QUFDakIsV0FBSywrQ0FEWTtBQUVqQixhQUFPO0FBRlU7QUFEVSxHQXBHbEI7QUEwR2I7QUFDQSxnQ0FBOEI7QUFDNUIsNkJBQXlCO0FBQ3ZCLFdBQUssdUNBRGtCO0FBRXZCLGFBQU87QUFGZ0I7QUFERyxHQTNHakI7QUFpSGIsK0JBQTZCO0FBQzNCLDZCQUF5QjtBQUN2QixXQUFLLHdFQURrQjtBQUV2QixhQUFPO0FBRmdCO0FBREUsR0FqSGhCO0FBdUhiLHdCQUFzQjtBQUNwQiw2QkFBeUI7QUFDdkIsV0FBSywwQkFEa0I7QUFFdkIsYUFBTztBQUZnQjtBQURMLEdBdkhUO0FBNkhiLHFDQUFtQztBQUNqQyw2QkFBeUI7QUFDdkIsV0FBSywyQkFEa0I7QUFFdkIsYUFBTztBQUZnQjtBQURRLEdBN0h0QjtBQW1JYixzQ0FBb0M7QUFDbEMsNkJBQXlCO0FBQ3ZCLFdBQUssbURBRGtCO0FBRXZCLGFBQU87QUFGZ0I7QUFEUyxHQW5JdkI7QUF5SWIsc0NBQW9DO0FBQ2xDLDZCQUF5QjtBQUN2QixXQUFLLG9EQURrQjtBQUV2QixhQUFPO0FBRmdCO0FBRFMsR0F6SXZCO0FBK0liLGtDQUFnQztBQUM5QiwwQkFBc0I7QUFDcEIsV0FBSyxpREFEZTtBQUVwQixhQUFPO0FBRmE7QUFEUSxHQS9JbkI7QUFxSmIscUNBQW1DO0FBQ2pDLDBCQUFzQjtBQUNwQixXQUFLLHFDQURlO0FBRXBCLGFBQU87QUFGYTtBQURXLEdBckp0QjtBQTJKYixrQ0FBZ0M7QUFDOUIsMEJBQXNCO0FBQ3BCLFdBQUssZ0NBRGU7QUFFcEIsYUFBTztBQUZhO0FBRFEsR0EzSm5CO0FBaUtiLDZDQUEyQztBQUN6Qyw2QkFBeUI7QUFDdkIsV0FBSyx3RUFEa0I7QUFFdkIsYUFBTztBQUZnQjtBQURnQixHQWpLOUI7QUF1S2IscUNBQW1DO0FBQ2pDLDZCQUF5QjtBQUN2QixXQUFLLHVDQURrQjtBQUV2QixhQUFPO0FBRmdCO0FBRFEsR0F2S3RCO0FBNktiLHFDQUFtQztBQUNqQyw2QkFBeUI7QUFDdkIsV0FBSywyQkFEa0I7QUFFdkIsYUFBTztBQUZnQjtBQURRLEdBN0t0QjtBQW1MYixzQ0FBb0M7QUFDbEMsNkJBQXlCO0FBQ3ZCLFdBQUsscURBRGtCO0FBRXZCLGFBQU87QUFGZ0I7QUFEUyxHQW5MdkI7QUF5TGIsc0NBQW9DO0FBQ2xDLDhCQUEwQjtBQUN4QixXQUFLLGlDQURtQjtBQUV4QixhQUFPO0FBRmlCO0FBRFEsR0F6THZCO0FBK0xiLHFDQUFtQztBQUNqQyw2QkFBeUI7QUFDdkIsV0FBSyxnQ0FEa0I7QUFFdkIsYUFBTztBQUZnQjtBQURRLEdBL0x0QjtBQXFNYix5Q0FBdUM7QUFDckM7QUFEcUMsR0FyTTFCO0FBd01iLHNDQUFvQztBQUNsQyxnQ0FBNEI7QUFDMUIsV0FBSyx3QkFEcUI7QUFFMUIsYUFBTztBQUZtQjtBQURNLEdBeE12QjtBQThNYixxQ0FBbUM7QUFDakMsZ0NBQTRCO0FBQzFCLFdBQUssOENBRHFCO0FBRTFCLGFBQU87QUFGbUI7QUFESyxHQTlNdEI7QUFvTmIsdUNBQXFDO0FBQ25DLGdDQUE0QjtBQUMxQixXQUFLLHFDQURxQjtBQUUxQixhQUFPO0FBRm1CO0FBRE8sR0FwTnhCO0FBME5iLHFDQUFtQztBQUNqQyxnQ0FBNEI7QUFDMUIsV0FBSywwQ0FEcUI7QUFFMUIsYUFBTztBQUZtQjtBQURLLEdBMU50QjtBQWdPYiw2Q0FBMkM7QUFDekMsa0NBQThCO0FBQzVCLFdBQUssNkNBRHVCO0FBRTVCLGFBQU87QUFGcUI7QUFEVyxHQWhPOUI7QUFzT2IsMENBQXdDO0FBQ3RDLGtDQUE4QjtBQUM1QixXQUFLLGlFQUR1QjtBQUU1QixhQUFPO0FBRnFCO0FBRFEsR0F0TzNCO0FBNE9iLHNDQUFvQztBQUNsQyw4QkFBMEI7QUFDeEIsV0FBSyxzRUFEbUI7QUFFeEIsYUFBTztBQUZpQjtBQURRLEdBNU92QjtBQWtQYixvQ0FBa0M7QUFDaEMsOEJBQTBCO0FBQ3hCLFdBQUssd0NBRG1CO0FBRXhCLGFBQU87QUFGaUI7QUFETSxHQWxQckI7QUF3UGI7QUFDQSwwQkFBd0I7QUFDdEIsNEJBQXdCO0FBQ3RCLFdBQUssZUFEaUI7QUFFdEIsYUFBTztBQUZlO0FBREYsR0F6UFg7QUErUGIseUJBQXVCO0FBQ3JCLDRCQUF3QjtBQUN0QixXQUFLLDhDQURpQjtBQUV0QixhQUFPO0FBRmU7QUFESCxHQS9QVjtBQXFRYiwyQkFBeUI7QUFDdkIsNEJBQXdCO0FBQ3RCLFdBQUssZ0RBRGlCO0FBRXRCLGFBQU87QUFGZTtBQURELEdBclFaO0FBMlFiLHlCQUF1QjtBQUNyQiw0QkFBd0I7QUFDdEIsV0FBSyxtQ0FEaUI7QUFFdEIsYUFBTztBQUZlO0FBREgsR0EzUVY7QUFpUmIsMkJBQXlCO0FBQ3ZCLDRCQUF3QjtBQUN0QixXQUFLLHFDQURpQjtBQUV0QixhQUFPO0FBRmU7QUFERCxHQWpSWjtBQXVSYiwwQkFBd0I7QUFDdEIsNEJBQXdCO0FBQ3RCLFdBQUsscUZBRGlCO0FBRXRCLGFBQU87QUFGZTtBQURGLEdBdlJYO0FBNlJiLDRCQUEwQjtBQUN4Qiw0QkFBd0I7QUFDdEIsV0FBSyx1RkFEaUI7QUFFdEIsYUFBTztBQUZlO0FBREEsR0E3UmI7QUFtU2Isc0JBQW9CO0FBQ2xCLDRCQUF3QjtBQUN0QixXQUFLLHVEQURpQjtBQUV0QixhQUFPO0FBRmU7QUFETixHQW5TUDtBQXlTYix3QkFBc0I7QUFDcEIsNEJBQXdCO0FBQ3RCLFdBQUsseURBRGlCO0FBRXRCLGFBQU87QUFGZTtBQURKLEdBelNUO0FBK1NiO0FBQ0EsbUNBQWlDO0FBQy9CLHNDQUFrQztBQUNoQyxXQUFLLHVDQUQyQjtBQUVoQyxhQUFPO0FBRnlCO0FBREgsR0FoVHBCO0FBc1RiLGtDQUFnQztBQUM5QixzQ0FBa0M7QUFDaEMsV0FBSyxrRkFEMkI7QUFFaEMsYUFBTztBQUZ5QjtBQURKLEdBdFRuQjtBQTRUYix3Q0FBc0M7QUFDcEMsc0NBQWtDO0FBQ2hDLFdBQUssa0NBRDJCO0FBRWhDLGFBQU87QUFGeUI7QUFERSxHQTVUekI7QUFrVWIscUNBQW1DO0FBQ2pDLHNDQUFrQztBQUNoQyxXQUFLLGtDQUQyQjtBQUVoQyxhQUFPO0FBRnlCO0FBREQsR0FsVXRCO0FBd1ViLG9DQUFrQztBQUNoQyxzQ0FBa0M7QUFDaEMsV0FBSyxnREFEMkI7QUFFaEMsYUFBTztBQUZ5QjtBQURGLEdBeFVyQjtBQThVYixvQ0FBa0M7QUFDaEMsc0NBQWtDO0FBQ2hDLFdBQUssc0RBRDJCO0FBRWhDLGFBQU87QUFGeUI7QUFERixHQTlVckI7QUFvVmIsNEJBQTBCO0FBQ3hCLHNDQUFrQztBQUNoQyxXQUFLLDRCQUQyQjtBQUVoQyxhQUFPO0FBRnlCO0FBRFYsR0FwVmI7QUEwVmIsaUNBQStCO0FBQzdCLHNDQUFrQztBQUNoQyxXQUFLLGlDQUQyQjtBQUVoQyxhQUFPO0FBRnlCO0FBREwsR0ExVmxCO0FBZ1diLDRDQUEwQztBQUN4QyxzQ0FBa0M7QUFDaEMsV0FBSyxvREFEMkI7QUFFaEMsYUFBTztBQUZ5QjtBQURNLEdBaFc3QjtBQXNXYixnQ0FBOEI7QUFDNUIsc0NBQWtDO0FBQ2hDLFdBQUssZ0NBRDJCO0FBRWhDLGFBQU87QUFGeUI7QUFETixHQXRXakI7QUE0V2I7QUFDQSw2Q0FBMkM7QUFDekMsZUFBVyxJQUQ4QjtBQUV6QyxpQ0FBNkI7QUFDM0IsV0FBSyx1Q0FEc0I7QUFFM0IsYUFBTztBQUZvQjtBQUZZLEdBN1c5QjtBQW9YYiwrQ0FBNkM7QUFDM0MsZUFBVyxJQURnQztBQUUzQyxpQ0FBNkI7QUFDM0IsV0FBSyxnQ0FEc0I7QUFFM0IsYUFBTztBQUZvQjtBQUZjLEdBcFhoQztBQTJYYixrREFBZ0Q7QUFDOUMsZUFBVyxJQURtQztBQUU5QyxpQ0FBNkI7QUFDM0IsV0FBSyxxQ0FEc0I7QUFFM0IsYUFBTztBQUZvQjtBQUZpQixHQTNYbkM7QUFrWWIsK0NBQTZDO0FBQzNDLGVBQVcsSUFEZ0M7QUFFM0MsYUFBUztBQUZrQyxHQWxZaEM7QUFzWWIsa0NBQWdDO0FBQzlCLGVBQVcsSUFEbUI7QUFFOUIsc0JBQWtCO0FBQ2hCLFdBQUssNERBRFc7QUFFaEIsYUFBTztBQUZTO0FBRlksR0F0WW5CO0FBNlliO0FBQ0Esa0NBQWdDO0FBQzlCLGVBQVcsSUFEbUI7QUFFOUIsc0JBQWtCO0FBQ2hCLFdBQUssMEVBRFc7QUFFaEIsYUFBTztBQUZTO0FBRlksR0E5WW5CO0FBcVpiLGlDQUErQjtBQUM3QixlQUFXLElBRGtCO0FBRTdCLHNCQUFrQjtBQUNoQixXQUFLLDBFQURXO0FBRWhCLGFBQU87QUFGUztBQUZXLEdBclpsQjtBQTRaYixnQ0FBOEI7QUFDNUIsZUFBVyxJQURpQjtBQUU1QixzQkFBa0I7QUFDaEIsV0FBSyxvRUFEVztBQUVoQixhQUFPO0FBRlM7QUFGVSxHQTVaakI7QUFtYWIsMkJBQXlCO0FBQ3ZCLGVBQVcsSUFEWTtBQUV2QixzQkFBa0I7QUFDaEIsV0FBSywyRUFEVztBQUVoQixhQUFPO0FBRlM7QUFGSyxHQW5hWjtBQTBhYiw0QkFBMEI7QUFDeEIsZUFBVyxJQURhO0FBRXhCLHNCQUFrQjtBQUNoQixXQUFLLCtEQURXO0FBRWhCLGFBQU87QUFGUztBQUZNLEdBMWFiO0FBaWJiLG9DQUFrQztBQUNoQyxlQUFXLElBRHFCO0FBRWhDLGFBQVM7QUFGdUIsR0FqYnJCO0FBcWJiLGdDQUE4QjtBQUM1Qiw2QkFBeUI7QUFDdkIsV0FBSyx5RUFEa0I7QUFFdkIsYUFBTztBQUZnQixLQURHO0FBSzVCLDRCQUF3QjtBQUN0QixXQUFLLHlFQURpQjtBQUV0QixhQUFPO0FBRmU7QUFMSSxHQXJiakI7QUErYmIseUNBQXVDO0FBQ3JDLDZCQUF5QjtBQUN2QixXQUFLLCtDQURrQjtBQUV2QixhQUFPO0FBRmdCO0FBRFksR0EvYjFCO0FBcWNiLHNDQUFvQztBQUNsQyw4QkFBMEI7QUFDeEIsV0FBSyxpQ0FEbUI7QUFFeEIsYUFBTztBQUZpQjtBQURRLEdBcmN2QjtBQTJjYixxQ0FBbUM7QUFDakMsNkJBQXlCO0FBQ3ZCLFdBQUssZ0NBRGtCO0FBRXZCLGFBQU87QUFGZ0I7QUFEUSxHQTNjdEI7QUFpZGIsa0NBQWdDO0FBQzlCLDBCQUFzQjtBQUNwQixXQUFLLGlEQURlO0FBRXBCLGFBQU87QUFGYTtBQURRLEdBamRuQjtBQXVkYixxQ0FBbUM7QUFDakMsMEJBQXNCO0FBQ3BCLFdBQUsscUNBRGU7QUFFcEIsYUFBTztBQUZhO0FBRFcsR0F2ZHRCO0FBNmRiLGtDQUFnQztBQUM5QiwwQkFBc0I7QUFDcEIsV0FBSyxrQ0FEZTtBQUVwQixhQUFPO0FBRmE7QUFEUSxHQTdkbkI7QUFtZWIsbUNBQWlDO0FBQy9CLGdDQUE0QjtBQUMxQixXQUFLLHlFQURxQjtBQUUxQixhQUFPO0FBRm1CO0FBREcsR0FuZXBCO0FBeWViLHlDQUF1QztBQUNyQyxnQ0FBNEI7QUFDMUIsV0FBSyxxREFEcUI7QUFFMUIsYUFBTztBQUZtQjtBQURTLEdBemUxQjtBQStlYix1Q0FBcUM7QUFDbkMsbUNBQStCO0FBQzdCLFdBQUssNkRBRHdCO0FBRTdCLGFBQU87QUFGc0I7QUFESSxHQS9leEI7QUFxZmIsa0NBQWdDO0FBQzlCLGdDQUE0QjtBQUMxQixXQUFLLHdEQURxQjtBQUUxQixhQUFPO0FBRm1CO0FBREUsR0FyZm5CO0FBMmZiLHdCQUFzQjtBQUNwQiwrQkFBMkI7QUFDekIsV0FBSyw2Q0FEb0I7QUFFekIsYUFBTztBQUZrQjtBQURQO0FBM2ZULENBQWY7O2tCQW1nQmUsVUFBQyxLQUFELEVBQVc7QUFDeEIsTUFBSSxDQUFDLEtBQUwsRUFBWSxPQUFPLEVBQVA7QUFDWixNQUFNLGFBQWEsTUFBTSxLQUFOLENBQVksR0FBWixDQUFuQjtBQUNBLE1BQU0sa0JBQWtCLFdBQ3JCLE1BRHFCLENBQ2Q7QUFBQSxXQUFRLFFBQVEsTUFBaEI7QUFBQSxHQURjLENBQXhCOztBQUdBLE1BQUksZ0JBQWdCLE1BQWhCLEtBQTJCLENBQS9CLEVBQWtDO0FBQ2hDLFFBQU0sU0FBUyxXQUFXLENBQVgsRUFBYyxLQUFkLENBQW9CLEdBQXBCLEVBQXlCLENBQXpCLENBQWY7QUFDQSxvQkFBZ0IsSUFBaEIsQ0FBd0IsTUFBeEI7QUFDRDs7QUFFRCxTQUFPLGdCQUNKLEdBREksQ0FDQTtBQUFBLFdBQVEsT0FBTyxJQUFQLENBQVI7QUFBQSxHQURBLEVBRUosTUFGSSxDQUVHLFVBQUMsUUFBRCxFQUFXLE9BQVg7QUFBQSxXQUF1QixzQkFBYyxFQUFkLEVBQWtCLFFBQWxCLEVBQTRCLE9BQTVCLENBQXZCO0FBQUEsR0FGSCxFQUVnRSxFQUZoRSxDQUFQO0FBR0QsQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUNqaEJEOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0lBQVksYzs7Ozs7O0FBRVosU0FBUyxpQkFBVCxPQUFxRTtBQUFBLE1BQXhDLFVBQXdDLFFBQXhDLFVBQXdDO0FBQUEsTUFBNUIsY0FBNEIsUUFBNUIsY0FBNEI7QUFBQSxNQUFaLFFBQVksUUFBWixRQUFZOztBQUNuRSxNQUFJLENBQUMsVUFBTCxFQUFpQixPQUFPO0FBQUE7QUFBQSxNQUFLLE9BQU8sY0FBWjtBQUE2QjtBQUE3QixHQUFQO0FBQ2pCLFNBQ0U7QUFBQTtBQUFBLE1BQUssV0FBVSxpQkFBZjtBQUNHO0FBREgsR0FERjtBQUtEOztBQUVELGtCQUFrQixTQUFsQixHQUE4QjtBQUM1QixjQUFZLGlCQUFVLElBRE07QUFFNUIsa0JBQWdCLGlCQUFVO0FBRkUsQ0FBOUI7O0lBS2EsRyxXQUFBLEc7Ozs7Ozs7Ozs7d0NBQ1M7QUFDbEIsV0FBSyxLQUFMLENBQVcsT0FBWCxDQUFtQixZQUFuQixDQUFnQyxLQUFLLEtBQUwsQ0FBVyxNQUFYLENBQWtCLFFBQWxEO0FBQ0EsVUFBSSxDQUFDLEtBQUssS0FBTCxDQUFXLE1BQVgsQ0FBa0IsT0FBbkIsSUFBOEIsQ0FBQyxLQUFLLEtBQUwsQ0FBVyxNQUFYLENBQWtCLFFBQXJELEVBQStEO0FBQzdELGFBQUssS0FBTCxDQUFXLE9BQVgsQ0FBbUIsWUFBbkIsQ0FBZ0MsS0FBSyxLQUFMLENBQVcsTUFBM0M7QUFDQSxhQUFLLEtBQUwsQ0FBVyxPQUFYLENBQW1CLFVBQW5CLENBQThCLEtBQUssS0FBTCxDQUFXLE1BQXpDO0FBQ0Q7QUFDRjs7OzZCQUVRO0FBQUEsVUFDQyxPQURELEdBQ2EsS0FBSyxLQUFMLENBQVcsTUFEeEIsQ0FDQyxPQUREOztBQUVQLFVBQU0sY0FBYyxFQUFwQjtBQUNBLFVBQU0sYUFBYTtBQUNqQixtQkFBVztBQUFDLDJCQUFEO0FBQUEsWUFBbUIsWUFBWSxPQUEvQjtBQUF3QztBQUF4QyxTQURNO0FBRWpCLGtCQUFVO0FBQUMsMkJBQUQ7QUFBQSxZQUFtQixZQUFZLE9BQS9CO0FBQXdDO0FBQXhDLFNBRk87QUFHakIsMkJBQW1CO0FBQUMsMkJBQUQ7QUFBQSxZQUFtQixZQUFZLE9BQS9CO0FBQXdDO0FBQXhDLFNBSEY7QUFJakIsZ0JBQVE7QUFBQywyQkFBRDtBQUFBLFlBQW1CLFlBQVksS0FBL0IsRUFBc0MsZ0JBQWdCLFVBQVUsRUFBVixHQUFlLFdBQXJFO0FBQWtGLG9FQUFnQixTQUFTLG1CQUFNLENBQUUsQ0FBakMsRUFBbUMsUUFBTyxFQUExQyxFQUE2QyxRQUFPLEVBQXBEO0FBQWxGLFNBSlM7QUFLakIsNEJBQW9CO0FBQUMsMkJBQUQ7QUFBQSxZQUFtQixZQUFZLEtBQS9CO0FBQXNDO0FBQXRDLFNBTEg7QUFNakIsNEJBQW9CO0FBQUMsMkJBQUQ7QUFBQSxZQUFtQixZQUFZLE9BQS9CO0FBQXdDO0FBQXhDO0FBTkgsT0FBbkI7QUFRQSxVQUFNLFlBQVksV0FBVyxLQUFLLEtBQUwsQ0FBVyxNQUFYLENBQWtCLFFBQTdCLENBQWxCO0FBQ0EsYUFBUSxTQUFSO0FBQ0Q7Ozs7O0FBR0gsSUFBSSxTQUFKLEdBQWdCO0FBQ2QsVUFBUSxpQkFBVSxNQUFWLENBQWlCLFVBRFg7QUFFZCxVQUFRLGlCQUFVLE1BQVYsQ0FBaUIsVUFGWDtBQUdkLFVBQVEsaUJBQVUsTUFBVixDQUFpQixVQUhYO0FBSWQsWUFBVSxpQkFBVSxNQUFWLENBQWlCLFVBSmI7QUFLZCxrQkFBZ0IsaUJBQVUsTUFBVixDQUFpQjtBQUxuQixDQUFoQjs7QUFRQSxJQUFNLHFCQUFxQixTQUFyQixrQkFBcUIsQ0FBQyxRQUFEO0FBQUEsU0FBZTtBQUN4QyxhQUFTLCtCQUFtQixjQUFuQixFQUFtQyxRQUFuQztBQUQrQixHQUFmO0FBQUEsQ0FBM0I7O2tCQUllLHlCQUNkO0FBQUEsU0FBVTtBQUNSLFlBQVEsTUFBTSxNQUROO0FBRVIsWUFBUSxNQUFNLE1BRk47QUFHUixZQUFRLE1BQU0sTUFITjtBQUlSLGNBQVUsTUFBTSxRQUpSO0FBS1Isb0JBQWdCLE1BQU07QUFMZCxHQUFWO0FBQUEsQ0FEYyxFQVFkLGtCQVJjLEVBU2IsR0FUYSxDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUM5RGY7Ozs7QUFDQTs7QUFDQTs7QUFDQTs7QUFDQTs7SUFBWSxjOztBQUNaOzs7O0FBQ0E7Ozs7Ozs7O0FBRUEsSUFBTSxjQUFjLCtDQUFzQixpQkFBdEIsQ0FBcEI7QUFDQSxJQUFNLGNBQWMsK0NBQXNCLGlCQUF0QixDQUFwQjs7SUFFYSxjLFdBQUEsYzs7Ozs7Ozs7OztpQ0FFRSxDLEVBQUc7QUFDZCxRQUFFLGNBQUY7QUFDQSxXQUFLLEtBQUwsQ0FBVyxPQUFYLENBQW1CLGtCQUFuQjtBQUNEOzs7bUNBRWMsQyxFQUFHO0FBQ2hCLFFBQUUsY0FBRjtBQUNBLFdBQUssS0FBTCxDQUFXLE9BQVgsQ0FBbUIscUJBQW5CO0FBQ0Q7OzsrQkFFVTtBQUNULGFBQU8sS0FBSyxLQUFMLENBQVcsTUFBWCxHQUFvQixvQkFBWSxLQUFLLEtBQUwsQ0FBVyxNQUF2QixFQUErQixNQUEvQixDQUFzQyxVQUFDLENBQUQ7QUFBQSxlQUFPLEVBQUUsVUFBRixDQUFhLGtCQUFiLENBQVA7QUFBQSxPQUF0QyxFQUErRSxNQUEvRSxHQUF3RixDQUE1RyxHQUFnSCxLQUF2SDtBQUNEOzs7Z0NBRVcsTyxFQUFTLE8sRUFBUztBQUFBOztBQUM1QixVQUFNLDRCQUEwQixPQUFoQztBQUNBLFVBQU0sT0FBTyxRQUFRLEdBQVIsQ0FBWTtBQUFBLG1DQUF1QixDQUF2QjtBQUFBLE9BQVosS0FBMkMsRUFBeEQ7QUFDQSxhQUFPLFVBQUMsQ0FBRCxFQUFPO0FBQ1osWUFBTSxTQUFTLEVBQUUsTUFBakI7QUFDQSxlQUFLLEtBQUwsQ0FBVyxPQUFYLENBQW1CLFFBQW5CLENBQTRCLGdCQUE1QixFQUE4QyxPQUFPLElBQXJELEVBQTJELE9BQU8sS0FBbEU7QUFDQSxlQUFLLEtBQUwsQ0FBVyxPQUFYLENBQW1CLFdBQW5CLENBQStCLElBQS9CLEVBQXFDLElBQXJDO0FBQ0QsT0FKRDtBQUtEOzs7NkJBRVE7QUFBQTs7QUFDUCxVQUFNLE1BQU0sS0FBSyxLQUFMLENBQVcsTUFBdkI7O0FBRUEsVUFBSSxnQkFBSjtBQUNBLFVBQUksS0FBSyxLQUFMLENBQVcsY0FBWCxDQUEwQixLQUExQixLQUFvQyxNQUF4QyxFQUFnRDtBQUM5QyxrQkFDRTtBQUFBO0FBQUE7QUFDRTtBQUFBO0FBQUE7QUFBRztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUgsV0FERjtBQUVFO0FBQUE7QUFBQTtBQUFBO0FBQUEsV0FGRjtBQUdFO0FBQUE7QUFBQSxjQUFRLFNBQVMsaUJBQUMsQ0FBRDtBQUFBLHVCQUFPLE9BQUssY0FBTCxDQUFvQixDQUFwQixDQUFQO0FBQUEsZUFBakIsRUFBZ0QsV0FBVSxtRUFBMUQ7QUFBQTtBQUFzSSxvREFBTSxlQUFZLE1BQWxCO0FBQXRJO0FBSEYsU0FERjtBQU9ELE9BUkQsTUFRTztBQUNMLGtCQUNFO0FBQUE7QUFBQSxZQUFNLFVBQVUsa0JBQUMsQ0FBRDtBQUFBLHFCQUFPLE9BQUssWUFBTCxDQUFrQixDQUFsQixDQUFQO0FBQUEsYUFBaEIsRUFBNkMsTUFBSyxNQUFsRCxFQUF5RCxRQUFPLE1BQWhFLEVBQXVFLFdBQVUsd0JBQWpGO0FBQ0UscUVBREY7QUFFRTtBQUFBO0FBQUEsY0FBSyxXQUFXLFlBQVksZ0JBQVosRUFBOEIsR0FBOUIsQ0FBaEI7QUFDRTtBQUFBO0FBQUEsZ0JBQUssV0FBVSxpQkFBZjtBQUNFO0FBQUE7QUFBQSxrQkFBTSxXQUFVLHdCQUFoQjtBQUF5QyxxREFBRyxXQUFVLGdCQUFiO0FBQXpDLGVBREY7QUFFRSx1REFBTyxNQUFLLE1BQVosRUFBbUIsVUFBVSxLQUFLLFdBQUwsQ0FBaUIsZ0JBQWpCLEVBQW1DLEVBQW5DLENBQTdCO0FBQ0Usc0JBQUssZ0JBRFA7QUFFRSwyQkFBVSxNQUZaO0FBR0UsNkJBQVksT0FIZDtBQUlFLHVCQUFPLEtBQUssS0FBTCxDQUFXLGNBQVgsQ0FBMEIsY0FKbkM7QUFLRSwyQkFBVTtBQUxaO0FBRkYsYUFERjtBQVdFO0FBQUE7QUFBQSxnQkFBSyxXQUFVLGdCQUFmO0FBQWlDLDBCQUFZLGdCQUFaLEVBQThCLEdBQTlCO0FBQWpDO0FBWEYsV0FGRjtBQWVFO0FBQUE7QUFBQSxjQUFLLFdBQVUsZ0NBQWY7QUFDRTtBQUFBO0FBQUEsZ0JBQVEsVUFBVSxLQUFLLEtBQUwsQ0FBVyxjQUFYLENBQTBCLEtBQTFCLEtBQW9DLE1BQXBDLEdBQTZDLFVBQTdDLEdBQTBELElBQTVFLEVBQWtGLE1BQUssUUFBdkYsRUFBZ0csV0FBVSwwRkFBMUc7QUFDRyxtQkFBSyxLQUFMLENBQVcsY0FBWCxDQUEwQixLQUExQixLQUFvQyxNQUFwQyxHQUNDLHFDQUFHLFdBQVUsbUNBQWIsR0FERCxHQUVDO0FBSEo7QUFERjtBQWZGLFNBREY7QUF5QkQ7QUFDRCxhQUNBO0FBQUE7QUFBQSxVQUFLLElBQUcsU0FBUixFQUFrQixXQUFVLHFFQUE1QjtBQUNFO0FBQUE7QUFBQSxZQUFLLFdBQVUsMkNBQWY7QUFDRTtBQUFBO0FBQUEsY0FBSSxXQUFVLHFDQUFkO0FBQUE7QUFBQSxXQURGO0FBRUU7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUZGLFNBREY7QUFLRyxlQUxIO0FBTUU7QUFBQTtBQUFBLFlBQUssV0FBVSxVQUFmO0FBQ0U7QUFBQTtBQUFBLGNBQUssV0FBVSwwREFBZjtBQUNJO0FBQUE7QUFBQTtBQUFBO0FBQUEsYUFESjtBQUN3QztBQUFBO0FBQUE7QUFBQTtBQUFBLGFBRHhDO0FBRUk7QUFBQTtBQUFBLGdCQUFZLFVBQVMsUUFBckI7QUFBQTtBQUFBO0FBRko7QUFERjtBQU5GLE9BREE7QUFlRDs7Ozs7QUFHSCxlQUFlLFNBQWYsR0FBMkI7QUFDekIsVUFBUSxpQkFBVSxNQUFWLENBQWlCLFVBREE7QUFFekIsVUFBUSxpQkFBVSxNQUFWLENBQWlCLFVBRkE7QUFHekIsVUFBUSxpQkFBVSxNQUFWLENBQWlCLFVBSEE7QUFJekIsWUFBVSxpQkFBVSxNQUFWLENBQWlCLFVBSkY7QUFLekIsa0JBQWdCLGlCQUFVLE1BQVYsQ0FBaUI7QUFMUixDQUEzQjs7QUFRQSxJQUFNLHFCQUFxQixTQUFyQixrQkFBcUIsQ0FBQyxRQUFEO0FBQUEsU0FBZTtBQUN4QyxhQUFTLCtCQUFtQixjQUFuQixFQUFtQyxRQUFuQztBQUQrQixHQUFmO0FBQUEsQ0FBM0I7O2tCQUllLHlCQUNkO0FBQUEsU0FBVTtBQUNSLFlBQVEsTUFBTSxNQUROO0FBRVIsWUFBUSxNQUFNLE1BRk47QUFHUixZQUFRLE1BQU0sTUFITjtBQUlSLGNBQVUsTUFBTSxRQUpSO0FBS1Isb0JBQWdCLE1BQU07QUFMZCxHQUFWO0FBQUEsQ0FEYyxFQVFkLGtCQVJjLEVBU2IsY0FUYSxDOzs7Ozs7Ozs7O2tCQ3ZHUyxzQjs7QUFIeEI7Ozs7QUFDQTs7Ozs7O0FBRWUsU0FBUyxzQkFBVCxHQUFrQztBQUMvQyxTQUFRO0FBQ04sc0JBRE07QUFFTixZQUFPLHlCQUZEO0FBR04sWUFBTztBQUhELElBQVI7QUFLRDs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUNURDs7OztBQUNBOztBQUNBOztBQUNBOztBQUNBOztJQUFZLGM7O0FBQ1o7Ozs7Ozs7O0FBRUEsSUFBTSxjQUFjLCtDQUFzQixjQUF0QixDQUFwQjtBQUNBLElBQU0sY0FBYywrQ0FBc0IsY0FBdEIsQ0FBcEI7O0lBRWEsYyxXQUFBLGM7OztBQUVYLDBCQUFZLEtBQVosRUFBbUI7QUFBQTs7QUFBQSxzSkFDWCxLQURXOztBQUVqQixVQUFLLEtBQUwsR0FBYTtBQUNYLGlCQUFXLEVBREE7QUFFWCxnQkFBVSxFQUZDO0FBR1gsYUFBTyxFQUhJO0FBSVgsZ0JBQVUsTUFBSyxLQUFMLENBQVcsTUFBWCxDQUFrQjtBQUpqQixLQUFiO0FBRmlCO0FBUWxCOzs7OzZCQUVRLEMsRUFBRyxJLEVBQU07QUFDaEIsVUFBTSxPQUFPLEVBQWI7QUFDQSxXQUFLLElBQUwsSUFBYSxFQUFFLE1BQUYsQ0FBUyxLQUF0QjtBQUNBLFdBQUssUUFBTCxDQUFjLElBQWQ7QUFDRDs7O3NDQUVpQjtBQUNoQixVQUFNLFdBQVc7QUFDZixrQkFBVTtBQUNSLGlCQUFPLDJCQURDO0FBRVIsb0JBQVUsd0NBRkY7QUFHUixvQkFBVSx1UkFIRjtBQUlSLHVCQUFhLENBQUMsV0FBRCxFQUFjLFVBQWQ7QUFKTCxTQURLO0FBT2YsZUFBTztBQUNMLGlCQUFPLHVCQURGO0FBRUwsdUJBQWEsQ0FBQyxPQUFELEVBQVUsVUFBVjtBQUZSO0FBUFEsT0FBakI7O0FBYUEsVUFBSSxDQUFDLFNBQVMsS0FBSyxLQUFMLENBQVcsTUFBWCxDQUFrQixPQUEzQixDQUFMLEVBQTBDO0FBQ3hDLGVBQU8sU0FBUyxRQUFoQjtBQUNEO0FBQ0QsYUFBTyxTQUFTLEtBQUssS0FBTCxDQUFXLE1BQVgsQ0FBa0IsT0FBM0IsQ0FBUDtBQUNEOzs7aUNBRVksQyxFQUFHO0FBQ2QsVUFBSSxDQUFDLEtBQUssS0FBTCxDQUFXLE1BQVgsQ0FBa0IsT0FBbkIsSUFBOEIsQ0FBQyxLQUFLLEtBQUwsQ0FBVyxNQUFYLENBQWtCLFFBQXJELEVBQStEO0FBQy9ELFFBQUUsY0FBRjs7QUFFQSxVQUFNLGVBQWUsS0FBSyxlQUFMLEVBQXJCO0FBQ0EsVUFBTSxXQUFXLFNBQVgsUUFBVyxDQUFDLElBQUQ7QUFBQSxlQUFVLGFBQWEsV0FBYixDQUF5QixPQUF6QixDQUFpQyxJQUFqQyxNQUEyQyxDQUFDLENBQXREO0FBQUEsT0FBakI7O0FBRUEsVUFBTSxPQUFPLEVBQWI7QUFDQSxVQUFJLFNBQVMsV0FBVCxDQUFKLEVBQTJCO0FBQ3pCLGFBQUssU0FBTCxHQUFpQixLQUFLLEtBQUwsQ0FBVyxTQUE1QjtBQUNEO0FBQ0QsVUFBSSxTQUFTLFVBQVQsQ0FBSixFQUEwQjtBQUN4QixhQUFLLFFBQUwsR0FBZ0IsS0FBSyxLQUFMLENBQVcsUUFBM0I7QUFDRDtBQUNELFVBQUksU0FBUyxPQUFULENBQUosRUFBdUI7QUFDckIsYUFBSyxLQUFMLEdBQWEsS0FBSyxLQUFMLENBQVcsS0FBeEI7QUFDRDtBQUNELFVBQUksU0FBUyxVQUFULENBQUosRUFBMEI7QUFDeEIsYUFBSyxRQUFMLEdBQWdCLEtBQUssS0FBTCxDQUFXLFFBQTNCO0FBQ0Q7QUFDRCxXQUFLLEtBQUwsQ0FBVyxPQUFYLENBQW1CLFdBQW5CO0FBQ0EsV0FBSyxLQUFMLENBQVcsT0FBWCxDQUFtQixjQUFuQixDQUFrQyxJQUFsQztBQUNEOzs7NkJBRVE7QUFBQTs7QUFDUCxVQUFNLE1BQU0sS0FBSyxLQUFMLENBQVcsTUFBdkI7QUFDQSxVQUFNLGVBQWUsS0FBSyxlQUFMLEVBQXJCO0FBQ0EsVUFBTSxXQUFXLFNBQVgsUUFBVyxDQUFDLElBQUQ7QUFBQSxlQUFVLGFBQWEsV0FBYixDQUF5QixPQUF6QixDQUFpQyxJQUFqQyxNQUEyQyxDQUFDLENBQXREO0FBQUEsT0FBakI7O0FBRUEsYUFDQTtBQUFBO0FBQUEsVUFBSyxJQUFHLGtCQUFSLEVBQTJCLFdBQVUscUVBQXJDO0FBQ0U7QUFBQTtBQUFBLFlBQUssV0FBVSwyQ0FBZjtBQUNFO0FBQUE7QUFBQSxjQUFJLFdBQVUscUNBQWQ7QUFBcUQseUJBQWE7QUFBbEU7QUFERixTQURGO0FBSUU7QUFBQTtBQUFBO0FBQ0U7QUFBQTtBQUFBLGNBQU0sY0FBYSxLQUFuQixFQUF5QixNQUFLLE1BQTlCLEVBQXFDLFVBQVUsa0JBQUMsQ0FBRDtBQUFBLHVCQUFPLE9BQUssWUFBTCxDQUFrQixDQUFsQixDQUFQO0FBQUEsZUFBL0MsRUFBNEUsV0FBVSxxQ0FBdEYsRUFBNEgsUUFBTyxNQUFuSSxFQUEwSSxRQUFPLHlCQUFqSjtBQUNHLGlCQUFLLEtBQUwsQ0FBVyxNQUFYLENBQWtCLEdBQWxCLEdBQXdCLHlDQUFPLE1BQUssUUFBWixFQUFxQixNQUFLLEtBQTFCLEVBQWdDLE9BQU8sbUJBQW1CLEtBQUssS0FBTCxDQUFXLE1BQVgsQ0FBa0IsR0FBckMsQ0FBdkMsR0FBeEIsR0FBK0csSUFEbEg7QUFFRyxxQkFBUyxVQUFULEtBQXdCLEtBQUssS0FBTCxDQUFXLE1BQVgsQ0FBa0IsUUFBMUMsR0FBcUQseUNBQU8sV0FBVSxhQUFqQixFQUErQixNQUFLLFFBQXBDLEVBQTZDLE1BQUssVUFBbEQsRUFBNkQsS0FBSSxVQUFqRSxFQUE0RSxPQUFPLEtBQUssS0FBTCxDQUFXLE1BQVgsQ0FBa0IsUUFBckcsR0FBckQsR0FBeUssSUFGNUs7QUFHRSxxREFBTyxNQUFLLFFBQVosRUFBcUIsTUFBSyxPQUExQixFQUFrQyxPQUFPLEtBQUssS0FBTCxDQUFXLE1BQVgsQ0FBa0IsS0FBM0QsR0FIRjtBQUlFLHFEQUFPLE1BQUssUUFBWixFQUFxQixNQUFLLGFBQTFCLEVBQXdDLE9BQU8sS0FBSyxLQUFMLENBQVcsTUFBWCxDQUFrQixTQUFqRSxHQUpGO0FBTUU7QUFBQTtBQUFBLGdCQUFLLFdBQVUsS0FBZjtBQUNFO0FBQUE7QUFBQSxrQkFBSyxXQUFVLG9CQUFmO0FBQ0cseUJBQVMsV0FBVCxJQUNDO0FBQ0Usd0JBQUssV0FEUCxFQUNtQixPQUFNLFlBRHpCLEVBQ3NDLE9BQU8sS0FBSyxLQUFMLENBQVcsU0FEeEQ7QUFFRSw4QkFBWSxZQUFZLFdBQVosRUFBeUIsR0FBekIsQ0FGZDtBQUdFLGdDQUFjLFlBQVksV0FBWixFQUF5QixHQUF6QixDQUhoQjtBQUlFLDRCQUFVLGtCQUFDLENBQUQ7QUFBQSwyQkFBTyxPQUFLLFFBQUwsQ0FBYyxDQUFkLEVBQWlCLFdBQWpCLENBQVA7QUFBQSxtQkFKWjtBQUtFLDZCQUFVO0FBTFosa0JBREQsR0FRQztBQVRKLGVBREY7QUFZRTtBQUFBO0FBQUEsa0JBQUssV0FBVSxvQkFBZjtBQUNHLHlCQUFTLFVBQVQsSUFDQztBQUNFLHdCQUFLLFdBRFAsRUFDbUIsT0FBTSxXQUR6QixFQUNxQyxPQUFPLEtBQUssS0FBTCxDQUFXLFFBRHZEO0FBRUUsOEJBQVksWUFBWSxVQUFaLEVBQXdCLEdBQXhCLENBRmQ7QUFHRSxnQ0FBYyxZQUFZLFVBQVosRUFBd0IsR0FBeEIsQ0FIaEI7QUFJRSw0QkFBVSxrQkFBQyxDQUFEO0FBQUEsMkJBQU8sT0FBSyxRQUFMLENBQWMsQ0FBZCxFQUFpQixVQUFqQixDQUFQO0FBQUE7QUFKWixrQkFERCxHQU9DO0FBUko7QUFaRixhQU5GO0FBOEJHLHFCQUFTLE9BQVQsSUFDQztBQUNFLG9CQUFLLE9BRFA7QUFFRSxxQkFBTyxLQUFLLEtBQUwsQ0FBVyxNQUFYLENBQWtCLFFBQWxCLEtBQStCLFNBQS9CLEdBQTJDLGtCQUEzQyxHQUFnRSxPQUZ6RTtBQUdFLHFCQUFPLEtBQUssS0FBTCxDQUFXLEtBSHBCO0FBSUUsMEJBQVksWUFBWSxPQUFaLEVBQXFCLEdBQXJCLENBSmQ7QUFLRSw0QkFBYyxZQUFZLE9BQVosRUFBcUIsR0FBckIsQ0FMaEI7QUFNRSx3QkFBVSxrQkFBQyxDQUFEO0FBQUEsdUJBQU8sT0FBSyxRQUFMLENBQWMsQ0FBZCxFQUFpQixPQUFqQixDQUFQO0FBQUE7QUFOWixjQURELEdBU0MsSUF2Q0o7QUF3Q0cseUJBQWEsUUFBYixHQUNDO0FBQUE7QUFBQSxnQkFBSyxXQUFVLGtCQUFmO0FBQ0U7QUFBQTtBQUFBLGtCQUFNLFdBQVUsNkJBQWhCLEVBQThDLE9BQU8sYUFBYSxRQUFsRTtBQUE2RSw2QkFBYTtBQUExRjtBQURGLGFBREQsR0FJQyxJQTVDSjtBQTZDRTtBQUFBO0FBQUE7QUFDRTtBQUFBO0FBQUEsa0JBQVEsTUFBSyxRQUFiLEVBQXNCLFdBQVUsbUVBQWhDO0FBQUE7QUFBQTtBQURGO0FBN0NGO0FBREY7QUFKRixPQURBO0FBNEREOzs7OztBQUdILGVBQWUsU0FBZixHQUEyQjtBQUN6QixVQUFRLGlCQUFVLE1BQVYsQ0FBaUIsVUFEQTtBQUV6QixVQUFRLGlCQUFVLE1BQVYsQ0FBaUI7QUFGQSxDQUEzQjs7QUFLQSxJQUFNLHFCQUFxQixTQUFyQixrQkFBcUIsQ0FBQyxRQUFEO0FBQUEsU0FBZTtBQUN4QyxhQUFTLCtCQUFtQixjQUFuQixFQUFtQyxRQUFuQztBQUQrQixHQUFmO0FBQUEsQ0FBM0I7O2tCQUllLHlCQUNkO0FBQUEsU0FBVTtBQUNSLFlBQVEsTUFBTSxNQUROO0FBRVIsWUFBUSxNQUFNO0FBRk4sR0FBVjtBQUFBLENBRGMsRUFLZCxrQkFMYyxFQU1iLGNBTmEsQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQ3JKZjs7OztBQUNBOztBQUNBOztBQUNBOztBQUNBOztJQUFZLGM7O0FBQ1o7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7OztBQUVBLElBQU0sY0FBYywrQ0FBc0IsY0FBdEIsQ0FBcEI7QUFDQSxJQUFNLGNBQWMsK0NBQXNCLGNBQXRCLENBQXBCO0FBQ0EsSUFBTSxxQkFBcUIsK0NBQXNCLFNBQXRCLENBQTNCO0FBQ0EsSUFBTSxxQkFBcUIsK0NBQXNCLFNBQXRCLENBQTNCOztJQUVhLFEsV0FBQSxROzs7QUFDWCxvQkFBWSxLQUFaLEVBQW1CO0FBQUE7O0FBQUEsMElBQ1gsS0FEVzs7QUFFakIsUUFBTSxZQUFZLE1BQU0sTUFBTixDQUFhLFFBQWIsS0FBMEIsU0FBNUM7QUFDQSxVQUFLLEtBQUwsR0FBYSxFQUFFLGFBQWEsQ0FBQyxTQUFoQixFQUFiO0FBSGlCO0FBSWxCOzs7O2dDQUVXLEMsRUFBRztBQUNiLFVBQU0sZUFBZSxzQ0FBcUIsQ0FBckIsQ0FBckI7QUFDQSxVQUFJLFlBQUosRUFBa0I7QUFDaEIsYUFBSyxVQUFMLENBQWdCLElBQWhCO0FBQ0EsYUFBSyxLQUFMLENBQVcsT0FBWCxDQUFtQixnQkFBbkIsQ0FBb0MsNkJBQWMsWUFBZCxDQUFwQztBQUNELE9BSEQsTUFHTztBQUNMLGFBQUssS0FBTCxDQUFXLE9BQVgsQ0FBbUIsV0FBbkIsQ0FBK0IsMEJBQS9CLEVBQTJELEVBQTNEO0FBQ0EsYUFBSyxVQUFMLENBQWdCLENBQWhCO0FBQ0Q7QUFDRjs7OytCQUVVLEcsRUFBSztBQUNkLFdBQUssUUFBTCxDQUFjLEVBQUUsYUFBYSxRQUFRLEdBQVIsQ0FBZixFQUFkO0FBQ0EsV0FBSyxLQUFMLENBQVcsT0FBWCxDQUFtQixRQUFuQixDQUE0QixVQUE1QixFQUF3QyxhQUF4QyxFQUF1RCxHQUF2RDtBQUNEOzs7dUNBRWtCO0FBQ2pCLGFBQVUsS0FBSyxLQUFMLENBQVcsTUFBWCxDQUFrQixNQUE1QjtBQUNEOzs7eUNBRW9CO0FBQ25CLGFBQVUsS0FBSyxLQUFMLENBQVcsTUFBWCxDQUFrQixNQUE1QjtBQUNEOzs7Z0NBRVcsTyxFQUFTLE8sRUFBUztBQUFBOztBQUM1QixVQUFNLHlCQUF1QixPQUE3QjtBQUNBLFVBQU0sT0FBTyxRQUFRLEdBQVIsQ0FBWTtBQUFBLGlDQUFxQixDQUFyQjtBQUFBLE9BQVosS0FBeUMsRUFBdEQ7QUFDQSxhQUFPLFVBQUMsQ0FBRCxFQUFPO0FBQ1osWUFBTSxTQUFTLEVBQUUsTUFBakI7QUFDQSxlQUFLLEtBQUwsQ0FBVyxPQUFYLENBQW1CLFFBQW5CLENBQTRCLFVBQTVCLEVBQXdDLE9BQU8sSUFBL0MsRUFBcUQsT0FBTyxJQUFQLEtBQWdCLFVBQWhCLElBQThCLE9BQU8sSUFBUCxLQUFnQixPQUE5QyxHQUF3RCxPQUFPLE9BQS9ELEdBQXlFLE9BQU8sS0FBckk7QUFDQSxlQUFLLEtBQUwsQ0FBVyxPQUFYLENBQW1CLFdBQW5CLENBQStCLElBQS9CLEVBQXFDLElBQXJDO0FBQ0EsZUFBSyxLQUFMLENBQVcsT0FBWCxDQUFtQixhQUFuQixDQUFpQyxJQUFqQztBQUNELE9BTEQ7QUFNRDs7OytCQUVVO0FBQ1QsYUFBTyxLQUFLLEtBQUwsQ0FBVyxNQUFYLEdBQW9CLG9CQUFZLEtBQUssS0FBTCxDQUFXLE1BQXZCLEVBQStCLE1BQS9CLENBQXNDLFVBQUMsQ0FBRDtBQUFBLGVBQU8sRUFBRSxVQUFGLENBQWEsZUFBYixDQUFQO0FBQUEsT0FBdEMsRUFBNEUsTUFBNUUsR0FBcUYsQ0FBekcsR0FBNkcsS0FBcEg7QUFDRDs7O21DQUVjO0FBQ2IsV0FBSyxLQUFMLENBQVcsT0FBWCxDQUFtQixlQUFuQixDQUFtQyxRQUFuQztBQUNEOzs7cUNBRWdCO0FBQ2YsV0FBSyxLQUFMLENBQVcsT0FBWCxDQUFtQixlQUFuQixDQUFtQyxVQUFuQztBQUNEOzs7aUNBRVksQyxFQUFHO0FBQ2QsUUFBRSxjQUFGO0FBQ0EsVUFBTSxTQUFTLEVBQUUsTUFBakI7QUFDQSxXQUFLLEtBQUwsQ0FBVyxPQUFYLENBQW1CLFlBQW5CLENBQWdDLFlBQU07QUFDcEMsZUFBTyxNQUFQLEdBRG9DLENBQ25CO0FBQ2xCLE9BRkQ7QUFHRDs7OzZCQUVRO0FBQUE7O0FBQUEsVUFDQyxXQURELEdBQ2lCLEtBQUssS0FBTCxDQUFXLFFBRDVCLENBQ0MsV0FERDs7QUFFUCxVQUFNLE1BQU0sS0FBSyxLQUFMLENBQVcsTUFBdkI7QUFDQSxVQUFNLFVBQVUsQ0FBQyxLQUFLLEtBQUwsQ0FBVyxNQUFYLENBQWtCLFFBQW5DO0FBQ0EsVUFBTSxZQUFZLEtBQUssS0FBTCxDQUFXLE1BQVgsQ0FBa0IsUUFBbEIsS0FBK0IsU0FBakQ7QUFDQSxVQUFNLFVBQVUsMkJBQVUsV0FBVixDQUFoQjtBQUNBLFVBQU0sVUFBVSxXQUFXLDJCQUFVLFdBQVYsQ0FBM0I7QUFDQSxVQUFNLGNBQWMsS0FBSyxLQUFMLENBQVcsV0FBL0I7O0FBRUEsVUFBTSxlQUFlO0FBQ25CLGtCQUFVLFFBRFM7QUFFbkIsb0JBQVksY0FBYyxzR0FBZCxHQUF1SCxNQUZoSDtBQUduQixtQkFBVyxjQUFjLE9BQWQsR0FBd0IsR0FIaEI7QUFJbkIsbUJBQVcsY0FBYyxZQUFkLEdBQTZCLGVBSnJCO0FBS25CLGlCQUFTLGNBQWMsR0FBZCxHQUFvQjtBQUxWLE9BQXJCOztBQVFBLGFBQ0E7QUFBQTtBQUFBLFVBQUssSUFBRyxTQUFSLEVBQWtCLFdBQVUscUVBQTVCO0FBQ0ksYUFBSyxLQUFMLENBQVcsTUFBWCxDQUFrQixRQUFsQixHQUNBLDZFQUFjLEtBQUssS0FBTCxDQUFXLE1BQVgsQ0FBa0IsUUFBaEMsSUFBMEMsUUFBUSxLQUFLLEtBQUwsQ0FBVyxNQUFYLENBQWtCLE1BQXBFLElBREEsR0FHQTtBQUFBO0FBQUEsWUFBSyxXQUFVLDJDQUFmO0FBQ0U7QUFBQTtBQUFBLGNBQUksV0FBVSxxQ0FBZDtBQUFBO0FBQUE7QUFERixTQUpKO0FBU0csb0JBQ0M7QUFBQTtBQUFBLFlBQUssV0FBVyxZQUFZLGFBQVosRUFBMkIsR0FBM0IsQ0FBaEI7QUFDRTtBQUFBO0FBQUEsY0FBTyxXQUFVLGtCQUFqQixFQUFvQyxTQUFRLG1CQUE1QztBQUFBO0FBQUEsV0FERjtBQUVFO0FBQ0Usa0JBQUssYUFEUDtBQUVFLG1CQUFPLEtBQUssS0FBTCxDQUFXLFFBQVgsQ0FBb0IsV0FGN0I7QUFHRSxzQkFBVSxrQkFBQyxDQUFEO0FBQUEscUJBQU8sT0FBSyxXQUFMLENBQWlCLENBQWpCLENBQVA7QUFBQSxhQUhaO0FBSUUsbUJBQU0sZUFKUjtBQUtFLHNCQUFVLEtBQUssS0FBTCxDQUFXLE1BQVgsQ0FBa0I7QUFMOUIsWUFGRjtBQVNFO0FBQUE7QUFBQSxjQUFLLFdBQVUsZ0JBQWY7QUFBaUMsd0JBQVksYUFBWixFQUEyQixHQUEzQjtBQUFqQztBQVRGLFNBREQsR0FZQyxJQXJCSjtBQXVCRTtBQUFBO0FBQUEsWUFBSyxPQUFPLFlBQVo7QUFDRTtBQUFBO0FBQUE7QUFFRyxhQUFDLFNBQUQsSUFBYyxDQUFDLE9BQWYsR0FDQztBQUFBO0FBQUE7QUFDRTtBQUFBO0FBQUEsa0JBQUssV0FBVSxLQUFmO0FBQ0U7QUFBQTtBQUFBLG9CQUFLLFdBQVUsV0FBZjtBQUNFO0FBQUE7QUFBQTtBQUNFLGdDQUFVLEtBQUssS0FBTCxDQUFXLFFBQVgsQ0FBb0IsS0FBcEIsS0FBOEIsTUFBOUIsSUFBd0MsS0FBSyxLQUFMLENBQVcsTUFBWCxDQUFrQixVQUExRCxHQUF1RSxVQUF2RSxHQUFvRixJQURoRztBQUVFLCtCQUFTLGlCQUFDLENBQUQ7QUFBQSwrQkFBTyxPQUFLLFlBQUwsQ0FBa0IsQ0FBbEIsQ0FBUDtBQUFBLHVCQUZYO0FBR0UsaUNBQVU7QUFIWjtBQUtHLHlCQUFLLEtBQUwsQ0FBVyxNQUFYLENBQWtCLFVBQWxCLEtBQWlDLFFBQWpDLEdBQ0MscUNBQUcsV0FBVSxzQ0FBYixHQURELEdBRUM7QUFBQTtBQUFBLHdCQUFNLFdBQVUsVUFBaEI7QUFBMkIsNkRBQUssT0FBTyxFQUFFLFNBQVMsYUFBWCxFQUEwQixlQUFlLFFBQXpDLEVBQVosRUFBaUUsS0FBSyxLQUFLLGdCQUFMLEVBQXRFLEdBQTNCO0FBQUE7QUFBQTtBQVBKO0FBREY7QUFERixlQURGO0FBZUU7QUFBQTtBQUFBLGtCQUFLLFdBQVUsbUJBQWY7QUFDRTtBQUFBO0FBQUEsb0JBQUssV0FBVSxXQUFmO0FBQ0U7QUFBQTtBQUFBO0FBQ0UsZ0NBQVUsS0FBSyxLQUFMLENBQVcsUUFBWCxDQUFvQixLQUFwQixLQUE4QixNQUE5QixJQUF3QyxLQUFLLEtBQUwsQ0FBVyxNQUFYLENBQWtCLFVBQTFELEdBQXVFLFVBQXZFLEdBQW9GLElBRGhHO0FBRUUsK0JBQVMsaUJBQUMsQ0FBRDtBQUFBLCtCQUFPLE9BQUssY0FBTCxDQUFvQixDQUFwQixDQUFQO0FBQUEsdUJBRlg7QUFHRSxpQ0FBVTtBQUhaO0FBS0cseUJBQUssS0FBTCxDQUFXLE1BQVgsQ0FBa0IsVUFBbEIsS0FBaUMsVUFBakMsR0FDQyxxQ0FBRyxXQUFVLHNDQUFiLEdBREQsR0FFQztBQUFBO0FBQUEsd0JBQU0sV0FBVSxVQUFoQjtBQUEyQiw2REFBSyxPQUFPLEVBQUUsU0FBUyxhQUFYLEVBQTBCLGVBQWUsUUFBekMsRUFBWixFQUFpRSxLQUFLLEtBQUssa0JBQUwsRUFBdEUsR0FBM0I7QUFBQTtBQUFBO0FBUEo7QUFERjtBQURGLGVBZkY7QUE2QkU7QUFBQTtBQUFBLGtCQUFLLFdBQVUsV0FBZjtBQUNFO0FBQUE7QUFBQSxvQkFBTSxXQUFVLDBCQUFoQjtBQUFBO0FBQUE7QUFERjtBQTdCRixhQURELEdBa0NDLElBcENKO0FBc0NFO0FBQUE7QUFBQSxnQkFBTSxjQUFhLEtBQW5CLEVBQXlCLE1BQUssTUFBOUIsRUFBcUMsVUFBVSxrQkFBQyxDQUFEO0FBQUEseUJBQU8sT0FBSyxZQUFMLENBQWtCLENBQWxCLENBQVA7QUFBQSxpQkFBL0MsRUFBNEUsV0FBVSxrQ0FBdEYsRUFBeUgsUUFBTyxNQUFoSSxFQUF1SSxRQUFPLDhCQUE5STtBQUNFLHlFQURGO0FBR0csMEJBQVkseUNBQU8sTUFBSyxRQUFaLEVBQXFCLE1BQUssYUFBMUIsRUFBd0MsT0FBTyxLQUFLLEtBQUwsQ0FBVyxRQUFYLENBQW9CLFdBQW5FLEdBQVosR0FBaUcsSUFIcEc7QUFLRyx3QkFDQztBQUFBO0FBQUEsa0JBQUssV0FBVSxLQUFmO0FBQ0U7QUFBQTtBQUFBLG9CQUFLLFdBQVUsb0JBQWY7QUFDRTtBQUNFLDBCQUFLLFdBRFAsRUFDbUIsT0FBTSxZQUR6QixFQUNzQyxPQUFPLEtBQUssS0FBTCxDQUFXLFFBQVgsQ0FBb0IsU0FEakU7QUFFRSxnQ0FBWSxZQUFZLFdBQVosRUFBeUIsR0FBekIsQ0FGZDtBQUdFLGtDQUFjLFlBQVksV0FBWixFQUF5QixHQUF6QixDQUhoQjtBQUlFLDhCQUFVLEtBQUssV0FBTCxDQUFpQixXQUFqQixFQUE4QixFQUE5QjtBQUpaO0FBREYsaUJBREY7QUFTRTtBQUFBO0FBQUEsb0JBQUssV0FBVSxvQkFBZjtBQUNFO0FBQ0UsMEJBQUssVUFEUCxFQUNrQixPQUFNLFdBRHhCLEVBQ29DLE9BQU8sS0FBSyxLQUFMLENBQVcsUUFBWCxDQUFvQixRQUQvRDtBQUVFLGdDQUFZLFlBQVksVUFBWixFQUF3QixHQUF4QixDQUZkO0FBR0Usa0NBQWMsWUFBWSxVQUFaLEVBQXdCLEdBQXhCLENBSGhCO0FBSUUsOEJBQVUsS0FBSyxXQUFMLENBQWlCLFVBQWpCLEVBQTZCLEVBQTdCO0FBSlo7QUFERjtBQVRGLGVBREQsR0FtQkMsSUF4Qko7QUEwQkcsZUFBQyxTQUFELElBQWMsQ0FBQyxPQUFmLEdBQ0M7QUFDRSxzQkFBSyxPQURQO0FBRUUsdUJBQVEsS0FBSyxLQUFMLENBQVcsTUFBWCxDQUFrQixRQUFsQixLQUErQixTQUEvQixJQUE0QyxPQUE3QyxHQUF3RCxrQkFBeEQsR0FBNkUsT0FGdEY7QUFHRSx1QkFBTyxLQUFLLEtBQUwsQ0FBVyxRQUFYLENBQW9CLEtBSDdCO0FBSUUsNEJBQVksWUFBWSxPQUFaLEVBQXFCLEdBQXJCLENBSmQ7QUFLRSw4QkFBYyxZQUFZLE9BQVosRUFBcUIsR0FBckIsQ0FMaEI7QUFNRSwwQkFBVSxLQUFLLFdBQUwsQ0FBaUIsT0FBakIsRUFBMEIsRUFBMUIsQ0FOWjtBQU9FLHNCQUFLO0FBUFAsZ0JBREQsR0FVQyxJQXBDSjtBQXFDRTtBQUNFLHNCQUFLLFVBRFA7QUFFRSx1QkFBTSxVQUZSO0FBR0UsdUJBQU8sS0FBSyxLQUFMLENBQVcsUUFBWCxDQUFvQixRQUg3QjtBQUlFLDRCQUFZLFlBQVksVUFBWixFQUF3QixHQUF4QixDQUpkO0FBS0UsOEJBQWMsWUFBWSxVQUFaLEVBQXdCLEdBQXhCLENBTGhCO0FBTUUsMEJBQVUsS0FBSyxXQUFMLENBQWlCLFVBQWpCLEVBQTZCLEVBQTdCO0FBTlosZ0JBckNGO0FBNkNFO0FBQ0Usc0JBQUssVUFEUDtBQUVFLHVCQUFNLFVBRlI7QUFHRSx1QkFBTyxLQUFLLEtBQUwsQ0FBVyxRQUFYLENBQW9CLFFBSDdCO0FBSUUsNEJBQVksWUFBWSxVQUFaLEVBQXdCLEdBQXhCLENBSmQ7QUFLRSw4QkFBYyxZQUFZLFVBQVosRUFBd0IsR0FBeEIsQ0FMaEI7QUFNRSwwQkFBVSxLQUFLLFdBQUwsQ0FBaUIsVUFBakIsRUFBNkIsRUFBN0IsQ0FOWjtBQU9FLHNCQUFLO0FBUFAsZ0JBN0NGO0FBdURHLDJCQUFhLE9BQWIsR0FDQztBQUFBO0FBQUE7QUFDRTtBQUNFLHdCQUFLLFdBRFA7QUFFRSx5QkFBTSwyQkFGUjtBQUdFLHlCQUFPLEtBQUssS0FBTCxDQUFXLFFBQVgsQ0FBb0IsU0FIN0I7QUFJRSw4QkFBWSxZQUFZLFdBQVosRUFBeUIsR0FBekIsQ0FKZDtBQUtFLGdDQUFjLFlBQVksV0FBWixFQUF5QixHQUF6QixDQUxoQjtBQU1FLDRCQUFVLEtBQUssV0FBTCxDQUFpQixXQUFqQixFQUE4QixFQUE5QjtBQU5aLGtCQURGO0FBU0U7QUFBQTtBQUFBLG9CQUFLLFdBQVUsV0FBZjtBQUNFO0FBQUE7QUFBQSxzQkFBTSxXQUFVLDBCQUFoQjtBQUFBO0FBQUE7QUFERixpQkFURjtBQVlFO0FBQ0Usd0JBQUssZUFEUDtBQUVFLHlCQUFNLG9DQUZSO0FBR0UseUJBQU8sS0FBSyxLQUFMLENBQVcsUUFBWCxDQUFvQixhQUg3QjtBQUlFLDhCQUFZLFlBQVksZUFBWixFQUE2QixHQUE3QixDQUpkO0FBS0UsZ0NBQWMsWUFBWSxlQUFaLEVBQTZCLEdBQTdCLENBTGhCO0FBTUUsNEJBQVUsS0FBSyxXQUFMLENBQWlCLGVBQWpCLEVBQWtDLEVBQWxDLENBTlo7QUFPRSx3QkFBSztBQVBQO0FBWkYsZUFERCxHQXVCQyxJQTlFSjtBQWdGRyxtQkFBSyxLQUFMLENBQVcsTUFBWCxDQUFrQixRQUFsQixLQUErQixTQUEvQixHQUNEO0FBQUE7QUFBQSxrQkFBSyxXQUFVLDZEQUFmO0FBQ0U7QUFBQTtBQUFBLG9CQUFPLFdBQVUsNEJBQWpCO0FBQThDLDJEQUFPLFVBQVUsS0FBSyxXQUFMLENBQWlCLFlBQWpCLEVBQStCLEVBQS9CLENBQWpCO0FBQzVDLDBCQUFLLFVBRHVDLEVBQzVCLE1BQUssWUFEdUI7QUFFNUMsK0JBQVUsY0FGa0M7QUFHNUMsMkJBQU0sTUFIc0M7QUFJNUMsNkJBQVMsS0FBSyxLQUFMLENBQVcsUUFBWCxDQUFvQjtBQUplLG9CQUE5QztBQU1FO0FBQUE7QUFBQSxzQkFBTSxXQUFVLFVBQWhCO0FBQUE7QUFBQTtBQU5GO0FBREYsZUFEQyxHQVdDLElBM0ZKO0FBNkZFO0FBQUE7QUFBQTtBQUNFO0FBQUE7QUFBQSxvQkFBUSxVQUFVLEtBQUssS0FBTCxDQUFXLFFBQVgsQ0FBb0IsS0FBcEIsS0FBOEIsTUFBOUIsSUFBd0MsS0FBSyxLQUFMLENBQVcsTUFBWCxDQUFrQixXQUFsQixLQUFrQyxNQUExRSxHQUFtRixVQUFuRixHQUFnRyxJQUFsSDtBQUNFLDBCQUFLLFFBRFAsRUFDZ0IsV0FBVTtBQUQxQjtBQUdHLHVCQUFLLEtBQUwsQ0FBVyxRQUFYLENBQW9CLEtBQXBCLEtBQThCLE1BQTlCLEdBQ0MscUNBQUcsV0FBVSxpREFBYixHQURELEdBRUM7QUFMSjtBQURGO0FBN0ZGLGFBdENGO0FBOElFO0FBQUE7QUFBQSxnQkFBSyxXQUFVLEtBQWY7QUFDRTtBQUFBO0FBQUEsa0JBQUssV0FBVSwyQkFBZixFQUEyQyxPQUFPLEVBQUUsY0FBYyxDQUFoQixFQUFsRDtBQUNFO0FBQUE7QUFBQSxvQkFBSyxXQUFVLGtCQUFmO0FBQUE7QUFBMEU7QUFBQTtBQUFBLHNCQUFHLFFBQU8sUUFBVixFQUFtQixXQUFVLG9CQUE3QixFQUFrRCxNQUFLLGtEQUF2RDtBQUFBO0FBQUEsbUJBQTFFO0FBQUE7QUFBaU47QUFBQTtBQUFBLHNCQUFHLFFBQU8sUUFBVixFQUFtQixXQUFVLG9CQUE3QixFQUFrRCxNQUFLLHVDQUF2RDtBQUFBO0FBQUE7QUFBak47QUFERjtBQURGLGFBOUlGO0FBb0pHLCtCQUFtQixjQUFuQixFQUFtQyxHQUFuQyxJQUNDO0FBQUE7QUFBQSxnQkFBSyxXQUFVLEtBQWY7QUFDRTtBQUFBO0FBQUEsa0JBQUssV0FBVSx5QkFBZjtBQUNFO0FBQUE7QUFBQSxvQkFBSyxXQUFVLGdCQUFmO0FBQWlDLHFDQUFtQixjQUFuQixFQUFtQyxHQUFuQztBQUFqQztBQURGO0FBREYsYUFERCxHQU1DO0FBMUpKO0FBREYsU0F2QkY7QUFzTEU7QUFBQTtBQUFBLFlBQUssV0FBVSxVQUFmO0FBQ0U7QUFBQTtBQUFBLGNBQUssV0FBVSwwREFBZjtBQUNJO0FBQUE7QUFBQTtBQUFBO0FBQUEsYUFESjtBQUM0QztBQUFBO0FBQUE7QUFBQTtBQUFBLGFBRDVDO0FBRUk7QUFBQTtBQUFBLGdCQUFZLFVBQVMsUUFBckI7QUFBQTtBQUFBO0FBRko7QUFERjtBQXRMRixPQURBO0FBK0xEOzs7OztBQUdILFNBQVMsU0FBVCxHQUFxQjtBQUNuQixVQUFRLGlCQUFVLE1BQVYsQ0FBaUIsVUFETjtBQUVuQixVQUFRLGlCQUFVLE1BQVYsQ0FBaUIsVUFGTjtBQUduQixZQUFVLGlCQUFVLE1BQVYsQ0FBaUI7QUFIUixDQUFyQjs7QUFNQSxJQUFNLHFCQUFxQixTQUFyQixrQkFBcUIsQ0FBQyxRQUFEO0FBQUEsU0FBZTtBQUN4QyxhQUFTLCtCQUFtQixjQUFuQixFQUFtQyxRQUFuQztBQUQrQixHQUFmO0FBQUEsQ0FBM0I7O2tCQUllLHlCQUNkO0FBQUEsU0FBVTtBQUNSLFlBQVEsTUFBTSxNQUROO0FBRVIsWUFBUSxNQUFNLE1BRk47QUFHUixjQUFVLE1BQU07QUFIUixHQUFWO0FBQUEsQ0FEYyxFQU1kLGtCQU5jLEVBT2IsUUFQYSxDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUM3U2Y7Ozs7QUFDQTs7QUFDQTs7QUFDQTs7SUFBWSxjOztBQUNaOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7O0FBQ0E7Ozs7Ozs7O0lBRWEsa0IsV0FBQSxrQjs7O0FBQ1gsOEJBQVksS0FBWixFQUFtQjtBQUFBOztBQUFBLDhKQUNYLEtBRFc7O0FBRWpCLFFBQU0sWUFBWSxNQUFNLE9BQU4sQ0FBYyxTQUFoQztBQUNBLFFBQU0sVUFBVSxNQUFNLE9BQU4sQ0FBYyxPQUE5QjtBQUNBLFFBQU0sa0JBQWtCLE1BQU0sTUFBTixDQUFhLFFBQXJDO0FBQ0EsUUFBTSxtQkFBbUIsa0NBQWEsU0FBYixFQUF3QixPQUF4QixFQUFpQyxlQUFqQyxDQUF6Qjs7QUFFQSxVQUFLLEtBQUwsR0FBYSxFQUFFLGtDQUFGLEVBQWI7QUFQaUI7QUFRbEI7Ozs7bUNBRWMsYSxFQUFlO0FBQUE7O0FBQzVCLFVBQU0sa0JBQWtCLEtBQUssS0FBTCxDQUFXLE9BQVgsQ0FBbUIsT0FBbkIsQ0FDdkIsTUFEdUIsQ0FDaEIsVUFBQyxJQUFEO0FBQUEsZUFBVSxrQkFBa0IsS0FBSyxJQUFqQztBQUFBLE9BRGdCLENBQXhCO0FBRUEsVUFBTSxtQkFBbUIsZ0JBQWdCLE1BQWhCLEdBQXlCLGdCQUFnQixDQUFoQixDQUF6QixHQUE4QyxFQUFFLE1BQU0sRUFBUixFQUFZLFlBQVksSUFBeEIsRUFBdkU7O0FBRUEsV0FBSyxRQUFMLENBQWMsRUFBRSxrQ0FBRixFQUFkOztBQUVBLFVBQU0sWUFBWSxLQUFLLEtBQUwsQ0FBVyxPQUFYLENBQW1CLFNBQXJDO0FBQ0EsVUFBTSxnQkFBZ0Isb0NBQWUsU0FBZixFQUEwQixnQkFBMUIsQ0FBdEI7O0FBRUEsVUFBTSxjQUFjLGNBQWMsTUFBZCxLQUF5QixDQUF6QixHQUE2QixjQUFjLENBQWQsRUFBaUIsSUFBOUMsR0FBcUQsRUFBekU7QUFDQSxVQUFNLGNBQWMsY0FBYyxNQUFkLEtBQXlCLENBQXpCLEdBQTZCLGNBQWMsQ0FBZCxFQUFpQixRQUE5QyxHQUF5RCxPQUE3RTtBQUNBLFdBQUssS0FBTCxDQUFXLE9BQVgsQ0FBbUIsV0FBbkIsQ0FBK0IsV0FBL0IsRUFBNEMsV0FBNUM7QUFDQSxVQUFJLENBQUMsaUJBQWlCLFVBQXRCLEVBQWtDO0FBQ2hDLG1CQUFXO0FBQUEsaUJBQU0sT0FBSyxJQUFMLENBQVUsTUFBVixDQUFpQixLQUFqQixFQUFOO0FBQUEsU0FBWCxFQUEyQyxFQUEzQyxFQURnQyxDQUNnQjtBQUNqRDtBQUNGOzs7cUNBRWdCLFcsRUFBYTtBQUFBOztBQUM1QixVQUFNLFlBQVksS0FBSyxLQUFMLENBQVcsT0FBWCxDQUFtQixTQUFyQztBQUNBLFVBQU0sb0JBQW9CLFVBQ3pCLE1BRHlCLENBQ2xCLFVBQUMsQ0FBRDtBQUFBLGVBQU8sZ0JBQWdCLEVBQUUsSUFBekI7QUFBQSxPQURrQixDQUExQjs7QUFHQSxVQUFNLGNBQWMsa0JBQWtCLE1BQWxCLEdBQTJCLGtCQUFrQixDQUFsQixFQUFxQixRQUFoRCxHQUEyRCxPQUEvRTtBQUNBLFdBQUssS0FBTCxDQUFXLE9BQVgsQ0FBbUIsV0FBbkIsQ0FBK0IsV0FBL0IsRUFBNEMsV0FBNUM7QUFDQSxpQkFBVztBQUFBLGVBQU0sT0FBSyxJQUFMLENBQVUsTUFBVixDQUFpQixLQUFqQixFQUFOO0FBQUEsT0FBWCxFQUEyQyxFQUEzQyxFQVA0QixDQU9vQjtBQUNqRDs7OzZCQUVRLEMsRUFBRztBQUNWLFVBQUksQ0FBQyxLQUFLLEtBQUwsQ0FBVyxNQUFYLENBQWtCLE9BQW5CLElBQThCLENBQUMsS0FBSyxLQUFMLENBQVcsTUFBWCxDQUFrQixRQUFyRCxFQUErRDtBQUMvRCxRQUFFLGNBQUY7QUFDQSxVQUFNLFdBQVcsS0FBSyxLQUFMLENBQVcsTUFBWCxDQUFrQixRQUFuQztBQUNBLFVBQU0sV0FBVyx5Q0FBb0IsS0FBSyxLQUFMLENBQVcsT0FBWCxDQUFtQixTQUF2QyxFQUFrRCxRQUFsRCxDQUFqQjs7QUFFQSxXQUFLLEtBQUwsQ0FBVyxPQUFYLENBQW1CLFdBQW5CLENBQStCLFFBQS9COztBQUVBLFVBQUksS0FBSyxLQUFMLENBQVcsWUFBZixFQUE2QjtBQUMzQixhQUFLLEtBQUwsQ0FBVyxPQUFYLENBQW1CLGNBQW5CLENBQWtDLEVBQUUsa0JBQUYsRUFBWSxrQkFBWixFQUFsQztBQUNELE9BRkQsTUFFTztBQUNMLGFBQUssS0FBTCxDQUFXLE9BQVgsQ0FBbUIsZUFBbkIsQ0FBbUMsVUFBbkM7QUFDRDtBQUNGOzs7NkJBRVE7QUFBQTs7QUFBQSwyQkFDd0IsS0FBSyxLQUFMLENBQVcsT0FEbkM7QUFBQSxVQUNDLFNBREQsa0JBQ0MsU0FERDtBQUFBLFVBQ1ksT0FEWixrQkFDWSxPQURaOztBQUVQLFVBQU0sa0JBQWtCLEtBQUssS0FBTCxDQUFXLE1BQVgsQ0FBa0IsUUFBMUM7QUFDQSxVQUFNLG1CQUFtQixLQUFLLEtBQUwsQ0FBVyxnQkFBcEM7O0FBRUEsVUFBTSxrQkFBa0Isb0NBQWUsU0FBZixFQUEwQixnQkFBMUIsRUFDdkIsR0FEdUIsQ0FDbkIsVUFBQyxHQUFEO0FBQUEsZUFBVTtBQUNiLGlCQUFPLElBQUksSUFERTtBQUViLGlCQUFPLElBQUk7QUFGRSxTQUFWO0FBQUEsT0FEbUIsQ0FBeEI7O0FBTUEsVUFBTSxnQkFBZ0IsUUFDckIsR0FEcUIsQ0FDakIsVUFBQyxHQUFEO0FBQUEsZUFBVTtBQUNiLGlCQUFPLElBQUksSUFERTtBQUViLGlCQUFPLElBQUk7QUFGRSxTQUFWO0FBQUEsT0FEaUIsQ0FBdEI7O0FBTUEsYUFDRTtBQUFBO0FBQUEsVUFBSyxJQUFHLGlCQUFSO0FBQ0ksYUFBSyxLQUFMLENBQVcsTUFBWCxDQUFrQixRQUFsQixHQUNBO0FBQUE7QUFBQSxZQUFLLFdBQVUsa0NBQWY7QUFDRSx1RkFBYyxLQUFLLEtBQUwsQ0FBVyxNQUFYLENBQWtCLFFBQWhDLElBQTBDLFFBQVEsS0FBSyxLQUFMLENBQVcsTUFBWCxDQUFrQixNQUFwRSxFQUE0RSxRQUFRLEtBQXBGO0FBREYsU0FEQSxHQUtBO0FBQUE7QUFBQSxZQUFLLFdBQVUscUJBQWY7QUFDRTtBQUFBO0FBQUEsY0FBSyxXQUFVLHFFQUFmO0FBQ0U7QUFBQTtBQUFBLGdCQUFLLFdBQVUsMEJBQWY7QUFDRTtBQUFBO0FBQUEsa0JBQUksV0FBVSxxQ0FBZDtBQUFBO0FBQUE7QUFERjtBQURGO0FBREYsU0FOSjtBQWNFO0FBQUE7QUFBQSxZQUFLLFdBQVUsd0JBQWY7QUFDRTtBQUFBO0FBQUEsY0FBSyxXQUFVLFlBQWY7QUFDRTtBQUFBO0FBQUE7QUFDRTtBQUFBO0FBQUEsa0JBQUksV0FBVSw0REFBZDtBQUEyRTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQTNFO0FBREYsYUFERjtBQUlFO0FBQUE7QUFBQSxnQkFBTSxjQUFhLEtBQW5CLEVBQXlCLFdBQVUsK0NBQW5DO0FBQ0Usd0JBQVEsS0FBSyxLQUFMLENBQVcsTUFEckIsRUFDNkIsUUFBUSxLQUFLLEtBQUwsQ0FBVyxNQURoRDtBQUVFLDBCQUFVLEtBQUssS0FBTCxDQUFXO0FBRnZCO0FBSUUsc0VBQWMsY0FBYyxLQUFLLEtBQUwsQ0FBVyxNQUFYLENBQWtCLFdBQWxCLE9BQW9DLEtBQWhFLEVBQXVFLGdCQUF2RSxHQUpGO0FBS0U7QUFBQTtBQUFBLGtCQUFLLFdBQVUsbUJBQWY7QUFDRTtBQUNFLHNCQUFHLGlCQURMO0FBRUUsNEJBQVUsa0JBQUMsQ0FBRDtBQUFBLDJCQUFPLE9BQUssY0FBTCxDQUFvQixDQUFwQixDQUFQO0FBQUEsbUJBRlo7QUFHRSx5QkFBTyxpQkFBaUIsSUFIMUI7QUFJRSwyQkFBUyxhQUpYO0FBS0Usb0NBQWlCO0FBTG5CO0FBREYsZUFMRjtBQWNHLCtCQUFpQixVQUFqQixHQUNEO0FBQUE7QUFBQTtBQUNFO0FBQUE7QUFBQSxvQkFBSyxXQUFVLG1CQUFmO0FBQ0U7QUFDRSx3QkFBRyxtQkFETDtBQUVFLCtCQUFVLHdCQUZaO0FBR0UsMEJBQUssVUFIUDtBQUlFLDhCQUFVLGtCQUFDLENBQUQ7QUFBQSw2QkFBTyxPQUFLLGdCQUFMLENBQXNCLENBQXRCLENBQVA7QUFBQSxxQkFKWjtBQUtFLDJCQUFPLGVBTFQ7QUFNRSw2QkFBUyxlQU5YO0FBT0Usc0NBQWlCO0FBUG5CO0FBREY7QUFERixlQURDLEdBY0MseUNBQU8sTUFBSyxRQUFaLEVBQXFCLE1BQUssVUFBMUIsRUFBcUMsT0FBTyxlQUE1QyxHQTVCSjtBQThCRTtBQUFBO0FBQUEsa0JBQVEsS0FBSSxRQUFaLEVBQXFCLFNBQVMsaUJBQUMsQ0FBRDtBQUFBLDJCQUFPLE9BQUssUUFBTCxDQUFjLENBQWQsQ0FBUDtBQUFBLG1CQUE5QixFQUF1RCxNQUFLLFFBQTVELEVBQXFFLFdBQVUsMEVBQS9FO0FBQUE7QUFBQTtBQTlCRjtBQUpGO0FBREYsU0FkRjtBQXFESSxTQUFDLEtBQUssS0FBTCxDQUFXLFlBQVosR0FDRjtBQUFBO0FBQUEsWUFBSyxXQUFVLHdCQUFmO0FBQ0U7QUFBQTtBQUFBLGNBQUssV0FBVSwwREFBZjtBQUNJO0FBQUE7QUFBQTtBQUFBO0FBQUEsYUFESjtBQUM0QztBQUFBO0FBQUE7QUFBQTtBQUFBLGFBRDVDO0FBRUk7QUFBQTtBQUFBLGdCQUFZLFVBQVMsUUFBckI7QUFBQTtBQUFBO0FBRko7QUFERixTQURFLEdBT0E7QUE1REosT0FERjtBQWdFRDs7Ozs7QUFHSCxtQkFBbUIsU0FBbkIsR0FBK0I7QUFDN0IsVUFBUSxpQkFBVSxNQUFWLENBQWlCLFVBREk7QUFFN0IsVUFBUSxpQkFBVSxNQUFWLENBQWlCLFVBRkk7QUFHN0IsV0FBUyxpQkFBVSxNQUFWLENBQWlCLFVBSEc7QUFJN0IsZ0JBQWMsaUJBQVUsSUFKSztBQUs3QixVQUFRLGlCQUFVLE1BQVYsQ0FBaUIsVUFMSTtBQU03QixVQUFRLGlCQUFVLE1BQVYsQ0FBaUI7QUFOSSxDQUEvQjs7QUFTQSxJQUFNLHFCQUFxQixTQUFyQixrQkFBcUIsQ0FBQyxRQUFEO0FBQUEsU0FBZTtBQUN4QyxhQUFTLCtCQUFtQixjQUFuQixFQUFtQyxRQUFuQztBQUQrQixHQUFmO0FBQUEsQ0FBM0I7O2tCQUllLHlCQUNkO0FBQUEsU0FBVTtBQUNSLFlBQVEsTUFBTSxNQUROO0FBRVIsWUFBUSxNQUFNLE1BRk47QUFHUixhQUFTLE1BQU07QUFIUCxHQUFWO0FBQUEsQ0FEYyxFQU1kLGtCQU5jLEVBT2Isa0JBUGEsQzs7Ozs7Ozs7OztrQkMvSlMsYzs7QUFIeEI7Ozs7QUFDQTs7Ozs7O0FBRWUsU0FBUyxjQUFULEdBQTBCO0FBQ3ZDLFNBQVE7QUFDTixZQUFPLGlCQUREO0FBRU4sWUFBTztBQUZELElBQVI7QUFJRDs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQ1JEOzs7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0lBQVksYzs7QUFDWjs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7Ozs7Ozs7QUFFQSxJQUFNLGNBQWMsK0NBQXNCLFFBQXRCLENBQXBCO0FBQ0EsSUFBTSxjQUFjLCtDQUFzQixRQUF0QixDQUFwQjtBQUNBLElBQU0scUJBQXFCLCtDQUFzQixTQUF0QixDQUEzQjtBQUNBLElBQU0scUJBQXFCLCtDQUFzQixTQUF0QixDQUEzQjs7SUFFYSxNLFdBQUEsTTs7Ozs7Ozs7Ozt1Q0FFUTtBQUNqQixhQUFVLEtBQUssS0FBTCxDQUFXLE1BQVgsQ0FBa0IsTUFBNUI7QUFDRDs7O3lDQUVvQjtBQUNuQixhQUFVLEtBQUssS0FBTCxDQUFXLE1BQVgsQ0FBa0IsTUFBNUI7QUFDRDs7O21DQUVjO0FBQ2IsV0FBSyxLQUFMLENBQVcsT0FBWCxDQUFtQixlQUFuQixDQUFtQyxRQUFuQztBQUNEOzs7cUNBRWdCO0FBQ2YsV0FBSyxLQUFMLENBQVcsT0FBWCxDQUFtQixlQUFuQixDQUFtQyxVQUFuQztBQUNEOzs7aUNBRVksQyxFQUFHO0FBQ2QsUUFBRSxjQUFGO0FBQ0EsVUFBTSxTQUFTLEVBQUUsTUFBakI7O0FBRUEsV0FBSyxLQUFMLENBQVcsT0FBWCxDQUFtQixVQUFuQixDQUE4QixZQUFNO0FBQ2xDLGVBQU8sTUFBUDtBQUNELE9BRkQ7QUFHRDs7OytCQUVVO0FBQ1QsYUFBTyxLQUFLLEtBQUwsQ0FBVyxNQUFYLEdBQW9CLG9CQUFZLEtBQUssS0FBTCxDQUFXLE1BQXZCLEVBQStCLE1BQS9CLENBQXNDLFVBQUMsQ0FBRDtBQUFBLGVBQU8sRUFBRSxVQUFGLENBQWEsU0FBYixDQUFQO0FBQUEsT0FBdEMsRUFBc0UsTUFBdEUsR0FBK0UsQ0FBbkcsR0FBdUcsS0FBOUc7QUFDRDs7O2dDQUVXLE8sRUFBUyxPLEVBQVM7QUFBQTs7QUFDNUIsVUFBTSxtQkFBaUIsT0FBdkI7QUFDQSxVQUFNLE9BQU8sUUFBUSxHQUFSLENBQVk7QUFBQSwyQkFBZSxDQUFmO0FBQUEsT0FBWixLQUFtQyxFQUFoRDtBQUNBLGFBQU8sVUFBQyxDQUFELEVBQU87QUFDWixZQUFNLFNBQVMsRUFBRSxNQUFqQjtBQUNBLGVBQUssS0FBTCxDQUFXLE9BQVgsQ0FBbUIsUUFBbkIsQ0FBNEIsUUFBNUIsRUFBc0MsT0FBTyxJQUE3QyxFQUFtRCxPQUFPLElBQVAsS0FBZ0IsVUFBaEIsSUFBOEIsT0FBTyxJQUFQLEtBQWdCLE9BQTlDLEdBQXdELE9BQU8sT0FBL0QsR0FBeUUsT0FBTyxLQUFuSTtBQUNBLGVBQUssS0FBTCxDQUFXLE9BQVgsQ0FBbUIsV0FBbkIsQ0FBK0IsSUFBL0IsRUFBcUMsSUFBckM7QUFDRCxPQUpEO0FBS0Q7Ozs2QkFFUTtBQUFBOztBQUNQLFVBQU0sTUFBTSxLQUFLLEtBQUwsQ0FBVyxNQUF2Qjs7QUFFQSxhQUNBO0FBQUE7QUFBQSxVQUFLLElBQUcsU0FBUixFQUFrQixXQUFVLHFFQUE1QjtBQUNJLGFBQUssS0FBTCxDQUFXLE1BQVgsQ0FBa0IsUUFBbEIsR0FDQSw2RUFBYyxLQUFLLEtBQUwsQ0FBVyxNQUFYLENBQWtCLFFBQWhDLElBQTBDLFFBQVEsS0FBSyxLQUFMLENBQVcsTUFBWCxDQUFrQixNQUFwRSxJQURBLEdBR0E7QUFBQTtBQUFBLFlBQUssV0FBVSwyQ0FBZjtBQUNFO0FBQUE7QUFBQSxjQUFJLFdBQVUscUNBQWQ7QUFBQTtBQUFBO0FBREYsU0FKSjtBQVFFO0FBQUE7QUFBQTtBQUNFO0FBQUE7QUFBQSxjQUFLLFdBQVUsS0FBZjtBQUNFO0FBQUE7QUFBQSxnQkFBSyxXQUFVLFdBQWY7QUFDRTtBQUFBO0FBQUE7QUFDRSw0QkFBVSxLQUFLLEtBQUwsQ0FBVyxNQUFYLENBQWtCLEtBQWxCLEtBQTRCLE1BQTVCLElBQXNDLEtBQUssS0FBTCxDQUFXLE1BQVgsQ0FBa0IsVUFBeEQsR0FBcUUsVUFBckUsR0FBa0YsSUFEOUY7QUFFRSwyQkFBUyxpQkFBQyxDQUFEO0FBQUEsMkJBQU8sT0FBSyxZQUFMLENBQWtCLENBQWxCLENBQVA7QUFBQSxtQkFGWDtBQUdFLDZCQUFVO0FBSFo7QUFLRyxxQkFBSyxLQUFMLENBQVcsTUFBWCxDQUFrQixVQUFsQixLQUFpQyxRQUFqQyxHQUNDLHFDQUFHLFdBQVUsc0NBQWIsR0FERCxHQUVDO0FBQUE7QUFBQSxvQkFBTSxXQUFVLFVBQWhCO0FBQTJCLHlEQUFLLE9BQU8sRUFBRSxTQUFTLGFBQVgsRUFBMEIsZUFBZSxRQUF6QyxFQUFaLEVBQWlFLEtBQUssS0FBSyxnQkFBTCxFQUF0RSxHQUEzQjtBQUFBO0FBQUE7QUFQSjtBQURGO0FBREYsV0FERjtBQWNFO0FBQUE7QUFBQSxjQUFLLFdBQVUsbUJBQWY7QUFDRTtBQUFBO0FBQUEsZ0JBQUssV0FBVSxXQUFmO0FBQ0U7QUFBQTtBQUFBO0FBQ0UsNEJBQVUsS0FBSyxLQUFMLENBQVcsTUFBWCxDQUFrQixLQUFsQixLQUE0QixNQUE1QixJQUFzQyxLQUFLLEtBQUwsQ0FBVyxNQUFYLENBQWtCLFVBQXhELEdBQXFFLFVBQXJFLEdBQWtGLElBRDlGO0FBRUUsMkJBQVMsaUJBQUMsQ0FBRDtBQUFBLDJCQUFPLE9BQUssY0FBTCxDQUFvQixDQUFwQixDQUFQO0FBQUEsbUJBRlg7QUFHRSw2QkFBVTtBQUhaO0FBS0cscUJBQUssS0FBTCxDQUFXLE1BQVgsQ0FBa0IsVUFBbEIsS0FBaUMsVUFBakMsR0FDQyxxQ0FBRyxXQUFVLHNDQUFiLEdBREQsR0FFQztBQUFBO0FBQUEsb0JBQU0sV0FBVSxVQUFoQjtBQUEyQix5REFBSyxPQUFPLEVBQUUsU0FBUyxhQUFYLEVBQTBCLGVBQWUsUUFBekMsRUFBWixFQUFpRSxLQUFLLEtBQUssa0JBQUwsRUFBdEUsR0FBM0I7QUFBQTtBQUFBO0FBUEo7QUFERjtBQURGLFdBZEY7QUE0QkU7QUFBQTtBQUFBLGNBQU0sY0FBYSxLQUFuQixFQUF5QixVQUFVLGtCQUFDLENBQUQ7QUFBQSx1QkFBTyxPQUFLLFlBQUwsQ0FBa0IsQ0FBbEIsQ0FBUDtBQUFBLGVBQW5DLEVBQWdFLE1BQUssTUFBckUsRUFBNEUsV0FBVSxpQ0FBdEYsRUFBd0gsUUFBTyxNQUEvSCxFQUFzSSxRQUFPLDZCQUE3STtBQUNFLHVFQURGO0FBRUU7QUFBQTtBQUFBLGdCQUFLLFdBQVUsV0FBZjtBQUNFO0FBQUE7QUFBQSxrQkFBTSxXQUFVLDBCQUFoQjtBQUFBO0FBQUE7QUFERixhQUZGO0FBS0U7QUFDRSxvQkFBSyxnQkFEUDtBQUVFLHFCQUFNLG1CQUZSO0FBR0Usb0JBQUssTUFIUDtBQUlFLHFCQUFPLEtBQUssS0FBTCxDQUFXLE1BQVgsQ0FBa0IsY0FKM0I7QUFLRSwwQkFBWSxZQUFZLFVBQVosRUFBd0IsR0FBeEIsQ0FMZDtBQU1FLDRCQUFjLFlBQVksVUFBWixFQUF3QixHQUF4QixDQU5oQjtBQU9FLHdCQUFVLEtBQUssV0FBTCxDQUFpQixVQUFqQixFQUE2QixDQUFDLFVBQUQsQ0FBN0IsQ0FQWjtBQVFFLHlCQUFVLE1BUlo7QUFTRSw0QkFBYTtBQVRmLGNBTEY7QUFnQkU7QUFDRSxvQkFBSyxVQURQO0FBRUUscUJBQU0sVUFGUjtBQUdFLG9CQUFLLE1BSFA7QUFJRSxxQkFBTyxLQUFLLEtBQUwsQ0FBVyxNQUFYLENBQWtCLFFBSjNCO0FBS0UsMEJBQVksWUFBWSxVQUFaLEVBQXdCLEdBQXhCLENBTGQ7QUFNRSw0QkFBYyxZQUFZLFVBQVosRUFBd0IsR0FBeEIsQ0FOaEI7QUFPRSx3QkFBVSxLQUFLLFdBQUwsQ0FBaUIsVUFBakIsRUFBNkIsQ0FBQyxVQUFELENBQTdCLENBUFo7QUFRRSxvQkFBSyxVQVJQO0FBU0UsNEJBQWE7QUFUZixjQWhCRjtBQTJCRTtBQUFBO0FBQUEsZ0JBQUssV0FBVSx5Q0FBZjtBQUNFO0FBQUE7QUFBQSxrQkFBSyxXQUFVLG1DQUFmO0FBQ0U7QUFBQTtBQUFBLG9CQUFPLFdBQVUsbUJBQWpCLEVBQXFDLE9BQU0sOENBQTNDO0FBQ0UsMkRBQU8sTUFBSyxVQUFaO0FBQ0UsMEJBQUssaUJBRFA7QUFFRSwyQkFBTSxNQUZSO0FBR0UsNkJBQVMsS0FBSyxLQUFMLENBQVcsTUFBWCxDQUFrQixlQUg3QjtBQUlFLDhCQUFVLEtBQUssV0FBTCxDQUFpQixpQkFBakIsRUFBb0MsRUFBcEM7QUFKWixvQkFERjtBQU9FO0FBQUE7QUFBQSxzQkFBTSxXQUFVLFVBQWhCO0FBQUE7QUFBQTtBQVBGO0FBREYsZUFERjtBQVlFO0FBQUE7QUFBQSxrQkFBWSxVQUFTLGdCQUFyQjtBQUFBO0FBQUE7QUFaRixhQTNCRjtBQXlDRTtBQUFBO0FBQUE7QUFDRTtBQUFBO0FBQUE7QUFDRSw0QkFBVSxLQUFLLEtBQUwsQ0FBVyxNQUFYLENBQWtCLEtBQWxCLEtBQTRCLE1BQTVCLElBQXNDLEtBQUssS0FBTCxDQUFXLE1BQVgsQ0FBa0IsV0FBbEIsS0FBa0MsTUFBeEUsR0FBaUYsVUFBakYsR0FBOEYsSUFEMUc7QUFFRSx3QkFBSyxRQUZQLEVBRWdCLFdBQVU7QUFGMUI7QUFJQyxxQkFBSyxLQUFMLENBQVcsV0FBWCxLQUEyQixNQUEzQixHQUNDLHFDQUFHLFdBQVUsaURBQWIsR0FERCxHQUVDO0FBTkY7QUFERjtBQXpDRixXQTVCRjtBQWdGRyw2QkFBbUIsY0FBbkIsRUFBbUMsR0FBbkMsSUFDQztBQUFBO0FBQUEsY0FBSyxXQUFVLEtBQWY7QUFDRTtBQUFBO0FBQUEsZ0JBQUssV0FBVSx5QkFBZjtBQUNFO0FBQUE7QUFBQSxrQkFBSyxXQUFVLGdCQUFmO0FBQWlDLG1DQUFtQixjQUFuQixFQUFtQyxHQUFuQztBQUFqQztBQURGO0FBREYsV0FERCxHQU1DO0FBdEZKLFNBUkY7QUFnR0U7QUFBQTtBQUFBLFlBQUssV0FBVSxVQUFmO0FBQ0U7QUFBQTtBQUFBLGNBQUssV0FBVSwrQ0FBZjtBQUNJO0FBQUE7QUFBQTtBQUFBO0FBQUEsYUFESjtBQUNrQztBQUFBO0FBQUE7QUFBQTtBQUFBLGFBRGxDO0FBRUk7QUFBQTtBQUFBLGdCQUFZLFVBQVMsVUFBckI7QUFBQTtBQUFBO0FBRko7QUFERjtBQWhHRixPQURBO0FBeUdEOzs7OztBQUdILE9BQU8sU0FBUCxHQUFtQjtBQUNqQixVQUFRLGlCQUFVLE1BQVYsQ0FBaUIsVUFEUjtBQUVqQixVQUFRLGlCQUFVLE1BQVYsQ0FBaUIsVUFGUjtBQUdqQixVQUFRLGlCQUFVLE1BQVYsQ0FBaUI7QUFIUixDQUFuQjs7QUFNQSxJQUFNLHFCQUFxQixTQUFyQixrQkFBcUIsQ0FBQyxRQUFEO0FBQUEsU0FBZTtBQUN4QyxhQUFTLCtCQUFtQixjQUFuQixFQUFtQyxRQUFuQztBQUQrQixHQUFmO0FBQUEsQ0FBM0I7O2tCQUllLHlCQUNkO0FBQUEsU0FBVTtBQUNSLFlBQVEsTUFBTSxNQUROO0FBRVIsWUFBUSxNQUFNLE1BRk47QUFHUixZQUFRLE1BQU07QUFITixHQUFWO0FBQUEsQ0FEYyxFQU1kLGtCQU5jLEVBT2IsTUFQYSxDOzs7Ozs7Ozs7OztBQ2pMZjs7Ozs7O0FBRUEsU0FBUyxRQUFULE9BQStEO0FBQUEsTUFBM0MsSUFBMkMsUUFBM0MsSUFBMkM7QUFBQSxNQUFyQyxJQUFxQyxRQUFyQyxJQUFxQztBQUFBLE1BQS9CLElBQStCLFFBQS9CLElBQStCO0FBQUEsTUFBekIsTUFBeUIsUUFBekIsTUFBeUI7QUFBQSx5QkFBakIsTUFBaUI7QUFBQSxNQUFqQixNQUFpQiwrQkFBUixJQUFROztBQUM3RCxNQUFNLFVBQVUsQ0FDZCxhQURjLEVBRWQsU0FBUyxrQkFBVCxHQUE4QixFQUZoQixrQkFHQSxJQUhBLEVBSWQsYUFKYyxFQUtkLGVBTGMsRUFNZCxhQU5jLEVBT2QsWUFQYyxDQUFoQjs7QUFVQSxTQUNFO0FBQUE7QUFBQSxNQUFLLFdBQVcsUUFBUSxJQUFSLENBQWEsR0FBYixDQUFoQjtBQUNFLDJDQUFLLEtBQVEsTUFBUixZQUFxQixJQUExQixFQUFrQyxRQUFPLElBQXpDLEdBREY7QUFFRTtBQUFBO0FBQUE7QUFBSTtBQUFKO0FBRkYsR0FERjtBQU1EOztBQUVELFNBQVMsU0FBVCxHQUFxQjtBQUNuQixRQUFNLGlCQUFVLE1BQVYsQ0FBaUIsVUFESjtBQUVuQixRQUFNLGlCQUFVLE1BQVYsQ0FBaUIsVUFGSjtBQUduQixRQUFNLGlCQUFVLE1BQVYsQ0FBaUIsVUFISjtBQUluQixVQUFRLGlCQUFVLE1BQVYsQ0FBaUIsVUFKTjtBQUtuQixVQUFRLGlCQUFVO0FBTEMsQ0FBckI7O2tCQVFlLFE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUM3QmY7Ozs7OztJQUVxQixZOzs7QUFDbkIsd0JBQVksS0FBWixFQUFtQjtBQUFBOztBQUFBLGtKQUNYLEtBRFc7O0FBRWpCLFVBQUssS0FBTCxHQUFhLEVBQUUsT0FBTyxNQUFNLEtBQU4sSUFBZSxFQUF4QixFQUFiO0FBRmlCO0FBR2xCOzs7OzRCQUVPLEMsRUFBRyxLLEVBQU87QUFDaEIsUUFBRSxjQUFGO0FBQ0EsVUFBTSxXQUFXLEtBQWpCO0FBQ0EsVUFBSSxhQUFhLEtBQUssS0FBTCxDQUFXLEtBQTVCLEVBQW1DO0FBQ2pDLGFBQUssUUFBTCxDQUFjLEVBQUUsT0FBTyxRQUFULEVBQWQ7QUFDQSxhQUFLLEtBQUwsQ0FBVyxRQUFYLENBQW9CLFFBQXBCO0FBQ0Q7QUFDRjs7OzZCQUVRO0FBQUE7O0FBQ1AsVUFBTSxVQUFVLEtBQUssS0FBTCxDQUFXLE9BQTNCOztBQUVBLGFBQVE7QUFBQTtBQUFBO0FBQ04sY0FBSSxLQUFLLEtBQUwsQ0FBVyxFQURUO0FBRU4scUJBQVcsS0FBSyxLQUFMLENBQVc7QUFGaEI7QUFJTCxhQUFLLEtBQUwsQ0FBVyxJQUFYLEdBQWtCLHlDQUFPLE1BQUssUUFBWixFQUFxQixPQUFPLEtBQUssS0FBTCxDQUFXLEtBQXZDLEVBQThDLE1BQU0sS0FBSyxLQUFMLENBQVcsSUFBL0QsR0FBbEIsR0FBNEYsSUFKdkY7QUFLTCxnQkFBUSxHQUFSLENBQVksVUFBQyxDQUFELEVBQUksS0FBSjtBQUFBLGlCQUNWLEVBQUUsS0FBRixLQUFZLE9BQUssS0FBTCxDQUFXLEtBQXZCLEdBQ0Q7QUFBQTtBQUFBLGNBQUssd0JBQXNCLEtBQTNCLEVBQW9DLFdBQVUsZ0NBQTlDO0FBQStFO0FBQUE7QUFBQSxnQkFBUSxXQUFVLHFEQUFsQixFQUF3RSxjQUF4RTtBQUFrRixnQkFBRTtBQUFwRjtBQUEvRSxXQURDLEdBR0Q7QUFBQTtBQUFBLGNBQUssd0JBQXNCLEtBQTNCLEVBQW9DLFdBQVUsZ0NBQTlDO0FBQStFO0FBQUE7QUFBQSxnQkFBUSxXQUFVLHlDQUFsQixFQUE0RCxTQUFTLGlCQUFDLENBQUQ7QUFBQSx5QkFBTyxPQUFLLE9BQUwsQ0FBYSxDQUFiLEVBQWdCLEVBQUUsS0FBbEIsQ0FBUDtBQUFBLGlCQUFyRTtBQUF1RyxnQkFBRTtBQUF6RztBQUEvRSxXQUpXO0FBQUEsU0FBWjtBQUxLLE9BQVI7QUFZRDs7Ozs7a0JBOUJrQixZOzs7QUFpQ3JCLGFBQWEsU0FBYixHQUF5QjtBQUN2QixNQUFJLGlCQUFVLE1BRFM7QUFFdkIsYUFBVyxpQkFBVSxNQUZFO0FBR3ZCLFdBQVMsaUJBQVUsS0FBVixDQUFnQixVQUhGO0FBSXZCLFlBQVUsaUJBQVUsSUFKRztBQUt2QixTQUFPLGlCQUFVLE1BTE07QUFNdkIsUUFBTSxpQkFBVTtBQU5PLENBQXpCOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FDbkNBOzs7Ozs7SUFFcUIsWTs7O0FBQ25CLHdCQUFZLEtBQVosRUFBbUI7QUFBQTs7QUFBQSxrSkFDWCxLQURXOztBQUVqQixVQUFLLEtBQUwsR0FBYSxFQUFFLE9BQU8sTUFBTSxLQUFOLElBQWUsRUFBeEIsRUFBYjtBQUZpQjtBQUdsQjs7Ozs2QkFFUSxDLEVBQUc7QUFDVixVQUFNLFdBQVcsRUFBRSxNQUFGLENBQVMsS0FBMUI7QUFDQSxVQUFJLGFBQWEsS0FBSyxLQUFMLENBQVcsS0FBNUIsRUFBbUM7QUFDakMsYUFBSyxRQUFMLENBQWMsRUFBRSxPQUFPLFFBQVQsRUFBZDtBQUNBLGFBQUssS0FBTCxDQUFXLFFBQVgsQ0FBb0IsUUFBcEI7QUFDRDtBQUNGOzs7NkJBRVE7QUFBQTs7QUFDUCxVQUFJLFVBQVUsRUFBZDtBQUNBLFVBQUksS0FBSyxLQUFMLENBQVcsZ0JBQWYsRUFBaUM7QUFDL0IsZ0JBQVEsSUFBUixDQUFhO0FBQ1gsaUJBQU8sS0FBSyxLQUFMLENBQVcsZ0JBRFA7QUFFWCxpQkFBTztBQUZJLFNBQWI7QUFJRDtBQUNELGdCQUFVLFFBQVEsTUFBUixDQUFlLEtBQUssS0FBTCxDQUFXLE9BQTFCLENBQVY7O0FBRUEsYUFBUTtBQUFBO0FBQUE7QUFDTix3QkFBYSxLQURQO0FBRU4sY0FBSSxLQUFLLEtBQUwsQ0FBVyxFQUZUO0FBR04scUJBQVcsS0FBSyxLQUFMLENBQVcsU0FIaEI7QUFJTixvQkFBVSxrQkFBQyxDQUFEO0FBQUEsbUJBQU8sT0FBSyxRQUFMLENBQWMsQ0FBZCxDQUFQO0FBQUEsV0FKSjtBQUtOLGlCQUFPLEtBQUssS0FBTCxDQUFXLEtBTFo7QUFNTixnQkFBTSxLQUFLLEtBQUwsQ0FBVztBQU5YO0FBUUwsZ0JBQVEsR0FBUixDQUFZLFVBQUMsQ0FBRCxFQUFJLEtBQUo7QUFBQSxpQkFDWDtBQUFBO0FBQUEsY0FBUSxpQkFBZSxLQUF2QixFQUFnQyxPQUFPLEVBQUUsS0FBekM7QUFBaUQsY0FBRTtBQUFuRCxXQURXO0FBQUEsU0FBWjtBQVJLLE9BQVI7QUFZRDs7Ozs7a0JBcENrQixZOzs7QUF1Q3JCLGFBQWEsU0FBYixHQUF5QjtBQUN2QixNQUFJLGlCQUFVLE1BRFM7QUFFdkIsYUFBVyxpQkFBVSxNQUZFO0FBR3ZCLFdBQVMsaUJBQVUsS0FBVixDQUFnQixVQUhGO0FBSXZCLG9CQUFrQixpQkFBVSxNQUpMO0FBS3ZCLFlBQVUsaUJBQVUsSUFMRztBQU12QixTQUFPLGlCQUFVLE1BTk07QUFPdkIsUUFBTSxpQkFBVTtBQVBPLENBQXpCOzs7Ozs7Ozs7O1FDckNnQixZLEdBQUEsWTs7QUFKaEI7Ozs7QUFDQTs7QUFDQTs7OztBQUVPLFNBQVMsWUFBVCxPQUF3RTtBQUFBLE1BQWhELE1BQWdELFFBQWhELE1BQWdEO0FBQUEsTUFBeEMsWUFBd0MsUUFBeEMsWUFBd0M7QUFBQSxNQUExQixVQUEwQixRQUExQixVQUEwQjtBQUFBLE1BQWQsVUFBYyxRQUFkLFVBQWM7O0FBQzdFLE1BQU0sY0FBYyw4QkFBZSxPQUFPLE1BQXRCLEVBQThCLE9BQU8sVUFBckMsQ0FBcEI7O0FBRUEsTUFBTSxvQkFBb0IsQ0FBQyxRQUFELEVBQVcsVUFBWCxFQUF1QixhQUF2QixFQUFzQyxnQkFBdEMsRUFDdkIsTUFEdUIsQ0FDaEIsVUFBQyxJQUFEO0FBQUEsV0FBVSxlQUFlLFlBQVksSUFBWixDQUF6QjtBQUFBLEdBRGdCLEVBRXZCLEdBRnVCLENBRW5CLFVBQUMsSUFBRDtBQUFBLFdBQVUseUNBQU8sTUFBSyxRQUFaLEVBQXFCLEtBQUssSUFBMUIsRUFBZ0MsTUFBTSxJQUF0QyxFQUE0QyxPQUFPLFlBQVksSUFBWixDQUFuRCxHQUFWO0FBQUEsR0FGbUIsQ0FBMUI7O0FBSUEsU0FBUTtBQUFBO0FBQUE7QUFDTCxxQkFESztBQUVMLFdBQU8sR0FBUCxHQUFhLHlDQUFPLE1BQUssUUFBWixFQUFxQixNQUFLLEtBQTFCLEVBQWdDLE9BQU8sT0FBTyxHQUE5QyxHQUFiLEdBQXFFLElBRmhFO0FBR0wsS0FBQyxVQUFELEdBQWMseUNBQU8sV0FBVSxhQUFqQixFQUErQixNQUFLLFFBQXBDLEVBQTZDLE1BQUssVUFBbEQsRUFBNkQsT0FBTyxPQUFPLFFBQVAsSUFBbUIsT0FBdkYsR0FBZCxHQUFtSCxJQUg5RztBQUlMLEtBQUMsVUFBRCxJQUFlLE9BQU8sUUFBdEIsR0FBaUMseUNBQU8sV0FBVSxZQUFqQixFQUE4QixNQUFLLFFBQW5DLEVBQTRDLE1BQUssVUFBakQsRUFBNEQsT0FBTyxPQUFPLFFBQTFFLEdBQWpDLEdBQTBILElBSnJIO0FBS0wsV0FBTyxNQUFQLEdBQWdCLHlDQUFPLFdBQVUsV0FBakIsRUFBNkIsTUFBSyxRQUFsQyxFQUEyQyxNQUFLLFFBQWhELEVBQXlELE9BQU8sT0FBTyxNQUF2RSxHQUFoQixHQUFvRyxJQUwvRjtBQU1OLDZDQUFPLE1BQUssUUFBWixFQUFxQixNQUFLLE9BQTFCLEVBQWtDLE9BQU8sT0FBTyxLQUFoRCxHQU5NO0FBT0wsS0FBQyxZQUFELEdBQWdCLHlDQUFPLE1BQUssUUFBWixFQUFxQixNQUFLLGFBQTFCLEVBQXdDLE9BQU8sT0FBTyxTQUF0RCxHQUFoQixHQUFzRixJQVBqRjtBQVFMLFdBQU8sZ0JBQVAsR0FBMEIseUNBQU8sV0FBVSxVQUFqQixFQUE0QixNQUFLLFFBQWpDLEVBQTBDLE1BQUssUUFBL0MsRUFBd0QsT0FBTSxNQUE5RCxHQUExQixHQUFvRyxJQVIvRjtBQVNMLFdBQU8sY0FBUCxDQUFzQixVQUF0QixJQUFvQyx5Q0FBTyxNQUFLLFFBQVosRUFBcUIsTUFBSyxVQUExQixFQUFxQyxPQUFPLE9BQU8sUUFBbkQsR0FBcEMsR0FBc0c7QUFUakcsR0FBUjtBQVdEOztBQUVELGFBQWEsU0FBYixHQUF5QjtBQUN2QixVQUFRLGlCQUFVLE1BQVYsQ0FBaUIsVUFERjtBQUV2QixnQkFBYyxpQkFBVSxJQUZEO0FBR3ZCLGNBQVksaUJBQVUsSUFIQztBQUl2QixjQUFZLGlCQUFVO0FBSkMsQ0FBekI7O2tCQU9lLHlCQUNkO0FBQUEsU0FBVTtBQUNSLFlBQVEsTUFBTTtBQUROLEdBQVY7QUFBQSxDQURjLEVBSWIsWUFKYSxDOzs7Ozs7Ozs7OztBQy9CZjs7Ozs7O0FBRUEsU0FBUyxVQUFULE9BQXdDO0FBQUEsTUFBbEIsSUFBa0IsUUFBbEIsSUFBa0I7QUFBQSxNQUFaLFFBQVksUUFBWixRQUFZOztBQUN0QyxNQUFJLENBQUMsSUFBTCxFQUFXLE9BQU87QUFBQTtBQUFBO0FBQU07QUFBTixHQUFQO0FBQ1gsU0FDRTtBQUFBO0FBQUEsTUFBSyxXQUFVLGlCQUFmO0FBQ0U7QUFBQTtBQUFBLFFBQU0sV0FBVSx3QkFBaEI7QUFBeUMsMkNBQUcsMEJBQXdCLElBQTNCO0FBQXpDLEtBREY7QUFFRztBQUZILEdBREY7QUFNRDs7QUFFRCxXQUFXLFNBQVgsR0FBdUI7QUFDckIsUUFBTSxpQkFBVTtBQURLLENBQXZCOztBQUlBLFNBQVMsVUFBVCxRQUFxSDtBQUFBLE1BQS9GLFVBQStGLFNBQS9GLFVBQStGO0FBQUEsTUFBbkYsWUFBbUYsU0FBbkYsWUFBbUY7QUFBQSxNQUFyRSxLQUFxRSxTQUFyRSxLQUFxRTtBQUFBLE1BQTlELEtBQThELFNBQTlELEtBQThEO0FBQUEsTUFBdkQsSUFBdUQsU0FBdkQsSUFBdUQ7QUFBQSxNQUFqRCxRQUFpRCxTQUFqRCxRQUFpRDtBQUFBLE1BQXZDLElBQXVDLFNBQXZDLElBQXVDO0FBQUEsTUFBakMsSUFBaUMsU0FBakMsSUFBaUM7QUFBQSxNQUEzQixTQUEyQixTQUEzQixTQUEyQjtBQUFBLE1BQWhCLFlBQWdCLFNBQWhCLFlBQWdCOztBQUNuSCxNQUFNLGVBQWEsSUFBbkI7QUFDQSxNQUFNLGFBQWEsUUFBUSxNQUEzQjtBQUNBLFNBQ0U7QUFBQTtBQUFBLE1BQUssV0FBVyxVQUFoQjtBQUNFO0FBQUMsZ0JBQUQ7QUFBQSxRQUFZLE1BQU0sSUFBbEI7QUFDRTtBQUFBO0FBQUEsVUFBTyxXQUFVLDZDQUFqQixFQUErRCxTQUFTLEVBQXhFO0FBQTZFO0FBQTdFLE9BREY7QUFFRSwrQ0FBTyxVQUFVLFFBQWpCLEVBQTJCLElBQUksRUFBL0IsRUFBbUMsTUFBTSxVQUF6QztBQUNFLGNBQU0sSUFEUjtBQUVFLHFCQUFhLEtBRmY7QUFHRSxtQkFBVSwyQ0FIWjtBQUlFLGVBQU8sS0FKVDtBQUtFLG1CQUFXLFNBTGI7QUFNRSxzQkFBYztBQU5oQjtBQUZGLEtBREY7QUFZQTtBQUFBO0FBQUEsUUFBSyxXQUFVLGdCQUFmO0FBQWlDO0FBQWpDO0FBWkEsR0FERjtBQWdCRDs7QUFFRCxXQUFXLFNBQVgsR0FBdUI7QUFDckIsY0FBWSxpQkFBVSxNQUFWLENBQWlCLFVBRFI7QUFFckIsZ0JBQWMsaUJBQVUsTUFBVixDQUFpQixVQUZWO0FBR3JCLFNBQU8saUJBQVUsTUFBVixDQUFpQixVQUhIO0FBSXJCLFFBQU0saUJBQVUsTUFKSztBQUtyQixTQUFPLGlCQUFVLE1BQVYsQ0FBaUIsVUFMSDtBQU1yQixRQUFNLGlCQUFVLE1BQVYsQ0FBaUIsVUFORjtBQU9yQixRQUFNLGlCQUFVLE1BUEs7QUFRckIsWUFBVSxpQkFBVSxJQUFWLENBQWUsVUFSSjtBQVNyQixhQUFXLGlCQUFVLE1BVEE7QUFVckIsZ0JBQWMsaUJBQVU7QUFWSCxDQUF2Qjs7a0JBYWUsVTs7Ozs7Ozs7OztRQzdDQyxVLEdBQUEsVTs7QUFMaEI7Ozs7QUFDQTs7QUFDQTs7QUFDQTs7SUFBWSxjOzs7Ozs7QUFFTCxTQUFTLFVBQVQsT0FBNkQ7QUFBQSxNQUF2QyxNQUF1QyxRQUF2QyxNQUF1QztBQUFBLE1BQS9CLFFBQStCLFFBQS9CLFFBQStCO0FBQUEsTUFBckIsUUFBcUIsUUFBckIsUUFBcUI7QUFBQSxNQUFYLE9BQVcsUUFBWCxPQUFXOztBQUNsRSxNQUFNLGdCQUFnQjtBQUNwQixZQUFRLFNBRFk7QUFFcEIsb0JBQWdCLGlCQUZJO0FBR3BCLGNBQVUsT0FBTyxnQkFBUCxHQUEwQixRQUExQixHQUFxQztBQUgzQixHQUF0Qjs7QUFNQSxNQUFNLGVBQWUsY0FBYyxRQUFkLENBQXJCOztBQUVBLE1BQU0sV0FBVyxTQUFYLFFBQVcsQ0FBQyxDQUFELEVBQU87QUFDdEIsUUFBSSxDQUFDLE9BQU8sT0FBUixJQUFtQixDQUFDLE9BQU8sUUFBL0IsRUFBeUM7QUFDekMsTUFBRSxjQUFGO0FBQ0EsWUFBUSxlQUFSLENBQXdCLFlBQXhCO0FBQ0QsR0FKRDs7QUFNQSxNQUFNLGFBQWEsbUJBQW1CLE9BQU8sR0FBMUIsQ0FBbkI7QUFDQSxNQUFNLGdCQUFnQixtQkFBbUIsT0FBTyxNQUExQixDQUF0Qjs7QUFFQSxNQUFNLEtBQUssRUFBWDtBQUNBLE1BQUksT0FBTyxHQUFYLEVBQWdCO0FBQ2QsT0FBRyxJQUFILFVBQWUsVUFBZjtBQUNEO0FBQ0QsTUFBSSxPQUFPLGdCQUFYLEVBQTZCO0FBQzNCLE9BQUcsSUFBSCxDQUFRLGFBQVI7QUFDRDtBQUNELE1BQUksUUFBUSxPQUFPLFVBQW5CLEVBQStCO0FBQzdCLE9BQUcsSUFBSCxhQUFrQixPQUFPLFVBQVAsQ0FBa0IsRUFBcEM7QUFDRDtBQUNELE1BQUksVUFBVSxPQUFPLFVBQXJCLEVBQWlDO0FBQy9CLE9BQUcsSUFBSCxlQUFvQixPQUFPLFVBQVAsQ0FBa0IsSUFBdEM7QUFDRDtBQUNELE1BQUksYUFBYSxPQUFPLFVBQXhCLEVBQW9DO0FBQ2xDLE9BQUcsSUFBSCxrQkFBdUIsT0FBTyxVQUFQLENBQWtCLE9BQXpDO0FBQ0Q7QUFDRCxNQUFJLGdCQUFnQixPQUFPLFVBQTNCLEVBQXVDO0FBQ3JDLE9BQUcsSUFBSCxxQkFBMEIsT0FBTyxVQUFQLENBQWtCLFVBQTVDO0FBQ0Q7QUFDRCxNQUFJLE9BQU8sTUFBWCxFQUFtQjtBQUNqQixPQUFHLElBQUgsYUFBa0IsYUFBbEI7QUFDRDtBQUNELE1BQUksT0FBTyxjQUFQLENBQXNCLFVBQXRCLENBQUosRUFBdUM7QUFDckMsT0FBRyxJQUFILGVBQW9CLE9BQU8sUUFBM0I7QUFDRDtBQUNELE1BQUksT0FBTyxLQUFYLEVBQWtCO0FBQ2hCLE9BQUcsSUFBSCxZQUFpQixPQUFPLEtBQXhCO0FBQ0Q7O0FBRUQsTUFBTSxXQUFXO0FBQ2YsWUFBUSxnQkFETztBQUVmLG9CQUFnQix3QkFGRDtBQUdmLDBCQUFvQjtBQUhMLEdBQWpCOztBQU1BLE1BQU0sVUFBVSxTQUFTLFFBQVQsQ0FBaEI7QUFDQSxNQUFNLE1BQU0sR0FBRyxNQUFILEdBQWUsT0FBZixTQUEwQixHQUFHLElBQUgsQ0FBUSxHQUFSLENBQTFCLEdBQTJDLE9BQXZEO0FBQ0EsTUFBTSxhQUFhLGFBQWEsZ0JBQWIsR0FBZ0MsYUFBaEMsR0FBZ0QsRUFBbkU7QUFDQSxTQUNFO0FBQUE7QUFBQSxNQUFHLFNBQVMsUUFBWixFQUFzQixNQUFNLEdBQTVCLEVBQWlDLGdEQUE4QyxVQUEvRTtBQUE4RjtBQUE5RixHQURGO0FBRUQ7O0FBRUQsV0FBVyxTQUFYLEdBQXVCO0FBQ3JCLFVBQVEsaUJBQVUsTUFBVixDQUFpQixVQURKO0FBRXJCLFdBQVMsaUJBQVUsTUFBVixDQUFpQixVQUZMO0FBR3JCLFlBQVUsaUJBQVUsTUFBVixDQUFpQjtBQUhOLENBQXZCOztBQU1BLElBQU0scUJBQXFCLFNBQXJCLGtCQUFxQixDQUFDLFFBQUQ7QUFBQSxTQUFlO0FBQ3hDLGFBQVMsK0JBQW1CLGNBQW5CLEVBQW1DLFFBQW5DO0FBRCtCLEdBQWY7QUFBQSxDQUEzQjs7a0JBSWUseUJBQ2Q7QUFBQSxTQUFVO0FBQ1IsWUFBUSxNQUFNO0FBRE4sR0FBVjtBQUFBLENBRGMsRUFJZCxrQkFKYyxFQUtiLFVBTGEsQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUMxRWY7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7OztBQUpBO0FBTUEsSUFBSTtBQUNGLFNBQU8sT0FBUCxHQUFpQiw2QkFBZ0IsT0FBakM7QUFDRCxDQUZELENBRUUsT0FBTyxDQUFQLEVBQVU7QUFDVjtBQUNEOztBQUVELElBQU0sWUFBWSxTQUFaLFNBQVksR0FBTTtBQUN0QixNQUFJLE9BQU8sUUFBUCxDQUFnQixNQUFwQixFQUE0QjtBQUMxQixXQUFPLE9BQU8sUUFBUCxDQUFnQixNQUF2QjtBQUNEO0FBQ0QsTUFBTSxPQUFPLE9BQU8sUUFBUCxDQUFnQixJQUFoQixTQUEyQixPQUFPLFFBQVAsQ0FBZ0IsSUFBM0MsR0FBb0QsRUFBakU7QUFDQSxNQUFNLFdBQVcsT0FBTyxRQUFQLENBQWdCLFFBQWpDO0FBQ0EsTUFBTSxXQUFXLE9BQU8sUUFBUCxDQUFnQixRQUFqQztBQUNBLFNBQVUsUUFBVixVQUF1QixRQUF2QixHQUFrQyxJQUFsQztBQUNELENBUkQ7O0FBVUEsSUFBTSx3QkFBd0IsSUFBOUI7QUFDQSxJQUFNLDJCQUEyQixLQUFqQzs7QUFFQSxJQUFNLGdCQUFnQjtBQUNwQixRQUFNLE1BRGM7QUFFcEIsZUFBYSxrQkFGTztBQUdwQixXQUFTO0FBQ1AsWUFBUSxrQkFERDtBQUVQLDBCQUFzQjtBQUZmO0FBSFcsQ0FBdEI7O0FBU0EsU0FBUyxXQUFULENBQXFCLFFBQXJCLEVBQStCLElBQS9CLEVBQXFDLEtBQXJDLEVBQTRDO0FBQzFDLE1BQUksd0JBQUo7QUFDQSxNQUFJLGdCQUFKO0FBQ0EsTUFBSSxLQUFKLEVBQVc7QUFDVCxRQUFNLEtBQUssSUFBSSxJQUFKLEVBQVg7QUFDQSxRQUFNLFFBQVEscUJBQWUsS0FBZixFQUFzQixHQUF0QixFQUEyQixVQUFDLEdBQUQ7QUFBQSxhQUFTLE9BQU8sSUFBSSxNQUFKLEtBQWUsQ0FBL0I7QUFBQSxLQUEzQixFQUE2RDtBQUFBLGFBQ3pFLFVBQUMsQ0FBRCxFQUFJLENBQUosRUFBVTtBQUNSLFlBQU0sS0FBSyxJQUFJLElBQUosRUFBWDtBQUNBLGdCQUFRLEdBQVIscUNBQThDLEVBQUUsS0FBaEQsZ0JBQStELEtBQUssRUFBcEU7QUFDRCxPQUp3RTtBQUFBLEtBQTdELENBQWQ7QUFNQSxzQkFBa0Isd0JBQWxCO0FBQ0EsY0FBVSxxQkFBVjtBQUNELEdBVkQsTUFVTztBQUNMO0FBQ0EsY0FBVSx3QkFBVjtBQUNEOztBQWhCeUMsYUFrQmYsU0FBUyxNQUFULENBQWdCLEtBQWhCLENBQXNCLGNBQXRCLEtBQXlDLEVBbEIxQjtBQUFBO0FBQUEsTUFrQm5DLEtBbEJtQztBQUFBLE1Ba0I1QixTQWxCNEI7O0FBb0IxQyxTQUFPLGdCQUFnQixzQkFBYyxFQUFkLEVBQWtCLGFBQWxCLEVBQWlDO0FBQ3RELFNBQUssUUFEaUQ7QUFFdEQsWUFBUSxNQUY4QztBQUd0RCxvQkFIc0Q7QUFJdEQsVUFBTSx5QkFBZSxJQUFmLENBSmdEO0FBS3RELGFBQVMsc0JBQWMsRUFBZCxFQUFrQixjQUFjLE9BQWhDLEVBQXlDLFNBQVMsU0FBVCxHQUFxQjtBQUNyRSxzQkFBZ0IsU0FBUztBQUQ0QyxLQUFyQixHQUU5QyxFQUZLO0FBTDZDLEdBQWpDLENBQWhCLENBQVA7QUFTRDs7QUFFRCxJQUFNLFVBQVUsdUJBQWlCLFVBQUMsQ0FBRCxFQUFPO0FBQ3RDLE1BQUk7QUFDRixXQUFPLEVBQUUsSUFBRixDQUFPLEtBQVAsR0FBZSxFQUFFLElBQUYsQ0FBTyxLQUF0QixHQUE4QixJQUFyQztBQUNELEdBRkQsQ0FFRSxPQUFPLENBQVAsRUFBVTtBQUNWLFdBQU8sSUFBUDtBQUNEO0FBQ0YsQ0FOZSxDQUFoQjtBQU9BLElBQU0sZ0JBQWdCLDBCQUF0Qjs7QUFFQSxTQUFTLFVBQVQsQ0FBb0IsUUFBcEIsRUFBOEIsSUFBOUIsRUFBb0M7QUFDbEMsTUFBTSxVQUFVLHdCQUFoQjs7QUFFQSxTQUFPLGNBQWMsc0JBQWMsRUFBZCxFQUFrQixhQUFsQixFQUFpQztBQUNwRCxTQUFLLFFBRCtDO0FBRXBELFlBQVEsS0FGNEM7QUFHcEQsb0JBSG9EO0FBSXBEO0FBSm9ELEdBQWpDLENBQWQsQ0FBUDtBQU1EOztBQUVELElBQU0sU0FBVSxTQUFTLFNBQVQsR0FBcUI7QUFDbkMsTUFBSTtBQUNGLFdBQU8sT0FBTyxHQUFQLENBQVcsTUFBbEI7QUFDRCxHQUZELENBRUUsT0FBTyxDQUFQLEVBQVU7QUFDVixXQUFPO0FBQ0wsVUFBSSxjQUFNLENBQUUsQ0FEUDtBQUVMLGVBQVMsbUJBQU0sQ0FBRTtBQUZaLEtBQVA7QUFJRDtBQUNGLENBVGUsRUFBaEI7O0FBV0EsSUFBTSxNQUFNO0FBQ1YsZ0JBRFUsMEJBQ0ssUUFETCxFQUNlO0FBQ3ZCLFdBQU8sV0FBVyxzQkFBWCxFQUFtQyxFQUFFLGtCQUFGLEVBQW5DLENBQVA7QUFDRCxHQUhTO0FBS1YsYUFMVSx1QkFLRSxLQUxGLEVBS1M7QUFDakIsV0FBTyxXQUFXLHNCQUFYLEVBQW1DLEVBQUUsWUFBRixFQUFuQyxDQUFQO0FBQ0QsR0FQUztBQVNWLFFBVFUsa0JBU0gsSUFURyxFQVNHO0FBQ1gsV0FBTyxZQUFZLDZCQUFaLEVBQTJDLElBQTNDLEVBQWlELENBQWpELENBQVA7QUFDRCxHQVhTO0FBYVYsVUFiVSxvQkFhRCxJQWJDLEVBYUs7QUFDYixXQUFPLFlBQVksOEJBQVosRUFBNEMsSUFBNUMsQ0FBUDtBQUNELEdBZlM7QUFpQlYsYUFqQlUsdUJBaUJFLFFBakJGLEVBaUJZLElBakJaLEVBaUJrQjtBQUMxQixXQUFPLHNCQUFZLFVBQUMsT0FBRCxFQUFVLE1BQVYsRUFBcUI7QUFDdEMsVUFBTSxTQUFTLG9CQUFZLElBQVosRUFDWixNQURZLENBQ0w7QUFBQSxlQUFLLENBQUMsQ0FBQyxLQUFLLENBQUwsQ0FBUDtBQUFBLE9BREssRUFFWixHQUZZLENBRVI7QUFBQSxlQUFLLENBQUMsQ0FBRCxFQUFJLG1CQUFtQixLQUFLLENBQUwsQ0FBbkIsQ0FBSixDQUFMO0FBQUEsT0FGUSxFQUdaLEdBSFksQ0FHUixVQUFDLENBQUQ7QUFBQSxlQUFVLEVBQUUsQ0FBRixDQUFWLFNBQWtCLEVBQUUsQ0FBRixDQUFsQjtBQUFBLE9BSFEsRUFJWixJQUpZLENBSVAsR0FKTyxDQUFmOztBQU1BLFVBQU0sbUJBQWlCLFFBQWpCLFNBQTZCLE1BQW5DOztBQUVBLFVBQUksQ0FBQyxLQUFLLE9BQVYsRUFBbUI7QUFDakIsZUFBTyxPQUFPLFFBQVAsQ0FBZ0IsTUFBaEIsQ0FBdUIsSUFBdkIsQ0FBUDtBQUNEOztBQUVELFVBQUksT0FBTyxLQUFYOztBQUVBLFVBQU0sY0FBYyxPQUFPLElBQVAsQ0FBWSxJQUFaLEVBQWtCLEVBQWxCLEVBQXNCLDBDQUF0QixDQUFwQjs7QUFFQSxlQUFTLFNBQVQsQ0FBbUIsR0FBbkIsRUFBd0I7QUFDdEIsWUFBSSxZQUFKO0FBQ0EsWUFBSSxJQUFJLE1BQUosS0FBZSxXQUFuQixFQUFnQztBQUNoQyxZQUFJO0FBQ0YsZ0JBQU0sc0JBQU8sSUFBSSxJQUFYLE1BQW9CLFFBQXBCLEdBQStCLElBQUksSUFBbkMsR0FBMEMsS0FBSyxLQUFMLENBQVcsSUFBSSxJQUFmLENBQWhEO0FBQ0QsU0FGRCxDQUVFLE9BQU8sQ0FBUCxFQUFVO0FBQ1Y7QUFDQTtBQUNBO0FBQ0Q7QUFDRCxZQUFJLElBQUksTUFBSixLQUFlLGFBQW5CLEVBQWtDO0FBQ2hDO0FBQ0Q7QUFDRCxZQUFJLElBQUksTUFBSixLQUFlLElBQWYsSUFBdUIsSUFBSSxNQUFKLEtBQWUsT0FBMUMsRUFBbUQ7QUFDakQsaUJBQU8sSUFBUDtBQUNBLGlCQUFPLG1CQUFQLENBQTJCLFNBQTNCLEVBQXNDLFNBQXRDO0FBQ0Esc0JBQVksS0FBWjtBQUNEO0FBQ0QsWUFBSSxJQUFJLE1BQUosS0FBZSxJQUFuQixFQUF5QjtBQUN2QjtBQUNBLGNBQUksSUFBSSxhQUFSLEVBQXVCO0FBQ3JCLGdCQUFNLE1BQU0sSUFBSSxLQUFKLENBQVUscUJBQVYsQ0FBWjtBQUNBLGdCQUFJLGFBQUosR0FBb0IsSUFBcEI7QUFDQSxtQkFBTyxPQUFPLEdBQVAsQ0FBUDtBQUNEO0FBQ0Q7QUFDRDtBQUNELFlBQUksSUFBSSxNQUFKLEtBQWUsT0FBbkIsRUFBNEI7QUFDMUIsaUJBQU8sSUFBSSxLQUFKLENBQVUsSUFBSSxTQUFkLENBQVA7QUFDRDtBQUNGOztBQUVELGFBQU8sZ0JBQVAsQ0FBd0IsU0FBeEIsRUFBbUMsU0FBbkM7O0FBRUEsVUFBTSxpQkFBaUIsT0FBTyxXQUFQLENBQW1CLFlBQU07QUFDOUMsWUFBTSxZQUFZLFNBQVosU0FBWSxDQUFDLFNBQUQsRUFBZTtBQUMvQixjQUFJLENBQUMsSUFBTCxFQUFXO0FBQ1QsbUJBQU8sSUFBSSxLQUFKLENBQVUsU0FBVixDQUFQO0FBQ0Q7QUFDRCxpQkFBTyxtQkFBUCxDQUEyQixTQUEzQixFQUFzQyxTQUF0QztBQUNBLGlCQUFPLGFBQVAsQ0FBcUIsY0FBckI7QUFDRCxTQU5EO0FBT0EsWUFBSTtBQUNGLGNBQUksQ0FBQyxXQUFMLEVBQWtCO0FBQ2hCLHNCQUFhLFFBQWI7QUFDRCxXQUZELE1BRU8sSUFBSSxZQUFZLE1BQWhCLEVBQXdCO0FBQzdCLHNCQUFhLFFBQWI7QUFDRDtBQUNGLFNBTkQsQ0FNRSxPQUFPLENBQVAsRUFBVTtBQUNWO0FBQ0Q7QUFDRixPQWpCc0IsRUFpQnBCLElBakJvQixDQUF2QjtBQWtCRCxLQXJFTSxDQUFQO0FBc0VELEdBeEZTO0FBMEZWLGdCQTFGVSwwQkEwRkssSUExRkwsRUEwRlc7QUFDbkIsV0FBTyxZQUFZLDRCQUFaLEVBQTBDLElBQTFDLENBQVA7QUFDRCxHQTVGUztBQThGVixnQkE5RlUsMEJBOEZLLElBOUZMLEVBOEZXO0FBQ25CLFdBQU8sWUFBWSx5QkFBWixFQUF1QyxJQUF2QyxDQUFQO0FBQ0QsR0FoR1M7QUFrR1YsUUFsR1Usa0JBa0dILEdBbEdHLEVBa0dFO0FBQ1YsUUFBSSxHQUFKLEVBQVM7QUFDUCxhQUFPLFFBQVAsQ0FBZ0IsTUFBaEIsQ0FBdUIsR0FBdkI7QUFDRCxLQUZELE1BRU87QUFDTCxhQUFPLFFBQVAsQ0FBZ0IsTUFBaEIsQ0FBdUIsSUFBdkI7QUFDRDtBQUNGLEdBeEdTO0FBMEdWLGVBMUdVLDJCQTBHTTtBQUNkLFdBQU8sT0FBUCxDQUFlLFdBQWY7QUFDRCxHQTVHUztBQThHVixpQkE5R1UsNkJBOEdRO0FBQ2hCLFdBQU8sT0FBUCxDQUFlLGFBQWYsRUFBOEIsU0FBOUI7QUFDRDtBQWhIUyxDQUFaOztrQkFtSGUsRzs7Ozs7Ozs7Ozs7Ozs7O1FDN01DLG9CLEdBQUEsb0I7UUFxQkEsUSxHQUFBLFE7UUFpQkEsUyxHQUFBLFM7UUFJQSxTLEdBQUEsUztRQUlBLE0sR0FBQSxNOzs7O0FBcERoQixTQUFTLFVBQVQsQ0FBb0IsS0FBcEIsRUFBMkIsS0FBM0IsRUFBa0M7QUFDaEMsTUFBTSxJQUFJLFFBQVEsSUFBSSxJQUFKLENBQVMsS0FBVCxDQUFSLEdBQTBCLElBQUksSUFBSixFQUFwQztBQUNBLElBQUUsV0FBRixDQUFjLEVBQUUsV0FBRixLQUFrQixLQUFoQztBQUNBLFNBQU8sQ0FBUDtBQUNEOztBQUVNLFNBQVMsb0JBQVQsQ0FBOEIsQ0FBOUIsRUFBaUMsS0FBakMsRUFBd0M7QUFDN0MsTUFBSSxDQUFDLENBQUwsRUFBUSxPQUFPLElBQVA7O0FBRHFDLHFCQUVsQixFQUFFLEtBQUYsQ0FBUSxHQUFSLEVBQWEsR0FBYixDQUFpQjtBQUFBLFdBQUssU0FBUyxDQUFULEVBQVksRUFBWixDQUFMO0FBQUEsR0FBakIsQ0FGa0I7QUFBQTtBQUFBLE1BRXRDLElBRnNDO0FBQUEsTUFFaEMsS0FGZ0M7QUFBQSxNQUV6QixHQUZ5Qjs7QUFHN0MsTUFBTSxPQUFPLElBQUksSUFBSixDQUFTLElBQVQsRUFBZSxRQUFRLENBQXZCLEVBQTBCLEdBQTFCLENBQWI7QUFDQSxNQUFNLGNBQWMsV0FBVyxDQUFDLENBQVosRUFBZSxLQUFmLENBQXBCO0FBQ0EsTUFBTSw4QkFBOEIsV0FBVyxDQUFDLEdBQVosRUFBaUIsS0FBakIsQ0FBcEM7QUFDQSxNQUFNLE1BQU0sV0FBVyxDQUFYLEVBQWMsS0FBZCxDQUFaOztBQUVBLE1BQUksT0FBTyxJQUFQLElBQWUsTUFBTSxLQUFLLFFBQUwsRUFBTixDQUFuQixFQUEyQztBQUN6QyxXQUFPLHFDQUFQO0FBQ0QsR0FGRCxNQUVPLElBQUksRUFBRSxLQUFLLFFBQUwsT0FBb0IsUUFBUSxDQUE1QixJQUFpQyxLQUFLLE9BQUwsT0FBbUIsR0FBcEQsSUFBMkQsS0FBSyxXQUFMLE9BQXVCLElBQXBGLENBQUosRUFBK0Y7QUFDcEcsV0FBTyxrQ0FBUDtBQUNELEdBRk0sTUFFQSxJQUFJLE1BQU0sSUFBVixFQUFnQjtBQUNyQixXQUFPLGlDQUFQO0FBQ0QsR0FGTSxNQUVBLElBQUksY0FBYyxJQUFsQixFQUF3QjtBQUM3QixXQUFPLG1DQUFQO0FBQ0QsR0FGTSxNQUVBLElBQUksOEJBQThCLElBQWxDLEVBQXdDO0FBQzdDLFdBQU8saUNBQVA7QUFDRDtBQUNGOztBQUVNLFNBQVMsUUFBVCxDQUFrQixJQUFsQixFQUF3QixLQUF4QixFQUErQjtBQUFBLHdCQUNULEtBQUssS0FBTCxDQUFXLEdBQVgsRUFBZ0IsR0FBaEIsQ0FBb0IsVUFBQyxJQUFEO0FBQUEsV0FBVSxTQUFTLElBQVQsRUFBZSxFQUFmLENBQVY7QUFBQSxHQUFwQixDQURTO0FBQUE7QUFBQSxNQUM3QixJQUQ2QjtBQUFBLE1BQ3ZCLEtBRHVCO0FBQUEsTUFDaEIsR0FEZ0I7O0FBRXBDLE1BQU0sSUFBSSxRQUFRLElBQUksSUFBSixDQUFTLEtBQVQsQ0FBUixHQUEwQixJQUFJLElBQUosRUFBcEM7QUFDQSxNQUFJLFlBQVksRUFBRSxXQUFGLEtBQWtCLElBQWxDO0FBQ0EsTUFBSSxhQUFjLEVBQUUsUUFBRixLQUFlLENBQWhCLEdBQXFCLEtBQXRDO0FBQ0EsTUFBSSxXQUFXLEVBQUUsT0FBRixLQUFjLEdBQTdCO0FBQ0EsTUFBSSxXQUFXLENBQWYsRUFBa0I7QUFDaEIsa0JBQWMsQ0FBZDtBQUNBLGdCQUFZLEVBQVo7QUFDRDtBQUNELE1BQUksYUFBYSxDQUFqQixFQUFvQjtBQUNsQixpQkFBYSxDQUFiO0FBQ0Esa0JBQWMsRUFBZDtBQUNEO0FBQ0QsU0FBTyxFQUFFLG9CQUFGLEVBQWEsc0JBQWIsRUFBeUIsa0JBQXpCLEVBQVA7QUFDRDs7QUFFTSxTQUFTLFNBQVQsQ0FBbUIsR0FBbkIsRUFBd0I7QUFDN0IsU0FBUSxDQUFDLHFCQUFxQixHQUFyQixDQUFELElBQThCLFNBQVMsR0FBVCxFQUFjLFNBQWQsR0FBMEIsRUFBaEU7QUFDRDs7QUFFTSxTQUFTLFNBQVQsQ0FBbUIsR0FBbkIsRUFBd0I7QUFDN0IsU0FBUSxDQUFDLHFCQUFxQixHQUFyQixDQUFELElBQThCLFNBQVMsR0FBVCxFQUFjLFNBQWQsR0FBMEIsRUFBaEU7QUFDRDs7QUFFTSxTQUFTLE1BQVQsQ0FBZ0IsV0FBaEIsRUFBNkI7QUFDbEMsVUFBUSxXQUFSO0FBQ0UsU0FBSyxJQUFMO0FBQ0EsU0FBSyxJQUFMO0FBQVcsYUFBTyxDQUFDLE9BQUQsRUFBVSxLQUFWLEVBQWlCLE1BQWpCLENBQVA7QUFDWDtBQUFTLGFBQU8sQ0FBQyxLQUFELEVBQVEsT0FBUixFQUFpQixNQUFqQixDQUFQO0FBSFg7QUFLRDs7Ozs7Ozs7OztRQ2xDZSxVLEdBQUEsVTtRQWlCQSxvQixHQUFBLG9CO0FBekNoQixJQUFNLGVBQWU7QUFDbkIsS0FBRyxRQURnQjtBQUVuQixLQUFHLGFBRmdCO0FBR25CLEtBQUcsd0JBSGdCO0FBSW5CLEtBQUc7QUFKZ0IsQ0FBckI7O0FBT0EsSUFBTSwwQkFBMEI7QUFDOUIsV0FBUyxlQURxQjtBQUU5QixVQUFRO0FBRnNCLENBQWhDOztBQUtBLFNBQVMsV0FBVCxDQUFxQixHQUFyQixFQUEwQjtBQUN4QixNQUFJLGNBQWMsR0FBZCxJQUFxQixrQkFBa0IsR0FBM0MsRUFBZ0Q7QUFDOUMsUUFBSTtBQUNGLGFBQU8sS0FBSyxLQUFMLENBQVcsSUFBSSxRQUFKLElBQWdCLElBQUksWUFBL0IsQ0FBUDtBQUNELEtBRkQsQ0FFRSxPQUFPLENBQVAsRUFBVTtBQUNWLGFBQU8sU0FBUDtBQUNEO0FBQ0YsR0FORCxNQU1PO0FBQ0wsV0FBTyxHQUFQO0FBQ0Q7QUFDRjs7QUFFTSxTQUFTLFVBQVQsQ0FBb0IsR0FBcEIsRUFBeUI7QUFDOUIsTUFBSSxJQUFJLE1BQUosS0FBZSxHQUFuQixFQUF3QjtBQUN0QixXQUFPLHFCQUFQO0FBQ0Q7QUFDRCxNQUFJLElBQUksTUFBSixLQUFlLEdBQW5CLEVBQXdCO0FBQ3RCLFFBQU0sV0FBVyxZQUFZLEdBQVosQ0FBakI7QUFDQSxRQUFJLFlBQWEsVUFBVSxRQUF2QixJQUFvQyxTQUFTLElBQVQsQ0FBYyxJQUF0RCxFQUE0RDtBQUMxRCxVQUFJLFNBQVMsSUFBVCxDQUFjLElBQWQsSUFBc0IsWUFBMUIsRUFBd0M7QUFDdEMsMkJBQWlCLGFBQWEsU0FBUyxJQUFULENBQWMsSUFBM0IsQ0FBakI7QUFDRCxPQUZELE1BRU8sSUFBSSxTQUFTLElBQVQsQ0FBYyxJQUFkLElBQXNCLHVCQUExQixFQUFtRDtBQUN4RCx5Q0FBK0Isd0JBQXdCLFNBQVMsSUFBVCxDQUFjLElBQXRDLENBQS9CO0FBQ0Q7QUFDRjtBQUNELFdBQU8sdUJBQVA7QUFDRDtBQUNGOztBQUVNLFNBQVMsb0JBQVQsQ0FBOEIsR0FBOUIsRUFBbUM7QUFDeEMsTUFBSSxJQUFJLE1BQUosS0FBZSxHQUFuQixFQUF3QjtBQUN0QixXQUFPLGdDQUFQO0FBQ0Q7QUFDRCxNQUFJLElBQUksTUFBSixLQUFlLEdBQW5CLEVBQXdCO0FBQ3RCLFFBQU0sV0FBVyxZQUFZLEdBQVosQ0FBakI7QUFDQSxRQUFJLFlBQWEsVUFBVSxRQUF2QixJQUFvQyxTQUFTLElBQVQsQ0FBYyxJQUFsRCxJQUEyRCxTQUFTLElBQVQsQ0FBYyxJQUFkLElBQXNCLFlBQXJGLEVBQW9HO0FBQ2xHLGtDQUEwQixhQUFhLFNBQVMsSUFBVCxDQUFjLElBQTNCLENBQTFCO0FBQ0Q7QUFDRCxXQUFPLGdDQUFQO0FBQ0Q7QUFDRjs7Ozs7Ozs7OztRQ3BEZSxxQixHQUFBLHFCO1FBT0EscUIsR0FBQSxxQjtBQVBULFNBQVMscUJBQVQsQ0FBK0IsTUFBL0IsRUFBdUM7QUFDNUMsU0FBTyxVQUFDLE1BQUQsRUFBWTtBQUNqQixRQUFNLFFBQVcsTUFBWCxTQUFxQixNQUEzQjtBQUNBLFdBQU8sVUFBQyxHQUFEO0FBQUEsYUFBVSxPQUFPLFNBQVMsR0FBaEIsR0FBc0IsSUFBSSxLQUFKLEVBQVcsR0FBakMsR0FBdUMsRUFBakQ7QUFBQSxLQUFQO0FBQ0QsR0FIRDtBQUlEOztBQUVNLFNBQVMscUJBQVQsQ0FBK0IsTUFBL0IsRUFBdUM7QUFDNUMsU0FBTyxVQUFDLE1BQUQsRUFBWTtBQUNqQixRQUFNLFFBQVcsTUFBWCxTQUFxQixNQUEzQjtBQUNBLFdBQU8sVUFBQyxHQUFEO0FBQUEsYUFBVSxPQUFPLFNBQVMsR0FBaEIsSUFBdUIsSUFBSSxLQUFKLEVBQVcsS0FBWCxLQUFxQixPQUE1QyxHQUFzRCxnQkFBdEQsR0FBeUUsRUFBbkY7QUFBQSxLQUFQO0FBQ0QsR0FIRDtBQUlEOzs7Ozs7Ozs7O1FDWmUsWSxHQUFBLFk7UUFnQkEsYyxHQUFBLGM7UUFVQSxtQixHQUFBLG1CO0FBMUJULFNBQVMsWUFBVCxDQUFzQixTQUF0QixFQUFpQyxPQUFqQyxFQUEwQyxlQUExQyxFQUEyRDtBQUNoRSxNQUFNLGNBQWMsUUFBUSxNQUFSLENBQWUsVUFBQyxJQUFEO0FBQUEsV0FBVSxLQUFLLElBQUwsS0FBYyxlQUF4QjtBQUFBLEdBQWYsQ0FBcEI7QUFDQSxNQUFJLFlBQVksTUFBaEIsRUFBd0I7QUFDdEIsV0FBTyxFQUFFLE1BQU0sWUFBWSxDQUFaLEVBQWUsSUFBdkIsRUFBNkIsWUFBWSxJQUF6QyxFQUFQO0FBQ0Q7QUFDRCxNQUFNLGdCQUFnQixVQUFVLE1BQVYsQ0FBaUIsVUFBQyxJQUFEO0FBQUEsV0FBVSxLQUFLLElBQUwsS0FBYyxlQUF4QjtBQUFBLEdBQWpCLENBQXRCO0FBQ0EsTUFBSSxjQUFjLE1BQWxCLEVBQTBCO0FBQ3hCLFFBQU0sYUFBYSxjQUFjLENBQWQsRUFBaUIsVUFBcEM7QUFDQSxRQUFNLGFBQWEsUUFBUSxNQUFSLENBQWUsVUFBQyxJQUFEO0FBQUEsYUFBVSxLQUFLLFVBQUwsS0FBb0IsVUFBOUI7QUFBQSxLQUFmLENBQW5CO0FBQ0EsUUFBSSxXQUFXLE1BQWYsRUFBdUI7QUFDckIsYUFBTyxFQUFFLE1BQU0sV0FBVyxDQUFYLEVBQWMsSUFBdEIsRUFBNEIsc0JBQTVCLEVBQVA7QUFDRDtBQUNGO0FBQ0QsU0FBTyxFQUFFLE1BQU0sRUFBUixFQUFZLFlBQVksSUFBeEIsRUFBUDtBQUNEOztBQUVNLFNBQVMsY0FBVCxDQUF3QixTQUF4QixFQUFtQyxnQkFBbkMsRUFBcUQ7QUFDMUQsU0FBTyxVQUNOLE1BRE0sQ0FDQyxVQUFDLEdBQUQsRUFBUztBQUNmLFFBQUksaUJBQWlCLFVBQXJCLEVBQWlDO0FBQy9CLGFBQU8sSUFBSSxVQUFKLEtBQW1CLGlCQUFpQixVQUEzQztBQUNEO0FBQ0QsV0FBTyxJQUFJLElBQUosS0FBYSxpQkFBaUIsSUFBckM7QUFDRCxHQU5NLENBQVA7QUFPRDs7QUFFTSxTQUFTLG1CQUFULENBQTZCLFNBQTdCLEVBQXdDLGVBQXhDLEVBQXlEO0FBQzlEO0FBQ0EsTUFBTSxXQUFXLFVBQVUsR0FBVixDQUFjLFVBQUMsR0FBRDtBQUFBLFdBQVMsSUFBSSxJQUFKLEtBQWEsZUFBdEI7QUFBQSxHQUFkLEVBQXFELE9BQXJELENBQTZELElBQTdELENBQWpCO0FBQ0EsTUFBTSxTQUFTLFVBQVUsUUFBVixDQUFmO0FBQ0EsU0FBTyxTQUFTLE9BQU8sUUFBaEIsR0FBMkIsT0FBbEM7QUFDRDs7Ozs7Ozs7OztRQ3JCZSxVLEdBQUEsVTtRQWtCQSxZLEdBQUEsWTtRQXlCQSxVLEdBQUEsVTtRQWNBLG1CLEdBQUEsbUI7UUFVQSxVLEdBQUEsVTtRQVVBLGEsR0FBQSxhO1FBV0EsZSxHQUFBLGU7UUFTQSxjLEdBQUEsYztBQTNHaEI7O0FBRUEsU0FBUyxLQUFULEdBQWlCO0FBQ2YsTUFBSTtBQUNGLFdBQU8sQ0FBQyxDQUFDLEdBQVQ7QUFDRCxHQUZELENBRUUsT0FBTyxDQUFQLEVBQVU7QUFDVixXQUFPLEtBQVA7QUFDRDtBQUNGOztBQUVNLFNBQVMsVUFBVCxDQUFvQixRQUFwQixFQUE4QjtBQUNuQyxNQUFJLENBQUUsT0FBTixFQUFlO0FBQ2YsTUFBSSxtQkFBSjtBQUNBLE1BQUksYUFBYSxTQUFqQixFQUE0QjtBQUMxQixpQkFBYSxPQUFiO0FBQ0QsR0FGRCxNQUVPLElBQUksYUFBYSxVQUFiLElBQTJCLGFBQWEsUUFBNUMsRUFBc0Q7QUFDM0QsaUJBQWEsVUFBYjtBQUNEO0FBQ0QsTUFBSSxVQUFKLEVBQWdCO0FBQ2QsUUFBSSxJQUFKLENBQVMsS0FBSyxLQUFkLEVBQXFCO0FBQ25CLGNBQVE7QUFDTixjQUFNO0FBREEsT0FEVztBQUluQjtBQUptQixLQUFyQjtBQU1EO0FBQ0Y7O0FBRU0sU0FBUyxZQUFULENBQXNCLFFBQXRCLEVBQWdDLElBQWhDLEVBQXNDLFFBQXRDLEVBQWdELGdCQUFoRCxFQUFrRTtBQUN2RSxNQUFJLENBQUUsT0FBTixFQUFlO0FBQ2YsTUFBTSxhQUFhO0FBQ2pCLGVBQVcsV0FETTtBQUVqQixjQUFVLFVBRk87QUFHakIsdUJBQW1CLGlCQUhGO0FBSWpCLFlBQVE7QUFKUyxHQUFuQjtBQU1BLE1BQU0sUUFBUTtBQUNaLFFBQUksV0FBVyxRQUFYLEtBQXdCLFdBRGhCO0FBRVosWUFBUTtBQUNOLFVBQUksbUJBQW1CLFdBQW5CLEdBQWlDLElBRC9CO0FBRU47QUFGTTtBQUZJLEdBQWQ7O0FBUUEsTUFBSSxhQUFhLFFBQWpCLEVBQTJCO0FBQ3pCLFVBQU0sT0FBTixHQUFnQixtQkFBaEI7QUFDRCxHQUZELE1BRU8sSUFBSSxRQUFKLEVBQWM7QUFDbkIsVUFBTSxPQUFOLEdBQWdCLFFBQWhCO0FBQ0Q7O0FBRUQsTUFBSSxJQUFKLENBQVMsS0FBSyxPQUFkLEVBQXVCLEtBQXZCO0FBQ0Q7O0FBRU0sU0FBUyxVQUFULENBQW9CLEVBQXBCLEVBQXdCLEdBQXhCLEVBQTZCLElBQTdCLEVBQW1DO0FBQ3hDLE1BQUksQ0FBRSxPQUFOLEVBQWU7QUFDZixNQUFNLE1BQU0sT0FBTyxlQUFQLEdBQXlCLEtBQUssYUFBOUIsR0FBOEMsS0FBSyxVQUEvRDtBQUNBLE1BQUksSUFBSixDQUFTLEdBQVQsRUFBYztBQUNaLFVBRFk7QUFFWixhQUFTO0FBQ1AsZUFBUztBQURGLEtBRkc7QUFLWixZQUFRO0FBQ047QUFETTtBQUxJLEdBQWQ7QUFTRDs7QUFFTSxTQUFTLG1CQUFULENBQTZCLElBQTdCLEVBQW1DLEVBQW5DLEVBQXVDO0FBQzVDLE1BQUksQ0FBRSxPQUFOLEVBQWUsT0FBTyxNQUFNLElBQWI7QUFDZixNQUFJLElBQUosQ0FBUyxLQUFLLE1BQWQsRUFBc0I7QUFDcEIsUUFBSSxpQkFEZ0I7QUFFcEIsWUFBUTtBQUNOO0FBRE07QUFGWSxHQUF0QixFQUtHLEVBTEg7QUFNRDs7QUFFTSxTQUFTLFVBQVQsQ0FBb0IsRUFBcEIsRUFBd0IsSUFBeEIsRUFBOEIsRUFBOUIsRUFBa0M7QUFDdkMsTUFBSSxDQUFFLE9BQU4sRUFBZSxPQUFPLE1BQU0sSUFBYjtBQUNmLE1BQUksSUFBSixDQUFTLEtBQUssS0FBZCxFQUFxQjtBQUNuQixVQURtQjtBQUVuQixZQUFRO0FBQ047QUFETTtBQUZXLEdBQXJCLEVBS0csRUFMSDtBQU1EOztBQUVNLFNBQVMsYUFBVCxDQUF1QixJQUF2QixFQUE2QixFQUE3QixFQUFpQztBQUN0QyxNQUFJLENBQUUsT0FBTixFQUFlLE9BQU8sTUFBTSxJQUFiO0FBQ2YsTUFBSSxJQUFKLENBQVMsS0FBSyxRQUFkLEVBQXdCO0FBQ3RCLFFBQUksVUFEa0I7QUFFdEIsWUFBUTtBQUNOO0FBRE0sS0FGYztBQUt0QixVQUFNLENBQUMsUUFBRDtBQUxnQixHQUF4QixFQU1HLEVBTkg7QUFPRDs7QUFFTSxTQUFTLGVBQVQsQ0FBeUIsT0FBekIsRUFBa0MsUUFBbEMsRUFBNEM7QUFDakQsTUFBSSxPQUFKLEVBQWE7QUFDWCxXQUFPLE9BQVA7QUFDRCxHQUZELE1BRU8sSUFBSSxRQUFKLEVBQWM7QUFDbkIsV0FBTyxPQUFQO0FBQ0Q7QUFDRCxTQUFPLFlBQVA7QUFDRDs7QUFFTSxTQUFTLGNBQVQsQ0FBd0IsWUFBeEIsRUFBc0Msb0JBQXRDLEVBQTREO0FBQ2pFLE1BQU0sT0FBTyxFQUFiOztBQUVBLE1BQUksUUFBUSxvQkFBUixJQUFnQyxRQUFRLFlBQTVDLEVBQTBEO0FBQ3hELFNBQUssTUFBTCxHQUFjLHFCQUFxQixFQUFyQixJQUEyQixhQUFhLEVBQXREO0FBQ0Q7O0FBRUQsTUFBSSxVQUFVLG9CQUFWLElBQWtDLFVBQVUsWUFBaEQsRUFBOEQ7QUFDNUQsU0FBSyxRQUFMLEdBQWdCLHFCQUFxQixJQUFyQixJQUE2QixhQUFhLElBQTFEO0FBQ0Q7O0FBRUQsTUFBSSxhQUFhLG9CQUFiLElBQXFDLGFBQWEsWUFBdEQsRUFBb0U7QUFDbEUsU0FBSyxXQUFMLEdBQW1CLHFCQUFxQixPQUFyQixJQUFnQyxhQUFhLE9BQWhFO0FBQ0Q7O0FBRUQsTUFBSSxnQkFBZ0Isb0JBQWhCLElBQXdDLGdCQUFnQixZQUE1RCxFQUEwRTtBQUN4RSxTQUFLLGNBQUwsR0FBc0IscUJBQXFCLFVBQXJCLElBQW1DLGFBQWEsVUFBdEU7QUFDRDs7QUFFRCxTQUFPLElBQVA7QUFDRDs7Ozs7Ozs7Ozs7Ozs7O2tCQzlIdUIsYzs7OztBQUFULFNBQVMsY0FBVCxDQUF3QixHQUF4QixFQUE2QixHQUE3QixFQUFrQztBQUMvQyxNQUFJLFFBQU8sR0FBUCx1REFBTyxHQUFQLE9BQWUsUUFBbkIsRUFBNkI7QUFDM0IsV0FBTyxTQUFQO0FBQ0Q7QUFDRCxPQUFLLElBQU0sQ0FBWCxJQUFnQixHQUFoQixFQUFxQjtBQUNuQixRQUFJLFFBQVEsQ0FBWixFQUFlO0FBQ2IsYUFBTyxJQUFJLEdBQUosQ0FBUDtBQUNEO0FBQ0QsUUFBTSxRQUFRLGVBQWUsSUFBSSxDQUFKLENBQWYsRUFBdUIsR0FBdkIsQ0FBZDtBQUNBLFFBQUksS0FBSixFQUFXO0FBQ1QsYUFBTyxLQUFQO0FBQ0Q7QUFDRjtBQUNELFNBQU8sU0FBUDtBQUNEOzs7Ozs7Ozs7O1FDWmUsSyxHQUFBLEs7UUFJQSxlLEdBQUEsZTtRQUlBLFcsR0FBQSxXO1FBSUEsVyxHQUFBLFc7UUFJQSxjLEdBQUEsYztRQUlBLGdCLEdBQUEsZ0I7UUFJQSxXLEdBQUEsVztRQUlBLGtCLEdBQUEsa0I7UUFJQSxhLEdBQUEsYTtRQUlBLGUsR0FBQSxlO1FBSUEsVSxHQUFBLFU7UUFJQSxZLEdBQUEsWTtRQUlBLGtCLEdBQUEsa0I7UUFJQSxlLEdBQUEsZTtRQUlBLFUsR0FBQSxVO1FBSUEsWSxHQUFBLFk7UUFJQSxlLEdBQUEsZTtRQUlBLGtCLEdBQUEsa0I7UUFJQSxrQixHQUFBLGtCO1FBSUEscUIsR0FBQSxxQjtRQUlBLGEsR0FBQSxhO1FBSUEsVyxHQUFBLFc7UUFJQSxRLEdBQUEsUTtRQUlBLFcsR0FBQSxXO1FBSUEsZSxHQUFBLGU7UUFJQSxVLEdBQUEsVTtRQUlBLFksR0FBQSxZOztBQTNHaEI7O0lBQVksUTs7OztBQUVaO0FBQ08sU0FBUyxLQUFULEdBQWlCO0FBQ3RCLFNBQU8sRUFBRSxNQUFNLFNBQVMsS0FBakIsRUFBUDtBQUNEOztBQUVNLFNBQVMsZUFBVCxDQUF5QixRQUF6QixFQUFtQztBQUN4QyxTQUFPLEVBQUUsTUFBTSxTQUFTLGtCQUFqQixFQUFxQyxrQkFBckMsRUFBUDtBQUNEOztBQUVNLFNBQVMsV0FBVCxDQUFxQixRQUFyQixFQUErQjtBQUNwQyxTQUFPLEVBQUUsTUFBTSxTQUFTLGFBQWpCLEVBQWdDLGtCQUFoQyxFQUFQO0FBQ0Q7O0FBRU0sU0FBUyxXQUFULENBQXFCLFFBQXJCLEVBQStCLFFBQS9CLEVBQXlDO0FBQzlDLFNBQU8sRUFBRSxNQUFNLFNBQVMsWUFBakIsRUFBK0Isa0JBQS9CLEVBQXlDLGtCQUF6QyxFQUFQO0FBQ0Q7O0FBRU0sU0FBUyxjQUFULENBQXdCLElBQXhCLEVBQThCO0FBQ25DLFNBQU8sRUFBRSxNQUFNLFNBQVMsZ0JBQWpCLEVBQW1DLFVBQW5DLEVBQVA7QUFDRDs7QUFFTSxTQUFTLGdCQUFULENBQTBCLE1BQTFCLEVBQWtDO0FBQ3ZDLFNBQU8sRUFBRSxNQUFNLFNBQVMsaUJBQWpCLEVBQW9DLGNBQXBDLEVBQVA7QUFDRDs7QUFFTSxTQUFTLFdBQVQsQ0FBcUIsUUFBckIsRUFBK0I7QUFDcEMsU0FBTyxFQUFFLE1BQU0sU0FBUyxhQUFqQixFQUFnQyxrQkFBaEMsRUFBUDtBQUNEOztBQUVNLFNBQVMsa0JBQVQsR0FBOEI7QUFDbkMsU0FBTyxFQUFFLE1BQU0sU0FBUyxxQkFBakIsRUFBUDtBQUNEOztBQUVNLFNBQVMsYUFBVCxHQUF5QjtBQUM5QixTQUFPLEVBQUUsTUFBTSxTQUFTLGVBQWpCLEVBQVA7QUFDRDs7QUFFTSxTQUFTLGVBQVQsR0FBMkI7QUFDaEMsU0FBTyxFQUFFLE1BQU0sU0FBUyxnQkFBakIsRUFBUDtBQUNEOztBQUVNLFNBQVMsVUFBVCxDQUFvQixNQUFwQixFQUE0QjtBQUNqQyxTQUFPLEVBQUUsTUFBTSxTQUFTLFlBQWpCLEVBQStCLGNBQS9CLEVBQVA7QUFDRDs7QUFFTSxTQUFTLFlBQVQsQ0FBc0IsTUFBdEIsRUFBOEI7QUFDbkMsU0FBTyxFQUFFLE1BQU0sU0FBUyxhQUFqQixFQUFnQyxjQUFoQyxFQUFQO0FBQ0Q7O0FBRU0sU0FBUyxrQkFBVCxDQUE0QixNQUE1QixFQUFvQztBQUN6QyxTQUFPLEVBQUUsTUFBTSxTQUFTLG9CQUFqQixFQUF1QyxjQUF2QyxFQUFQO0FBQ0Q7O0FBRU0sU0FBUyxlQUFULENBQXlCLE1BQXpCLEVBQWlDO0FBQ3RDLFNBQU8sRUFBRSxNQUFNLFNBQVMsa0JBQWpCLEVBQXFDLGNBQXJDLEVBQVA7QUFDRDs7QUFFTSxTQUFTLFVBQVQsQ0FBb0IsUUFBcEIsRUFBOEI7QUFDbkMsU0FBTyxFQUFFLE1BQU0sU0FBUyxZQUFqQixFQUErQixrQkFBL0IsRUFBUDtBQUNEOztBQUVNLFNBQVMsWUFBVCxDQUFzQixRQUF0QixFQUFnQztBQUNyQyxTQUFPLEVBQUUsTUFBTSxTQUFTLGFBQWpCLEVBQWdDLGtCQUFoQyxFQUFQO0FBQ0Q7O0FBRU0sU0FBUyxlQUFULENBQXlCLFFBQXpCLEVBQW1DO0FBQ3hDLFNBQU8sRUFBRSxNQUFNLFNBQVMsa0JBQWpCLEVBQXFDLGtCQUFyQyxFQUFQO0FBQ0Q7O0FBRU0sU0FBUyxrQkFBVCxHQUE4QjtBQUNuQyxTQUFPLEVBQUUsTUFBTSxTQUFTLG9CQUFqQixFQUFQO0FBQ0Q7O0FBRU0sU0FBUyxrQkFBVCxHQUE4QjtBQUNuQyxTQUFPLEVBQUUsTUFBTSxTQUFTLG9CQUFqQixFQUFQO0FBQ0Q7O0FBRU0sU0FBUyxxQkFBVCxHQUFpQztBQUN0QyxTQUFPLEVBQUUsTUFBTSxTQUFTLHVCQUFqQixFQUFQO0FBQ0Q7O0FBRU0sU0FBUyxhQUFULENBQXVCLElBQXZCLEVBQTZCO0FBQ2xDLFNBQU8sRUFBRSxNQUFNLFNBQVMsY0FBakIsRUFBaUMsVUFBakMsRUFBUDtBQUNEOztBQUVNLFNBQVMsV0FBVCxDQUFxQixJQUFyQixFQUEyQixJQUEzQixFQUFpQztBQUN0QyxTQUFPLEVBQUUsTUFBTSxTQUFTLFlBQWpCLEVBQStCLFVBQS9CLEVBQXFDLFVBQXJDLEVBQVA7QUFDRDs7QUFFTSxTQUFTLFFBQVQsQ0FBa0IsSUFBbEIsRUFBd0IsSUFBeEIsRUFBOEIsS0FBOUIsRUFBcUM7QUFDMUMsU0FBTyxFQUFFLE1BQU0sU0FBUyxTQUFqQixFQUE0QixVQUE1QixFQUFrQyxVQUFsQyxFQUF3QyxZQUF4QyxFQUFQO0FBQ0Q7O0FBRU0sU0FBUyxXQUFULEdBQXVCO0FBQzVCLFNBQU8sRUFBRSxNQUFNLFNBQVMsWUFBakIsRUFBUDtBQUNEOztBQUVNLFNBQVMsZUFBVCxDQUF5QixRQUF6QixFQUFtQztBQUN4QyxTQUFPLEVBQUUsTUFBTSxTQUFTLGlCQUFqQixFQUFvQyxrQkFBcEMsRUFBUDtBQUNEOztBQUVNLFNBQVMsVUFBVCxDQUFvQixRQUFwQixFQUE4QjtBQUNuQyxTQUFPLEVBQUUsTUFBTSxTQUFTLFdBQWpCLEVBQThCLGtCQUE5QixFQUFQO0FBQ0Q7O0FBRU0sU0FBUyxZQUFULENBQXNCLFFBQXRCLEVBQWdDO0FBQ3JDLFNBQU8sRUFBRSxNQUFNLFNBQVMsYUFBakIsRUFBZ0Msa0JBQWhDLEVBQVA7QUFDRDs7Ozs7Ozs7OztBQzdHTSxJQUFNLHdCQUFRLE9BQWQ7QUFDQSxJQUFNLGtEQUFxQixvQkFBM0I7QUFDQSxJQUFNLHdDQUFnQixlQUF0QjtBQUNBLElBQU0sd0NBQWdCLGVBQXRCO0FBQ0EsSUFBTSxzQ0FBZSxjQUFyQjtBQUNBLElBQU0sOENBQW1CLGtCQUF6Qjs7QUFFQSxJQUFNLGdEQUFvQixtQkFBMUI7O0FBRUEsSUFBTSx3REFBd0IsdUJBQTlCO0FBQ0EsSUFBTSw0Q0FBa0IsaUJBQXhCO0FBQ0EsSUFBTSw4Q0FBbUIsa0JBQXpCO0FBQ0EsSUFBTSw0REFBMEIseUJBQWhDOztBQUVBLElBQU0sc0NBQWUsY0FBckI7QUFDQSxJQUFNLHdDQUFnQixlQUF0QjtBQUNBLElBQU0sa0RBQXFCLG9CQUEzQjs7QUFFQSxJQUFNLHNDQUFlLGNBQXJCO0FBQ0EsSUFBTSx3Q0FBZ0IsZUFBdEI7QUFDQSxJQUFNLHNEQUF1QixzQkFBN0I7QUFDQSxJQUFNLGtEQUFxQixvQkFBM0I7O0FBRUEsSUFBTSxzREFBdUIsc0JBQTdCO0FBQ0EsSUFBTSxzREFBdUIsc0JBQTdCOztBQUVBLElBQU0sMENBQWlCLGdCQUF2QjtBQUNBLElBQU0sc0NBQWUsY0FBckI7QUFDQSxJQUFNLGdDQUFZLFdBQWxCOztBQUVBLElBQU0sc0NBQWUsY0FBckI7QUFDQSxJQUFNLGdEQUFvQixtQkFBMUI7O0FBRUEsSUFBTSx3Q0FBZ0IsZUFBdEI7QUFDQSxJQUFNLG9DQUFjLGFBQXBCOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O2tCQzJHaUIsTzs7QUE3SXhCOztJQUFZLFE7Ozs7OztBQUVaLElBQU0sZUFBZTtBQUNuQixVQUFRLEVBRFc7QUFFbkIsWUFBVTtBQUNSLGVBQVcsRUFESDtBQUVSLGNBQVUsRUFGRjtBQUdSLFdBQU8sRUFIQztBQUlSLGNBQVUsRUFKRjtBQUtSLGNBQVUsRUFMRjtBQU1SLGdCQUFZLEtBTko7QUFPUixzQkFBa0IsSUFQVjtBQVFSLFdBQU87QUFSQyxHQUZTO0FBWW5CLFVBQVE7QUFDTixvQkFBZ0IsRUFEVjtBQUVOLGNBQVUsRUFGSjtBQUdOLHFCQUFpQixLQUhYO0FBSU4sV0FBTztBQUpELEdBWlc7QUFrQm5CLGtCQUFnQjtBQUNkLG9CQUFnQixFQURGO0FBRWQsV0FBTztBQUZPLEdBbEJHO0FBc0JuQixVQUFRO0FBdEJXLENBQXJCOztBQXlCQSxTQUFTLE1BQVQsQ0FBZ0IsS0FBaEIsRUFBdUIsR0FBdkIsRUFBNEI7QUFDMUIsTUFBTSxJQUFJLEVBQVY7QUFDQSxzQkFBWSxHQUFaLEVBQWlCLE9BQWpCLENBQXlCLFVBQUMsSUFBRCxFQUFVO0FBQ2pDLE1BQUUsSUFBRixJQUFVLHNCQUFjLEVBQWQsRUFBa0IsTUFBTSxJQUFOLENBQWxCLEVBQStCLElBQUksSUFBSixDQUEvQixDQUFWO0FBQ0QsR0FGRDtBQUdBLFNBQU8sc0JBQWMsRUFBZCxFQUFrQixLQUFsQixFQUF5QixDQUF6QixDQUFQO0FBQ0Q7O0FBRUQ7QUFDQSxTQUFTLEtBQVQsQ0FBZSxLQUFmLEVBQXNCO0FBQ3BCLE1BQU0sV0FBVztBQUNmLFlBQVEsRUFETztBQUVmLFlBQVEsc0JBQWMsRUFBZCxFQUFrQixNQUFNLE1BQXhCLEVBQWdDLEVBQUUsWUFBWSxJQUFkLEVBQWhDLENBRk87QUFHZixjQUFVLGFBQWEsUUFIUjtBQUlmLFlBQVEsYUFBYSxNQUpOO0FBS2Ysb0JBQWdCLGFBQWE7QUFMZCxHQUFqQjtBQU9BLFdBQVMsTUFBVCxDQUFnQixlQUFoQixHQUFrQyxNQUFNLE1BQU4sQ0FBYSxRQUEvQztBQUNBLFNBQU8sc0JBQWMsRUFBZCxFQUFrQixLQUFsQixFQUF5QixRQUF6QixDQUFQO0FBQ0Q7O0FBRUQsU0FBUyxXQUFULENBQXFCLEtBQXJCLEVBQTRCO0FBQzFCLFNBQU8sc0JBQWMsRUFBZCxFQUFrQixLQUFsQixFQUF5QixFQUFFLFFBQVEsRUFBVixFQUF6QixDQUFQO0FBQ0Q7O0FBRUQsU0FBUyxXQUFULENBQXFCLEtBQXJCLEVBQTRCLE1BQTVCLEVBQW9DO0FBQ2xDLFNBQU8sT0FBTyxLQUFQLEVBQWMsRUFBRSxRQUFRLEVBQUUsVUFBVSxPQUFPLFFBQW5CLEVBQVYsRUFBZCxDQUFQO0FBQ0Q7O0FBRUQsU0FBUyxXQUFULENBQXFCLEtBQXJCLEVBQTRCLE1BQTVCLEVBQW9DO0FBQ2xDLFNBQU8sT0FBTyxLQUFQLEVBQWMsRUFBRSxRQUFRLEVBQUUsVUFBVSxPQUFPLFFBQW5CLEVBQVYsRUFBZCxDQUFQO0FBQ0Q7O0FBRUQsU0FBUyxXQUFULENBQXFCLEtBQXJCLEVBQTRCLE1BQTVCLEVBQW9DO0FBQ2xDLFNBQU8sT0FBTyxLQUFQLEVBQWMsRUFBRSxRQUFRLEVBQUUsVUFBVSxPQUFPLFFBQW5CLEVBQTZCLFVBQVUsT0FBTyxRQUE5QyxFQUFWLEVBQWQsQ0FBUDtBQUNEOztBQUVELFNBQVMsZ0JBQVQsQ0FBMEIsS0FBMUIsRUFBaUMsTUFBakMsRUFBeUM7QUFDdkMsU0FBTyxPQUFPLEtBQVAsRUFBYyxFQUFFLFFBQVEsT0FBTyxNQUFqQixFQUFkLENBQVA7QUFDRDs7QUFFRCxTQUFTLFVBQVQsQ0FBb0IsS0FBcEIsRUFBMkI7QUFDekIsU0FBTyxPQUFPLFlBQVksS0FBWixDQUFQLEVBQTJCLEVBQUUsUUFBUSxFQUFFLE9BQU8sTUFBVCxFQUFWLEVBQTNCLENBQVA7QUFDRDs7QUFFRCxTQUFTLFlBQVQsQ0FBc0IsS0FBdEIsRUFBNkI7QUFDM0IsU0FBTyxPQUFPLFlBQVksS0FBWixDQUFQLEVBQTJCLEVBQUUsVUFBVSxFQUFFLE9BQU8sTUFBVCxFQUFaLEVBQTNCLENBQVA7QUFDRDs7QUFFRCxTQUFTLGVBQVQsQ0FBeUIsS0FBekIsRUFBZ0MsTUFBaEMsRUFBd0M7QUFDdEMsU0FBTyxPQUFPLFlBQVksS0FBWixDQUFQLEVBQTJCLEVBQUUsUUFBUSxFQUFFLFlBQVksT0FBTyxRQUFyQixFQUFWLEVBQTNCLENBQVA7QUFDRDs7QUFFRCxTQUFTLGtCQUFULENBQTRCLEtBQTVCLEVBQW1DO0FBQ2pDLFNBQU8sT0FBTyxZQUFZLEtBQVosQ0FBUCxFQUEyQixFQUFFLGdCQUFnQixFQUFFLE9BQU8sTUFBVCxFQUFsQixFQUEzQixDQUFQO0FBQ0Q7O0FBRUQsU0FBUyxVQUFULENBQW9CLEtBQXBCLEVBQTJCO0FBQ3pCLFNBQU8sT0FBTyxLQUFQLEVBQWMsRUFBRSxRQUFRLEVBQUUsT0FBTyxJQUFULEVBQVYsRUFBZCxDQUFQO0FBQ0Q7O0FBRUQsU0FBUyxZQUFULENBQXNCLEtBQXRCLEVBQTZCO0FBQzNCLFNBQU8sT0FBTyxLQUFQLEVBQWMsRUFBRSxVQUFVLEVBQUUsT0FBTyxJQUFULEVBQVosRUFBZCxDQUFQO0FBQ0Q7O0FBRUQsU0FBUyxlQUFULENBQXlCLEtBQXpCLEVBQWdDO0FBQzlCLFNBQU8sT0FBTyxLQUFQLEVBQWMsRUFBRSxRQUFRLEVBQUUsWUFBWSxJQUFkLEVBQVYsRUFBZCxDQUFQO0FBQ0Q7O0FBRUQsU0FBUyxrQkFBVCxDQUE0QixLQUE1QixFQUFtQztBQUNqQyxTQUFPLE9BQU8sS0FBUCxFQUFjLEVBQUUsZ0JBQWdCLEVBQUUsT0FBTyxJQUFULEVBQWxCLEVBQWQsQ0FBUDtBQUNEOztBQUVELFNBQVMsa0JBQVQsQ0FBNEIsS0FBNUIsRUFBbUM7QUFDakMsU0FBTyxPQUFPLFlBQVksS0FBWixDQUFQLEVBQTJCLEVBQUUsZ0JBQWdCLEVBQUUsT0FBTyxNQUFULEVBQWxCLEVBQTNCLENBQVA7QUFDRDs7QUFFRCxTQUFTLGFBQVQsQ0FBdUIsS0FBdkIsRUFBOEIsTUFBOUIsRUFBc0M7QUFDcEMsTUFBSSxPQUFPLElBQVAsS0FBZ0Isb0JBQWhCLElBQXdDLE1BQU0sUUFBTixDQUFlLFFBQWYsS0FBNEIsRUFBeEUsRUFBNEU7QUFDMUUsV0FBTyxPQUFPLEtBQVAsRUFBYyxFQUFFLFVBQVUsRUFBRSxrQkFBa0IsSUFBcEIsRUFBWixFQUFkLENBQVA7QUFDRDtBQUNELE1BQUksT0FBTyxJQUFQLEtBQWdCLHVCQUFwQixFQUE2QztBQUMzQyxXQUFPLE9BQU8sS0FBUCxFQUFjLEVBQUUsVUFBVSxFQUFFLGtCQUFrQixLQUFwQixFQUFaLEVBQWQsQ0FBUDtBQUNEO0FBQ0QsU0FBTyxLQUFQO0FBQ0Q7O0FBRUQsU0FBUyxXQUFULENBQXFCLEtBQXJCLEVBQTRCLE1BQTVCLEVBQW9DO0FBQ2xDLE1BQU0sWUFBWSxzQkFBYyxFQUFkLEVBQWtCLE1BQU0sTUFBeEIsQ0FBbEI7QUFDQSxTQUFPLFVBQVUsT0FBTyxJQUFqQixDQUFQO0FBQ0EsU0FBTyxJQUFQLENBQVksT0FBWixDQUFvQjtBQUFBLFdBQUssT0FBTyxVQUFVLENBQVYsQ0FBWjtBQUFBLEdBQXBCO0FBQ0EsU0FBTyxzQkFBYyxFQUFkLEVBQWtCLEtBQWxCLEVBQXlCLEVBQUUsUUFBUSxTQUFWLEVBQXpCLENBQVA7QUFDRDs7QUFFRCxTQUFTLFFBQVQsQ0FBa0IsS0FBbEIsRUFBeUIsTUFBekIsRUFBaUM7QUFDL0IsTUFBTSxNQUFNLEVBQVo7QUFDQSxNQUFJLE9BQU8sSUFBWCxJQUFtQixFQUFuQjtBQUNBLE1BQUksT0FBTyxJQUFYLEVBQWlCLE9BQU8sSUFBeEIsSUFBZ0MsT0FBTyxLQUF2QztBQUNBLE1BQUksT0FBTyxJQUFQLEtBQWdCLFFBQWhCLElBQTRCLE9BQU8sSUFBUCxLQUFnQixnQkFBaEQsRUFBa0U7QUFDaEUsMEJBQWMsR0FBZCxFQUFtQixFQUFFLGdCQUFnQixFQUFFLGdCQUFnQixPQUFPLEtBQXpCLEVBQWxCLEVBQW5CO0FBQ0Q7QUFDRCxTQUFPLE9BQU8sS0FBUCxFQUFjLEdBQWQsQ0FBUDtBQUNEOztBQUVELFNBQVMsZUFBVCxDQUF5QixLQUF6QixFQUFnQyxNQUFoQyxFQUF3QztBQUN0QyxNQUFJLENBQUMsTUFBTSxRQUFOLENBQWUsZ0JBQXBCLEVBQXNDO0FBQ3BDLFdBQU8sS0FBUDtBQUNEO0FBQ0QsTUFBTSxZQUFZLHNCQUFjLEVBQWQsRUFBa0IsTUFBTSxNQUF4QixDQUFsQjtBQUNBLFNBQU8sVUFBVSx1QkFBVixDQUFQO0FBQ0EsTUFBTSxXQUFXLHNCQUFjLEVBQWQsRUFBa0IsS0FBbEIsRUFBeUIsRUFBRSxRQUFRLFNBQVYsRUFBekIsQ0FBakI7QUFDQSxTQUFPLE9BQU8sUUFBUCxFQUFpQixFQUFFLFVBQVUsRUFBRSxVQUFVLE9BQU8sUUFBbkIsRUFBWixFQUFqQixDQUFQO0FBQ0Q7O0FBRWMsU0FBUyxPQUFULEdBQW9EO0FBQUEsTUFBbkMsS0FBbUMsdUVBQTNCLFlBQTJCO0FBQUEsTUFBYixNQUFhLHVFQUFKLEVBQUk7O0FBQ2pFLFVBQVEsT0FBTyxJQUFmO0FBQ0UsU0FBSyxTQUFTLEtBQWQ7QUFDRSxhQUFPLE1BQU0sS0FBTixFQUFhLE1BQWIsQ0FBUDtBQUNGLFNBQUssU0FBUyxhQUFkO0FBQ0UsYUFBTyxZQUFZLEtBQVosRUFBbUIsTUFBbkIsQ0FBUDtBQUNGLFNBQUssU0FBUyxhQUFkO0FBQ0UsYUFBTyxZQUFZLEtBQVosRUFBbUIsTUFBbkIsQ0FBUDtBQUNGLFNBQUssU0FBUyxZQUFkO0FBQ0UsYUFBTyxZQUFZLEtBQVosRUFBbUIsTUFBbkIsQ0FBUDtBQUNGLFNBQUssU0FBUyxpQkFBZDtBQUNFLGFBQU8saUJBQWlCLEtBQWpCLEVBQXdCLE1BQXhCLENBQVA7QUFDRixTQUFLLFNBQVMsWUFBZDtBQUNFLGFBQU8sV0FBVyxLQUFYLEVBQWtCLE1BQWxCLENBQVA7QUFDRixTQUFLLFNBQVMsYUFBZDtBQUNFLGFBQU8sYUFBYSxLQUFiLEVBQW9CLE1BQXBCLENBQVA7QUFDRixTQUFLLFNBQVMsa0JBQWQ7QUFDRSxhQUFPLGdCQUFnQixLQUFoQixFQUF1QixNQUF2QixDQUFQO0FBQ0YsU0FBSyxTQUFTLG9CQUFkO0FBQ0UsYUFBTyxtQkFBbUIsS0FBbkIsRUFBMEIsTUFBMUIsQ0FBUDtBQUNGLFNBQUssU0FBUyxZQUFkO0FBQ0UsYUFBTyxXQUFXLEtBQVgsRUFBa0IsTUFBbEIsQ0FBUDtBQUNGLFNBQUssU0FBUyxhQUFkO0FBQ0UsYUFBTyxhQUFhLEtBQWIsRUFBb0IsTUFBcEIsQ0FBUDtBQUNGLFNBQUssU0FBUyxrQkFBZDtBQUNFLGFBQU8sZ0JBQWdCLEtBQWhCLEVBQXVCLE1BQXZCLENBQVA7QUFDRixTQUFLLFNBQVMsb0JBQWQ7QUFDRSxhQUFPLG1CQUFtQixLQUFuQixFQUEwQixNQUExQixDQUFQO0FBQ0YsU0FBSyxTQUFTLG9CQUFkO0FBQ0UsYUFBTyxtQkFBbUIsS0FBbkIsRUFBMEIsTUFBMUIsQ0FBUDtBQUNGLFNBQUssU0FBUyxjQUFkO0FBQ0UsYUFBTyxjQUFjLEtBQWQsRUFBcUIsTUFBckIsQ0FBUDtBQUNGLFNBQUssU0FBUyxZQUFkO0FBQ0UsYUFBTyxZQUFZLEtBQVosRUFBbUIsTUFBbkIsQ0FBUDtBQUNGLFNBQUssU0FBUyxTQUFkO0FBQ0UsYUFBTyxTQUFTLEtBQVQsRUFBZ0IsTUFBaEIsQ0FBUDtBQUNGLFNBQUssU0FBUyxZQUFkO0FBQ0UsYUFBTyxZQUFZLEtBQVosRUFBbUIsTUFBbkIsQ0FBUDtBQUNGLFNBQUssU0FBUyxpQkFBZDtBQUNFLGFBQU8sZ0JBQWdCLEtBQWhCLEVBQXVCLE1BQXZCLENBQVA7O0FBRUY7QUFBUyxhQUFPLEtBQVA7QUF4Q1g7QUEwQ0Q7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7UUM5R2dCLFUsR0FBQSxVO1FBMEJBLFksR0FBQSxZO1FBMEJBLGUsR0FBQSxlO1FBaUNBLGtCLEdBQUEsa0I7UUF3QkEsYSxHQUFBLGE7UUFjQSxxQixHQUFBLHFCO1FBT0EsYyxHQUFBLGM7UUFVQSxhLEdBQUEsYTtRQXVCQSxlLEdBQUEsZTtRQWNBLGUsR0FBQSxlO1FBY0EsVSxHQUFBLFU7UUFhQSxZLEdBQUEsWTtRQVdBLGMsR0FBQSxjO1FBSUEsZ0IsR0FBQSxnQjtrQkE4QlEsUTs7QUFuVXpCOztBQUNBOztBQUVBOzs7O0FBQ0E7O0FBQ0E7O0lBQVksTzs7QUFDWjs7QUFDQTs7OztBQUNBOzs7O0FBRUE7O0lBQVksUTs7QUFDWjs7OztBQUNBOzs7Ozs7ZUE4RGlCLFUsRUEwQkEsWSxFQTBCQSxlLEVBaUNBLGtCLEVBd0JBLGEsRUFjQSxxQixFQU9BLGMsRUFVQSxhLEVBdUJBLGUsRUFjQSxlLEVBY0EsVSxFQWFBLFksRUFXQSxjLEVBSUEsZ0IsRUFXUCxrQixFQW1CZSxROztBQTFTekI7OztBQUdBLFNBQVMsU0FBVCxHQUFxQjtBQUNuQixNQUFJO0FBQ0YsV0FBTyxNQUFQO0FBQ0QsR0FGRCxDQUVFLE9BQU8sQ0FBUCxFQUFVO0FBQ1YsV0FBTyxFQUFQO0FBQ0Q7QUFDRjs7QUFFRCxTQUFTLFlBQVQsQ0FBc0IsR0FBdEIsRUFBMkIsTUFBM0IsRUFBbUM7QUFDakMsTUFBTSxtQkFBbUIsSUFBSSxNQUFKLElBQWMsR0FBZCxJQUFxQixJQUFJLE1BQUosR0FBYSxHQUFsQyxHQUF3QyxRQUF4QyxHQUFtRCxTQUE1RTtBQUNBLE1BQUk7QUFDRixRQUFNLFdBQVcsS0FBSyxLQUFMLENBQVcsSUFBSSxRQUFKLElBQWdCLElBQUksWUFBL0IsQ0FBakI7QUFDQTtBQUNBLFFBQU0sYUFBYSxTQUFTLE1BQVQsQ0FBZ0IsR0FBaEIsQ0FBb0I7QUFBQSxhQUFRLE1BQVIsU0FBa0IsRUFBRSxLQUFwQixTQUE2QixFQUFFLEtBQUYsQ0FBUSxDQUFSLENBQTdCO0FBQUEsS0FBcEIsQ0FBbkI7QUFDQSxXQUFPLFdBQVcsTUFBWCxHQUFvQixXQUFXLElBQVgsQ0FBZ0IsR0FBaEIsQ0FBcEIsR0FBOEMsTUFBOUMsU0FBd0QsZ0JBQXhELFdBQVA7QUFDRCxHQUxELENBS0UsT0FBTyxDQUFQLEVBQVU7QUFDVixRQUFJLFlBQVksU0FBaEIsRUFBMkI7QUFDekIsVUFBSSxpQkFBSjtBQUNBLFVBQUksSUFBSSxNQUFKLEtBQWUsQ0FBbkIsRUFBc0I7QUFDcEIsbUJBQVcsRUFBRSxPQUFPLEVBQUUsa0RBQWdELE1BQWhELHFCQUFzRSxJQUFJLFVBQTVFLEVBQTBGLFVBQVUsWUFBcEcsRUFBa0gsWUFBWSxDQUE5SCxFQUFpSSxjQUFjLENBQS9JLEVBQVQsRUFBWDtBQUNELE9BRkQsTUFFTztBQUNMLG1CQUFXLEVBQUUsT0FBTyxFQUFFLDJEQUF5RCxnQkFBekQsVUFBOEUsTUFBOUUsV0FBMEYsSUFBSSxNQUE5RixXQUEwRyxJQUFJLFFBQWhILEVBQTRILFVBQVUsUUFBdEksRUFBZ0osWUFBWSxDQUE1SixFQUErSixjQUFjLENBQTdLLEVBQVQsRUFBWDtBQUNEO0FBQ0Qsa0JBQVksU0FBWixDQUFzQixJQUF0QixDQUEyQixRQUEzQjtBQUNEO0FBQ0QsV0FBVSxNQUFWLFNBQW9CLGdCQUFwQjtBQUNEO0FBQ0Y7O0FBRUQsSUFBTSxxQkFBcUIsa0JBQUksTUFBSixHQUFhLEdBQWIsQ0FBaUIsQ0FBakIsRUFBb0IsR0FBcEIsQ0FBd0IsRUFBeEIsRUFBNEIsS0FBNUIsQ0FBa0MsbUJBQWxDLEVBQXVELFFBQXZELEVBQTNCO0FBQ0EsSUFBTSxrQkFBa0Isa0JBQUksTUFBSixHQUFhLEtBQWIsRUFBeEI7O0FBRUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FBRUE7OztBQUdPLFNBQVUsVUFBVixDQUFxQixNQUFyQjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLGlCQUNDLGtCQUFJLFFBQVEsV0FBUixFQUFKLENBREQ7O0FBQUE7QUFBQTtBQUFBLGlCQUVrQix3Q0FGbEI7O0FBQUE7QUFFQyxrQkFGRDtBQUFBO0FBQUEsaUJBR2lCLHVDQUhqQjs7QUFBQTtBQUdDLGlCQUhEOztBQUFBLGdCQUlELENBQUMsUUFBRCxJQUFhLENBQUMsT0FKYjtBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUEsaUJBTUssd0NBQWdCLFdBQWhCLEVBQTZCLCtCQUFnQixPQUFoQixFQUF5QixRQUF6QixDQUE3QixDQU5MOztBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7O0FBUUQsa0JBQVEsR0FBUixDQUFZLHNCQUFaLEVBQW9DLFlBQUUsT0FBdEMsRUFSQyxDQVErQzs7QUFSL0M7QUFBQTtBQUFBLGlCQVVHLG1CQUFLLE9BQU8sUUFBWixDQVZIOztBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBQUEsaUJBY0cseUNBQWlCLFdBQWpCLEVBQThCLCtCQUFnQixPQUFoQixFQUF5QixRQUF6QixDQUE5QixDQWRIOztBQUFBO0FBQUE7QUFBQSxpQkFldUIsMENBZnZCOztBQUFBO0FBZUcscUJBZkg7QUFBQTtBQUFBLGlCQWdCRyxtQkFBSyxjQUFJLE1BQVQsRUFBaUIsV0FBakIsQ0FoQkg7O0FBQUE7QUFBQTtBQUFBLGlCQWlCRyxrQkFBSSxRQUFRLGFBQVIsRUFBSixDQWpCSDs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBbUJHLG1CQW5CSCxHQW1CZSxpREFBaUIsMEJBQWdCLFFBQWhCLENBbkJoQztBQW9CRyxnQkFwQkgsR0FvQlksNkJBQWMsU0FBZCxDQXBCWjtBQUFBO0FBQUEsaUJBcUJHLGtCQUFJLFFBQVEsZ0JBQVIsQ0FBeUIsTUFBekIsQ0FBSixDQXJCSDs7QUFBQTtBQUFBO0FBQUEsaUJBc0JHLGtCQUFJLFFBQVEsVUFBUixDQUFtQixNQUFuQixDQUFKLENBdEJIOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQTBCQSxTQUFVLFlBQVYsQ0FBdUIsTUFBdkI7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSxpQkFDQyxrQkFBSSxRQUFRLFdBQVIsRUFBSixDQUREOztBQUFBO0FBQUE7QUFBQSxpQkFFa0Isd0NBRmxCOztBQUFBO0FBRUMsa0JBRkQ7QUFBQTtBQUFBLGlCQUdpQix1Q0FIakI7O0FBQUE7QUFHQyxpQkFIRDs7QUFBQSxnQkFJRCxDQUFDLFFBQUQsSUFBYSxDQUFDLE9BSmI7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBLGlCQU1LLDJDQUFtQiwrQkFBZ0IsT0FBaEIsRUFBeUIsUUFBekIsQ0FBbkIsQ0FOTDs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBOztBQVFELGtCQUFRLEdBQVIsQ0FBWSw2QkFBWixFQUEyQyxhQUFFLE9BQTdDLEVBUkMsQ0FRc0Q7O0FBUnREO0FBQUE7QUFBQSxpQkFVRyxtQkFBSyxPQUFPLFFBQVosQ0FWSDs7QUFBQTtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBLGlCQWNHLDRDQUFvQiwrQkFBZ0IsT0FBaEIsRUFBeUIsUUFBekIsQ0FBcEIsQ0FkSDs7QUFBQTtBQUFBO0FBQUEsaUJBZWdCLGdEQWZoQjs7QUFBQTtBQWVHLGNBZkg7QUFBQTtBQUFBLGlCQWdCRyxtQkFBSyxjQUFJLFFBQVQsRUFBbUIsSUFBbkIsQ0FoQkg7O0FBQUE7QUFBQTtBQUFBLGlCQWlCRyxrQkFBSSxRQUFRLGVBQVIsRUFBSixDQWpCSDs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBbUJHLG1CQW5CSCxHQW1CZSwyQkFBZ0IsY0FBaEIsQ0FuQmY7QUFvQkcsZ0JBcEJILEdBb0JZLDZCQUFjLFNBQWQsQ0FwQlo7QUFBQTtBQUFBLGlCQXFCRyxrQkFBSSxRQUFRLGdCQUFSLENBQXlCLE1BQXpCLENBQUosQ0FyQkg7O0FBQUE7QUFBQTtBQUFBLGlCQXNCRyxrQkFBSSxRQUFRLFlBQVIsQ0FBcUIsTUFBckIsQ0FBSixDQXRCSDs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUEwQkEsU0FBVSxlQUFWO0FBQUEsTUFBNEIsUUFBNUIsUUFBNEIsUUFBNUI7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLGlCQUVHLGtCQUFJLFFBQVEsV0FBUixFQUFKLENBRkg7O0FBQUE7QUFBQTtBQUFBLGlCQUdvQix3Q0FIcEI7O0FBQUE7QUFHRyxrQkFISDtBQUFBO0FBQUEsaUJBSW1CLHVDQUpuQjs7QUFBQTtBQUlHLGlCQUpIO0FBQUE7QUFBQSxpQkFLZ0IsZ0RBTGhCOztBQUFBO0FBS0csY0FMSDs7QUFBQSxnQkFNQyxDQUFDLE9BQUQsSUFBWSxDQUFDLFFBTmQ7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBLGlCQVFPLHdDQUFtQixRQUFuQixhQUFxQywrQkFBZ0IsT0FBaEIsRUFBeUIsUUFBekIsQ0FBckMsQ0FSUDs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBOztBQVVDLGtCQUFRLEdBQVIsZUFBd0IsUUFBeEIsbUJBQWdELGFBQUUsT0FBbEQsRUFWRCxDQVU2RDs7QUFWN0Q7QUFBQTtBQUFBLGlCQVlLLG1CQUFLLGNBQUksV0FBVCxFQUFzQixRQUF0QixFQUFnQyxJQUFoQyxDQVpMOztBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBLGlCQWdCRyx5Q0FBb0IsUUFBcEIsYUFBc0MsK0JBQWdCLE9BQWhCLEVBQXlCLFFBQXpCLENBQXRDLENBaEJIOztBQUFBO0FBQUE7QUFBQSxpQkFpQkcsbUJBQUssY0FBSSxXQUFULEVBQXNCLFFBQXRCLEVBQWdDLElBQWhDLENBakJIOztBQUFBO0FBQUE7QUFBQSxpQkFrQkcsa0JBQUksUUFBUSxrQkFBUixFQUFKLENBbEJIOztBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7O0FBQUEsZUFvQkMsYUFBRSxhQXBCSDtBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBLGlCQXNCSyxrQkFBSSxRQUFRLFdBQVIsQ0FBb0Isa0JBQXBCLENBQUosQ0F0Qkw7O0FBQUE7QUFBQTs7QUFBQTtBQTBCRyxtQkExQkgsR0EwQmUsYUFBRSxPQTFCakI7QUEyQkcsZ0JBM0JILEdBMkJZLDZCQUFjLFNBQWQsQ0EzQlo7QUFBQTtBQUFBLGlCQTRCRyxrQkFBSSxRQUFRLGdCQUFSLENBQXlCLE1BQXpCLENBQUosQ0E1Qkg7O0FBQUE7QUFBQTtBQUFBLGlCQTZCRyxrQkFBSSxRQUFRLGVBQVIsQ0FBd0IsTUFBeEIsQ0FBSixDQTdCSDs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFpQ0EsU0FBVSxrQkFBVjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLGlCQUNDLGtCQUFJLFFBQVEsV0FBUixFQUFKLENBREQ7O0FBQUE7QUFBQTtBQUFBLGlCQUVrQix3Q0FGbEI7O0FBQUE7QUFFQyxrQkFGRDtBQUFBO0FBQUEsaUJBR2lCLHVDQUhqQjs7QUFBQTtBQUdDLGlCQUhEO0FBQUE7QUFBQTtBQUFBLGlCQU1HLGlEQUF5QiwrQkFBZ0IsT0FBaEIsRUFBeUIsUUFBekIsQ0FBekIsQ0FOSDs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBOztBQVFILGtCQUFRLEdBQVIsQ0FBWSxnQ0FBWixFQUE4QyxhQUFFLE9BQWhELEVBUkcsQ0FRdUQ7O0FBUnZEO0FBQUE7QUFBQTtBQUFBLGlCQVlnQixrREFaaEI7O0FBQUE7QUFZRyxjQVpIO0FBQUE7QUFBQSxpQkFhRyxtQkFBSyxjQUFJLGNBQVQsRUFBeUIsSUFBekIsQ0FiSDs7QUFBQTtBQUFBO0FBQUEsaUJBY0csa0JBQUksUUFBUSxrQkFBUixFQUFKLENBZEg7O0FBQUE7QUFBQTtBQUFBLGlCQWVHLGtCQUFJLFFBQVEsUUFBUixDQUFpQixnQkFBakIsRUFBbUMsZ0JBQW5DLEVBQXFELEVBQXJELENBQUosQ0FmSDs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBaUJHLG1CQWpCSCxHQWlCZSw0REFBMkIsMkJBQWdCLGlCQUFoQixDQWpCMUM7QUFrQkcsZ0JBbEJILEdBa0JZLDZCQUFjLFNBQWQsQ0FsQlo7QUFBQTtBQUFBLGlCQW1CRyxrQkFBSSxRQUFRLGdCQUFSLENBQXlCLE1BQXpCLENBQUosQ0FuQkg7O0FBQUE7QUFBQTtBQUFBLGlCQW9CRyxrQkFBSSxRQUFRLGtCQUFSLENBQTJCLE1BQTNCLENBQUosQ0FwQkg7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBd0JBLFNBQVUsYUFBVjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLGlCQUNtQix5Q0FEbkI7O0FBQUE7QUFDQyxtQkFERDs7QUFBQSxnQkFFRCxjQUFjLFFBRmI7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQSxpQkFHbUIsZ0RBSG5COztBQUFBO0FBR0csaUJBSEg7QUFBQTtBQUFBLGlCQUlxQiwwQ0FBcUIsT0FBckIsQ0FKckI7O0FBQUE7QUFJRyxtQkFKSDtBQUFBO0FBQUEsaUJBS0csbUJBQUssY0FBSSxNQUFULEVBQWlCLFNBQWpCLENBTEg7O0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUE7QUFBQSxpQkFPRyxtQkFBSyxjQUFJLGVBQVQsQ0FQSDs7QUFBQTtBQUFBO0FBQUEsaUJBUUcsbUJBQUssY0FBSSxhQUFULENBUkg7O0FBQUE7QUFBQTtBQUFBLGlCQVNHLHFDQUFZLEdBQVosQ0FUSDs7QUFBQTtBQUFBO0FBQUEsaUJBVUcsa0JBQUksUUFBUSxLQUFSLEVBQUosQ0FWSDs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFjQSxTQUFVLHFCQUFWO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLGlCQUNDLGtCQUFJLFFBQVEsUUFBUixDQUFpQixnQkFBakIsRUFBbUMsZ0JBQW5DLEVBQXFELEVBQXJELENBQUosQ0FERDs7QUFBQTtBQUFBO0FBQUEsaUJBRUMsbUJBQUssY0FBSSxlQUFULENBRkQ7O0FBQUE7QUFBQTtBQUFBLGlCQUdDLHFDQUFZLEdBQVosQ0FIRDs7QUFBQTtBQUFBO0FBQUEsaUJBSUMsa0JBQUksUUFBUSxLQUFSLEVBQUosQ0FKRDs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFPQSxTQUFVLGNBQVYsQ0FBeUIsTUFBekI7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLGlCQUVHLG1CQUFLLGNBQUksY0FBVCxFQUF5QixPQUFPLElBQWhDLENBRkg7O0FBQUE7QUFBQTtBQUFBLGlCQUdHLGtCQUFJLFFBQVEsYUFBUixFQUFKLENBSEg7O0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUtHLG1CQUxILEdBS2UsMkJBQWdCLGNBQWhCLENBTGY7QUFBQTtBQUFBLGlCQU1HLGtCQUFJLFFBQVEsZ0JBQVIsQ0FBeUIsNkJBQWMsU0FBZCxDQUF6QixDQUFKLENBTkg7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBVUEsU0FBVSxhQUFWLENBQXdCLE1BQXhCO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLGlCQUNDLHFDQUFZLElBQVosQ0FERDs7QUFBQTtBQUFBO0FBQUEsaUJBRWtCLGdEQUZsQjs7QUFBQTtBQUVDLGtCQUZEO0FBQUE7O0FBQUEsZ0JBSUMsT0FBTyxJQUFQLEtBQWdCLHVCQUFoQixJQUEyQyxTQUFTLFFBQXBELElBQWdFLENBQUMsa0JBQUksUUFBSixDQUFhLFNBQVMsUUFBdEIsRUFBZ0Msa0JBQWhDLEVBQW9ELEtBSnRIO0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUEsaUJBS3NCLG1CQUFLLGNBQUksY0FBVCxFQUF5QixTQUFTLFFBQWxDLENBTHRCOztBQUFBO0FBS0ssa0JBTEw7O0FBQUEsZUFNRyxTQUFTLE1BTlo7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQSxpQkFPTyxrQkFBSSxRQUFRLGdCQUFSLENBQXlCLDZCQUFjLGlDQUFkLENBQXpCLENBQUosQ0FQUDs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQSxnQkFTUSxPQUFPLElBQVAsS0FBZ0Isb0JBQWhCLElBQXdDLFNBQVMsS0FBakQsSUFBMEQsQ0FBQyxrQkFBSSxRQUFKLENBQWEsU0FBUyxLQUF0QixFQUE2QixlQUE3QixFQUE4QyxLQVRqSDtBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBLGlCQVVzQixtQkFBSyxjQUFJLFdBQVQsRUFBc0IsU0FBUyxLQUEvQixDQVZ0Qjs7QUFBQTtBQVVLLG1CQVZMOztBQUFBLGVBV0csVUFBUyxNQVhaO0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUEsaUJBWU8sa0JBQUksUUFBUSxnQkFBUixDQUF5Qiw2QkFBYyw4QkFBZCxDQUF6QixDQUFKLENBWlA7O0FBQUE7QUFBQSxlQWNHLFVBQVMsaUJBZFo7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQSxpQkFlTyxrQkFBSSxRQUFRLGVBQVIsQ0FBd0IsVUFBUyxpQkFBakMsQ0FBSixDQWZQOztBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7O0FBbUJILGtCQUFRLEdBQVIsQ0FBWSxzQkFBWixFQUFvQyxPQUFPLElBQTNDLEVBQWlELGFBQUUsT0FBbkQsRUFuQkcsQ0FtQjJEOztBQW5CM0Q7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBdUJBLFNBQVUsZUFBVjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLGlCQUNrQixnREFEbEI7O0FBQUE7QUFDQyxrQkFERDtBQUFBOztBQUFBLGdCQUdDLFNBQVMsS0FBVCxJQUFrQixDQUFDLGtCQUFJLFFBQUosQ0FBYSxTQUFTLEtBQXRCLEVBQTZCLGVBQTdCLEVBQThDLEtBSGxFO0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUEsaUJBSXNCLG1CQUFLLGNBQUksV0FBVCxFQUFzQixTQUFTLEtBQS9CLENBSnRCOztBQUFBO0FBSUssa0JBSkw7O0FBQUEsZUFLRyxTQUFTLGlCQUxaO0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUEsaUJBTU8sa0JBQUksUUFBUSxlQUFSLENBQXdCLFNBQVMsaUJBQWpDLENBQUosQ0FOUDs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBOztBQVVILGtCQUFRLEdBQVIsQ0FBWSx3QkFBWixFQUFzQyxhQUFFLE9BQXhDLEVBVkcsQ0FVZ0Q7O0FBVmhEO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQWNBLFNBQVUsZUFBVixDQUEwQixNQUExQjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLGlCQUNrQix3Q0FEbEI7O0FBQUE7QUFDQyxrQkFERDtBQUFBO0FBQUEsaUJBRWlCLHVDQUZqQjs7QUFBQTtBQUVDLGlCQUZEOztBQUFBLGdCQUdELENBQUMsT0FBRCxJQUFZLENBQUMsUUFIWjtBQUFBO0FBQUE7QUFBQTs7QUFBQTs7QUFBQTtBQUFBO0FBQUEsaUJBS3FCLHdDQUxyQjs7QUFBQTtBQUtDLHFCQUxEOztBQUFBLGdCQU1ELGdCQUFnQixPQUFPLFFBTnRCO0FBQUE7QUFBQTtBQUFBOztBQUFBOztBQUFBO0FBQUE7QUFBQSxpQkFTQyxrQkFBSSxRQUFRLFdBQVIsQ0FBb0IsT0FBTyxRQUEzQixDQUFKLENBVEQ7O0FBQUE7QUFBQTtBQUFBLGlCQVVDLGtCQUFJLFFBQVEsVUFBUixDQUFtQixPQUFPLFFBQTFCLENBQUosQ0FWRDs7QUFBQTtBQUFBO0FBQUEsaUJBV0Msa0JBQUksUUFBUSxZQUFSLENBQXFCLE9BQU8sUUFBNUIsQ0FBSixDQVhEOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQWNBLFNBQVUsVUFBVixDQUFxQixNQUFyQjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSxjQUNBLE9BQU8sTUFEUDtBQUFBO0FBQUE7QUFBQTs7QUFBQTs7QUFBQTtBQUVDLHdCQUZELEdBRWtCLG9CQUFZLE9BQU8sTUFBbkIsRUFBMkIsTUFBM0IsQ0FBa0MsVUFBQyxDQUFEO0FBQUEsbUJBQU8sRUFBRSxVQUFGLENBQWEsU0FBYixLQUEyQixFQUFFLFVBQUYsQ0FBYSxzQkFBYixDQUFsQztBQUFBLFdBQWxDLENBRmxCOztBQUFBLGVBSUQsZUFBZSxNQUpkO0FBQUE7QUFBQTtBQUFBOztBQUtHLGFBTEgsR0FLUyw4QkFBZSxPQUFPLE1BQVAsQ0FBYyxlQUFlLENBQWYsQ0FBZCxDQUFmLEVBQWlELEtBQWpELEtBQTJELGVBTHBFO0FBTUcsWUFOSCxHQU1RLGVBQWUsQ0FBZixNQUFzQixzQkFBdEIsR0FBK0MsbUJBQS9DLEdBQXFFLFlBTjdFO0FBQUE7QUFBQSxpQkFPb0Isd0NBUHBCOztBQUFBO0FBT0csa0JBUEg7QUFBQTtBQUFBLGlCQVFtQix1Q0FSbkI7O0FBQUE7QUFRRyxpQkFSSDtBQUFBO0FBQUEsaUJBU0cseUNBQWlCLEVBQWpCLEVBQXFCLEdBQXJCLEVBQTBCLCtCQUFnQixPQUFoQixFQUF5QixRQUF6QixDQUExQixDQVRIOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQWFBLFNBQVUsWUFBVixDQUF1QixNQUF2QjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSxjQUNBLE9BQU8sTUFEUDtBQUFBO0FBQUE7QUFBQTs7QUFBQTs7QUFBQTtBQUVDLHdCQUZELEdBRWtCLG9CQUFZLE9BQU8sTUFBbkIsRUFBMkIsTUFBM0IsQ0FBa0MsVUFBQyxDQUFEO0FBQUEsbUJBQU8sRUFBRSxVQUFGLENBQWEsZUFBYixDQUFQO0FBQUEsV0FBbEMsQ0FGbEI7O0FBQUEsZUFHRCxlQUFlLE1BSGQ7QUFBQTtBQUFBO0FBQUE7O0FBSUcsYUFKSCxHQUlTLDhCQUFlLE9BQU8sTUFBUCxDQUFjLGVBQWUsQ0FBZixDQUFkLENBQWYsRUFBaUQsS0FBakQsS0FBMkQsZUFKcEU7QUFBQTtBQUFBLGlCQUtvQix3Q0FMcEI7O0FBQUE7QUFLRyxrQkFMSDtBQUFBO0FBQUEsaUJBTW1CLHVDQU5uQjs7QUFBQTtBQU1HLGlCQU5IO0FBQUE7QUFBQSxpQkFPRyx5Q0FBaUIsZUFBakIsRUFBa0MsR0FBbEMsRUFBdUMsK0JBQWdCLE9BQWhCLEVBQXlCLFFBQXpCLENBQXZDLENBUEg7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBV0EsU0FBVSxjQUFWLENBQXlCLE1BQXpCO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLGlCQUNDLHlDQUFpQixPQUFPLFFBQXhCLENBREQ7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBSUEsU0FBVSxnQkFBVixDQUEyQixNQUEzQjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLGlCQUNrQix3Q0FEbEI7O0FBQUE7QUFDQyxrQkFERDtBQUFBO0FBQUEsaUJBRWlCLHVDQUZqQjs7QUFBQTtBQUVDLGlCQUZEO0FBQUE7QUFBQSxpQkFHa0Isd0NBSGxCOztBQUFBO0FBR0Msa0JBSEQ7QUFBQTtBQUFBLGlCQUswQixnREFMMUI7O0FBQUE7QUFLQywwQkFMRDs7QUFBQSxjQU1BLFFBTkE7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQSxpQkFPRywyQ0FBbUIsT0FBTyxRQUExQixFQUFvQywrQkFBZ0IsT0FBaEIsRUFBeUIsUUFBekIsQ0FBcEMsRUFBd0UsUUFBeEUsRUFBa0YsZ0JBQWxGLENBUEg7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBV1AsU0FBVSxrQkFBVixDQUE2QixPQUE3QixFQUFzQyxJQUF0QztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLGlCQUNxQiw4Q0FBSyxTQUFVLE9BQVY7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQ2hCLDRCQURnQixHQUNMLEVBREs7O0FBQUE7QUFBQSx5QkFFZixJQUZlO0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUEsMkJBR0MsbUJBQUssT0FBTCxDQUhEOztBQUFBO0FBR2QsMEJBSGM7O0FBQUEsMEJBSWhCLE9BQU8sSUFBUCxJQUFlLFFBSkM7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQSwyQkFNWixxQkFBTyxTQUFTLE9BQU8sSUFBaEIsQ0FBUCxDQU5ZOztBQUFBO0FBQUE7QUFBQSwyQkFRVSxtQkFBSyxJQUFMLEVBQVcsTUFBWCxDQVJWOztBQUFBO0FBUXBCLDZCQUFTLE9BQU8sSUFBaEIsQ0FSb0I7QUFBQTtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSxlQUFVLE9BQVY7QUFBQSxXQUFMLEVBRHJCOztBQUFBO0FBQ1EsY0FEUjtBQUFBLDZDQVlTLElBWlQ7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBZUEsU0FBUyxPQUFULENBQWlCLE1BQWpCLEVBQXlCO0FBQ3ZCLFNBQU8sT0FBTyxJQUFQLEtBQWdCLFNBQVMsY0FBekIsSUFBMkMsT0FBTyxJQUFQLEtBQWdCLG9CQUFsRTtBQUNEOztBQUVjLFNBQVUsUUFBVjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSxpQkFDUCxDQUNKLDBCQUFVLFNBQVMsWUFBbkIsRUFBaUMsVUFBakMsQ0FESSxFQUVKLDBCQUFVLFNBQVMsYUFBbkIsRUFBa0MsWUFBbEMsQ0FGSSxFQUdKLDBCQUFVLFNBQVMsa0JBQW5CLEVBQXVDLGVBQXZDLENBSEksRUFJSiwwQkFBVSxTQUFTLG9CQUFuQixFQUF5QyxrQkFBekMsQ0FKSSxFQUtKLDBCQUFVLFNBQVMscUJBQW5CLEVBQTBDLGFBQTFDLENBTEksRUFNSiwwQkFBVSxTQUFTLGVBQW5CLEVBQW9DLGFBQXBDLENBTkksRUFPSiwwQkFBVSxTQUFTLGdCQUFuQixFQUFxQyxhQUFyQyxDQVBJLEVBUUosMEJBQVUsU0FBUyx1QkFBbkIsRUFBNEMscUJBQTVDLENBUkksRUFTSiwwQkFBVSxTQUFTLGdCQUFuQixFQUFxQyxjQUFyQyxDQVRJLEVBVUosMEJBQVUsU0FBUyxrQkFBbkIsRUFBdUMsZUFBdkMsQ0FWSSxFQVdKLDBCQUFVLFNBQVMsWUFBbkIsRUFBaUMsVUFBakMsQ0FYSSxFQVlKLDBCQUFVLFNBQVMsa0JBQW5CLEVBQXVDLFVBQXZDLENBWkksRUFhSiwwQkFBVSxTQUFTLGFBQW5CLEVBQWtDLFlBQWxDLENBYkksRUFjSiwwQkFBVSxTQUFTLFdBQW5CLEVBQWdDLGNBQWhDLENBZEksRUFlSiwwQkFBVSxTQUFTLGFBQW5CLEVBQWtDLGdCQUFsQyxDQWZJLEVBZ0JKLG1CQUFtQixTQUFTLGNBQTVCLEVBQTRDLGFBQTVDLENBaEJJLEVBaUJKLHlCQUFTLEdBQVQsRUFBYyxPQUFkLEVBQXVCLGVBQXZCLENBakJJLENBRE87O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7Ozs7Ozs7Ozs7UUNoVUMsbUIsR0FBQSxtQjtRQUlBLFksR0FBQSxZO1FBSUEsVyxHQUFBLFc7UUFJQSxXLEdBQUEsVztRQUlBLFUsR0FBQSxVO1FBSUEsVyxHQUFBLFc7UUFJQSxxQixHQUFBLHFCO1FBSUEsWSxHQUFBLFk7UUFPQSxhLEdBQUEsYTtRQTZCQSxtQixHQUFBLG1CO1FBa0RBLG1CLEdBQUEsbUI7O0FBckhoQjs7QUFDQTs7QUFFTyxTQUFTLG1CQUFULENBQTZCLEtBQTdCLEVBQW9DO0FBQ3pDLFNBQU8sTUFBTSxNQUFOLENBQWEsZ0JBQXBCO0FBQ0Q7O0FBRU0sU0FBUyxZQUFULENBQXNCLEtBQXRCLEVBQTZCO0FBQ2xDLFNBQU8sTUFBTSxNQUFOLENBQWEsU0FBcEI7QUFDRDs7QUFFTSxTQUFTLFdBQVQsQ0FBcUIsS0FBckIsRUFBNEI7QUFDakMsU0FBTyxNQUFNLE1BQU4sQ0FBYSxRQUFwQjtBQUNEOztBQUVNLFNBQVMsV0FBVCxDQUFxQixLQUFyQixFQUE0QjtBQUNqQyxTQUFPLE1BQU0sTUFBTixDQUFhLFFBQXBCO0FBQ0Q7O0FBRU0sU0FBUyxVQUFULENBQW9CLEtBQXBCLEVBQTJCO0FBQ2hDLFNBQU8sTUFBTSxNQUFOLENBQWEsT0FBcEI7QUFDRDs7QUFFTSxTQUFTLFdBQVQsQ0FBcUIsS0FBckIsRUFBNEI7QUFDakMsU0FBTyxNQUFNLE1BQU4sQ0FBYSxRQUFwQjtBQUNEOztBQUVNLFNBQVMscUJBQVQsQ0FBK0IsS0FBL0IsRUFBc0M7QUFDM0MsU0FBTyxFQUFFLE9BQU8sTUFBTSxjQUFOLENBQXFCLGNBQTlCLEVBQVA7QUFDRDs7QUFFTSxTQUFTLFlBQVQsQ0FBc0IsS0FBdEIsRUFBNkIsT0FBN0IsRUFBc0M7QUFDM0MsTUFBSSxRQUFRLFFBQVIsS0FBcUIsU0FBckIsSUFBa0MsQ0FBQyxRQUFRLFNBQTNDLElBQXdELFFBQVEsYUFBcEUsRUFBbUY7QUFDakYsV0FBTyxNQUFNLE1BQU4sQ0FBYSxtQkFBcEI7QUFDRDtBQUNELFNBQU8sTUFBTSxNQUFOLENBQWEsU0FBcEI7QUFDRDs7QUFFTSxTQUFTLGFBQVQsQ0FBdUIsS0FBdkIsRUFBOEI7QUFDbkMsTUFBTSxTQUFTLE1BQU0sTUFBckI7QUFDQSxNQUFNLFNBQVMsTUFBTSxNQUFyQjtBQUNBLE1BQU0sY0FBYyw4QkFBZSxPQUFPLE1BQXRCLEVBQThCLE9BQU8sVUFBckMsQ0FBcEI7O0FBRUEsTUFBTSxpQkFBaUIsT0FBTyxjQUE5QjtBQUNBLE1BQU0sV0FBVyxPQUFPLFFBQXhCO0FBQ0EsTUFBTSxrQkFBa0IsT0FBTyxlQUEvQjtBQUNBLE1BQU0sUUFBUSxPQUFPLEtBQXJCOztBQUVBLE1BQU0sU0FBUyxZQUFZLE1BQTNCO0FBQ0EsTUFBTSxXQUFXLFlBQVksUUFBN0I7QUFDQSxNQUFNLGNBQWMsWUFBWSxXQUFoQztBQUNBLE1BQU0saUJBQWlCLFlBQVksY0FBbkM7O0FBRUEsTUFBTSxPQUFPO0FBQ1gsZ0JBRFc7QUFFWCxrQ0FGVztBQUdYLHNCQUhXO0FBSVgsb0NBSlc7QUFLWCxrQkFMVztBQU1YLHNCQU5XO0FBT1gsNEJBUFc7QUFRWDtBQVJXLEdBQWI7O0FBV0EsU0FBTyxJQUFQO0FBQ0Q7O0FBRU0sU0FBUyxtQkFBVCxDQUE2QixLQUE3QixFQUFvQztBQUN6QyxNQUFNLFNBQVMsTUFBTSxNQUFyQjtBQUNBLE1BQU0sV0FBVyxNQUFNLFFBQXZCO0FBQ0EsTUFBTSxjQUFjLDhCQUFlLE9BQU8sTUFBdEIsRUFBOEIsT0FBTyxVQUFyQyxDQUFwQjs7QUFFQSxNQUFNLFVBQVUsT0FBTyxPQUF2QjtBQUNBLE1BQU0sV0FBVyxPQUFPLFFBQXhCO0FBQ0EsTUFBTSxZQUFZLE9BQU8sUUFBUCxLQUFvQixTQUF0Qzs7QUFFQSxNQUFNLFNBQVMsQ0FBQyxDQUFDLFNBQVMsV0FBMUI7QUFDQSxNQUFNLFVBQVUsMkJBQVUsU0FBUyxXQUFuQixDQUFoQjs7QUFFQSxNQUFNLFNBQVMsWUFBWSxNQUEzQjtBQUNBLE1BQU0sV0FBVyxZQUFZLFFBQTdCO0FBQ0EsTUFBTSxjQUFjLFlBQVksV0FBaEM7QUFDQSxNQUFNLGlCQUFpQixZQUFZLGNBQW5DOztBQUVBLE1BQU0sT0FBTztBQUNYLGNBQVUsU0FBUyxRQURSO0FBRVgsV0FBTyxTQUFTLEtBQVQsSUFBa0IsRUFGZDtBQUdYLGNBQVUsU0FBUyxRQUhSO0FBSVgsY0FBVSxPQUFPLFFBQVAsSUFBbUIsSUFKbEI7QUFLWCxnQkFBWSxZQUFZLEtBQVosR0FBb0IsU0FBUyxVQUw5QjtBQU1YLFlBQVMsQ0FBQyxPQUFELElBQVksQ0FBQyxRQUFkLEdBQTBCLE9BQU8sR0FBakMsR0FBdUMsVUFBVSxPQUFPLFFBQVAsQ0FBZ0IsSUFOOUQ7QUFPWCxrQkFQVztBQVFYLHNCQVJXO0FBU1gsNEJBVFc7QUFVWCxrQ0FWVztBQVdYLFdBQU8sT0FBTztBQVhILEdBQWI7O0FBY0EsT0FBSyxRQUFMLEdBQWdCLE9BQU8sUUFBUCxJQUFtQixFQUFuQzs7QUFFQSxNQUFJLENBQUMsT0FBTyxRQUFaLEVBQXNCO0FBQ3BCLFNBQUssU0FBTCxHQUFpQixTQUFTLFNBQTFCO0FBQ0EsU0FBSyxRQUFMLEdBQWdCLFNBQVMsUUFBekI7QUFDRDs7QUFFRCxNQUFJLGFBQWEsTUFBakIsRUFBeUI7QUFDdkIsU0FBSyxXQUFMLEdBQW1CLFNBQVMsV0FBNUI7QUFDRDs7QUFFRCxNQUFJLGFBQWEsT0FBakIsRUFBMEI7QUFDeEIsU0FBSyxTQUFMLEdBQWlCLFNBQVMsU0FBMUI7QUFDQSxTQUFLLGFBQUwsR0FBcUIsU0FBUyxhQUE5QjtBQUNEOztBQUVELFNBQU8sSUFBUDtBQUNEOztBQUVNLFNBQVMsbUJBQVQsQ0FBNkIsS0FBN0IsRUFBb0M7QUFDekMsTUFBTSxTQUFTLE1BQU0sTUFBckI7QUFDQSxNQUFNLFdBQVcsTUFBTSxRQUF2QjtBQUNBLE1BQU0sY0FBYyw4QkFBZSxPQUFPLE1BQXRCLEVBQThCLE9BQU8sVUFBckMsQ0FBcEI7O0FBRUEsTUFBTSxZQUFZLE9BQU8sUUFBUCxLQUFvQixTQUF0QztBQUNBLE1BQU0sVUFBVSxPQUFPLE9BQXZCO0FBQ0EsTUFBTSxXQUFXLE9BQU8sUUFBeEI7O0FBRUEsTUFBTSxTQUFTLFlBQVksTUFBM0I7QUFDQSxNQUFNLFdBQVcsWUFBWSxRQUE3QjtBQUNBLE1BQU0sY0FBYyxZQUFZLFdBQWhDO0FBQ0EsTUFBTSxpQkFBaUIsWUFBWSxjQUFuQztBQUNBLE1BQUksZUFBSjtBQUNBLE1BQUksT0FBTyxNQUFYLEVBQW1CO0FBQ2pCLGFBQVMsT0FBTyxNQUFoQjtBQUNELEdBRkQsTUFFTyxJQUFJLENBQUMsT0FBRCxJQUFZLENBQUMsUUFBakIsRUFBMkI7QUFDaEMsYUFBUyxPQUFPLEdBQWhCO0FBQ0QsR0FGTSxNQUVBO0FBQ0wsYUFBUyxVQUFVLE9BQU8sUUFBUCxDQUFnQixJQUFuQztBQUNEOztBQUVELE1BQU0sT0FBTztBQUNYLGFBQVMsV0FBVyxRQURUO0FBRVgsY0FBVSxPQUFPLFFBRk47QUFHWCxnQkFBWSxZQUFZLEtBQVosR0FBb0IsU0FBUyxVQUg5QjtBQUlYLGtCQUpXO0FBS1gsV0FBTyxPQUFPLEtBTEg7QUFNWCxrQkFOVztBQU9YLHNCQVBXO0FBUVgsNEJBUlc7QUFTWCxrQ0FUVztBQVVYLHFCQUFpQixNQUFNLE1BQU4sQ0FBYSxlQVZuQjtBQVdYLFNBQU0sV0FBVyxRQUFaLEdBQXdCLG9CQUF4QixHQUErQyxPQUFPLEdBQVAsSUFBYyxPQUFPLFFBQVAsQ0FBZ0I7QUFYdkUsR0FBYjs7QUFjQSxPQUFLLFFBQUwsR0FBZ0IsT0FBTyxRQUFQLElBQW1CLEVBQW5DOztBQUVBLFNBQU8sSUFBUDtBQUNEOzs7Ozs7O0FDM0pEOztBQUNBOzs7O0FBQ0E7O0FBRUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7O0FBQ0E7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7O0lBQVksTzs7QUFDWjs7Ozs7O0FBRUEsSUFBTSxTQUFTLE9BQU8sR0FBUCxDQUFXLE1BQTFCLEMsQ0FoQkE7OztBQWtCQSwwQkFBZSxRQUFmOztBQUVBLElBQU0sZ0JBQWdCLHFCQUF0QjtBQUNBLElBQU0sbUJBQWlCLGFBQXZCOztBQUVBLElBQU0sWUFBWSxTQUFaLFNBQVksR0FBTTtBQUN0QixNQUFNLGlCQUFpQiwwQkFBdkI7O0FBRUEsTUFBTSxlQUFlLFNBQVMsYUFBVCxDQUF1QixVQUF2QixDQUFyQjtBQUNBLGVBQWEsU0FBYixHQUE0QixhQUE1QjtBQUNBLE1BQU0sZUFBZSxLQUFLLEtBQUwsQ0FBVyxhQUFhLFlBQWIsQ0FBMEIsaUJBQTFCLENBQVgsQ0FBckI7O0FBRUEsTUFBTSxXQUFXLG9CQUNmLDRCQUFnQixjQUFoQixDQURlLENBQWpCOztBQUlBLE1BQU0sUUFBUSw0Q0FFWixZQUZZLEVBR1osUUFIWSxDQUFkO0FBS0E7QUFDQSxpQkFBZSxHQUFmOztBQUVBLE1BQU0sTUFBTSxnQkFBTSxhQUFOLGVBQVo7QUFDQSxNQUFNLFdBQVcsZ0JBQU0sYUFBTix1QkFBOEIsRUFBRSxZQUFGLEVBQTlCLEVBQXlDLEdBQXpDLENBQWpCOztBQUVBLHFCQUFTLE1BQVQsQ0FBZ0IsUUFBaEIsRUFBMEIsWUFBMUI7O0FBRUEsU0FBTyxFQUFQLENBQVUsY0FBVixFQUEwQixVQUFDLFNBQUQsRUFBWSxJQUFaLEVBQXFCO0FBQzdDLFFBQUksS0FBSyxLQUFMLEtBQWUsU0FBbkIsRUFBOEI7QUFDNUIsWUFBTSxRQUFOLENBQWUsUUFBUSxlQUFSLENBQXdCLEtBQUssR0FBN0IsQ0FBZjtBQUNEO0FBQ0YsR0FKRDtBQUtBO0FBQ0EsU0FBTyxFQUFQLENBQVUscUJBQVYsRUFBaUMsVUFBQyxTQUFELEVBQVksSUFBWixFQUFxQjtBQUNwRCxRQUFNLE9BQU8sS0FBSyxHQUFsQjtBQUNBLFFBQUksS0FBSyxLQUFMLEtBQWUsU0FBZixJQUE0QixTQUFTLHdCQUFZLE1BQU0sUUFBTixFQUFaLENBQXpDLEVBQXdFO0FBQ3RFLFlBQU0sUUFBTixDQUFlLFFBQVEsVUFBUixDQUFtQixJQUFuQixDQUFmO0FBQ0Q7QUFDRixHQUxEO0FBTUQsQ0FwQ0Q7O0FBc0NBLElBQUksU0FBUyxhQUFULENBQXVCLFVBQXZCLENBQUosRUFBd0M7QUFDdEMsY0FEc0MsQ0FDekI7QUFDZCxDQUZELE1BRU87QUFDTCxTQUFPLEdBQVAsQ0FBVyxZQUFYLEVBQXlCLFNBQXpCLEVBREssQ0FDZ0M7QUFDdEMiLCJmaWxlIjoiZ2VuZXJhdGVkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXNDb250ZW50IjpbIihmdW5jdGlvbiBlKHQsbixyKXtmdW5jdGlvbiBzKG8sdSl7aWYoIW5bb10pe2lmKCF0W29dKXt2YXIgYT10eXBlb2YgcmVxdWlyZT09XCJmdW5jdGlvblwiJiZyZXF1aXJlO2lmKCF1JiZhKXJldHVybiBhKG8sITApO2lmKGkpcmV0dXJuIGkobywhMCk7dmFyIGY9bmV3IEVycm9yKFwiQ2Fubm90IGZpbmQgbW9kdWxlICdcIitvK1wiJ1wiKTt0aHJvdyBmLmNvZGU9XCJNT0RVTEVfTk9UX0ZPVU5EXCIsZn12YXIgbD1uW29dPXtleHBvcnRzOnt9fTt0W29dWzBdLmNhbGwobC5leHBvcnRzLGZ1bmN0aW9uKGUpe3ZhciBuPXRbb11bMV1bZV07cmV0dXJuIHMobj9uOmUpfSxsLGwuZXhwb3J0cyxlLHQsbixyKX1yZXR1cm4gbltvXS5leHBvcnRzfXZhciBpPXR5cGVvZiByZXF1aXJlPT1cImZ1bmN0aW9uXCImJnJlcXVpcmU7Zm9yKHZhciBvPTA7bzxyLmxlbmd0aDtvKyspcyhyW29dKTtyZXR1cm4gc30pIiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbnZhciBfbWVtb2l6ZSA9IHJlcXVpcmUoMyk7XG52YXIgd3JhcHBlciA9IHJlcXVpcmUoNCk7XG5cbmZ1bmN0aW9uIG1lbW9pemUoZ2V0S2V5KSB7XG4gIHJldHVybiBfbWVtb2l6ZSh3cmFwcGVyLCBnZXRLZXkpO1xufVxuXG5tb2R1bGUuZXhwb3J0cyA9IG1lbW9pemU7XG5cbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG52YXIgX3JldHJ5ID0gcmVxdWlyZSg1KTtcbnZhciB3cmFwcGVyID0gcmVxdWlyZSg0KTtcblxuZnVuY3Rpb24gcmV0cnkodGltZXMsIGludGVydmFsLCBlcnJvcikge1xuICByZXR1cm4gX3JldHJ5KHdyYXBwZXIsIHRpbWVzLCBpbnRlcnZhbCwgZXJyb3IpO1xufVxuXG5tb2R1bGUuZXhwb3J0cyA9IHJldHJ5O1xuXG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xudmFyIGRlZmF1bHRMb2dnZXIgPSByZXF1aXJlKDcpO1xudmFyIGtleUdldHRlciA9IHJlcXVpcmUoMTM4KTtcblxuZnVuY3Rpb24gbWVtb2l6ZURlY29yYXRvcih3cmFwcGVyLCBnZXRLZXkpIHtcbiAgZ2V0S2V5ID0ga2V5R2V0dGVyKGdldEtleSB8fCBmdW5jdGlvbiAoKSB7IHJldHVybiAnX2RlZmF1bHQnOyB9KTtcbiAgcmV0dXJuIHdyYXBwZXIoZnVuY3Rpb24gKGZ1bmMpIHtcbiAgICB2YXIgY2FjaGUgPSB7fTtcbiAgICByZXR1cm4gZnVuY3Rpb24gKCkge1xuICAgICAgdmFyIGNvbnRleHQgPSB0aGlzO1xuICAgICAgdmFyIGFyZ3MgPSBBcnJheS5wcm90b3R5cGUuc2xpY2UuY2FsbChhcmd1bWVudHMsIDApO1xuICAgICAgdmFyIGxvZ2dlciA9IGRlZmF1bHRMb2dnZXIuYXBwbHkoY29udGV4dCk7XG4gICAgICB2YXIgY2IgPSBhcmdzW2FyZ3MubGVuZ3RoIC0gMV07XG4gICAgICB2YXIgY2FjaGVLZXkgPSBnZXRLZXkuYXBwbHkoY29udGV4dCwgYXJncyk7XG4gICAgICBhcmdzW2FyZ3MubGVuZ3RoIC0gMV0gPSBmdW5jdGlvbiAoZXJyLCBkZXApIHtcbiAgICAgICAgaWYgKCFlcnIgJiYgY2FjaGVLZXkgIT09IG51bGwpIHtcbiAgICAgICAgICBjYWNoZVtjYWNoZUtleV0gPSBkZXA7XG4gICAgICAgIH1cbiAgICAgICAgY2IoZXJyLCBkZXApO1xuICAgICAgfTtcbiAgICAgIGlmIChjYWNoZUtleSAhPT0gbnVsbCAmJiBjYWNoZUtleSBpbiBjYWNoZSkge1xuICAgICAgICBsb2dnZXIoJ21lbW9pemUtaGl0Jywge2tleTogY2FjaGVLZXksIHJlc3VsdDogY2FjaGVbY2FjaGVLZXldfSk7XG4gICAgICAgIHJldHVybiBjYihudWxsLCBjYWNoZVtjYWNoZUtleV0pO1xuICAgICAgfVxuICAgICAgZWxzZSB7XG4gICAgICAgIGZ1bmMuYXBwbHkoY29udGV4dCwgYXJncyk7XG4gICAgICB9XG4gICAgfTtcbiAgfSk7XG59XG5cbm1vZHVsZS5leHBvcnRzID0gbWVtb2l6ZURlY29yYXRvcjtcblxufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbnZhciBwcm9taXNpZnkgPSByZXF1aXJlKDEzNSk7XG52YXIgY2FsbGJhY2tpZnkgPSByZXF1aXJlKDYpO1xuXG4vLyBpdCB3b3JrcyBmb3IgZGVjb3JhdG9yKGYpIGFuZCBkZWNvcmF0b3IoW2YxLCBmMiwgZjMgLi4uXSlcblxuZnVuY3Rpb24gcHJvbWlzZVRyYW5zbGF0b3IoZGVjb3JhdG9yKSB7XG4gIHJldHVybiBmdW5jdGlvbiAoZikgeyAvLyBmIHJldHVybnMgYSBwcm9taXNlXG4gICAgdmFyIGNiO1xuICAgIGlmIChBcnJheS5pc0FycmF5KGYpKSB7XG4gICAgICBjYiA9IGYubWFwKGNhbGxiYWNraWZ5KTtcbiAgICB9IGVsc2Uge1xuICAgICAgY2IgPSBjYWxsYmFja2lmeShmKTtcbiAgICB9XG5cbiAgICByZXR1cm4gcHJvbWlzaWZ5KGRlY29yYXRvcihjYikpO1xuICB9O1xufVxuXG5tb2R1bGUuZXhwb3J0cyA9IHByb21pc2VUcmFuc2xhdG9yO1xuXG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xudmFyIGRlZmF1bHRMb2dnZXIgPSByZXF1aXJlKDcpO1xuXG5mdW5jdGlvbiByZXRyeURlY29yYXRvcih3cmFwcGVyLCB0aW1lcywgaW50ZXJ2YWwsIGVycm9yKSB7XG4gIHZhciBjb25kaXRpb247XG4gIHRpbWVzID0gdGltZXMgfHwgSW5maW5pdHk7XG4gIGVycm9yID0gZXJyb3IgfHwgRXJyb3I7XG4gIGludGVydmFsID0gaW50ZXJ2YWwgfHwgMDtcbiAgdmFyIGludGVydmFsRnVuYyA9IHR5cGVvZiBpbnRlcnZhbCA9PT0gJ2Z1bmN0aW9uJyA/XG4gICAgaW50ZXJ2YWwgOlxuICAgIGZ1bmN0aW9uICgpIHsgcmV0dXJuIGludGVydmFsOyB9O1xuXG4gIGlmIChlcnJvciA9PT0gRXJyb3IgfHwgRXJyb3IuaXNQcm90b3R5cGVPZihlcnJvcikpIHtcbiAgICBjb25kaXRpb24gPSBmdW5jdGlvbiAoZXJyLCBkZXApIHsgcmV0dXJuIGVyciBpbnN0YW5jZW9mIGVycm9yOyB9O1xuICB9XG4gIGVsc2Uge1xuICAgIGNvbmRpdGlvbiA9IGVycm9yO1xuICB9XG5cbiAgcmV0dXJuIHdyYXBwZXIoZnVuY3Rpb24gKGZ1bmMpIHtcbiAgICByZXR1cm4gZnVuY3Rpb24gKCkge1xuICAgICAgdmFyIGNvdW50ZXIgPSAwO1xuICAgICAgdmFyIGNvbnRleHQgPSB0aGlzO1xuICAgICAgdmFyIGFyZ3MgPSBBcnJheS5wcm90b3R5cGUuc2xpY2UuY2FsbChhcmd1bWVudHMsIDApO1xuICAgICAgdmFyIGxvZ2dlciA9IGRlZmF1bHRMb2dnZXIuYXBwbHkoY29udGV4dCk7XG4gICAgICB2YXIgY2IgPSBhcmdzW2FyZ3MubGVuZ3RoIC0gMV07XG5cbiAgICAgIHZhciByZXRyeSA9IGZ1bmN0aW9uICgpIHtcbiAgICAgICAgaWYgKGNvdW50ZXIrKyAmJiBpbnRlcnZhbEZ1bmMoY291bnRlcikgPiAwKSB7IC8vIGRvIG5vdCB3YWl0IGZvciBjb3VudGVyID09PSAwXG4gICAgICAgICAgc2V0VGltZW91dChmdW5jdGlvbiAoKSB7XG4gICAgICAgICAgICBmdW5jLmFwcGx5KGNvbnRleHQsIGFyZ3MpO1xuICAgICAgICAgIH0sIGludGVydmFsKTtcbiAgICAgICAgfVxuICAgICAgICBlbHNlIHtcbiAgICAgICAgICBmdW5jLmFwcGx5KGNvbnRleHQsIGFyZ3MpO1xuICAgICAgICB9XG4gICAgICB9O1xuXG4gICAgICBhcmdzW2FyZ3MubGVuZ3RoIC0gMV0gPSBmdW5jdGlvbiAoZXJyLCBkZXApIHtcbiAgICAgICAgaWYgKGNvbmRpdGlvbihlcnIsIGRlcCkgJiYgY291bnRlciA8IHRpbWVzKSB7XG4gICAgICAgICAgbG9nZ2VyKCdyZXRyeScsIHtcbiAgICAgICAgICAgIHRpbWVzOiBjb3VudGVyLFxuICAgICAgICAgICAgYWN0dWFsUmVzdWx0OiB7ZXJyOiBlcnIsIHJlczogZGVwfVxuICAgICAgICAgIH0pO1xuICAgICAgICAgIHJldHJ5KCk7XG4gICAgICAgIH1cbiAgICAgICAgZWxzZSB7XG4gICAgICAgICAgY2IoZXJyLCBkZXApO1xuICAgICAgICB9XG4gICAgICB9O1xuICAgICAgcmV0cnkoKTtcbiAgICB9O1xuICB9KTtcbn1cblxubW9kdWxlLmV4cG9ydHMgPSByZXRyeURlY29yYXRvcjtcblxufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbmZ1bmN0aW9uIGlzUHJvbWlzZShvYmopIHtcbiAgcmV0dXJuIHR5cGVvZiBvYmogPT09ICdvYmplY3QnICYmICd0aGVuJyBpbiBvYmo7XG59XG5cbmZ1bmN0aW9uIGNhbGxiYWNraWZ5KGZ1bmMpIHtcbiAgcmV0dXJuIGZ1bmN0aW9uICgpIHtcbiAgICAvLyBnZXQgYXJndW1lbnRzXG4gICAgdmFyIGNvbnRleHQgPSB0aGlzO1xuICAgIHZhciBhcmdzID0gQXJyYXkucHJvdG90eXBlLnNsaWNlLmNhbGwoYXJndW1lbnRzLCAwLCAtMSk7XG4gICAgdmFyIGNiID0gYXJndW1lbnRzW2FyZ3VtZW50cy5sZW5ndGggLSAxXTtcbiAgICB0cnkge1xuICAgICAgdmFyIG91dHB1dCA9IGZ1bmMuYXBwbHkoY29udGV4dCwgYXJncyk7XG4gICAgfVxuICAgIGNhdGNoIChlKSB7XG4gICAgICByZXR1cm4gY2IoZSk7XG4gICAgfVxuXG4gICAgaWYgKGlzUHJvbWlzZShvdXRwdXQpKSB7XG4gICAgICBvdXRwdXQudGhlbihmdW5jdGlvbiAocmVzKSB7IC8vIG9uZnVsZmlsbGVkXG4gICAgICAgIGNiKG51bGwsIHJlcyk7XG4gICAgICB9LFxuICAgICAgZnVuY3Rpb24gKGVycm9yKSB7IC8vIG9ucmVqZWN0ZWRcbiAgICAgICAgY2IoZXJyb3IpO1xuICAgICAgfSk7XG4gICAgfVxuICAgIGVsc2Uge1xuICAgICAgY2IobnVsbCwgb3V0cHV0KTtcbiAgICB9XG4gIH07XG59XG5cbm1vZHVsZS5leHBvcnRzID0gY2FsbGJhY2tpZnk7XG5cbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uICgpIHtcbiAgaWYgKHR5cGVvZiB0aGlzID09PSAnb2JqZWN0JyAmJiAnX19sb2cnIGluIHRoaXMpIHtcbiAgICByZXR1cm4gdGhpcy5fX2xvZztcbiAgfVxuICByZXR1cm4gZnVuY3Rpb24gKCkge307XG59O1xuXG59KTsiLCIoZnVuY3Rpb24gKGNiKXtcbiAgdmFyIHc7XG4gIHRyeSB7XG4gICAgdyA9IHdpbmRvdztcbiAgfSBjYXRjaCAoZSkge1xuICAgIHcgPSBnbG9iYWw7XG4gIH1cblxuICB2YXIgcXVldWUgPSB3Ll9hc3luY19kZWZpbmVfcXVldWUgPSAnX2FzeW5jX2RlZmluZV9xdWV1ZScgaW4gdyA/IHcuX2FzeW5jX2RlZmluZV9xdWV1ZSA6IFtdO1xuICB2YXIgY2FjaGVkX2RlcGVuZGVuY2llcyA9IHcuX2FzeW5jX2RlZmluZV9jYWNoZWRfZGVwZW5kZW5jaWVzID0gJ19hc3luY19kZWZpbmVfY2FjaGVkX2RlcGVuZGVuY2llcycgaW4gdyA/IHcuX2FzeW5jX2RlZmluZV9jYWNoZWRfZGVwZW5kZW5jaWVzIDoge307XG5cbiAgZnVuY3Rpb24gZ2V0RGVwc0FycmF5KGRlcE5hbWVzKSB7XG4gICAgdmFyIGksXG4gICAgICB0bXAsIGRlcE5TLCBkZXBQcm9wLFxuICAgICAgbGVuID0gZGVwTmFtZXMubGVuZ3RoLFxuICAgICAgZGVwcyA9IFtdO1xuXG4gICAgZm9yIChpID0gMDsgaSA8IGxlbjsgaSsrKSB7XG4gICAgICB0bXAgPSBkZXBOYW1lc1tpXS5zcGxpdCgnfCcpO1xuICAgICAgZGVwTlMgPSB0bXBbMF07XG4gICAgICBkZXBQcm9wID0gdG1wWzFdO1xuICAgICAgaWYgKGRlcE5TIGluIGNhY2hlZF9kZXBlbmRlbmNpZXMpe1xuICAgICAgICBkZXBzLnB1c2goZGVwUHJvcCA/IGNhY2hlZF9kZXBlbmRlbmNpZXNbZGVwTlNdW2RlcFByb3BdIDogY2FjaGVkX2RlcGVuZGVuY2llc1tkZXBOU10pO1xuICAgICAgfVxuICAgICAgZWxzZSB7XG4gICAgICAgIHJldHVybjtcbiAgICAgIH1cbiAgICB9XG4gICAgcmV0dXJuIGRlcHM7XG4gIH1cblxuICBmdW5jdGlvbiBydW5UaHJvdWdoUXVldWUoKSB7XG4gICAgd2hpbGUgKF9ydW5UaHJvdWdoUXVldWUoKSk7XG4gIH1cblxuICBmdW5jdGlvbiBfcnVuVGhyb3VnaFF1ZXVlKCkge1xuICAgIHZhciBpID0gMDtcbiAgICB2YXIgc29sdmVkRGVwZW5kZW5jeSA9IGZhbHNlO1xuICAgIHdoaWxlIChpIDwgcXVldWUubGVuZ3RoKXtcbiAgICAgIGlmIChleGVjdXRlKHF1ZXVlW2ldKSl7XG4gICAgICAgIGlmIChxdWV1ZVtpXS5uYW1lKXtcbiAgICAgICAgICBzb2x2ZWREZXBlbmRlbmN5ID0gdHJ1ZTtcbiAgICAgICAgfVxuICAgICAgICBxdWV1ZS5zcGxpY2UoaSwgMSk7XG4gICAgICB9XG4gICAgICBlbHNlIHtcbiAgICAgICAgaSsrO1xuICAgICAgfVxuICAgIH1cbiAgICByZXR1cm4gc29sdmVkRGVwZW5kZW5jeTtcbiAgfVxuXG4gIGZ1bmN0aW9uIGV4ZWN1dGUgKGl0ZW0pe1xuICAgIGlmIChpdGVtLm5hbWUgaW4gY2FjaGVkX2RlcGVuZGVuY2llcykgeyAvLyBkb24ndCBleGVjdXRlIHR3aWNlXG4gICAgICByZXR1cm4gdHJ1ZTtcbiAgICB9XG4gICAgdmFyIGRlcHMgPSBnZXREZXBzQXJyYXkoaXRlbS5kZXBOYW1lcyk7XG4gICAgdmFyIGV4cDtcbiAgICBpZiAoZGVwcyl7XG4gICAgICBleHAgPSBpdGVtLmZ1bmMuYXBwbHkodywgZGVwcyk7XG4gICAgICBpZiAoaXRlbS5uYW1lKXtcbiAgICAgICAgY2FjaGVkX2RlcGVuZGVuY2llc1tpdGVtLm5hbWVdID0gZXhwO1xuICAgICAgfVxuICAgICAgcmV0dXJuIHRydWU7XG4gICAgfVxuICAgIGVsc2Uge1xuICAgICAgcmV0dXJuO1xuICAgIH1cbiAgfVxuXG4gIGZ1bmN0aW9uIHdyYXBPYmogKG8pe1xuICAgIGlmICh0eXBlb2YgbyA9PT0gJ2Z1bmN0aW9uJyl7XG4gICAgICByZXR1cm4gbztcbiAgICB9XG4gICAgZWxzZSB7XG4gICAgICByZXR1cm4gZnVuY3Rpb24gKCl7XG4gICAgICAgIHJldHVybiBvO1xuICAgICAgfTtcbiAgICB9XG4gIH1cblxuICBmdW5jdGlvbiBhZCgpIHtcbiAgICB2YXIgaXRlbSA9IHtcbiAgICAgICAgbmFtZTogIHR5cGVvZiBhcmd1bWVudHNbMF0gPT09ICdzdHJpbmcnID8gYXJndW1lbnRzWzBdIDogdW5kZWZpbmVkLFxuICAgICAgICBkZXBOYW1lczogQXJyYXkuaXNBcnJheShhcmd1bWVudHNbMF0pID8gYXJndW1lbnRzWzBdIDogQXJyYXkuaXNBcnJheShhcmd1bWVudHNbMV0pID8gYXJndW1lbnRzWzFdIDogW10sXG4gICAgICAgIGZ1bmM6IHdyYXBPYmooYXJndW1lbnRzW2FyZ3VtZW50cy5sZW5ndGggLSAxXSlcbiAgICB9O1xuICAgIGlmICghZXhlY3V0ZShpdGVtKSl7XG4gICAgICBxdWV1ZS5wdXNoKGl0ZW0pO1xuICAgIH1cbiAgICBlbHNlIHtcbiAgICAgIGlmIChpdGVtLm5hbWUpe1xuICAgICAgICBydW5UaHJvdWdoUXVldWUoKTsgLy8gZXhlY3V0ZWQgc3RyYWlnaHQgYXdheSwgdHJ5IHRvIHJlc29sdmUgZnVuYyB0aGF0IGRlcGVuZHMgb24gdGhpc1xuICAgICAgfVxuICAgIH1cbiAgfVxuICBjYi5jYWxsKHcsIGFkKTtcbn0oZnVuY3Rpb24gKGRlZmluZSkge1xuICBpZiAodHlwZW9mIGV4cG9ydHMgPT09ICdvYmplY3QnKXtcbiAgbW9kdWxlLmV4cG9ydHMgPSBkZWZpbmU7XG59XG5lbHNle1xuICB0aGlzLmFzeW5jRGVmaW5lID0gZGVmaW5lO1xufVxuXG59KSk7XG5cbiIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG5tb2R1bGUuZXhwb3J0cyA9IHsgXCJkZWZhdWx0XCI6IHJlcXVpcmUoMzEpLCBfX2VzTW9kdWxlOiB0cnVlIH07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xubW9kdWxlLmV4cG9ydHMgPSB7IFwiZGVmYXVsdFwiOiByZXF1aXJlKDMyKSwgX19lc01vZHVsZTogdHJ1ZSB9O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbm1vZHVsZS5leHBvcnRzID0geyBcImRlZmF1bHRcIjogcmVxdWlyZSgzMyksIF9fZXNNb2R1bGU6IHRydWUgfTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG5tb2R1bGUuZXhwb3J0cyA9IHsgXCJkZWZhdWx0XCI6IHJlcXVpcmUoMzQpLCBfX2VzTW9kdWxlOiB0cnVlIH07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xubW9kdWxlLmV4cG9ydHMgPSB7IFwiZGVmYXVsdFwiOiByZXF1aXJlKDM1KSwgX19lc01vZHVsZTogdHJ1ZSB9O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbm1vZHVsZS5leHBvcnRzID0geyBcImRlZmF1bHRcIjogcmVxdWlyZSgzNiksIF9fZXNNb2R1bGU6IHRydWUgfTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG5tb2R1bGUuZXhwb3J0cyA9IHsgXCJkZWZhdWx0XCI6IHJlcXVpcmUoMzcpLCBfX2VzTW9kdWxlOiB0cnVlIH07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xubW9kdWxlLmV4cG9ydHMgPSB7IFwiZGVmYXVsdFwiOiByZXF1aXJlKDM4KSwgX19lc01vZHVsZTogdHJ1ZSB9O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbm1vZHVsZS5leHBvcnRzID0geyBcImRlZmF1bHRcIjogcmVxdWlyZSgzOSksIF9fZXNNb2R1bGU6IHRydWUgfTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG5tb2R1bGUuZXhwb3J0cyA9IHsgXCJkZWZhdWx0XCI6IHJlcXVpcmUoNDApLCBfX2VzTW9kdWxlOiB0cnVlIH07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xubW9kdWxlLmV4cG9ydHMgPSB7IFwiZGVmYXVsdFwiOiByZXF1aXJlKDQxKSwgX19lc01vZHVsZTogdHJ1ZSB9O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbm1vZHVsZS5leHBvcnRzID0geyBcImRlZmF1bHRcIjogcmVxdWlyZSg0MiksIF9fZXNNb2R1bGU6IHRydWUgfTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG5cInVzZSBzdHJpY3RcIjtcblxuZXhwb3J0cy5fX2VzTW9kdWxlID0gdHJ1ZTtcblxuZXhwb3J0cy5kZWZhdWx0ID0gZnVuY3Rpb24gKGluc3RhbmNlLCBDb25zdHJ1Y3Rvcikge1xuICBpZiAoIShpbnN0YW5jZSBpbnN0YW5jZW9mIENvbnN0cnVjdG9yKSkge1xuICAgIHRocm93IG5ldyBUeXBlRXJyb3IoXCJDYW5ub3QgY2FsbCBhIGNsYXNzIGFzIGEgZnVuY3Rpb25cIik7XG4gIH1cbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xuXCJ1c2Ugc3RyaWN0XCI7XG5cbmV4cG9ydHMuX19lc01vZHVsZSA9IHRydWU7XG5cbnZhciBfZGVmaW5lUHJvcGVydHkgPSByZXF1aXJlKDE0KTtcblxudmFyIF9kZWZpbmVQcm9wZXJ0eTIgPSBfaW50ZXJvcFJlcXVpcmVEZWZhdWx0KF9kZWZpbmVQcm9wZXJ0eSk7XG5cbmZ1bmN0aW9uIF9pbnRlcm9wUmVxdWlyZURlZmF1bHQob2JqKSB7IHJldHVybiBvYmogJiYgb2JqLl9fZXNNb2R1bGUgPyBvYmogOiB7IGRlZmF1bHQ6IG9iaiB9OyB9XG5cbmV4cG9ydHMuZGVmYXVsdCA9IGZ1bmN0aW9uICgpIHtcbiAgZnVuY3Rpb24gZGVmaW5lUHJvcGVydGllcyh0YXJnZXQsIHByb3BzKSB7XG4gICAgZm9yICh2YXIgaSA9IDA7IGkgPCBwcm9wcy5sZW5ndGg7IGkrKykge1xuICAgICAgdmFyIGRlc2NyaXB0b3IgPSBwcm9wc1tpXTtcbiAgICAgIGRlc2NyaXB0b3IuZW51bWVyYWJsZSA9IGRlc2NyaXB0b3IuZW51bWVyYWJsZSB8fCBmYWxzZTtcbiAgICAgIGRlc2NyaXB0b3IuY29uZmlndXJhYmxlID0gdHJ1ZTtcbiAgICAgIGlmIChcInZhbHVlXCIgaW4gZGVzY3JpcHRvcikgZGVzY3JpcHRvci53cml0YWJsZSA9IHRydWU7XG4gICAgICAoMCwgX2RlZmluZVByb3BlcnR5Mi5kZWZhdWx0KSh0YXJnZXQsIGRlc2NyaXB0b3Iua2V5LCBkZXNjcmlwdG9yKTtcbiAgICB9XG4gIH1cblxuICByZXR1cm4gZnVuY3Rpb24gKENvbnN0cnVjdG9yLCBwcm90b1Byb3BzLCBzdGF0aWNQcm9wcykge1xuICAgIGlmIChwcm90b1Byb3BzKSBkZWZpbmVQcm9wZXJ0aWVzKENvbnN0cnVjdG9yLnByb3RvdHlwZSwgcHJvdG9Qcm9wcyk7XG4gICAgaWYgKHN0YXRpY1Byb3BzKSBkZWZpbmVQcm9wZXJ0aWVzKENvbnN0cnVjdG9yLCBzdGF0aWNQcm9wcyk7XG4gICAgcmV0dXJuIENvbnN0cnVjdG9yO1xuICB9O1xufSgpO1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcblwidXNlIHN0cmljdFwiO1xuXG5leHBvcnRzLl9fZXNNb2R1bGUgPSB0cnVlO1xuXG52YXIgX2RlZmluZVByb3BlcnR5ID0gcmVxdWlyZSgxNCk7XG5cbnZhciBfZGVmaW5lUHJvcGVydHkyID0gX2ludGVyb3BSZXF1aXJlRGVmYXVsdChfZGVmaW5lUHJvcGVydHkpO1xuXG5mdW5jdGlvbiBfaW50ZXJvcFJlcXVpcmVEZWZhdWx0KG9iaikgeyByZXR1cm4gb2JqICYmIG9iai5fX2VzTW9kdWxlID8gb2JqIDogeyBkZWZhdWx0OiBvYmogfTsgfVxuXG5leHBvcnRzLmRlZmF1bHQgPSBmdW5jdGlvbiAob2JqLCBrZXksIHZhbHVlKSB7XG4gIGlmIChrZXkgaW4gb2JqKSB7XG4gICAgKDAsIF9kZWZpbmVQcm9wZXJ0eTIuZGVmYXVsdCkob2JqLCBrZXksIHtcbiAgICAgIHZhbHVlOiB2YWx1ZSxcbiAgICAgIGVudW1lcmFibGU6IHRydWUsXG4gICAgICBjb25maWd1cmFibGU6IHRydWUsXG4gICAgICB3cml0YWJsZTogdHJ1ZVxuICAgIH0pO1xuICB9IGVsc2Uge1xuICAgIG9ialtrZXldID0gdmFsdWU7XG4gIH1cblxuICByZXR1cm4gb2JqO1xufTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG5cInVzZSBzdHJpY3RcIjtcblxuZXhwb3J0cy5fX2VzTW9kdWxlID0gdHJ1ZTtcblxudmFyIF9hc3NpZ24gPSByZXF1aXJlKDEyKTtcblxudmFyIF9hc3NpZ24yID0gX2ludGVyb3BSZXF1aXJlRGVmYXVsdChfYXNzaWduKTtcblxuZnVuY3Rpb24gX2ludGVyb3BSZXF1aXJlRGVmYXVsdChvYmopIHsgcmV0dXJuIG9iaiAmJiBvYmouX19lc01vZHVsZSA/IG9iaiA6IHsgZGVmYXVsdDogb2JqIH07IH1cblxuZXhwb3J0cy5kZWZhdWx0ID0gX2Fzc2lnbjIuZGVmYXVsdCB8fCBmdW5jdGlvbiAodGFyZ2V0KSB7XG4gIGZvciAodmFyIGkgPSAxOyBpIDwgYXJndW1lbnRzLmxlbmd0aDsgaSsrKSB7XG4gICAgdmFyIHNvdXJjZSA9IGFyZ3VtZW50c1tpXTtcblxuICAgIGZvciAodmFyIGtleSBpbiBzb3VyY2UpIHtcbiAgICAgIGlmIChPYmplY3QucHJvdG90eXBlLmhhc093blByb3BlcnR5LmNhbGwoc291cmNlLCBrZXkpKSB7XG4gICAgICAgIHRhcmdldFtrZXldID0gc291cmNlW2tleV07XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgcmV0dXJuIHRhcmdldDtcbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xuXCJ1c2Ugc3RyaWN0XCI7XG5cbmV4cG9ydHMuX19lc01vZHVsZSA9IHRydWU7XG5cbnZhciBfc2V0UHJvdG90eXBlT2YgPSByZXF1aXJlKDE3KTtcblxudmFyIF9zZXRQcm90b3R5cGVPZjIgPSBfaW50ZXJvcFJlcXVpcmVEZWZhdWx0KF9zZXRQcm90b3R5cGVPZik7XG5cbnZhciBfY3JlYXRlID0gcmVxdWlyZSgxMyk7XG5cbnZhciBfY3JlYXRlMiA9IF9pbnRlcm9wUmVxdWlyZURlZmF1bHQoX2NyZWF0ZSk7XG5cbnZhciBfdHlwZW9mMiA9IHJlcXVpcmUoMjgpO1xuXG52YXIgX3R5cGVvZjMgPSBfaW50ZXJvcFJlcXVpcmVEZWZhdWx0KF90eXBlb2YyKTtcblxuZnVuY3Rpb24gX2ludGVyb3BSZXF1aXJlRGVmYXVsdChvYmopIHsgcmV0dXJuIG9iaiAmJiBvYmouX19lc01vZHVsZSA/IG9iaiA6IHsgZGVmYXVsdDogb2JqIH07IH1cblxuZXhwb3J0cy5kZWZhdWx0ID0gZnVuY3Rpb24gKHN1YkNsYXNzLCBzdXBlckNsYXNzKSB7XG4gIGlmICh0eXBlb2Ygc3VwZXJDbGFzcyAhPT0gXCJmdW5jdGlvblwiICYmIHN1cGVyQ2xhc3MgIT09IG51bGwpIHtcbiAgICB0aHJvdyBuZXcgVHlwZUVycm9yKFwiU3VwZXIgZXhwcmVzc2lvbiBtdXN0IGVpdGhlciBiZSBudWxsIG9yIGEgZnVuY3Rpb24sIG5vdCBcIiArICh0eXBlb2Ygc3VwZXJDbGFzcyA9PT0gXCJ1bmRlZmluZWRcIiA/IFwidW5kZWZpbmVkXCIgOiAoMCwgX3R5cGVvZjMuZGVmYXVsdCkoc3VwZXJDbGFzcykpKTtcbiAgfVxuXG4gIHN1YkNsYXNzLnByb3RvdHlwZSA9ICgwLCBfY3JlYXRlMi5kZWZhdWx0KShzdXBlckNsYXNzICYmIHN1cGVyQ2xhc3MucHJvdG90eXBlLCB7XG4gICAgY29uc3RydWN0b3I6IHtcbiAgICAgIHZhbHVlOiBzdWJDbGFzcyxcbiAgICAgIGVudW1lcmFibGU6IGZhbHNlLFxuICAgICAgd3JpdGFibGU6IHRydWUsXG4gICAgICBjb25maWd1cmFibGU6IHRydWVcbiAgICB9XG4gIH0pO1xuICBpZiAoc3VwZXJDbGFzcykgX3NldFByb3RvdHlwZU9mMi5kZWZhdWx0ID8gKDAsIF9zZXRQcm90b3R5cGVPZjIuZGVmYXVsdCkoc3ViQ2xhc3MsIHN1cGVyQ2xhc3MpIDogc3ViQ2xhc3MuX19wcm90b19fID0gc3VwZXJDbGFzcztcbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xuXCJ1c2Ugc3RyaWN0XCI7XG5cbmV4cG9ydHMuX19lc01vZHVsZSA9IHRydWU7XG5cbnZhciBfdHlwZW9mMiA9IHJlcXVpcmUoMjgpO1xuXG52YXIgX3R5cGVvZjMgPSBfaW50ZXJvcFJlcXVpcmVEZWZhdWx0KF90eXBlb2YyKTtcblxuZnVuY3Rpb24gX2ludGVyb3BSZXF1aXJlRGVmYXVsdChvYmopIHsgcmV0dXJuIG9iaiAmJiBvYmouX19lc01vZHVsZSA/IG9iaiA6IHsgZGVmYXVsdDogb2JqIH07IH1cblxuZXhwb3J0cy5kZWZhdWx0ID0gZnVuY3Rpb24gKHNlbGYsIGNhbGwpIHtcbiAgaWYgKCFzZWxmKSB7XG4gICAgdGhyb3cgbmV3IFJlZmVyZW5jZUVycm9yKFwidGhpcyBoYXNuJ3QgYmVlbiBpbml0aWFsaXNlZCAtIHN1cGVyKCkgaGFzbid0IGJlZW4gY2FsbGVkXCIpO1xuICB9XG5cbiAgcmV0dXJuIGNhbGwgJiYgKCh0eXBlb2YgY2FsbCA9PT0gXCJ1bmRlZmluZWRcIiA/IFwidW5kZWZpbmVkXCIgOiAoMCwgX3R5cGVvZjMuZGVmYXVsdCkoY2FsbCkpID09PSBcIm9iamVjdFwiIHx8IHR5cGVvZiBjYWxsID09PSBcImZ1bmN0aW9uXCIpID8gY2FsbCA6IHNlbGY7XG59O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcblwidXNlIHN0cmljdFwiO1xuXG5leHBvcnRzLl9fZXNNb2R1bGUgPSB0cnVlO1xuXG52YXIgX2lzSXRlcmFibGUyID0gcmVxdWlyZSgxMCk7XG5cbnZhciBfaXNJdGVyYWJsZTMgPSBfaW50ZXJvcFJlcXVpcmVEZWZhdWx0KF9pc0l0ZXJhYmxlMik7XG5cbnZhciBfZ2V0SXRlcmF0b3IyID0gcmVxdWlyZSg5KTtcblxudmFyIF9nZXRJdGVyYXRvcjMgPSBfaW50ZXJvcFJlcXVpcmVEZWZhdWx0KF9nZXRJdGVyYXRvcjIpO1xuXG5mdW5jdGlvbiBfaW50ZXJvcFJlcXVpcmVEZWZhdWx0KG9iaikgeyByZXR1cm4gb2JqICYmIG9iai5fX2VzTW9kdWxlID8gb2JqIDogeyBkZWZhdWx0OiBvYmogfTsgfVxuXG5leHBvcnRzLmRlZmF1bHQgPSBmdW5jdGlvbiAoKSB7XG4gIGZ1bmN0aW9uIHNsaWNlSXRlcmF0b3IoYXJyLCBpKSB7XG4gICAgdmFyIF9hcnIgPSBbXTtcbiAgICB2YXIgX24gPSB0cnVlO1xuICAgIHZhciBfZCA9IGZhbHNlO1xuICAgIHZhciBfZSA9IHVuZGVmaW5lZDtcblxuICAgIHRyeSB7XG4gICAgICBmb3IgKHZhciBfaSA9ICgwLCBfZ2V0SXRlcmF0b3IzLmRlZmF1bHQpKGFyciksIF9zOyAhKF9uID0gKF9zID0gX2kubmV4dCgpKS5kb25lKTsgX24gPSB0cnVlKSB7XG4gICAgICAgIF9hcnIucHVzaChfcy52YWx1ZSk7XG5cbiAgICAgICAgaWYgKGkgJiYgX2Fyci5sZW5ndGggPT09IGkpIGJyZWFrO1xuICAgICAgfVxuICAgIH0gY2F0Y2ggKGVycikge1xuICAgICAgX2QgPSB0cnVlO1xuICAgICAgX2UgPSBlcnI7XG4gICAgfSBmaW5hbGx5IHtcbiAgICAgIHRyeSB7XG4gICAgICAgIGlmICghX24gJiYgX2lbXCJyZXR1cm5cIl0pIF9pW1wicmV0dXJuXCJdKCk7XG4gICAgICB9IGZpbmFsbHkge1xuICAgICAgICBpZiAoX2QpIHRocm93IF9lO1xuICAgICAgfVxuICAgIH1cblxuICAgIHJldHVybiBfYXJyO1xuICB9XG5cbiAgcmV0dXJuIGZ1bmN0aW9uIChhcnIsIGkpIHtcbiAgICBpZiAoQXJyYXkuaXNBcnJheShhcnIpKSB7XG4gICAgICByZXR1cm4gYXJyO1xuICAgIH0gZWxzZSBpZiAoKDAsIF9pc0l0ZXJhYmxlMy5kZWZhdWx0KShPYmplY3QoYXJyKSkpIHtcbiAgICAgIHJldHVybiBzbGljZUl0ZXJhdG9yKGFyciwgaSk7XG4gICAgfSBlbHNlIHtcbiAgICAgIHRocm93IG5ldyBUeXBlRXJyb3IoXCJJbnZhbGlkIGF0dGVtcHQgdG8gZGVzdHJ1Y3R1cmUgbm9uLWl0ZXJhYmxlIGluc3RhbmNlXCIpO1xuICAgIH1cbiAgfTtcbn0oKTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG5cInVzZSBzdHJpY3RcIjtcblxuZXhwb3J0cy5fX2VzTW9kdWxlID0gdHJ1ZTtcblxudmFyIF9pdGVyYXRvciA9IHJlcXVpcmUoMjApO1xuXG52YXIgX2l0ZXJhdG9yMiA9IF9pbnRlcm9wUmVxdWlyZURlZmF1bHQoX2l0ZXJhdG9yKTtcblxudmFyIF9zeW1ib2wgPSByZXF1aXJlKDE5KTtcblxudmFyIF9zeW1ib2wyID0gX2ludGVyb3BSZXF1aXJlRGVmYXVsdChfc3ltYm9sKTtcblxudmFyIF90eXBlb2YgPSB0eXBlb2YgX3N5bWJvbDIuZGVmYXVsdCA9PT0gXCJmdW5jdGlvblwiICYmIHR5cGVvZiBfaXRlcmF0b3IyLmRlZmF1bHQgPT09IFwic3ltYm9sXCIgPyBmdW5jdGlvbiAob2JqKSB7IHJldHVybiB0eXBlb2Ygb2JqOyB9IDogZnVuY3Rpb24gKG9iaikgeyByZXR1cm4gb2JqICYmIHR5cGVvZiBfc3ltYm9sMi5kZWZhdWx0ID09PSBcImZ1bmN0aW9uXCIgJiYgb2JqLmNvbnN0cnVjdG9yID09PSBfc3ltYm9sMi5kZWZhdWx0ICYmIG9iaiAhPT0gX3N5bWJvbDIuZGVmYXVsdC5wcm90b3R5cGUgPyBcInN5bWJvbFwiIDogdHlwZW9mIG9iajsgfTtcblxuZnVuY3Rpb24gX2ludGVyb3BSZXF1aXJlRGVmYXVsdChvYmopIHsgcmV0dXJuIG9iaiAmJiBvYmouX19lc01vZHVsZSA/IG9iaiA6IHsgZGVmYXVsdDogb2JqIH07IH1cblxuZXhwb3J0cy5kZWZhdWx0ID0gdHlwZW9mIF9zeW1ib2wyLmRlZmF1bHQgPT09IFwiZnVuY3Rpb25cIiAmJiBfdHlwZW9mKF9pdGVyYXRvcjIuZGVmYXVsdCkgPT09IFwic3ltYm9sXCIgPyBmdW5jdGlvbiAob2JqKSB7XG4gIHJldHVybiB0eXBlb2Ygb2JqID09PSBcInVuZGVmaW5lZFwiID8gXCJ1bmRlZmluZWRcIiA6IF90eXBlb2Yob2JqKTtcbn0gOiBmdW5jdGlvbiAob2JqKSB7XG4gIHJldHVybiBvYmogJiYgdHlwZW9mIF9zeW1ib2wyLmRlZmF1bHQgPT09IFwiZnVuY3Rpb25cIiAmJiBvYmouY29uc3RydWN0b3IgPT09IF9zeW1ib2wyLmRlZmF1bHQgJiYgb2JqICE9PSBfc3ltYm9sMi5kZWZhdWx0LnByb3RvdHlwZSA/IFwic3ltYm9sXCIgOiB0eXBlb2Ygb2JqID09PSBcInVuZGVmaW5lZFwiID8gXCJ1bmRlZmluZWRcIiA6IF90eXBlb2Yob2JqKTtcbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xubW9kdWxlLmV4cG9ydHMgPSByZXF1aXJlKDE1NSk7XG5cbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG5cbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG5yZXF1aXJlKDEzMCk7XG5yZXF1aXJlKDEyNik7XG5tb2R1bGUuZXhwb3J0cyA9IHJlcXVpcmUoMTE1KTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG5yZXF1aXJlKDEzMCk7XG5yZXF1aXJlKDEyNik7XG5tb2R1bGUuZXhwb3J0cyA9IHJlcXVpcmUoMTE2KTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG52YXIgY29yZSAgPSByZXF1aXJlKDUwKVxuICAsICRKU09OID0gY29yZS5KU09OIHx8IChjb3JlLkpTT04gPSB7c3RyaW5naWZ5OiBKU09OLnN0cmluZ2lmeX0pO1xubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbiBzdHJpbmdpZnkoaXQpeyAvLyBlc2xpbnQtZGlzYWJsZS1saW5lIG5vLXVudXNlZC12YXJzXG4gIHJldHVybiAkSlNPTi5zdHJpbmdpZnkuYXBwbHkoJEpTT04sIGFyZ3VtZW50cyk7XG59O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbnJlcXVpcmUoMTE4KTtcbm1vZHVsZS5leHBvcnRzID0gcmVxdWlyZSg1MCkuT2JqZWN0LmFzc2lnbjtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG5yZXF1aXJlKDExOSk7XG52YXIgJE9iamVjdCA9IHJlcXVpcmUoNTApLk9iamVjdDtcbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24gY3JlYXRlKFAsIEQpe1xuICByZXR1cm4gJE9iamVjdC5jcmVhdGUoUCwgRCk7XG59O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbnJlcXVpcmUoMTIwKTtcbnZhciAkT2JqZWN0ID0gcmVxdWlyZSg1MCkuT2JqZWN0O1xubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbiBkZWZpbmVQcm9wZXJ0eShpdCwga2V5LCBkZXNjKXtcbiAgcmV0dXJuICRPYmplY3QuZGVmaW5lUHJvcGVydHkoaXQsIGtleSwgZGVzYyk7XG59O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbnJlcXVpcmUoMTIxKTtcbm1vZHVsZS5leHBvcnRzID0gcmVxdWlyZSg1MCkuT2JqZWN0LmdldFByb3RvdHlwZU9mO1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbnJlcXVpcmUoMTIyKTtcbm1vZHVsZS5leHBvcnRzID0gcmVxdWlyZSg1MCkuT2JqZWN0LmtleXM7XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xucmVxdWlyZSgxMjMpO1xubW9kdWxlLmV4cG9ydHMgPSByZXF1aXJlKDUwKS5PYmplY3Quc2V0UHJvdG90eXBlT2Y7XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xucmVxdWlyZSgxMjQpO1xucmVxdWlyZSgxMjYpO1xucmVxdWlyZSgxMzApO1xucmVxdWlyZSgxMjUpO1xubW9kdWxlLmV4cG9ydHMgPSByZXF1aXJlKDUwKS5Qcm9taXNlO1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbnJlcXVpcmUoMTI3KTtcbnJlcXVpcmUoMTI0KTtcbnJlcXVpcmUoMTI4KTtcbnJlcXVpcmUoMTI5KTtcbm1vZHVsZS5leHBvcnRzID0gcmVxdWlyZSg1MCkuU3ltYm9sO1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbnJlcXVpcmUoMTI2KTtcbnJlcXVpcmUoMTMwKTtcbm1vZHVsZS5leHBvcnRzID0gcmVxdWlyZSgxMTIpLmYoJ2l0ZXJhdG9yJyk7XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbihpdCl7XG4gIGlmKHR5cGVvZiBpdCAhPSAnZnVuY3Rpb24nKXRocm93IFR5cGVFcnJvcihpdCArICcgaXMgbm90IGEgZnVuY3Rpb24hJyk7XG4gIHJldHVybiBpdDtcbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbigpeyAvKiBlbXB0eSAqLyB9O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24oaXQsIENvbnN0cnVjdG9yLCBuYW1lLCBmb3JiaWRkZW5GaWVsZCl7XG4gIGlmKCEoaXQgaW5zdGFuY2VvZiBDb25zdHJ1Y3RvcikgfHwgKGZvcmJpZGRlbkZpZWxkICE9PSB1bmRlZmluZWQgJiYgZm9yYmlkZGVuRmllbGQgaW4gaXQpKXtcbiAgICB0aHJvdyBUeXBlRXJyb3IobmFtZSArICc6IGluY29ycmVjdCBpbnZvY2F0aW9uIScpO1xuICB9IHJldHVybiBpdDtcbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xudmFyIGlzT2JqZWN0ID0gcmVxdWlyZSg2OSk7XG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uKGl0KXtcbiAgaWYoIWlzT2JqZWN0KGl0KSl0aHJvdyBUeXBlRXJyb3IoaXQgKyAnIGlzIG5vdCBhbiBvYmplY3QhJyk7XG4gIHJldHVybiBpdDtcbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xuLy8gZmFsc2UgLT4gQXJyYXkjaW5kZXhPZlxuLy8gdHJ1ZSAgLT4gQXJyYXkjaW5jbHVkZXNcbnZhciB0b0lPYmplY3QgPSByZXF1aXJlKDEwNilcbiAgLCB0b0xlbmd0aCAgPSByZXF1aXJlKDEwNylcbiAgLCB0b0luZGV4ICAgPSByZXF1aXJlKDEwNCk7XG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uKElTX0lOQ0xVREVTKXtcbiAgcmV0dXJuIGZ1bmN0aW9uKCR0aGlzLCBlbCwgZnJvbUluZGV4KXtcbiAgICB2YXIgTyAgICAgID0gdG9JT2JqZWN0KCR0aGlzKVxuICAgICAgLCBsZW5ndGggPSB0b0xlbmd0aChPLmxlbmd0aClcbiAgICAgICwgaW5kZXggID0gdG9JbmRleChmcm9tSW5kZXgsIGxlbmd0aClcbiAgICAgICwgdmFsdWU7XG4gICAgLy8gQXJyYXkjaW5jbHVkZXMgdXNlcyBTYW1lVmFsdWVaZXJvIGVxdWFsaXR5IGFsZ29yaXRobVxuICAgIGlmKElTX0lOQ0xVREVTICYmIGVsICE9IGVsKXdoaWxlKGxlbmd0aCA+IGluZGV4KXtcbiAgICAgIHZhbHVlID0gT1tpbmRleCsrXTtcbiAgICAgIGlmKHZhbHVlICE9IHZhbHVlKXJldHVybiB0cnVlO1xuICAgIC8vIEFycmF5I3RvSW5kZXggaWdub3JlcyBob2xlcywgQXJyYXkjaW5jbHVkZXMgLSBub3RcbiAgICB9IGVsc2UgZm9yKDtsZW5ndGggPiBpbmRleDsgaW5kZXgrKylpZihJU19JTkNMVURFUyB8fCBpbmRleCBpbiBPKXtcbiAgICAgIGlmKE9baW5kZXhdID09PSBlbClyZXR1cm4gSVNfSU5DTFVERVMgfHwgaW5kZXggfHwgMDtcbiAgICB9IHJldHVybiAhSVNfSU5DTFVERVMgJiYgLTE7XG4gIH07XG59O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbi8vIGdldHRpbmcgdGFnIGZyb20gMTkuMS4zLjYgT2JqZWN0LnByb3RvdHlwZS50b1N0cmluZygpXG52YXIgY29mID0gcmVxdWlyZSg0OSlcbiAgLCBUQUcgPSByZXF1aXJlKDExMykoJ3RvU3RyaW5nVGFnJylcbiAgLy8gRVMzIHdyb25nIGhlcmVcbiAgLCBBUkcgPSBjb2YoZnVuY3Rpb24oKXsgcmV0dXJuIGFyZ3VtZW50czsgfSgpKSA9PSAnQXJndW1lbnRzJztcblxuLy8gZmFsbGJhY2sgZm9yIElFMTEgU2NyaXB0IEFjY2VzcyBEZW5pZWQgZXJyb3JcbnZhciB0cnlHZXQgPSBmdW5jdGlvbihpdCwga2V5KXtcbiAgdHJ5IHtcbiAgICByZXR1cm4gaXRba2V5XTtcbiAgfSBjYXRjaChlKXsgLyogZW1wdHkgKi8gfVxufTtcblxubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbihpdCl7XG4gIHZhciBPLCBULCBCO1xuICByZXR1cm4gaXQgPT09IHVuZGVmaW5lZCA/ICdVbmRlZmluZWQnIDogaXQgPT09IG51bGwgPyAnTnVsbCdcbiAgICAvLyBAQHRvU3RyaW5nVGFnIGNhc2VcbiAgICA6IHR5cGVvZiAoVCA9IHRyeUdldChPID0gT2JqZWN0KGl0KSwgVEFHKSkgPT0gJ3N0cmluZycgPyBUXG4gICAgLy8gYnVpbHRpblRhZyBjYXNlXG4gICAgOiBBUkcgPyBjb2YoTylcbiAgICAvLyBFUzMgYXJndW1lbnRzIGZhbGxiYWNrXG4gICAgOiAoQiA9IGNvZihPKSkgPT0gJ09iamVjdCcgJiYgdHlwZW9mIE8uY2FsbGVlID09ICdmdW5jdGlvbicgPyAnQXJndW1lbnRzJyA6IEI7XG59O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbnZhciB0b1N0cmluZyA9IHt9LnRvU3RyaW5nO1xuXG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uKGl0KXtcbiAgcmV0dXJuIHRvU3RyaW5nLmNhbGwoaXQpLnNsaWNlKDgsIC0xKTtcbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xudmFyIGNvcmUgPSBtb2R1bGUuZXhwb3J0cyA9IHt2ZXJzaW9uOiAnMi40LjAnfTtcbmlmKHR5cGVvZiBfX2UgPT0gJ251bWJlcicpX19lID0gY29yZTsgLy8gZXNsaW50LWRpc2FibGUtbGluZSBuby11bmRlZlxufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbi8vIG9wdGlvbmFsIC8gc2ltcGxlIGNvbnRleHQgYmluZGluZ1xudmFyIGFGdW5jdGlvbiA9IHJlcXVpcmUoNDMpO1xubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbihmbiwgdGhhdCwgbGVuZ3RoKXtcbiAgYUZ1bmN0aW9uKGZuKTtcbiAgaWYodGhhdCA9PT0gdW5kZWZpbmVkKXJldHVybiBmbjtcbiAgc3dpdGNoKGxlbmd0aCl7XG4gICAgY2FzZSAxOiByZXR1cm4gZnVuY3Rpb24oYSl7XG4gICAgICByZXR1cm4gZm4uY2FsbCh0aGF0LCBhKTtcbiAgICB9O1xuICAgIGNhc2UgMjogcmV0dXJuIGZ1bmN0aW9uKGEsIGIpe1xuICAgICAgcmV0dXJuIGZuLmNhbGwodGhhdCwgYSwgYik7XG4gICAgfTtcbiAgICBjYXNlIDM6IHJldHVybiBmdW5jdGlvbihhLCBiLCBjKXtcbiAgICAgIHJldHVybiBmbi5jYWxsKHRoYXQsIGEsIGIsIGMpO1xuICAgIH07XG4gIH1cbiAgcmV0dXJuIGZ1bmN0aW9uKC8qIC4uLmFyZ3MgKi8pe1xuICAgIHJldHVybiBmbi5hcHBseSh0aGF0LCBhcmd1bWVudHMpO1xuICB9O1xufTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4vLyA3LjIuMSBSZXF1aXJlT2JqZWN0Q29lcmNpYmxlKGFyZ3VtZW50KVxubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbihpdCl7XG4gIGlmKGl0ID09IHVuZGVmaW5lZCl0aHJvdyBUeXBlRXJyb3IoXCJDYW4ndCBjYWxsIG1ldGhvZCBvbiAgXCIgKyBpdCk7XG4gIHJldHVybiBpdDtcbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xuLy8gVGhhbmsncyBJRTggZm9yIGhpcyBmdW5ueSBkZWZpbmVQcm9wZXJ0eVxubW9kdWxlLmV4cG9ydHMgPSAhcmVxdWlyZSg1OCkoZnVuY3Rpb24oKXtcbiAgcmV0dXJuIE9iamVjdC5kZWZpbmVQcm9wZXJ0eSh7fSwgJ2EnLCB7Z2V0OiBmdW5jdGlvbigpeyByZXR1cm4gNzsgfX0pLmEgIT0gNztcbn0pO1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbnZhciBpc09iamVjdCA9IHJlcXVpcmUoNjkpXG4gICwgZG9jdW1lbnQgPSByZXF1aXJlKDYwKS5kb2N1bWVudFxuICAvLyBpbiBvbGQgSUUgdHlwZW9mIGRvY3VtZW50LmNyZWF0ZUVsZW1lbnQgaXMgJ29iamVjdCdcbiAgLCBpcyA9IGlzT2JqZWN0KGRvY3VtZW50KSAmJiBpc09iamVjdChkb2N1bWVudC5jcmVhdGVFbGVtZW50KTtcbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24oaXQpe1xuICByZXR1cm4gaXMgPyBkb2N1bWVudC5jcmVhdGVFbGVtZW50KGl0KSA6IHt9O1xufTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4vLyBJRSA4LSBkb24ndCBlbnVtIGJ1ZyBrZXlzXG5tb2R1bGUuZXhwb3J0cyA9IChcbiAgJ2NvbnN0cnVjdG9yLGhhc093blByb3BlcnR5LGlzUHJvdG90eXBlT2YscHJvcGVydHlJc0VudW1lcmFibGUsdG9Mb2NhbGVTdHJpbmcsdG9TdHJpbmcsdmFsdWVPZidcbikuc3BsaXQoJywnKTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4vLyBhbGwgZW51bWVyYWJsZSBvYmplY3Qga2V5cywgaW5jbHVkZXMgc3ltYm9sc1xudmFyIGdldEtleXMgPSByZXF1aXJlKDkwKVxuICAsIGdPUFMgICAgPSByZXF1aXJlKDg3KVxuICAsIHBJRSAgICAgPSByZXF1aXJlKDkxKTtcbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24oaXQpe1xuICB2YXIgcmVzdWx0ICAgICA9IGdldEtleXMoaXQpXG4gICAgLCBnZXRTeW1ib2xzID0gZ09QUy5mO1xuICBpZihnZXRTeW1ib2xzKXtcbiAgICB2YXIgc3ltYm9scyA9IGdldFN5bWJvbHMoaXQpXG4gICAgICAsIGlzRW51bSAgPSBwSUUuZlxuICAgICAgLCBpICAgICAgID0gMFxuICAgICAgLCBrZXk7XG4gICAgd2hpbGUoc3ltYm9scy5sZW5ndGggPiBpKWlmKGlzRW51bS5jYWxsKGl0LCBrZXkgPSBzeW1ib2xzW2krK10pKXJlc3VsdC5wdXNoKGtleSk7XG4gIH0gcmV0dXJuIHJlc3VsdDtcbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xudmFyIGdsb2JhbCAgICA9IHJlcXVpcmUoNjApXG4gICwgY29yZSAgICAgID0gcmVxdWlyZSg1MClcbiAgLCBjdHggICAgICAgPSByZXF1aXJlKDUxKVxuICAsIGhpZGUgICAgICA9IHJlcXVpcmUoNjIpXG4gICwgUFJPVE9UWVBFID0gJ3Byb3RvdHlwZSc7XG5cbnZhciAkZXhwb3J0ID0gZnVuY3Rpb24odHlwZSwgbmFtZSwgc291cmNlKXtcbiAgdmFyIElTX0ZPUkNFRCA9IHR5cGUgJiAkZXhwb3J0LkZcbiAgICAsIElTX0dMT0JBTCA9IHR5cGUgJiAkZXhwb3J0LkdcbiAgICAsIElTX1NUQVRJQyA9IHR5cGUgJiAkZXhwb3J0LlNcbiAgICAsIElTX1BST1RPICA9IHR5cGUgJiAkZXhwb3J0LlBcbiAgICAsIElTX0JJTkQgICA9IHR5cGUgJiAkZXhwb3J0LkJcbiAgICAsIElTX1dSQVAgICA9IHR5cGUgJiAkZXhwb3J0LldcbiAgICAsIGV4cG9ydHMgICA9IElTX0dMT0JBTCA/IGNvcmUgOiBjb3JlW25hbWVdIHx8IChjb3JlW25hbWVdID0ge30pXG4gICAgLCBleHBQcm90byAgPSBleHBvcnRzW1BST1RPVFlQRV1cbiAgICAsIHRhcmdldCAgICA9IElTX0dMT0JBTCA/IGdsb2JhbCA6IElTX1NUQVRJQyA/IGdsb2JhbFtuYW1lXSA6IChnbG9iYWxbbmFtZV0gfHwge30pW1BST1RPVFlQRV1cbiAgICAsIGtleSwgb3duLCBvdXQ7XG4gIGlmKElTX0dMT0JBTClzb3VyY2UgPSBuYW1lO1xuICBmb3Ioa2V5IGluIHNvdXJjZSl7XG4gICAgLy8gY29udGFpbnMgaW4gbmF0aXZlXG4gICAgb3duID0gIUlTX0ZPUkNFRCAmJiB0YXJnZXQgJiYgdGFyZ2V0W2tleV0gIT09IHVuZGVmaW5lZDtcbiAgICBpZihvd24gJiYga2V5IGluIGV4cG9ydHMpY29udGludWU7XG4gICAgLy8gZXhwb3J0IG5hdGl2ZSBvciBwYXNzZWRcbiAgICBvdXQgPSBvd24gPyB0YXJnZXRba2V5XSA6IHNvdXJjZVtrZXldO1xuICAgIC8vIHByZXZlbnQgZ2xvYmFsIHBvbGx1dGlvbiBmb3IgbmFtZXNwYWNlc1xuICAgIGV4cG9ydHNba2V5XSA9IElTX0dMT0JBTCAmJiB0eXBlb2YgdGFyZ2V0W2tleV0gIT0gJ2Z1bmN0aW9uJyA/IHNvdXJjZVtrZXldXG4gICAgLy8gYmluZCB0aW1lcnMgdG8gZ2xvYmFsIGZvciBjYWxsIGZyb20gZXhwb3J0IGNvbnRleHRcbiAgICA6IElTX0JJTkQgJiYgb3duID8gY3R4KG91dCwgZ2xvYmFsKVxuICAgIC8vIHdyYXAgZ2xvYmFsIGNvbnN0cnVjdG9ycyBmb3IgcHJldmVudCBjaGFuZ2UgdGhlbSBpbiBsaWJyYXJ5XG4gICAgOiBJU19XUkFQICYmIHRhcmdldFtrZXldID09IG91dCA/IChmdW5jdGlvbihDKXtcbiAgICAgIHZhciBGID0gZnVuY3Rpb24oYSwgYiwgYyl7XG4gICAgICAgIGlmKHRoaXMgaW5zdGFuY2VvZiBDKXtcbiAgICAgICAgICBzd2l0Y2goYXJndW1lbnRzLmxlbmd0aCl7XG4gICAgICAgICAgICBjYXNlIDA6IHJldHVybiBuZXcgQztcbiAgICAgICAgICAgIGNhc2UgMTogcmV0dXJuIG5ldyBDKGEpO1xuICAgICAgICAgICAgY2FzZSAyOiByZXR1cm4gbmV3IEMoYSwgYik7XG4gICAgICAgICAgfSByZXR1cm4gbmV3IEMoYSwgYiwgYyk7XG4gICAgICAgIH0gcmV0dXJuIEMuYXBwbHkodGhpcywgYXJndW1lbnRzKTtcbiAgICAgIH07XG4gICAgICBGW1BST1RPVFlQRV0gPSBDW1BST1RPVFlQRV07XG4gICAgICByZXR1cm4gRjtcbiAgICAvLyBtYWtlIHN0YXRpYyB2ZXJzaW9ucyBmb3IgcHJvdG90eXBlIG1ldGhvZHNcbiAgICB9KShvdXQpIDogSVNfUFJPVE8gJiYgdHlwZW9mIG91dCA9PSAnZnVuY3Rpb24nID8gY3R4KEZ1bmN0aW9uLmNhbGwsIG91dCkgOiBvdXQ7XG4gICAgLy8gZXhwb3J0IHByb3RvIG1ldGhvZHMgdG8gY29yZS4lQ09OU1RSVUNUT1IlLm1ldGhvZHMuJU5BTUUlXG4gICAgaWYoSVNfUFJPVE8pe1xuICAgICAgKGV4cG9ydHMudmlydHVhbCB8fCAoZXhwb3J0cy52aXJ0dWFsID0ge30pKVtrZXldID0gb3V0O1xuICAgICAgLy8gZXhwb3J0IHByb3RvIG1ldGhvZHMgdG8gY29yZS4lQ09OU1RSVUNUT1IlLnByb3RvdHlwZS4lTkFNRSVcbiAgICAgIGlmKHR5cGUgJiAkZXhwb3J0LlIgJiYgZXhwUHJvdG8gJiYgIWV4cFByb3RvW2tleV0paGlkZShleHBQcm90bywga2V5LCBvdXQpO1xuICAgIH1cbiAgfVxufTtcbi8vIHR5cGUgYml0bWFwXG4kZXhwb3J0LkYgPSAxOyAgIC8vIGZvcmNlZFxuJGV4cG9ydC5HID0gMjsgICAvLyBnbG9iYWxcbiRleHBvcnQuUyA9IDQ7ICAgLy8gc3RhdGljXG4kZXhwb3J0LlAgPSA4OyAgIC8vIHByb3RvXG4kZXhwb3J0LkIgPSAxNjsgIC8vIGJpbmRcbiRleHBvcnQuVyA9IDMyOyAgLy8gd3JhcFxuJGV4cG9ydC5VID0gNjQ7ICAvLyBzYWZlXG4kZXhwb3J0LlIgPSAxMjg7IC8vIHJlYWwgcHJvdG8gbWV0aG9kIGZvciBgbGlicmFyeWAgXG5tb2R1bGUuZXhwb3J0cyA9ICRleHBvcnQ7XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbihleGVjKXtcbiAgdHJ5IHtcbiAgICByZXR1cm4gISFleGVjKCk7XG4gIH0gY2F0Y2goZSl7XG4gICAgcmV0dXJuIHRydWU7XG4gIH1cbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xudmFyIGN0eCAgICAgICAgID0gcmVxdWlyZSg1MSlcbiAgLCBjYWxsICAgICAgICA9IHJlcXVpcmUoNzApXG4gICwgaXNBcnJheUl0ZXIgPSByZXF1aXJlKDY3KVxuICAsIGFuT2JqZWN0ICAgID0gcmVxdWlyZSg0NilcbiAgLCB0b0xlbmd0aCAgICA9IHJlcXVpcmUoMTA3KVxuICAsIGdldEl0ZXJGbiAgID0gcmVxdWlyZSgxMTQpXG4gICwgQlJFQUsgICAgICAgPSB7fVxuICAsIFJFVFVSTiAgICAgID0ge307XG52YXIgZXhwb3J0cyA9IG1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24oaXRlcmFibGUsIGVudHJpZXMsIGZuLCB0aGF0LCBJVEVSQVRPUil7XG4gIHZhciBpdGVyRm4gPSBJVEVSQVRPUiA/IGZ1bmN0aW9uKCl7IHJldHVybiBpdGVyYWJsZTsgfSA6IGdldEl0ZXJGbihpdGVyYWJsZSlcbiAgICAsIGYgICAgICA9IGN0eChmbiwgdGhhdCwgZW50cmllcyA/IDIgOiAxKVxuICAgICwgaW5kZXggID0gMFxuICAgICwgbGVuZ3RoLCBzdGVwLCBpdGVyYXRvciwgcmVzdWx0O1xuICBpZih0eXBlb2YgaXRlckZuICE9ICdmdW5jdGlvbicpdGhyb3cgVHlwZUVycm9yKGl0ZXJhYmxlICsgJyBpcyBub3QgaXRlcmFibGUhJyk7XG4gIC8vIGZhc3QgY2FzZSBmb3IgYXJyYXlzIHdpdGggZGVmYXVsdCBpdGVyYXRvclxuICBpZihpc0FycmF5SXRlcihpdGVyRm4pKWZvcihsZW5ndGggPSB0b0xlbmd0aChpdGVyYWJsZS5sZW5ndGgpOyBsZW5ndGggPiBpbmRleDsgaW5kZXgrKyl7XG4gICAgcmVzdWx0ID0gZW50cmllcyA/IGYoYW5PYmplY3Qoc3RlcCA9IGl0ZXJhYmxlW2luZGV4XSlbMF0sIHN0ZXBbMV0pIDogZihpdGVyYWJsZVtpbmRleF0pO1xuICAgIGlmKHJlc3VsdCA9PT0gQlJFQUsgfHwgcmVzdWx0ID09PSBSRVRVUk4pcmV0dXJuIHJlc3VsdDtcbiAgfSBlbHNlIGZvcihpdGVyYXRvciA9IGl0ZXJGbi5jYWxsKGl0ZXJhYmxlKTsgIShzdGVwID0gaXRlcmF0b3IubmV4dCgpKS5kb25lOyApe1xuICAgIHJlc3VsdCA9IGNhbGwoaXRlcmF0b3IsIGYsIHN0ZXAudmFsdWUsIGVudHJpZXMpO1xuICAgIGlmKHJlc3VsdCA9PT0gQlJFQUsgfHwgcmVzdWx0ID09PSBSRVRVUk4pcmV0dXJuIHJlc3VsdDtcbiAgfVxufTtcbmV4cG9ydHMuQlJFQUsgID0gQlJFQUs7XG5leHBvcnRzLlJFVFVSTiA9IFJFVFVSTjtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4vLyBodHRwczovL2dpdGh1Yi5jb20vemxvaXJvY2svY29yZS1qcy9pc3N1ZXMvODYjaXNzdWVjb21tZW50LTExNTc1OTAyOFxudmFyIGdsb2JhbCA9IG1vZHVsZS5leHBvcnRzID0gdHlwZW9mIHdpbmRvdyAhPSAndW5kZWZpbmVkJyAmJiB3aW5kb3cuTWF0aCA9PSBNYXRoXG4gID8gd2luZG93IDogdHlwZW9mIHNlbGYgIT0gJ3VuZGVmaW5lZCcgJiYgc2VsZi5NYXRoID09IE1hdGggPyBzZWxmIDogRnVuY3Rpb24oJ3JldHVybiB0aGlzJykoKTtcbmlmKHR5cGVvZiBfX2cgPT0gJ251bWJlcicpX19nID0gZ2xvYmFsOyAvLyBlc2xpbnQtZGlzYWJsZS1saW5lIG5vLXVuZGVmXG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xudmFyIGhhc093blByb3BlcnR5ID0ge30uaGFzT3duUHJvcGVydHk7XG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uKGl0LCBrZXkpe1xuICByZXR1cm4gaGFzT3duUHJvcGVydHkuY2FsbChpdCwga2V5KTtcbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xudmFyIGRQICAgICAgICAgPSByZXF1aXJlKDgyKVxuICAsIGNyZWF0ZURlc2MgPSByZXF1aXJlKDkzKTtcbm1vZHVsZS5leHBvcnRzID0gcmVxdWlyZSg1MykgPyBmdW5jdGlvbihvYmplY3QsIGtleSwgdmFsdWUpe1xuICByZXR1cm4gZFAuZihvYmplY3QsIGtleSwgY3JlYXRlRGVzYygxLCB2YWx1ZSkpO1xufSA6IGZ1bmN0aW9uKG9iamVjdCwga2V5LCB2YWx1ZSl7XG4gIG9iamVjdFtrZXldID0gdmFsdWU7XG4gIHJldHVybiBvYmplY3Q7XG59O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbm1vZHVsZS5leHBvcnRzID0gcmVxdWlyZSg2MCkuZG9jdW1lbnQgJiYgZG9jdW1lbnQuZG9jdW1lbnRFbGVtZW50O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbm1vZHVsZS5leHBvcnRzID0gIXJlcXVpcmUoNTMpICYmICFyZXF1aXJlKDU4KShmdW5jdGlvbigpe1xuICByZXR1cm4gT2JqZWN0LmRlZmluZVByb3BlcnR5KHJlcXVpcmUoNTQpKCdkaXYnKSwgJ2EnLCB7Z2V0OiBmdW5jdGlvbigpeyByZXR1cm4gNzsgfX0pLmEgIT0gNztcbn0pO1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbi8vIGZhc3QgYXBwbHksIGh0dHA6Ly9qc3BlcmYubG5raXQuY29tL2Zhc3QtYXBwbHkvNVxubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbihmbiwgYXJncywgdGhhdCl7XG4gIHZhciB1biA9IHRoYXQgPT09IHVuZGVmaW5lZDtcbiAgc3dpdGNoKGFyZ3MubGVuZ3RoKXtcbiAgICBjYXNlIDA6IHJldHVybiB1biA/IGZuKClcbiAgICAgICAgICAgICAgICAgICAgICA6IGZuLmNhbGwodGhhdCk7XG4gICAgY2FzZSAxOiByZXR1cm4gdW4gPyBmbihhcmdzWzBdKVxuICAgICAgICAgICAgICAgICAgICAgIDogZm4uY2FsbCh0aGF0LCBhcmdzWzBdKTtcbiAgICBjYXNlIDI6IHJldHVybiB1biA/IGZuKGFyZ3NbMF0sIGFyZ3NbMV0pXG4gICAgICAgICAgICAgICAgICAgICAgOiBmbi5jYWxsKHRoYXQsIGFyZ3NbMF0sIGFyZ3NbMV0pO1xuICAgIGNhc2UgMzogcmV0dXJuIHVuID8gZm4oYXJnc1swXSwgYXJnc1sxXSwgYXJnc1syXSlcbiAgICAgICAgICAgICAgICAgICAgICA6IGZuLmNhbGwodGhhdCwgYXJnc1swXSwgYXJnc1sxXSwgYXJnc1syXSk7XG4gICAgY2FzZSA0OiByZXR1cm4gdW4gPyBmbihhcmdzWzBdLCBhcmdzWzFdLCBhcmdzWzJdLCBhcmdzWzNdKVxuICAgICAgICAgICAgICAgICAgICAgIDogZm4uY2FsbCh0aGF0LCBhcmdzWzBdLCBhcmdzWzFdLCBhcmdzWzJdLCBhcmdzWzNdKTtcbiAgfSByZXR1cm4gICAgICAgICAgICAgIGZuLmFwcGx5KHRoYXQsIGFyZ3MpO1xufTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4vLyBmYWxsYmFjayBmb3Igbm9uLWFycmF5LWxpa2UgRVMzIGFuZCBub24tZW51bWVyYWJsZSBvbGQgVjggc3RyaW5nc1xudmFyIGNvZiA9IHJlcXVpcmUoNDkpO1xubW9kdWxlLmV4cG9ydHMgPSBPYmplY3QoJ3onKS5wcm9wZXJ0eUlzRW51bWVyYWJsZSgwKSA/IE9iamVjdCA6IGZ1bmN0aW9uKGl0KXtcbiAgcmV0dXJuIGNvZihpdCkgPT0gJ1N0cmluZycgPyBpdC5zcGxpdCgnJykgOiBPYmplY3QoaXQpO1xufTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4vLyBjaGVjayBvbiBkZWZhdWx0IEFycmF5IGl0ZXJhdG9yXG52YXIgSXRlcmF0b3JzICA9IHJlcXVpcmUoNzUpXG4gICwgSVRFUkFUT1IgICA9IHJlcXVpcmUoMTEzKSgnaXRlcmF0b3InKVxuICAsIEFycmF5UHJvdG8gPSBBcnJheS5wcm90b3R5cGU7XG5cbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24oaXQpe1xuICByZXR1cm4gaXQgIT09IHVuZGVmaW5lZCAmJiAoSXRlcmF0b3JzLkFycmF5ID09PSBpdCB8fCBBcnJheVByb3RvW0lURVJBVE9SXSA9PT0gaXQpO1xufTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4vLyA3LjIuMiBJc0FycmF5KGFyZ3VtZW50KVxudmFyIGNvZiA9IHJlcXVpcmUoNDkpO1xubW9kdWxlLmV4cG9ydHMgPSBBcnJheS5pc0FycmF5IHx8IGZ1bmN0aW9uIGlzQXJyYXkoYXJnKXtcbiAgcmV0dXJuIGNvZihhcmcpID09ICdBcnJheSc7XG59O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24oaXQpe1xuICByZXR1cm4gdHlwZW9mIGl0ID09PSAnb2JqZWN0JyA/IGl0ICE9PSBudWxsIDogdHlwZW9mIGl0ID09PSAnZnVuY3Rpb24nO1xufTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4vLyBjYWxsIHNvbWV0aGluZyBvbiBpdGVyYXRvciBzdGVwIHdpdGggc2FmZSBjbG9zaW5nIG9uIGVycm9yXG52YXIgYW5PYmplY3QgPSByZXF1aXJlKDQ2KTtcbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24oaXRlcmF0b3IsIGZuLCB2YWx1ZSwgZW50cmllcyl7XG4gIHRyeSB7XG4gICAgcmV0dXJuIGVudHJpZXMgPyBmbihhbk9iamVjdCh2YWx1ZSlbMF0sIHZhbHVlWzFdKSA6IGZuKHZhbHVlKTtcbiAgLy8gNy40LjYgSXRlcmF0b3JDbG9zZShpdGVyYXRvciwgY29tcGxldGlvbilcbiAgfSBjYXRjaChlKXtcbiAgICB2YXIgcmV0ID0gaXRlcmF0b3JbJ3JldHVybiddO1xuICAgIGlmKHJldCAhPT0gdW5kZWZpbmVkKWFuT2JqZWN0KHJldC5jYWxsKGl0ZXJhdG9yKSk7XG4gICAgdGhyb3cgZTtcbiAgfVxufTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4ndXNlIHN0cmljdCc7XG52YXIgY3JlYXRlICAgICAgICAgPSByZXF1aXJlKDgxKVxuICAsIGRlc2NyaXB0b3IgICAgID0gcmVxdWlyZSg5MylcbiAgLCBzZXRUb1N0cmluZ1RhZyA9IHJlcXVpcmUoOTgpXG4gICwgSXRlcmF0b3JQcm90b3R5cGUgPSB7fTtcblxuLy8gMjUuMS4yLjEuMSAlSXRlcmF0b3JQcm90b3R5cGUlW0BAaXRlcmF0b3JdKClcbnJlcXVpcmUoNjIpKEl0ZXJhdG9yUHJvdG90eXBlLCByZXF1aXJlKDExMykoJ2l0ZXJhdG9yJyksIGZ1bmN0aW9uKCl7IHJldHVybiB0aGlzOyB9KTtcblxubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbihDb25zdHJ1Y3RvciwgTkFNRSwgbmV4dCl7XG4gIENvbnN0cnVjdG9yLnByb3RvdHlwZSA9IGNyZWF0ZShJdGVyYXRvclByb3RvdHlwZSwge25leHQ6IGRlc2NyaXB0b3IoMSwgbmV4dCl9KTtcbiAgc2V0VG9TdHJpbmdUYWcoQ29uc3RydWN0b3IsIE5BTUUgKyAnIEl0ZXJhdG9yJyk7XG59O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbid1c2Ugc3RyaWN0JztcbnZhciBMSUJSQVJZICAgICAgICA9IHJlcXVpcmUoNzcpXG4gICwgJGV4cG9ydCAgICAgICAgPSByZXF1aXJlKDU3KVxuICAsIHJlZGVmaW5lICAgICAgID0gcmVxdWlyZSg5NSlcbiAgLCBoaWRlICAgICAgICAgICA9IHJlcXVpcmUoNjIpXG4gICwgaGFzICAgICAgICAgICAgPSByZXF1aXJlKDYxKVxuICAsIEl0ZXJhdG9ycyAgICAgID0gcmVxdWlyZSg3NSlcbiAgLCAkaXRlckNyZWF0ZSAgICA9IHJlcXVpcmUoNzEpXG4gICwgc2V0VG9TdHJpbmdUYWcgPSByZXF1aXJlKDk4KVxuICAsIGdldFByb3RvdHlwZU9mID0gcmVxdWlyZSg4OClcbiAgLCBJVEVSQVRPUiAgICAgICA9IHJlcXVpcmUoMTEzKSgnaXRlcmF0b3InKVxuICAsIEJVR0dZICAgICAgICAgID0gIShbXS5rZXlzICYmICduZXh0JyBpbiBbXS5rZXlzKCkpIC8vIFNhZmFyaSBoYXMgYnVnZ3kgaXRlcmF0b3JzIHcvbyBgbmV4dGBcbiAgLCBGRl9JVEVSQVRPUiAgICA9ICdAQGl0ZXJhdG9yJ1xuICAsIEtFWVMgICAgICAgICAgID0gJ2tleXMnXG4gICwgVkFMVUVTICAgICAgICAgPSAndmFsdWVzJztcblxudmFyIHJldHVyblRoaXMgPSBmdW5jdGlvbigpeyByZXR1cm4gdGhpczsgfTtcblxubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbihCYXNlLCBOQU1FLCBDb25zdHJ1Y3RvciwgbmV4dCwgREVGQVVMVCwgSVNfU0VULCBGT1JDRUQpe1xuICAkaXRlckNyZWF0ZShDb25zdHJ1Y3RvciwgTkFNRSwgbmV4dCk7XG4gIHZhciBnZXRNZXRob2QgPSBmdW5jdGlvbihraW5kKXtcbiAgICBpZighQlVHR1kgJiYga2luZCBpbiBwcm90bylyZXR1cm4gcHJvdG9ba2luZF07XG4gICAgc3dpdGNoKGtpbmQpe1xuICAgICAgY2FzZSBLRVlTOiByZXR1cm4gZnVuY3Rpb24ga2V5cygpeyByZXR1cm4gbmV3IENvbnN0cnVjdG9yKHRoaXMsIGtpbmQpOyB9O1xuICAgICAgY2FzZSBWQUxVRVM6IHJldHVybiBmdW5jdGlvbiB2YWx1ZXMoKXsgcmV0dXJuIG5ldyBDb25zdHJ1Y3Rvcih0aGlzLCBraW5kKTsgfTtcbiAgICB9IHJldHVybiBmdW5jdGlvbiBlbnRyaWVzKCl7IHJldHVybiBuZXcgQ29uc3RydWN0b3IodGhpcywga2luZCk7IH07XG4gIH07XG4gIHZhciBUQUcgICAgICAgID0gTkFNRSArICcgSXRlcmF0b3InXG4gICAgLCBERUZfVkFMVUVTID0gREVGQVVMVCA9PSBWQUxVRVNcbiAgICAsIFZBTFVFU19CVUcgPSBmYWxzZVxuICAgICwgcHJvdG8gICAgICA9IEJhc2UucHJvdG90eXBlXG4gICAgLCAkbmF0aXZlICAgID0gcHJvdG9bSVRFUkFUT1JdIHx8IHByb3RvW0ZGX0lURVJBVE9SXSB8fCBERUZBVUxUICYmIHByb3RvW0RFRkFVTFRdXG4gICAgLCAkZGVmYXVsdCAgID0gJG5hdGl2ZSB8fCBnZXRNZXRob2QoREVGQVVMVClcbiAgICAsICRlbnRyaWVzICAgPSBERUZBVUxUID8gIURFRl9WQUxVRVMgPyAkZGVmYXVsdCA6IGdldE1ldGhvZCgnZW50cmllcycpIDogdW5kZWZpbmVkXG4gICAgLCAkYW55TmF0aXZlID0gTkFNRSA9PSAnQXJyYXknID8gcHJvdG8uZW50cmllcyB8fCAkbmF0aXZlIDogJG5hdGl2ZVxuICAgICwgbWV0aG9kcywga2V5LCBJdGVyYXRvclByb3RvdHlwZTtcbiAgLy8gRml4IG5hdGl2ZVxuICBpZigkYW55TmF0aXZlKXtcbiAgICBJdGVyYXRvclByb3RvdHlwZSA9IGdldFByb3RvdHlwZU9mKCRhbnlOYXRpdmUuY2FsbChuZXcgQmFzZSkpO1xuICAgIGlmKEl0ZXJhdG9yUHJvdG90eXBlICE9PSBPYmplY3QucHJvdG90eXBlKXtcbiAgICAgIC8vIFNldCBAQHRvU3RyaW5nVGFnIHRvIG5hdGl2ZSBpdGVyYXRvcnNcbiAgICAgIHNldFRvU3RyaW5nVGFnKEl0ZXJhdG9yUHJvdG90eXBlLCBUQUcsIHRydWUpO1xuICAgICAgLy8gZml4IGZvciBzb21lIG9sZCBlbmdpbmVzXG4gICAgICBpZighTElCUkFSWSAmJiAhaGFzKEl0ZXJhdG9yUHJvdG90eXBlLCBJVEVSQVRPUikpaGlkZShJdGVyYXRvclByb3RvdHlwZSwgSVRFUkFUT1IsIHJldHVyblRoaXMpO1xuICAgIH1cbiAgfVxuICAvLyBmaXggQXJyYXkje3ZhbHVlcywgQEBpdGVyYXRvcn0ubmFtZSBpbiBWOCAvIEZGXG4gIGlmKERFRl9WQUxVRVMgJiYgJG5hdGl2ZSAmJiAkbmF0aXZlLm5hbWUgIT09IFZBTFVFUyl7XG4gICAgVkFMVUVTX0JVRyA9IHRydWU7XG4gICAgJGRlZmF1bHQgPSBmdW5jdGlvbiB2YWx1ZXMoKXsgcmV0dXJuICRuYXRpdmUuY2FsbCh0aGlzKTsgfTtcbiAgfVxuICAvLyBEZWZpbmUgaXRlcmF0b3JcbiAgaWYoKCFMSUJSQVJZIHx8IEZPUkNFRCkgJiYgKEJVR0dZIHx8IFZBTFVFU19CVUcgfHwgIXByb3RvW0lURVJBVE9SXSkpe1xuICAgIGhpZGUocHJvdG8sIElURVJBVE9SLCAkZGVmYXVsdCk7XG4gIH1cbiAgLy8gUGx1ZyBmb3IgbGlicmFyeVxuICBJdGVyYXRvcnNbTkFNRV0gPSAkZGVmYXVsdDtcbiAgSXRlcmF0b3JzW1RBR10gID0gcmV0dXJuVGhpcztcbiAgaWYoREVGQVVMVCl7XG4gICAgbWV0aG9kcyA9IHtcbiAgICAgIHZhbHVlczogIERFRl9WQUxVRVMgPyAkZGVmYXVsdCA6IGdldE1ldGhvZChWQUxVRVMpLFxuICAgICAga2V5czogICAgSVNfU0VUICAgICA/ICRkZWZhdWx0IDogZ2V0TWV0aG9kKEtFWVMpLFxuICAgICAgZW50cmllczogJGVudHJpZXNcbiAgICB9O1xuICAgIGlmKEZPUkNFRClmb3Ioa2V5IGluIG1ldGhvZHMpe1xuICAgICAgaWYoIShrZXkgaW4gcHJvdG8pKXJlZGVmaW5lKHByb3RvLCBrZXksIG1ldGhvZHNba2V5XSk7XG4gICAgfSBlbHNlICRleHBvcnQoJGV4cG9ydC5QICsgJGV4cG9ydC5GICogKEJVR0dZIHx8IFZBTFVFU19CVUcpLCBOQU1FLCBtZXRob2RzKTtcbiAgfVxuICByZXR1cm4gbWV0aG9kcztcbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xudmFyIElURVJBVE9SICAgICA9IHJlcXVpcmUoMTEzKSgnaXRlcmF0b3InKVxuICAsIFNBRkVfQ0xPU0lORyA9IGZhbHNlO1xuXG50cnkge1xuICB2YXIgcml0ZXIgPSBbN11bSVRFUkFUT1JdKCk7XG4gIHJpdGVyWydyZXR1cm4nXSA9IGZ1bmN0aW9uKCl7IFNBRkVfQ0xPU0lORyA9IHRydWU7IH07XG4gIEFycmF5LmZyb20ocml0ZXIsIGZ1bmN0aW9uKCl7IHRocm93IDI7IH0pO1xufSBjYXRjaChlKXsgLyogZW1wdHkgKi8gfVxuXG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uKGV4ZWMsIHNraXBDbG9zaW5nKXtcbiAgaWYoIXNraXBDbG9zaW5nICYmICFTQUZFX0NMT1NJTkcpcmV0dXJuIGZhbHNlO1xuICB2YXIgc2FmZSA9IGZhbHNlO1xuICB0cnkge1xuICAgIHZhciBhcnIgID0gWzddXG4gICAgICAsIGl0ZXIgPSBhcnJbSVRFUkFUT1JdKCk7XG4gICAgaXRlci5uZXh0ID0gZnVuY3Rpb24oKXsgcmV0dXJuIHtkb25lOiBzYWZlID0gdHJ1ZX07IH07XG4gICAgYXJyW0lURVJBVE9SXSA9IGZ1bmN0aW9uKCl7IHJldHVybiBpdGVyOyB9O1xuICAgIGV4ZWMoYXJyKTtcbiAgfSBjYXRjaChlKXsgLyogZW1wdHkgKi8gfVxuICByZXR1cm4gc2FmZTtcbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbihkb25lLCB2YWx1ZSl7XG4gIHJldHVybiB7dmFsdWU6IHZhbHVlLCBkb25lOiAhIWRvbmV9O1xufTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG5tb2R1bGUuZXhwb3J0cyA9IHt9O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbnZhciBnZXRLZXlzICAgPSByZXF1aXJlKDkwKVxuICAsIHRvSU9iamVjdCA9IHJlcXVpcmUoMTA2KTtcbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24ob2JqZWN0LCBlbCl7XG4gIHZhciBPICAgICAgPSB0b0lPYmplY3Qob2JqZWN0KVxuICAgICwga2V5cyAgID0gZ2V0S2V5cyhPKVxuICAgICwgbGVuZ3RoID0ga2V5cy5sZW5ndGhcbiAgICAsIGluZGV4ICA9IDBcbiAgICAsIGtleTtcbiAgd2hpbGUobGVuZ3RoID4gaW5kZXgpaWYoT1trZXkgPSBrZXlzW2luZGV4KytdXSA9PT0gZWwpcmV0dXJuIGtleTtcbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xubW9kdWxlLmV4cG9ydHMgPSB0cnVlO1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbnZhciBNRVRBICAgICA9IHJlcXVpcmUoMTEwKSgnbWV0YScpXG4gICwgaXNPYmplY3QgPSByZXF1aXJlKDY5KVxuICAsIGhhcyAgICAgID0gcmVxdWlyZSg2MSlcbiAgLCBzZXREZXNjICA9IHJlcXVpcmUoODIpLmZcbiAgLCBpZCAgICAgICA9IDA7XG52YXIgaXNFeHRlbnNpYmxlID0gT2JqZWN0LmlzRXh0ZW5zaWJsZSB8fCBmdW5jdGlvbigpe1xuICByZXR1cm4gdHJ1ZTtcbn07XG52YXIgRlJFRVpFID0gIXJlcXVpcmUoNTgpKGZ1bmN0aW9uKCl7XG4gIHJldHVybiBpc0V4dGVuc2libGUoT2JqZWN0LnByZXZlbnRFeHRlbnNpb25zKHt9KSk7XG59KTtcbnZhciBzZXRNZXRhID0gZnVuY3Rpb24oaXQpe1xuICBzZXREZXNjKGl0LCBNRVRBLCB7dmFsdWU6IHtcbiAgICBpOiAnTycgKyArK2lkLCAvLyBvYmplY3QgSURcbiAgICB3OiB7fSAgICAgICAgICAvLyB3ZWFrIGNvbGxlY3Rpb25zIElEc1xuICB9fSk7XG59O1xudmFyIGZhc3RLZXkgPSBmdW5jdGlvbihpdCwgY3JlYXRlKXtcbiAgLy8gcmV0dXJuIHByaW1pdGl2ZSB3aXRoIHByZWZpeFxuICBpZighaXNPYmplY3QoaXQpKXJldHVybiB0eXBlb2YgaXQgPT0gJ3N5bWJvbCcgPyBpdCA6ICh0eXBlb2YgaXQgPT0gJ3N0cmluZycgPyAnUycgOiAnUCcpICsgaXQ7XG4gIGlmKCFoYXMoaXQsIE1FVEEpKXtcbiAgICAvLyBjYW4ndCBzZXQgbWV0YWRhdGEgdG8gdW5jYXVnaHQgZnJvemVuIG9iamVjdFxuICAgIGlmKCFpc0V4dGVuc2libGUoaXQpKXJldHVybiAnRic7XG4gICAgLy8gbm90IG5lY2Vzc2FyeSB0byBhZGQgbWV0YWRhdGFcbiAgICBpZighY3JlYXRlKXJldHVybiAnRSc7XG4gICAgLy8gYWRkIG1pc3NpbmcgbWV0YWRhdGFcbiAgICBzZXRNZXRhKGl0KTtcbiAgLy8gcmV0dXJuIG9iamVjdCBJRFxuICB9IHJldHVybiBpdFtNRVRBXS5pO1xufTtcbnZhciBnZXRXZWFrID0gZnVuY3Rpb24oaXQsIGNyZWF0ZSl7XG4gIGlmKCFoYXMoaXQsIE1FVEEpKXtcbiAgICAvLyBjYW4ndCBzZXQgbWV0YWRhdGEgdG8gdW5jYXVnaHQgZnJvemVuIG9iamVjdFxuICAgIGlmKCFpc0V4dGVuc2libGUoaXQpKXJldHVybiB0cnVlO1xuICAgIC8vIG5vdCBuZWNlc3NhcnkgdG8gYWRkIG1ldGFkYXRhXG4gICAgaWYoIWNyZWF0ZSlyZXR1cm4gZmFsc2U7XG4gICAgLy8gYWRkIG1pc3NpbmcgbWV0YWRhdGFcbiAgICBzZXRNZXRhKGl0KTtcbiAgLy8gcmV0dXJuIGhhc2ggd2VhayBjb2xsZWN0aW9ucyBJRHNcbiAgfSByZXR1cm4gaXRbTUVUQV0udztcbn07XG4vLyBhZGQgbWV0YWRhdGEgb24gZnJlZXplLWZhbWlseSBtZXRob2RzIGNhbGxpbmdcbnZhciBvbkZyZWV6ZSA9IGZ1bmN0aW9uKGl0KXtcbiAgaWYoRlJFRVpFICYmIG1ldGEuTkVFRCAmJiBpc0V4dGVuc2libGUoaXQpICYmICFoYXMoaXQsIE1FVEEpKXNldE1ldGEoaXQpO1xuICByZXR1cm4gaXQ7XG59O1xudmFyIG1ldGEgPSBtb2R1bGUuZXhwb3J0cyA9IHtcbiAgS0VZOiAgICAgIE1FVEEsXG4gIE5FRUQ6ICAgICBmYWxzZSxcbiAgZmFzdEtleTogIGZhc3RLZXksXG4gIGdldFdlYWs6ICBnZXRXZWFrLFxuICBvbkZyZWV6ZTogb25GcmVlemVcbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xudmFyIGdsb2JhbCAgICA9IHJlcXVpcmUoNjApXG4gICwgbWFjcm90YXNrID0gcmVxdWlyZSgxMDMpLnNldFxuICAsIE9ic2VydmVyICA9IGdsb2JhbC5NdXRhdGlvbk9ic2VydmVyIHx8IGdsb2JhbC5XZWJLaXRNdXRhdGlvbk9ic2VydmVyXG4gICwgcHJvY2VzcyAgID0gZ2xvYmFsLnByb2Nlc3NcbiAgLCBQcm9taXNlICAgPSBnbG9iYWwuUHJvbWlzZVxuICAsIGlzTm9kZSAgICA9IHJlcXVpcmUoNDkpKHByb2Nlc3MpID09ICdwcm9jZXNzJztcblxubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbigpe1xuICB2YXIgaGVhZCwgbGFzdCwgbm90aWZ5O1xuXG4gIHZhciBmbHVzaCA9IGZ1bmN0aW9uKCl7XG4gICAgdmFyIHBhcmVudCwgZm47XG4gICAgaWYoaXNOb2RlICYmIChwYXJlbnQgPSBwcm9jZXNzLmRvbWFpbikpcGFyZW50LmV4aXQoKTtcbiAgICB3aGlsZShoZWFkKXtcbiAgICAgIGZuICAgPSBoZWFkLmZuO1xuICAgICAgaGVhZCA9IGhlYWQubmV4dDtcbiAgICAgIHRyeSB7XG4gICAgICAgIGZuKCk7XG4gICAgICB9IGNhdGNoKGUpe1xuICAgICAgICBpZihoZWFkKW5vdGlmeSgpO1xuICAgICAgICBlbHNlIGxhc3QgPSB1bmRlZmluZWQ7XG4gICAgICAgIHRocm93IGU7XG4gICAgICB9XG4gICAgfSBsYXN0ID0gdW5kZWZpbmVkO1xuICAgIGlmKHBhcmVudClwYXJlbnQuZW50ZXIoKTtcbiAgfTtcblxuICAvLyBOb2RlLmpzXG4gIGlmKGlzTm9kZSl7XG4gICAgbm90aWZ5ID0gZnVuY3Rpb24oKXtcbiAgICAgIHByb2Nlc3MubmV4dFRpY2soZmx1c2gpO1xuICAgIH07XG4gIC8vIGJyb3dzZXJzIHdpdGggTXV0YXRpb25PYnNlcnZlclxuICB9IGVsc2UgaWYoT2JzZXJ2ZXIpe1xuICAgIHZhciB0b2dnbGUgPSB0cnVlXG4gICAgICAsIG5vZGUgICA9IGRvY3VtZW50LmNyZWF0ZVRleHROb2RlKCcnKTtcbiAgICBuZXcgT2JzZXJ2ZXIoZmx1c2gpLm9ic2VydmUobm9kZSwge2NoYXJhY3RlckRhdGE6IHRydWV9KTsgLy8gZXNsaW50LWRpc2FibGUtbGluZSBuby1uZXdcbiAgICBub3RpZnkgPSBmdW5jdGlvbigpe1xuICAgICAgbm9kZS5kYXRhID0gdG9nZ2xlID0gIXRvZ2dsZTtcbiAgICB9O1xuICAvLyBlbnZpcm9ubWVudHMgd2l0aCBtYXliZSBub24tY29tcGxldGVseSBjb3JyZWN0LCBidXQgZXhpc3RlbnQgUHJvbWlzZVxuICB9IGVsc2UgaWYoUHJvbWlzZSAmJiBQcm9taXNlLnJlc29sdmUpe1xuICAgIHZhciBwcm9taXNlID0gUHJvbWlzZS5yZXNvbHZlKCk7XG4gICAgbm90aWZ5ID0gZnVuY3Rpb24oKXtcbiAgICAgIHByb21pc2UudGhlbihmbHVzaCk7XG4gICAgfTtcbiAgLy8gZm9yIG90aGVyIGVudmlyb25tZW50cyAtIG1hY3JvdGFzayBiYXNlZCBvbjpcbiAgLy8gLSBzZXRJbW1lZGlhdGVcbiAgLy8gLSBNZXNzYWdlQ2hhbm5lbFxuICAvLyAtIHdpbmRvdy5wb3N0TWVzc2FnXG4gIC8vIC0gb25yZWFkeXN0YXRlY2hhbmdlXG4gIC8vIC0gc2V0VGltZW91dFxuICB9IGVsc2Uge1xuICAgIG5vdGlmeSA9IGZ1bmN0aW9uKCl7XG4gICAgICAvLyBzdHJhbmdlIElFICsgd2VicGFjayBkZXYgc2VydmVyIGJ1ZyAtIHVzZSAuY2FsbChnbG9iYWwpXG4gICAgICBtYWNyb3Rhc2suY2FsbChnbG9iYWwsIGZsdXNoKTtcbiAgICB9O1xuICB9XG5cbiAgcmV0dXJuIGZ1bmN0aW9uKGZuKXtcbiAgICB2YXIgdGFzayA9IHtmbjogZm4sIG5leHQ6IHVuZGVmaW5lZH07XG4gICAgaWYobGFzdClsYXN0Lm5leHQgPSB0YXNrO1xuICAgIGlmKCFoZWFkKXtcbiAgICAgIGhlYWQgPSB0YXNrO1xuICAgICAgbm90aWZ5KCk7XG4gICAgfSBsYXN0ID0gdGFzaztcbiAgfTtcbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xuJ3VzZSBzdHJpY3QnO1xuLy8gMTkuMS4yLjEgT2JqZWN0LmFzc2lnbih0YXJnZXQsIHNvdXJjZSwgLi4uKVxudmFyIGdldEtleXMgID0gcmVxdWlyZSg5MClcbiAgLCBnT1BTICAgICA9IHJlcXVpcmUoODcpXG4gICwgcElFICAgICAgPSByZXF1aXJlKDkxKVxuICAsIHRvT2JqZWN0ID0gcmVxdWlyZSgxMDgpXG4gICwgSU9iamVjdCAgPSByZXF1aXJlKDY2KVxuICAsICRhc3NpZ24gID0gT2JqZWN0LmFzc2lnbjtcblxuLy8gc2hvdWxkIHdvcmsgd2l0aCBzeW1ib2xzIGFuZCBzaG91bGQgaGF2ZSBkZXRlcm1pbmlzdGljIHByb3BlcnR5IG9yZGVyIChWOCBidWcpXG5tb2R1bGUuZXhwb3J0cyA9ICEkYXNzaWduIHx8IHJlcXVpcmUoNTgpKGZ1bmN0aW9uKCl7XG4gIHZhciBBID0ge31cbiAgICAsIEIgPSB7fVxuICAgICwgUyA9IFN5bWJvbCgpXG4gICAgLCBLID0gJ2FiY2RlZmdoaWprbG1ub3BxcnN0JztcbiAgQVtTXSA9IDc7XG4gIEsuc3BsaXQoJycpLmZvckVhY2goZnVuY3Rpb24oayl7IEJba10gPSBrOyB9KTtcbiAgcmV0dXJuICRhc3NpZ24oe30sIEEpW1NdICE9IDcgfHwgT2JqZWN0LmtleXMoJGFzc2lnbih7fSwgQikpLmpvaW4oJycpICE9IEs7XG59KSA/IGZ1bmN0aW9uIGFzc2lnbih0YXJnZXQsIHNvdXJjZSl7IC8vIGVzbGludC1kaXNhYmxlLWxpbmUgbm8tdW51c2VkLXZhcnNcbiAgdmFyIFQgICAgID0gdG9PYmplY3QodGFyZ2V0KVxuICAgICwgYUxlbiAgPSBhcmd1bWVudHMubGVuZ3RoXG4gICAgLCBpbmRleCA9IDFcbiAgICAsIGdldFN5bWJvbHMgPSBnT1BTLmZcbiAgICAsIGlzRW51bSAgICAgPSBwSUUuZjtcbiAgd2hpbGUoYUxlbiA+IGluZGV4KXtcbiAgICB2YXIgUyAgICAgID0gSU9iamVjdChhcmd1bWVudHNbaW5kZXgrK10pXG4gICAgICAsIGtleXMgICA9IGdldFN5bWJvbHMgPyBnZXRLZXlzKFMpLmNvbmNhdChnZXRTeW1ib2xzKFMpKSA6IGdldEtleXMoUylcbiAgICAgICwgbGVuZ3RoID0ga2V5cy5sZW5ndGhcbiAgICAgICwgaiAgICAgID0gMFxuICAgICAgLCBrZXk7XG4gICAgd2hpbGUobGVuZ3RoID4gailpZihpc0VudW0uY2FsbChTLCBrZXkgPSBrZXlzW2orK10pKVRba2V5XSA9IFNba2V5XTtcbiAgfSByZXR1cm4gVDtcbn0gOiAkYXNzaWduO1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbi8vIDE5LjEuMi4yIC8gMTUuMi4zLjUgT2JqZWN0LmNyZWF0ZShPIFssIFByb3BlcnRpZXNdKVxudmFyIGFuT2JqZWN0ICAgID0gcmVxdWlyZSg0NilcbiAgLCBkUHMgICAgICAgICA9IHJlcXVpcmUoODMpXG4gICwgZW51bUJ1Z0tleXMgPSByZXF1aXJlKDU1KVxuICAsIElFX1BST1RPICAgID0gcmVxdWlyZSg5OSkoJ0lFX1BST1RPJylcbiAgLCBFbXB0eSAgICAgICA9IGZ1bmN0aW9uKCl7IC8qIGVtcHR5ICovIH1cbiAgLCBQUk9UT1RZUEUgICA9ICdwcm90b3R5cGUnO1xuXG4vLyBDcmVhdGUgb2JqZWN0IHdpdGggZmFrZSBgbnVsbGAgcHJvdG90eXBlOiB1c2UgaWZyYW1lIE9iamVjdCB3aXRoIGNsZWFyZWQgcHJvdG90eXBlXG52YXIgY3JlYXRlRGljdCA9IGZ1bmN0aW9uKCl7XG4gIC8vIFRocmFzaCwgd2FzdGUgYW5kIHNvZG9teTogSUUgR0MgYnVnXG4gIHZhciBpZnJhbWUgPSByZXF1aXJlKDU0KSgnaWZyYW1lJylcbiAgICAsIGkgICAgICA9IGVudW1CdWdLZXlzLmxlbmd0aFxuICAgICwgbHQgICAgID0gJzwnXG4gICAgLCBndCAgICAgPSAnPidcbiAgICAsIGlmcmFtZURvY3VtZW50O1xuICBpZnJhbWUuc3R5bGUuZGlzcGxheSA9ICdub25lJztcbiAgcmVxdWlyZSg2MykuYXBwZW5kQ2hpbGQoaWZyYW1lKTtcbiAgaWZyYW1lLnNyYyA9ICdqYXZhc2NyaXB0Oic7IC8vIGVzbGludC1kaXNhYmxlLWxpbmUgbm8tc2NyaXB0LXVybFxuICAvLyBjcmVhdGVEaWN0ID0gaWZyYW1lLmNvbnRlbnRXaW5kb3cuT2JqZWN0O1xuICAvLyBodG1sLnJlbW92ZUNoaWxkKGlmcmFtZSk7XG4gIGlmcmFtZURvY3VtZW50ID0gaWZyYW1lLmNvbnRlbnRXaW5kb3cuZG9jdW1lbnQ7XG4gIGlmcmFtZURvY3VtZW50Lm9wZW4oKTtcbiAgaWZyYW1lRG9jdW1lbnQud3JpdGUobHQgKyAnc2NyaXB0JyArIGd0ICsgJ2RvY3VtZW50LkY9T2JqZWN0JyArIGx0ICsgJy9zY3JpcHQnICsgZ3QpO1xuICBpZnJhbWVEb2N1bWVudC5jbG9zZSgpO1xuICBjcmVhdGVEaWN0ID0gaWZyYW1lRG9jdW1lbnQuRjtcbiAgd2hpbGUoaS0tKWRlbGV0ZSBjcmVhdGVEaWN0W1BST1RPVFlQRV1bZW51bUJ1Z0tleXNbaV1dO1xuICByZXR1cm4gY3JlYXRlRGljdCgpO1xufTtcblxubW9kdWxlLmV4cG9ydHMgPSBPYmplY3QuY3JlYXRlIHx8IGZ1bmN0aW9uIGNyZWF0ZShPLCBQcm9wZXJ0aWVzKXtcbiAgdmFyIHJlc3VsdDtcbiAgaWYoTyAhPT0gbnVsbCl7XG4gICAgRW1wdHlbUFJPVE9UWVBFXSA9IGFuT2JqZWN0KE8pO1xuICAgIHJlc3VsdCA9IG5ldyBFbXB0eTtcbiAgICBFbXB0eVtQUk9UT1RZUEVdID0gbnVsbDtcbiAgICAvLyBhZGQgXCJfX3Byb3RvX19cIiBmb3IgT2JqZWN0LmdldFByb3RvdHlwZU9mIHBvbHlmaWxsXG4gICAgcmVzdWx0W0lFX1BST1RPXSA9IE87XG4gIH0gZWxzZSByZXN1bHQgPSBjcmVhdGVEaWN0KCk7XG4gIHJldHVybiBQcm9wZXJ0aWVzID09PSB1bmRlZmluZWQgPyByZXN1bHQgOiBkUHMocmVzdWx0LCBQcm9wZXJ0aWVzKTtcbn07XG5cbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG52YXIgYW5PYmplY3QgICAgICAgPSByZXF1aXJlKDQ2KVxuICAsIElFOF9ET01fREVGSU5FID0gcmVxdWlyZSg2NClcbiAgLCB0b1ByaW1pdGl2ZSAgICA9IHJlcXVpcmUoMTA5KVxuICAsIGRQICAgICAgICAgICAgID0gT2JqZWN0LmRlZmluZVByb3BlcnR5O1xuXG5leHBvcnRzLmYgPSByZXF1aXJlKDUzKSA/IE9iamVjdC5kZWZpbmVQcm9wZXJ0eSA6IGZ1bmN0aW9uIGRlZmluZVByb3BlcnR5KE8sIFAsIEF0dHJpYnV0ZXMpe1xuICBhbk9iamVjdChPKTtcbiAgUCA9IHRvUHJpbWl0aXZlKFAsIHRydWUpO1xuICBhbk9iamVjdChBdHRyaWJ1dGVzKTtcbiAgaWYoSUU4X0RPTV9ERUZJTkUpdHJ5IHtcbiAgICByZXR1cm4gZFAoTywgUCwgQXR0cmlidXRlcyk7XG4gIH0gY2F0Y2goZSl7IC8qIGVtcHR5ICovIH1cbiAgaWYoJ2dldCcgaW4gQXR0cmlidXRlcyB8fCAnc2V0JyBpbiBBdHRyaWJ1dGVzKXRocm93IFR5cGVFcnJvcignQWNjZXNzb3JzIG5vdCBzdXBwb3J0ZWQhJyk7XG4gIGlmKCd2YWx1ZScgaW4gQXR0cmlidXRlcylPW1BdID0gQXR0cmlidXRlcy52YWx1ZTtcbiAgcmV0dXJuIE87XG59O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbnZhciBkUCAgICAgICA9IHJlcXVpcmUoODIpXG4gICwgYW5PYmplY3QgPSByZXF1aXJlKDQ2KVxuICAsIGdldEtleXMgID0gcmVxdWlyZSg5MCk7XG5cbm1vZHVsZS5leHBvcnRzID0gcmVxdWlyZSg1MykgPyBPYmplY3QuZGVmaW5lUHJvcGVydGllcyA6IGZ1bmN0aW9uIGRlZmluZVByb3BlcnRpZXMoTywgUHJvcGVydGllcyl7XG4gIGFuT2JqZWN0KE8pO1xuICB2YXIga2V5cyAgID0gZ2V0S2V5cyhQcm9wZXJ0aWVzKVxuICAgICwgbGVuZ3RoID0ga2V5cy5sZW5ndGhcbiAgICAsIGkgPSAwXG4gICAgLCBQO1xuICB3aGlsZShsZW5ndGggPiBpKWRQLmYoTywgUCA9IGtleXNbaSsrXSwgUHJvcGVydGllc1tQXSk7XG4gIHJldHVybiBPO1xufTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG52YXIgcElFICAgICAgICAgICAgPSByZXF1aXJlKDkxKVxuICAsIGNyZWF0ZURlc2MgICAgID0gcmVxdWlyZSg5MylcbiAgLCB0b0lPYmplY3QgICAgICA9IHJlcXVpcmUoMTA2KVxuICAsIHRvUHJpbWl0aXZlICAgID0gcmVxdWlyZSgxMDkpXG4gICwgaGFzICAgICAgICAgICAgPSByZXF1aXJlKDYxKVxuICAsIElFOF9ET01fREVGSU5FID0gcmVxdWlyZSg2NClcbiAgLCBnT1BEICAgICAgICAgICA9IE9iamVjdC5nZXRPd25Qcm9wZXJ0eURlc2NyaXB0b3I7XG5cbmV4cG9ydHMuZiA9IHJlcXVpcmUoNTMpID8gZ09QRCA6IGZ1bmN0aW9uIGdldE93blByb3BlcnR5RGVzY3JpcHRvcihPLCBQKXtcbiAgTyA9IHRvSU9iamVjdChPKTtcbiAgUCA9IHRvUHJpbWl0aXZlKFAsIHRydWUpO1xuICBpZihJRThfRE9NX0RFRklORSl0cnkge1xuICAgIHJldHVybiBnT1BEKE8sIFApO1xuICB9IGNhdGNoKGUpeyAvKiBlbXB0eSAqLyB9XG4gIGlmKGhhcyhPLCBQKSlyZXR1cm4gY3JlYXRlRGVzYyghcElFLmYuY2FsbChPLCBQKSwgT1tQXSk7XG59O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbi8vIGZhbGxiYWNrIGZvciBJRTExIGJ1Z2d5IE9iamVjdC5nZXRPd25Qcm9wZXJ0eU5hbWVzIHdpdGggaWZyYW1lIGFuZCB3aW5kb3dcbnZhciB0b0lPYmplY3QgPSByZXF1aXJlKDEwNilcbiAgLCBnT1BOICAgICAgPSByZXF1aXJlKDg2KS5mXG4gICwgdG9TdHJpbmcgID0ge30udG9TdHJpbmc7XG5cbnZhciB3aW5kb3dOYW1lcyA9IHR5cGVvZiB3aW5kb3cgPT0gJ29iamVjdCcgJiYgd2luZG93ICYmIE9iamVjdC5nZXRPd25Qcm9wZXJ0eU5hbWVzXG4gID8gT2JqZWN0LmdldE93blByb3BlcnR5TmFtZXMod2luZG93KSA6IFtdO1xuXG52YXIgZ2V0V2luZG93TmFtZXMgPSBmdW5jdGlvbihpdCl7XG4gIHRyeSB7XG4gICAgcmV0dXJuIGdPUE4oaXQpO1xuICB9IGNhdGNoKGUpe1xuICAgIHJldHVybiB3aW5kb3dOYW1lcy5zbGljZSgpO1xuICB9XG59O1xuXG5tb2R1bGUuZXhwb3J0cy5mID0gZnVuY3Rpb24gZ2V0T3duUHJvcGVydHlOYW1lcyhpdCl7XG4gIHJldHVybiB3aW5kb3dOYW1lcyAmJiB0b1N0cmluZy5jYWxsKGl0KSA9PSAnW29iamVjdCBXaW5kb3ddJyA/IGdldFdpbmRvd05hbWVzKGl0KSA6IGdPUE4odG9JT2JqZWN0KGl0KSk7XG59O1xuXG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xuLy8gMTkuMS4yLjcgLyAxNS4yLjMuNCBPYmplY3QuZ2V0T3duUHJvcGVydHlOYW1lcyhPKVxudmFyICRrZXlzICAgICAgPSByZXF1aXJlKDg5KVxuICAsIGhpZGRlbktleXMgPSByZXF1aXJlKDU1KS5jb25jYXQoJ2xlbmd0aCcsICdwcm90b3R5cGUnKTtcblxuZXhwb3J0cy5mID0gT2JqZWN0LmdldE93blByb3BlcnR5TmFtZXMgfHwgZnVuY3Rpb24gZ2V0T3duUHJvcGVydHlOYW1lcyhPKXtcbiAgcmV0dXJuICRrZXlzKE8sIGhpZGRlbktleXMpO1xufTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG5leHBvcnRzLmYgPSBPYmplY3QuZ2V0T3duUHJvcGVydHlTeW1ib2xzO1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbi8vIDE5LjEuMi45IC8gMTUuMi4zLjIgT2JqZWN0LmdldFByb3RvdHlwZU9mKE8pXG52YXIgaGFzICAgICAgICAgPSByZXF1aXJlKDYxKVxuICAsIHRvT2JqZWN0ICAgID0gcmVxdWlyZSgxMDgpXG4gICwgSUVfUFJPVE8gICAgPSByZXF1aXJlKDk5KSgnSUVfUFJPVE8nKVxuICAsIE9iamVjdFByb3RvID0gT2JqZWN0LnByb3RvdHlwZTtcblxubW9kdWxlLmV4cG9ydHMgPSBPYmplY3QuZ2V0UHJvdG90eXBlT2YgfHwgZnVuY3Rpb24oTyl7XG4gIE8gPSB0b09iamVjdChPKTtcbiAgaWYoaGFzKE8sIElFX1BST1RPKSlyZXR1cm4gT1tJRV9QUk9UT107XG4gIGlmKHR5cGVvZiBPLmNvbnN0cnVjdG9yID09ICdmdW5jdGlvbicgJiYgTyBpbnN0YW5jZW9mIE8uY29uc3RydWN0b3Ipe1xuICAgIHJldHVybiBPLmNvbnN0cnVjdG9yLnByb3RvdHlwZTtcbiAgfSByZXR1cm4gTyBpbnN0YW5jZW9mIE9iamVjdCA/IE9iamVjdFByb3RvIDogbnVsbDtcbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xudmFyIGhhcyAgICAgICAgICA9IHJlcXVpcmUoNjEpXG4gICwgdG9JT2JqZWN0ICAgID0gcmVxdWlyZSgxMDYpXG4gICwgYXJyYXlJbmRleE9mID0gcmVxdWlyZSg0NykoZmFsc2UpXG4gICwgSUVfUFJPVE8gICAgID0gcmVxdWlyZSg5OSkoJ0lFX1BST1RPJyk7XG5cbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24ob2JqZWN0LCBuYW1lcyl7XG4gIHZhciBPICAgICAgPSB0b0lPYmplY3Qob2JqZWN0KVxuICAgICwgaSAgICAgID0gMFxuICAgICwgcmVzdWx0ID0gW11cbiAgICAsIGtleTtcbiAgZm9yKGtleSBpbiBPKWlmKGtleSAhPSBJRV9QUk9UTyloYXMoTywga2V5KSAmJiByZXN1bHQucHVzaChrZXkpO1xuICAvLyBEb24ndCBlbnVtIGJ1ZyAmIGhpZGRlbiBrZXlzXG4gIHdoaWxlKG5hbWVzLmxlbmd0aCA+IGkpaWYoaGFzKE8sIGtleSA9IG5hbWVzW2krK10pKXtcbiAgICB+YXJyYXlJbmRleE9mKHJlc3VsdCwga2V5KSB8fCByZXN1bHQucHVzaChrZXkpO1xuICB9XG4gIHJldHVybiByZXN1bHQ7XG59O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbi8vIDE5LjEuMi4xNCAvIDE1LjIuMy4xNCBPYmplY3Qua2V5cyhPKVxudmFyICRrZXlzICAgICAgID0gcmVxdWlyZSg4OSlcbiAgLCBlbnVtQnVnS2V5cyA9IHJlcXVpcmUoNTUpO1xuXG5tb2R1bGUuZXhwb3J0cyA9IE9iamVjdC5rZXlzIHx8IGZ1bmN0aW9uIGtleXMoTyl7XG4gIHJldHVybiAka2V5cyhPLCBlbnVtQnVnS2V5cyk7XG59O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbmV4cG9ydHMuZiA9IHt9LnByb3BlcnR5SXNFbnVtZXJhYmxlO1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbi8vIG1vc3QgT2JqZWN0IG1ldGhvZHMgYnkgRVM2IHNob3VsZCBhY2NlcHQgcHJpbWl0aXZlc1xudmFyICRleHBvcnQgPSByZXF1aXJlKDU3KVxuICAsIGNvcmUgICAgPSByZXF1aXJlKDUwKVxuICAsIGZhaWxzICAgPSByZXF1aXJlKDU4KTtcbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24oS0VZLCBleGVjKXtcbiAgdmFyIGZuICA9IChjb3JlLk9iamVjdCB8fCB7fSlbS0VZXSB8fCBPYmplY3RbS0VZXVxuICAgICwgZXhwID0ge307XG4gIGV4cFtLRVldID0gZXhlYyhmbik7XG4gICRleHBvcnQoJGV4cG9ydC5TICsgJGV4cG9ydC5GICogZmFpbHMoZnVuY3Rpb24oKXsgZm4oMSk7IH0pLCAnT2JqZWN0JywgZXhwKTtcbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbihiaXRtYXAsIHZhbHVlKXtcbiAgcmV0dXJuIHtcbiAgICBlbnVtZXJhYmxlICA6ICEoYml0bWFwICYgMSksXG4gICAgY29uZmlndXJhYmxlOiAhKGJpdG1hcCAmIDIpLFxuICAgIHdyaXRhYmxlICAgIDogIShiaXRtYXAgJiA0KSxcbiAgICB2YWx1ZSAgICAgICA6IHZhbHVlXG4gIH07XG59O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbnZhciBoaWRlID0gcmVxdWlyZSg2Mik7XG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uKHRhcmdldCwgc3JjLCBzYWZlKXtcbiAgZm9yKHZhciBrZXkgaW4gc3JjKXtcbiAgICBpZihzYWZlICYmIHRhcmdldFtrZXldKXRhcmdldFtrZXldID0gc3JjW2tleV07XG4gICAgZWxzZSBoaWRlKHRhcmdldCwga2V5LCBzcmNba2V5XSk7XG4gIH0gcmV0dXJuIHRhcmdldDtcbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xubW9kdWxlLmV4cG9ydHMgPSByZXF1aXJlKDYyKTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4vLyBXb3JrcyB3aXRoIF9fcHJvdG9fXyBvbmx5LiBPbGQgdjggY2FuJ3Qgd29yayB3aXRoIG51bGwgcHJvdG8gb2JqZWN0cy5cbi8qIGVzbGludC1kaXNhYmxlIG5vLXByb3RvICovXG52YXIgaXNPYmplY3QgPSByZXF1aXJlKDY5KVxuICAsIGFuT2JqZWN0ID0gcmVxdWlyZSg0Nik7XG52YXIgY2hlY2sgPSBmdW5jdGlvbihPLCBwcm90byl7XG4gIGFuT2JqZWN0KE8pO1xuICBpZighaXNPYmplY3QocHJvdG8pICYmIHByb3RvICE9PSBudWxsKXRocm93IFR5cGVFcnJvcihwcm90byArIFwiOiBjYW4ndCBzZXQgYXMgcHJvdG90eXBlIVwiKTtcbn07XG5tb2R1bGUuZXhwb3J0cyA9IHtcbiAgc2V0OiBPYmplY3Quc2V0UHJvdG90eXBlT2YgfHwgKCdfX3Byb3RvX18nIGluIHt9ID8gLy8gZXNsaW50LWRpc2FibGUtbGluZVxuICAgIGZ1bmN0aW9uKHRlc3QsIGJ1Z2d5LCBzZXQpe1xuICAgICAgdHJ5IHtcbiAgICAgICAgc2V0ID0gcmVxdWlyZSg1MSkoRnVuY3Rpb24uY2FsbCwgcmVxdWlyZSg4NCkuZihPYmplY3QucHJvdG90eXBlLCAnX19wcm90b19fJykuc2V0LCAyKTtcbiAgICAgICAgc2V0KHRlc3QsIFtdKTtcbiAgICAgICAgYnVnZ3kgPSAhKHRlc3QgaW5zdGFuY2VvZiBBcnJheSk7XG4gICAgICB9IGNhdGNoKGUpeyBidWdneSA9IHRydWU7IH1cbiAgICAgIHJldHVybiBmdW5jdGlvbiBzZXRQcm90b3R5cGVPZihPLCBwcm90byl7XG4gICAgICAgIGNoZWNrKE8sIHByb3RvKTtcbiAgICAgICAgaWYoYnVnZ3kpTy5fX3Byb3RvX18gPSBwcm90bztcbiAgICAgICAgZWxzZSBzZXQoTywgcHJvdG8pO1xuICAgICAgICByZXR1cm4gTztcbiAgICAgIH07XG4gICAgfSh7fSwgZmFsc2UpIDogdW5kZWZpbmVkKSxcbiAgY2hlY2s6IGNoZWNrXG59O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbid1c2Ugc3RyaWN0JztcbnZhciBnbG9iYWwgICAgICA9IHJlcXVpcmUoNjApXG4gICwgY29yZSAgICAgICAgPSByZXF1aXJlKDUwKVxuICAsIGRQICAgICAgICAgID0gcmVxdWlyZSg4MilcbiAgLCBERVNDUklQVE9SUyA9IHJlcXVpcmUoNTMpXG4gICwgU1BFQ0lFUyAgICAgPSByZXF1aXJlKDExMykoJ3NwZWNpZXMnKTtcblxubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbihLRVkpe1xuICB2YXIgQyA9IHR5cGVvZiBjb3JlW0tFWV0gPT0gJ2Z1bmN0aW9uJyA/IGNvcmVbS0VZXSA6IGdsb2JhbFtLRVldO1xuICBpZihERVNDUklQVE9SUyAmJiBDICYmICFDW1NQRUNJRVNdKWRQLmYoQywgU1BFQ0lFUywge1xuICAgIGNvbmZpZ3VyYWJsZTogdHJ1ZSxcbiAgICBnZXQ6IGZ1bmN0aW9uKCl7IHJldHVybiB0aGlzOyB9XG4gIH0pO1xufTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG52YXIgZGVmID0gcmVxdWlyZSg4MikuZlxuICAsIGhhcyA9IHJlcXVpcmUoNjEpXG4gICwgVEFHID0gcmVxdWlyZSgxMTMpKCd0b1N0cmluZ1RhZycpO1xuXG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uKGl0LCB0YWcsIHN0YXQpe1xuICBpZihpdCAmJiAhaGFzKGl0ID0gc3RhdCA/IGl0IDogaXQucHJvdG90eXBlLCBUQUcpKWRlZihpdCwgVEFHLCB7Y29uZmlndXJhYmxlOiB0cnVlLCB2YWx1ZTogdGFnfSk7XG59O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbnZhciBzaGFyZWQgPSByZXF1aXJlKDEwMCkoJ2tleXMnKVxuICAsIHVpZCAgICA9IHJlcXVpcmUoMTEwKTtcbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24oa2V5KXtcbiAgcmV0dXJuIHNoYXJlZFtrZXldIHx8IChzaGFyZWRba2V5XSA9IHVpZChrZXkpKTtcbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xudmFyIGdsb2JhbCA9IHJlcXVpcmUoNjApXG4gICwgU0hBUkVEID0gJ19fY29yZS1qc19zaGFyZWRfXydcbiAgLCBzdG9yZSAgPSBnbG9iYWxbU0hBUkVEXSB8fCAoZ2xvYmFsW1NIQVJFRF0gPSB7fSk7XG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uKGtleSl7XG4gIHJldHVybiBzdG9yZVtrZXldIHx8IChzdG9yZVtrZXldID0ge30pO1xufTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4vLyA3LjMuMjAgU3BlY2llc0NvbnN0cnVjdG9yKE8sIGRlZmF1bHRDb25zdHJ1Y3RvcilcbnZhciBhbk9iamVjdCAgPSByZXF1aXJlKDQ2KVxuICAsIGFGdW5jdGlvbiA9IHJlcXVpcmUoNDMpXG4gICwgU1BFQ0lFUyAgID0gcmVxdWlyZSgxMTMpKCdzcGVjaWVzJyk7XG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uKE8sIEQpe1xuICB2YXIgQyA9IGFuT2JqZWN0KE8pLmNvbnN0cnVjdG9yLCBTO1xuICByZXR1cm4gQyA9PT0gdW5kZWZpbmVkIHx8IChTID0gYW5PYmplY3QoQylbU1BFQ0lFU10pID09IHVuZGVmaW5lZCA/IEQgOiBhRnVuY3Rpb24oUyk7XG59O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbnZhciB0b0ludGVnZXIgPSByZXF1aXJlKDEwNSlcbiAgLCBkZWZpbmVkICAgPSByZXF1aXJlKDUyKTtcbi8vIHRydWUgIC0+IFN0cmluZyNhdFxuLy8gZmFsc2UgLT4gU3RyaW5nI2NvZGVQb2ludEF0XG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uKFRPX1NUUklORyl7XG4gIHJldHVybiBmdW5jdGlvbih0aGF0LCBwb3Mpe1xuICAgIHZhciBzID0gU3RyaW5nKGRlZmluZWQodGhhdCkpXG4gICAgICAsIGkgPSB0b0ludGVnZXIocG9zKVxuICAgICAgLCBsID0gcy5sZW5ndGhcbiAgICAgICwgYSwgYjtcbiAgICBpZihpIDwgMCB8fCBpID49IGwpcmV0dXJuIFRPX1NUUklORyA/ICcnIDogdW5kZWZpbmVkO1xuICAgIGEgPSBzLmNoYXJDb2RlQXQoaSk7XG4gICAgcmV0dXJuIGEgPCAweGQ4MDAgfHwgYSA+IDB4ZGJmZiB8fCBpICsgMSA9PT0gbCB8fCAoYiA9IHMuY2hhckNvZGVBdChpICsgMSkpIDwgMHhkYzAwIHx8IGIgPiAweGRmZmZcbiAgICAgID8gVE9fU1RSSU5HID8gcy5jaGFyQXQoaSkgOiBhXG4gICAgICA6IFRPX1NUUklORyA/IHMuc2xpY2UoaSwgaSArIDIpIDogKGEgLSAweGQ4MDAgPDwgMTApICsgKGIgLSAweGRjMDApICsgMHgxMDAwMDtcbiAgfTtcbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xudmFyIGN0eCAgICAgICAgICAgICAgICA9IHJlcXVpcmUoNTEpXG4gICwgaW52b2tlICAgICAgICAgICAgID0gcmVxdWlyZSg2NSlcbiAgLCBodG1sICAgICAgICAgICAgICAgPSByZXF1aXJlKDYzKVxuICAsIGNlbCAgICAgICAgICAgICAgICA9IHJlcXVpcmUoNTQpXG4gICwgZ2xvYmFsICAgICAgICAgICAgID0gcmVxdWlyZSg2MClcbiAgLCBwcm9jZXNzICAgICAgICAgICAgPSBnbG9iYWwucHJvY2Vzc1xuICAsIHNldFRhc2sgICAgICAgICAgICA9IGdsb2JhbC5zZXRJbW1lZGlhdGVcbiAgLCBjbGVhclRhc2sgICAgICAgICAgPSBnbG9iYWwuY2xlYXJJbW1lZGlhdGVcbiAgLCBNZXNzYWdlQ2hhbm5lbCAgICAgPSBnbG9iYWwuTWVzc2FnZUNoYW5uZWxcbiAgLCBjb3VudGVyICAgICAgICAgICAgPSAwXG4gICwgcXVldWUgICAgICAgICAgICAgID0ge31cbiAgLCBPTlJFQURZU1RBVEVDSEFOR0UgPSAnb25yZWFkeXN0YXRlY2hhbmdlJ1xuICAsIGRlZmVyLCBjaGFubmVsLCBwb3J0O1xudmFyIHJ1biA9IGZ1bmN0aW9uKCl7XG4gIHZhciBpZCA9ICt0aGlzO1xuICBpZihxdWV1ZS5oYXNPd25Qcm9wZXJ0eShpZCkpe1xuICAgIHZhciBmbiA9IHF1ZXVlW2lkXTtcbiAgICBkZWxldGUgcXVldWVbaWRdO1xuICAgIGZuKCk7XG4gIH1cbn07XG52YXIgbGlzdGVuZXIgPSBmdW5jdGlvbihldmVudCl7XG4gIHJ1bi5jYWxsKGV2ZW50LmRhdGEpO1xufTtcbi8vIE5vZGUuanMgMC45KyAmIElFMTArIGhhcyBzZXRJbW1lZGlhdGUsIG90aGVyd2lzZTpcbmlmKCFzZXRUYXNrIHx8ICFjbGVhclRhc2spe1xuICBzZXRUYXNrID0gZnVuY3Rpb24gc2V0SW1tZWRpYXRlKGZuKXtcbiAgICB2YXIgYXJncyA9IFtdLCBpID0gMTtcbiAgICB3aGlsZShhcmd1bWVudHMubGVuZ3RoID4gaSlhcmdzLnB1c2goYXJndW1lbnRzW2krK10pO1xuICAgIHF1ZXVlWysrY291bnRlcl0gPSBmdW5jdGlvbigpe1xuICAgICAgaW52b2tlKHR5cGVvZiBmbiA9PSAnZnVuY3Rpb24nID8gZm4gOiBGdW5jdGlvbihmbiksIGFyZ3MpO1xuICAgIH07XG4gICAgZGVmZXIoY291bnRlcik7XG4gICAgcmV0dXJuIGNvdW50ZXI7XG4gIH07XG4gIGNsZWFyVGFzayA9IGZ1bmN0aW9uIGNsZWFySW1tZWRpYXRlKGlkKXtcbiAgICBkZWxldGUgcXVldWVbaWRdO1xuICB9O1xuICAvLyBOb2RlLmpzIDAuOC1cbiAgaWYocmVxdWlyZSg0OSkocHJvY2VzcykgPT0gJ3Byb2Nlc3MnKXtcbiAgICBkZWZlciA9IGZ1bmN0aW9uKGlkKXtcbiAgICAgIHByb2Nlc3MubmV4dFRpY2soY3R4KHJ1biwgaWQsIDEpKTtcbiAgICB9O1xuICAvLyBCcm93c2VycyB3aXRoIE1lc3NhZ2VDaGFubmVsLCBpbmNsdWRlcyBXZWJXb3JrZXJzXG4gIH0gZWxzZSBpZihNZXNzYWdlQ2hhbm5lbCl7XG4gICAgY2hhbm5lbCA9IG5ldyBNZXNzYWdlQ2hhbm5lbDtcbiAgICBwb3J0ICAgID0gY2hhbm5lbC5wb3J0MjtcbiAgICBjaGFubmVsLnBvcnQxLm9ubWVzc2FnZSA9IGxpc3RlbmVyO1xuICAgIGRlZmVyID0gY3R4KHBvcnQucG9zdE1lc3NhZ2UsIHBvcnQsIDEpO1xuICAvLyBCcm93c2VycyB3aXRoIHBvc3RNZXNzYWdlLCBza2lwIFdlYldvcmtlcnNcbiAgLy8gSUU4IGhhcyBwb3N0TWVzc2FnZSwgYnV0IGl0J3Mgc3luYyAmIHR5cGVvZiBpdHMgcG9zdE1lc3NhZ2UgaXMgJ29iamVjdCdcbiAgfSBlbHNlIGlmKGdsb2JhbC5hZGRFdmVudExpc3RlbmVyICYmIHR5cGVvZiBwb3N0TWVzc2FnZSA9PSAnZnVuY3Rpb24nICYmICFnbG9iYWwuaW1wb3J0U2NyaXB0cyl7XG4gICAgZGVmZXIgPSBmdW5jdGlvbihpZCl7XG4gICAgICBnbG9iYWwucG9zdE1lc3NhZ2UoaWQgKyAnJywgJyonKTtcbiAgICB9O1xuICAgIGdsb2JhbC5hZGRFdmVudExpc3RlbmVyKCdtZXNzYWdlJywgbGlzdGVuZXIsIGZhbHNlKTtcbiAgLy8gSUU4LVxuICB9IGVsc2UgaWYoT05SRUFEWVNUQVRFQ0hBTkdFIGluIGNlbCgnc2NyaXB0Jykpe1xuICAgIGRlZmVyID0gZnVuY3Rpb24oaWQpe1xuICAgICAgaHRtbC5hcHBlbmRDaGlsZChjZWwoJ3NjcmlwdCcpKVtPTlJFQURZU1RBVEVDSEFOR0VdID0gZnVuY3Rpb24oKXtcbiAgICAgICAgaHRtbC5yZW1vdmVDaGlsZCh0aGlzKTtcbiAgICAgICAgcnVuLmNhbGwoaWQpO1xuICAgICAgfTtcbiAgICB9O1xuICAvLyBSZXN0IG9sZCBicm93c2Vyc1xuICB9IGVsc2Uge1xuICAgIGRlZmVyID0gZnVuY3Rpb24oaWQpe1xuICAgICAgc2V0VGltZW91dChjdHgocnVuLCBpZCwgMSksIDApO1xuICAgIH07XG4gIH1cbn1cbm1vZHVsZS5leHBvcnRzID0ge1xuICBzZXQ6ICAgc2V0VGFzayxcbiAgY2xlYXI6IGNsZWFyVGFza1xufTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG52YXIgdG9JbnRlZ2VyID0gcmVxdWlyZSgxMDUpXG4gICwgbWF4ICAgICAgID0gTWF0aC5tYXhcbiAgLCBtaW4gICAgICAgPSBNYXRoLm1pbjtcbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24oaW5kZXgsIGxlbmd0aCl7XG4gIGluZGV4ID0gdG9JbnRlZ2VyKGluZGV4KTtcbiAgcmV0dXJuIGluZGV4IDwgMCA/IG1heChpbmRleCArIGxlbmd0aCwgMCkgOiBtaW4oaW5kZXgsIGxlbmd0aCk7XG59O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbi8vIDcuMS40IFRvSW50ZWdlclxudmFyIGNlaWwgID0gTWF0aC5jZWlsXG4gICwgZmxvb3IgPSBNYXRoLmZsb29yO1xubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbihpdCl7XG4gIHJldHVybiBpc05hTihpdCA9ICtpdCkgPyAwIDogKGl0ID4gMCA/IGZsb29yIDogY2VpbCkoaXQpO1xufTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4vLyB0byBpbmRleGVkIG9iamVjdCwgdG9PYmplY3Qgd2l0aCBmYWxsYmFjayBmb3Igbm9uLWFycmF5LWxpa2UgRVMzIHN0cmluZ3NcbnZhciBJT2JqZWN0ID0gcmVxdWlyZSg2NilcbiAgLCBkZWZpbmVkID0gcmVxdWlyZSg1Mik7XG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uKGl0KXtcbiAgcmV0dXJuIElPYmplY3QoZGVmaW5lZChpdCkpO1xufTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4vLyA3LjEuMTUgVG9MZW5ndGhcbnZhciB0b0ludGVnZXIgPSByZXF1aXJlKDEwNSlcbiAgLCBtaW4gICAgICAgPSBNYXRoLm1pbjtcbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24oaXQpe1xuICByZXR1cm4gaXQgPiAwID8gbWluKHRvSW50ZWdlcihpdCksIDB4MWZmZmZmZmZmZmZmZmYpIDogMDsgLy8gcG93KDIsIDUzKSAtIDEgPT0gOTAwNzE5OTI1NDc0MDk5MVxufTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4vLyA3LjEuMTMgVG9PYmplY3QoYXJndW1lbnQpXG52YXIgZGVmaW5lZCA9IHJlcXVpcmUoNTIpO1xubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbihpdCl7XG4gIHJldHVybiBPYmplY3QoZGVmaW5lZChpdCkpO1xufTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4vLyA3LjEuMSBUb1ByaW1pdGl2ZShpbnB1dCBbLCBQcmVmZXJyZWRUeXBlXSlcbnZhciBpc09iamVjdCA9IHJlcXVpcmUoNjkpO1xuLy8gaW5zdGVhZCBvZiB0aGUgRVM2IHNwZWMgdmVyc2lvbiwgd2UgZGlkbid0IGltcGxlbWVudCBAQHRvUHJpbWl0aXZlIGNhc2Vcbi8vIGFuZCB0aGUgc2Vjb25kIGFyZ3VtZW50IC0gZmxhZyAtIHByZWZlcnJlZCB0eXBlIGlzIGEgc3RyaW5nXG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uKGl0LCBTKXtcbiAgaWYoIWlzT2JqZWN0KGl0KSlyZXR1cm4gaXQ7XG4gIHZhciBmbiwgdmFsO1xuICBpZihTICYmIHR5cGVvZiAoZm4gPSBpdC50b1N0cmluZykgPT0gJ2Z1bmN0aW9uJyAmJiAhaXNPYmplY3QodmFsID0gZm4uY2FsbChpdCkpKXJldHVybiB2YWw7XG4gIGlmKHR5cGVvZiAoZm4gPSBpdC52YWx1ZU9mKSA9PSAnZnVuY3Rpb24nICYmICFpc09iamVjdCh2YWwgPSBmbi5jYWxsKGl0KSkpcmV0dXJuIHZhbDtcbiAgaWYoIVMgJiYgdHlwZW9mIChmbiA9IGl0LnRvU3RyaW5nKSA9PSAnZnVuY3Rpb24nICYmICFpc09iamVjdCh2YWwgPSBmbi5jYWxsKGl0KSkpcmV0dXJuIHZhbDtcbiAgdGhyb3cgVHlwZUVycm9yKFwiQ2FuJ3QgY29udmVydCBvYmplY3QgdG8gcHJpbWl0aXZlIHZhbHVlXCIpO1xufTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG52YXIgaWQgPSAwXG4gICwgcHggPSBNYXRoLnJhbmRvbSgpO1xubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbihrZXkpe1xuICByZXR1cm4gJ1N5bWJvbCgnLmNvbmNhdChrZXkgPT09IHVuZGVmaW5lZCA/ICcnIDoga2V5LCAnKV8nLCAoKytpZCArIHB4KS50b1N0cmluZygzNikpO1xufTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG52YXIgZ2xvYmFsICAgICAgICAgPSByZXF1aXJlKDYwKVxuICAsIGNvcmUgICAgICAgICAgID0gcmVxdWlyZSg1MClcbiAgLCBMSUJSQVJZICAgICAgICA9IHJlcXVpcmUoNzcpXG4gICwgd2tzRXh0ICAgICAgICAgPSByZXF1aXJlKDExMilcbiAgLCBkZWZpbmVQcm9wZXJ0eSA9IHJlcXVpcmUoODIpLmY7XG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uKG5hbWUpe1xuICB2YXIgJFN5bWJvbCA9IGNvcmUuU3ltYm9sIHx8IChjb3JlLlN5bWJvbCA9IExJQlJBUlkgPyB7fSA6IGdsb2JhbC5TeW1ib2wgfHwge30pO1xuICBpZihuYW1lLmNoYXJBdCgwKSAhPSAnXycgJiYgIShuYW1lIGluICRTeW1ib2wpKWRlZmluZVByb3BlcnR5KCRTeW1ib2wsIG5hbWUsIHt2YWx1ZTogd2tzRXh0LmYobmFtZSl9KTtcbn07XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xuZXhwb3J0cy5mID0gcmVxdWlyZSgxMTMpO1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbnZhciBzdG9yZSAgICAgID0gcmVxdWlyZSgxMDApKCd3a3MnKVxuICAsIHVpZCAgICAgICAgPSByZXF1aXJlKDExMClcbiAgLCBTeW1ib2wgICAgID0gcmVxdWlyZSg2MCkuU3ltYm9sXG4gICwgVVNFX1NZTUJPTCA9IHR5cGVvZiBTeW1ib2wgPT0gJ2Z1bmN0aW9uJztcblxudmFyICRleHBvcnRzID0gbW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbihuYW1lKXtcbiAgcmV0dXJuIHN0b3JlW25hbWVdIHx8IChzdG9yZVtuYW1lXSA9XG4gICAgVVNFX1NZTUJPTCAmJiBTeW1ib2xbbmFtZV0gfHwgKFVTRV9TWU1CT0wgPyBTeW1ib2wgOiB1aWQpKCdTeW1ib2wuJyArIG5hbWUpKTtcbn07XG5cbiRleHBvcnRzLnN0b3JlID0gc3RvcmU7XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xudmFyIGNsYXNzb2YgICA9IHJlcXVpcmUoNDgpXG4gICwgSVRFUkFUT1IgID0gcmVxdWlyZSgxMTMpKCdpdGVyYXRvcicpXG4gICwgSXRlcmF0b3JzID0gcmVxdWlyZSg3NSk7XG5tb2R1bGUuZXhwb3J0cyA9IHJlcXVpcmUoNTApLmdldEl0ZXJhdG9yTWV0aG9kID0gZnVuY3Rpb24oaXQpe1xuICBpZihpdCAhPSB1bmRlZmluZWQpcmV0dXJuIGl0W0lURVJBVE9SXVxuICAgIHx8IGl0WydAQGl0ZXJhdG9yJ11cbiAgICB8fCBJdGVyYXRvcnNbY2xhc3NvZihpdCldO1xufTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG52YXIgYW5PYmplY3QgPSByZXF1aXJlKDQ2KVxuICAsIGdldCAgICAgID0gcmVxdWlyZSgxMTQpO1xubW9kdWxlLmV4cG9ydHMgPSByZXF1aXJlKDUwKS5nZXRJdGVyYXRvciA9IGZ1bmN0aW9uKGl0KXtcbiAgdmFyIGl0ZXJGbiA9IGdldChpdCk7XG4gIGlmKHR5cGVvZiBpdGVyRm4gIT0gJ2Z1bmN0aW9uJyl0aHJvdyBUeXBlRXJyb3IoaXQgKyAnIGlzIG5vdCBpdGVyYWJsZSEnKTtcbiAgcmV0dXJuIGFuT2JqZWN0KGl0ZXJGbi5jYWxsKGl0KSk7XG59O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbnZhciBjbGFzc29mICAgPSByZXF1aXJlKDQ4KVxuICAsIElURVJBVE9SICA9IHJlcXVpcmUoMTEzKSgnaXRlcmF0b3InKVxuICAsIEl0ZXJhdG9ycyA9IHJlcXVpcmUoNzUpO1xubW9kdWxlLmV4cG9ydHMgPSByZXF1aXJlKDUwKS5pc0l0ZXJhYmxlID0gZnVuY3Rpb24oaXQpe1xuICB2YXIgTyA9IE9iamVjdChpdCk7XG4gIHJldHVybiBPW0lURVJBVE9SXSAhPT0gdW5kZWZpbmVkXG4gICAgfHwgJ0BAaXRlcmF0b3InIGluIE9cbiAgICB8fCBJdGVyYXRvcnMuaGFzT3duUHJvcGVydHkoY2xhc3NvZihPKSk7XG59O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbid1c2Ugc3RyaWN0JztcbnZhciBhZGRUb1Vuc2NvcGFibGVzID0gcmVxdWlyZSg0NClcbiAgLCBzdGVwICAgICAgICAgICAgID0gcmVxdWlyZSg3NClcbiAgLCBJdGVyYXRvcnMgICAgICAgID0gcmVxdWlyZSg3NSlcbiAgLCB0b0lPYmplY3QgICAgICAgID0gcmVxdWlyZSgxMDYpO1xuXG4vLyAyMi4xLjMuNCBBcnJheS5wcm90b3R5cGUuZW50cmllcygpXG4vLyAyMi4xLjMuMTMgQXJyYXkucHJvdG90eXBlLmtleXMoKVxuLy8gMjIuMS4zLjI5IEFycmF5LnByb3RvdHlwZS52YWx1ZXMoKVxuLy8gMjIuMS4zLjMwIEFycmF5LnByb3RvdHlwZVtAQGl0ZXJhdG9yXSgpXG5tb2R1bGUuZXhwb3J0cyA9IHJlcXVpcmUoNzIpKEFycmF5LCAnQXJyYXknLCBmdW5jdGlvbihpdGVyYXRlZCwga2luZCl7XG4gIHRoaXMuX3QgPSB0b0lPYmplY3QoaXRlcmF0ZWQpOyAvLyB0YXJnZXRcbiAgdGhpcy5faSA9IDA7ICAgICAgICAgICAgICAgICAgIC8vIG5leHQgaW5kZXhcbiAgdGhpcy5fayA9IGtpbmQ7ICAgICAgICAgICAgICAgIC8vIGtpbmRcbi8vIDIyLjEuNS4yLjEgJUFycmF5SXRlcmF0b3JQcm90b3R5cGUlLm5leHQoKVxufSwgZnVuY3Rpb24oKXtcbiAgdmFyIE8gICAgID0gdGhpcy5fdFxuICAgICwga2luZCAgPSB0aGlzLl9rXG4gICAgLCBpbmRleCA9IHRoaXMuX2krKztcbiAgaWYoIU8gfHwgaW5kZXggPj0gTy5sZW5ndGgpe1xuICAgIHRoaXMuX3QgPSB1bmRlZmluZWQ7XG4gICAgcmV0dXJuIHN0ZXAoMSk7XG4gIH1cbiAgaWYoa2luZCA9PSAna2V5cycgIClyZXR1cm4gc3RlcCgwLCBpbmRleCk7XG4gIGlmKGtpbmQgPT0gJ3ZhbHVlcycpcmV0dXJuIHN0ZXAoMCwgT1tpbmRleF0pO1xuICByZXR1cm4gc3RlcCgwLCBbaW5kZXgsIE9baW5kZXhdXSk7XG59LCAndmFsdWVzJyk7XG5cbi8vIGFyZ3VtZW50c0xpc3RbQEBpdGVyYXRvcl0gaXMgJUFycmF5UHJvdG9fdmFsdWVzJSAoOS40LjQuNiwgOS40LjQuNylcbkl0ZXJhdG9ycy5Bcmd1bWVudHMgPSBJdGVyYXRvcnMuQXJyYXk7XG5cbmFkZFRvVW5zY29wYWJsZXMoJ2tleXMnKTtcbmFkZFRvVW5zY29wYWJsZXMoJ3ZhbHVlcycpO1xuYWRkVG9VbnNjb3BhYmxlcygnZW50cmllcycpO1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbi8vIDE5LjEuMy4xIE9iamVjdC5hc3NpZ24odGFyZ2V0LCBzb3VyY2UpXG52YXIgJGV4cG9ydCA9IHJlcXVpcmUoNTcpO1xuXG4kZXhwb3J0KCRleHBvcnQuUyArICRleHBvcnQuRiwgJ09iamVjdCcsIHthc3NpZ246IHJlcXVpcmUoODApfSk7XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xudmFyICRleHBvcnQgPSByZXF1aXJlKDU3KVxuLy8gMTkuMS4yLjIgLyAxNS4yLjMuNSBPYmplY3QuY3JlYXRlKE8gWywgUHJvcGVydGllc10pXG4kZXhwb3J0KCRleHBvcnQuUywgJ09iamVjdCcsIHtjcmVhdGU6IHJlcXVpcmUoODEpfSk7XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xudmFyICRleHBvcnQgPSByZXF1aXJlKDU3KTtcbi8vIDE5LjEuMi40IC8gMTUuMi4zLjYgT2JqZWN0LmRlZmluZVByb3BlcnR5KE8sIFAsIEF0dHJpYnV0ZXMpXG4kZXhwb3J0KCRleHBvcnQuUyArICRleHBvcnQuRiAqICFyZXF1aXJlKDUzKSwgJ09iamVjdCcsIHtkZWZpbmVQcm9wZXJ0eTogcmVxdWlyZSg4MikuZn0pO1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbi8vIDE5LjEuMi45IE9iamVjdC5nZXRQcm90b3R5cGVPZihPKVxudmFyIHRvT2JqZWN0ICAgICAgICA9IHJlcXVpcmUoMTA4KVxuICAsICRnZXRQcm90b3R5cGVPZiA9IHJlcXVpcmUoODgpO1xuXG5yZXF1aXJlKDkyKSgnZ2V0UHJvdG90eXBlT2YnLCBmdW5jdGlvbigpe1xuICByZXR1cm4gZnVuY3Rpb24gZ2V0UHJvdG90eXBlT2YoaXQpe1xuICAgIHJldHVybiAkZ2V0UHJvdG90eXBlT2YodG9PYmplY3QoaXQpKTtcbiAgfTtcbn0pO1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbi8vIDE5LjEuMi4xNCBPYmplY3Qua2V5cyhPKVxudmFyIHRvT2JqZWN0ID0gcmVxdWlyZSgxMDgpXG4gICwgJGtleXMgICAgPSByZXF1aXJlKDkwKTtcblxucmVxdWlyZSg5MikoJ2tleXMnLCBmdW5jdGlvbigpe1xuICByZXR1cm4gZnVuY3Rpb24ga2V5cyhpdCl7XG4gICAgcmV0dXJuICRrZXlzKHRvT2JqZWN0KGl0KSk7XG4gIH07XG59KTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4vLyAxOS4xLjMuMTkgT2JqZWN0LnNldFByb3RvdHlwZU9mKE8sIHByb3RvKVxudmFyICRleHBvcnQgPSByZXF1aXJlKDU3KTtcbiRleHBvcnQoJGV4cG9ydC5TLCAnT2JqZWN0Jywge3NldFByb3RvdHlwZU9mOiByZXF1aXJlKDk2KS5zZXR9KTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4ndXNlIHN0cmljdCc7XG52YXIgTElCUkFSWSAgICAgICAgICAgID0gcmVxdWlyZSg3NylcbiAgLCBnbG9iYWwgICAgICAgICAgICAgPSByZXF1aXJlKDYwKVxuICAsIGN0eCAgICAgICAgICAgICAgICA9IHJlcXVpcmUoNTEpXG4gICwgY2xhc3NvZiAgICAgICAgICAgID0gcmVxdWlyZSg0OClcbiAgLCAkZXhwb3J0ICAgICAgICAgICAgPSByZXF1aXJlKDU3KVxuICAsIGlzT2JqZWN0ICAgICAgICAgICA9IHJlcXVpcmUoNjkpXG4gICwgYUZ1bmN0aW9uICAgICAgICAgID0gcmVxdWlyZSg0MylcbiAgLCBhbkluc3RhbmNlICAgICAgICAgPSByZXF1aXJlKDQ1KVxuICAsIGZvck9mICAgICAgICAgICAgICA9IHJlcXVpcmUoNTkpXG4gICwgc3BlY2llc0NvbnN0cnVjdG9yID0gcmVxdWlyZSgxMDEpXG4gICwgdGFzayAgICAgICAgICAgICAgID0gcmVxdWlyZSgxMDMpLnNldFxuICAsIG1pY3JvdGFzayAgICAgICAgICA9IHJlcXVpcmUoNzkpKClcbiAgLCBQUk9NSVNFICAgICAgICAgICAgPSAnUHJvbWlzZSdcbiAgLCBUeXBlRXJyb3IgICAgICAgICAgPSBnbG9iYWwuVHlwZUVycm9yXG4gICwgcHJvY2VzcyAgICAgICAgICAgID0gZ2xvYmFsLnByb2Nlc3NcbiAgLCAkUHJvbWlzZSAgICAgICAgICAgPSBnbG9iYWxbUFJPTUlTRV1cbiAgLCBwcm9jZXNzICAgICAgICAgICAgPSBnbG9iYWwucHJvY2Vzc1xuICAsIGlzTm9kZSAgICAgICAgICAgICA9IGNsYXNzb2YocHJvY2VzcykgPT0gJ3Byb2Nlc3MnXG4gICwgZW1wdHkgICAgICAgICAgICAgID0gZnVuY3Rpb24oKXsgLyogZW1wdHkgKi8gfVxuICAsIEludGVybmFsLCBHZW5lcmljUHJvbWlzZUNhcGFiaWxpdHksIFdyYXBwZXI7XG5cbnZhciBVU0VfTkFUSVZFID0gISFmdW5jdGlvbigpe1xuICB0cnkge1xuICAgIC8vIGNvcnJlY3Qgc3ViY2xhc3Npbmcgd2l0aCBAQHNwZWNpZXMgc3VwcG9ydFxuICAgIHZhciBwcm9taXNlICAgICA9ICRQcm9taXNlLnJlc29sdmUoMSlcbiAgICAgICwgRmFrZVByb21pc2UgPSAocHJvbWlzZS5jb25zdHJ1Y3RvciA9IHt9KVtyZXF1aXJlKDExMykoJ3NwZWNpZXMnKV0gPSBmdW5jdGlvbihleGVjKXsgZXhlYyhlbXB0eSwgZW1wdHkpOyB9O1xuICAgIC8vIHVuaGFuZGxlZCByZWplY3Rpb25zIHRyYWNraW5nIHN1cHBvcnQsIE5vZGVKUyBQcm9taXNlIHdpdGhvdXQgaXQgZmFpbHMgQEBzcGVjaWVzIHRlc3RcbiAgICByZXR1cm4gKGlzTm9kZSB8fCB0eXBlb2YgUHJvbWlzZVJlamVjdGlvbkV2ZW50ID09ICdmdW5jdGlvbicpICYmIHByb21pc2UudGhlbihlbXB0eSkgaW5zdGFuY2VvZiBGYWtlUHJvbWlzZTtcbiAgfSBjYXRjaChlKXsgLyogZW1wdHkgKi8gfVxufSgpO1xuXG4vLyBoZWxwZXJzXG52YXIgc2FtZUNvbnN0cnVjdG9yID0gZnVuY3Rpb24oYSwgYil7XG4gIC8vIHdpdGggbGlicmFyeSB3cmFwcGVyIHNwZWNpYWwgY2FzZVxuICByZXR1cm4gYSA9PT0gYiB8fCBhID09PSAkUHJvbWlzZSAmJiBiID09PSBXcmFwcGVyO1xufTtcbnZhciBpc1RoZW5hYmxlID0gZnVuY3Rpb24oaXQpe1xuICB2YXIgdGhlbjtcbiAgcmV0dXJuIGlzT2JqZWN0KGl0KSAmJiB0eXBlb2YgKHRoZW4gPSBpdC50aGVuKSA9PSAnZnVuY3Rpb24nID8gdGhlbiA6IGZhbHNlO1xufTtcbnZhciBuZXdQcm9taXNlQ2FwYWJpbGl0eSA9IGZ1bmN0aW9uKEMpe1xuICByZXR1cm4gc2FtZUNvbnN0cnVjdG9yKCRQcm9taXNlLCBDKVxuICAgID8gbmV3IFByb21pc2VDYXBhYmlsaXR5KEMpXG4gICAgOiBuZXcgR2VuZXJpY1Byb21pc2VDYXBhYmlsaXR5KEMpO1xufTtcbnZhciBQcm9taXNlQ2FwYWJpbGl0eSA9IEdlbmVyaWNQcm9taXNlQ2FwYWJpbGl0eSA9IGZ1bmN0aW9uKEMpe1xuICB2YXIgcmVzb2x2ZSwgcmVqZWN0O1xuICB0aGlzLnByb21pc2UgPSBuZXcgQyhmdW5jdGlvbigkJHJlc29sdmUsICQkcmVqZWN0KXtcbiAgICBpZihyZXNvbHZlICE9PSB1bmRlZmluZWQgfHwgcmVqZWN0ICE9PSB1bmRlZmluZWQpdGhyb3cgVHlwZUVycm9yKCdCYWQgUHJvbWlzZSBjb25zdHJ1Y3RvcicpO1xuICAgIHJlc29sdmUgPSAkJHJlc29sdmU7XG4gICAgcmVqZWN0ICA9ICQkcmVqZWN0O1xuICB9KTtcbiAgdGhpcy5yZXNvbHZlID0gYUZ1bmN0aW9uKHJlc29sdmUpO1xuICB0aGlzLnJlamVjdCAgPSBhRnVuY3Rpb24ocmVqZWN0KTtcbn07XG52YXIgcGVyZm9ybSA9IGZ1bmN0aW9uKGV4ZWMpe1xuICB0cnkge1xuICAgIGV4ZWMoKTtcbiAgfSBjYXRjaChlKXtcbiAgICByZXR1cm4ge2Vycm9yOiBlfTtcbiAgfVxufTtcbnZhciBub3RpZnkgPSBmdW5jdGlvbihwcm9taXNlLCBpc1JlamVjdCl7XG4gIGlmKHByb21pc2UuX24pcmV0dXJuO1xuICBwcm9taXNlLl9uID0gdHJ1ZTtcbiAgdmFyIGNoYWluID0gcHJvbWlzZS5fYztcbiAgbWljcm90YXNrKGZ1bmN0aW9uKCl7XG4gICAgdmFyIHZhbHVlID0gcHJvbWlzZS5fdlxuICAgICAgLCBvayAgICA9IHByb21pc2UuX3MgPT0gMVxuICAgICAgLCBpICAgICA9IDA7XG4gICAgdmFyIHJ1biA9IGZ1bmN0aW9uKHJlYWN0aW9uKXtcbiAgICAgIHZhciBoYW5kbGVyID0gb2sgPyByZWFjdGlvbi5vayA6IHJlYWN0aW9uLmZhaWxcbiAgICAgICAgLCByZXNvbHZlID0gcmVhY3Rpb24ucmVzb2x2ZVxuICAgICAgICAsIHJlamVjdCAgPSByZWFjdGlvbi5yZWplY3RcbiAgICAgICAgLCBkb21haW4gID0gcmVhY3Rpb24uZG9tYWluXG4gICAgICAgICwgcmVzdWx0LCB0aGVuO1xuICAgICAgdHJ5IHtcbiAgICAgICAgaWYoaGFuZGxlcil7XG4gICAgICAgICAgaWYoIW9rKXtcbiAgICAgICAgICAgIGlmKHByb21pc2UuX2ggPT0gMilvbkhhbmRsZVVuaGFuZGxlZChwcm9taXNlKTtcbiAgICAgICAgICAgIHByb21pc2UuX2ggPSAxO1xuICAgICAgICAgIH1cbiAgICAgICAgICBpZihoYW5kbGVyID09PSB0cnVlKXJlc3VsdCA9IHZhbHVlO1xuICAgICAgICAgIGVsc2Uge1xuICAgICAgICAgICAgaWYoZG9tYWluKWRvbWFpbi5lbnRlcigpO1xuICAgICAgICAgICAgcmVzdWx0ID0gaGFuZGxlcih2YWx1ZSk7XG4gICAgICAgICAgICBpZihkb21haW4pZG9tYWluLmV4aXQoKTtcbiAgICAgICAgICB9XG4gICAgICAgICAgaWYocmVzdWx0ID09PSByZWFjdGlvbi5wcm9taXNlKXtcbiAgICAgICAgICAgIHJlamVjdChUeXBlRXJyb3IoJ1Byb21pc2UtY2hhaW4gY3ljbGUnKSk7XG4gICAgICAgICAgfSBlbHNlIGlmKHRoZW4gPSBpc1RoZW5hYmxlKHJlc3VsdCkpe1xuICAgICAgICAgICAgdGhlbi5jYWxsKHJlc3VsdCwgcmVzb2x2ZSwgcmVqZWN0KTtcbiAgICAgICAgICB9IGVsc2UgcmVzb2x2ZShyZXN1bHQpO1xuICAgICAgICB9IGVsc2UgcmVqZWN0KHZhbHVlKTtcbiAgICAgIH0gY2F0Y2goZSl7XG4gICAgICAgIHJlamVjdChlKTtcbiAgICAgIH1cbiAgICB9O1xuICAgIHdoaWxlKGNoYWluLmxlbmd0aCA+IGkpcnVuKGNoYWluW2krK10pOyAvLyB2YXJpYWJsZSBsZW5ndGggLSBjYW4ndCB1c2UgZm9yRWFjaFxuICAgIHByb21pc2UuX2MgPSBbXTtcbiAgICBwcm9taXNlLl9uID0gZmFsc2U7XG4gICAgaWYoaXNSZWplY3QgJiYgIXByb21pc2UuX2gpb25VbmhhbmRsZWQocHJvbWlzZSk7XG4gIH0pO1xufTtcbnZhciBvblVuaGFuZGxlZCA9IGZ1bmN0aW9uKHByb21pc2Upe1xuICB0YXNrLmNhbGwoZ2xvYmFsLCBmdW5jdGlvbigpe1xuICAgIHZhciB2YWx1ZSA9IHByb21pc2UuX3ZcbiAgICAgICwgYWJydXB0LCBoYW5kbGVyLCBjb25zb2xlO1xuICAgIGlmKGlzVW5oYW5kbGVkKHByb21pc2UpKXtcbiAgICAgIGFicnVwdCA9IHBlcmZvcm0oZnVuY3Rpb24oKXtcbiAgICAgICAgaWYoaXNOb2RlKXtcbiAgICAgICAgICBwcm9jZXNzLmVtaXQoJ3VuaGFuZGxlZFJlamVjdGlvbicsIHZhbHVlLCBwcm9taXNlKTtcbiAgICAgICAgfSBlbHNlIGlmKGhhbmRsZXIgPSBnbG9iYWwub251bmhhbmRsZWRyZWplY3Rpb24pe1xuICAgICAgICAgIGhhbmRsZXIoe3Byb21pc2U6IHByb21pc2UsIHJlYXNvbjogdmFsdWV9KTtcbiAgICAgICAgfSBlbHNlIGlmKChjb25zb2xlID0gZ2xvYmFsLmNvbnNvbGUpICYmIGNvbnNvbGUuZXJyb3Ipe1xuICAgICAgICAgIGNvbnNvbGUuZXJyb3IoJ1VuaGFuZGxlZCBwcm9taXNlIHJlamVjdGlvbicsIHZhbHVlKTtcbiAgICAgICAgfVxuICAgICAgfSk7XG4gICAgICAvLyBCcm93c2VycyBzaG91bGQgbm90IHRyaWdnZXIgYHJlamVjdGlvbkhhbmRsZWRgIGV2ZW50IGlmIGl0IHdhcyBoYW5kbGVkIGhlcmUsIE5vZGVKUyAtIHNob3VsZFxuICAgICAgcHJvbWlzZS5faCA9IGlzTm9kZSB8fCBpc1VuaGFuZGxlZChwcm9taXNlKSA/IDIgOiAxO1xuICAgIH0gcHJvbWlzZS5fYSA9IHVuZGVmaW5lZDtcbiAgICBpZihhYnJ1cHQpdGhyb3cgYWJydXB0LmVycm9yO1xuICB9KTtcbn07XG52YXIgaXNVbmhhbmRsZWQgPSBmdW5jdGlvbihwcm9taXNlKXtcbiAgaWYocHJvbWlzZS5faCA9PSAxKXJldHVybiBmYWxzZTtcbiAgdmFyIGNoYWluID0gcHJvbWlzZS5fYSB8fCBwcm9taXNlLl9jXG4gICAgLCBpICAgICA9IDBcbiAgICAsIHJlYWN0aW9uO1xuICB3aGlsZShjaGFpbi5sZW5ndGggPiBpKXtcbiAgICByZWFjdGlvbiA9IGNoYWluW2krK107XG4gICAgaWYocmVhY3Rpb24uZmFpbCB8fCAhaXNVbmhhbmRsZWQocmVhY3Rpb24ucHJvbWlzZSkpcmV0dXJuIGZhbHNlO1xuICB9IHJldHVybiB0cnVlO1xufTtcbnZhciBvbkhhbmRsZVVuaGFuZGxlZCA9IGZ1bmN0aW9uKHByb21pc2Upe1xuICB0YXNrLmNhbGwoZ2xvYmFsLCBmdW5jdGlvbigpe1xuICAgIHZhciBoYW5kbGVyO1xuICAgIGlmKGlzTm9kZSl7XG4gICAgICBwcm9jZXNzLmVtaXQoJ3JlamVjdGlvbkhhbmRsZWQnLCBwcm9taXNlKTtcbiAgICB9IGVsc2UgaWYoaGFuZGxlciA9IGdsb2JhbC5vbnJlamVjdGlvbmhhbmRsZWQpe1xuICAgICAgaGFuZGxlcih7cHJvbWlzZTogcHJvbWlzZSwgcmVhc29uOiBwcm9taXNlLl92fSk7XG4gICAgfVxuICB9KTtcbn07XG52YXIgJHJlamVjdCA9IGZ1bmN0aW9uKHZhbHVlKXtcbiAgdmFyIHByb21pc2UgPSB0aGlzO1xuICBpZihwcm9taXNlLl9kKXJldHVybjtcbiAgcHJvbWlzZS5fZCA9IHRydWU7XG4gIHByb21pc2UgPSBwcm9taXNlLl93IHx8IHByb21pc2U7IC8vIHVud3JhcFxuICBwcm9taXNlLl92ID0gdmFsdWU7XG4gIHByb21pc2UuX3MgPSAyO1xuICBpZighcHJvbWlzZS5fYSlwcm9taXNlLl9hID0gcHJvbWlzZS5fYy5zbGljZSgpO1xuICBub3RpZnkocHJvbWlzZSwgdHJ1ZSk7XG59O1xudmFyICRyZXNvbHZlID0gZnVuY3Rpb24odmFsdWUpe1xuICB2YXIgcHJvbWlzZSA9IHRoaXNcbiAgICAsIHRoZW47XG4gIGlmKHByb21pc2UuX2QpcmV0dXJuO1xuICBwcm9taXNlLl9kID0gdHJ1ZTtcbiAgcHJvbWlzZSA9IHByb21pc2UuX3cgfHwgcHJvbWlzZTsgLy8gdW53cmFwXG4gIHRyeSB7XG4gICAgaWYocHJvbWlzZSA9PT0gdmFsdWUpdGhyb3cgVHlwZUVycm9yKFwiUHJvbWlzZSBjYW4ndCBiZSByZXNvbHZlZCBpdHNlbGZcIik7XG4gICAgaWYodGhlbiA9IGlzVGhlbmFibGUodmFsdWUpKXtcbiAgICAgIG1pY3JvdGFzayhmdW5jdGlvbigpe1xuICAgICAgICB2YXIgd3JhcHBlciA9IHtfdzogcHJvbWlzZSwgX2Q6IGZhbHNlfTsgLy8gd3JhcFxuICAgICAgICB0cnkge1xuICAgICAgICAgIHRoZW4uY2FsbCh2YWx1ZSwgY3R4KCRyZXNvbHZlLCB3cmFwcGVyLCAxKSwgY3R4KCRyZWplY3QsIHdyYXBwZXIsIDEpKTtcbiAgICAgICAgfSBjYXRjaChlKXtcbiAgICAgICAgICAkcmVqZWN0LmNhbGwod3JhcHBlciwgZSk7XG4gICAgICAgIH1cbiAgICAgIH0pO1xuICAgIH0gZWxzZSB7XG4gICAgICBwcm9taXNlLl92ID0gdmFsdWU7XG4gICAgICBwcm9taXNlLl9zID0gMTtcbiAgICAgIG5vdGlmeShwcm9taXNlLCBmYWxzZSk7XG4gICAgfVxuICB9IGNhdGNoKGUpe1xuICAgICRyZWplY3QuY2FsbCh7X3c6IHByb21pc2UsIF9kOiBmYWxzZX0sIGUpOyAvLyB3cmFwXG4gIH1cbn07XG5cbi8vIGNvbnN0cnVjdG9yIHBvbHlmaWxsXG5pZighVVNFX05BVElWRSl7XG4gIC8vIDI1LjQuMy4xIFByb21pc2UoZXhlY3V0b3IpXG4gICRQcm9taXNlID0gZnVuY3Rpb24gUHJvbWlzZShleGVjdXRvcil7XG4gICAgYW5JbnN0YW5jZSh0aGlzLCAkUHJvbWlzZSwgUFJPTUlTRSwgJ19oJyk7XG4gICAgYUZ1bmN0aW9uKGV4ZWN1dG9yKTtcbiAgICBJbnRlcm5hbC5jYWxsKHRoaXMpO1xuICAgIHRyeSB7XG4gICAgICBleGVjdXRvcihjdHgoJHJlc29sdmUsIHRoaXMsIDEpLCBjdHgoJHJlamVjdCwgdGhpcywgMSkpO1xuICAgIH0gY2F0Y2goZXJyKXtcbiAgICAgICRyZWplY3QuY2FsbCh0aGlzLCBlcnIpO1xuICAgIH1cbiAgfTtcbiAgSW50ZXJuYWwgPSBmdW5jdGlvbiBQcm9taXNlKGV4ZWN1dG9yKXtcbiAgICB0aGlzLl9jID0gW107ICAgICAgICAgICAgIC8vIDwtIGF3YWl0aW5nIHJlYWN0aW9uc1xuICAgIHRoaXMuX2EgPSB1bmRlZmluZWQ7ICAgICAgLy8gPC0gY2hlY2tlZCBpbiBpc1VuaGFuZGxlZCByZWFjdGlvbnNcbiAgICB0aGlzLl9zID0gMDsgICAgICAgICAgICAgIC8vIDwtIHN0YXRlXG4gICAgdGhpcy5fZCA9IGZhbHNlOyAgICAgICAgICAvLyA8LSBkb25lXG4gICAgdGhpcy5fdiA9IHVuZGVmaW5lZDsgICAgICAvLyA8LSB2YWx1ZVxuICAgIHRoaXMuX2ggPSAwOyAgICAgICAgICAgICAgLy8gPC0gcmVqZWN0aW9uIHN0YXRlLCAwIC0gZGVmYXVsdCwgMSAtIGhhbmRsZWQsIDIgLSB1bmhhbmRsZWRcbiAgICB0aGlzLl9uID0gZmFsc2U7ICAgICAgICAgIC8vIDwtIG5vdGlmeVxuICB9O1xuICBJbnRlcm5hbC5wcm90b3R5cGUgPSByZXF1aXJlKDk0KSgkUHJvbWlzZS5wcm90b3R5cGUsIHtcbiAgICAvLyAyNS40LjUuMyBQcm9taXNlLnByb3RvdHlwZS50aGVuKG9uRnVsZmlsbGVkLCBvblJlamVjdGVkKVxuICAgIHRoZW46IGZ1bmN0aW9uIHRoZW4ob25GdWxmaWxsZWQsIG9uUmVqZWN0ZWQpe1xuICAgICAgdmFyIHJlYWN0aW9uICAgID0gbmV3UHJvbWlzZUNhcGFiaWxpdHkoc3BlY2llc0NvbnN0cnVjdG9yKHRoaXMsICRQcm9taXNlKSk7XG4gICAgICByZWFjdGlvbi5vayAgICAgPSB0eXBlb2Ygb25GdWxmaWxsZWQgPT0gJ2Z1bmN0aW9uJyA/IG9uRnVsZmlsbGVkIDogdHJ1ZTtcbiAgICAgIHJlYWN0aW9uLmZhaWwgICA9IHR5cGVvZiBvblJlamVjdGVkID09ICdmdW5jdGlvbicgJiYgb25SZWplY3RlZDtcbiAgICAgIHJlYWN0aW9uLmRvbWFpbiA9IGlzTm9kZSA/IHByb2Nlc3MuZG9tYWluIDogdW5kZWZpbmVkO1xuICAgICAgdGhpcy5fYy5wdXNoKHJlYWN0aW9uKTtcbiAgICAgIGlmKHRoaXMuX2EpdGhpcy5fYS5wdXNoKHJlYWN0aW9uKTtcbiAgICAgIGlmKHRoaXMuX3Mpbm90aWZ5KHRoaXMsIGZhbHNlKTtcbiAgICAgIHJldHVybiByZWFjdGlvbi5wcm9taXNlO1xuICAgIH0sXG4gICAgLy8gMjUuNC41LjEgUHJvbWlzZS5wcm90b3R5cGUuY2F0Y2gob25SZWplY3RlZClcbiAgICAnY2F0Y2gnOiBmdW5jdGlvbihvblJlamVjdGVkKXtcbiAgICAgIHJldHVybiB0aGlzLnRoZW4odW5kZWZpbmVkLCBvblJlamVjdGVkKTtcbiAgICB9XG4gIH0pO1xuICBQcm9taXNlQ2FwYWJpbGl0eSA9IGZ1bmN0aW9uKCl7XG4gICAgdmFyIHByb21pc2UgID0gbmV3IEludGVybmFsO1xuICAgIHRoaXMucHJvbWlzZSA9IHByb21pc2U7XG4gICAgdGhpcy5yZXNvbHZlID0gY3R4KCRyZXNvbHZlLCBwcm9taXNlLCAxKTtcbiAgICB0aGlzLnJlamVjdCAgPSBjdHgoJHJlamVjdCwgcHJvbWlzZSwgMSk7XG4gIH07XG59XG5cbiRleHBvcnQoJGV4cG9ydC5HICsgJGV4cG9ydC5XICsgJGV4cG9ydC5GICogIVVTRV9OQVRJVkUsIHtQcm9taXNlOiAkUHJvbWlzZX0pO1xucmVxdWlyZSg5OCkoJFByb21pc2UsIFBST01JU0UpO1xucmVxdWlyZSg5NykoUFJPTUlTRSk7XG5XcmFwcGVyID0gcmVxdWlyZSg1MClbUFJPTUlTRV07XG5cbi8vIHN0YXRpY3NcbiRleHBvcnQoJGV4cG9ydC5TICsgJGV4cG9ydC5GICogIVVTRV9OQVRJVkUsIFBST01JU0UsIHtcbiAgLy8gMjUuNC40LjUgUHJvbWlzZS5yZWplY3QocilcbiAgcmVqZWN0OiBmdW5jdGlvbiByZWplY3Qocil7XG4gICAgdmFyIGNhcGFiaWxpdHkgPSBuZXdQcm9taXNlQ2FwYWJpbGl0eSh0aGlzKVxuICAgICAgLCAkJHJlamVjdCAgID0gY2FwYWJpbGl0eS5yZWplY3Q7XG4gICAgJCRyZWplY3Qocik7XG4gICAgcmV0dXJuIGNhcGFiaWxpdHkucHJvbWlzZTtcbiAgfVxufSk7XG4kZXhwb3J0KCRleHBvcnQuUyArICRleHBvcnQuRiAqIChMSUJSQVJZIHx8ICFVU0VfTkFUSVZFKSwgUFJPTUlTRSwge1xuICAvLyAyNS40LjQuNiBQcm9taXNlLnJlc29sdmUoeClcbiAgcmVzb2x2ZTogZnVuY3Rpb24gcmVzb2x2ZSh4KXtcbiAgICAvLyBpbnN0YW5jZW9mIGluc3RlYWQgb2YgaW50ZXJuYWwgc2xvdCBjaGVjayBiZWNhdXNlIHdlIHNob3VsZCBmaXggaXQgd2l0aG91dCByZXBsYWNlbWVudCBuYXRpdmUgUHJvbWlzZSBjb3JlXG4gICAgaWYoeCBpbnN0YW5jZW9mICRQcm9taXNlICYmIHNhbWVDb25zdHJ1Y3Rvcih4LmNvbnN0cnVjdG9yLCB0aGlzKSlyZXR1cm4geDtcbiAgICB2YXIgY2FwYWJpbGl0eSA9IG5ld1Byb21pc2VDYXBhYmlsaXR5KHRoaXMpXG4gICAgICAsICQkcmVzb2x2ZSAgPSBjYXBhYmlsaXR5LnJlc29sdmU7XG4gICAgJCRyZXNvbHZlKHgpO1xuICAgIHJldHVybiBjYXBhYmlsaXR5LnByb21pc2U7XG4gIH1cbn0pO1xuJGV4cG9ydCgkZXhwb3J0LlMgKyAkZXhwb3J0LkYgKiAhKFVTRV9OQVRJVkUgJiYgcmVxdWlyZSg3MykoZnVuY3Rpb24oaXRlcil7XG4gICRQcm9taXNlLmFsbChpdGVyKVsnY2F0Y2gnXShlbXB0eSk7XG59KSksIFBST01JU0UsIHtcbiAgLy8gMjUuNC40LjEgUHJvbWlzZS5hbGwoaXRlcmFibGUpXG4gIGFsbDogZnVuY3Rpb24gYWxsKGl0ZXJhYmxlKXtcbiAgICB2YXIgQyAgICAgICAgICA9IHRoaXNcbiAgICAgICwgY2FwYWJpbGl0eSA9IG5ld1Byb21pc2VDYXBhYmlsaXR5KEMpXG4gICAgICAsIHJlc29sdmUgICAgPSBjYXBhYmlsaXR5LnJlc29sdmVcbiAgICAgICwgcmVqZWN0ICAgICA9IGNhcGFiaWxpdHkucmVqZWN0O1xuICAgIHZhciBhYnJ1cHQgPSBwZXJmb3JtKGZ1bmN0aW9uKCl7XG4gICAgICB2YXIgdmFsdWVzICAgID0gW11cbiAgICAgICAgLCBpbmRleCAgICAgPSAwXG4gICAgICAgICwgcmVtYWluaW5nID0gMTtcbiAgICAgIGZvck9mKGl0ZXJhYmxlLCBmYWxzZSwgZnVuY3Rpb24ocHJvbWlzZSl7XG4gICAgICAgIHZhciAkaW5kZXggICAgICAgID0gaW5kZXgrK1xuICAgICAgICAgICwgYWxyZWFkeUNhbGxlZCA9IGZhbHNlO1xuICAgICAgICB2YWx1ZXMucHVzaCh1bmRlZmluZWQpO1xuICAgICAgICByZW1haW5pbmcrKztcbiAgICAgICAgQy5yZXNvbHZlKHByb21pc2UpLnRoZW4oZnVuY3Rpb24odmFsdWUpe1xuICAgICAgICAgIGlmKGFscmVhZHlDYWxsZWQpcmV0dXJuO1xuICAgICAgICAgIGFscmVhZHlDYWxsZWQgID0gdHJ1ZTtcbiAgICAgICAgICB2YWx1ZXNbJGluZGV4XSA9IHZhbHVlO1xuICAgICAgICAgIC0tcmVtYWluaW5nIHx8IHJlc29sdmUodmFsdWVzKTtcbiAgICAgICAgfSwgcmVqZWN0KTtcbiAgICAgIH0pO1xuICAgICAgLS1yZW1haW5pbmcgfHwgcmVzb2x2ZSh2YWx1ZXMpO1xuICAgIH0pO1xuICAgIGlmKGFicnVwdClyZWplY3QoYWJydXB0LmVycm9yKTtcbiAgICByZXR1cm4gY2FwYWJpbGl0eS5wcm9taXNlO1xuICB9LFxuICAvLyAyNS40LjQuNCBQcm9taXNlLnJhY2UoaXRlcmFibGUpXG4gIHJhY2U6IGZ1bmN0aW9uIHJhY2UoaXRlcmFibGUpe1xuICAgIHZhciBDICAgICAgICAgID0gdGhpc1xuICAgICAgLCBjYXBhYmlsaXR5ID0gbmV3UHJvbWlzZUNhcGFiaWxpdHkoQylcbiAgICAgICwgcmVqZWN0ICAgICA9IGNhcGFiaWxpdHkucmVqZWN0O1xuICAgIHZhciBhYnJ1cHQgPSBwZXJmb3JtKGZ1bmN0aW9uKCl7XG4gICAgICBmb3JPZihpdGVyYWJsZSwgZmFsc2UsIGZ1bmN0aW9uKHByb21pc2Upe1xuICAgICAgICBDLnJlc29sdmUocHJvbWlzZSkudGhlbihjYXBhYmlsaXR5LnJlc29sdmUsIHJlamVjdCk7XG4gICAgICB9KTtcbiAgICB9KTtcbiAgICBpZihhYnJ1cHQpcmVqZWN0KGFicnVwdC5lcnJvcik7XG4gICAgcmV0dXJuIGNhcGFiaWxpdHkucHJvbWlzZTtcbiAgfVxufSk7XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xuJ3VzZSBzdHJpY3QnO1xudmFyICRhdCAgPSByZXF1aXJlKDEwMikodHJ1ZSk7XG5cbi8vIDIxLjEuMy4yNyBTdHJpbmcucHJvdG90eXBlW0BAaXRlcmF0b3JdKClcbnJlcXVpcmUoNzIpKFN0cmluZywgJ1N0cmluZycsIGZ1bmN0aW9uKGl0ZXJhdGVkKXtcbiAgdGhpcy5fdCA9IFN0cmluZyhpdGVyYXRlZCk7IC8vIHRhcmdldFxuICB0aGlzLl9pID0gMDsgICAgICAgICAgICAgICAgLy8gbmV4dCBpbmRleFxuLy8gMjEuMS41LjIuMSAlU3RyaW5nSXRlcmF0b3JQcm90b3R5cGUlLm5leHQoKVxufSwgZnVuY3Rpb24oKXtcbiAgdmFyIE8gICAgID0gdGhpcy5fdFxuICAgICwgaW5kZXggPSB0aGlzLl9pXG4gICAgLCBwb2ludDtcbiAgaWYoaW5kZXggPj0gTy5sZW5ndGgpcmV0dXJuIHt2YWx1ZTogdW5kZWZpbmVkLCBkb25lOiB0cnVlfTtcbiAgcG9pbnQgPSAkYXQoTywgaW5kZXgpO1xuICB0aGlzLl9pICs9IHBvaW50Lmxlbmd0aDtcbiAgcmV0dXJuIHt2YWx1ZTogcG9pbnQsIGRvbmU6IGZhbHNlfTtcbn0pO1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbid1c2Ugc3RyaWN0Jztcbi8vIEVDTUFTY3JpcHQgNiBzeW1ib2xzIHNoaW1cbnZhciBnbG9iYWwgICAgICAgICA9IHJlcXVpcmUoNjApXG4gICwgaGFzICAgICAgICAgICAgPSByZXF1aXJlKDYxKVxuICAsIERFU0NSSVBUT1JTICAgID0gcmVxdWlyZSg1MylcbiAgLCAkZXhwb3J0ICAgICAgICA9IHJlcXVpcmUoNTcpXG4gICwgcmVkZWZpbmUgICAgICAgPSByZXF1aXJlKDk1KVxuICAsIE1FVEEgICAgICAgICAgID0gcmVxdWlyZSg3OCkuS0VZXG4gICwgJGZhaWxzICAgICAgICAgPSByZXF1aXJlKDU4KVxuICAsIHNoYXJlZCAgICAgICAgID0gcmVxdWlyZSgxMDApXG4gICwgc2V0VG9TdHJpbmdUYWcgPSByZXF1aXJlKDk4KVxuICAsIHVpZCAgICAgICAgICAgID0gcmVxdWlyZSgxMTApXG4gICwgd2tzICAgICAgICAgICAgPSByZXF1aXJlKDExMylcbiAgLCB3a3NFeHQgICAgICAgICA9IHJlcXVpcmUoMTEyKVxuICAsIHdrc0RlZmluZSAgICAgID0gcmVxdWlyZSgxMTEpXG4gICwga2V5T2YgICAgICAgICAgPSByZXF1aXJlKDc2KVxuICAsIGVudW1LZXlzICAgICAgID0gcmVxdWlyZSg1NilcbiAgLCBpc0FycmF5ICAgICAgICA9IHJlcXVpcmUoNjgpXG4gICwgYW5PYmplY3QgICAgICAgPSByZXF1aXJlKDQ2KVxuICAsIHRvSU9iamVjdCAgICAgID0gcmVxdWlyZSgxMDYpXG4gICwgdG9QcmltaXRpdmUgICAgPSByZXF1aXJlKDEwOSlcbiAgLCBjcmVhdGVEZXNjICAgICA9IHJlcXVpcmUoOTMpXG4gICwgX2NyZWF0ZSAgICAgICAgPSByZXF1aXJlKDgxKVxuICAsIGdPUE5FeHQgICAgICAgID0gcmVxdWlyZSg4NSlcbiAgLCAkR09QRCAgICAgICAgICA9IHJlcXVpcmUoODQpXG4gICwgJERQICAgICAgICAgICAgPSByZXF1aXJlKDgyKVxuICAsICRrZXlzICAgICAgICAgID0gcmVxdWlyZSg5MClcbiAgLCBnT1BEICAgICAgICAgICA9ICRHT1BELmZcbiAgLCBkUCAgICAgICAgICAgICA9ICREUC5mXG4gICwgZ09QTiAgICAgICAgICAgPSBnT1BORXh0LmZcbiAgLCAkU3ltYm9sICAgICAgICA9IGdsb2JhbC5TeW1ib2xcbiAgLCAkSlNPTiAgICAgICAgICA9IGdsb2JhbC5KU09OXG4gICwgX3N0cmluZ2lmeSAgICAgPSAkSlNPTiAmJiAkSlNPTi5zdHJpbmdpZnlcbiAgLCBQUk9UT1RZUEUgICAgICA9ICdwcm90b3R5cGUnXG4gICwgSElEREVOICAgICAgICAgPSB3a3MoJ19oaWRkZW4nKVxuICAsIFRPX1BSSU1JVElWRSAgID0gd2tzKCd0b1ByaW1pdGl2ZScpXG4gICwgaXNFbnVtICAgICAgICAgPSB7fS5wcm9wZXJ0eUlzRW51bWVyYWJsZVxuICAsIFN5bWJvbFJlZ2lzdHJ5ID0gc2hhcmVkKCdzeW1ib2wtcmVnaXN0cnknKVxuICAsIEFsbFN5bWJvbHMgICAgID0gc2hhcmVkKCdzeW1ib2xzJylcbiAgLCBPUFN5bWJvbHMgICAgICA9IHNoYXJlZCgnb3Atc3ltYm9scycpXG4gICwgT2JqZWN0UHJvdG8gICAgPSBPYmplY3RbUFJPVE9UWVBFXVxuICAsIFVTRV9OQVRJVkUgICAgID0gdHlwZW9mICRTeW1ib2wgPT0gJ2Z1bmN0aW9uJ1xuICAsIFFPYmplY3QgICAgICAgID0gZ2xvYmFsLlFPYmplY3Q7XG4vLyBEb24ndCB1c2Ugc2V0dGVycyBpbiBRdCBTY3JpcHQsIGh0dHBzOi8vZ2l0aHViLmNvbS96bG9pcm9jay9jb3JlLWpzL2lzc3Vlcy8xNzNcbnZhciBzZXR0ZXIgPSAhUU9iamVjdCB8fCAhUU9iamVjdFtQUk9UT1RZUEVdIHx8ICFRT2JqZWN0W1BST1RPVFlQRV0uZmluZENoaWxkO1xuXG4vLyBmYWxsYmFjayBmb3Igb2xkIEFuZHJvaWQsIGh0dHBzOi8vY29kZS5nb29nbGUuY29tL3AvdjgvaXNzdWVzL2RldGFpbD9pZD02ODdcbnZhciBzZXRTeW1ib2xEZXNjID0gREVTQ1JJUFRPUlMgJiYgJGZhaWxzKGZ1bmN0aW9uKCl7XG4gIHJldHVybiBfY3JlYXRlKGRQKHt9LCAnYScsIHtcbiAgICBnZXQ6IGZ1bmN0aW9uKCl7IHJldHVybiBkUCh0aGlzLCAnYScsIHt2YWx1ZTogN30pLmE7IH1cbiAgfSkpLmEgIT0gNztcbn0pID8gZnVuY3Rpb24oaXQsIGtleSwgRCl7XG4gIHZhciBwcm90b0Rlc2MgPSBnT1BEKE9iamVjdFByb3RvLCBrZXkpO1xuICBpZihwcm90b0Rlc2MpZGVsZXRlIE9iamVjdFByb3RvW2tleV07XG4gIGRQKGl0LCBrZXksIEQpO1xuICBpZihwcm90b0Rlc2MgJiYgaXQgIT09IE9iamVjdFByb3RvKWRQKE9iamVjdFByb3RvLCBrZXksIHByb3RvRGVzYyk7XG59IDogZFA7XG5cbnZhciB3cmFwID0gZnVuY3Rpb24odGFnKXtcbiAgdmFyIHN5bSA9IEFsbFN5bWJvbHNbdGFnXSA9IF9jcmVhdGUoJFN5bWJvbFtQUk9UT1RZUEVdKTtcbiAgc3ltLl9rID0gdGFnO1xuICByZXR1cm4gc3ltO1xufTtcblxudmFyIGlzU3ltYm9sID0gVVNFX05BVElWRSAmJiB0eXBlb2YgJFN5bWJvbC5pdGVyYXRvciA9PSAnc3ltYm9sJyA/IGZ1bmN0aW9uKGl0KXtcbiAgcmV0dXJuIHR5cGVvZiBpdCA9PSAnc3ltYm9sJztcbn0gOiBmdW5jdGlvbihpdCl7XG4gIHJldHVybiBpdCBpbnN0YW5jZW9mICRTeW1ib2w7XG59O1xuXG52YXIgJGRlZmluZVByb3BlcnR5ID0gZnVuY3Rpb24gZGVmaW5lUHJvcGVydHkoaXQsIGtleSwgRCl7XG4gIGlmKGl0ID09PSBPYmplY3RQcm90bykkZGVmaW5lUHJvcGVydHkoT1BTeW1ib2xzLCBrZXksIEQpO1xuICBhbk9iamVjdChpdCk7XG4gIGtleSA9IHRvUHJpbWl0aXZlKGtleSwgdHJ1ZSk7XG4gIGFuT2JqZWN0KEQpO1xuICBpZihoYXMoQWxsU3ltYm9scywga2V5KSl7XG4gICAgaWYoIUQuZW51bWVyYWJsZSl7XG4gICAgICBpZighaGFzKGl0LCBISURERU4pKWRQKGl0LCBISURERU4sIGNyZWF0ZURlc2MoMSwge30pKTtcbiAgICAgIGl0W0hJRERFTl1ba2V5XSA9IHRydWU7XG4gICAgfSBlbHNlIHtcbiAgICAgIGlmKGhhcyhpdCwgSElEREVOKSAmJiBpdFtISURERU5dW2tleV0paXRbSElEREVOXVtrZXldID0gZmFsc2U7XG4gICAgICBEID0gX2NyZWF0ZShELCB7ZW51bWVyYWJsZTogY3JlYXRlRGVzYygwLCBmYWxzZSl9KTtcbiAgICB9IHJldHVybiBzZXRTeW1ib2xEZXNjKGl0LCBrZXksIEQpO1xuICB9IHJldHVybiBkUChpdCwga2V5LCBEKTtcbn07XG52YXIgJGRlZmluZVByb3BlcnRpZXMgPSBmdW5jdGlvbiBkZWZpbmVQcm9wZXJ0aWVzKGl0LCBQKXtcbiAgYW5PYmplY3QoaXQpO1xuICB2YXIga2V5cyA9IGVudW1LZXlzKFAgPSB0b0lPYmplY3QoUCkpXG4gICAgLCBpICAgID0gMFxuICAgICwgbCA9IGtleXMubGVuZ3RoXG4gICAgLCBrZXk7XG4gIHdoaWxlKGwgPiBpKSRkZWZpbmVQcm9wZXJ0eShpdCwga2V5ID0ga2V5c1tpKytdLCBQW2tleV0pO1xuICByZXR1cm4gaXQ7XG59O1xudmFyICRjcmVhdGUgPSBmdW5jdGlvbiBjcmVhdGUoaXQsIFApe1xuICByZXR1cm4gUCA9PT0gdW5kZWZpbmVkID8gX2NyZWF0ZShpdCkgOiAkZGVmaW5lUHJvcGVydGllcyhfY3JlYXRlKGl0KSwgUCk7XG59O1xudmFyICRwcm9wZXJ0eUlzRW51bWVyYWJsZSA9IGZ1bmN0aW9uIHByb3BlcnR5SXNFbnVtZXJhYmxlKGtleSl7XG4gIHZhciBFID0gaXNFbnVtLmNhbGwodGhpcywga2V5ID0gdG9QcmltaXRpdmUoa2V5LCB0cnVlKSk7XG4gIGlmKHRoaXMgPT09IE9iamVjdFByb3RvICYmIGhhcyhBbGxTeW1ib2xzLCBrZXkpICYmICFoYXMoT1BTeW1ib2xzLCBrZXkpKXJldHVybiBmYWxzZTtcbiAgcmV0dXJuIEUgfHwgIWhhcyh0aGlzLCBrZXkpIHx8ICFoYXMoQWxsU3ltYm9scywga2V5KSB8fCBoYXModGhpcywgSElEREVOKSAmJiB0aGlzW0hJRERFTl1ba2V5XSA/IEUgOiB0cnVlO1xufTtcbnZhciAkZ2V0T3duUHJvcGVydHlEZXNjcmlwdG9yID0gZnVuY3Rpb24gZ2V0T3duUHJvcGVydHlEZXNjcmlwdG9yKGl0LCBrZXkpe1xuICBpdCAgPSB0b0lPYmplY3QoaXQpO1xuICBrZXkgPSB0b1ByaW1pdGl2ZShrZXksIHRydWUpO1xuICBpZihpdCA9PT0gT2JqZWN0UHJvdG8gJiYgaGFzKEFsbFN5bWJvbHMsIGtleSkgJiYgIWhhcyhPUFN5bWJvbHMsIGtleSkpcmV0dXJuO1xuICB2YXIgRCA9IGdPUEQoaXQsIGtleSk7XG4gIGlmKEQgJiYgaGFzKEFsbFN5bWJvbHMsIGtleSkgJiYgIShoYXMoaXQsIEhJRERFTikgJiYgaXRbSElEREVOXVtrZXldKSlELmVudW1lcmFibGUgPSB0cnVlO1xuICByZXR1cm4gRDtcbn07XG52YXIgJGdldE93blByb3BlcnR5TmFtZXMgPSBmdW5jdGlvbiBnZXRPd25Qcm9wZXJ0eU5hbWVzKGl0KXtcbiAgdmFyIG5hbWVzICA9IGdPUE4odG9JT2JqZWN0KGl0KSlcbiAgICAsIHJlc3VsdCA9IFtdXG4gICAgLCBpICAgICAgPSAwXG4gICAgLCBrZXk7XG4gIHdoaWxlKG5hbWVzLmxlbmd0aCA+IGkpe1xuICAgIGlmKCFoYXMoQWxsU3ltYm9scywga2V5ID0gbmFtZXNbaSsrXSkgJiYga2V5ICE9IEhJRERFTiAmJiBrZXkgIT0gTUVUQSlyZXN1bHQucHVzaChrZXkpO1xuICB9IHJldHVybiByZXN1bHQ7XG59O1xudmFyICRnZXRPd25Qcm9wZXJ0eVN5bWJvbHMgPSBmdW5jdGlvbiBnZXRPd25Qcm9wZXJ0eVN5bWJvbHMoaXQpe1xuICB2YXIgSVNfT1AgID0gaXQgPT09IE9iamVjdFByb3RvXG4gICAgLCBuYW1lcyAgPSBnT1BOKElTX09QID8gT1BTeW1ib2xzIDogdG9JT2JqZWN0KGl0KSlcbiAgICAsIHJlc3VsdCA9IFtdXG4gICAgLCBpICAgICAgPSAwXG4gICAgLCBrZXk7XG4gIHdoaWxlKG5hbWVzLmxlbmd0aCA+IGkpe1xuICAgIGlmKGhhcyhBbGxTeW1ib2xzLCBrZXkgPSBuYW1lc1tpKytdKSAmJiAoSVNfT1AgPyBoYXMoT2JqZWN0UHJvdG8sIGtleSkgOiB0cnVlKSlyZXN1bHQucHVzaChBbGxTeW1ib2xzW2tleV0pO1xuICB9IHJldHVybiByZXN1bHQ7XG59O1xuXG4vLyAxOS40LjEuMSBTeW1ib2woW2Rlc2NyaXB0aW9uXSlcbmlmKCFVU0VfTkFUSVZFKXtcbiAgJFN5bWJvbCA9IGZ1bmN0aW9uIFN5bWJvbCgpe1xuICAgIGlmKHRoaXMgaW5zdGFuY2VvZiAkU3ltYm9sKXRocm93IFR5cGVFcnJvcignU3ltYm9sIGlzIG5vdCBhIGNvbnN0cnVjdG9yIScpO1xuICAgIHZhciB0YWcgPSB1aWQoYXJndW1lbnRzLmxlbmd0aCA+IDAgPyBhcmd1bWVudHNbMF0gOiB1bmRlZmluZWQpO1xuICAgIHZhciAkc2V0ID0gZnVuY3Rpb24odmFsdWUpe1xuICAgICAgaWYodGhpcyA9PT0gT2JqZWN0UHJvdG8pJHNldC5jYWxsKE9QU3ltYm9scywgdmFsdWUpO1xuICAgICAgaWYoaGFzKHRoaXMsIEhJRERFTikgJiYgaGFzKHRoaXNbSElEREVOXSwgdGFnKSl0aGlzW0hJRERFTl1bdGFnXSA9IGZhbHNlO1xuICAgICAgc2V0U3ltYm9sRGVzYyh0aGlzLCB0YWcsIGNyZWF0ZURlc2MoMSwgdmFsdWUpKTtcbiAgICB9O1xuICAgIGlmKERFU0NSSVBUT1JTICYmIHNldHRlcilzZXRTeW1ib2xEZXNjKE9iamVjdFByb3RvLCB0YWcsIHtjb25maWd1cmFibGU6IHRydWUsIHNldDogJHNldH0pO1xuICAgIHJldHVybiB3cmFwKHRhZyk7XG4gIH07XG4gIHJlZGVmaW5lKCRTeW1ib2xbUFJPVE9UWVBFXSwgJ3RvU3RyaW5nJywgZnVuY3Rpb24gdG9TdHJpbmcoKXtcbiAgICByZXR1cm4gdGhpcy5faztcbiAgfSk7XG5cbiAgJEdPUEQuZiA9ICRnZXRPd25Qcm9wZXJ0eURlc2NyaXB0b3I7XG4gICREUC5mICAgPSAkZGVmaW5lUHJvcGVydHk7XG4gIHJlcXVpcmUoODYpLmYgPSBnT1BORXh0LmYgPSAkZ2V0T3duUHJvcGVydHlOYW1lcztcbiAgcmVxdWlyZSg5MSkuZiAgPSAkcHJvcGVydHlJc0VudW1lcmFibGU7XG4gIHJlcXVpcmUoODcpLmYgPSAkZ2V0T3duUHJvcGVydHlTeW1ib2xzO1xuXG4gIGlmKERFU0NSSVBUT1JTICYmICFyZXF1aXJlKDc3KSl7XG4gICAgcmVkZWZpbmUoT2JqZWN0UHJvdG8sICdwcm9wZXJ0eUlzRW51bWVyYWJsZScsICRwcm9wZXJ0eUlzRW51bWVyYWJsZSwgdHJ1ZSk7XG4gIH1cblxuICB3a3NFeHQuZiA9IGZ1bmN0aW9uKG5hbWUpe1xuICAgIHJldHVybiB3cmFwKHdrcyhuYW1lKSk7XG4gIH1cbn1cblxuJGV4cG9ydCgkZXhwb3J0LkcgKyAkZXhwb3J0LlcgKyAkZXhwb3J0LkYgKiAhVVNFX05BVElWRSwge1N5bWJvbDogJFN5bWJvbH0pO1xuXG5mb3IodmFyIHN5bWJvbHMgPSAoXG4gIC8vIDE5LjQuMi4yLCAxOS40LjIuMywgMTkuNC4yLjQsIDE5LjQuMi42LCAxOS40LjIuOCwgMTkuNC4yLjksIDE5LjQuMi4xMCwgMTkuNC4yLjExLCAxOS40LjIuMTIsIDE5LjQuMi4xMywgMTkuNC4yLjE0XG4gICdoYXNJbnN0YW5jZSxpc0NvbmNhdFNwcmVhZGFibGUsaXRlcmF0b3IsbWF0Y2gscmVwbGFjZSxzZWFyY2gsc3BlY2llcyxzcGxpdCx0b1ByaW1pdGl2ZSx0b1N0cmluZ1RhZyx1bnNjb3BhYmxlcydcbikuc3BsaXQoJywnKSwgaSA9IDA7IHN5bWJvbHMubGVuZ3RoID4gaTsgKXdrcyhzeW1ib2xzW2krK10pO1xuXG5mb3IodmFyIHN5bWJvbHMgPSAka2V5cyh3a3Muc3RvcmUpLCBpID0gMDsgc3ltYm9scy5sZW5ndGggPiBpOyApd2tzRGVmaW5lKHN5bWJvbHNbaSsrXSk7XG5cbiRleHBvcnQoJGV4cG9ydC5TICsgJGV4cG9ydC5GICogIVVTRV9OQVRJVkUsICdTeW1ib2wnLCB7XG4gIC8vIDE5LjQuMi4xIFN5bWJvbC5mb3Ioa2V5KVxuICAnZm9yJzogZnVuY3Rpb24oa2V5KXtcbiAgICByZXR1cm4gaGFzKFN5bWJvbFJlZ2lzdHJ5LCBrZXkgKz0gJycpXG4gICAgICA/IFN5bWJvbFJlZ2lzdHJ5W2tleV1cbiAgICAgIDogU3ltYm9sUmVnaXN0cnlba2V5XSA9ICRTeW1ib2woa2V5KTtcbiAgfSxcbiAgLy8gMTkuNC4yLjUgU3ltYm9sLmtleUZvcihzeW0pXG4gIGtleUZvcjogZnVuY3Rpb24ga2V5Rm9yKGtleSl7XG4gICAgaWYoaXNTeW1ib2woa2V5KSlyZXR1cm4ga2V5T2YoU3ltYm9sUmVnaXN0cnksIGtleSk7XG4gICAgdGhyb3cgVHlwZUVycm9yKGtleSArICcgaXMgbm90IGEgc3ltYm9sIScpO1xuICB9LFxuICB1c2VTZXR0ZXI6IGZ1bmN0aW9uKCl7IHNldHRlciA9IHRydWU7IH0sXG4gIHVzZVNpbXBsZTogZnVuY3Rpb24oKXsgc2V0dGVyID0gZmFsc2U7IH1cbn0pO1xuXG4kZXhwb3J0KCRleHBvcnQuUyArICRleHBvcnQuRiAqICFVU0VfTkFUSVZFLCAnT2JqZWN0Jywge1xuICAvLyAxOS4xLjIuMiBPYmplY3QuY3JlYXRlKE8gWywgUHJvcGVydGllc10pXG4gIGNyZWF0ZTogJGNyZWF0ZSxcbiAgLy8gMTkuMS4yLjQgT2JqZWN0LmRlZmluZVByb3BlcnR5KE8sIFAsIEF0dHJpYnV0ZXMpXG4gIGRlZmluZVByb3BlcnR5OiAkZGVmaW5lUHJvcGVydHksXG4gIC8vIDE5LjEuMi4zIE9iamVjdC5kZWZpbmVQcm9wZXJ0aWVzKE8sIFByb3BlcnRpZXMpXG4gIGRlZmluZVByb3BlcnRpZXM6ICRkZWZpbmVQcm9wZXJ0aWVzLFxuICAvLyAxOS4xLjIuNiBPYmplY3QuZ2V0T3duUHJvcGVydHlEZXNjcmlwdG9yKE8sIFApXG4gIGdldE93blByb3BlcnR5RGVzY3JpcHRvcjogJGdldE93blByb3BlcnR5RGVzY3JpcHRvcixcbiAgLy8gMTkuMS4yLjcgT2JqZWN0LmdldE93blByb3BlcnR5TmFtZXMoTylcbiAgZ2V0T3duUHJvcGVydHlOYW1lczogJGdldE93blByb3BlcnR5TmFtZXMsXG4gIC8vIDE5LjEuMi44IE9iamVjdC5nZXRPd25Qcm9wZXJ0eVN5bWJvbHMoTylcbiAgZ2V0T3duUHJvcGVydHlTeW1ib2xzOiAkZ2V0T3duUHJvcGVydHlTeW1ib2xzXG59KTtcblxuLy8gMjQuMy4yIEpTT04uc3RyaW5naWZ5KHZhbHVlIFssIHJlcGxhY2VyIFssIHNwYWNlXV0pXG4kSlNPTiAmJiAkZXhwb3J0KCRleHBvcnQuUyArICRleHBvcnQuRiAqICghVVNFX05BVElWRSB8fCAkZmFpbHMoZnVuY3Rpb24oKXtcbiAgdmFyIFMgPSAkU3ltYm9sKCk7XG4gIC8vIE1TIEVkZ2UgY29udmVydHMgc3ltYm9sIHZhbHVlcyB0byBKU09OIGFzIHt9XG4gIC8vIFdlYktpdCBjb252ZXJ0cyBzeW1ib2wgdmFsdWVzIHRvIEpTT04gYXMgbnVsbFxuICAvLyBWOCB0aHJvd3Mgb24gYm94ZWQgc3ltYm9sc1xuICByZXR1cm4gX3N0cmluZ2lmeShbU10pICE9ICdbbnVsbF0nIHx8IF9zdHJpbmdpZnkoe2E6IFN9KSAhPSAne30nIHx8IF9zdHJpbmdpZnkoT2JqZWN0KFMpKSAhPSAne30nO1xufSkpLCAnSlNPTicsIHtcbiAgc3RyaW5naWZ5OiBmdW5jdGlvbiBzdHJpbmdpZnkoaXQpe1xuICAgIGlmKGl0ID09PSB1bmRlZmluZWQgfHwgaXNTeW1ib2woaXQpKXJldHVybjsgLy8gSUU4IHJldHVybnMgc3RyaW5nIG9uIHVuZGVmaW5lZFxuICAgIHZhciBhcmdzID0gW2l0XVxuICAgICAgLCBpICAgID0gMVxuICAgICAgLCByZXBsYWNlciwgJHJlcGxhY2VyO1xuICAgIHdoaWxlKGFyZ3VtZW50cy5sZW5ndGggPiBpKWFyZ3MucHVzaChhcmd1bWVudHNbaSsrXSk7XG4gICAgcmVwbGFjZXIgPSBhcmdzWzFdO1xuICAgIGlmKHR5cGVvZiByZXBsYWNlciA9PSAnZnVuY3Rpb24nKSRyZXBsYWNlciA9IHJlcGxhY2VyO1xuICAgIGlmKCRyZXBsYWNlciB8fCAhaXNBcnJheShyZXBsYWNlcikpcmVwbGFjZXIgPSBmdW5jdGlvbihrZXksIHZhbHVlKXtcbiAgICAgIGlmKCRyZXBsYWNlcil2YWx1ZSA9ICRyZXBsYWNlci5jYWxsKHRoaXMsIGtleSwgdmFsdWUpO1xuICAgICAgaWYoIWlzU3ltYm9sKHZhbHVlKSlyZXR1cm4gdmFsdWU7XG4gICAgfTtcbiAgICBhcmdzWzFdID0gcmVwbGFjZXI7XG4gICAgcmV0dXJuIF9zdHJpbmdpZnkuYXBwbHkoJEpTT04sIGFyZ3MpO1xuICB9XG59KTtcblxuLy8gMTkuNC4zLjQgU3ltYm9sLnByb3RvdHlwZVtAQHRvUHJpbWl0aXZlXShoaW50KVxuJFN5bWJvbFtQUk9UT1RZUEVdW1RPX1BSSU1JVElWRV0gfHwgcmVxdWlyZSg2MikoJFN5bWJvbFtQUk9UT1RZUEVdLCBUT19QUklNSVRJVkUsICRTeW1ib2xbUFJPVE9UWVBFXS52YWx1ZU9mKTtcbi8vIDE5LjQuMy41IFN5bWJvbC5wcm90b3R5cGVbQEB0b1N0cmluZ1RhZ11cbnNldFRvU3RyaW5nVGFnKCRTeW1ib2wsICdTeW1ib2wnKTtcbi8vIDIwLjIuMS45IE1hdGhbQEB0b1N0cmluZ1RhZ11cbnNldFRvU3RyaW5nVGFnKE1hdGgsICdNYXRoJywgdHJ1ZSk7XG4vLyAyNC4zLjMgSlNPTltAQHRvU3RyaW5nVGFnXVxuc2V0VG9TdHJpbmdUYWcoZ2xvYmFsLkpTT04sICdKU09OJywgdHJ1ZSk7XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xucmVxdWlyZSgxMTEpKCdhc3luY0l0ZXJhdG9yJyk7XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xucmVxdWlyZSgxMTEpKCdvYnNlcnZhYmxlJyk7XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xucmVxdWlyZSgxMTcpO1xudmFyIGdsb2JhbCAgICAgICAgPSByZXF1aXJlKDYwKVxuICAsIGhpZGUgICAgICAgICAgPSByZXF1aXJlKDYyKVxuICAsIEl0ZXJhdG9ycyAgICAgPSByZXF1aXJlKDc1KVxuICAsIFRPX1NUUklOR19UQUcgPSByZXF1aXJlKDExMykoJ3RvU3RyaW5nVGFnJyk7XG5cbmZvcih2YXIgY29sbGVjdGlvbnMgPSBbJ05vZGVMaXN0JywgJ0RPTVRva2VuTGlzdCcsICdNZWRpYUxpc3QnLCAnU3R5bGVTaGVldExpc3QnLCAnQ1NTUnVsZUxpc3QnXSwgaSA9IDA7IGkgPCA1OyBpKyspe1xuICB2YXIgTkFNRSAgICAgICA9IGNvbGxlY3Rpb25zW2ldXG4gICAgLCBDb2xsZWN0aW9uID0gZ2xvYmFsW05BTUVdXG4gICAgLCBwcm90byAgICAgID0gQ29sbGVjdGlvbiAmJiBDb2xsZWN0aW9uLnByb3RvdHlwZTtcbiAgaWYocHJvdG8gJiYgIXByb3RvW1RPX1NUUklOR19UQUddKWhpZGUocHJvdG8sIFRPX1NUUklOR19UQUcsIE5BTUUpO1xuICBJdGVyYXRvcnNbTkFNRV0gPSBJdGVyYXRvcnMuQXJyYXk7XG59XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xuLyoqXG4gKiBDb2RlIHJlZmFjdG9yZWQgZnJvbSBNb3ppbGxhIERldmVsb3BlciBOZXR3b3JrOlxuICogaHR0cHM6Ly9kZXZlbG9wZXIubW96aWxsYS5vcmcvZW4tVVMvZG9jcy9XZWIvSmF2YVNjcmlwdC9SZWZlcmVuY2UvR2xvYmFsX09iamVjdHMvT2JqZWN0L2Fzc2lnblxuICovXG5cbid1c2Ugc3RyaWN0JztcblxuZnVuY3Rpb24gYXNzaWduKHRhcmdldCwgZmlyc3RTb3VyY2UpIHtcbiAgaWYgKHRhcmdldCA9PT0gdW5kZWZpbmVkIHx8IHRhcmdldCA9PT0gbnVsbCkge1xuICAgIHRocm93IG5ldyBUeXBlRXJyb3IoJ0Nhbm5vdCBjb252ZXJ0IGZpcnN0IGFyZ3VtZW50IHRvIG9iamVjdCcpO1xuICB9XG5cbiAgdmFyIHRvID0gT2JqZWN0KHRhcmdldCk7XG4gIGZvciAodmFyIGkgPSAxOyBpIDwgYXJndW1lbnRzLmxlbmd0aDsgaSsrKSB7XG4gICAgdmFyIG5leHRTb3VyY2UgPSBhcmd1bWVudHNbaV07XG4gICAgaWYgKG5leHRTb3VyY2UgPT09IHVuZGVmaW5lZCB8fCBuZXh0U291cmNlID09PSBudWxsKSB7XG4gICAgICBjb250aW51ZTtcbiAgICB9XG5cbiAgICB2YXIga2V5c0FycmF5ID0gT2JqZWN0LmtleXMoT2JqZWN0KG5leHRTb3VyY2UpKTtcbiAgICBmb3IgKHZhciBuZXh0SW5kZXggPSAwLCBsZW4gPSBrZXlzQXJyYXkubGVuZ3RoOyBuZXh0SW5kZXggPCBsZW47IG5leHRJbmRleCsrKSB7XG4gICAgICB2YXIgbmV4dEtleSA9IGtleXNBcnJheVtuZXh0SW5kZXhdO1xuICAgICAgdmFyIGRlc2MgPSBPYmplY3QuZ2V0T3duUHJvcGVydHlEZXNjcmlwdG9yKG5leHRTb3VyY2UsIG5leHRLZXkpO1xuICAgICAgaWYgKGRlc2MgIT09IHVuZGVmaW5lZCAmJiBkZXNjLmVudW1lcmFibGUpIHtcbiAgICAgICAgdG9bbmV4dEtleV0gPSBuZXh0U291cmNlW25leHRLZXldO1xuICAgICAgfVxuICAgIH1cbiAgfVxuICByZXR1cm4gdG87XG59XG5cbmZ1bmN0aW9uIHBvbHlmaWxsKCkge1xuICBpZiAoIU9iamVjdC5hc3NpZ24pIHtcbiAgICBPYmplY3QuZGVmaW5lUHJvcGVydHkoT2JqZWN0LCAnYXNzaWduJywge1xuICAgICAgZW51bWVyYWJsZTogZmFsc2UsXG4gICAgICBjb25maWd1cmFibGU6IHRydWUsXG4gICAgICB3cml0YWJsZTogdHJ1ZSxcbiAgICAgIHZhbHVlOiBhc3NpZ25cbiAgICB9KTtcbiAgfVxufVxuXG5tb2R1bGUuZXhwb3J0cyA9IHtcbiAgYXNzaWduOiBhc3NpZ24sXG4gIHBvbHlmaWxsOiBwb2x5ZmlsbFxufTtcblxufSk7IiwicmVxdWlyZSgnL3Jvb3QvYXBwL25vZGVfbW9kdWxlcy9hc3luYy1kZWZpbmUvbGliL2FzeW5jRGVmaW5lLmpzJykoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4oZnVuY3Rpb24oZ2xvYmFsKXtcblxuLy9cbi8vIENoZWNrIGZvciBuYXRpdmUgUHJvbWlzZSBhbmQgaXQgaGFzIGNvcnJlY3QgaW50ZXJmYWNlXG4vL1xuXG52YXIgTmF0aXZlUHJvbWlzZSA9IGdsb2JhbFsnUHJvbWlzZSddO1xudmFyIG5hdGl2ZVByb21pc2VTdXBwb3J0ZWQgPVxuICBOYXRpdmVQcm9taXNlICYmXG4gIC8vIFNvbWUgb2YgdGhlc2UgbWV0aG9kcyBhcmUgbWlzc2luZyBmcm9tXG4gIC8vIEZpcmVmb3gvQ2hyb21lIGV4cGVyaW1lbnRhbCBpbXBsZW1lbnRhdGlvbnNcbiAgJ3Jlc29sdmUnIGluIE5hdGl2ZVByb21pc2UgJiZcbiAgJ3JlamVjdCcgaW4gTmF0aXZlUHJvbWlzZSAmJlxuICAnYWxsJyBpbiBOYXRpdmVQcm9taXNlICYmXG4gICdyYWNlJyBpbiBOYXRpdmVQcm9taXNlICYmXG4gIC8vIE9sZGVyIHZlcnNpb24gb2YgdGhlIHNwZWMgaGFkIGEgcmVzb2x2ZXIgb2JqZWN0XG4gIC8vIGFzIHRoZSBhcmcgcmF0aGVyIHRoYW4gYSBmdW5jdGlvblxuICAoZnVuY3Rpb24oKXtcbiAgICB2YXIgcmVzb2x2ZTtcbiAgICBuZXcgTmF0aXZlUHJvbWlzZShmdW5jdGlvbihyKXsgcmVzb2x2ZSA9IHI7IH0pO1xuICAgIHJldHVybiB0eXBlb2YgcmVzb2x2ZSA9PT0gJ2Z1bmN0aW9uJztcbiAgfSkoKTtcblxuXG4vL1xuLy8gZXhwb3J0IGlmIG5lY2Vzc2FyeVxuLy9cblxuaWYgKHR5cGVvZiBleHBvcnRzICE9PSAndW5kZWZpbmVkJyAmJiBleHBvcnRzKVxue1xuICAvLyBub2RlLmpzXG4gIGV4cG9ydHMuUHJvbWlzZSA9IG5hdGl2ZVByb21pc2VTdXBwb3J0ZWQgPyBOYXRpdmVQcm9taXNlIDogUHJvbWlzZTtcbiAgZXhwb3J0cy5Qb2x5ZmlsbCA9IFByb21pc2U7XG59XG5lbHNlXG57XG4gIC8vIEFNRFxuICBpZiAodHlwZW9mIGRlZmluZSA9PSAnZnVuY3Rpb24nICYmIGRlZmluZS5hbWQpXG4gIHtcbiAgICBkZWZpbmUoZnVuY3Rpb24oKXtcbiAgICAgIHJldHVybiBuYXRpdmVQcm9taXNlU3VwcG9ydGVkID8gTmF0aXZlUHJvbWlzZSA6IFByb21pc2U7XG4gICAgfSk7XG4gIH1cbiAgZWxzZVxuICB7XG4gICAgLy8gaW4gYnJvd3NlciBhZGQgdG8gZ2xvYmFsXG4gICAgaWYgKCFuYXRpdmVQcm9taXNlU3VwcG9ydGVkKVxuICAgICAgZ2xvYmFsWydQcm9taXNlJ10gPSBQcm9taXNlO1xuICB9XG59XG5cblxuLy9cbi8vIFBvbHlmaWxsXG4vL1xuXG52YXIgUEVORElORyA9ICdwZW5kaW5nJztcbnZhciBTRUFMRUQgPSAnc2VhbGVkJztcbnZhciBGVUxGSUxMRUQgPSAnZnVsZmlsbGVkJztcbnZhciBSRUpFQ1RFRCA9ICdyZWplY3RlZCc7XG52YXIgTk9PUCA9IGZ1bmN0aW9uKCl7fTtcblxuZnVuY3Rpb24gaXNBcnJheSh2YWx1ZSkge1xuICByZXR1cm4gT2JqZWN0LnByb3RvdHlwZS50b1N0cmluZy5jYWxsKHZhbHVlKSA9PT0gJ1tvYmplY3QgQXJyYXldJztcbn1cblxuLy8gYXN5bmMgY2FsbHNcbnZhciBhc3luY1NldFRpbWVyID0gdHlwZW9mIHNldEltbWVkaWF0ZSAhPT0gJ3VuZGVmaW5lZCcgPyBzZXRJbW1lZGlhdGUgOiBzZXRUaW1lb3V0O1xudmFyIGFzeW5jUXVldWUgPSBbXTtcbnZhciBhc3luY1RpbWVyO1xuXG5mdW5jdGlvbiBhc3luY0ZsdXNoKCl7XG4gIC8vIHJ1biBwcm9taXNlIGNhbGxiYWNrc1xuICBmb3IgKHZhciBpID0gMDsgaSA8IGFzeW5jUXVldWUubGVuZ3RoOyBpKyspXG4gICAgYXN5bmNRdWV1ZVtpXVswXShhc3luY1F1ZXVlW2ldWzFdKTtcblxuICAvLyByZXNldCBhc3luYyBhc3luY1F1ZXVlXG4gIGFzeW5jUXVldWUgPSBbXTtcbiAgYXN5bmNUaW1lciA9IGZhbHNlO1xufVxuXG5mdW5jdGlvbiBhc3luY0NhbGwoY2FsbGJhY2ssIGFyZyl7XG4gIGFzeW5jUXVldWUucHVzaChbY2FsbGJhY2ssIGFyZ10pO1xuXG4gIGlmICghYXN5bmNUaW1lcilcbiAge1xuICAgIGFzeW5jVGltZXIgPSB0cnVlO1xuICAgIGFzeW5jU2V0VGltZXIoYXN5bmNGbHVzaCwgMCk7XG4gIH1cbn1cblxuXG5mdW5jdGlvbiBpbnZva2VSZXNvbHZlcihyZXNvbHZlciwgcHJvbWlzZSkge1xuICBmdW5jdGlvbiByZXNvbHZlUHJvbWlzZSh2YWx1ZSkge1xuICAgIHJlc29sdmUocHJvbWlzZSwgdmFsdWUpO1xuICB9XG5cbiAgZnVuY3Rpb24gcmVqZWN0UHJvbWlzZShyZWFzb24pIHtcbiAgICByZWplY3QocHJvbWlzZSwgcmVhc29uKTtcbiAgfVxuXG4gIHRyeSB7XG4gICAgcmVzb2x2ZXIocmVzb2x2ZVByb21pc2UsIHJlamVjdFByb21pc2UpO1xuICB9IGNhdGNoKGUpIHtcbiAgICByZWplY3RQcm9taXNlKGUpO1xuICB9XG59XG5cbmZ1bmN0aW9uIGludm9rZUNhbGxiYWNrKHN1YnNjcmliZXIpe1xuICB2YXIgb3duZXIgPSBzdWJzY3JpYmVyLm93bmVyO1xuICB2YXIgc2V0dGxlZCA9IG93bmVyLnN0YXRlXztcbiAgdmFyIHZhbHVlID0gb3duZXIuZGF0YV87ICBcbiAgdmFyIGNhbGxiYWNrID0gc3Vic2NyaWJlcltzZXR0bGVkXTtcbiAgdmFyIHByb21pc2UgPSBzdWJzY3JpYmVyLnRoZW47XG5cbiAgaWYgKHR5cGVvZiBjYWxsYmFjayA9PT0gJ2Z1bmN0aW9uJylcbiAge1xuICAgIHNldHRsZWQgPSBGVUxGSUxMRUQ7XG4gICAgdHJ5IHtcbiAgICAgIHZhbHVlID0gY2FsbGJhY2sodmFsdWUpO1xuICAgIH0gY2F0Y2goZSkge1xuICAgICAgcmVqZWN0KHByb21pc2UsIGUpO1xuICAgIH1cbiAgfVxuXG4gIGlmICghaGFuZGxlVGhlbmFibGUocHJvbWlzZSwgdmFsdWUpKVxuICB7XG4gICAgaWYgKHNldHRsZWQgPT09IEZVTEZJTExFRClcbiAgICAgIHJlc29sdmUocHJvbWlzZSwgdmFsdWUpO1xuXG4gICAgaWYgKHNldHRsZWQgPT09IFJFSkVDVEVEKVxuICAgICAgcmVqZWN0KHByb21pc2UsIHZhbHVlKTtcbiAgfVxufVxuXG5mdW5jdGlvbiBoYW5kbGVUaGVuYWJsZShwcm9taXNlLCB2YWx1ZSkge1xuICB2YXIgcmVzb2x2ZWQ7XG5cbiAgdHJ5IHtcbiAgICBpZiAocHJvbWlzZSA9PT0gdmFsdWUpXG4gICAgICB0aHJvdyBuZXcgVHlwZUVycm9yKCdBIHByb21pc2VzIGNhbGxiYWNrIGNhbm5vdCByZXR1cm4gdGhhdCBzYW1lIHByb21pc2UuJyk7XG5cbiAgICBpZiAodmFsdWUgJiYgKHR5cGVvZiB2YWx1ZSA9PT0gJ2Z1bmN0aW9uJyB8fCB0eXBlb2YgdmFsdWUgPT09ICdvYmplY3QnKSlcbiAgICB7XG4gICAgICB2YXIgdGhlbiA9IHZhbHVlLnRoZW47ICAvLyB0aGVuIHNob3VsZCBiZSByZXRyaXZlZCBvbmx5IG9uY2VcblxuICAgICAgaWYgKHR5cGVvZiB0aGVuID09PSAnZnVuY3Rpb24nKVxuICAgICAge1xuICAgICAgICB0aGVuLmNhbGwodmFsdWUsIGZ1bmN0aW9uKHZhbCl7XG4gICAgICAgICAgaWYgKCFyZXNvbHZlZClcbiAgICAgICAgICB7XG4gICAgICAgICAgICByZXNvbHZlZCA9IHRydWU7XG5cbiAgICAgICAgICAgIGlmICh2YWx1ZSAhPT0gdmFsKVxuICAgICAgICAgICAgICByZXNvbHZlKHByb21pc2UsIHZhbCk7XG4gICAgICAgICAgICBlbHNlXG4gICAgICAgICAgICAgIGZ1bGZpbGwocHJvbWlzZSwgdmFsKTtcbiAgICAgICAgICB9XG4gICAgICAgIH0sIGZ1bmN0aW9uKHJlYXNvbil7XG4gICAgICAgICAgaWYgKCFyZXNvbHZlZClcbiAgICAgICAgICB7XG4gICAgICAgICAgICByZXNvbHZlZCA9IHRydWU7XG5cbiAgICAgICAgICAgIHJlamVjdChwcm9taXNlLCByZWFzb24pO1xuICAgICAgICAgIH1cbiAgICAgICAgfSk7XG5cbiAgICAgICAgcmV0dXJuIHRydWU7XG4gICAgICB9XG4gICAgfVxuICB9IGNhdGNoIChlKSB7XG4gICAgaWYgKCFyZXNvbHZlZClcbiAgICAgIHJlamVjdChwcm9taXNlLCBlKTtcblxuICAgIHJldHVybiB0cnVlO1xuICB9XG5cbiAgcmV0dXJuIGZhbHNlO1xufVxuXG5mdW5jdGlvbiByZXNvbHZlKHByb21pc2UsIHZhbHVlKXtcbiAgaWYgKHByb21pc2UgPT09IHZhbHVlIHx8ICFoYW5kbGVUaGVuYWJsZShwcm9taXNlLCB2YWx1ZSkpXG4gICAgZnVsZmlsbChwcm9taXNlLCB2YWx1ZSk7XG59XG5cbmZ1bmN0aW9uIGZ1bGZpbGwocHJvbWlzZSwgdmFsdWUpe1xuICBpZiAocHJvbWlzZS5zdGF0ZV8gPT09IFBFTkRJTkcpXG4gIHtcbiAgICBwcm9taXNlLnN0YXRlXyA9IFNFQUxFRDtcbiAgICBwcm9taXNlLmRhdGFfID0gdmFsdWU7XG5cbiAgICBhc3luY0NhbGwocHVibGlzaEZ1bGZpbGxtZW50LCBwcm9taXNlKTtcbiAgfVxufVxuXG5mdW5jdGlvbiByZWplY3QocHJvbWlzZSwgcmVhc29uKXtcbiAgaWYgKHByb21pc2Uuc3RhdGVfID09PSBQRU5ESU5HKVxuICB7XG4gICAgcHJvbWlzZS5zdGF0ZV8gPSBTRUFMRUQ7XG4gICAgcHJvbWlzZS5kYXRhXyA9IHJlYXNvbjtcblxuICAgIGFzeW5jQ2FsbChwdWJsaXNoUmVqZWN0aW9uLCBwcm9taXNlKTtcbiAgfVxufVxuXG5mdW5jdGlvbiBwdWJsaXNoKHByb21pc2UpIHtcbiAgdmFyIGNhbGxiYWNrcyA9IHByb21pc2UudGhlbl87XG4gIHByb21pc2UudGhlbl8gPSB1bmRlZmluZWQ7XG5cbiAgZm9yICh2YXIgaSA9IDA7IGkgPCBjYWxsYmFja3MubGVuZ3RoOyBpKyspIHtcbiAgICBpbnZva2VDYWxsYmFjayhjYWxsYmFja3NbaV0pO1xuICB9XG59XG5cbmZ1bmN0aW9uIHB1Ymxpc2hGdWxmaWxsbWVudChwcm9taXNlKXtcbiAgcHJvbWlzZS5zdGF0ZV8gPSBGVUxGSUxMRUQ7XG4gIHB1Ymxpc2gocHJvbWlzZSk7XG59XG5cbmZ1bmN0aW9uIHB1Ymxpc2hSZWplY3Rpb24ocHJvbWlzZSl7XG4gIHByb21pc2Uuc3RhdGVfID0gUkVKRUNURUQ7XG4gIHB1Ymxpc2gocHJvbWlzZSk7XG59XG5cbi8qKlxuKiBAY2xhc3NcbiovXG5mdW5jdGlvbiBQcm9taXNlKHJlc29sdmVyKXtcbiAgaWYgKHR5cGVvZiByZXNvbHZlciAhPT0gJ2Z1bmN0aW9uJylcbiAgICB0aHJvdyBuZXcgVHlwZUVycm9yKCdQcm9taXNlIGNvbnN0cnVjdG9yIHRha2VzIGEgZnVuY3Rpb24gYXJndW1lbnQnKTtcblxuICBpZiAodGhpcyBpbnN0YW5jZW9mIFByb21pc2UgPT09IGZhbHNlKVxuICAgIHRocm93IG5ldyBUeXBlRXJyb3IoJ0ZhaWxlZCB0byBjb25zdHJ1Y3QgXFwnUHJvbWlzZVxcJzogUGxlYXNlIHVzZSB0aGUgXFwnbmV3XFwnIG9wZXJhdG9yLCB0aGlzIG9iamVjdCBjb25zdHJ1Y3RvciBjYW5ub3QgYmUgY2FsbGVkIGFzIGEgZnVuY3Rpb24uJyk7XG5cbiAgdGhpcy50aGVuXyA9IFtdO1xuXG4gIGludm9rZVJlc29sdmVyKHJlc29sdmVyLCB0aGlzKTtcbn1cblxuUHJvbWlzZS5wcm90b3R5cGUgPSB7XG4gIGNvbnN0cnVjdG9yOiBQcm9taXNlLFxuXG4gIHN0YXRlXzogUEVORElORyxcbiAgdGhlbl86IG51bGwsXG4gIGRhdGFfOiB1bmRlZmluZWQsXG5cbiAgdGhlbjogZnVuY3Rpb24ob25GdWxmaWxsbWVudCwgb25SZWplY3Rpb24pe1xuICAgIHZhciBzdWJzY3JpYmVyID0ge1xuICAgICAgb3duZXI6IHRoaXMsXG4gICAgICB0aGVuOiBuZXcgdGhpcy5jb25zdHJ1Y3RvcihOT09QKSxcbiAgICAgIGZ1bGZpbGxlZDogb25GdWxmaWxsbWVudCxcbiAgICAgIHJlamVjdGVkOiBvblJlamVjdGlvblxuICAgIH07XG5cbiAgICBpZiAodGhpcy5zdGF0ZV8gPT09IEZVTEZJTExFRCB8fCB0aGlzLnN0YXRlXyA9PT0gUkVKRUNURUQpXG4gICAge1xuICAgICAgLy8gYWxyZWFkeSByZXNvbHZlZCwgY2FsbCBjYWxsYmFjayBhc3luY1xuICAgICAgYXN5bmNDYWxsKGludm9rZUNhbGxiYWNrLCBzdWJzY3JpYmVyKTtcbiAgICB9XG4gICAgZWxzZVxuICAgIHtcbiAgICAgIC8vIHN1YnNjcmliZVxuICAgICAgdGhpcy50aGVuXy5wdXNoKHN1YnNjcmliZXIpO1xuICAgIH1cblxuICAgIHJldHVybiBzdWJzY3JpYmVyLnRoZW47XG4gIH0sXG5cbiAgJ2NhdGNoJzogZnVuY3Rpb24ob25SZWplY3Rpb24pIHtcbiAgICByZXR1cm4gdGhpcy50aGVuKG51bGwsIG9uUmVqZWN0aW9uKTtcbiAgfVxufTtcblxuUHJvbWlzZS5hbGwgPSBmdW5jdGlvbihwcm9taXNlcyl7XG4gIHZhciBDbGFzcyA9IHRoaXM7XG5cbiAgaWYgKCFpc0FycmF5KHByb21pc2VzKSlcbiAgICB0aHJvdyBuZXcgVHlwZUVycm9yKCdZb3UgbXVzdCBwYXNzIGFuIGFycmF5IHRvIFByb21pc2UuYWxsKCkuJyk7XG5cbiAgcmV0dXJuIG5ldyBDbGFzcyhmdW5jdGlvbihyZXNvbHZlLCByZWplY3Qpe1xuICAgIHZhciByZXN1bHRzID0gW107XG4gICAgdmFyIHJlbWFpbmluZyA9IDA7XG5cbiAgICBmdW5jdGlvbiByZXNvbHZlcihpbmRleCl7XG4gICAgICByZW1haW5pbmcrKztcbiAgICAgIHJldHVybiBmdW5jdGlvbih2YWx1ZSl7XG4gICAgICAgIHJlc3VsdHNbaW5kZXhdID0gdmFsdWU7XG4gICAgICAgIGlmICghLS1yZW1haW5pbmcpXG4gICAgICAgICAgcmVzb2x2ZShyZXN1bHRzKTtcbiAgICAgIH07XG4gICAgfVxuXG4gICAgZm9yICh2YXIgaSA9IDAsIHByb21pc2U7IGkgPCBwcm9taXNlcy5sZW5ndGg7IGkrKylcbiAgICB7XG4gICAgICBwcm9taXNlID0gcHJvbWlzZXNbaV07XG5cbiAgICAgIGlmIChwcm9taXNlICYmIHR5cGVvZiBwcm9taXNlLnRoZW4gPT09ICdmdW5jdGlvbicpXG4gICAgICAgIHByb21pc2UudGhlbihyZXNvbHZlcihpKSwgcmVqZWN0KTtcbiAgICAgIGVsc2VcbiAgICAgICAgcmVzdWx0c1tpXSA9IHByb21pc2U7XG4gICAgfVxuXG4gICAgaWYgKCFyZW1haW5pbmcpXG4gICAgICByZXNvbHZlKHJlc3VsdHMpO1xuICB9KTtcbn07XG5cblByb21pc2UucmFjZSA9IGZ1bmN0aW9uKHByb21pc2VzKXtcbiAgdmFyIENsYXNzID0gdGhpcztcblxuICBpZiAoIWlzQXJyYXkocHJvbWlzZXMpKVxuICAgIHRocm93IG5ldyBUeXBlRXJyb3IoJ1lvdSBtdXN0IHBhc3MgYW4gYXJyYXkgdG8gUHJvbWlzZS5yYWNlKCkuJyk7XG5cbiAgcmV0dXJuIG5ldyBDbGFzcyhmdW5jdGlvbihyZXNvbHZlLCByZWplY3QpIHtcbiAgICBmb3IgKHZhciBpID0gMCwgcHJvbWlzZTsgaSA8IHByb21pc2VzLmxlbmd0aDsgaSsrKVxuICAgIHtcbiAgICAgIHByb21pc2UgPSBwcm9taXNlc1tpXTtcblxuICAgICAgaWYgKHByb21pc2UgJiYgdHlwZW9mIHByb21pc2UudGhlbiA9PT0gJ2Z1bmN0aW9uJylcbiAgICAgICAgcHJvbWlzZS50aGVuKHJlc29sdmUsIHJlamVjdCk7XG4gICAgICBlbHNlXG4gICAgICAgIHJlc29sdmUocHJvbWlzZSk7XG4gICAgfVxuICB9KTtcbn07XG5cblByb21pc2UucmVzb2x2ZSA9IGZ1bmN0aW9uKHZhbHVlKXtcbiAgdmFyIENsYXNzID0gdGhpcztcblxuICBpZiAodmFsdWUgJiYgdHlwZW9mIHZhbHVlID09PSAnb2JqZWN0JyAmJiB2YWx1ZS5jb25zdHJ1Y3RvciA9PT0gQ2xhc3MpXG4gICAgcmV0dXJuIHZhbHVlO1xuXG4gIHJldHVybiBuZXcgQ2xhc3MoZnVuY3Rpb24ocmVzb2x2ZSl7XG4gICAgcmVzb2x2ZSh2YWx1ZSk7XG4gIH0pO1xufTtcblxuUHJvbWlzZS5yZWplY3QgPSBmdW5jdGlvbihyZWFzb24pe1xuICB2YXIgQ2xhc3MgPSB0aGlzO1xuXG4gIHJldHVybiBuZXcgQ2xhc3MoZnVuY3Rpb24ocmVzb2x2ZSwgcmVqZWN0KXtcbiAgICByZWplY3QocmVhc29uKTtcbiAgfSk7XG59O1xuXG59KSh0eXBlb2Ygd2luZG93ICE9ICd1bmRlZmluZWQnID8gd2luZG93IDogdHlwZW9mIGdsb2JhbCAhPSAndW5kZWZpbmVkJyA/IGdsb2JhbCA6IHR5cGVvZiBzZWxmICE9ICd1bmRlZmluZWQnID8gc2VsZiA6IHRoaXMpO1xuXG59KTsiLCJyZXF1aXJlKCcvcm9vdC9hcHAvbm9kZV9tb2R1bGVzL2FzeW5jLWRlZmluZS9saWIvYXN5bmNEZWZpbmUuanMnKShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbi8qIVxuICogQG92ZXJ2aWV3IGVzNi1wcm9taXNlIC0gYSB0aW55IGltcGxlbWVudGF0aW9uIG9mIFByb21pc2VzL0ErLlxuICogQGNvcHlyaWdodCBDb3B5cmlnaHQgKGMpIDIwMTQgWWVodWRhIEthdHosIFRvbSBEYWxlLCBTdGVmYW4gUGVubmVyIGFuZCBjb250cmlidXRvcnMgKENvbnZlcnNpb24gdG8gRVM2IEFQSSBieSBKYWtlIEFyY2hpYmFsZClcbiAqIEBsaWNlbnNlICAgTGljZW5zZWQgdW5kZXIgTUlUIGxpY2Vuc2VcbiAqICAgICAgICAgICAgU2VlIGh0dHBzOi8vcmF3LmdpdGh1YnVzZXJjb250ZW50LmNvbS9zdGVmYW5wZW5uZXIvZXM2LXByb21pc2UvbWFzdGVyL0xJQ0VOU0VcbiAqIEB2ZXJzaW9uICAgMy4zLjFcbiAqL1xuXG4oZnVuY3Rpb24gKGdsb2JhbCwgZmFjdG9yeSkge1xuICAgIHR5cGVvZiBleHBvcnRzID09PSAnb2JqZWN0JyAmJiB0eXBlb2YgbW9kdWxlICE9PSAndW5kZWZpbmVkJyA/IG1vZHVsZS5leHBvcnRzID0gZmFjdG9yeSgpIDpcbiAgICB0eXBlb2YgZGVmaW5lID09PSAnZnVuY3Rpb24nICYmIGRlZmluZS5hbWQgPyBkZWZpbmUoZmFjdG9yeSkgOlxuICAgIChnbG9iYWwuRVM2UHJvbWlzZSA9IGZhY3RvcnkoKSk7XG59KHRoaXMsIChmdW5jdGlvbiAoKSB7ICd1c2Ugc3RyaWN0JztcblxuZnVuY3Rpb24gb2JqZWN0T3JGdW5jdGlvbih4KSB7XG4gIHJldHVybiB0eXBlb2YgeCA9PT0gJ2Z1bmN0aW9uJyB8fCB0eXBlb2YgeCA9PT0gJ29iamVjdCcgJiYgeCAhPT0gbnVsbDtcbn1cblxuZnVuY3Rpb24gaXNGdW5jdGlvbih4KSB7XG4gIHJldHVybiB0eXBlb2YgeCA9PT0gJ2Z1bmN0aW9uJztcbn1cblxudmFyIF9pc0FycmF5ID0gdW5kZWZpbmVkO1xuaWYgKCFBcnJheS5pc0FycmF5KSB7XG4gIF9pc0FycmF5ID0gZnVuY3Rpb24gKHgpIHtcbiAgICByZXR1cm4gT2JqZWN0LnByb3RvdHlwZS50b1N0cmluZy5jYWxsKHgpID09PSAnW29iamVjdCBBcnJheV0nO1xuICB9O1xufSBlbHNlIHtcbiAgX2lzQXJyYXkgPSBBcnJheS5pc0FycmF5O1xufVxuXG52YXIgaXNBcnJheSA9IF9pc0FycmF5O1xuXG52YXIgbGVuID0gMDtcbnZhciB2ZXJ0eE5leHQgPSB1bmRlZmluZWQ7XG52YXIgY3VzdG9tU2NoZWR1bGVyRm4gPSB1bmRlZmluZWQ7XG5cbnZhciBhc2FwID0gZnVuY3Rpb24gYXNhcChjYWxsYmFjaywgYXJnKSB7XG4gIHF1ZXVlW2xlbl0gPSBjYWxsYmFjaztcbiAgcXVldWVbbGVuICsgMV0gPSBhcmc7XG4gIGxlbiArPSAyO1xuICBpZiAobGVuID09PSAyKSB7XG4gICAgLy8gSWYgbGVuIGlzIDIsIHRoYXQgbWVhbnMgdGhhdCB3ZSBuZWVkIHRvIHNjaGVkdWxlIGFuIGFzeW5jIGZsdXNoLlxuICAgIC8vIElmIGFkZGl0aW9uYWwgY2FsbGJhY2tzIGFyZSBxdWV1ZWQgYmVmb3JlIHRoZSBxdWV1ZSBpcyBmbHVzaGVkLCB0aGV5XG4gICAgLy8gd2lsbCBiZSBwcm9jZXNzZWQgYnkgdGhpcyBmbHVzaCB0aGF0IHdlIGFyZSBzY2hlZHVsaW5nLlxuICAgIGlmIChjdXN0b21TY2hlZHVsZXJGbikge1xuICAgICAgY3VzdG9tU2NoZWR1bGVyRm4oZmx1c2gpO1xuICAgIH0gZWxzZSB7XG4gICAgICBzY2hlZHVsZUZsdXNoKCk7XG4gICAgfVxuICB9XG59O1xuXG5mdW5jdGlvbiBzZXRTY2hlZHVsZXIoc2NoZWR1bGVGbikge1xuICBjdXN0b21TY2hlZHVsZXJGbiA9IHNjaGVkdWxlRm47XG59XG5cbmZ1bmN0aW9uIHNldEFzYXAoYXNhcEZuKSB7XG4gIGFzYXAgPSBhc2FwRm47XG59XG5cbnZhciBicm93c2VyV2luZG93ID0gdHlwZW9mIHdpbmRvdyAhPT0gJ3VuZGVmaW5lZCcgPyB3aW5kb3cgOiB1bmRlZmluZWQ7XG52YXIgYnJvd3Nlckdsb2JhbCA9IGJyb3dzZXJXaW5kb3cgfHwge307XG52YXIgQnJvd3Nlck11dGF0aW9uT2JzZXJ2ZXIgPSBicm93c2VyR2xvYmFsLk11dGF0aW9uT2JzZXJ2ZXIgfHwgYnJvd3Nlckdsb2JhbC5XZWJLaXRNdXRhdGlvbk9ic2VydmVyO1xudmFyIGlzTm9kZSA9IHR5cGVvZiBzZWxmID09PSAndW5kZWZpbmVkJyAmJiB0eXBlb2YgcHJvY2VzcyAhPT0gJ3VuZGVmaW5lZCcgJiYgKHt9KS50b1N0cmluZy5jYWxsKHByb2Nlc3MpID09PSAnW29iamVjdCBwcm9jZXNzXSc7XG5cbi8vIHRlc3QgZm9yIHdlYiB3b3JrZXIgYnV0IG5vdCBpbiBJRTEwXG52YXIgaXNXb3JrZXIgPSB0eXBlb2YgVWludDhDbGFtcGVkQXJyYXkgIT09ICd1bmRlZmluZWQnICYmIHR5cGVvZiBpbXBvcnRTY3JpcHRzICE9PSAndW5kZWZpbmVkJyAmJiB0eXBlb2YgTWVzc2FnZUNoYW5uZWwgIT09ICd1bmRlZmluZWQnO1xuXG4vLyBub2RlXG5mdW5jdGlvbiB1c2VOZXh0VGljaygpIHtcbiAgLy8gbm9kZSB2ZXJzaW9uIDAuMTAueCBkaXNwbGF5cyBhIGRlcHJlY2F0aW9uIHdhcm5pbmcgd2hlbiBuZXh0VGljayBpcyB1c2VkIHJlY3Vyc2l2ZWx5XG4gIC8vIHNlZSBodHRwczovL2dpdGh1Yi5jb20vY3Vqb2pzL3doZW4vaXNzdWVzLzQxMCBmb3IgZGV0YWlsc1xuICByZXR1cm4gZnVuY3Rpb24gKCkge1xuICAgIHJldHVybiBwcm9jZXNzLm5leHRUaWNrKGZsdXNoKTtcbiAgfTtcbn1cblxuLy8gdmVydHhcbmZ1bmN0aW9uIHVzZVZlcnR4VGltZXIoKSB7XG4gIHJldHVybiBmdW5jdGlvbiAoKSB7XG4gICAgdmVydHhOZXh0KGZsdXNoKTtcbiAgfTtcbn1cblxuZnVuY3Rpb24gdXNlTXV0YXRpb25PYnNlcnZlcigpIHtcbiAgdmFyIGl0ZXJhdGlvbnMgPSAwO1xuICB2YXIgb2JzZXJ2ZXIgPSBuZXcgQnJvd3Nlck11dGF0aW9uT2JzZXJ2ZXIoZmx1c2gpO1xuICB2YXIgbm9kZSA9IGRvY3VtZW50LmNyZWF0ZVRleHROb2RlKCcnKTtcbiAgb2JzZXJ2ZXIub2JzZXJ2ZShub2RlLCB7IGNoYXJhY3RlckRhdGE6IHRydWUgfSk7XG5cbiAgcmV0dXJuIGZ1bmN0aW9uICgpIHtcbiAgICBub2RlLmRhdGEgPSBpdGVyYXRpb25zID0gKytpdGVyYXRpb25zICUgMjtcbiAgfTtcbn1cblxuLy8gd2ViIHdvcmtlclxuZnVuY3Rpb24gdXNlTWVzc2FnZUNoYW5uZWwoKSB7XG4gIHZhciBjaGFubmVsID0gbmV3IE1lc3NhZ2VDaGFubmVsKCk7XG4gIGNoYW5uZWwucG9ydDEub25tZXNzYWdlID0gZmx1c2g7XG4gIHJldHVybiBmdW5jdGlvbiAoKSB7XG4gICAgcmV0dXJuIGNoYW5uZWwucG9ydDIucG9zdE1lc3NhZ2UoMCk7XG4gIH07XG59XG5cbmZ1bmN0aW9uIHVzZVNldFRpbWVvdXQoKSB7XG4gIC8vIFN0b3JlIHNldFRpbWVvdXQgcmVmZXJlbmNlIHNvIGVzNi1wcm9taXNlIHdpbGwgYmUgdW5hZmZlY3RlZCBieVxuICAvLyBvdGhlciBjb2RlIG1vZGlmeWluZyBzZXRUaW1lb3V0IChsaWtlIHNpbm9uLnVzZUZha2VUaW1lcnMoKSlcbiAgdmFyIGdsb2JhbFNldFRpbWVvdXQgPSBzZXRUaW1lb3V0O1xuICByZXR1cm4gZnVuY3Rpb24gKCkge1xuICAgIHJldHVybiBnbG9iYWxTZXRUaW1lb3V0KGZsdXNoLCAxKTtcbiAgfTtcbn1cblxudmFyIHF1ZXVlID0gbmV3IEFycmF5KDEwMDApO1xuZnVuY3Rpb24gZmx1c2goKSB7XG4gIGZvciAodmFyIGkgPSAwOyBpIDwgbGVuOyBpICs9IDIpIHtcbiAgICB2YXIgY2FsbGJhY2sgPSBxdWV1ZVtpXTtcbiAgICB2YXIgYXJnID0gcXVldWVbaSArIDFdO1xuXG4gICAgY2FsbGJhY2soYXJnKTtcblxuICAgIHF1ZXVlW2ldID0gdW5kZWZpbmVkO1xuICAgIHF1ZXVlW2kgKyAxXSA9IHVuZGVmaW5lZDtcbiAgfVxuXG4gIGxlbiA9IDA7XG59XG5cbmZ1bmN0aW9uIGF0dGVtcHRWZXJ0eCgpIHtcbiAgdHJ5IHtcbiAgICB2YXIgciA9IHJlcXVpcmU7XG4gICAgdmFyIHZlcnR4ID0gcigndmVydHgnKTtcbiAgICB2ZXJ0eE5leHQgPSB2ZXJ0eC5ydW5Pbkxvb3AgfHwgdmVydHgucnVuT25Db250ZXh0O1xuICAgIHJldHVybiB1c2VWZXJ0eFRpbWVyKCk7XG4gIH0gY2F0Y2ggKGUpIHtcbiAgICByZXR1cm4gdXNlU2V0VGltZW91dCgpO1xuICB9XG59XG5cbnZhciBzY2hlZHVsZUZsdXNoID0gdW5kZWZpbmVkO1xuLy8gRGVjaWRlIHdoYXQgYXN5bmMgbWV0aG9kIHRvIHVzZSB0byB0cmlnZ2VyaW5nIHByb2Nlc3Npbmcgb2YgcXVldWVkIGNhbGxiYWNrczpcbmlmIChpc05vZGUpIHtcbiAgc2NoZWR1bGVGbHVzaCA9IHVzZU5leHRUaWNrKCk7XG59IGVsc2UgaWYgKEJyb3dzZXJNdXRhdGlvbk9ic2VydmVyKSB7XG4gIHNjaGVkdWxlRmx1c2ggPSB1c2VNdXRhdGlvbk9ic2VydmVyKCk7XG59IGVsc2UgaWYgKGlzV29ya2VyKSB7XG4gIHNjaGVkdWxlRmx1c2ggPSB1c2VNZXNzYWdlQ2hhbm5lbCgpO1xufSBlbHNlIGlmIChicm93c2VyV2luZG93ID09PSB1bmRlZmluZWQgJiYgdHlwZW9mIHJlcXVpcmUgPT09ICdmdW5jdGlvbicpIHtcbiAgc2NoZWR1bGVGbHVzaCA9IGF0dGVtcHRWZXJ0eCgpO1xufSBlbHNlIHtcbiAgc2NoZWR1bGVGbHVzaCA9IHVzZVNldFRpbWVvdXQoKTtcbn1cblxuZnVuY3Rpb24gdGhlbihvbkZ1bGZpbGxtZW50LCBvblJlamVjdGlvbikge1xuICB2YXIgX2FyZ3VtZW50cyA9IGFyZ3VtZW50cztcblxuICB2YXIgcGFyZW50ID0gdGhpcztcblxuICB2YXIgY2hpbGQgPSBuZXcgdGhpcy5jb25zdHJ1Y3Rvcihub29wKTtcblxuICBpZiAoY2hpbGRbUFJPTUlTRV9JRF0gPT09IHVuZGVmaW5lZCkge1xuICAgIG1ha2VQcm9taXNlKGNoaWxkKTtcbiAgfVxuXG4gIHZhciBfc3RhdGUgPSBwYXJlbnQuX3N0YXRlO1xuXG4gIGlmIChfc3RhdGUpIHtcbiAgICAoZnVuY3Rpb24gKCkge1xuICAgICAgdmFyIGNhbGxiYWNrID0gX2FyZ3VtZW50c1tfc3RhdGUgLSAxXTtcbiAgICAgIGFzYXAoZnVuY3Rpb24gKCkge1xuICAgICAgICByZXR1cm4gaW52b2tlQ2FsbGJhY2soX3N0YXRlLCBjaGlsZCwgY2FsbGJhY2ssIHBhcmVudC5fcmVzdWx0KTtcbiAgICAgIH0pO1xuICAgIH0pKCk7XG4gIH0gZWxzZSB7XG4gICAgc3Vic2NyaWJlKHBhcmVudCwgY2hpbGQsIG9uRnVsZmlsbG1lbnQsIG9uUmVqZWN0aW9uKTtcbiAgfVxuXG4gIHJldHVybiBjaGlsZDtcbn1cblxuLyoqXG4gIGBQcm9taXNlLnJlc29sdmVgIHJldHVybnMgYSBwcm9taXNlIHRoYXQgd2lsbCBiZWNvbWUgcmVzb2x2ZWQgd2l0aCB0aGVcbiAgcGFzc2VkIGB2YWx1ZWAuIEl0IGlzIHNob3J0aGFuZCBmb3IgdGhlIGZvbGxvd2luZzpcblxuICBgYGBqYXZhc2NyaXB0XG4gIGxldCBwcm9taXNlID0gbmV3IFByb21pc2UoZnVuY3Rpb24ocmVzb2x2ZSwgcmVqZWN0KXtcbiAgICByZXNvbHZlKDEpO1xuICB9KTtcblxuICBwcm9taXNlLnRoZW4oZnVuY3Rpb24odmFsdWUpe1xuICAgIC8vIHZhbHVlID09PSAxXG4gIH0pO1xuICBgYGBcblxuICBJbnN0ZWFkIG9mIHdyaXRpbmcgdGhlIGFib3ZlLCB5b3VyIGNvZGUgbm93IHNpbXBseSBiZWNvbWVzIHRoZSBmb2xsb3dpbmc6XG5cbiAgYGBgamF2YXNjcmlwdFxuICBsZXQgcHJvbWlzZSA9IFByb21pc2UucmVzb2x2ZSgxKTtcblxuICBwcm9taXNlLnRoZW4oZnVuY3Rpb24odmFsdWUpe1xuICAgIC8vIHZhbHVlID09PSAxXG4gIH0pO1xuICBgYGBcblxuICBAbWV0aG9kIHJlc29sdmVcbiAgQHN0YXRpY1xuICBAcGFyYW0ge0FueX0gdmFsdWUgdmFsdWUgdGhhdCB0aGUgcmV0dXJuZWQgcHJvbWlzZSB3aWxsIGJlIHJlc29sdmVkIHdpdGhcbiAgVXNlZnVsIGZvciB0b29saW5nLlxuICBAcmV0dXJuIHtQcm9taXNlfSBhIHByb21pc2UgdGhhdCB3aWxsIGJlY29tZSBmdWxmaWxsZWQgd2l0aCB0aGUgZ2l2ZW5cbiAgYHZhbHVlYFxuKi9cbmZ1bmN0aW9uIHJlc29sdmUob2JqZWN0KSB7XG4gIC8qanNoaW50IHZhbGlkdGhpczp0cnVlICovXG4gIHZhciBDb25zdHJ1Y3RvciA9IHRoaXM7XG5cbiAgaWYgKG9iamVjdCAmJiB0eXBlb2Ygb2JqZWN0ID09PSAnb2JqZWN0JyAmJiBvYmplY3QuY29uc3RydWN0b3IgPT09IENvbnN0cnVjdG9yKSB7XG4gICAgcmV0dXJuIG9iamVjdDtcbiAgfVxuXG4gIHZhciBwcm9taXNlID0gbmV3IENvbnN0cnVjdG9yKG5vb3ApO1xuICBfcmVzb2x2ZShwcm9taXNlLCBvYmplY3QpO1xuICByZXR1cm4gcHJvbWlzZTtcbn1cblxudmFyIFBST01JU0VfSUQgPSBNYXRoLnJhbmRvbSgpLnRvU3RyaW5nKDM2KS5zdWJzdHJpbmcoMTYpO1xuXG5mdW5jdGlvbiBub29wKCkge31cblxudmFyIFBFTkRJTkcgPSB2b2lkIDA7XG52YXIgRlVMRklMTEVEID0gMTtcbnZhciBSRUpFQ1RFRCA9IDI7XG5cbnZhciBHRVRfVEhFTl9FUlJPUiA9IG5ldyBFcnJvck9iamVjdCgpO1xuXG5mdW5jdGlvbiBzZWxmRnVsZmlsbG1lbnQoKSB7XG4gIHJldHVybiBuZXcgVHlwZUVycm9yKFwiWW91IGNhbm5vdCByZXNvbHZlIGEgcHJvbWlzZSB3aXRoIGl0c2VsZlwiKTtcbn1cblxuZnVuY3Rpb24gY2Fubm90UmV0dXJuT3duKCkge1xuICByZXR1cm4gbmV3IFR5cGVFcnJvcignQSBwcm9taXNlcyBjYWxsYmFjayBjYW5ub3QgcmV0dXJuIHRoYXQgc2FtZSBwcm9taXNlLicpO1xufVxuXG5mdW5jdGlvbiBnZXRUaGVuKHByb21pc2UpIHtcbiAgdHJ5IHtcbiAgICByZXR1cm4gcHJvbWlzZS50aGVuO1xuICB9IGNhdGNoIChlcnJvcikge1xuICAgIEdFVF9USEVOX0VSUk9SLmVycm9yID0gZXJyb3I7XG4gICAgcmV0dXJuIEdFVF9USEVOX0VSUk9SO1xuICB9XG59XG5cbmZ1bmN0aW9uIHRyeVRoZW4odGhlbiwgdmFsdWUsIGZ1bGZpbGxtZW50SGFuZGxlciwgcmVqZWN0aW9uSGFuZGxlcikge1xuICB0cnkge1xuICAgIHRoZW4uY2FsbCh2YWx1ZSwgZnVsZmlsbG1lbnRIYW5kbGVyLCByZWplY3Rpb25IYW5kbGVyKTtcbiAgfSBjYXRjaCAoZSkge1xuICAgIHJldHVybiBlO1xuICB9XG59XG5cbmZ1bmN0aW9uIGhhbmRsZUZvcmVpZ25UaGVuYWJsZShwcm9taXNlLCB0aGVuYWJsZSwgdGhlbikge1xuICBhc2FwKGZ1bmN0aW9uIChwcm9taXNlKSB7XG4gICAgdmFyIHNlYWxlZCA9IGZhbHNlO1xuICAgIHZhciBlcnJvciA9IHRyeVRoZW4odGhlbiwgdGhlbmFibGUsIGZ1bmN0aW9uICh2YWx1ZSkge1xuICAgICAgaWYgKHNlYWxlZCkge1xuICAgICAgICByZXR1cm47XG4gICAgICB9XG4gICAgICBzZWFsZWQgPSB0cnVlO1xuICAgICAgaWYgKHRoZW5hYmxlICE9PSB2YWx1ZSkge1xuICAgICAgICBfcmVzb2x2ZShwcm9taXNlLCB2YWx1ZSk7XG4gICAgICB9IGVsc2Uge1xuICAgICAgICBmdWxmaWxsKHByb21pc2UsIHZhbHVlKTtcbiAgICAgIH1cbiAgICB9LCBmdW5jdGlvbiAocmVhc29uKSB7XG4gICAgICBpZiAoc2VhbGVkKSB7XG4gICAgICAgIHJldHVybjtcbiAgICAgIH1cbiAgICAgIHNlYWxlZCA9IHRydWU7XG5cbiAgICAgIF9yZWplY3QocHJvbWlzZSwgcmVhc29uKTtcbiAgICB9LCAnU2V0dGxlOiAnICsgKHByb21pc2UuX2xhYmVsIHx8ICcgdW5rbm93biBwcm9taXNlJykpO1xuXG4gICAgaWYgKCFzZWFsZWQgJiYgZXJyb3IpIHtcbiAgICAgIHNlYWxlZCA9IHRydWU7XG4gICAgICBfcmVqZWN0KHByb21pc2UsIGVycm9yKTtcbiAgICB9XG4gIH0sIHByb21pc2UpO1xufVxuXG5mdW5jdGlvbiBoYW5kbGVPd25UaGVuYWJsZShwcm9taXNlLCB0aGVuYWJsZSkge1xuICBpZiAodGhlbmFibGUuX3N0YXRlID09PSBGVUxGSUxMRUQpIHtcbiAgICBmdWxmaWxsKHByb21pc2UsIHRoZW5hYmxlLl9yZXN1bHQpO1xuICB9IGVsc2UgaWYgKHRoZW5hYmxlLl9zdGF0ZSA9PT0gUkVKRUNURUQpIHtcbiAgICBfcmVqZWN0KHByb21pc2UsIHRoZW5hYmxlLl9yZXN1bHQpO1xuICB9IGVsc2Uge1xuICAgIHN1YnNjcmliZSh0aGVuYWJsZSwgdW5kZWZpbmVkLCBmdW5jdGlvbiAodmFsdWUpIHtcbiAgICAgIHJldHVybiBfcmVzb2x2ZShwcm9taXNlLCB2YWx1ZSk7XG4gICAgfSwgZnVuY3Rpb24gKHJlYXNvbikge1xuICAgICAgcmV0dXJuIF9yZWplY3QocHJvbWlzZSwgcmVhc29uKTtcbiAgICB9KTtcbiAgfVxufVxuXG5mdW5jdGlvbiBoYW5kbGVNYXliZVRoZW5hYmxlKHByb21pc2UsIG1heWJlVGhlbmFibGUsIHRoZW4kJCkge1xuICBpZiAobWF5YmVUaGVuYWJsZS5jb25zdHJ1Y3RvciA9PT0gcHJvbWlzZS5jb25zdHJ1Y3RvciAmJiB0aGVuJCQgPT09IHRoZW4gJiYgbWF5YmVUaGVuYWJsZS5jb25zdHJ1Y3Rvci5yZXNvbHZlID09PSByZXNvbHZlKSB7XG4gICAgaGFuZGxlT3duVGhlbmFibGUocHJvbWlzZSwgbWF5YmVUaGVuYWJsZSk7XG4gIH0gZWxzZSB7XG4gICAgaWYgKHRoZW4kJCA9PT0gR0VUX1RIRU5fRVJST1IpIHtcbiAgICAgIF9yZWplY3QocHJvbWlzZSwgR0VUX1RIRU5fRVJST1IuZXJyb3IpO1xuICAgIH0gZWxzZSBpZiAodGhlbiQkID09PSB1bmRlZmluZWQpIHtcbiAgICAgIGZ1bGZpbGwocHJvbWlzZSwgbWF5YmVUaGVuYWJsZSk7XG4gICAgfSBlbHNlIGlmIChpc0Z1bmN0aW9uKHRoZW4kJCkpIHtcbiAgICAgIGhhbmRsZUZvcmVpZ25UaGVuYWJsZShwcm9taXNlLCBtYXliZVRoZW5hYmxlLCB0aGVuJCQpO1xuICAgIH0gZWxzZSB7XG4gICAgICBmdWxmaWxsKHByb21pc2UsIG1heWJlVGhlbmFibGUpO1xuICAgIH1cbiAgfVxufVxuXG5mdW5jdGlvbiBfcmVzb2x2ZShwcm9taXNlLCB2YWx1ZSkge1xuICBpZiAocHJvbWlzZSA9PT0gdmFsdWUpIHtcbiAgICBfcmVqZWN0KHByb21pc2UsIHNlbGZGdWxmaWxsbWVudCgpKTtcbiAgfSBlbHNlIGlmIChvYmplY3RPckZ1bmN0aW9uKHZhbHVlKSkge1xuICAgIGhhbmRsZU1heWJlVGhlbmFibGUocHJvbWlzZSwgdmFsdWUsIGdldFRoZW4odmFsdWUpKTtcbiAgfSBlbHNlIHtcbiAgICBmdWxmaWxsKHByb21pc2UsIHZhbHVlKTtcbiAgfVxufVxuXG5mdW5jdGlvbiBwdWJsaXNoUmVqZWN0aW9uKHByb21pc2UpIHtcbiAgaWYgKHByb21pc2UuX29uZXJyb3IpIHtcbiAgICBwcm9taXNlLl9vbmVycm9yKHByb21pc2UuX3Jlc3VsdCk7XG4gIH1cblxuICBwdWJsaXNoKHByb21pc2UpO1xufVxuXG5mdW5jdGlvbiBmdWxmaWxsKHByb21pc2UsIHZhbHVlKSB7XG4gIGlmIChwcm9taXNlLl9zdGF0ZSAhPT0gUEVORElORykge1xuICAgIHJldHVybjtcbiAgfVxuXG4gIHByb21pc2UuX3Jlc3VsdCA9IHZhbHVlO1xuICBwcm9taXNlLl9zdGF0ZSA9IEZVTEZJTExFRDtcblxuICBpZiAocHJvbWlzZS5fc3Vic2NyaWJlcnMubGVuZ3RoICE9PSAwKSB7XG4gICAgYXNhcChwdWJsaXNoLCBwcm9taXNlKTtcbiAgfVxufVxuXG5mdW5jdGlvbiBfcmVqZWN0KHByb21pc2UsIHJlYXNvbikge1xuICBpZiAocHJvbWlzZS5fc3RhdGUgIT09IFBFTkRJTkcpIHtcbiAgICByZXR1cm47XG4gIH1cbiAgcHJvbWlzZS5fc3RhdGUgPSBSRUpFQ1RFRDtcbiAgcHJvbWlzZS5fcmVzdWx0ID0gcmVhc29uO1xuXG4gIGFzYXAocHVibGlzaFJlamVjdGlvbiwgcHJvbWlzZSk7XG59XG5cbmZ1bmN0aW9uIHN1YnNjcmliZShwYXJlbnQsIGNoaWxkLCBvbkZ1bGZpbGxtZW50LCBvblJlamVjdGlvbikge1xuICB2YXIgX3N1YnNjcmliZXJzID0gcGFyZW50Ll9zdWJzY3JpYmVycztcbiAgdmFyIGxlbmd0aCA9IF9zdWJzY3JpYmVycy5sZW5ndGg7XG5cbiAgcGFyZW50Ll9vbmVycm9yID0gbnVsbDtcblxuICBfc3Vic2NyaWJlcnNbbGVuZ3RoXSA9IGNoaWxkO1xuICBfc3Vic2NyaWJlcnNbbGVuZ3RoICsgRlVMRklMTEVEXSA9IG9uRnVsZmlsbG1lbnQ7XG4gIF9zdWJzY3JpYmVyc1tsZW5ndGggKyBSRUpFQ1RFRF0gPSBvblJlamVjdGlvbjtcblxuICBpZiAobGVuZ3RoID09PSAwICYmIHBhcmVudC5fc3RhdGUpIHtcbiAgICBhc2FwKHB1Ymxpc2gsIHBhcmVudCk7XG4gIH1cbn1cblxuZnVuY3Rpb24gcHVibGlzaChwcm9taXNlKSB7XG4gIHZhciBzdWJzY3JpYmVycyA9IHByb21pc2UuX3N1YnNjcmliZXJzO1xuICB2YXIgc2V0dGxlZCA9IHByb21pc2UuX3N0YXRlO1xuXG4gIGlmIChzdWJzY3JpYmVycy5sZW5ndGggPT09IDApIHtcbiAgICByZXR1cm47XG4gIH1cblxuICB2YXIgY2hpbGQgPSB1bmRlZmluZWQsXG4gICAgICBjYWxsYmFjayA9IHVuZGVmaW5lZCxcbiAgICAgIGRldGFpbCA9IHByb21pc2UuX3Jlc3VsdDtcblxuICBmb3IgKHZhciBpID0gMDsgaSA8IHN1YnNjcmliZXJzLmxlbmd0aDsgaSArPSAzKSB7XG4gICAgY2hpbGQgPSBzdWJzY3JpYmVyc1tpXTtcbiAgICBjYWxsYmFjayA9IHN1YnNjcmliZXJzW2kgKyBzZXR0bGVkXTtcblxuICAgIGlmIChjaGlsZCkge1xuICAgICAgaW52b2tlQ2FsbGJhY2soc2V0dGxlZCwgY2hpbGQsIGNhbGxiYWNrLCBkZXRhaWwpO1xuICAgIH0gZWxzZSB7XG4gICAgICBjYWxsYmFjayhkZXRhaWwpO1xuICAgIH1cbiAgfVxuXG4gIHByb21pc2UuX3N1YnNjcmliZXJzLmxlbmd0aCA9IDA7XG59XG5cbmZ1bmN0aW9uIEVycm9yT2JqZWN0KCkge1xuICB0aGlzLmVycm9yID0gbnVsbDtcbn1cblxudmFyIFRSWV9DQVRDSF9FUlJPUiA9IG5ldyBFcnJvck9iamVjdCgpO1xuXG5mdW5jdGlvbiB0cnlDYXRjaChjYWxsYmFjaywgZGV0YWlsKSB7XG4gIHRyeSB7XG4gICAgcmV0dXJuIGNhbGxiYWNrKGRldGFpbCk7XG4gIH0gY2F0Y2ggKGUpIHtcbiAgICBUUllfQ0FUQ0hfRVJST1IuZXJyb3IgPSBlO1xuICAgIHJldHVybiBUUllfQ0FUQ0hfRVJST1I7XG4gIH1cbn1cblxuZnVuY3Rpb24gaW52b2tlQ2FsbGJhY2soc2V0dGxlZCwgcHJvbWlzZSwgY2FsbGJhY2ssIGRldGFpbCkge1xuICB2YXIgaGFzQ2FsbGJhY2sgPSBpc0Z1bmN0aW9uKGNhbGxiYWNrKSxcbiAgICAgIHZhbHVlID0gdW5kZWZpbmVkLFxuICAgICAgZXJyb3IgPSB1bmRlZmluZWQsXG4gICAgICBzdWNjZWVkZWQgPSB1bmRlZmluZWQsXG4gICAgICBmYWlsZWQgPSB1bmRlZmluZWQ7XG5cbiAgaWYgKGhhc0NhbGxiYWNrKSB7XG4gICAgdmFsdWUgPSB0cnlDYXRjaChjYWxsYmFjaywgZGV0YWlsKTtcblxuICAgIGlmICh2YWx1ZSA9PT0gVFJZX0NBVENIX0VSUk9SKSB7XG4gICAgICBmYWlsZWQgPSB0cnVlO1xuICAgICAgZXJyb3IgPSB2YWx1ZS5lcnJvcjtcbiAgICAgIHZhbHVlID0gbnVsbDtcbiAgICB9IGVsc2Uge1xuICAgICAgc3VjY2VlZGVkID0gdHJ1ZTtcbiAgICB9XG5cbiAgICBpZiAocHJvbWlzZSA9PT0gdmFsdWUpIHtcbiAgICAgIF9yZWplY3QocHJvbWlzZSwgY2Fubm90UmV0dXJuT3duKCkpO1xuICAgICAgcmV0dXJuO1xuICAgIH1cbiAgfSBlbHNlIHtcbiAgICB2YWx1ZSA9IGRldGFpbDtcbiAgICBzdWNjZWVkZWQgPSB0cnVlO1xuICB9XG5cbiAgaWYgKHByb21pc2UuX3N0YXRlICE9PSBQRU5ESU5HKSB7XG4gICAgLy8gbm9vcFxuICB9IGVsc2UgaWYgKGhhc0NhbGxiYWNrICYmIHN1Y2NlZWRlZCkge1xuICAgICAgX3Jlc29sdmUocHJvbWlzZSwgdmFsdWUpO1xuICAgIH0gZWxzZSBpZiAoZmFpbGVkKSB7XG4gICAgICBfcmVqZWN0KHByb21pc2UsIGVycm9yKTtcbiAgICB9IGVsc2UgaWYgKHNldHRsZWQgPT09IEZVTEZJTExFRCkge1xuICAgICAgZnVsZmlsbChwcm9taXNlLCB2YWx1ZSk7XG4gICAgfSBlbHNlIGlmIChzZXR0bGVkID09PSBSRUpFQ1RFRCkge1xuICAgICAgX3JlamVjdChwcm9taXNlLCB2YWx1ZSk7XG4gICAgfVxufVxuXG5mdW5jdGlvbiBpbml0aWFsaXplUHJvbWlzZShwcm9taXNlLCByZXNvbHZlcikge1xuICB0cnkge1xuICAgIHJlc29sdmVyKGZ1bmN0aW9uIHJlc29sdmVQcm9taXNlKHZhbHVlKSB7XG4gICAgICBfcmVzb2x2ZShwcm9taXNlLCB2YWx1ZSk7XG4gICAgfSwgZnVuY3Rpb24gcmVqZWN0UHJvbWlzZShyZWFzb24pIHtcbiAgICAgIF9yZWplY3QocHJvbWlzZSwgcmVhc29uKTtcbiAgICB9KTtcbiAgfSBjYXRjaCAoZSkge1xuICAgIF9yZWplY3QocHJvbWlzZSwgZSk7XG4gIH1cbn1cblxudmFyIGlkID0gMDtcbmZ1bmN0aW9uIG5leHRJZCgpIHtcbiAgcmV0dXJuIGlkKys7XG59XG5cbmZ1bmN0aW9uIG1ha2VQcm9taXNlKHByb21pc2UpIHtcbiAgcHJvbWlzZVtQUk9NSVNFX0lEXSA9IGlkKys7XG4gIHByb21pc2UuX3N0YXRlID0gdW5kZWZpbmVkO1xuICBwcm9taXNlLl9yZXN1bHQgPSB1bmRlZmluZWQ7XG4gIHByb21pc2UuX3N1YnNjcmliZXJzID0gW107XG59XG5cbmZ1bmN0aW9uIEVudW1lcmF0b3IoQ29uc3RydWN0b3IsIGlucHV0KSB7XG4gIHRoaXMuX2luc3RhbmNlQ29uc3RydWN0b3IgPSBDb25zdHJ1Y3RvcjtcbiAgdGhpcy5wcm9taXNlID0gbmV3IENvbnN0cnVjdG9yKG5vb3ApO1xuXG4gIGlmICghdGhpcy5wcm9taXNlW1BST01JU0VfSURdKSB7XG4gICAgbWFrZVByb21pc2UodGhpcy5wcm9taXNlKTtcbiAgfVxuXG4gIGlmIChpc0FycmF5KGlucHV0KSkge1xuICAgIHRoaXMuX2lucHV0ID0gaW5wdXQ7XG4gICAgdGhpcy5sZW5ndGggPSBpbnB1dC5sZW5ndGg7XG4gICAgdGhpcy5fcmVtYWluaW5nID0gaW5wdXQubGVuZ3RoO1xuXG4gICAgdGhpcy5fcmVzdWx0ID0gbmV3IEFycmF5KHRoaXMubGVuZ3RoKTtcblxuICAgIGlmICh0aGlzLmxlbmd0aCA9PT0gMCkge1xuICAgICAgZnVsZmlsbCh0aGlzLnByb21pc2UsIHRoaXMuX3Jlc3VsdCk7XG4gICAgfSBlbHNlIHtcbiAgICAgIHRoaXMubGVuZ3RoID0gdGhpcy5sZW5ndGggfHwgMDtcbiAgICAgIHRoaXMuX2VudW1lcmF0ZSgpO1xuICAgICAgaWYgKHRoaXMuX3JlbWFpbmluZyA9PT0gMCkge1xuICAgICAgICBmdWxmaWxsKHRoaXMucHJvbWlzZSwgdGhpcy5fcmVzdWx0KTtcbiAgICAgIH1cbiAgICB9XG4gIH0gZWxzZSB7XG4gICAgX3JlamVjdCh0aGlzLnByb21pc2UsIHZhbGlkYXRpb25FcnJvcigpKTtcbiAgfVxufVxuXG5mdW5jdGlvbiB2YWxpZGF0aW9uRXJyb3IoKSB7XG4gIHJldHVybiBuZXcgRXJyb3IoJ0FycmF5IE1ldGhvZHMgbXVzdCBiZSBwcm92aWRlZCBhbiBBcnJheScpO1xufTtcblxuRW51bWVyYXRvci5wcm90b3R5cGUuX2VudW1lcmF0ZSA9IGZ1bmN0aW9uICgpIHtcbiAgdmFyIGxlbmd0aCA9IHRoaXMubGVuZ3RoO1xuICB2YXIgX2lucHV0ID0gdGhpcy5faW5wdXQ7XG5cbiAgZm9yICh2YXIgaSA9IDA7IHRoaXMuX3N0YXRlID09PSBQRU5ESU5HICYmIGkgPCBsZW5ndGg7IGkrKykge1xuICAgIHRoaXMuX2VhY2hFbnRyeShfaW5wdXRbaV0sIGkpO1xuICB9XG59O1xuXG5FbnVtZXJhdG9yLnByb3RvdHlwZS5fZWFjaEVudHJ5ID0gZnVuY3Rpb24gKGVudHJ5LCBpKSB7XG4gIHZhciBjID0gdGhpcy5faW5zdGFuY2VDb25zdHJ1Y3RvcjtcbiAgdmFyIHJlc29sdmUkJCA9IGMucmVzb2x2ZTtcblxuICBpZiAocmVzb2x2ZSQkID09PSByZXNvbHZlKSB7XG4gICAgdmFyIF90aGVuID0gZ2V0VGhlbihlbnRyeSk7XG5cbiAgICBpZiAoX3RoZW4gPT09IHRoZW4gJiYgZW50cnkuX3N0YXRlICE9PSBQRU5ESU5HKSB7XG4gICAgICB0aGlzLl9zZXR0bGVkQXQoZW50cnkuX3N0YXRlLCBpLCBlbnRyeS5fcmVzdWx0KTtcbiAgICB9IGVsc2UgaWYgKHR5cGVvZiBfdGhlbiAhPT0gJ2Z1bmN0aW9uJykge1xuICAgICAgdGhpcy5fcmVtYWluaW5nLS07XG4gICAgICB0aGlzLl9yZXN1bHRbaV0gPSBlbnRyeTtcbiAgICB9IGVsc2UgaWYgKGMgPT09IFByb21pc2UpIHtcbiAgICAgIHZhciBwcm9taXNlID0gbmV3IGMobm9vcCk7XG4gICAgICBoYW5kbGVNYXliZVRoZW5hYmxlKHByb21pc2UsIGVudHJ5LCBfdGhlbik7XG4gICAgICB0aGlzLl93aWxsU2V0dGxlQXQocHJvbWlzZSwgaSk7XG4gICAgfSBlbHNlIHtcbiAgICAgIHRoaXMuX3dpbGxTZXR0bGVBdChuZXcgYyhmdW5jdGlvbiAocmVzb2x2ZSQkKSB7XG4gICAgICAgIHJldHVybiByZXNvbHZlJCQoZW50cnkpO1xuICAgICAgfSksIGkpO1xuICAgIH1cbiAgfSBlbHNlIHtcbiAgICB0aGlzLl93aWxsU2V0dGxlQXQocmVzb2x2ZSQkKGVudHJ5KSwgaSk7XG4gIH1cbn07XG5cbkVudW1lcmF0b3IucHJvdG90eXBlLl9zZXR0bGVkQXQgPSBmdW5jdGlvbiAoc3RhdGUsIGksIHZhbHVlKSB7XG4gIHZhciBwcm9taXNlID0gdGhpcy5wcm9taXNlO1xuXG4gIGlmIChwcm9taXNlLl9zdGF0ZSA9PT0gUEVORElORykge1xuICAgIHRoaXMuX3JlbWFpbmluZy0tO1xuXG4gICAgaWYgKHN0YXRlID09PSBSRUpFQ1RFRCkge1xuICAgICAgX3JlamVjdChwcm9taXNlLCB2YWx1ZSk7XG4gICAgfSBlbHNlIHtcbiAgICAgIHRoaXMuX3Jlc3VsdFtpXSA9IHZhbHVlO1xuICAgIH1cbiAgfVxuXG4gIGlmICh0aGlzLl9yZW1haW5pbmcgPT09IDApIHtcbiAgICBmdWxmaWxsKHByb21pc2UsIHRoaXMuX3Jlc3VsdCk7XG4gIH1cbn07XG5cbkVudW1lcmF0b3IucHJvdG90eXBlLl93aWxsU2V0dGxlQXQgPSBmdW5jdGlvbiAocHJvbWlzZSwgaSkge1xuICB2YXIgZW51bWVyYXRvciA9IHRoaXM7XG5cbiAgc3Vic2NyaWJlKHByb21pc2UsIHVuZGVmaW5lZCwgZnVuY3Rpb24gKHZhbHVlKSB7XG4gICAgcmV0dXJuIGVudW1lcmF0b3IuX3NldHRsZWRBdChGVUxGSUxMRUQsIGksIHZhbHVlKTtcbiAgfSwgZnVuY3Rpb24gKHJlYXNvbikge1xuICAgIHJldHVybiBlbnVtZXJhdG9yLl9zZXR0bGVkQXQoUkVKRUNURUQsIGksIHJlYXNvbik7XG4gIH0pO1xufTtcblxuLyoqXG4gIGBQcm9taXNlLmFsbGAgYWNjZXB0cyBhbiBhcnJheSBvZiBwcm9taXNlcywgYW5kIHJldHVybnMgYSBuZXcgcHJvbWlzZSB3aGljaFxuICBpcyBmdWxmaWxsZWQgd2l0aCBhbiBhcnJheSBvZiBmdWxmaWxsbWVudCB2YWx1ZXMgZm9yIHRoZSBwYXNzZWQgcHJvbWlzZXMsIG9yXG4gIHJlamVjdGVkIHdpdGggdGhlIHJlYXNvbiBvZiB0aGUgZmlyc3QgcGFzc2VkIHByb21pc2UgdG8gYmUgcmVqZWN0ZWQuIEl0IGNhc3RzIGFsbFxuICBlbGVtZW50cyBvZiB0aGUgcGFzc2VkIGl0ZXJhYmxlIHRvIHByb21pc2VzIGFzIGl0IHJ1bnMgdGhpcyBhbGdvcml0aG0uXG5cbiAgRXhhbXBsZTpcblxuICBgYGBqYXZhc2NyaXB0XG4gIGxldCBwcm9taXNlMSA9IHJlc29sdmUoMSk7XG4gIGxldCBwcm9taXNlMiA9IHJlc29sdmUoMik7XG4gIGxldCBwcm9taXNlMyA9IHJlc29sdmUoMyk7XG4gIGxldCBwcm9taXNlcyA9IFsgcHJvbWlzZTEsIHByb21pc2UyLCBwcm9taXNlMyBdO1xuXG4gIFByb21pc2UuYWxsKHByb21pc2VzKS50aGVuKGZ1bmN0aW9uKGFycmF5KXtcbiAgICAvLyBUaGUgYXJyYXkgaGVyZSB3b3VsZCBiZSBbIDEsIDIsIDMgXTtcbiAgfSk7XG4gIGBgYFxuXG4gIElmIGFueSBvZiB0aGUgYHByb21pc2VzYCBnaXZlbiB0byBgYWxsYCBhcmUgcmVqZWN0ZWQsIHRoZSBmaXJzdCBwcm9taXNlXG4gIHRoYXQgaXMgcmVqZWN0ZWQgd2lsbCBiZSBnaXZlbiBhcyBhbiBhcmd1bWVudCB0byB0aGUgcmV0dXJuZWQgcHJvbWlzZXMnc1xuICByZWplY3Rpb24gaGFuZGxlci4gRm9yIGV4YW1wbGU6XG5cbiAgRXhhbXBsZTpcblxuICBgYGBqYXZhc2NyaXB0XG4gIGxldCBwcm9taXNlMSA9IHJlc29sdmUoMSk7XG4gIGxldCBwcm9taXNlMiA9IHJlamVjdChuZXcgRXJyb3IoXCIyXCIpKTtcbiAgbGV0IHByb21pc2UzID0gcmVqZWN0KG5ldyBFcnJvcihcIjNcIikpO1xuICBsZXQgcHJvbWlzZXMgPSBbIHByb21pc2UxLCBwcm9taXNlMiwgcHJvbWlzZTMgXTtcblxuICBQcm9taXNlLmFsbChwcm9taXNlcykudGhlbihmdW5jdGlvbihhcnJheSl7XG4gICAgLy8gQ29kZSBoZXJlIG5ldmVyIHJ1bnMgYmVjYXVzZSB0aGVyZSBhcmUgcmVqZWN0ZWQgcHJvbWlzZXMhXG4gIH0sIGZ1bmN0aW9uKGVycm9yKSB7XG4gICAgLy8gZXJyb3IubWVzc2FnZSA9PT0gXCIyXCJcbiAgfSk7XG4gIGBgYFxuXG4gIEBtZXRob2QgYWxsXG4gIEBzdGF0aWNcbiAgQHBhcmFtIHtBcnJheX0gZW50cmllcyBhcnJheSBvZiBwcm9taXNlc1xuICBAcGFyYW0ge1N0cmluZ30gbGFiZWwgb3B0aW9uYWwgc3RyaW5nIGZvciBsYWJlbGluZyB0aGUgcHJvbWlzZS5cbiAgVXNlZnVsIGZvciB0b29saW5nLlxuICBAcmV0dXJuIHtQcm9taXNlfSBwcm9taXNlIHRoYXQgaXMgZnVsZmlsbGVkIHdoZW4gYWxsIGBwcm9taXNlc2AgaGF2ZSBiZWVuXG4gIGZ1bGZpbGxlZCwgb3IgcmVqZWN0ZWQgaWYgYW55IG9mIHRoZW0gYmVjb21lIHJlamVjdGVkLlxuICBAc3RhdGljXG4qL1xuZnVuY3Rpb24gYWxsKGVudHJpZXMpIHtcbiAgcmV0dXJuIG5ldyBFbnVtZXJhdG9yKHRoaXMsIGVudHJpZXMpLnByb21pc2U7XG59XG5cbi8qKlxuICBgUHJvbWlzZS5yYWNlYCByZXR1cm5zIGEgbmV3IHByb21pc2Ugd2hpY2ggaXMgc2V0dGxlZCBpbiB0aGUgc2FtZSB3YXkgYXMgdGhlXG4gIGZpcnN0IHBhc3NlZCBwcm9taXNlIHRvIHNldHRsZS5cblxuICBFeGFtcGxlOlxuXG4gIGBgYGphdmFzY3JpcHRcbiAgbGV0IHByb21pc2UxID0gbmV3IFByb21pc2UoZnVuY3Rpb24ocmVzb2x2ZSwgcmVqZWN0KXtcbiAgICBzZXRUaW1lb3V0KGZ1bmN0aW9uKCl7XG4gICAgICByZXNvbHZlKCdwcm9taXNlIDEnKTtcbiAgICB9LCAyMDApO1xuICB9KTtcblxuICBsZXQgcHJvbWlzZTIgPSBuZXcgUHJvbWlzZShmdW5jdGlvbihyZXNvbHZlLCByZWplY3Qpe1xuICAgIHNldFRpbWVvdXQoZnVuY3Rpb24oKXtcbiAgICAgIHJlc29sdmUoJ3Byb21pc2UgMicpO1xuICAgIH0sIDEwMCk7XG4gIH0pO1xuXG4gIFByb21pc2UucmFjZShbcHJvbWlzZTEsIHByb21pc2UyXSkudGhlbihmdW5jdGlvbihyZXN1bHQpe1xuICAgIC8vIHJlc3VsdCA9PT0gJ3Byb21pc2UgMicgYmVjYXVzZSBpdCB3YXMgcmVzb2x2ZWQgYmVmb3JlIHByb21pc2UxXG4gICAgLy8gd2FzIHJlc29sdmVkLlxuICB9KTtcbiAgYGBgXG5cbiAgYFByb21pc2UucmFjZWAgaXMgZGV0ZXJtaW5pc3RpYyBpbiB0aGF0IG9ubHkgdGhlIHN0YXRlIG9mIHRoZSBmaXJzdFxuICBzZXR0bGVkIHByb21pc2UgbWF0dGVycy4gRm9yIGV4YW1wbGUsIGV2ZW4gaWYgb3RoZXIgcHJvbWlzZXMgZ2l2ZW4gdG8gdGhlXG4gIGBwcm9taXNlc2AgYXJyYXkgYXJndW1lbnQgYXJlIHJlc29sdmVkLCBidXQgdGhlIGZpcnN0IHNldHRsZWQgcHJvbWlzZSBoYXNcbiAgYmVjb21lIHJlamVjdGVkIGJlZm9yZSB0aGUgb3RoZXIgcHJvbWlzZXMgYmVjYW1lIGZ1bGZpbGxlZCwgdGhlIHJldHVybmVkXG4gIHByb21pc2Ugd2lsbCBiZWNvbWUgcmVqZWN0ZWQ6XG5cbiAgYGBgamF2YXNjcmlwdFxuICBsZXQgcHJvbWlzZTEgPSBuZXcgUHJvbWlzZShmdW5jdGlvbihyZXNvbHZlLCByZWplY3Qpe1xuICAgIHNldFRpbWVvdXQoZnVuY3Rpb24oKXtcbiAgICAgIHJlc29sdmUoJ3Byb21pc2UgMScpO1xuICAgIH0sIDIwMCk7XG4gIH0pO1xuXG4gIGxldCBwcm9taXNlMiA9IG5ldyBQcm9taXNlKGZ1bmN0aW9uKHJlc29sdmUsIHJlamVjdCl7XG4gICAgc2V0VGltZW91dChmdW5jdGlvbigpe1xuICAgICAgcmVqZWN0KG5ldyBFcnJvcigncHJvbWlzZSAyJykpO1xuICAgIH0sIDEwMCk7XG4gIH0pO1xuXG4gIFByb21pc2UucmFjZShbcHJvbWlzZTEsIHByb21pc2UyXSkudGhlbihmdW5jdGlvbihyZXN1bHQpe1xuICAgIC8vIENvZGUgaGVyZSBuZXZlciBydW5zXG4gIH0sIGZ1bmN0aW9uKHJlYXNvbil7XG4gICAgLy8gcmVhc29uLm1lc3NhZ2UgPT09ICdwcm9taXNlIDInIGJlY2F1c2UgcHJvbWlzZSAyIGJlY2FtZSByZWplY3RlZCBiZWZvcmVcbiAgICAvLyBwcm9taXNlIDEgYmVjYW1lIGZ1bGZpbGxlZFxuICB9KTtcbiAgYGBgXG5cbiAgQW4gZXhhbXBsZSByZWFsLXdvcmxkIHVzZSBjYXNlIGlzIGltcGxlbWVudGluZyB0aW1lb3V0czpcblxuICBgYGBqYXZhc2NyaXB0XG4gIFByb21pc2UucmFjZShbYWpheCgnZm9vLmpzb24nKSwgdGltZW91dCg1MDAwKV0pXG4gIGBgYFxuXG4gIEBtZXRob2QgcmFjZVxuICBAc3RhdGljXG4gIEBwYXJhbSB7QXJyYXl9IHByb21pc2VzIGFycmF5IG9mIHByb21pc2VzIHRvIG9ic2VydmVcbiAgVXNlZnVsIGZvciB0b29saW5nLlxuICBAcmV0dXJuIHtQcm9taXNlfSBhIHByb21pc2Ugd2hpY2ggc2V0dGxlcyBpbiB0aGUgc2FtZSB3YXkgYXMgdGhlIGZpcnN0IHBhc3NlZFxuICBwcm9taXNlIHRvIHNldHRsZS5cbiovXG5mdW5jdGlvbiByYWNlKGVudHJpZXMpIHtcbiAgLypqc2hpbnQgdmFsaWR0aGlzOnRydWUgKi9cbiAgdmFyIENvbnN0cnVjdG9yID0gdGhpcztcblxuICBpZiAoIWlzQXJyYXkoZW50cmllcykpIHtcbiAgICByZXR1cm4gbmV3IENvbnN0cnVjdG9yKGZ1bmN0aW9uIChfLCByZWplY3QpIHtcbiAgICAgIHJldHVybiByZWplY3QobmV3IFR5cGVFcnJvcignWW91IG11c3QgcGFzcyBhbiBhcnJheSB0byByYWNlLicpKTtcbiAgICB9KTtcbiAgfSBlbHNlIHtcbiAgICByZXR1cm4gbmV3IENvbnN0cnVjdG9yKGZ1bmN0aW9uIChyZXNvbHZlLCByZWplY3QpIHtcbiAgICAgIHZhciBsZW5ndGggPSBlbnRyaWVzLmxlbmd0aDtcbiAgICAgIGZvciAodmFyIGkgPSAwOyBpIDwgbGVuZ3RoOyBpKyspIHtcbiAgICAgICAgQ29uc3RydWN0b3IucmVzb2x2ZShlbnRyaWVzW2ldKS50aGVuKHJlc29sdmUsIHJlamVjdCk7XG4gICAgICB9XG4gICAgfSk7XG4gIH1cbn1cblxuLyoqXG4gIGBQcm9taXNlLnJlamVjdGAgcmV0dXJucyBhIHByb21pc2UgcmVqZWN0ZWQgd2l0aCB0aGUgcGFzc2VkIGByZWFzb25gLlxuICBJdCBpcyBzaG9ydGhhbmQgZm9yIHRoZSBmb2xsb3dpbmc6XG5cbiAgYGBgamF2YXNjcmlwdFxuICBsZXQgcHJvbWlzZSA9IG5ldyBQcm9taXNlKGZ1bmN0aW9uKHJlc29sdmUsIHJlamVjdCl7XG4gICAgcmVqZWN0KG5ldyBFcnJvcignV0hPT1BTJykpO1xuICB9KTtcblxuICBwcm9taXNlLnRoZW4oZnVuY3Rpb24odmFsdWUpe1xuICAgIC8vIENvZGUgaGVyZSBkb2Vzbid0IHJ1biBiZWNhdXNlIHRoZSBwcm9taXNlIGlzIHJlamVjdGVkIVxuICB9LCBmdW5jdGlvbihyZWFzb24pe1xuICAgIC8vIHJlYXNvbi5tZXNzYWdlID09PSAnV0hPT1BTJ1xuICB9KTtcbiAgYGBgXG5cbiAgSW5zdGVhZCBvZiB3cml0aW5nIHRoZSBhYm92ZSwgeW91ciBjb2RlIG5vdyBzaW1wbHkgYmVjb21lcyB0aGUgZm9sbG93aW5nOlxuXG4gIGBgYGphdmFzY3JpcHRcbiAgbGV0IHByb21pc2UgPSBQcm9taXNlLnJlamVjdChuZXcgRXJyb3IoJ1dIT09QUycpKTtcblxuICBwcm9taXNlLnRoZW4oZnVuY3Rpb24odmFsdWUpe1xuICAgIC8vIENvZGUgaGVyZSBkb2Vzbid0IHJ1biBiZWNhdXNlIHRoZSBwcm9taXNlIGlzIHJlamVjdGVkIVxuICB9LCBmdW5jdGlvbihyZWFzb24pe1xuICAgIC8vIHJlYXNvbi5tZXNzYWdlID09PSAnV0hPT1BTJ1xuICB9KTtcbiAgYGBgXG5cbiAgQG1ldGhvZCByZWplY3RcbiAgQHN0YXRpY1xuICBAcGFyYW0ge0FueX0gcmVhc29uIHZhbHVlIHRoYXQgdGhlIHJldHVybmVkIHByb21pc2Ugd2lsbCBiZSByZWplY3RlZCB3aXRoLlxuICBVc2VmdWwgZm9yIHRvb2xpbmcuXG4gIEByZXR1cm4ge1Byb21pc2V9IGEgcHJvbWlzZSByZWplY3RlZCB3aXRoIHRoZSBnaXZlbiBgcmVhc29uYC5cbiovXG5mdW5jdGlvbiByZWplY3QocmVhc29uKSB7XG4gIC8qanNoaW50IHZhbGlkdGhpczp0cnVlICovXG4gIHZhciBDb25zdHJ1Y3RvciA9IHRoaXM7XG4gIHZhciBwcm9taXNlID0gbmV3IENvbnN0cnVjdG9yKG5vb3ApO1xuICBfcmVqZWN0KHByb21pc2UsIHJlYXNvbik7XG4gIHJldHVybiBwcm9taXNlO1xufVxuXG5mdW5jdGlvbiBuZWVkc1Jlc29sdmVyKCkge1xuICB0aHJvdyBuZXcgVHlwZUVycm9yKCdZb3UgbXVzdCBwYXNzIGEgcmVzb2x2ZXIgZnVuY3Rpb24gYXMgdGhlIGZpcnN0IGFyZ3VtZW50IHRvIHRoZSBwcm9taXNlIGNvbnN0cnVjdG9yJyk7XG59XG5cbmZ1bmN0aW9uIG5lZWRzTmV3KCkge1xuICB0aHJvdyBuZXcgVHlwZUVycm9yKFwiRmFpbGVkIHRvIGNvbnN0cnVjdCAnUHJvbWlzZSc6IFBsZWFzZSB1c2UgdGhlICduZXcnIG9wZXJhdG9yLCB0aGlzIG9iamVjdCBjb25zdHJ1Y3RvciBjYW5ub3QgYmUgY2FsbGVkIGFzIGEgZnVuY3Rpb24uXCIpO1xufVxuXG4vKipcbiAgUHJvbWlzZSBvYmplY3RzIHJlcHJlc2VudCB0aGUgZXZlbnR1YWwgcmVzdWx0IG9mIGFuIGFzeW5jaHJvbm91cyBvcGVyYXRpb24uIFRoZVxuICBwcmltYXJ5IHdheSBvZiBpbnRlcmFjdGluZyB3aXRoIGEgcHJvbWlzZSBpcyB0aHJvdWdoIGl0cyBgdGhlbmAgbWV0aG9kLCB3aGljaFxuICByZWdpc3RlcnMgY2FsbGJhY2tzIHRvIHJlY2VpdmUgZWl0aGVyIGEgcHJvbWlzZSdzIGV2ZW50dWFsIHZhbHVlIG9yIHRoZSByZWFzb25cbiAgd2h5IHRoZSBwcm9taXNlIGNhbm5vdCBiZSBmdWxmaWxsZWQuXG5cbiAgVGVybWlub2xvZ3lcbiAgLS0tLS0tLS0tLS1cblxuICAtIGBwcm9taXNlYCBpcyBhbiBvYmplY3Qgb3IgZnVuY3Rpb24gd2l0aCBhIGB0aGVuYCBtZXRob2Qgd2hvc2UgYmVoYXZpb3IgY29uZm9ybXMgdG8gdGhpcyBzcGVjaWZpY2F0aW9uLlxuICAtIGB0aGVuYWJsZWAgaXMgYW4gb2JqZWN0IG9yIGZ1bmN0aW9uIHRoYXQgZGVmaW5lcyBhIGB0aGVuYCBtZXRob2QuXG4gIC0gYHZhbHVlYCBpcyBhbnkgbGVnYWwgSmF2YVNjcmlwdCB2YWx1ZSAoaW5jbHVkaW5nIHVuZGVmaW5lZCwgYSB0aGVuYWJsZSwgb3IgYSBwcm9taXNlKS5cbiAgLSBgZXhjZXB0aW9uYCBpcyBhIHZhbHVlIHRoYXQgaXMgdGhyb3duIHVzaW5nIHRoZSB0aHJvdyBzdGF0ZW1lbnQuXG4gIC0gYHJlYXNvbmAgaXMgYSB2YWx1ZSB0aGF0IGluZGljYXRlcyB3aHkgYSBwcm9taXNlIHdhcyByZWplY3RlZC5cbiAgLSBgc2V0dGxlZGAgdGhlIGZpbmFsIHJlc3Rpbmcgc3RhdGUgb2YgYSBwcm9taXNlLCBmdWxmaWxsZWQgb3IgcmVqZWN0ZWQuXG5cbiAgQSBwcm9taXNlIGNhbiBiZSBpbiBvbmUgb2YgdGhyZWUgc3RhdGVzOiBwZW5kaW5nLCBmdWxmaWxsZWQsIG9yIHJlamVjdGVkLlxuXG4gIFByb21pc2VzIHRoYXQgYXJlIGZ1bGZpbGxlZCBoYXZlIGEgZnVsZmlsbG1lbnQgdmFsdWUgYW5kIGFyZSBpbiB0aGUgZnVsZmlsbGVkXG4gIHN0YXRlLiAgUHJvbWlzZXMgdGhhdCBhcmUgcmVqZWN0ZWQgaGF2ZSBhIHJlamVjdGlvbiByZWFzb24gYW5kIGFyZSBpbiB0aGVcbiAgcmVqZWN0ZWQgc3RhdGUuICBBIGZ1bGZpbGxtZW50IHZhbHVlIGlzIG5ldmVyIGEgdGhlbmFibGUuXG5cbiAgUHJvbWlzZXMgY2FuIGFsc28gYmUgc2FpZCB0byAqcmVzb2x2ZSogYSB2YWx1ZS4gIElmIHRoaXMgdmFsdWUgaXMgYWxzbyBhXG4gIHByb21pc2UsIHRoZW4gdGhlIG9yaWdpbmFsIHByb21pc2UncyBzZXR0bGVkIHN0YXRlIHdpbGwgbWF0Y2ggdGhlIHZhbHVlJ3NcbiAgc2V0dGxlZCBzdGF0ZS4gIFNvIGEgcHJvbWlzZSB0aGF0ICpyZXNvbHZlcyogYSBwcm9taXNlIHRoYXQgcmVqZWN0cyB3aWxsXG4gIGl0c2VsZiByZWplY3QsIGFuZCBhIHByb21pc2UgdGhhdCAqcmVzb2x2ZXMqIGEgcHJvbWlzZSB0aGF0IGZ1bGZpbGxzIHdpbGxcbiAgaXRzZWxmIGZ1bGZpbGwuXG5cblxuICBCYXNpYyBVc2FnZTpcbiAgLS0tLS0tLS0tLS0tXG5cbiAgYGBganNcbiAgbGV0IHByb21pc2UgPSBuZXcgUHJvbWlzZShmdW5jdGlvbihyZXNvbHZlLCByZWplY3QpIHtcbiAgICAvLyBvbiBzdWNjZXNzXG4gICAgcmVzb2x2ZSh2YWx1ZSk7XG5cbiAgICAvLyBvbiBmYWlsdXJlXG4gICAgcmVqZWN0KHJlYXNvbik7XG4gIH0pO1xuXG4gIHByb21pc2UudGhlbihmdW5jdGlvbih2YWx1ZSkge1xuICAgIC8vIG9uIGZ1bGZpbGxtZW50XG4gIH0sIGZ1bmN0aW9uKHJlYXNvbikge1xuICAgIC8vIG9uIHJlamVjdGlvblxuICB9KTtcbiAgYGBgXG5cbiAgQWR2YW5jZWQgVXNhZ2U6XG4gIC0tLS0tLS0tLS0tLS0tLVxuXG4gIFByb21pc2VzIHNoaW5lIHdoZW4gYWJzdHJhY3RpbmcgYXdheSBhc3luY2hyb25vdXMgaW50ZXJhY3Rpb25zIHN1Y2ggYXNcbiAgYFhNTEh0dHBSZXF1ZXN0YHMuXG5cbiAgYGBganNcbiAgZnVuY3Rpb24gZ2V0SlNPTih1cmwpIHtcbiAgICByZXR1cm4gbmV3IFByb21pc2UoZnVuY3Rpb24ocmVzb2x2ZSwgcmVqZWN0KXtcbiAgICAgIGxldCB4aHIgPSBuZXcgWE1MSHR0cFJlcXVlc3QoKTtcblxuICAgICAgeGhyLm9wZW4oJ0dFVCcsIHVybCk7XG4gICAgICB4aHIub25yZWFkeXN0YXRlY2hhbmdlID0gaGFuZGxlcjtcbiAgICAgIHhoci5yZXNwb25zZVR5cGUgPSAnanNvbic7XG4gICAgICB4aHIuc2V0UmVxdWVzdEhlYWRlcignQWNjZXB0JywgJ2FwcGxpY2F0aW9uL2pzb24nKTtcbiAgICAgIHhoci5zZW5kKCk7XG5cbiAgICAgIGZ1bmN0aW9uIGhhbmRsZXIoKSB7XG4gICAgICAgIGlmICh0aGlzLnJlYWR5U3RhdGUgPT09IHRoaXMuRE9ORSkge1xuICAgICAgICAgIGlmICh0aGlzLnN0YXR1cyA9PT0gMjAwKSB7XG4gICAgICAgICAgICByZXNvbHZlKHRoaXMucmVzcG9uc2UpO1xuICAgICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgICByZWplY3QobmV3IEVycm9yKCdnZXRKU09OOiBgJyArIHVybCArICdgIGZhaWxlZCB3aXRoIHN0YXR1czogWycgKyB0aGlzLnN0YXR1cyArICddJykpO1xuICAgICAgICAgIH1cbiAgICAgICAgfVxuICAgICAgfTtcbiAgICB9KTtcbiAgfVxuXG4gIGdldEpTT04oJy9wb3N0cy5qc29uJykudGhlbihmdW5jdGlvbihqc29uKSB7XG4gICAgLy8gb24gZnVsZmlsbG1lbnRcbiAgfSwgZnVuY3Rpb24ocmVhc29uKSB7XG4gICAgLy8gb24gcmVqZWN0aW9uXG4gIH0pO1xuICBgYGBcblxuICBVbmxpa2UgY2FsbGJhY2tzLCBwcm9taXNlcyBhcmUgZ3JlYXQgY29tcG9zYWJsZSBwcmltaXRpdmVzLlxuXG4gIGBgYGpzXG4gIFByb21pc2UuYWxsKFtcbiAgICBnZXRKU09OKCcvcG9zdHMnKSxcbiAgICBnZXRKU09OKCcvY29tbWVudHMnKVxuICBdKS50aGVuKGZ1bmN0aW9uKHZhbHVlcyl7XG4gICAgdmFsdWVzWzBdIC8vID0+IHBvc3RzSlNPTlxuICAgIHZhbHVlc1sxXSAvLyA9PiBjb21tZW50c0pTT05cblxuICAgIHJldHVybiB2YWx1ZXM7XG4gIH0pO1xuICBgYGBcblxuICBAY2xhc3MgUHJvbWlzZVxuICBAcGFyYW0ge2Z1bmN0aW9ufSByZXNvbHZlclxuICBVc2VmdWwgZm9yIHRvb2xpbmcuXG4gIEBjb25zdHJ1Y3RvclxuKi9cbmZ1bmN0aW9uIFByb21pc2UocmVzb2x2ZXIpIHtcbiAgdGhpc1tQUk9NSVNFX0lEXSA9IG5leHRJZCgpO1xuICB0aGlzLl9yZXN1bHQgPSB0aGlzLl9zdGF0ZSA9IHVuZGVmaW5lZDtcbiAgdGhpcy5fc3Vic2NyaWJlcnMgPSBbXTtcblxuICBpZiAobm9vcCAhPT0gcmVzb2x2ZXIpIHtcbiAgICB0eXBlb2YgcmVzb2x2ZXIgIT09ICdmdW5jdGlvbicgJiYgbmVlZHNSZXNvbHZlcigpO1xuICAgIHRoaXMgaW5zdGFuY2VvZiBQcm9taXNlID8gaW5pdGlhbGl6ZVByb21pc2UodGhpcywgcmVzb2x2ZXIpIDogbmVlZHNOZXcoKTtcbiAgfVxufVxuXG5Qcm9taXNlLmFsbCA9IGFsbDtcblByb21pc2UucmFjZSA9IHJhY2U7XG5Qcm9taXNlLnJlc29sdmUgPSByZXNvbHZlO1xuUHJvbWlzZS5yZWplY3QgPSByZWplY3Q7XG5Qcm9taXNlLl9zZXRTY2hlZHVsZXIgPSBzZXRTY2hlZHVsZXI7XG5Qcm9taXNlLl9zZXRBc2FwID0gc2V0QXNhcDtcblByb21pc2UuX2FzYXAgPSBhc2FwO1xuXG5Qcm9taXNlLnByb3RvdHlwZSA9IHtcbiAgY29uc3RydWN0b3I6IFByb21pc2UsXG5cbiAgLyoqXG4gICAgVGhlIHByaW1hcnkgd2F5IG9mIGludGVyYWN0aW5nIHdpdGggYSBwcm9taXNlIGlzIHRocm91Z2ggaXRzIGB0aGVuYCBtZXRob2QsXG4gICAgd2hpY2ggcmVnaXN0ZXJzIGNhbGxiYWNrcyB0byByZWNlaXZlIGVpdGhlciBhIHByb21pc2UncyBldmVudHVhbCB2YWx1ZSBvciB0aGVcbiAgICByZWFzb24gd2h5IHRoZSBwcm9taXNlIGNhbm5vdCBiZSBmdWxmaWxsZWQuXG4gIFxuICAgIGBgYGpzXG4gICAgZmluZFVzZXIoKS50aGVuKGZ1bmN0aW9uKHVzZXIpe1xuICAgICAgLy8gdXNlciBpcyBhdmFpbGFibGVcbiAgICB9LCBmdW5jdGlvbihyZWFzb24pe1xuICAgICAgLy8gdXNlciBpcyB1bmF2YWlsYWJsZSwgYW5kIHlvdSBhcmUgZ2l2ZW4gdGhlIHJlYXNvbiB3aHlcbiAgICB9KTtcbiAgICBgYGBcbiAgXG4gICAgQ2hhaW5pbmdcbiAgICAtLS0tLS0tLVxuICBcbiAgICBUaGUgcmV0dXJuIHZhbHVlIG9mIGB0aGVuYCBpcyBpdHNlbGYgYSBwcm9taXNlLiAgVGhpcyBzZWNvbmQsICdkb3duc3RyZWFtJ1xuICAgIHByb21pc2UgaXMgcmVzb2x2ZWQgd2l0aCB0aGUgcmV0dXJuIHZhbHVlIG9mIHRoZSBmaXJzdCBwcm9taXNlJ3MgZnVsZmlsbG1lbnRcbiAgICBvciByZWplY3Rpb24gaGFuZGxlciwgb3IgcmVqZWN0ZWQgaWYgdGhlIGhhbmRsZXIgdGhyb3dzIGFuIGV4Y2VwdGlvbi5cbiAgXG4gICAgYGBganNcbiAgICBmaW5kVXNlcigpLnRoZW4oZnVuY3Rpb24gKHVzZXIpIHtcbiAgICAgIHJldHVybiB1c2VyLm5hbWU7XG4gICAgfSwgZnVuY3Rpb24gKHJlYXNvbikge1xuICAgICAgcmV0dXJuICdkZWZhdWx0IG5hbWUnO1xuICAgIH0pLnRoZW4oZnVuY3Rpb24gKHVzZXJOYW1lKSB7XG4gICAgICAvLyBJZiBgZmluZFVzZXJgIGZ1bGZpbGxlZCwgYHVzZXJOYW1lYCB3aWxsIGJlIHRoZSB1c2VyJ3MgbmFtZSwgb3RoZXJ3aXNlIGl0XG4gICAgICAvLyB3aWxsIGJlIGAnZGVmYXVsdCBuYW1lJ2BcbiAgICB9KTtcbiAgXG4gICAgZmluZFVzZXIoKS50aGVuKGZ1bmN0aW9uICh1c2VyKSB7XG4gICAgICB0aHJvdyBuZXcgRXJyb3IoJ0ZvdW5kIHVzZXIsIGJ1dCBzdGlsbCB1bmhhcHB5Jyk7XG4gICAgfSwgZnVuY3Rpb24gKHJlYXNvbikge1xuICAgICAgdGhyb3cgbmV3IEVycm9yKCdgZmluZFVzZXJgIHJlamVjdGVkIGFuZCB3ZSdyZSB1bmhhcHB5Jyk7XG4gICAgfSkudGhlbihmdW5jdGlvbiAodmFsdWUpIHtcbiAgICAgIC8vIG5ldmVyIHJlYWNoZWRcbiAgICB9LCBmdW5jdGlvbiAocmVhc29uKSB7XG4gICAgICAvLyBpZiBgZmluZFVzZXJgIGZ1bGZpbGxlZCwgYHJlYXNvbmAgd2lsbCBiZSAnRm91bmQgdXNlciwgYnV0IHN0aWxsIHVuaGFwcHknLlxuICAgICAgLy8gSWYgYGZpbmRVc2VyYCByZWplY3RlZCwgYHJlYXNvbmAgd2lsbCBiZSAnYGZpbmRVc2VyYCByZWplY3RlZCBhbmQgd2UncmUgdW5oYXBweScuXG4gICAgfSk7XG4gICAgYGBgXG4gICAgSWYgdGhlIGRvd25zdHJlYW0gcHJvbWlzZSBkb2VzIG5vdCBzcGVjaWZ5IGEgcmVqZWN0aW9uIGhhbmRsZXIsIHJlamVjdGlvbiByZWFzb25zIHdpbGwgYmUgcHJvcGFnYXRlZCBmdXJ0aGVyIGRvd25zdHJlYW0uXG4gIFxuICAgIGBgYGpzXG4gICAgZmluZFVzZXIoKS50aGVuKGZ1bmN0aW9uICh1c2VyKSB7XG4gICAgICB0aHJvdyBuZXcgUGVkYWdvZ2ljYWxFeGNlcHRpb24oJ1Vwc3RyZWFtIGVycm9yJyk7XG4gICAgfSkudGhlbihmdW5jdGlvbiAodmFsdWUpIHtcbiAgICAgIC8vIG5ldmVyIHJlYWNoZWRcbiAgICB9KS50aGVuKGZ1bmN0aW9uICh2YWx1ZSkge1xuICAgICAgLy8gbmV2ZXIgcmVhY2hlZFxuICAgIH0sIGZ1bmN0aW9uIChyZWFzb24pIHtcbiAgICAgIC8vIFRoZSBgUGVkZ2Fnb2NpYWxFeGNlcHRpb25gIGlzIHByb3BhZ2F0ZWQgYWxsIHRoZSB3YXkgZG93biB0byBoZXJlXG4gICAgfSk7XG4gICAgYGBgXG4gIFxuICAgIEFzc2ltaWxhdGlvblxuICAgIC0tLS0tLS0tLS0tLVxuICBcbiAgICBTb21ldGltZXMgdGhlIHZhbHVlIHlvdSB3YW50IHRvIHByb3BhZ2F0ZSB0byBhIGRvd25zdHJlYW0gcHJvbWlzZSBjYW4gb25seSBiZVxuICAgIHJldHJpZXZlZCBhc3luY2hyb25vdXNseS4gVGhpcyBjYW4gYmUgYWNoaWV2ZWQgYnkgcmV0dXJuaW5nIGEgcHJvbWlzZSBpbiB0aGVcbiAgICBmdWxmaWxsbWVudCBvciByZWplY3Rpb24gaGFuZGxlci4gVGhlIGRvd25zdHJlYW0gcHJvbWlzZSB3aWxsIHRoZW4gYmUgcGVuZGluZ1xuICAgIHVudGlsIHRoZSByZXR1cm5lZCBwcm9taXNlIGlzIHNldHRsZWQuIFRoaXMgaXMgY2FsbGVkICphc3NpbWlsYXRpb24qLlxuICBcbiAgICBgYGBqc1xuICAgIGZpbmRVc2VyKCkudGhlbihmdW5jdGlvbiAodXNlcikge1xuICAgICAgcmV0dXJuIGZpbmRDb21tZW50c0J5QXV0aG9yKHVzZXIpO1xuICAgIH0pLnRoZW4oZnVuY3Rpb24gKGNvbW1lbnRzKSB7XG4gICAgICAvLyBUaGUgdXNlcidzIGNvbW1lbnRzIGFyZSBub3cgYXZhaWxhYmxlXG4gICAgfSk7XG4gICAgYGBgXG4gIFxuICAgIElmIHRoZSBhc3NpbWxpYXRlZCBwcm9taXNlIHJlamVjdHMsIHRoZW4gdGhlIGRvd25zdHJlYW0gcHJvbWlzZSB3aWxsIGFsc28gcmVqZWN0LlxuICBcbiAgICBgYGBqc1xuICAgIGZpbmRVc2VyKCkudGhlbihmdW5jdGlvbiAodXNlcikge1xuICAgICAgcmV0dXJuIGZpbmRDb21tZW50c0J5QXV0aG9yKHVzZXIpO1xuICAgIH0pLnRoZW4oZnVuY3Rpb24gKGNvbW1lbnRzKSB7XG4gICAgICAvLyBJZiBgZmluZENvbW1lbnRzQnlBdXRob3JgIGZ1bGZpbGxzLCB3ZSdsbCBoYXZlIHRoZSB2YWx1ZSBoZXJlXG4gICAgfSwgZnVuY3Rpb24gKHJlYXNvbikge1xuICAgICAgLy8gSWYgYGZpbmRDb21tZW50c0J5QXV0aG9yYCByZWplY3RzLCB3ZSdsbCBoYXZlIHRoZSByZWFzb24gaGVyZVxuICAgIH0pO1xuICAgIGBgYFxuICBcbiAgICBTaW1wbGUgRXhhbXBsZVxuICAgIC0tLS0tLS0tLS0tLS0tXG4gIFxuICAgIFN5bmNocm9ub3VzIEV4YW1wbGVcbiAgXG4gICAgYGBgamF2YXNjcmlwdFxuICAgIGxldCByZXN1bHQ7XG4gIFxuICAgIHRyeSB7XG4gICAgICByZXN1bHQgPSBmaW5kUmVzdWx0KCk7XG4gICAgICAvLyBzdWNjZXNzXG4gICAgfSBjYXRjaChyZWFzb24pIHtcbiAgICAgIC8vIGZhaWx1cmVcbiAgICB9XG4gICAgYGBgXG4gIFxuICAgIEVycmJhY2sgRXhhbXBsZVxuICBcbiAgICBgYGBqc1xuICAgIGZpbmRSZXN1bHQoZnVuY3Rpb24ocmVzdWx0LCBlcnIpe1xuICAgICAgaWYgKGVycikge1xuICAgICAgICAvLyBmYWlsdXJlXG4gICAgICB9IGVsc2Uge1xuICAgICAgICAvLyBzdWNjZXNzXG4gICAgICB9XG4gICAgfSk7XG4gICAgYGBgXG4gIFxuICAgIFByb21pc2UgRXhhbXBsZTtcbiAgXG4gICAgYGBgamF2YXNjcmlwdFxuICAgIGZpbmRSZXN1bHQoKS50aGVuKGZ1bmN0aW9uKHJlc3VsdCl7XG4gICAgICAvLyBzdWNjZXNzXG4gICAgfSwgZnVuY3Rpb24ocmVhc29uKXtcbiAgICAgIC8vIGZhaWx1cmVcbiAgICB9KTtcbiAgICBgYGBcbiAgXG4gICAgQWR2YW5jZWQgRXhhbXBsZVxuICAgIC0tLS0tLS0tLS0tLS0tXG4gIFxuICAgIFN5bmNocm9ub3VzIEV4YW1wbGVcbiAgXG4gICAgYGBgamF2YXNjcmlwdFxuICAgIGxldCBhdXRob3IsIGJvb2tzO1xuICBcbiAgICB0cnkge1xuICAgICAgYXV0aG9yID0gZmluZEF1dGhvcigpO1xuICAgICAgYm9va3MgID0gZmluZEJvb2tzQnlBdXRob3IoYXV0aG9yKTtcbiAgICAgIC8vIHN1Y2Nlc3NcbiAgICB9IGNhdGNoKHJlYXNvbikge1xuICAgICAgLy8gZmFpbHVyZVxuICAgIH1cbiAgICBgYGBcbiAgXG4gICAgRXJyYmFjayBFeGFtcGxlXG4gIFxuICAgIGBgYGpzXG4gIFxuICAgIGZ1bmN0aW9uIGZvdW5kQm9va3MoYm9va3MpIHtcbiAgXG4gICAgfVxuICBcbiAgICBmdW5jdGlvbiBmYWlsdXJlKHJlYXNvbikge1xuICBcbiAgICB9XG4gIFxuICAgIGZpbmRBdXRob3IoZnVuY3Rpb24oYXV0aG9yLCBlcnIpe1xuICAgICAgaWYgKGVycikge1xuICAgICAgICBmYWlsdXJlKGVycik7XG4gICAgICAgIC8vIGZhaWx1cmVcbiAgICAgIH0gZWxzZSB7XG4gICAgICAgIHRyeSB7XG4gICAgICAgICAgZmluZEJvb29rc0J5QXV0aG9yKGF1dGhvciwgZnVuY3Rpb24oYm9va3MsIGVycikge1xuICAgICAgICAgICAgaWYgKGVycikge1xuICAgICAgICAgICAgICBmYWlsdXJlKGVycik7XG4gICAgICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgICAgICB0cnkge1xuICAgICAgICAgICAgICAgIGZvdW5kQm9va3MoYm9va3MpO1xuICAgICAgICAgICAgICB9IGNhdGNoKHJlYXNvbikge1xuICAgICAgICAgICAgICAgIGZhaWx1cmUocmVhc29uKTtcbiAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgfVxuICAgICAgICAgIH0pO1xuICAgICAgICB9IGNhdGNoKGVycm9yKSB7XG4gICAgICAgICAgZmFpbHVyZShlcnIpO1xuICAgICAgICB9XG4gICAgICAgIC8vIHN1Y2Nlc3NcbiAgICAgIH1cbiAgICB9KTtcbiAgICBgYGBcbiAgXG4gICAgUHJvbWlzZSBFeGFtcGxlO1xuICBcbiAgICBgYGBqYXZhc2NyaXB0XG4gICAgZmluZEF1dGhvcigpLlxuICAgICAgdGhlbihmaW5kQm9va3NCeUF1dGhvcikuXG4gICAgICB0aGVuKGZ1bmN0aW9uKGJvb2tzKXtcbiAgICAgICAgLy8gZm91bmQgYm9va3NcbiAgICB9KS5jYXRjaChmdW5jdGlvbihyZWFzb24pe1xuICAgICAgLy8gc29tZXRoaW5nIHdlbnQgd3JvbmdcbiAgICB9KTtcbiAgICBgYGBcbiAgXG4gICAgQG1ldGhvZCB0aGVuXG4gICAgQHBhcmFtIHtGdW5jdGlvbn0gb25GdWxmaWxsZWRcbiAgICBAcGFyYW0ge0Z1bmN0aW9ufSBvblJlamVjdGVkXG4gICAgVXNlZnVsIGZvciB0b29saW5nLlxuICAgIEByZXR1cm4ge1Byb21pc2V9XG4gICovXG4gIHRoZW46IHRoZW4sXG5cbiAgLyoqXG4gICAgYGNhdGNoYCBpcyBzaW1wbHkgc3VnYXIgZm9yIGB0aGVuKHVuZGVmaW5lZCwgb25SZWplY3Rpb24pYCB3aGljaCBtYWtlcyBpdCB0aGUgc2FtZVxuICAgIGFzIHRoZSBjYXRjaCBibG9jayBvZiBhIHRyeS9jYXRjaCBzdGF0ZW1lbnQuXG4gIFxuICAgIGBgYGpzXG4gICAgZnVuY3Rpb24gZmluZEF1dGhvcigpe1xuICAgICAgdGhyb3cgbmV3IEVycm9yKCdjb3VsZG4ndCBmaW5kIHRoYXQgYXV0aG9yJyk7XG4gICAgfVxuICBcbiAgICAvLyBzeW5jaHJvbm91c1xuICAgIHRyeSB7XG4gICAgICBmaW5kQXV0aG9yKCk7XG4gICAgfSBjYXRjaChyZWFzb24pIHtcbiAgICAgIC8vIHNvbWV0aGluZyB3ZW50IHdyb25nXG4gICAgfVxuICBcbiAgICAvLyBhc3luYyB3aXRoIHByb21pc2VzXG4gICAgZmluZEF1dGhvcigpLmNhdGNoKGZ1bmN0aW9uKHJlYXNvbil7XG4gICAgICAvLyBzb21ldGhpbmcgd2VudCB3cm9uZ1xuICAgIH0pO1xuICAgIGBgYFxuICBcbiAgICBAbWV0aG9kIGNhdGNoXG4gICAgQHBhcmFtIHtGdW5jdGlvbn0gb25SZWplY3Rpb25cbiAgICBVc2VmdWwgZm9yIHRvb2xpbmcuXG4gICAgQHJldHVybiB7UHJvbWlzZX1cbiAgKi9cbiAgJ2NhdGNoJzogZnVuY3Rpb24gX2NhdGNoKG9uUmVqZWN0aW9uKSB7XG4gICAgcmV0dXJuIHRoaXMudGhlbihudWxsLCBvblJlamVjdGlvbik7XG4gIH1cbn07XG5cbmZ1bmN0aW9uIHBvbHlmaWxsKCkge1xuICAgIHZhciBsb2NhbCA9IHVuZGVmaW5lZDtcblxuICAgIGlmICh0eXBlb2YgZ2xvYmFsICE9PSAndW5kZWZpbmVkJykge1xuICAgICAgICBsb2NhbCA9IGdsb2JhbDtcbiAgICB9IGVsc2UgaWYgKHR5cGVvZiBzZWxmICE9PSAndW5kZWZpbmVkJykge1xuICAgICAgICBsb2NhbCA9IHNlbGY7XG4gICAgfSBlbHNlIHtcbiAgICAgICAgdHJ5IHtcbiAgICAgICAgICAgIGxvY2FsID0gRnVuY3Rpb24oJ3JldHVybiB0aGlzJykoKTtcbiAgICAgICAgfSBjYXRjaCAoZSkge1xuICAgICAgICAgICAgdGhyb3cgbmV3IEVycm9yKCdwb2x5ZmlsbCBmYWlsZWQgYmVjYXVzZSBnbG9iYWwgb2JqZWN0IGlzIHVuYXZhaWxhYmxlIGluIHRoaXMgZW52aXJvbm1lbnQnKTtcbiAgICAgICAgfVxuICAgIH1cblxuICAgIHZhciBQID0gbG9jYWwuUHJvbWlzZTtcblxuICAgIGlmIChQKSB7XG4gICAgICAgIHZhciBwcm9taXNlVG9TdHJpbmcgPSBudWxsO1xuICAgICAgICB0cnkge1xuICAgICAgICAgICAgcHJvbWlzZVRvU3RyaW5nID0gT2JqZWN0LnByb3RvdHlwZS50b1N0cmluZy5jYWxsKFAucmVzb2x2ZSgpKTtcbiAgICAgICAgfSBjYXRjaCAoZSkge1xuICAgICAgICAgICAgLy8gc2lsZW50bHkgaWdub3JlZFxuICAgICAgICB9XG5cbiAgICAgICAgaWYgKHByb21pc2VUb1N0cmluZyA9PT0gJ1tvYmplY3QgUHJvbWlzZV0nICYmICFQLmNhc3QpIHtcbiAgICAgICAgICAgIHJldHVybjtcbiAgICAgICAgfVxuICAgIH1cblxuICAgIGxvY2FsLlByb21pc2UgPSBQcm9taXNlO1xufVxuXG5wb2x5ZmlsbCgpO1xuLy8gU3RyYW5nZSBjb21wYXQuLlxuUHJvbWlzZS5wb2x5ZmlsbCA9IHBvbHlmaWxsO1xuUHJvbWlzZS5Qcm9taXNlID0gUHJvbWlzZTtcblxucmV0dXJuIFByb21pc2U7XG5cbn0pKSk7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1lczYtcHJvbWlzZS5tYXBcbn0pOyIsInJlcXVpcmUoJy9yb290L2FwcC9ub2RlX21vZHVsZXMvYXN5bmMtZGVmaW5lL2xpYi9hc3luY0RlZmluZS5qcycpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xuLypqc2xpbnQgZXM2LCBub2RlLCBicm93c2VyLCBtYXhsZW46IDEyMCAqL1xuLypnbG9iYWwgc2VsZiwgd2luZG93ICovXG5cblwidXNlIHN0cmljdFwiO1xuXG5tb2R1bGUuZXhwb3J0cyA9IChmdW5jdGlvbiAoKSB7XG5cbiAgICBcInVzZSBzdHJpY3RcIjtcblxuICAgIHZhciBnbG9iYWxPYmplY3QgPSB1bmRlZmluZWQ7XG5cbiAgICBmdW5jdGlvbiBpc0Z1bmN0aW9uKHgpIHtcbiAgICAgICAgcmV0dXJuIHR5cGVvZiB4ID09PSBcImZ1bmN0aW9uXCI7XG4gICAgfVxuXG4gICAgLy8gU2VlayB0aGUgZ2xvYmFsIG9iamVjdFxuICAgIGlmIChnbG9iYWwgIT09IHVuZGVmaW5lZCkge1xuICAgICAgICBnbG9iYWxPYmplY3QgPSBnbG9iYWw7XG4gICAgfSBlbHNlIGlmICh3aW5kb3cgIT09IHVuZGVmaW5lZCAmJiB3aW5kb3cuZG9jdW1lbnQpIHtcbiAgICAgICAgZ2xvYmFsT2JqZWN0ID0gd2luZG93O1xuICAgIH0gZWxzZSB7XG4gICAgICAgIGdsb2JhbE9iamVjdCA9IHNlbGY7XG4gICAgfVxuXG4gICAgLy8gVGVzdCBmb3IgYW55IG5hdGl2ZSBwcm9taXNlIGltcGxlbWVudGF0aW9uLCBhbmQgaWYgdGhhdFxuICAgIC8vIGltcGxlbWVudGF0aW9uIGFwcGVhcnMgdG8gY29uZm9ybSB0byB0aGUgc3BlY2lmaWNhdG9uLlxuICAgIC8vIFRoaXMgY29kZSBtb3N0bHkgbmlja2VkIGZyb20gdGhlIGVzNi1wcm9taXNlIG1vZHVsZSBwb2x5ZmlsbFxuICAgIC8vIGFuZCB0aGVuIGZvb2xlZCB3aXRoLlxuICAgIHZhciBoYXNQcm9taXNlU3VwcG9ydCA9IChmdW5jdGlvbiAoKSB7XG5cbiAgICAgICAgLy8gTm8gcHJvbWlzZSBvYmplY3QgYXQgYWxsLCBhbmQgaXQncyBhIG5vbi1zdGFydGVyXG4gICAgICAgIGlmICghZ2xvYmFsT2JqZWN0Lmhhc093blByb3BlcnR5KFwiUHJvbWlzZVwiKSkge1xuICAgICAgICAgICAgcmV0dXJuIGZhbHNlO1xuICAgICAgICB9XG5cbiAgICAgICAgLy8gVGhlcmUgaXMgYSBQcm9taXNlIG9iamVjdC4gRG9lcyBpdCBjb25mb3JtIHRvIHRoZSBzcGVjP1xuICAgICAgICB2YXIgUCA9IGdsb2JhbE9iamVjdC5Qcm9taXNlO1xuXG4gICAgICAgIC8vIFNvbWUgb2YgdGhlc2UgbWV0aG9kcyBhcmUgbWlzc2luZyBmcm9tXG4gICAgICAgIC8vIEZpcmVmb3gvQ2hyb21lIGV4cGVyaW1lbnRhbCBpbXBsZW1lbnRhdGlvbnNcbiAgICAgICAgaWYgKCFQLmhhc093blByb3BlcnR5KFwicmVzb2x2ZVwiKSB8fCAhUC5oYXNPd25Qcm9wZXJ0eShcInJlamVjdFwiKSkge1xuICAgICAgICAgICAgcmV0dXJuIGZhbHNlO1xuICAgICAgICB9XG5cbiAgICAgICAgaWYgKCFQLmhhc093blByb3BlcnR5KFwiYWxsXCIpIHx8ICFQLmhhc093blByb3BlcnR5KFwicmFjZVwiKSkge1xuICAgICAgICAgICAgcmV0dXJuIGZhbHNlO1xuICAgICAgICB9XG5cbiAgICAgICAgLy8gT2xkZXIgdmVyc2lvbiBvZiB0aGUgc3BlYyBoYWQgYSByZXNvbHZlciBvYmplY3RcbiAgICAgICAgLy8gYXMgdGhlIGFyZyByYXRoZXIgdGhhbiBhIGZ1bmN0aW9uXG4gICAgICAgIHJldHVybiAoZnVuY3Rpb24gKCkge1xuXG4gICAgICAgICAgICB2YXIgcmVzb2x2ZSA9IHVuZGVmaW5lZCxcbiAgICAgICAgICAgICAgICBwID0gbmV3IGdsb2JhbE9iamVjdC5Qcm9taXNlKGZ1bmN0aW9uIChyKSB7XG4gICAgICAgICAgICAgICAgcmVzb2x2ZSA9IHI7XG4gICAgICAgICAgICB9KTtcblxuICAgICAgICAgICAgaWYgKHApIHtcbiAgICAgICAgICAgICAgICByZXR1cm4gaXNGdW5jdGlvbihyZXNvbHZlKTtcbiAgICAgICAgICAgIH1cblxuICAgICAgICAgICAgcmV0dXJuIGZhbHNlO1xuICAgICAgICB9KSgpO1xuICAgIH0pKCk7XG5cbiAgICAvLyBFeHBvcnQgdGhlIG5hdGl2ZSBQcm9taXNlIGltcGxlbWVudGF0aW9uIGlmIGl0XG4gICAgLy8gbG9va3MgbGlrZSBpdCBtYXRjaGVzIHRoZSBzcGVjXG4gICAgaWYgKGhhc1Byb21pc2VTdXBwb3J0KSB7XG4gICAgICAgIHJldHVybiBnbG9iYWxPYmplY3QuUHJvbWlzZTtcbiAgICB9XG5cbiAgICAvLyAgT3RoZXJ3aXNlLCByZXR1cm4gdGhlIGVzNi1wcm9taXNlIHBvbHlmaWxsIGJ5IEBqYWZmYXRoZWNha2UuXG4gICAgcmV0dXJuIHJlcXVpcmUoXCJlczYtcHJvbWlzZVwiKS5Qcm9taXNlO1xufSkoKTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4vKmpzbGludCBub2RlLCB0aGlzLCBlczYsIG1heGxlbjogMTIwICovXG5cInVzZSBzdHJpY3RcIjtcblxubW9kdWxlLmV4cG9ydHMgPSAoZnVuY3Rpb24gKCkge1xuXG4gICAgXCJ1c2Ugc3RyaWN0XCI7XG5cbiAgICAvLyBHZXQgYSBwcm9taXNlIG9iamVjdC4gVGhpcyBtYXkgYmUgbmF0aXZlLCBvciBpdCBtYXkgYmUgcG9seWZpbGxlZFxuICAgIHZhciBFUzZQcm9taXNlID0gcmVxdWlyZSgxMzQpO1xuXG4gICAgLy8gUHJvbWlzZSBDb250ZXh0IG9iamVjdCBjb25zdHJ1Y3Rvci5cbiAgICBmdW5jdGlvbiBDb250ZXh0KHJlc29sdmUsIHJlamVjdCwgY3VzdG9tKSB7XG4gICAgICAgIHRoaXMucmVzb2x2ZSA9IHJlc29sdmU7XG4gICAgICAgIHRoaXMucmVqZWN0ID0gcmVqZWN0O1xuICAgICAgICB0aGlzLmN1c3RvbSA9IGN1c3RvbTtcbiAgICB9XG5cbiAgICAvLyBEZWZhdWx0IGNhbGxiYWNrIGZ1bmN0aW9uIC0gcmVqZWN0cyBvbiB0cnV0aHkgZXJyb3IsIG90aGVyd2lzZSByZXNvbHZlc1xuICAgIGZ1bmN0aW9uIGNhbGxiYWNrKCkge1xuICAgICAgICBmb3IgKHZhciBfbGVuID0gYXJndW1lbnRzLmxlbmd0aCwgYXJncyA9IEFycmF5KF9sZW4pLCBfa2V5ID0gMDsgX2tleSA8IF9sZW47IF9rZXkrKykge1xuICAgICAgICAgICAgYXJnc1tfa2V5XSA9IGFyZ3VtZW50c1tfa2V5XTtcbiAgICAgICAgfVxuXG4gICAgICAgIHZhciBjdHggPSBhcmdzLnNoaWZ0KCksXG4gICAgICAgICAgICBlcnIgPSBhcmdzLnNoaWZ0KCksXG4gICAgICAgICAgICBjdXN0ID0gdW5kZWZpbmVkO1xuXG4gICAgICAgIGFyZ3MgPSBhcmdzLmxlbmd0aCA+IDEgPyBhcmdzIDogYXJnc1swXTtcblxuICAgICAgICBpZiAodHlwZW9mIGN0eC5jdXN0b20gPT09ICdmdW5jdGlvbicpIHtcbiAgICAgICAgICAgIGN1c3QgPSBmdW5jdGlvbiAoKSB7XG4gICAgICAgICAgICAgICAgZm9yICh2YXIgX2xlbjIgPSBhcmd1bWVudHMubGVuZ3RoLCBjdXN0QXJncyA9IEFycmF5KF9sZW4yKSwgX2tleTIgPSAwOyBfa2V5MiA8IF9sZW4yOyBfa2V5MisrKSB7XG4gICAgICAgICAgICAgICAgICAgIGN1c3RBcmdzW19rZXkyXSA9IGFyZ3VtZW50c1tfa2V5Ml07XG4gICAgICAgICAgICAgICAgfVxuXG4gICAgICAgICAgICAgICAgLy8gQmluZCB0aGUgY2FsbGJhY2sgdG8gaXRzZWxmLCBzbyB0aGUgcmVzb2x2ZSBhbmQgcmVqZWN0XG4gICAgICAgICAgICAgICAgLy8gcHJvcGVydGllcyB0aGF0IHdlIGJvdW5kIGFyZSBhdmFpbGFibGUgdG8gdGhlIGNhbGxiYWNrLlxuICAgICAgICAgICAgICAgIC8vIFRoZW4gd2UgcHVzaCBpdCBvbnRvIHRoZSBlbmQgb2YgdGhlIGFyZ3VtZW50cyBhcnJheS5cbiAgICAgICAgICAgICAgICByZXR1cm4gY3R4LmN1c3RvbS5hcHBseShjdXN0LCBjdXN0QXJncyk7XG4gICAgICAgICAgICB9O1xuICAgICAgICAgICAgY3VzdC5yZXNvbHZlID0gY3R4LnJlc29sdmU7XG4gICAgICAgICAgICBjdXN0LnJlamVjdCA9IGN0eC5yZWplY3Q7XG4gICAgICAgICAgICBjdXN0LmNhbGwobnVsbCwgZXJyLCBhcmdzKTtcbiAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICAgIGlmIChlcnIpIHtcbiAgICAgICAgICAgICAgICByZXR1cm4gY3R4LnJlamVjdChlcnIpO1xuICAgICAgICAgICAgfVxuICAgICAgICAgICAgY3R4LnJlc29sdmUoYXJncyk7XG4gICAgICAgIH1cbiAgICB9XG5cbiAgICAvKipcbiAgICAgKiBwcm9taXNpZnlcbiAgICAgKlxuICAgICAqIFRyYW5zZm9ybXMgY2FsbGJhY2stYmFzZWQgZnVuY3Rpb24gLS0gZnVuYyhhcmcxLCBhcmcyIC4uIGFyZ04sIGNhbGxiYWNrKSAtLSBpbnRvXG4gICAgICogYW4gRVM2LWNvbXBhdGlibGUgUHJvbWlzZS4gVXNlciBjYW4gcHJvdmlkZSB0aGVpciBvd24gY2FsbGJhY2sgZnVuY3Rpb247IG90aGVyd2lzZVxuICAgICAqIHByb21pc2lmeSBwcm92aWRlcyBhIGNhbGxiYWNrIG9mIHRoZSBmb3JtIChlcnJvciwgcmVzdWx0KSBhbmQgcmVqZWN0cyBvbiB0cnV0aHkgZXJyb3IuXG4gICAgICogSWYgc3VwcGx5aW5nIHlvdXIgb3duIGNhbGxiYWNrIGZ1bmN0aW9uLCB1c2UgdGhpcy5yZXNvbHZlKCkgYW5kIHRoaXMucmVqZWN0KCkuXG4gICAgICpcbiAgICAgKiBAcGFyYW0ge2Z1bmN0aW9ufSBvcmlnaW5hbCAtIFRoZSBmdW5jdGlvbiB0byBwcm9taXNpZnlcbiAgICAgKiBAcGFyYW0ge2Z1bmN0aW9ufSBjYWxsYmFjayAtIE9wdGlvbmFsIGN1c3RvbSBjYWxsYmFjIGZ1bmN0aW9uXG4gICAgICpcbiAgICAgKiBAcmV0dXJuIHtmdW5jdGlvbn0gQSBwcm9taXNpZmllZCB2ZXJzaW9uIG9mICdvcmlnaW5hbCdcbiAgICAgKi9cbiAgICByZXR1cm4gZnVuY3Rpb24gKG9yaWdpbmFsLCBjdXN0b20pIHtcblxuICAgICAgICByZXR1cm4gZnVuY3Rpb24gKCkge1xuICAgICAgICAgICAgZm9yICh2YXIgX2xlbjMgPSBhcmd1bWVudHMubGVuZ3RoLCBhcmdzID0gQXJyYXkoX2xlbjMpLCBfa2V5MyA9IDA7IF9rZXkzIDwgX2xlbjM7IF9rZXkzKyspIHtcbiAgICAgICAgICAgICAgICBhcmdzW19rZXkzXSA9IGFyZ3VtZW50c1tfa2V5M107XG4gICAgICAgICAgICB9XG5cbiAgICAgICAgICAgIC8vIFN0b3JlIG9yaWdpbmFsIGNvbnRleHRcbiAgICAgICAgICAgIHZhciB0aGF0ID0gdGhpcztcblxuICAgICAgICAgICAgLy8gUmV0dXJuIHRoZSBwcm9taXNpZmllZCBmdW5jdGlvblxuICAgICAgICAgICAgcmV0dXJuIG5ldyBFUzZQcm9taXNlKGZ1bmN0aW9uIChyZXNvbHZlLCByZWplY3QpIHtcblxuICAgICAgICAgICAgICAgIC8vIENyZWF0ZSBhIENvbnRleHQgb2JqZWN0XG4gICAgICAgICAgICAgICAgdmFyIGN0eCA9IG5ldyBDb250ZXh0KHJlc29sdmUsIHJlamVjdCwgY3VzdG9tKTtcblxuICAgICAgICAgICAgICAgIC8vIEFwcGVuZCB0aGUgY2FsbGJhY2sgYm91bmQgdG8gdGhlIGNvbnRleHRcbiAgICAgICAgICAgICAgICBhcmdzLnB1c2goY2FsbGJhY2suYmluZChudWxsLCBjdHgpKTtcblxuICAgICAgICAgICAgICAgIC8vIENhbGwgdGhlIGZ1bmN0aW9uXG4gICAgICAgICAgICAgICAgb3JpZ2luYWwuYXBwbHkodGhhdCwgYXJncyk7XG4gICAgICAgICAgICB9KTtcbiAgICAgICAgfTtcbiAgICB9O1xufSkoKTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4oZnVuY3Rpb24oKSB7XG5cdHZhciB0ZXN0T2JqZWN0ID0ge307XG5cblx0aWYgKCEoT2JqZWN0LnNldFByb3RvdHlwZU9mIHx8IHRlc3RPYmplY3QuX19wcm90b19fKSkge1xuXHRcdHZhciBuYXRpdmVHZXRQcm90b3R5cGVPZiA9IE9iamVjdC5nZXRQcm90b3R5cGVPZjtcblxuXHRcdE9iamVjdC5nZXRQcm90b3R5cGVPZiA9IGZ1bmN0aW9uKG9iamVjdCkge1xuXHRcdFx0aWYgKG9iamVjdC5fX3Byb3RvX18pIHtcblx0XHRcdFx0cmV0dXJuIG9iamVjdC5fX3Byb3RvX187XG5cdFx0XHR9IGVsc2Uge1xuXHRcdFx0XHRyZXR1cm4gbmF0aXZlR2V0UHJvdG90eXBlT2YuY2FsbChPYmplY3QsIG9iamVjdCk7XG5cdFx0XHR9XG5cdFx0fVxuXHR9XG59KSgpO1xuXG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xuXCJ1c2Ugc3RyaWN0XCI7XG5cbi8qKlxuICogRXhwb3NlIGBtZDVvbWF0aWMoc3RyKWAuXG4gKi9cbiBcbm1vZHVsZS5leHBvcnRzID0gbWQ1b21hdGljO1xuXG4vKipcbiAqIEhhc2ggYW55IHN0cmluZyB1c2luZyBtZXNzYWdlIGRpZ2VzdC5cbiAqXG4gKiBAcGFyYW0ge1N0cmluZ30gc3RyXG4gKiBAcmV0dXJuIHtTdHJpbmd9XG4gKiBAYXBpIHB1YmxpY1xuICovXG4gXG5mdW5jdGlvbiBtZDVvbWF0aWMoc3RyKSB7XG4gICAgdmFyIHggPSBzdHIyYmxrc19NRDUoc3RyKTtcbiAgICB2YXIgYSA9ICAxNzMyNTg0MTkzO1xuICAgIHZhciBiID0gLTI3MTczMzg3OTtcbiAgICB2YXIgYyA9IC0xNzMyNTg0MTk0O1xuICAgIHZhciBkID0gIDI3MTczMzg3ODtcblxuICAgIGZvcih2YXIgaT0wOyBpPHgubGVuZ3RoOyBpICs9IDE2KVxuICAgIHtcbiAgICAgICAgdmFyIG9sZGEgPSBhO1xuICAgICAgICB2YXIgb2xkYiA9IGI7XG4gICAgICAgIHZhciBvbGRjID0gYztcbiAgICAgICAgdmFyIG9sZGQgPSBkO1xuXG4gICAgICAgIGEgPSBmZihhLCBiLCBjLCBkLCB4W2krIDBdLCA3ICwgLTY4MDg3NjkzNik7XG4gICAgICAgIGQgPSBmZihkLCBhLCBiLCBjLCB4W2krIDFdLCAxMiwgLTM4OTU2NDU4Nik7XG4gICAgICAgIGMgPSBmZihjLCBkLCBhLCBiLCB4W2krIDJdLCAxNywgIDYwNjEwNTgxOSk7XG4gICAgICAgIGIgPSBmZihiLCBjLCBkLCBhLCB4W2krIDNdLCAyMiwgLTEwNDQ1MjUzMzApO1xuICAgICAgICBhID0gZmYoYSwgYiwgYywgZCwgeFtpKyA0XSwgNyAsIC0xNzY0MTg4OTcpO1xuICAgICAgICBkID0gZmYoZCwgYSwgYiwgYywgeFtpKyA1XSwgMTIsICAxMjAwMDgwNDI2KTtcbiAgICAgICAgYyA9IGZmKGMsIGQsIGEsIGIsIHhbaSsgNl0sIDE3LCAtMTQ3MzIzMTM0MSk7XG4gICAgICAgIGIgPSBmZihiLCBjLCBkLCBhLCB4W2krIDddLCAyMiwgLTQ1NzA1OTgzKTtcbiAgICAgICAgYSA9IGZmKGEsIGIsIGMsIGQsIHhbaSsgOF0sIDcgLCAgMTc3MDAzNTQxNik7XG4gICAgICAgIGQgPSBmZihkLCBhLCBiLCBjLCB4W2krIDldLCAxMiwgLTE5NTg0MTQ0MTcpO1xuICAgICAgICBjID0gZmYoYywgZCwgYSwgYiwgeFtpKzEwXSwgMTcsIC00MjA2Myk7XG4gICAgICAgIGIgPSBmZihiLCBjLCBkLCBhLCB4W2krMTFdLCAyMiwgLTE5OTA0MDQxNjIpO1xuICAgICAgICBhID0gZmYoYSwgYiwgYywgZCwgeFtpKzEyXSwgNyAsICAxODA0NjAzNjgyKTtcbiAgICAgICAgZCA9IGZmKGQsIGEsIGIsIGMsIHhbaSsxM10sIDEyLCAtNDAzNDExMDEpO1xuICAgICAgICBjID0gZmYoYywgZCwgYSwgYiwgeFtpKzE0XSwgMTcsIC0xNTAyMDAyMjkwKTtcbiAgICAgICAgYiA9IGZmKGIsIGMsIGQsIGEsIHhbaSsxNV0sIDIyLCAgMTIzNjUzNTMyOSk7XG4gICAgICAgIGEgPSBnZyhhLCBiLCBjLCBkLCB4W2krIDFdLCA1ICwgLTE2NTc5NjUxMCk7XG4gICAgICAgIGQgPSBnZyhkLCBhLCBiLCBjLCB4W2krIDZdLCA5ICwgLTEwNjk1MDE2MzIpO1xuICAgICAgICBjID0gZ2coYywgZCwgYSwgYiwgeFtpKzExXSwgMTQsICA2NDM3MTc3MTMpO1xuICAgICAgICBiID0gZ2coYiwgYywgZCwgYSwgeFtpKyAwXSwgMjAsIC0zNzM4OTczMDIpO1xuICAgICAgICBhID0gZ2coYSwgYiwgYywgZCwgeFtpKyA1XSwgNSAsIC03MDE1NTg2OTEpO1xuICAgICAgICBkID0gZ2coZCwgYSwgYiwgYywgeFtpKzEwXSwgOSAsICAzODAxNjA4Myk7XG4gICAgICAgIGMgPSBnZyhjLCBkLCBhLCBiLCB4W2krMTVdLCAxNCwgLTY2MDQ3ODMzNSk7XG4gICAgICAgIGIgPSBnZyhiLCBjLCBkLCBhLCB4W2krIDRdLCAyMCwgLTQwNTUzNzg0OCk7XG4gICAgICAgIGEgPSBnZyhhLCBiLCBjLCBkLCB4W2krIDldLCA1ICwgIDU2ODQ0NjQzOCk7XG4gICAgICAgIGQgPSBnZyhkLCBhLCBiLCBjLCB4W2krMTRdLCA5ICwgLTEwMTk4MDM2OTApO1xuICAgICAgICBjID0gZ2coYywgZCwgYSwgYiwgeFtpKyAzXSwgMTQsIC0xODczNjM5NjEpO1xuICAgICAgICBiID0gZ2coYiwgYywgZCwgYSwgeFtpKyA4XSwgMjAsICAxMTYzNTMxNTAxKTtcbiAgICAgICAgYSA9IGdnKGEsIGIsIGMsIGQsIHhbaSsxM10sIDUgLCAtMTQ0NDY4MTQ2Nyk7XG4gICAgICAgIGQgPSBnZyhkLCBhLCBiLCBjLCB4W2krIDJdLCA5ICwgLTUxNDAzNzg0KTtcbiAgICAgICAgYyA9IGdnKGMsIGQsIGEsIGIsIHhbaSsgN10sIDE0LCAgMTczNTMyODQ3Myk7XG4gICAgICAgIGIgPSBnZyhiLCBjLCBkLCBhLCB4W2krMTJdLCAyMCwgLTE5MjY2MDc3MzQpO1xuICAgICAgICBhID0gaGgoYSwgYiwgYywgZCwgeFtpKyA1XSwgNCAsIC0zNzg1NTgpO1xuICAgICAgICBkID0gaGgoZCwgYSwgYiwgYywgeFtpKyA4XSwgMTEsIC0yMDIyNTc0NDYzKTtcbiAgICAgICAgYyA9IGhoKGMsIGQsIGEsIGIsIHhbaSsxMV0sIDE2LCAgMTgzOTAzMDU2Mik7XG4gICAgICAgIGIgPSBoaChiLCBjLCBkLCBhLCB4W2krMTRdLCAyMywgLTM1MzA5NTU2KTtcbiAgICAgICAgYSA9IGhoKGEsIGIsIGMsIGQsIHhbaSsgMV0sIDQgLCAtMTUzMDk5MjA2MCk7XG4gICAgICAgIGQgPSBoaChkLCBhLCBiLCBjLCB4W2krIDRdLCAxMSwgIDEyNzI4OTMzNTMpO1xuICAgICAgICBjID0gaGgoYywgZCwgYSwgYiwgeFtpKyA3XSwgMTYsIC0xNTU0OTc2MzIpO1xuICAgICAgICBiID0gaGgoYiwgYywgZCwgYSwgeFtpKzEwXSwgMjMsIC0xMDk0NzMwNjQwKTtcbiAgICAgICAgYSA9IGhoKGEsIGIsIGMsIGQsIHhbaSsxM10sIDQgLCAgNjgxMjc5MTc0KTtcbiAgICAgICAgZCA9IGhoKGQsIGEsIGIsIGMsIHhbaSsgMF0sIDExLCAtMzU4NTM3MjIyKTtcbiAgICAgICAgYyA9IGhoKGMsIGQsIGEsIGIsIHhbaSsgM10sIDE2LCAtNzIyNTIxOTc5KTtcbiAgICAgICAgYiA9IGhoKGIsIGMsIGQsIGEsIHhbaSsgNl0sIDIzLCAgNzYwMjkxODkpO1xuICAgICAgICBhID0gaGgoYSwgYiwgYywgZCwgeFtpKyA5XSwgNCAsIC02NDAzNjQ0ODcpO1xuICAgICAgICBkID0gaGgoZCwgYSwgYiwgYywgeFtpKzEyXSwgMTEsIC00MjE4MTU4MzUpO1xuICAgICAgICBjID0gaGgoYywgZCwgYSwgYiwgeFtpKzE1XSwgMTYsICA1MzA3NDI1MjApO1xuICAgICAgICBiID0gaGgoYiwgYywgZCwgYSwgeFtpKyAyXSwgMjMsIC05OTUzMzg2NTEpO1xuICAgICAgICBhID0gaWkoYSwgYiwgYywgZCwgeFtpKyAwXSwgNiAsIC0xOTg2MzA4NDQpO1xuICAgICAgICBkID0gaWkoZCwgYSwgYiwgYywgeFtpKyA3XSwgMTAsICAxMTI2ODkxNDE1KTtcbiAgICAgICAgYyA9IGlpKGMsIGQsIGEsIGIsIHhbaSsxNF0sIDE1LCAtMTQxNjM1NDkwNSk7XG4gICAgICAgIGIgPSBpaShiLCBjLCBkLCBhLCB4W2krIDVdLCAyMSwgLTU3NDM0MDU1KTtcbiAgICAgICAgYSA9IGlpKGEsIGIsIGMsIGQsIHhbaSsxMl0sIDYgLCAgMTcwMDQ4NTU3MSk7XG4gICAgICAgIGQgPSBpaShkLCBhLCBiLCBjLCB4W2krIDNdLCAxMCwgLTE4OTQ5ODY2MDYpO1xuICAgICAgICBjID0gaWkoYywgZCwgYSwgYiwgeFtpKzEwXSwgMTUsIC0xMDUxNTIzKTtcbiAgICAgICAgYiA9IGlpKGIsIGMsIGQsIGEsIHhbaSsgMV0sIDIxLCAtMjA1NDkyMjc5OSk7XG4gICAgICAgIGEgPSBpaShhLCBiLCBjLCBkLCB4W2krIDhdLCA2ICwgIDE4NzMzMTMzNTkpO1xuICAgICAgICBkID0gaWkoZCwgYSwgYiwgYywgeFtpKzE1XSwgMTAsIC0zMDYxMTc0NCk7XG4gICAgICAgIGMgPSBpaShjLCBkLCBhLCBiLCB4W2krIDZdLCAxNSwgLTE1NjAxOTgzODApO1xuICAgICAgICBiID0gaWkoYiwgYywgZCwgYSwgeFtpKzEzXSwgMjEsICAxMzA5MTUxNjQ5KTtcbiAgICAgICAgYSA9IGlpKGEsIGIsIGMsIGQsIHhbaSsgNF0sIDYgLCAtMTQ1NTIzMDcwKTtcbiAgICAgICAgZCA9IGlpKGQsIGEsIGIsIGMsIHhbaSsxMV0sIDEwLCAtMTEyMDIxMDM3OSk7XG4gICAgICAgIGMgPSBpaShjLCBkLCBhLCBiLCB4W2krIDJdLCAxNSwgIDcxODc4NzI1OSk7XG4gICAgICAgIGIgPSBpaShiLCBjLCBkLCBhLCB4W2krIDldLCAyMSwgLTM0MzQ4NTU1MSk7XG5cbiAgICAgICAgYSA9IGFkZG1lKGEsIG9sZGEpO1xuICAgICAgICBiID0gYWRkbWUoYiwgb2xkYik7XG4gICAgICAgIGMgPSBhZGRtZShjLCBvbGRjKTtcbiAgICAgICAgZCA9IGFkZG1lKGQsIG9sZGQpO1xuICAgIH1cblxuICAgIHJldHVybiByaGV4KGEpICsgcmhleChiKSArIHJoZXgoYykgKyByaGV4KGQpO1xufTtcblxudmFyIGhleF9jaHIgPSBcIjAxMjM0NTY3ODlhYmNkZWZcIjtcblxuZnVuY3Rpb24gYml0T1IoYSwgYilcbntcbiAgICB2YXIgbHNiID0gKGEgJiAweDEpIHwgKGIgJiAweDEpO1xuICAgIHZhciBtc2IzMSA9IChhID4+PiAxKSB8IChiID4+PiAxKTtcblxuICAgIHJldHVybiAobXNiMzEgPDwgMSkgfCBsc2I7XG59XG5cbmZ1bmN0aW9uIGJpdFhPUihhLCBiKVxue1xuICAgIHZhciBsc2IgPSAoYSAmIDB4MSkgXiAoYiAmIDB4MSk7XG4gICAgdmFyIG1zYjMxID0gKGEgPj4+IDEpIF4gKGIgPj4+IDEpO1xuXG4gICAgcmV0dXJuIChtc2IzMSA8PCAxKSB8IGxzYjtcbn1cblxuZnVuY3Rpb24gYml0QU5EKGEsIGIpXG57XG4gICAgdmFyIGxzYiA9IChhICYgMHgxKSAmIChiICYgMHgxKTtcbiAgICB2YXIgbXNiMzEgPSAoYSA+Pj4gMSkgJiAoYiA+Pj4gMSk7XG5cbiAgICByZXR1cm4gKG1zYjMxIDw8IDEpIHwgbHNiO1xufVxuXG5mdW5jdGlvbiBhZGRtZSh4LCB5KVxue1xuICAgIHZhciBsc3cgPSAoeCAmIDB4RkZGRikrKHkgJiAweEZGRkYpO1xuICAgIHZhciBtc3cgPSAoeCA+PiAxNikrKHkgPj4gMTYpKyhsc3cgPj4gMTYpO1xuXG4gICAgcmV0dXJuIChtc3cgPDwgMTYpIHwgKGxzdyAmIDB4RkZGRik7XG59XG5cbmZ1bmN0aW9uIHJoZXgobnVtKVxue1xuICAgIHZhciBzdHIgPSBcIlwiO1xuICAgIHZhciBqO1xuXG4gICAgZm9yKGo9MDsgajw9MzsgaisrKVxuICAgICAgICBzdHIgKz0gaGV4X2Noci5jaGFyQXQoKG51bSA+PiAoaiAqIDggKyA0KSkgJiAweDBGKSArIGhleF9jaHIuY2hhckF0KChudW0gPj4gKGogKiA4KSkgJiAweDBGKTtcblxuICAgIHJldHVybiBzdHI7XG59XG5cbmZ1bmN0aW9uIHN0cjJibGtzX01ENShzdHIpXG57XG4gICAgdmFyIG5ibGsgPSAoKHN0ci5sZW5ndGggKyA4KSA+PiA2KSArIDE7XG4gICAgdmFyIGJsa3MgPSBuZXcgQXJyYXkobmJsayAqIDE2KTtcbiAgICB2YXIgaTtcblxuICAgIGZvcihpPTA7IGk8bmJsayAqIDE2OyBpKyspXG4gICAgICAgIGJsa3NbaV0gPSAwO1xuXG4gICAgZm9yKGk9MDsgaTxzdHIubGVuZ3RoOyBpKyspXG4gICAgICAgIGJsa3NbaSA+PiAyXSB8PSBzdHIuY2hhckNvZGVBdChpKSA8PCAoKChzdHIubGVuZ3RoICogOCArIGkpICUgNCkgKiA4KTtcblxuICAgIGJsa3NbaSA+PiAyXSB8PSAweDgwIDw8ICgoKHN0ci5sZW5ndGggKiA4ICsgaSkgJSA0KSAqIDgpO1xuXG4gICAgdmFyIGwgPSBzdHIubGVuZ3RoICogODtcbiAgICBibGtzW25ibGsgKiAxNiAtIDJdID0gKGwgJiAweEZGKTtcbiAgICBibGtzW25ibGsgKiAxNiAtIDJdIHw9ICgobCA+Pj4gOCkgJiAweEZGKSA8PCA4O1xuICAgIGJsa3NbbmJsayAqIDE2IC0gMl0gfD0gKChsID4+PiAxNikgJiAweEZGKSA8PCAxNjtcbiAgICBibGtzW25ibGsgKiAxNiAtIDJdIHw9ICgobCA+Pj4gMjQpICYgMHhGRikgPDwgMjQ7XG5cbiAgICByZXR1cm4gYmxrcztcbn1cblxuZnVuY3Rpb24gcm9sKG51bSwgY250KVxue1xuICAgIHJldHVybiAobnVtIDw8IGNudCkgfCAobnVtID4+PiAoMzIgLSBjbnQpKTtcbn1cblxuZnVuY3Rpb24gY21uKHEsIGEsIGIsIHgsIHMsIHQpXG57XG4gICAgcmV0dXJuIGFkZG1lKHJvbCgoYWRkbWUoYWRkbWUoYSwgcSksIGFkZG1lKHgsIHQpKSksIHMpLCBiKTtcbn1cblxuZnVuY3Rpb24gZmYoYSwgYiwgYywgZCwgeCwgcywgdClcbntcbiAgICByZXR1cm4gY21uKGJpdE9SKGJpdEFORChiLCBjKSwgYml0QU5EKCh+YiksIGQpKSwgYSwgYiwgeCwgcywgdCk7XG59XG5cbmZ1bmN0aW9uIGdnKGEsIGIsIGMsIGQsIHgsIHMsIHQpXG57XG4gICAgcmV0dXJuIGNtbihiaXRPUihiaXRBTkQoYiwgZCksIGJpdEFORChjLCAofmQpKSksIGEsIGIsIHgsIHMsIHQpO1xufVxuXG5mdW5jdGlvbiBoaChhLCBiLCBjLCBkLCB4LCBzLCB0KVxue1xuICAgIHJldHVybiBjbW4oYml0WE9SKGJpdFhPUihiLCBjKSwgZCksIGEsIGIsIHgsIHMsIHQpO1xufVxuXG5mdW5jdGlvbiBpaShhLCBiLCBjLCBkLCB4LCBzLCB0KVxue1xuICAgIHJldHVybiBjbW4oYml0WE9SKGMsIGJpdE9SKGIsICh+ZCkpKSwgYSwgYiwgeCwgcywgdCk7XG59XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xudmFyIG1kNW9tYXRpYyA9IHJlcXVpcmUoMTM3KTtcblxubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbiAoZnVuYywgcHJlZml4KSB7XG4gIHByZWZpeCA9IHByZWZpeCB8fCAnJztcbiAgZnVuYyA9IGZ1bmMgfHwgZnVuY3Rpb24gKCkgeyByZXR1cm4gJ19kZWZhdWx0JzsgfTtcbiAgcmV0dXJuIGZ1bmN0aW9uICgpIHtcbiAgICB2YXIgYXJncyA9IEFycmF5LnByb3RvdHlwZS5zbGljZS5jYWxsKGFyZ3VtZW50cyk7XG4gICAgdmFyIGsgPSBmdW5jLmFwcGx5KHVuZGVmaW5lZCwgYXJncyk7XG4gICAgaWYgKGsgPT09IG51bGwpIHtcbiAgICAgIHJldHVybiBudWxsO1xuICAgIH1cbiAgICBpZiAodHlwZW9mIGsgPT09ICd1bmRlZmluZWQnIHx8XG4gICAgICAodHlwZW9mIGsgPT09ICdudW1iZXInICYmIGlzTmFOKGspKSB8fFxuICAgICAgayA9PT0gJycgfHxcbiAgICAgICh0eXBlb2YgayA9PT0gJ29iamVjdCcgJiYgT2JqZWN0LmtleXMoaykubGVuZ3RoID09PSAwKSkge1xuICAgICAgdGhyb3cgbmV3IEVycm9yKCdOb3QgYSB2YWxpZCBrZXknKTtcbiAgICB9XG4gICAgaWYgKHR5cGVvZiBrICE9PSAnc3RyaW5nJykge1xuICAgICAgayA9IG1kNW9tYXRpYyhKU09OLnN0cmluZ2lmeShrKSk7XG4gICAgfVxuICAgIHJldHVybiBwcmVmaXggKyBrO1xuICB9O1xufTtcblxufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbmZ1bmN0aW9uIGlzT2JqKHYpIHtcbiAgcmV0dXJuIHR5cGVvZiB2ID09PSAnb2JqZWN0Jztcbn1cblxuZnVuY3Rpb24gaXNTdHIodikge1xuICByZXR1cm4gdHlwZW9mIHYgPT09ICdzdHJpbmcnO1xufVxuXG5mdW5jdGlvbiBpc0Jvb2wodikge1xuICByZXR1cm4gdHlwZW9mIHYgPT09ICdib29sZWFuJztcbn1cblxuZnVuY3Rpb24gaXNVbmRlZih2KSB7XG4gIGlmICh0eXBlb2YgdiA9PT0gJ3N0cmluZycpIHtcbiAgICByZXR1cm4gdi5sZW5ndGggPT09IDA7XG4gIH1cbiAgcmV0dXJuIHR5cGVvZiB2ID09PSAndW5kZWZpbmVkJztcbn1cblxuZnVuY3Rpb24gZmxhdHRlbihhcnIpIHtcbiAgcmV0dXJuIFtdLmNvbmNhdC5hcHBseShbXSwgYXJyKTtcbn1cblxudmFyIGVtYWlsUkUgPSAvLitcXEAuK1xcLi4rLztcblxudmFyIF92YWxpZGF0b3JGYWN0b3JpZXMgPSB7XG4gIG9iamVjdDogZnVuY3Rpb24gKCkgeyByZXR1cm4gZnVuY3Rpb24gKHZhbHVlKSB7IHJldHVybiAoaXNVbmRlZih2YWx1ZSkgfHwgaXNPYmoodmFsdWUpID8gW10gOiBbJ29iamVjdC5iYXNlJ10pOyB9OyB9LFxuICBzdHJpbmc6IGZ1bmN0aW9uICgpIHsgcmV0dXJuIGZ1bmN0aW9uICh2YWx1ZSkgeyByZXR1cm4gKGlzVW5kZWYodmFsdWUpIHx8IGlzU3RyKHZhbHVlKSA/IFtdIDogWydzdHJpbmcuYmFzZSddKTsgfTsgfSxcbiAgYm9vbGVhbjogZnVuY3Rpb24gKCkgeyByZXR1cm4gZnVuY3Rpb24gKHZhbHVlKSB7IHJldHVybiAoaXNVbmRlZih2YWx1ZSkgfHwgaXNCb29sKHZhbHVlKSA/IFtdIDogWydib29sZWFuLmJhc2UnXSk7IH07IH0sXG4gIG1pbjogZnVuY3Rpb24gKG1pblZhbHVlKSB7IHJldHVybiBmdW5jdGlvbiAodmFsdWUpIHsgcmV0dXJuIChpc1VuZGVmKHZhbHVlKSB8fCB2YWx1ZS5sZW5ndGggPj0gbWluVmFsdWUgPyBbXSA6IFsnc3RyaW5nLm1pbiddKTsgfTsgfSxcbiAgbWF4OiBmdW5jdGlvbiAobWF4VmFsdWUpIHsgcmV0dXJuIGZ1bmN0aW9uICh2YWx1ZSkgeyByZXR1cm4gKGlzVW5kZWYodmFsdWUpIHx8IHZhbHVlLmxlbmd0aCA8PSBtYXhWYWx1ZSA/IFtdIDogWydzdHJpbmcubWF4J10pOyB9OyB9LFxuICBlbWFpbDogZnVuY3Rpb24gKCkgeyByZXR1cm4gZnVuY3Rpb24gKHZhbHVlKSB7IHJldHVybiAoaXNVbmRlZih2YWx1ZSkgfHwgZW1haWxSRS50ZXN0KHZhbHVlKSA/IFtdIDogWydzdHJpbmcuZW1haWwnXSk7IH07IH0sXG4gIHJlcXVpcmVkOiBmdW5jdGlvbiAoKSB7IHJldHVybiBmdW5jdGlvbiAodmFsdWUpIHsgcmV0dXJuICghaXNVbmRlZih2YWx1ZSkgPyBbXSA6IFsnYW55LmVtcHR5J10pOyB9OyB9LFxuICByZWdleDogZnVuY3Rpb24gKHJlKSB7IHJldHVybiBmdW5jdGlvbiAodmFsdWUpIHsgcmV0dXJuIChpc1VuZGVmKHZhbHVlKSB8fCByZS50ZXN0KHZhbHVlKSA/IFtdIDogWydzdHJpbmcucmVnZXguYmFzZSddKTsgfTsgfSxcbiAga2V5czogZnVuY3Rpb24gKG9iaikgeyByZXR1cm4gZnVuY3Rpb24gKHZhbHVlKSB7IHJldHVybiAoaXNVbmRlZih2YWx1ZSkgPyBbXSA6IGZsYXR0ZW4oT2JqZWN0LmtleXMob2JqKS5tYXAoZnVuY3Rpb24gKGF0dHIpIHsgcmV0dXJuIG9ialthdHRyXS5fdmFsaWRhdGUodmFsdWVbYXR0cl0sIGF0dHIpOyB9KSkpOyB9OyB9LFxufTtcblxuZnVuY3Rpb24gX2pvaSgpIHtcbiAgdGhpcy5fdmFsaWRhdG9ycyA9IFtdO1xufVxuXG52YXIgam9pID0ge307XG5cbk9iamVjdC5rZXlzKF92YWxpZGF0b3JGYWN0b3JpZXMpLmZvckVhY2goZnVuY3Rpb24gKGspIHtcbiAgX2pvaS5wcm90b3R5cGVba10gPSBmdW5jdGlvbiB1bm5hbWVkKGFyZykge1xuICAgIHRoaXMuX3ZhbGlkYXRvcnMucHVzaChfdmFsaWRhdG9yRmFjdG9yaWVzW2tdKGFyZykpO1xuICAgIHJldHVybiB0aGlzO1xuICB9O1xuXG4gIGpvaVtrXSA9IGZ1bmN0aW9uIChhcmcpIHtcbiAgICB2YXIgaiA9IG5ldyBfam9pKCk7XG4gICAgcmV0dXJuIGpba10oYXJnKTtcbiAgfTtcbn0pO1xuXG5fam9pLnByb3RvdHlwZS5fdmFsaWRhdGUgPSBmdW5jdGlvbiBfdmFsaWRhdGUodmFsdWUsIHBhdGgpIHtcbiAgcmV0dXJuIGZsYXR0ZW4odGhpcy5fdmFsaWRhdG9ycy5tYXAoZnVuY3Rpb24gKGZ1bmMpIHsgcmV0dXJuIGZ1bmModmFsdWUpOyB9KSlcbiAgLm1hcChmdW5jdGlvbiAoZSkge1xuICAgIHZhciBvdXQgPSB7XG4gICAgICB0eXBlOiB0eXBlb2YgZSA9PT0gJ3N0cmluZycgPyBlIDogZS50eXBlLFxuICAgIH07XG4gICAgdmFyIHBhdGhzID0gW107XG4gICAgaWYgKHBhdGgpIHtcbiAgICAgIHBhdGhzLnB1c2gocGF0aCk7XG4gICAgfVxuICAgIGlmICh0eXBlb2YgZSAhPT0gJ3N0cmluZycgJiYgJ3BhdGgnIGluIGUpIHtcbiAgICAgIHBhdGhzLnB1c2goZS5wYXRoKTtcbiAgICB9XG5cbiAgICBpZiAocGF0aHMubGVuZ3RoKSB7XG4gICAgICBvdXQucGF0aCA9IHBhdGhzLmpvaW4oJy4nKTtcbiAgICB9XG4gICAgcmV0dXJuIG91dDtcbiAgfSk7XG59O1xuXG5qb2kudmFsaWRhdGUgPSBmdW5jdGlvbiB2YWxpZGF0ZShkYXRhLCBzY2hlbWEsIG9wdGlvbnMsIGNhbGxiYWNrKSB7XG4gIC8vIGNvbnN0IGFib3J0RWFybHkgPSBvcHRpb25zLmFib3J0RWFybHk7XG4gIHZhciBlcnJvcnMgPSBzY2hlbWEuX3ZhbGlkYXRlKGRhdGEpO1xuICB2YXIgb3V0ID0gZXJyb3JzLmxlbmd0aCA/IHtcbiAgICBlcnJvcjoge1xuICAgICAgZGV0YWlsczogZXJyb3JzLFxuICAgIH0sXG4gICAgdmFsdWU6IGRhdGEsXG4gIH0gOiB7IGVycm9yOiBudWxsLCB2YWx1ZTogZGF0YSB9O1xuXG4gIGlmIChjYWxsYmFjaykge1xuICAgIGNhbGxiYWNrKG91dC5lcnJvciwgb3V0LnZhbHVlKTtcbiAgfVxuICByZXR1cm4gb3V0O1xufTtcblxubW9kdWxlLmV4cG9ydHMgPSBqb2k7XG5cbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4ndXNlIHN0cmljdCc7XG5cbk9iamVjdC5kZWZpbmVQcm9wZXJ0eShleHBvcnRzLCBcIl9fZXNNb2R1bGVcIiwge1xuICB2YWx1ZTogdHJ1ZVxufSk7XG5leHBvcnRzLlNpbXBsZURhdGUgPSB1bmRlZmluZWQ7XG5cbnZhciBfZGVmaW5lUHJvcGVydHkyID0gcmVxdWlyZSgyMyk7XG5cbnZhciBfZGVmaW5lUHJvcGVydHkzID0gX2ludGVyb3BSZXF1aXJlRGVmYXVsdChfZGVmaW5lUHJvcGVydHkyKTtcblxudmFyIF9nZXRQcm90b3R5cGVPZiA9IHJlcXVpcmUoMTUpO1xuXG52YXIgX2dldFByb3RvdHlwZU9mMiA9IF9pbnRlcm9wUmVxdWlyZURlZmF1bHQoX2dldFByb3RvdHlwZU9mKTtcblxudmFyIF9jbGFzc0NhbGxDaGVjazIgPSByZXF1aXJlKDIxKTtcblxudmFyIF9jbGFzc0NhbGxDaGVjazMgPSBfaW50ZXJvcFJlcXVpcmVEZWZhdWx0KF9jbGFzc0NhbGxDaGVjazIpO1xuXG52YXIgX2NyZWF0ZUNsYXNzMiA9IHJlcXVpcmUoMjIpO1xuXG52YXIgX2NyZWF0ZUNsYXNzMyA9IF9pbnRlcm9wUmVxdWlyZURlZmF1bHQoX2NyZWF0ZUNsYXNzMik7XG5cbnZhciBfcG9zc2libGVDb25zdHJ1Y3RvclJldHVybjIgPSByZXF1aXJlKDI2KTtcblxudmFyIF9wb3NzaWJsZUNvbnN0cnVjdG9yUmV0dXJuMyA9IF9pbnRlcm9wUmVxdWlyZURlZmF1bHQoX3Bvc3NpYmxlQ29uc3RydWN0b3JSZXR1cm4yKTtcblxudmFyIF9pbmhlcml0czIgPSByZXF1aXJlKDI1KTtcblxudmFyIF9pbmhlcml0czMgPSBfaW50ZXJvcFJlcXVpcmVEZWZhdWx0KF9pbmhlcml0czIpO1xuXG52YXIgX3JlYWN0ID0gX19yZWFjdDtcblxudmFyIF9yZWFjdDIgPSBfaW50ZXJvcFJlcXVpcmVEZWZhdWx0KF9yZWFjdCk7XG5cbmZ1bmN0aW9uIF9pbnRlcm9wUmVxdWlyZURlZmF1bHQob2JqKSB7IHJldHVybiBvYmogJiYgb2JqLl9fZXNNb2R1bGUgPyBvYmogOiB7IGRlZmF1bHQ6IG9iaiB9OyB9XG5cbmZ1bmN0aW9uIHNlbGVjdEFsbChub2RlKSB7XG4gIHNldFRpbWVvdXQoZnVuY3Rpb24gKCkge1xuICAgIG5vZGUuc2V0U2VsZWN0aW9uUmFuZ2UoMCwgbm9kZS52YWx1ZS5sZW5ndGgpO1xuICB9LCA1KTtcbn1cblxuZnVuY3Rpb24gc2V0Rm9jdXMobm9kZSkge1xuICBub2RlLmZvY3VzKCk7XG4gIHNlbGVjdEFsbChub2RlKTtcbn1cblxuZnVuY3Rpb24gZ2V0RGF0ZUl0ZW0ocykge1xuICAvLyB1bmRlZmluZWQgYW5kIG51bGwgc2hvdWxkIHJldHVybiBhbiBlbXB0eSBzdHJpbmcgKGludmFsaWQgZGF0ZSlcbiAgdmFyIGQgPSBuZXcgRGF0ZShzIHx8ICcnKTtcbiAgdmFyIGluVmFsaWQgPSBpc05hTihkLmdldERhdGUoKSk7XG4gIHZhciBkYXkgPSBpblZhbGlkID8gJycgOiBkLmdldERhdGUoKS50b1N0cmluZygpO1xuICB2YXIgbW9udGggPSBpblZhbGlkID8gJycgOiAoZC5nZXRNb250aCgpICsgMSkudG9TdHJpbmcoKTtcbiAgdmFyIHllYXIgPSBpblZhbGlkID8gJycgOiBkLmdldEZ1bGxZZWFyKCkudG9TdHJpbmcoKTtcbiAgcmV0dXJuIHsgZGF5OiBkYXksIG1vbnRoOiBtb250aCwgeWVhcjogeWVhciB9O1xufVxuXG5mdW5jdGlvbiBpbnB1dEJ1aWxkZXIoY29udGV4dCwgbmFtZSwgcGxhY2Vob2xkZXIsIG1heExlbmd0aCwgbGFiZWwpIHtcbiAgdmFyIGNvbnRyb2xOYW1lID0gY29udGV4dC5wcm9wcy5uYW1lO1xuICB2YXIgaWQgPSBjb250cm9sTmFtZSArICctJyArIG5hbWU7XG4gIHZhciBkZXNjcmlwdGlvbiA9IGxhYmVsICsgJyAtICcgKyBuYW1lO1xuICByZXR1cm4gX3JlYWN0Mi5kZWZhdWx0LmNyZWF0ZUVsZW1lbnQoXG4gICAgJ3NwYW4nLFxuICAgIG51bGwsXG4gICAgX3JlYWN0Mi5kZWZhdWx0LmNyZWF0ZUVsZW1lbnQoXG4gICAgICAnbGFiZWwnLFxuICAgICAgeyBjbGFzc05hbWU6ICd0ZXMtc2ltcGxlLWRhdGVfX2xhYmVsJywgaHRtbEZvcjogaWQgfSxcbiAgICAgIGRlc2NyaXB0aW9uXG4gICAgKSxcbiAgICBfcmVhY3QyLmRlZmF1bHQuY3JlYXRlRWxlbWVudCgnaW5wdXQnLCB7XG4gICAgICBpZDogaWQsXG4gICAgICBjbGFzc05hbWU6ICd0ZXMtc2ltcGxlLWRhdGVfX2l0ZW0gdGVzLXNpbXBsZS1kYXRlX18nICsgbmFtZSxcbiAgICAgIG9uQ2xpY2s6IGZ1bmN0aW9uIG9uQ2xpY2soZSkge1xuICAgICAgICByZXR1cm4gY29udGV4dC5vbkNsaWNrKGUpO1xuICAgICAgfSxcbiAgICAgIG9uS2V5RG93bjogZnVuY3Rpb24gb25LZXlEb3duKGUpIHtcbiAgICAgICAgcmV0dXJuIGNvbnRleHQuZm9jdXNOZXh0KGUsIG5hbWUpO1xuICAgICAgfSxcbiAgICAgIHJlZjogbmFtZSxcbiAgICAgIG9uQ2hhbmdlOiBmdW5jdGlvbiBvbkNoYW5nZShlKSB7XG4gICAgICAgIHJldHVybiBjb250ZXh0Lm9uQ2hhbmdlKGUsIG5hbWUsIG1heExlbmd0aCk7XG4gICAgICB9LFxuICAgICAgc2l6ZTogbWF4TGVuZ3RoLFxuICAgICAgdmFsdWU6IGNvbnRleHQuc3RhdGVbbmFtZV0sXG4gICAgICBwbGFjZWhvbGRlcjogcGxhY2Vob2xkZXJcbiAgICB9KVxuICApO1xufVxuXG52YXIgU2ltcGxlRGF0ZSA9IGV4cG9ydHMuU2ltcGxlRGF0ZSA9IGZ1bmN0aW9uIChfQ29tcG9uZW50KSB7XG4gICgwLCBfaW5oZXJpdHMzLmRlZmF1bHQpKFNpbXBsZURhdGUsIF9Db21wb25lbnQpO1xuXG4gIGZ1bmN0aW9uIFNpbXBsZURhdGUocHJvcHMpIHtcbiAgICAoMCwgX2NsYXNzQ2FsbENoZWNrMy5kZWZhdWx0KSh0aGlzLCBTaW1wbGVEYXRlKTtcblxuICAgIHZhciBfdGhpcyA9ICgwLCBfcG9zc2libGVDb25zdHJ1Y3RvclJldHVybjMuZGVmYXVsdCkodGhpcywgKFNpbXBsZURhdGUuX19wcm90b19fIHx8ICgwLCBfZ2V0UHJvdG90eXBlT2YyLmRlZmF1bHQpKFNpbXBsZURhdGUpKS5jYWxsKHRoaXMsIHByb3BzKSk7XG5cbiAgICBfdGhpcy5zZXF1ZW5jZSA9IF90aGlzLnByb3BzLnNlcXVlbmNlIHx8IFsnZGF5JywgJ21vbnRoJywgJ3llYXInXTtcbiAgICBfdGhpcy5uZXh0SXRlbXMgPSBfdGhpcy5zZXF1ZW5jZS5yZWR1Y2UoZnVuY3Rpb24gKG9iaiwgY3VyLCBpbmRleCwgYXJyKSB7XG4gICAgICBvYmpbY3VyXSA9IGFycltpbmRleCArIDFdO1xuICAgICAgcmV0dXJuIG9iajtcbiAgICB9LCB7fSk7XG5cbiAgICBfdGhpcy5wcmV2aW91c0l0ZW1zID0gX3RoaXMuc2VxdWVuY2UucmVkdWNlKGZ1bmN0aW9uIChvYmosIGN1ciwgaW5kZXgsIGFycikge1xuICAgICAgb2JqW2N1cl0gPSBhcnJbaW5kZXggLSAxXTtcbiAgICAgIHJldHVybiBvYmo7XG4gICAgfSwge30pO1xuICAgIF90aGlzLnN0YXRlID0gZ2V0RGF0ZUl0ZW0oX3RoaXMucHJvcHMudmFsdWUpO1xuICAgIHJldHVybiBfdGhpcztcbiAgfVxuXG4gICgwLCBfY3JlYXRlQ2xhc3MzLmRlZmF1bHQpKFNpbXBsZURhdGUsIFt7XG4gICAga2V5OiAnY29tcG9uZW50RGlkVXBkYXRlJyxcbiAgICB2YWx1ZTogZnVuY3Rpb24gY29tcG9uZW50RGlkVXBkYXRlKHByZXZQcm9wcywgcHJldlN0YXRlKSB7XG4gICAgICB2YXIgX3N0YXRlID0gdGhpcy5zdGF0ZSxcbiAgICAgICAgICB5ZWFyID0gX3N0YXRlLnllYXIsXG4gICAgICAgICAgbW9udGggPSBfc3RhdGUubW9udGgsXG4gICAgICAgICAgZGF5ID0gX3N0YXRlLmRheTtcblxuICAgICAgaWYgKHByZXZTdGF0ZS5kYXkgPT09IGRheSAmJiBwcmV2U3RhdGUubW9udGggPT09IG1vbnRoICYmIHByZXZTdGF0ZS55ZWFyID09PSB5ZWFyKSB7XG4gICAgICAgIHJldHVybjtcbiAgICAgIH1cbiAgICAgIHRoaXMucHJvcHMub25DaGFuZ2UoeWVhciArICctJyArIG1vbnRoICsgJy0nICsgZGF5KTtcbiAgICB9XG4gIH0sIHtcbiAgICBrZXk6ICdvbkNoYW5nZScsXG4gICAgdmFsdWU6IGZ1bmN0aW9uIG9uQ2hhbmdlKGV2dCwgY3VycmVudCwgbWF4TGVuZ3RoKSB7XG4gICAgICB2YXIgbmV4dEl0ZW0gPSB0aGlzLm5leHRJdGVtc1tjdXJyZW50XTtcbiAgICAgIC8vIGNvbnN0IHByZXZpb3VzSXRlbSA9IHRoaXMucHJldmlvdXNJdGVtc1tjdXJyZW50XTtcbiAgICAgIHZhciBjdXJyZW50VmFsdWUgPSB0aGlzLnJlZnNbY3VycmVudF0udmFsdWU7XG5cbiAgICAgIGlmIChuZXcgUmVnRXhwKCdeWzAtOV17MCwnICsgbWF4TGVuZ3RoICsgJ30kJykudGVzdChjdXJyZW50VmFsdWUpKSB7XG4gICAgICAgIHRoaXMuc2V0U3RhdGUoKDAsIF9kZWZpbmVQcm9wZXJ0eTMuZGVmYXVsdCkoe30sIGN1cnJlbnQsIGN1cnJlbnRWYWx1ZSkpO1xuICAgICAgICBpZiAobmV4dEl0ZW0gJiYgY3VycmVudFZhbHVlLmxlbmd0aCA+PSBtYXhMZW5ndGgpIHtcbiAgICAgICAgICBzZXRGb2N1cyh0aGlzLnJlZnNbbmV4dEl0ZW1dKTtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cbiAgfSwge1xuICAgIGtleTogJ29uQ2xpY2snLFxuICAgIHZhbHVlOiBmdW5jdGlvbiBvbkNsaWNrKGV2dCkge1xuICAgICAgc2VsZWN0QWxsKGV2dC50YXJnZXQpO1xuICAgIH1cbiAgfSwge1xuICAgIGtleTogJ2ZvY3VzTmV4dCcsXG4gICAgdmFsdWU6IGZ1bmN0aW9uIGZvY3VzTmV4dChldnQsIGN1cnJlbnQpIHtcbiAgICAgIHZhciBuZXh0SXRlbSA9IHRoaXMubmV4dEl0ZW1zW2N1cnJlbnRdO1xuICAgICAgdmFyIHByZXZpb3VzSXRlbSA9IHRoaXMucHJldmlvdXNJdGVtc1tjdXJyZW50XTtcbiAgICAgIHZhciBjdXJyZW50VmFsdWUgPSB0aGlzLnJlZnNbY3VycmVudF0udmFsdWU7XG5cbiAgICAgIGlmIChuZXh0SXRlbSkge1xuICAgICAgICBpZiAoZXZ0LmtleSA9PT0gJy8nIHx8IGV2dC5rZXkgPT09ICctJyB8fCBldnQua2V5ID09PSAnQXJyb3dSaWdodCcgJiYgZXZ0LnRhcmdldC5zZWxlY3Rpb25TdGFydCA9PT0gY3VycmVudFZhbHVlLmxlbmd0aCkge1xuICAgICAgICAgIHNldEZvY3VzKHRoaXMucmVmc1tuZXh0SXRlbV0pO1xuICAgICAgICB9XG4gICAgICB9XG5cbiAgICAgIGlmIChwcmV2aW91c0l0ZW0pIHtcbiAgICAgICAgaWYgKGV2dC5rZXkgPT09ICdBcnJvd0xlZnQnICYmIGV2dC50YXJnZXQuc2VsZWN0aW9uU3RhcnQgPT09IDApIHtcbiAgICAgICAgICBzZXRGb2N1cyh0aGlzLnJlZnNbcHJldmlvdXNJdGVtXSk7XG4gICAgICAgIH0gZWxzZSBpZiAoY3VycmVudFZhbHVlLmxlbmd0aCA9PT0gMCAmJiBldnQua2V5ID09PSAnQmFja3NwYWNlJykge1xuICAgICAgICAgIHNldEZvY3VzKHRoaXMucmVmc1twcmV2aW91c0l0ZW1dKTtcbiAgICAgICAgICBldnQucHJldmVudERlZmF1bHQoKTtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cbiAgfSwge1xuICAgIGtleTogJ3JlbmRlcicsXG4gICAgdmFsdWU6IGZ1bmN0aW9uIHJlbmRlcigpIHtcbiAgICAgIHZhciBkYXkgPSBpbnB1dEJ1aWxkZXIodGhpcywgJ2RheScsICdERCcsIDIsIHRoaXMucHJvcHMubGFiZWwpO1xuICAgICAgdmFyIG1vbnRoID0gaW5wdXRCdWlsZGVyKHRoaXMsICdtb250aCcsICdNTScsIDIsIHRoaXMucHJvcHMubGFiZWwpO1xuICAgICAgdmFyIHllYXIgPSBpbnB1dEJ1aWxkZXIodGhpcywgJ3llYXInLCAnWVlZWScsIDQsIHRoaXMucHJvcHMubGFiZWwpO1xuXG4gICAgICB2YXIgZGF0ZUNvbXBvbmVudHMgPSB7IGRheTogZGF5LCBtb250aDogbW9udGgsIHllYXI6IHllYXIgfTtcbiAgICAgIHZhciBzZXF1ZW5jZSA9IHRoaXMucHJvcHMuc2VxdWVuY2UgfHwgWydkYXknLCAnbW9udGgnLCAneWVhciddO1xuXG4gICAgICByZXR1cm4gX3JlYWN0Mi5kZWZhdWx0LmNyZWF0ZUVsZW1lbnQoXG4gICAgICAgICdkaXYnLFxuICAgICAgICB7IGNsYXNzTmFtZTogJ3Rlcy1zaW1wbGUtZGF0ZScgfSxcbiAgICAgICAgX3JlYWN0Mi5kZWZhdWx0LmNyZWF0ZUVsZW1lbnQoJ2lucHV0JywgeyB0eXBlOiAnaGlkZGVuJywgbmFtZTogdGhpcy5wcm9wcy5uYW1lLCB2YWx1ZTogdGhpcy5wcm9wcy52YWx1ZSB9KSxcbiAgICAgICAgZGF0ZUNvbXBvbmVudHNbc2VxdWVuY2VbMF1dLFxuICAgICAgICAnLycsXG4gICAgICAgIGRhdGVDb21wb25lbnRzW3NlcXVlbmNlWzFdXSxcbiAgICAgICAgJy8nLFxuICAgICAgICBkYXRlQ29tcG9uZW50c1tzZXF1ZW5jZVsyXV1cbiAgICAgICk7XG4gICAgfVxuICB9XSk7XG4gIHJldHVybiBTaW1wbGVEYXRlO1xufShfcmVhY3QuQ29tcG9uZW50KTtcblxuU2ltcGxlRGF0ZS5wcm9wVHlwZXMgPSB7XG4gIG5hbWU6IF9yZWFjdC5Qcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIGxhYmVsOiBfcmVhY3QuUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB2YWx1ZTogX3JlYWN0LlByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgb25DaGFuZ2U6IF9yZWFjdC5Qcm9wVHlwZXMuZnVuYy5pc1JlcXVpcmVkLFxuICBzZXF1ZW5jZTogX3JlYWN0LlByb3BUeXBlcy5hcnJheVxufTtcblxuZXhwb3J0cy5kZWZhdWx0ID0gU2ltcGxlRGF0ZTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4vLyBzaGltIGZvciB1c2luZyBwcm9jZXNzIGluIGJyb3dzZXJcbnZhciBwcm9jZXNzID0gbW9kdWxlLmV4cG9ydHMgPSB7fTtcblxuLy8gY2FjaGVkIGZyb20gd2hhdGV2ZXIgZ2xvYmFsIGlzIHByZXNlbnQgc28gdGhhdCB0ZXN0IHJ1bm5lcnMgdGhhdCBzdHViIGl0XG4vLyBkb24ndCBicmVhayB0aGluZ3MuICBCdXQgd2UgbmVlZCB0byB3cmFwIGl0IGluIGEgdHJ5IGNhdGNoIGluIGNhc2UgaXQgaXNcbi8vIHdyYXBwZWQgaW4gc3RyaWN0IG1vZGUgY29kZSB3aGljaCBkb2Vzbid0IGRlZmluZSBhbnkgZ2xvYmFscy4gIEl0J3MgaW5zaWRlIGFcbi8vIGZ1bmN0aW9uIGJlY2F1c2UgdHJ5L2NhdGNoZXMgZGVvcHRpbWl6ZSBpbiBjZXJ0YWluIGVuZ2luZXMuXG5cbnZhciBjYWNoZWRTZXRUaW1lb3V0O1xudmFyIGNhY2hlZENsZWFyVGltZW91dDtcblxuZnVuY3Rpb24gZGVmYXVsdFNldFRpbW91dCgpIHtcbiAgICB0aHJvdyBuZXcgRXJyb3IoJ3NldFRpbWVvdXQgaGFzIG5vdCBiZWVuIGRlZmluZWQnKTtcbn1cbmZ1bmN0aW9uIGRlZmF1bHRDbGVhclRpbWVvdXQgKCkge1xuICAgIHRocm93IG5ldyBFcnJvcignY2xlYXJUaW1lb3V0IGhhcyBub3QgYmVlbiBkZWZpbmVkJyk7XG59XG4oZnVuY3Rpb24gKCkge1xuICAgIHRyeSB7XG4gICAgICAgIGlmICh0eXBlb2Ygc2V0VGltZW91dCA9PT0gJ2Z1bmN0aW9uJykge1xuICAgICAgICAgICAgY2FjaGVkU2V0VGltZW91dCA9IHNldFRpbWVvdXQ7XG4gICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgICBjYWNoZWRTZXRUaW1lb3V0ID0gZGVmYXVsdFNldFRpbW91dDtcbiAgICAgICAgfVxuICAgIH0gY2F0Y2ggKGUpIHtcbiAgICAgICAgY2FjaGVkU2V0VGltZW91dCA9IGRlZmF1bHRTZXRUaW1vdXQ7XG4gICAgfVxuICAgIHRyeSB7XG4gICAgICAgIGlmICh0eXBlb2YgY2xlYXJUaW1lb3V0ID09PSAnZnVuY3Rpb24nKSB7XG4gICAgICAgICAgICBjYWNoZWRDbGVhclRpbWVvdXQgPSBjbGVhclRpbWVvdXQ7XG4gICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgICBjYWNoZWRDbGVhclRpbWVvdXQgPSBkZWZhdWx0Q2xlYXJUaW1lb3V0O1xuICAgICAgICB9XG4gICAgfSBjYXRjaCAoZSkge1xuICAgICAgICBjYWNoZWRDbGVhclRpbWVvdXQgPSBkZWZhdWx0Q2xlYXJUaW1lb3V0O1xuICAgIH1cbn0gKCkpXG5mdW5jdGlvbiBydW5UaW1lb3V0KGZ1bikge1xuICAgIGlmIChjYWNoZWRTZXRUaW1lb3V0ID09PSBzZXRUaW1lb3V0KSB7XG4gICAgICAgIC8vbm9ybWFsIGVudmlyb21lbnRzIGluIHNhbmUgc2l0dWF0aW9uc1xuICAgICAgICByZXR1cm4gc2V0VGltZW91dChmdW4sIDApO1xuICAgIH1cbiAgICAvLyBpZiBzZXRUaW1lb3V0IHdhc24ndCBhdmFpbGFibGUgYnV0IHdhcyBsYXR0ZXIgZGVmaW5lZFxuICAgIGlmICgoY2FjaGVkU2V0VGltZW91dCA9PT0gZGVmYXVsdFNldFRpbW91dCB8fCAhY2FjaGVkU2V0VGltZW91dCkgJiYgc2V0VGltZW91dCkge1xuICAgICAgICBjYWNoZWRTZXRUaW1lb3V0ID0gc2V0VGltZW91dDtcbiAgICAgICAgcmV0dXJuIHNldFRpbWVvdXQoZnVuLCAwKTtcbiAgICB9XG4gICAgdHJ5IHtcbiAgICAgICAgLy8gd2hlbiB3aGVuIHNvbWVib2R5IGhhcyBzY3Jld2VkIHdpdGggc2V0VGltZW91dCBidXQgbm8gSS5FLiBtYWRkbmVzc1xuICAgICAgICByZXR1cm4gY2FjaGVkU2V0VGltZW91dChmdW4sIDApO1xuICAgIH0gY2F0Y2goZSl7XG4gICAgICAgIHRyeSB7XG4gICAgICAgICAgICAvLyBXaGVuIHdlIGFyZSBpbiBJLkUuIGJ1dCB0aGUgc2NyaXB0IGhhcyBiZWVuIGV2YWxlZCBzbyBJLkUuIGRvZXNuJ3QgdHJ1c3QgdGhlIGdsb2JhbCBvYmplY3Qgd2hlbiBjYWxsZWQgbm9ybWFsbHlcbiAgICAgICAgICAgIHJldHVybiBjYWNoZWRTZXRUaW1lb3V0LmNhbGwobnVsbCwgZnVuLCAwKTtcbiAgICAgICAgfSBjYXRjaChlKXtcbiAgICAgICAgICAgIC8vIHNhbWUgYXMgYWJvdmUgYnV0IHdoZW4gaXQncyBhIHZlcnNpb24gb2YgSS5FLiB0aGF0IG11c3QgaGF2ZSB0aGUgZ2xvYmFsIG9iamVjdCBmb3IgJ3RoaXMnLCBob3BmdWxseSBvdXIgY29udGV4dCBjb3JyZWN0IG90aGVyd2lzZSBpdCB3aWxsIHRocm93IGEgZ2xvYmFsIGVycm9yXG4gICAgICAgICAgICByZXR1cm4gY2FjaGVkU2V0VGltZW91dC5jYWxsKHRoaXMsIGZ1biwgMCk7XG4gICAgICAgIH1cbiAgICB9XG5cblxufVxuZnVuY3Rpb24gcnVuQ2xlYXJUaW1lb3V0KG1hcmtlcikge1xuICAgIGlmIChjYWNoZWRDbGVhclRpbWVvdXQgPT09IGNsZWFyVGltZW91dCkge1xuICAgICAgICAvL25vcm1hbCBlbnZpcm9tZW50cyBpbiBzYW5lIHNpdHVhdGlvbnNcbiAgICAgICAgcmV0dXJuIGNsZWFyVGltZW91dChtYXJrZXIpO1xuICAgIH1cbiAgICAvLyBpZiBjbGVhclRpbWVvdXQgd2Fzbid0IGF2YWlsYWJsZSBidXQgd2FzIGxhdHRlciBkZWZpbmVkXG4gICAgaWYgKChjYWNoZWRDbGVhclRpbWVvdXQgPT09IGRlZmF1bHRDbGVhclRpbWVvdXQgfHwgIWNhY2hlZENsZWFyVGltZW91dCkgJiYgY2xlYXJUaW1lb3V0KSB7XG4gICAgICAgIGNhY2hlZENsZWFyVGltZW91dCA9IGNsZWFyVGltZW91dDtcbiAgICAgICAgcmV0dXJuIGNsZWFyVGltZW91dChtYXJrZXIpO1xuICAgIH1cbiAgICB0cnkge1xuICAgICAgICAvLyB3aGVuIHdoZW4gc29tZWJvZHkgaGFzIHNjcmV3ZWQgd2l0aCBzZXRUaW1lb3V0IGJ1dCBubyBJLkUuIG1hZGRuZXNzXG4gICAgICAgIHJldHVybiBjYWNoZWRDbGVhclRpbWVvdXQobWFya2VyKTtcbiAgICB9IGNhdGNoIChlKXtcbiAgICAgICAgdHJ5IHtcbiAgICAgICAgICAgIC8vIFdoZW4gd2UgYXJlIGluIEkuRS4gYnV0IHRoZSBzY3JpcHQgaGFzIGJlZW4gZXZhbGVkIHNvIEkuRS4gZG9lc24ndCAgdHJ1c3QgdGhlIGdsb2JhbCBvYmplY3Qgd2hlbiBjYWxsZWQgbm9ybWFsbHlcbiAgICAgICAgICAgIHJldHVybiBjYWNoZWRDbGVhclRpbWVvdXQuY2FsbChudWxsLCBtYXJrZXIpO1xuICAgICAgICB9IGNhdGNoIChlKXtcbiAgICAgICAgICAgIC8vIHNhbWUgYXMgYWJvdmUgYnV0IHdoZW4gaXQncyBhIHZlcnNpb24gb2YgSS5FLiB0aGF0IG11c3QgaGF2ZSB0aGUgZ2xvYmFsIG9iamVjdCBmb3IgJ3RoaXMnLCBob3BmdWxseSBvdXIgY29udGV4dCBjb3JyZWN0IG90aGVyd2lzZSBpdCB3aWxsIHRocm93IGEgZ2xvYmFsIGVycm9yLlxuICAgICAgICAgICAgLy8gU29tZSB2ZXJzaW9ucyBvZiBJLkUuIGhhdmUgZGlmZmVyZW50IHJ1bGVzIGZvciBjbGVhclRpbWVvdXQgdnMgc2V0VGltZW91dFxuICAgICAgICAgICAgcmV0dXJuIGNhY2hlZENsZWFyVGltZW91dC5jYWxsKHRoaXMsIG1hcmtlcik7XG4gICAgICAgIH1cbiAgICB9XG5cblxuXG59XG52YXIgcXVldWUgPSBbXTtcbnZhciBkcmFpbmluZyA9IGZhbHNlO1xudmFyIGN1cnJlbnRRdWV1ZTtcbnZhciBxdWV1ZUluZGV4ID0gLTE7XG5cbmZ1bmN0aW9uIGNsZWFuVXBOZXh0VGljaygpIHtcbiAgICBpZiAoIWRyYWluaW5nIHx8ICFjdXJyZW50UXVldWUpIHtcbiAgICAgICAgcmV0dXJuO1xuICAgIH1cbiAgICBkcmFpbmluZyA9IGZhbHNlO1xuICAgIGlmIChjdXJyZW50UXVldWUubGVuZ3RoKSB7XG4gICAgICAgIHF1ZXVlID0gY3VycmVudFF1ZXVlLmNvbmNhdChxdWV1ZSk7XG4gICAgfSBlbHNlIHtcbiAgICAgICAgcXVldWVJbmRleCA9IC0xO1xuICAgIH1cbiAgICBpZiAocXVldWUubGVuZ3RoKSB7XG4gICAgICAgIGRyYWluUXVldWUoKTtcbiAgICB9XG59XG5cbmZ1bmN0aW9uIGRyYWluUXVldWUoKSB7XG4gICAgaWYgKGRyYWluaW5nKSB7XG4gICAgICAgIHJldHVybjtcbiAgICB9XG4gICAgdmFyIHRpbWVvdXQgPSBydW5UaW1lb3V0KGNsZWFuVXBOZXh0VGljayk7XG4gICAgZHJhaW5pbmcgPSB0cnVlO1xuXG4gICAgdmFyIGxlbiA9IHF1ZXVlLmxlbmd0aDtcbiAgICB3aGlsZShsZW4pIHtcbiAgICAgICAgY3VycmVudFF1ZXVlID0gcXVldWU7XG4gICAgICAgIHF1ZXVlID0gW107XG4gICAgICAgIHdoaWxlICgrK3F1ZXVlSW5kZXggPCBsZW4pIHtcbiAgICAgICAgICAgIGlmIChjdXJyZW50UXVldWUpIHtcbiAgICAgICAgICAgICAgICBjdXJyZW50UXVldWVbcXVldWVJbmRleF0ucnVuKCk7XG4gICAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgICAgcXVldWVJbmRleCA9IC0xO1xuICAgICAgICBsZW4gPSBxdWV1ZS5sZW5ndGg7XG4gICAgfVxuICAgIGN1cnJlbnRRdWV1ZSA9IG51bGw7XG4gICAgZHJhaW5pbmcgPSBmYWxzZTtcbiAgICBydW5DbGVhclRpbWVvdXQodGltZW91dCk7XG59XG5cbnByb2Nlc3MubmV4dFRpY2sgPSBmdW5jdGlvbiAoZnVuKSB7XG4gICAgdmFyIGFyZ3MgPSBuZXcgQXJyYXkoYXJndW1lbnRzLmxlbmd0aCAtIDEpO1xuICAgIGlmIChhcmd1bWVudHMubGVuZ3RoID4gMSkge1xuICAgICAgICBmb3IgKHZhciBpID0gMTsgaSA8IGFyZ3VtZW50cy5sZW5ndGg7IGkrKykge1xuICAgICAgICAgICAgYXJnc1tpIC0gMV0gPSBhcmd1bWVudHNbaV07XG4gICAgICAgIH1cbiAgICB9XG4gICAgcXVldWUucHVzaChuZXcgSXRlbShmdW4sIGFyZ3MpKTtcbiAgICBpZiAocXVldWUubGVuZ3RoID09PSAxICYmICFkcmFpbmluZykge1xuICAgICAgICBydW5UaW1lb3V0KGRyYWluUXVldWUpO1xuICAgIH1cbn07XG5cbi8vIHY4IGxpa2VzIHByZWRpY3RpYmxlIG9iamVjdHNcbmZ1bmN0aW9uIEl0ZW0oZnVuLCBhcnJheSkge1xuICAgIHRoaXMuZnVuID0gZnVuO1xuICAgIHRoaXMuYXJyYXkgPSBhcnJheTtcbn1cbkl0ZW0ucHJvdG90eXBlLnJ1biA9IGZ1bmN0aW9uICgpIHtcbiAgICB0aGlzLmZ1bi5hcHBseShudWxsLCB0aGlzLmFycmF5KTtcbn07XG5wcm9jZXNzLnRpdGxlID0gJ2Jyb3dzZXInO1xucHJvY2Vzcy5icm93c2VyID0gdHJ1ZTtcbnByb2Nlc3MuZW52ID0ge307XG5wcm9jZXNzLmFyZ3YgPSBbXTtcbnByb2Nlc3MudmVyc2lvbiA9ICcnOyAvLyBlbXB0eSBzdHJpbmcgdG8gYXZvaWQgcmVnZXhwIGlzc3Vlc1xucHJvY2Vzcy52ZXJzaW9ucyA9IHt9O1xuXG5mdW5jdGlvbiBub29wKCkge31cblxucHJvY2Vzcy5vbiA9IG5vb3A7XG5wcm9jZXNzLmFkZExpc3RlbmVyID0gbm9vcDtcbnByb2Nlc3Mub25jZSA9IG5vb3A7XG5wcm9jZXNzLm9mZiA9IG5vb3A7XG5wcm9jZXNzLnJlbW92ZUxpc3RlbmVyID0gbm9vcDtcbnByb2Nlc3MucmVtb3ZlQWxsTGlzdGVuZXJzID0gbm9vcDtcbnByb2Nlc3MuZW1pdCA9IG5vb3A7XG5wcm9jZXNzLnByZXBlbmRMaXN0ZW5lciA9IG5vb3A7XG5wcm9jZXNzLnByZXBlbmRPbmNlTGlzdGVuZXIgPSBub29wO1xuXG5wcm9jZXNzLmxpc3RlbmVycyA9IGZ1bmN0aW9uIChuYW1lKSB7IHJldHVybiBbXSB9XG5cbnByb2Nlc3MuYmluZGluZyA9IGZ1bmN0aW9uIChuYW1lKSB7XG4gICAgdGhyb3cgbmV3IEVycm9yKCdwcm9jZXNzLmJpbmRpbmcgaXMgbm90IHN1cHBvcnRlZCcpO1xufTtcblxucHJvY2Vzcy5jd2QgPSBmdW5jdGlvbiAoKSB7IHJldHVybiAnLycgfTtcbnByb2Nlc3MuY2hkaXIgPSBmdW5jdGlvbiAoZGlyKSB7XG4gICAgdGhyb3cgbmV3IEVycm9yKCdwcm9jZXNzLmNoZGlyIGlzIG5vdCBzdXBwb3J0ZWQnKTtcbn07XG5wcm9jZXNzLnVtYXNrID0gZnVuY3Rpb24oKSB7IHJldHVybiAwOyB9O1xuXG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xubW9kdWxlLmV4cG9ydHMgPSByZXF1aXJlKDE0Mylcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4ndXNlIHN0cmljdCc7XG5cbk9iamVjdC5kZWZpbmVQcm9wZXJ0eShleHBvcnRzLCBcIl9fZXNNb2R1bGVcIiwge1xuICB2YWx1ZTogdHJ1ZVxufSk7XG5cbnZhciBfaW8gPSByZXF1aXJlKDE0OCk7XG5cbk9iamVjdC5kZWZpbmVQcm9wZXJ0eShleHBvcnRzLCAndGFrZScsIHtcbiAgZW51bWVyYWJsZTogdHJ1ZSxcbiAgZ2V0OiBmdW5jdGlvbiBnZXQoKSB7XG4gICAgcmV0dXJuIF9pby50YWtlO1xuICB9XG59KTtcbk9iamVjdC5kZWZpbmVQcm9wZXJ0eShleHBvcnRzLCAndGFrZW0nLCB7XG4gIGVudW1lcmFibGU6IHRydWUsXG4gIGdldDogZnVuY3Rpb24gZ2V0KCkge1xuICAgIHJldHVybiBfaW8udGFrZW07XG4gIH1cbn0pO1xuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsICdwdXQnLCB7XG4gIGVudW1lcmFibGU6IHRydWUsXG4gIGdldDogZnVuY3Rpb24gZ2V0KCkge1xuICAgIHJldHVybiBfaW8ucHV0O1xuICB9XG59KTtcbk9iamVjdC5kZWZpbmVQcm9wZXJ0eShleHBvcnRzLCAncmFjZScsIHtcbiAgZW51bWVyYWJsZTogdHJ1ZSxcbiAgZ2V0OiBmdW5jdGlvbiBnZXQoKSB7XG4gICAgcmV0dXJuIF9pby5yYWNlO1xuICB9XG59KTtcbk9iamVjdC5kZWZpbmVQcm9wZXJ0eShleHBvcnRzLCAnY2FsbCcsIHtcbiAgZW51bWVyYWJsZTogdHJ1ZSxcbiAgZ2V0OiBmdW5jdGlvbiBnZXQoKSB7XG4gICAgcmV0dXJuIF9pby5jYWxsO1xuICB9XG59KTtcbk9iamVjdC5kZWZpbmVQcm9wZXJ0eShleHBvcnRzLCAnYXBwbHknLCB7XG4gIGVudW1lcmFibGU6IHRydWUsXG4gIGdldDogZnVuY3Rpb24gZ2V0KCkge1xuICAgIHJldHVybiBfaW8uYXBwbHk7XG4gIH1cbn0pO1xuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsICdjcHMnLCB7XG4gIGVudW1lcmFibGU6IHRydWUsXG4gIGdldDogZnVuY3Rpb24gZ2V0KCkge1xuICAgIHJldHVybiBfaW8uY3BzO1xuICB9XG59KTtcbk9iamVjdC5kZWZpbmVQcm9wZXJ0eShleHBvcnRzLCAnZm9yaycsIHtcbiAgZW51bWVyYWJsZTogdHJ1ZSxcbiAgZ2V0OiBmdW5jdGlvbiBnZXQoKSB7XG4gICAgcmV0dXJuIF9pby5mb3JrO1xuICB9XG59KTtcbk9iamVjdC5kZWZpbmVQcm9wZXJ0eShleHBvcnRzLCAnc3Bhd24nLCB7XG4gIGVudW1lcmFibGU6IHRydWUsXG4gIGdldDogZnVuY3Rpb24gZ2V0KCkge1xuICAgIHJldHVybiBfaW8uc3Bhd247XG4gIH1cbn0pO1xuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsICdqb2luJywge1xuICBlbnVtZXJhYmxlOiB0cnVlLFxuICBnZXQ6IGZ1bmN0aW9uIGdldCgpIHtcbiAgICByZXR1cm4gX2lvLmpvaW47XG4gIH1cbn0pO1xuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsICdjYW5jZWwnLCB7XG4gIGVudW1lcmFibGU6IHRydWUsXG4gIGdldDogZnVuY3Rpb24gZ2V0KCkge1xuICAgIHJldHVybiBfaW8uY2FuY2VsO1xuICB9XG59KTtcbk9iamVjdC5kZWZpbmVQcm9wZXJ0eShleHBvcnRzLCAnc2VsZWN0Jywge1xuICBlbnVtZXJhYmxlOiB0cnVlLFxuICBnZXQ6IGZ1bmN0aW9uIGdldCgpIHtcbiAgICByZXR1cm4gX2lvLnNlbGVjdDtcbiAgfVxufSk7XG5PYmplY3QuZGVmaW5lUHJvcGVydHkoZXhwb3J0cywgJ2FjdGlvbkNoYW5uZWwnLCB7XG4gIGVudW1lcmFibGU6IHRydWUsXG4gIGdldDogZnVuY3Rpb24gZ2V0KCkge1xuICAgIHJldHVybiBfaW8uYWN0aW9uQ2hhbm5lbDtcbiAgfVxufSk7XG5PYmplY3QuZGVmaW5lUHJvcGVydHkoZXhwb3J0cywgJ2NhbmNlbGxlZCcsIHtcbiAgZW51bWVyYWJsZTogdHJ1ZSxcbiAgZ2V0OiBmdW5jdGlvbiBnZXQoKSB7XG4gICAgcmV0dXJuIF9pby5jYW5jZWxsZWQ7XG4gIH1cbn0pO1xuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsICdmbHVzaCcsIHtcbiAgZW51bWVyYWJsZTogdHJ1ZSxcbiAgZ2V0OiBmdW5jdGlvbiBnZXQoKSB7XG4gICAgcmV0dXJuIF9pby5mbHVzaDtcbiAgfVxufSk7XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xuJ3VzZSBzdHJpY3QnO1xuXG5PYmplY3QuZGVmaW5lUHJvcGVydHkoZXhwb3J0cywgXCJfX2VzTW9kdWxlXCIsIHtcbiAgdmFsdWU6IHRydWVcbn0pO1xuZXhwb3J0cy51dGlscyA9IGV4cG9ydHMuZWZmZWN0cyA9IGV4cG9ydHMuQ0FOQ0VMID0gZXhwb3J0cy5kZWxheSA9IGV4cG9ydHMudGhyb3R0bGUgPSBleHBvcnRzLnRha2VMYXRlc3QgPSBleHBvcnRzLnRha2VFdmVyeSA9IGV4cG9ydHMuYnVmZmVycyA9IGV4cG9ydHMuY2hhbm5lbCA9IGV4cG9ydHMuZXZlbnRDaGFubmVsID0gZXhwb3J0cy5FTkQgPSBleHBvcnRzLnJ1blNhZ2EgPSB1bmRlZmluZWQ7XG5cbnZhciBfcnVuU2FnYSA9IHJlcXVpcmUoMTUxKTtcblxuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsICdydW5TYWdhJywge1xuICBlbnVtZXJhYmxlOiB0cnVlLFxuICBnZXQ6IGZ1bmN0aW9uIGdldCgpIHtcbiAgICByZXR1cm4gX3J1blNhZ2EucnVuU2FnYTtcbiAgfVxufSk7XG5cbnZhciBfY2hhbm5lbCA9IHJlcXVpcmUoMTQ3KTtcblxuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsICdFTkQnLCB7XG4gIGVudW1lcmFibGU6IHRydWUsXG4gIGdldDogZnVuY3Rpb24gZ2V0KCkge1xuICAgIHJldHVybiBfY2hhbm5lbC5FTkQ7XG4gIH1cbn0pO1xuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsICdldmVudENoYW5uZWwnLCB7XG4gIGVudW1lcmFibGU6IHRydWUsXG4gIGdldDogZnVuY3Rpb24gZ2V0KCkge1xuICAgIHJldHVybiBfY2hhbm5lbC5ldmVudENoYW5uZWw7XG4gIH1cbn0pO1xuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsICdjaGFubmVsJywge1xuICBlbnVtZXJhYmxlOiB0cnVlLFxuICBnZXQ6IGZ1bmN0aW9uIGdldCgpIHtcbiAgICByZXR1cm4gX2NoYW5uZWwuY2hhbm5lbDtcbiAgfVxufSk7XG5cbnZhciBfYnVmZmVycyA9IHJlcXVpcmUoMTQ2KTtcblxuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsICdidWZmZXJzJywge1xuICBlbnVtZXJhYmxlOiB0cnVlLFxuICBnZXQ6IGZ1bmN0aW9uIGdldCgpIHtcbiAgICByZXR1cm4gX2J1ZmZlcnMuYnVmZmVycztcbiAgfVxufSk7XG5cbnZhciBfc2FnYUhlbHBlcnMgPSByZXF1aXJlKDE1Mik7XG5cbk9iamVjdC5kZWZpbmVQcm9wZXJ0eShleHBvcnRzLCAndGFrZUV2ZXJ5Jywge1xuICBlbnVtZXJhYmxlOiB0cnVlLFxuICBnZXQ6IGZ1bmN0aW9uIGdldCgpIHtcbiAgICByZXR1cm4gX3NhZ2FIZWxwZXJzLnRha2VFdmVyeTtcbiAgfVxufSk7XG5PYmplY3QuZGVmaW5lUHJvcGVydHkoZXhwb3J0cywgJ3Rha2VMYXRlc3QnLCB7XG4gIGVudW1lcmFibGU6IHRydWUsXG4gIGdldDogZnVuY3Rpb24gZ2V0KCkge1xuICAgIHJldHVybiBfc2FnYUhlbHBlcnMudGFrZUxhdGVzdDtcbiAgfVxufSk7XG5PYmplY3QuZGVmaW5lUHJvcGVydHkoZXhwb3J0cywgJ3Rocm90dGxlJywge1xuICBlbnVtZXJhYmxlOiB0cnVlLFxuICBnZXQ6IGZ1bmN0aW9uIGdldCgpIHtcbiAgICByZXR1cm4gX3NhZ2FIZWxwZXJzLnRocm90dGxlO1xuICB9XG59KTtcblxudmFyIF91dGlscyA9IHJlcXVpcmUoMTUzKTtcblxuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsICdkZWxheScsIHtcbiAgZW51bWVyYWJsZTogdHJ1ZSxcbiAgZ2V0OiBmdW5jdGlvbiBnZXQoKSB7XG4gICAgcmV0dXJuIF91dGlscy5kZWxheTtcbiAgfVxufSk7XG5PYmplY3QuZGVmaW5lUHJvcGVydHkoZXhwb3J0cywgJ0NBTkNFTCcsIHtcbiAgZW51bWVyYWJsZTogdHJ1ZSxcbiAgZ2V0OiBmdW5jdGlvbiBnZXQoKSB7XG4gICAgcmV0dXJuIF91dGlscy5DQU5DRUw7XG4gIH1cbn0pO1xuXG52YXIgX21pZGRsZXdhcmUgPSByZXF1aXJlKDE0OSk7XG5cbnZhciBfbWlkZGxld2FyZTIgPSBfaW50ZXJvcFJlcXVpcmVEZWZhdWx0KF9taWRkbGV3YXJlKTtcblxudmFyIF9lZmZlY3RzID0gcmVxdWlyZSgxNDMpO1xuXG52YXIgZWZmZWN0cyA9IF9pbnRlcm9wUmVxdWlyZVdpbGRjYXJkKF9lZmZlY3RzKTtcblxudmFyIF91dGlsczIgPSByZXF1aXJlKDE1NCk7XG5cbnZhciB1dGlscyA9IF9pbnRlcm9wUmVxdWlyZVdpbGRjYXJkKF91dGlsczIpO1xuXG5mdW5jdGlvbiBfaW50ZXJvcFJlcXVpcmVXaWxkY2FyZChvYmopIHsgaWYgKG9iaiAmJiBvYmouX19lc01vZHVsZSkgeyByZXR1cm4gb2JqOyB9IGVsc2UgeyB2YXIgbmV3T2JqID0ge307IGlmIChvYmogIT0gbnVsbCkgeyBmb3IgKHZhciBrZXkgaW4gb2JqKSB7IGlmIChPYmplY3QucHJvdG90eXBlLmhhc093blByb3BlcnR5LmNhbGwob2JqLCBrZXkpKSBuZXdPYmpba2V5XSA9IG9ialtrZXldOyB9IH0gbmV3T2JqLmRlZmF1bHQgPSBvYmo7IHJldHVybiBuZXdPYmo7IH0gfVxuXG5mdW5jdGlvbiBfaW50ZXJvcFJlcXVpcmVEZWZhdWx0KG9iaikgeyByZXR1cm4gb2JqICYmIG9iai5fX2VzTW9kdWxlID8gb2JqIDogeyBkZWZhdWx0OiBvYmogfTsgfVxuXG5leHBvcnRzLmRlZmF1bHQgPSBfbWlkZGxld2FyZTIuZGVmYXVsdDtcbmV4cG9ydHMuZWZmZWN0cyA9IGVmZmVjdHM7XG5leHBvcnRzLnV0aWxzID0gdXRpbHM7XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xuXCJ1c2Ugc3RyaWN0XCI7XG5cbk9iamVjdC5kZWZpbmVQcm9wZXJ0eShleHBvcnRzLCBcIl9fZXNNb2R1bGVcIiwge1xuICB2YWx1ZTogdHJ1ZVxufSk7XG5leHBvcnRzLmRlZmF1bHQgPSBhc2FwO1xudmFyIHF1ZXVlID0gW107XG52YXIgaXNTdXNwZW5kZWQgPSBmYWxzZTtcblxuZnVuY3Rpb24gYXNhcCh0YXNrKSB7XG4gIGlmICghaXNTdXNwZW5kZWQpIHtcbiAgICBpc1N1c3BlbmRlZCA9IHRydWU7XG4gICAgcXVldWUucHVzaCh0YXNrKTtcbiAgICBhc2FwLmZsdXNoKCk7XG4gIH0gZWxzZSB7XG4gICAgcXVldWUucHVzaCh0YXNrKTtcbiAgfVxufVxuXG5hc2FwLnN1c3BlbmQgPSBmdW5jdGlvbiAoKSB7XG4gIHJldHVybiBpc1N1c3BlbmRlZCA9IHRydWU7XG59O1xuYXNhcC5mbHVzaCA9IGZ1bmN0aW9uICgpIHtcbiAgdmFyIG5leHRUYXNrID0gdm9pZCAwO1xuICB3aGlsZSAobmV4dFRhc2sgPSBxdWV1ZS5zaGlmdCgpKSB7XG4gICAgbmV4dFRhc2soKTtcbiAgfVxuICBpc1N1c3BlbmRlZCA9IGZhbHNlO1xufTtcbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4ndXNlIHN0cmljdCc7XG5cbk9iamVjdC5kZWZpbmVQcm9wZXJ0eShleHBvcnRzLCBcIl9fZXNNb2R1bGVcIiwge1xuICB2YWx1ZTogdHJ1ZVxufSk7XG5leHBvcnRzLmJ1ZmZlcnMgPSBleHBvcnRzLkJVRkZFUl9PVkVSRkxPVyA9IHVuZGVmaW5lZDtcblxudmFyIF91dGlscyA9IHJlcXVpcmUoMTUzKTtcblxudmFyIEJVRkZFUl9PVkVSRkxPVyA9IGV4cG9ydHMuQlVGRkVSX09WRVJGTE9XID0gJ0NoYW5uZWxcXCdzIEJ1ZmZlciBvdmVyZmxvdyEnO1xuXG52YXIgT05fT1ZFUkZMT1dfVEhST1cgPSAxO1xudmFyIE9OX09WRVJGTE9XX0RST1AgPSAyO1xudmFyIE9OX09WRVJGTE9XX1NMSURFID0gMztcbnZhciBPTl9PVkVSRkxPV19FWFBBTkQgPSA0O1xuXG52YXIgemVyb0J1ZmZlciA9IHsgaXNFbXB0eTogX3V0aWxzLmtUcnVlLCBwdXQ6IF91dGlscy5ub29wLCB0YWtlOiBfdXRpbHMubm9vcCB9O1xuXG5mdW5jdGlvbiByaW5nQnVmZmVyKCkge1xuICB2YXIgbGltaXQgPSBhcmd1bWVudHMubGVuZ3RoIDw9IDAgfHwgYXJndW1lbnRzWzBdID09PSB1bmRlZmluZWQgPyAxMCA6IGFyZ3VtZW50c1swXTtcbiAgdmFyIG92ZXJmbG93QWN0aW9uID0gYXJndW1lbnRzWzFdO1xuXG4gIHZhciBhcnIgPSBuZXcgQXJyYXkobGltaXQpO1xuICB2YXIgbGVuZ3RoID0gMDtcbiAgdmFyIHB1c2hJbmRleCA9IDA7XG4gIHZhciBwb3BJbmRleCA9IDA7XG5cbiAgdmFyIHB1c2ggPSBmdW5jdGlvbiBwdXNoKGl0KSB7XG4gICAgYXJyW3B1c2hJbmRleF0gPSBpdDtcbiAgICBwdXNoSW5kZXggPSAocHVzaEluZGV4ICsgMSkgJSBsaW1pdDtcbiAgICBsZW5ndGgrKztcbiAgfTtcblxuICB2YXIgdGFrZSA9IGZ1bmN0aW9uIHRha2UoKSB7XG4gICAgaWYgKGxlbmd0aCAhPSAwKSB7XG4gICAgICB2YXIgaXQgPSBhcnJbcG9wSW5kZXhdO1xuICAgICAgYXJyW3BvcEluZGV4XSA9IG51bGw7XG4gICAgICBsZW5ndGgtLTtcbiAgICAgIHBvcEluZGV4ID0gKHBvcEluZGV4ICsgMSkgJSBsaW1pdDtcbiAgICAgIHJldHVybiBpdDtcbiAgICB9XG4gIH07XG5cbiAgdmFyIGZsdXNoID0gZnVuY3Rpb24gZmx1c2goKSB7XG4gICAgdmFyIGl0ZW1zID0gW107XG4gICAgd2hpbGUgKGxlbmd0aCkge1xuICAgICAgaXRlbXMucHVzaCh0YWtlKCkpO1xuICAgIH1cbiAgICByZXR1cm4gaXRlbXM7XG4gIH07XG5cbiAgcmV0dXJuIHtcbiAgICBpc0VtcHR5OiBmdW5jdGlvbiBpc0VtcHR5KCkge1xuICAgICAgcmV0dXJuIGxlbmd0aCA9PSAwO1xuICAgIH0sXG4gICAgcHV0OiBmdW5jdGlvbiBwdXQoaXQpIHtcbiAgICAgIGlmIChsZW5ndGggPCBsaW1pdCkge1xuICAgICAgICBwdXNoKGl0KTtcbiAgICAgIH0gZWxzZSB7XG4gICAgICAgIHZhciBkb3VibGVkTGltaXQgPSB2b2lkIDA7XG4gICAgICAgIHN3aXRjaCAob3ZlcmZsb3dBY3Rpb24pIHtcbiAgICAgICAgICBjYXNlIE9OX09WRVJGTE9XX1RIUk9XOlxuICAgICAgICAgICAgdGhyb3cgbmV3IEVycm9yKEJVRkZFUl9PVkVSRkxPVyk7XG4gICAgICAgICAgY2FzZSBPTl9PVkVSRkxPV19TTElERTpcbiAgICAgICAgICAgIGFycltwdXNoSW5kZXhdID0gaXQ7XG4gICAgICAgICAgICBwdXNoSW5kZXggPSAocHVzaEluZGV4ICsgMSkgJSBsaW1pdDtcbiAgICAgICAgICAgIHBvcEluZGV4ID0gcHVzaEluZGV4O1xuICAgICAgICAgICAgYnJlYWs7XG4gICAgICAgICAgY2FzZSBPTl9PVkVSRkxPV19FWFBBTkQ6XG4gICAgICAgICAgICBkb3VibGVkTGltaXQgPSAyICogbGltaXQ7XG5cbiAgICAgICAgICAgIGFyciA9IGZsdXNoKCk7XG5cbiAgICAgICAgICAgIGxlbmd0aCA9IGFyci5sZW5ndGg7XG4gICAgICAgICAgICBwdXNoSW5kZXggPSBhcnIubGVuZ3RoO1xuICAgICAgICAgICAgcG9wSW5kZXggPSAwO1xuXG4gICAgICAgICAgICBhcnIubGVuZ3RoID0gZG91YmxlZExpbWl0O1xuICAgICAgICAgICAgbGltaXQgPSBkb3VibGVkTGltaXQ7XG5cbiAgICAgICAgICAgIHB1c2goaXQpO1xuICAgICAgICAgICAgYnJlYWs7XG4gICAgICAgICAgZGVmYXVsdDpcbiAgICAgICAgICAvLyBEUk9QXG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9LFxuICAgIHRha2U6IHRha2UsIGZsdXNoOiBmbHVzaFxuICB9O1xufVxuXG52YXIgYnVmZmVycyA9IGV4cG9ydHMuYnVmZmVycyA9IHtcbiAgbm9uZTogZnVuY3Rpb24gbm9uZSgpIHtcbiAgICByZXR1cm4gemVyb0J1ZmZlcjtcbiAgfSxcbiAgZml4ZWQ6IGZ1bmN0aW9uIGZpeGVkKGxpbWl0KSB7XG4gICAgcmV0dXJuIHJpbmdCdWZmZXIobGltaXQsIE9OX09WRVJGTE9XX1RIUk9XKTtcbiAgfSxcbiAgZHJvcHBpbmc6IGZ1bmN0aW9uIGRyb3BwaW5nKGxpbWl0KSB7XG4gICAgcmV0dXJuIHJpbmdCdWZmZXIobGltaXQsIE9OX09WRVJGTE9XX0RST1ApO1xuICB9LFxuICBzbGlkaW5nOiBmdW5jdGlvbiBzbGlkaW5nKGxpbWl0KSB7XG4gICAgcmV0dXJuIHJpbmdCdWZmZXIobGltaXQsIE9OX09WRVJGTE9XX1NMSURFKTtcbiAgfSxcbiAgZXhwYW5kaW5nOiBmdW5jdGlvbiBleHBhbmRpbmcoaW5pdGlhbFNpemUpIHtcbiAgICByZXR1cm4gcmluZ0J1ZmZlcihpbml0aWFsU2l6ZSwgT05fT1ZFUkZMT1dfRVhQQU5EKTtcbiAgfVxufTtcbn0pOyIsInJlcXVpcmUoJy9yb290L2FwcC9ub2RlX21vZHVsZXMvYXN5bmMtZGVmaW5lL2xpYi9hc3luY0RlZmluZS5qcycpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xuJ3VzZSBzdHJpY3QnO1xuXG5PYmplY3QuZGVmaW5lUHJvcGVydHkoZXhwb3J0cywgXCJfX2VzTW9kdWxlXCIsIHtcbiAgdmFsdWU6IHRydWVcbn0pO1xuZXhwb3J0cy5VTkRFRklORURfSU5QVVRfRVJST1IgPSBleHBvcnRzLklOVkFMSURfQlVGRkVSID0gZXhwb3J0cy5pc0VuZCA9IGV4cG9ydHMuRU5EID0gdW5kZWZpbmVkO1xuXG52YXIgX2V4dGVuZHMgPSBPYmplY3QuYXNzaWduIHx8IGZ1bmN0aW9uICh0YXJnZXQpIHsgZm9yICh2YXIgaSA9IDE7IGkgPCBhcmd1bWVudHMubGVuZ3RoOyBpKyspIHsgdmFyIHNvdXJjZSA9IGFyZ3VtZW50c1tpXTsgZm9yICh2YXIga2V5IGluIHNvdXJjZSkgeyBpZiAoT2JqZWN0LnByb3RvdHlwZS5oYXNPd25Qcm9wZXJ0eS5jYWxsKHNvdXJjZSwga2V5KSkgeyB0YXJnZXRba2V5XSA9IHNvdXJjZVtrZXldOyB9IH0gfSByZXR1cm4gdGFyZ2V0OyB9O1xuXG5leHBvcnRzLmVtaXR0ZXIgPSBlbWl0dGVyO1xuZXhwb3J0cy5jaGFubmVsID0gY2hhbm5lbDtcbmV4cG9ydHMuZXZlbnRDaGFubmVsID0gZXZlbnRDaGFubmVsO1xuZXhwb3J0cy5zdGRDaGFubmVsID0gc3RkQ2hhbm5lbDtcblxudmFyIF91dGlscyA9IHJlcXVpcmUoJy4vdXRpbHMnKTtcblxudmFyIF9idWZmZXJzID0gcmVxdWlyZSgnLi9idWZmZXJzJyk7XG5cbnZhciBDSEFOTkVMX0VORF9UWVBFID0gJ0BAcmVkdXgtc2FnYS9DSEFOTkVMX0VORCc7XG52YXIgRU5EID0gZXhwb3J0cy5FTkQgPSB7IHR5cGU6IENIQU5ORUxfRU5EX1RZUEUgfTtcbnZhciBpc0VuZCA9IGV4cG9ydHMuaXNFbmQgPSBmdW5jdGlvbiBpc0VuZChhKSB7XG4gIHJldHVybiBhICYmIGEudHlwZSA9PT0gQ0hBTk5FTF9FTkRfVFlQRTtcbn07XG5cbmZ1bmN0aW9uIGVtaXR0ZXIoKSB7XG4gIHZhciBzdWJzY3JpYmVycyA9IFtdO1xuXG4gIGZ1bmN0aW9uIHN1YnNjcmliZShzdWIpIHtcbiAgICBzdWJzY3JpYmVycy5wdXNoKHN1Yik7XG4gICAgcmV0dXJuIGZ1bmN0aW9uICgpIHtcbiAgICAgIHJldHVybiAoMCwgX3V0aWxzLnJlbW92ZSkoc3Vic2NyaWJlcnMsIHN1Yik7XG4gICAgfTtcbiAgfVxuXG4gIGZ1bmN0aW9uIGVtaXQoaXRlbSkge1xuICAgIHZhciBhcnIgPSBzdWJzY3JpYmVycy5zbGljZSgpO1xuICAgIGZvciAodmFyIGkgPSAwLCBsZW4gPSBhcnIubGVuZ3RoOyBpIDwgbGVuOyBpKyspIHtcbiAgICAgIGFycltpXShpdGVtKTtcbiAgICB9XG4gIH1cblxuICByZXR1cm4ge1xuICAgIHN1YnNjcmliZTogc3Vic2NyaWJlLFxuICAgIGVtaXQ6IGVtaXRcbiAgfTtcbn1cblxudmFyIElOVkFMSURfQlVGRkVSID0gZXhwb3J0cy5JTlZBTElEX0JVRkZFUiA9ICdpbnZhbGlkIGJ1ZmZlciBwYXNzZWQgdG8gY2hhbm5lbCBmYWN0b3J5IGZ1bmN0aW9uJztcbnZhciBVTkRFRklORURfSU5QVVRfRVJST1IgPSBleHBvcnRzLlVOREVGSU5FRF9JTlBVVF9FUlJPUiA9ICdTYWdhIHdhcyBwcm92aWRlZCB3aXRoIGFuIHVuZGVmaW5lZCBhY3Rpb24nO1xuXG5pZiAocHJvY2Vzcy5lbnYuTk9ERV9FTlYgIT09ICdwcm9kdWN0aW9uJykge1xuICBleHBvcnRzLlVOREVGSU5FRF9JTlBVVF9FUlJPUiA9IFVOREVGSU5FRF9JTlBVVF9FUlJPUiArPSAnXFxuSGludHM6XFxuICAgIC0gY2hlY2sgdGhhdCB5b3VyIEFjdGlvbiBDcmVhdG9yIHJldHVybnMgYSBub24tdW5kZWZpbmVkIHZhbHVlXFxuICAgIC0gaWYgdGhlIFNhZ2Egd2FzIHN0YXJ0ZWQgdXNpbmcgcnVuU2FnYSwgY2hlY2sgdGhhdCB5b3VyIHN1YnNjcmliZSBzb3VyY2UgcHJvdmlkZXMgdGhlIGFjdGlvbiB0byBpdHMgbGlzdGVuZXJzXFxuICAnO1xufVxuXG5mdW5jdGlvbiBjaGFubmVsKCkge1xuICB2YXIgYnVmZmVyID0gYXJndW1lbnRzLmxlbmd0aCA8PSAwIHx8IGFyZ3VtZW50c1swXSA9PT0gdW5kZWZpbmVkID8gX2J1ZmZlcnMuYnVmZmVycy5maXhlZCgpIDogYXJndW1lbnRzWzBdO1xuXG4gIHZhciBjbG9zZWQgPSBmYWxzZTtcbiAgdmFyIHRha2VycyA9IFtdO1xuXG4gICgwLCBfdXRpbHMuY2hlY2spKGJ1ZmZlciwgX3V0aWxzLmlzLmJ1ZmZlciwgSU5WQUxJRF9CVUZGRVIpO1xuXG4gIGZ1bmN0aW9uIGNoZWNrRm9yYmlkZGVuU3RhdGVzKCkge1xuICAgIGlmIChjbG9zZWQgJiYgdGFrZXJzLmxlbmd0aCkge1xuICAgICAgdGhyb3cgKDAsIF91dGlscy5pbnRlcm5hbEVycikoJ0Nhbm5vdCBoYXZlIGEgY2xvc2VkIGNoYW5uZWwgd2l0aCBwZW5kaW5nIHRha2VycycpO1xuICAgIH1cbiAgICBpZiAodGFrZXJzLmxlbmd0aCAmJiAhYnVmZmVyLmlzRW1wdHkoKSkge1xuICAgICAgdGhyb3cgKDAsIF91dGlscy5pbnRlcm5hbEVycikoJ0Nhbm5vdCBoYXZlIHBlbmRpbmcgdGFrZXJzIHdpdGggbm9uIGVtcHR5IGJ1ZmZlcicpO1xuICAgIH1cbiAgfVxuXG4gIGZ1bmN0aW9uIHB1dChpbnB1dCkge1xuICAgIGNoZWNrRm9yYmlkZGVuU3RhdGVzKCk7XG4gICAgKDAsIF91dGlscy5jaGVjaykoaW5wdXQsIF91dGlscy5pcy5ub3RVbmRlZiwgVU5ERUZJTkVEX0lOUFVUX0VSUk9SKTtcbiAgICBpZiAoY2xvc2VkKSB7XG4gICAgICByZXR1cm47XG4gICAgfVxuICAgIGlmICghdGFrZXJzLmxlbmd0aCkge1xuICAgICAgcmV0dXJuIGJ1ZmZlci5wdXQoaW5wdXQpO1xuICAgIH1cbiAgICBmb3IgKHZhciBpID0gMDsgaSA8IHRha2Vycy5sZW5ndGg7IGkrKykge1xuICAgICAgdmFyIGNiID0gdGFrZXJzW2ldO1xuICAgICAgaWYgKCFjYltfdXRpbHMuTUFUQ0hdIHx8IGNiW191dGlscy5NQVRDSF0oaW5wdXQpKSB7XG4gICAgICAgIHRha2Vycy5zcGxpY2UoaSwgMSk7XG4gICAgICAgIHJldHVybiBjYihpbnB1dCk7XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgZnVuY3Rpb24gdGFrZShjYikge1xuICAgIGNoZWNrRm9yYmlkZGVuU3RhdGVzKCk7XG4gICAgKDAsIF91dGlscy5jaGVjaykoY2IsIF91dGlscy5pcy5mdW5jLCAnY2hhbm5lbC50YWtlXFwncyBjYWxsYmFjayBtdXN0IGJlIGEgZnVuY3Rpb24nKTtcblxuICAgIGlmIChjbG9zZWQgJiYgYnVmZmVyLmlzRW1wdHkoKSkge1xuICAgICAgY2IoRU5EKTtcbiAgICB9IGVsc2UgaWYgKCFidWZmZXIuaXNFbXB0eSgpKSB7XG4gICAgICBjYihidWZmZXIudGFrZSgpKTtcbiAgICB9IGVsc2Uge1xuICAgICAgdGFrZXJzLnB1c2goY2IpO1xuICAgICAgY2IuY2FuY2VsID0gZnVuY3Rpb24gKCkge1xuICAgICAgICByZXR1cm4gKDAsIF91dGlscy5yZW1vdmUpKHRha2VycywgY2IpO1xuICAgICAgfTtcbiAgICB9XG4gIH1cblxuICBmdW5jdGlvbiBmbHVzaChjYikge1xuICAgIGNoZWNrRm9yYmlkZGVuU3RhdGVzKCk7IC8vIFRPRE86IGNoZWNrIGlmIHNvbWUgbmV3IHN0YXRlIHNob3VsZCBiZSBmb3JiaWRkZW4gbm93XG4gICAgKDAsIF91dGlscy5jaGVjaykoY2IsIF91dGlscy5pcy5mdW5jLCAnY2hhbm5lbC5mbHVzaFxcJyBjYWxsYmFjayBtdXN0IGJlIGEgZnVuY3Rpb24nKTtcbiAgICBpZiAoY2xvc2VkICYmIGJ1ZmZlci5pc0VtcHR5KCkpIHtcbiAgICAgIGNiKEVORCk7XG4gICAgICByZXR1cm47XG4gICAgfVxuICAgIGNiKGJ1ZmZlci5mbHVzaCgpKTtcbiAgfVxuXG4gIGZ1bmN0aW9uIGNsb3NlKCkge1xuICAgIGNoZWNrRm9yYmlkZGVuU3RhdGVzKCk7XG4gICAgaWYgKCFjbG9zZWQpIHtcbiAgICAgIGNsb3NlZCA9IHRydWU7XG4gICAgICBpZiAodGFrZXJzLmxlbmd0aCkge1xuICAgICAgICB2YXIgYXJyID0gdGFrZXJzO1xuICAgICAgICB0YWtlcnMgPSBbXTtcbiAgICAgICAgZm9yICh2YXIgaSA9IDAsIGxlbiA9IGFyci5sZW5ndGg7IGkgPCBsZW47IGkrKykge1xuICAgICAgICAgIGFycltpXShFTkQpO1xuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgcmV0dXJuIHsgdGFrZTogdGFrZSwgcHV0OiBwdXQsIGZsdXNoOiBmbHVzaCwgY2xvc2U6IGNsb3NlLFxuICAgIGdldCBfX3Rha2Vyc19fKCkge1xuICAgICAgcmV0dXJuIHRha2VycztcbiAgICB9LFxuICAgIGdldCBfX2Nsb3NlZF9fKCkge1xuICAgICAgcmV0dXJuIGNsb3NlZDtcbiAgICB9XG4gIH07XG59XG5cbmZ1bmN0aW9uIGV2ZW50Q2hhbm5lbChzdWJzY3JpYmUpIHtcbiAgdmFyIGJ1ZmZlciA9IGFyZ3VtZW50cy5sZW5ndGggPD0gMSB8fCBhcmd1bWVudHNbMV0gPT09IHVuZGVmaW5lZCA/IF9idWZmZXJzLmJ1ZmZlcnMubm9uZSgpIDogYXJndW1lbnRzWzFdO1xuICB2YXIgbWF0Y2hlciA9IGFyZ3VtZW50c1syXTtcblxuICAvKipcbiAgICBzaG91bGQgYmUgaWYodHlwZW9mIG1hdGNoZXIgIT09IHVuZGVmaW5lZCkgaW5zdGVhZD9cbiAgICBzZWUgUFIgIzI3MyBmb3IgYSBiYWNrZ3JvdW5kIGRpc2N1c3Npb25cbiAgKiovXG4gIGlmIChhcmd1bWVudHMubGVuZ3RoID4gMikge1xuICAgICgwLCBfdXRpbHMuY2hlY2spKG1hdGNoZXIsIF91dGlscy5pcy5mdW5jLCAnSW52YWxpZCBtYXRjaCBmdW5jdGlvbiBwYXNzZWQgdG8gZXZlbnRDaGFubmVsJyk7XG4gIH1cblxuICB2YXIgY2hhbiA9IGNoYW5uZWwoYnVmZmVyKTtcbiAgdmFyIHVuc3Vic2NyaWJlID0gc3Vic2NyaWJlKGZ1bmN0aW9uIChpbnB1dCkge1xuICAgIGlmIChpc0VuZChpbnB1dCkpIHtcbiAgICAgIGNoYW4uY2xvc2UoKTtcbiAgICB9IGVsc2UgaWYgKCFtYXRjaGVyIHx8IG1hdGNoZXIoaW5wdXQpKSB7XG4gICAgICBjaGFuLnB1dChpbnB1dCk7XG4gICAgfVxuICB9KTtcblxuICBpZiAoIV91dGlscy5pcy5mdW5jKHVuc3Vic2NyaWJlKSkge1xuICAgIHRocm93IG5ldyBFcnJvcignaW4gZXZlbnRDaGFubmVsOiBzdWJzY3JpYmUgc2hvdWxkIHJldHVybiBhIGZ1bmN0aW9uIHRvIHVuc3Vic2NyaWJlJyk7XG4gIH1cblxuICByZXR1cm4ge1xuICAgIHRha2U6IGNoYW4udGFrZSxcbiAgICBmbHVzaDogY2hhbi5mbHVzaCxcbiAgICBjbG9zZTogZnVuY3Rpb24gY2xvc2UoKSB7XG4gICAgICBpZiAoIWNoYW4uX19jbG9zZWRfXykge1xuICAgICAgICBjaGFuLmNsb3NlKCk7XG4gICAgICAgIHVuc3Vic2NyaWJlKCk7XG4gICAgICB9XG4gICAgfVxuICB9O1xufVxuXG5mdW5jdGlvbiBzdGRDaGFubmVsKHN1YnNjcmliZSkge1xuICB2YXIgY2hhbiA9IGV2ZW50Q2hhbm5lbChzdWJzY3JpYmUpO1xuXG4gIHJldHVybiBfZXh0ZW5kcyh7fSwgY2hhbiwge1xuICAgIHRha2U6IGZ1bmN0aW9uIHRha2UoY2IsIG1hdGNoZXIpIHtcbiAgICAgIGlmIChhcmd1bWVudHMubGVuZ3RoID4gMSkge1xuICAgICAgICAoMCwgX3V0aWxzLmNoZWNrKShtYXRjaGVyLCBfdXRpbHMuaXMuZnVuYywgJ2NoYW5uZWwudGFrZVxcJ3MgbWF0Y2hlciBhcmd1bWVudCBtdXN0IGJlIGEgZnVuY3Rpb24nKTtcbiAgICAgICAgY2JbX3V0aWxzLk1BVENIXSA9IG1hdGNoZXI7XG4gICAgICB9XG4gICAgICBjaGFuLnRha2UoY2IpO1xuICAgIH1cbiAgfSk7XG59XG59KTsiLCJyZXF1aXJlKDgpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xuJ3VzZSBzdHJpY3QnO1xuXG5PYmplY3QuZGVmaW5lUHJvcGVydHkoZXhwb3J0cywgXCJfX2VzTW9kdWxlXCIsIHtcbiAgdmFsdWU6IHRydWVcbn0pO1xuZXhwb3J0cy5hc0VmZmVjdCA9IHVuZGVmaW5lZDtcblxudmFyIF9zbGljZWRUb0FycmF5ID0gZnVuY3Rpb24gKCkgeyBmdW5jdGlvbiBzbGljZUl0ZXJhdG9yKGFyciwgaSkgeyB2YXIgX2FyciA9IFtdOyB2YXIgX24gPSB0cnVlOyB2YXIgX2QgPSBmYWxzZTsgdmFyIF9lID0gdW5kZWZpbmVkOyB0cnkgeyBmb3IgKHZhciBfaSA9IGFycltTeW1ib2wuaXRlcmF0b3JdKCksIF9zOyAhKF9uID0gKF9zID0gX2kubmV4dCgpKS5kb25lKTsgX24gPSB0cnVlKSB7IF9hcnIucHVzaChfcy52YWx1ZSk7IGlmIChpICYmIF9hcnIubGVuZ3RoID09PSBpKSBicmVhazsgfSB9IGNhdGNoIChlcnIpIHsgX2QgPSB0cnVlOyBfZSA9IGVycjsgfSBmaW5hbGx5IHsgdHJ5IHsgaWYgKCFfbiAmJiBfaVtcInJldHVyblwiXSkgX2lbXCJyZXR1cm5cIl0oKTsgfSBmaW5hbGx5IHsgaWYgKF9kKSB0aHJvdyBfZTsgfSB9IHJldHVybiBfYXJyOyB9IHJldHVybiBmdW5jdGlvbiAoYXJyLCBpKSB7IGlmIChBcnJheS5pc0FycmF5KGFycikpIHsgcmV0dXJuIGFycjsgfSBlbHNlIGlmIChTeW1ib2wuaXRlcmF0b3IgaW4gT2JqZWN0KGFycikpIHsgcmV0dXJuIHNsaWNlSXRlcmF0b3IoYXJyLCBpKTsgfSBlbHNlIHsgdGhyb3cgbmV3IFR5cGVFcnJvcihcIkludmFsaWQgYXR0ZW1wdCB0byBkZXN0cnVjdHVyZSBub24taXRlcmFibGUgaW5zdGFuY2VcIik7IH0gfTsgfSgpO1xuXG5leHBvcnRzLnRha2UgPSB0YWtlO1xuZXhwb3J0cy50YWtlbSA9IHRha2VtO1xuZXhwb3J0cy5wdXQgPSBwdXQ7XG5leHBvcnRzLnJhY2UgPSByYWNlO1xuZXhwb3J0cy5jYWxsID0gY2FsbDtcbmV4cG9ydHMuYXBwbHkgPSBhcHBseTtcbmV4cG9ydHMuY3BzID0gY3BzO1xuZXhwb3J0cy5mb3JrID0gZm9yaztcbmV4cG9ydHMuc3Bhd24gPSBzcGF3bjtcbmV4cG9ydHMuam9pbiA9IGpvaW47XG5leHBvcnRzLmNhbmNlbCA9IGNhbmNlbDtcbmV4cG9ydHMuc2VsZWN0ID0gc2VsZWN0O1xuZXhwb3J0cy5hY3Rpb25DaGFubmVsID0gYWN0aW9uQ2hhbm5lbDtcbmV4cG9ydHMuY2FuY2VsbGVkID0gY2FuY2VsbGVkO1xuZXhwb3J0cy5mbHVzaCA9IGZsdXNoO1xuXG52YXIgX3V0aWxzID0gcmVxdWlyZSgxNTMpO1xuXG5mdW5jdGlvbiBfZGVmaW5lUHJvcGVydHkob2JqLCBrZXksIHZhbHVlKSB7IGlmIChrZXkgaW4gb2JqKSB7IE9iamVjdC5kZWZpbmVQcm9wZXJ0eShvYmosIGtleSwgeyB2YWx1ZTogdmFsdWUsIGVudW1lcmFibGU6IHRydWUsIGNvbmZpZ3VyYWJsZTogdHJ1ZSwgd3JpdGFibGU6IHRydWUgfSk7IH0gZWxzZSB7IG9ialtrZXldID0gdmFsdWU7IH0gcmV0dXJuIG9iajsgfVxuXG52YXIgSU8gPSAoMCwgX3V0aWxzLnN5bSkoJ0lPJyk7XG52YXIgVEFLRSA9ICdUQUtFJztcbnZhciBQVVQgPSAnUFVUJztcbnZhciBSQUNFID0gJ1JBQ0UnO1xudmFyIENBTEwgPSAnQ0FMTCc7XG52YXIgQ1BTID0gJ0NQUyc7XG52YXIgRk9SSyA9ICdGT1JLJztcbnZhciBKT0lOID0gJ0pPSU4nO1xudmFyIENBTkNFTCA9ICdDQU5DRUwnO1xudmFyIFNFTEVDVCA9ICdTRUxFQ1QnO1xudmFyIEFDVElPTl9DSEFOTkVMID0gJ0FDVElPTl9DSEFOTkVMJztcbnZhciBDQU5DRUxMRUQgPSAnQ0FOQ0VMTEVEJztcbnZhciBGTFVTSCA9ICdGTFVTSCc7XG5cbnZhciBlZmZlY3QgPSBmdW5jdGlvbiBlZmZlY3QodHlwZSwgcGF5bG9hZCkge1xuICB2YXIgX3JlZjtcblxuICByZXR1cm4gX3JlZiA9IHt9LCBfZGVmaW5lUHJvcGVydHkoX3JlZiwgSU8sIHRydWUpLCBfZGVmaW5lUHJvcGVydHkoX3JlZiwgdHlwZSwgcGF5bG9hZCksIF9yZWY7XG59O1xuXG5mdW5jdGlvbiB0YWtlKCkge1xuICB2YXIgcGF0dGVybk9yQ2hhbm5lbCA9IGFyZ3VtZW50cy5sZW5ndGggPD0gMCB8fCBhcmd1bWVudHNbMF0gPT09IHVuZGVmaW5lZCA/ICcqJyA6IGFyZ3VtZW50c1swXTtcblxuICBpZiAoYXJndW1lbnRzLmxlbmd0aCkge1xuICAgICgwLCBfdXRpbHMuY2hlY2spKGFyZ3VtZW50c1swXSwgX3V0aWxzLmlzLm5vdFVuZGVmLCAndGFrZShwYXR0ZXJuT3JDaGFubmVsKTogcGF0dGVybk9yQ2hhbm5lbCBpcyB1bmRlZmluZWQnKTtcbiAgfVxuICBpZiAoX3V0aWxzLmlzLnBhdHRlcm4ocGF0dGVybk9yQ2hhbm5lbCkpIHtcbiAgICByZXR1cm4gZWZmZWN0KFRBS0UsIHsgcGF0dGVybjogcGF0dGVybk9yQ2hhbm5lbCB9KTtcbiAgfVxuICBpZiAoX3V0aWxzLmlzLmNoYW5uZWwocGF0dGVybk9yQ2hhbm5lbCkpIHtcbiAgICByZXR1cm4gZWZmZWN0KFRBS0UsIHsgY2hhbm5lbDogcGF0dGVybk9yQ2hhbm5lbCB9KTtcbiAgfVxuICB0aHJvdyBuZXcgRXJyb3IoJ3Rha2UocGF0dGVybk9yQ2hhbm5lbCk6IGFyZ3VtZW50ICcgKyBTdHJpbmcocGF0dGVybk9yQ2hhbm5lbCkgKyAnIGlzIG5vdCB2YWxpZCBjaGFubmVsIG9yIGEgdmFsaWQgcGF0dGVybicpO1xufVxuXG5mdW5jdGlvbiB0YWtlbSgpIHtcbiAgdmFyIGVmZiA9IHRha2UuYXBwbHkodW5kZWZpbmVkLCBhcmd1bWVudHMpO1xuICBlZmZbVEFLRV0ubWF5YmUgPSB0cnVlO1xuICByZXR1cm4gZWZmO1xufVxuXG5mdW5jdGlvbiBwdXQoY2hhbm5lbCwgYWN0aW9uKSB7XG4gIGlmIChhcmd1bWVudHMubGVuZ3RoID4gMSkge1xuICAgICgwLCBfdXRpbHMuY2hlY2spKGNoYW5uZWwsIF91dGlscy5pcy5ub3RVbmRlZiwgJ3B1dChjaGFubmVsLCBhY3Rpb24pOiBhcmd1bWVudCBjaGFubmVsIGlzIHVuZGVmaW5lZCcpO1xuICAgICgwLCBfdXRpbHMuY2hlY2spKGNoYW5uZWwsIF91dGlscy5pcy5jaGFubmVsLCAncHV0KGNoYW5uZWwsIGFjdGlvbik6IGFyZ3VtZW50ICcgKyBjaGFubmVsICsgJyBpcyBub3QgYSB2YWxpZCBjaGFubmVsJyk7XG4gICAgKDAsIF91dGlscy5jaGVjaykoYWN0aW9uLCBfdXRpbHMuaXMubm90VW5kZWYsICdwdXQoY2hhbm5lbCwgYWN0aW9uKTogYXJndW1lbnQgYWN0aW9uIGlzIHVuZGVmaW5lZCcpO1xuICB9IGVsc2Uge1xuICAgICgwLCBfdXRpbHMuY2hlY2spKGNoYW5uZWwsIF91dGlscy5pcy5ub3RVbmRlZiwgJ3B1dChhY3Rpb24pOiBhcmd1bWVudCBhY3Rpb24gaXMgdW5kZWZpbmVkJyk7XG4gICAgYWN0aW9uID0gY2hhbm5lbDtcbiAgICBjaGFubmVsID0gbnVsbDtcbiAgfVxuICByZXR1cm4gZWZmZWN0KFBVVCwgeyBjaGFubmVsOiBjaGFubmVsLCBhY3Rpb246IGFjdGlvbiB9KTtcbn1cblxucHV0LnN5bmMgPSBmdW5jdGlvbiAoKSB7XG4gIHZhciBlZmYgPSBwdXQuYXBwbHkodW5kZWZpbmVkLCBhcmd1bWVudHMpO1xuICBlZmZbUFVUXS5zeW5jID0gdHJ1ZTtcbiAgcmV0dXJuIGVmZjtcbn07XG5cbmZ1bmN0aW9uIHJhY2UoZWZmZWN0cykge1xuICByZXR1cm4gZWZmZWN0KFJBQ0UsIGVmZmVjdHMpO1xufVxuXG5mdW5jdGlvbiBnZXRGbkNhbGxEZXNjKG1ldGgsIGZuLCBhcmdzKSB7XG4gICgwLCBfdXRpbHMuY2hlY2spKGZuLCBfdXRpbHMuaXMubm90VW5kZWYsIG1ldGggKyAnOiBhcmd1bWVudCBmbiBpcyB1bmRlZmluZWQnKTtcblxuICB2YXIgY29udGV4dCA9IG51bGw7XG4gIGlmIChfdXRpbHMuaXMuYXJyYXkoZm4pKSB7XG4gICAgdmFyIF9mbiA9IGZuO1xuXG4gICAgdmFyIF9mbjIgPSBfc2xpY2VkVG9BcnJheShfZm4sIDIpO1xuXG4gICAgY29udGV4dCA9IF9mbjJbMF07XG4gICAgZm4gPSBfZm4yWzFdO1xuICB9IGVsc2UgaWYgKGZuLmZuKSB7XG4gICAgdmFyIF9mbjMgPSBmbjtcbiAgICBjb250ZXh0ID0gX2ZuMy5jb250ZXh0O1xuICAgIGZuID0gX2ZuMy5mbjtcbiAgfVxuICAoMCwgX3V0aWxzLmNoZWNrKShmbiwgX3V0aWxzLmlzLmZ1bmMsIG1ldGggKyAnOiBhcmd1bWVudCAnICsgZm4gKyAnIGlzIG5vdCBhIGZ1bmN0aW9uJyk7XG5cbiAgcmV0dXJuIHsgY29udGV4dDogY29udGV4dCwgZm46IGZuLCBhcmdzOiBhcmdzIH07XG59XG5cbmZ1bmN0aW9uIGNhbGwoZm4pIHtcbiAgZm9yICh2YXIgX2xlbiA9IGFyZ3VtZW50cy5sZW5ndGgsIGFyZ3MgPSBBcnJheShfbGVuID4gMSA/IF9sZW4gLSAxIDogMCksIF9rZXkgPSAxOyBfa2V5IDwgX2xlbjsgX2tleSsrKSB7XG4gICAgYXJnc1tfa2V5IC0gMV0gPSBhcmd1bWVudHNbX2tleV07XG4gIH1cblxuICByZXR1cm4gZWZmZWN0KENBTEwsIGdldEZuQ2FsbERlc2MoJ2NhbGwnLCBmbiwgYXJncykpO1xufVxuXG5mdW5jdGlvbiBhcHBseShjb250ZXh0LCBmbikge1xuICB2YXIgYXJncyA9IGFyZ3VtZW50cy5sZW5ndGggPD0gMiB8fCBhcmd1bWVudHNbMl0gPT09IHVuZGVmaW5lZCA/IFtdIDogYXJndW1lbnRzWzJdO1xuXG4gIHJldHVybiBlZmZlY3QoQ0FMTCwgZ2V0Rm5DYWxsRGVzYygnYXBwbHknLCB7IGNvbnRleHQ6IGNvbnRleHQsIGZuOiBmbiB9LCBhcmdzKSk7XG59XG5cbmZ1bmN0aW9uIGNwcyhmbikge1xuICBmb3IgKHZhciBfbGVuMiA9IGFyZ3VtZW50cy5sZW5ndGgsIGFyZ3MgPSBBcnJheShfbGVuMiA+IDEgPyBfbGVuMiAtIDEgOiAwKSwgX2tleTIgPSAxOyBfa2V5MiA8IF9sZW4yOyBfa2V5MisrKSB7XG4gICAgYXJnc1tfa2V5MiAtIDFdID0gYXJndW1lbnRzW19rZXkyXTtcbiAgfVxuXG4gIHJldHVybiBlZmZlY3QoQ1BTLCBnZXRGbkNhbGxEZXNjKCdjcHMnLCBmbiwgYXJncykpO1xufVxuXG5mdW5jdGlvbiBmb3JrKGZuKSB7XG4gIGZvciAodmFyIF9sZW4zID0gYXJndW1lbnRzLmxlbmd0aCwgYXJncyA9IEFycmF5KF9sZW4zID4gMSA/IF9sZW4zIC0gMSA6IDApLCBfa2V5MyA9IDE7IF9rZXkzIDwgX2xlbjM7IF9rZXkzKyspIHtcbiAgICBhcmdzW19rZXkzIC0gMV0gPSBhcmd1bWVudHNbX2tleTNdO1xuICB9XG5cbiAgcmV0dXJuIGVmZmVjdChGT1JLLCBnZXRGbkNhbGxEZXNjKCdmb3JrJywgZm4sIGFyZ3MpKTtcbn1cblxuZnVuY3Rpb24gc3Bhd24oZm4pIHtcbiAgZm9yICh2YXIgX2xlbjQgPSBhcmd1bWVudHMubGVuZ3RoLCBhcmdzID0gQXJyYXkoX2xlbjQgPiAxID8gX2xlbjQgLSAxIDogMCksIF9rZXk0ID0gMTsgX2tleTQgPCBfbGVuNDsgX2tleTQrKykge1xuICAgIGFyZ3NbX2tleTQgLSAxXSA9IGFyZ3VtZW50c1tfa2V5NF07XG4gIH1cblxuICB2YXIgZWZmID0gZm9yay5hcHBseSh1bmRlZmluZWQsIFtmbl0uY29uY2F0KGFyZ3MpKTtcbiAgZWZmW0ZPUktdLmRldGFjaGVkID0gdHJ1ZTtcbiAgcmV0dXJuIGVmZjtcbn1cblxudmFyIGlzRm9ya2VkVGFzayA9IGZ1bmN0aW9uIGlzRm9ya2VkVGFzayh0YXNrKSB7XG4gIHJldHVybiB0YXNrW191dGlscy5UQVNLXTtcbn07XG5cbmZ1bmN0aW9uIGpvaW4odGFzaykge1xuICAoMCwgX3V0aWxzLmNoZWNrKSh0YXNrLCBfdXRpbHMuaXMubm90VW5kZWYsICdqb2luKHRhc2spOiBhcmd1bWVudCB0YXNrIGlzIHVuZGVmaW5lZCcpO1xuICBpZiAoIWlzRm9ya2VkVGFzayh0YXNrKSkge1xuICAgIHRocm93IG5ldyBFcnJvcignam9pbih0YXNrKTogYXJndW1lbnQgJyArIHRhc2sgKyAnIGlzIG5vdCBhIHZhbGlkIFRhc2sgb2JqZWN0IFxcbihISU5UOiBpZiB5b3UgYXJlIGdldHRpbmcgdGhpcyBlcnJvcnMgaW4gdGVzdHMsIGNvbnNpZGVyIHVzaW5nIGNyZWF0ZU1vY2tUYXNrIGZyb20gcmVkdXgtc2FnYS91dGlscyknKTtcbiAgfVxuXG4gIHJldHVybiBlZmZlY3QoSk9JTiwgdGFzayk7XG59XG5cbmZ1bmN0aW9uIGNhbmNlbCh0YXNrKSB7XG4gICgwLCBfdXRpbHMuY2hlY2spKHRhc2ssIF91dGlscy5pcy5ub3RVbmRlZiwgJ2NhbmNlbCh0YXNrKTogYXJndW1lbnQgdGFzayBpcyB1bmRlZmluZWQnKTtcbiAgaWYgKCFpc0ZvcmtlZFRhc2sodGFzaykpIHtcbiAgICB0aHJvdyBuZXcgRXJyb3IoJ2NhbmNlbCh0YXNrKTogYXJndW1lbnQgJyArIHRhc2sgKyAnIGlzIG5vdCBhIHZhbGlkIFRhc2sgb2JqZWN0IFxcbihISU5UOiBpZiB5b3UgYXJlIGdldHRpbmcgdGhpcyBlcnJvcnMgaW4gdGVzdHMsIGNvbnNpZGVyIHVzaW5nIGNyZWF0ZU1vY2tUYXNrIGZyb20gcmVkdXgtc2FnYS91dGlscyknKTtcbiAgfVxuXG4gIHJldHVybiBlZmZlY3QoQ0FOQ0VMLCB0YXNrKTtcbn1cblxuZnVuY3Rpb24gc2VsZWN0KHNlbGVjdG9yKSB7XG4gIGZvciAodmFyIF9sZW41ID0gYXJndW1lbnRzLmxlbmd0aCwgYXJncyA9IEFycmF5KF9sZW41ID4gMSA/IF9sZW41IC0gMSA6IDApLCBfa2V5NSA9IDE7IF9rZXk1IDwgX2xlbjU7IF9rZXk1KyspIHtcbiAgICBhcmdzW19rZXk1IC0gMV0gPSBhcmd1bWVudHNbX2tleTVdO1xuICB9XG5cbiAgaWYgKGFyZ3VtZW50cy5sZW5ndGggPT09IDApIHtcbiAgICBzZWxlY3RvciA9IF91dGlscy5pZGVudDtcbiAgfSBlbHNlIHtcbiAgICAoMCwgX3V0aWxzLmNoZWNrKShzZWxlY3RvciwgX3V0aWxzLmlzLm5vdFVuZGVmLCAnc2VsZWN0KHNlbGVjdG9yLFsuLi5dKTogYXJndW1lbnQgc2VsZWN0b3IgaXMgdW5kZWZpbmVkJyk7XG4gICAgKDAsIF91dGlscy5jaGVjaykoc2VsZWN0b3IsIF91dGlscy5pcy5mdW5jLCAnc2VsZWN0KHNlbGVjdG9yLFsuLi5dKTogYXJndW1lbnQgJyArIHNlbGVjdG9yICsgJyBpcyBub3QgYSBmdW5jdGlvbicpO1xuICB9XG4gIHJldHVybiBlZmZlY3QoU0VMRUNULCB7IHNlbGVjdG9yOiBzZWxlY3RvciwgYXJnczogYXJncyB9KTtcbn1cblxuLyoqXG4gIGNoYW5uZWwocGF0dGVybiwgW2J1ZmZlcl0pICAgID0+IGNyZWF0ZXMgYW4gZXZlbnQgY2hhbm5lbCBmb3Igc3RvcmUgYWN0aW9uc1xuKiovXG5mdW5jdGlvbiBhY3Rpb25DaGFubmVsKHBhdHRlcm4sIGJ1ZmZlcikge1xuICAoMCwgX3V0aWxzLmNoZWNrKShwYXR0ZXJuLCBfdXRpbHMuaXMubm90VW5kZWYsICdhY3Rpb25DaGFubmVsKHBhdHRlcm4sLi4uKTogYXJndW1lbnQgcGF0dGVybiBpcyB1bmRlZmluZWQnKTtcbiAgaWYgKGFyZ3VtZW50cy5sZW5ndGggPiAxKSB7XG4gICAgKDAsIF91dGlscy5jaGVjaykoYnVmZmVyLCBfdXRpbHMuaXMubm90VW5kZWYsICdhY3Rpb25DaGFubmVsKHBhdHRlcm4sIGJ1ZmZlcik6IGFyZ3VtZW50IGJ1ZmZlciBpcyB1bmRlZmluZWQnKTtcbiAgICAoMCwgX3V0aWxzLmNoZWNrKShidWZmZXIsIF91dGlscy5pcy5ub3RVbmRlZiwgJ2FjdGlvbkNoYW5uZWwocGF0dGVybiwgYnVmZmVyKTogYXJndW1lbnQgJyArIGJ1ZmZlciArICcgaXMgbm90IGEgdmFsaWQgYnVmZmVyJyk7XG4gIH1cbiAgcmV0dXJuIGVmZmVjdChBQ1RJT05fQ0hBTk5FTCwgeyBwYXR0ZXJuOiBwYXR0ZXJuLCBidWZmZXI6IGJ1ZmZlciB9KTtcbn1cblxuZnVuY3Rpb24gY2FuY2VsbGVkKCkge1xuICByZXR1cm4gZWZmZWN0KENBTkNFTExFRCwge30pO1xufVxuXG5mdW5jdGlvbiBmbHVzaChjaGFubmVsKSB7XG4gICgwLCBfdXRpbHMuY2hlY2spKGNoYW5uZWwsIF91dGlscy5pcy5jaGFubmVsLCAnZmx1c2goY2hhbm5lbCk6IGFyZ3VtZW50ICcgKyBjaGFubmVsICsgJyBpcyBub3QgdmFsaWQgY2hhbm5lbCcpO1xuICByZXR1cm4gZWZmZWN0KEZMVVNILCBjaGFubmVsKTtcbn1cblxudmFyIGFzRWZmZWN0ID0gZXhwb3J0cy5hc0VmZmVjdCA9IHtcbiAgdGFrZTogZnVuY3Rpb24gdGFrZShlZmZlY3QpIHtcbiAgICByZXR1cm4gZWZmZWN0ICYmIGVmZmVjdFtJT10gJiYgZWZmZWN0W1RBS0VdO1xuICB9LFxuICBwdXQ6IGZ1bmN0aW9uIHB1dChlZmZlY3QpIHtcbiAgICByZXR1cm4gZWZmZWN0ICYmIGVmZmVjdFtJT10gJiYgZWZmZWN0W1BVVF07XG4gIH0sXG4gIHJhY2U6IGZ1bmN0aW9uIHJhY2UoZWZmZWN0KSB7XG4gICAgcmV0dXJuIGVmZmVjdCAmJiBlZmZlY3RbSU9dICYmIGVmZmVjdFtSQUNFXTtcbiAgfSxcbiAgY2FsbDogZnVuY3Rpb24gY2FsbChlZmZlY3QpIHtcbiAgICByZXR1cm4gZWZmZWN0ICYmIGVmZmVjdFtJT10gJiYgZWZmZWN0W0NBTExdO1xuICB9LFxuICBjcHM6IGZ1bmN0aW9uIGNwcyhlZmZlY3QpIHtcbiAgICByZXR1cm4gZWZmZWN0ICYmIGVmZmVjdFtJT10gJiYgZWZmZWN0W0NQU107XG4gIH0sXG4gIGZvcms6IGZ1bmN0aW9uIGZvcmsoZWZmZWN0KSB7XG4gICAgcmV0dXJuIGVmZmVjdCAmJiBlZmZlY3RbSU9dICYmIGVmZmVjdFtGT1JLXTtcbiAgfSxcbiAgam9pbjogZnVuY3Rpb24gam9pbihlZmZlY3QpIHtcbiAgICByZXR1cm4gZWZmZWN0ICYmIGVmZmVjdFtJT10gJiYgZWZmZWN0W0pPSU5dO1xuICB9LFxuICBjYW5jZWw6IGZ1bmN0aW9uIGNhbmNlbChlZmZlY3QpIHtcbiAgICByZXR1cm4gZWZmZWN0ICYmIGVmZmVjdFtJT10gJiYgZWZmZWN0W0NBTkNFTF07XG4gIH0sXG4gIHNlbGVjdDogZnVuY3Rpb24gc2VsZWN0KGVmZmVjdCkge1xuICAgIHJldHVybiBlZmZlY3QgJiYgZWZmZWN0W0lPXSAmJiBlZmZlY3RbU0VMRUNUXTtcbiAgfSxcbiAgYWN0aW9uQ2hhbm5lbDogZnVuY3Rpb24gYWN0aW9uQ2hhbm5lbChlZmZlY3QpIHtcbiAgICByZXR1cm4gZWZmZWN0ICYmIGVmZmVjdFtJT10gJiYgZWZmZWN0W0FDVElPTl9DSEFOTkVMXTtcbiAgfSxcbiAgY2FuY2VsbGVkOiBmdW5jdGlvbiBjYW5jZWxsZWQoZWZmZWN0KSB7XG4gICAgcmV0dXJuIGVmZmVjdCAmJiBlZmZlY3RbSU9dICYmIGVmZmVjdFtDQU5DRUxMRURdO1xuICB9LFxuICBmbHVzaDogZnVuY3Rpb24gZmx1c2goZWZmZWN0KSB7XG4gICAgcmV0dXJuIGVmZmVjdCAmJiBlZmZlY3RbSU9dICYmIGVmZmVjdFtGTFVTSF07XG4gIH1cbn07XG59KTsiLCJyZXF1aXJlKCcvcm9vdC9hcHAvbm9kZV9tb2R1bGVzL2FzeW5jLWRlZmluZS9saWIvYXN5bmNEZWZpbmUuanMnKShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbid1c2Ugc3RyaWN0JztcblxuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsIFwiX19lc01vZHVsZVwiLCB7XG4gIHZhbHVlOiB0cnVlXG59KTtcbmV4cG9ydHMuZGVmYXVsdCA9IHNhZ2FNaWRkbGV3YXJlRmFjdG9yeTtcblxudmFyIF91dGlscyA9IHJlcXVpcmUoJy4vdXRpbHMnKTtcblxudmFyIF9wcm9jID0gcmVxdWlyZSgnLi9wcm9jJyk7XG5cbnZhciBfcHJvYzIgPSBfaW50ZXJvcFJlcXVpcmVEZWZhdWx0KF9wcm9jKTtcblxudmFyIF9jaGFubmVsID0gcmVxdWlyZSgnLi9jaGFubmVsJyk7XG5cbmZ1bmN0aW9uIF9pbnRlcm9wUmVxdWlyZURlZmF1bHQob2JqKSB7IHJldHVybiBvYmogJiYgb2JqLl9fZXNNb2R1bGUgPyBvYmogOiB7IGRlZmF1bHQ6IG9iaiB9OyB9XG5cbmZ1bmN0aW9uIHNhZ2FNaWRkbGV3YXJlRmFjdG9yeSgpIHtcbiAgdmFyIG9wdGlvbnMgPSBhcmd1bWVudHMubGVuZ3RoIDw9IDAgfHwgYXJndW1lbnRzWzBdID09PSB1bmRlZmluZWQgPyB7fSA6IGFyZ3VtZW50c1swXTtcblxuICB2YXIgcnVuU2FnYUR5bmFtaWNhbGx5ID0gdm9pZCAwO1xuXG4gIGlmIChfdXRpbHMuaXMuZnVuYyhvcHRpb25zKSkge1xuICAgIGlmIChwcm9jZXNzLmVudi5OT0RFX0VOViA9PT0gJ3Byb2R1Y3Rpb24nKSB7XG4gICAgICB0aHJvdyBuZXcgRXJyb3IoJ1NhZ2EgbWlkZGxld2FyZSBubyBsb25nZXIgYWNjZXB0IEdlbmVyYXRvciBmdW5jdGlvbnMuIFVzZSBzYWdhTWlkZGxld2FyZS5ydW4gaW5zdGVhZCcpO1xuICAgIH0gZWxzZSB7XG4gICAgICB0aHJvdyBuZXcgRXJyb3IoJ1lvdSBwYXNzZWQgYSBmdW5jdGlvbiB0byB0aGUgU2FnYSBtaWRkbGV3YXJlLiBZb3UgYXJlIGxpa2VseSB0cnlpbmcgdG8gc3RhcnQgYSAgICAgICAgU2FnYSBieSBkaXJlY3RseSBwYXNzaW5nIGl0IHRvIHRoZSBtaWRkbGV3YXJlLiBUaGlzIGlzIG5vIGxvbmdlciBwb3NzaWJsZSBzdGFydGluZyBmcm9tIDAuMTAuMC4gICAgICAgIFRvIHJ1biBhIFNhZ2EsIHlvdSBtdXN0IGRvIGl0IGR5bmFtaWNhbGx5IEFGVEVSIG1vdW50aW5nIHRoZSBtaWRkbGV3YXJlIGludG8gdGhlIHN0b3JlLlxcbiAgICAgICAgRXhhbXBsZTpcXG4gICAgICAgICAgaW1wb3J0IGNyZWF0ZVNhZ2FNaWRkbGV3YXJlIGZyb20gXFwncmVkdXgtc2FnYVxcJ1xcbiAgICAgICAgICAuLi4gb3RoZXIgaW1wb3J0c1xcblxcbiAgICAgICAgICBjb25zdCBzYWdhTWlkZGxld2FyZSA9IGNyZWF0ZVNhZ2FNaWRkbGV3YXJlKClcXG4gICAgICAgICAgY29uc3Qgc3RvcmUgPSBjcmVhdGVTdG9yZShyZWR1Y2VyLCBhcHBseU1pZGRsZXdhcmUoc2FnYU1pZGRsZXdhcmUpKVxcbiAgICAgICAgICBzYWdhTWlkZGxld2FyZS5ydW4oc2FnYSwgLi4uYXJncylcXG4gICAgICAnKTtcbiAgICB9XG4gIH1cblxuICBpZiAob3B0aW9ucy5sb2dnZXIgJiYgIV91dGlscy5pcy5mdW5jKG9wdGlvbnMubG9nZ2VyKSkge1xuICAgIHRocm93IG5ldyBFcnJvcignYG9wdGlvbnMubG9nZ2VyYCBwYXNzZWQgdG8gdGhlIFNhZ2EgbWlkZGxld2FyZSBpcyBub3QgYSBmdW5jdGlvbiEnKTtcbiAgfVxuXG4gIGlmIChvcHRpb25zLm9uZXJyb3IgJiYgIV91dGlscy5pcy5mdW5jKG9wdGlvbnMub25lcnJvcikpIHtcbiAgICB0aHJvdyBuZXcgRXJyb3IoJ2BvcHRpb25zLm9uZXJyb3JgIHBhc3NlZCB0byB0aGUgU2FnYSBtaWRkbGV3YXJlIGlzIG5vdCBhIGZ1bmN0aW9uIScpO1xuICB9XG5cbiAgZnVuY3Rpb24gc2FnYU1pZGRsZXdhcmUoX3JlZikge1xuICAgIHZhciBnZXRTdGF0ZSA9IF9yZWYuZ2V0U3RhdGU7XG4gICAgdmFyIGRpc3BhdGNoID0gX3JlZi5kaXNwYXRjaDtcblxuICAgIHJ1blNhZ2FEeW5hbWljYWxseSA9IHJ1blNhZ2E7XG4gICAgdmFyIHNhZ2FFbWl0dGVyID0gKDAsIF9jaGFubmVsLmVtaXR0ZXIpKCk7XG5cbiAgICBmdW5jdGlvbiBydW5TYWdhKHNhZ2EpIHtcbiAgICAgIGZvciAodmFyIF9sZW4gPSBhcmd1bWVudHMubGVuZ3RoLCBhcmdzID0gQXJyYXkoX2xlbiA+IDEgPyBfbGVuIC0gMSA6IDApLCBfa2V5ID0gMTsgX2tleSA8IF9sZW47IF9rZXkrKykge1xuICAgICAgICBhcmdzW19rZXkgLSAxXSA9IGFyZ3VtZW50c1tfa2V5XTtcbiAgICAgIH1cblxuICAgICAgcmV0dXJuICgwLCBfcHJvYzIuZGVmYXVsdCkoc2FnYS5hcHBseSh1bmRlZmluZWQsIGFyZ3MpLCBzYWdhRW1pdHRlci5zdWJzY3JpYmUsIGRpc3BhdGNoLCBnZXRTdGF0ZSwgb3B0aW9ucywgMCwgc2FnYS5uYW1lKTtcbiAgICB9XG5cbiAgICByZXR1cm4gZnVuY3Rpb24gKG5leHQpIHtcbiAgICAgIHJldHVybiBmdW5jdGlvbiAoYWN0aW9uKSB7XG4gICAgICAgIHZhciByZXN1bHQgPSBuZXh0KGFjdGlvbik7IC8vIGhpdCByZWR1Y2Vyc1xuICAgICAgICBzYWdhRW1pdHRlci5lbWl0KGFjdGlvbik7XG4gICAgICAgIHJldHVybiByZXN1bHQ7XG4gICAgICB9O1xuICAgIH07XG4gIH1cblxuICBzYWdhTWlkZGxld2FyZS5ydW4gPSBmdW5jdGlvbiAoc2FnYSkge1xuICAgIGZvciAodmFyIF9sZW4yID0gYXJndW1lbnRzLmxlbmd0aCwgYXJncyA9IEFycmF5KF9sZW4yID4gMSA/IF9sZW4yIC0gMSA6IDApLCBfa2V5MiA9IDE7IF9rZXkyIDwgX2xlbjI7IF9rZXkyKyspIHtcbiAgICAgIGFyZ3NbX2tleTIgLSAxXSA9IGFyZ3VtZW50c1tfa2V5Ml07XG4gICAgfVxuXG4gICAgKDAsIF91dGlscy5jaGVjaykocnVuU2FnYUR5bmFtaWNhbGx5LCBfdXRpbHMuaXMubm90VW5kZWYsICdCZWZvcmUgcnVubmluZyBhIFNhZ2EsIHlvdSBtdXN0IG1vdW50IHRoZSBTYWdhIG1pZGRsZXdhcmUgb24gdGhlIFN0b3JlIHVzaW5nIGFwcGx5TWlkZGxld2FyZScpO1xuICAgICgwLCBfdXRpbHMuY2hlY2spKHNhZ2EsIF91dGlscy5pcy5mdW5jLCAnc2FnYU1pZGRsZXdhcmUucnVuKHNhZ2EsIC4uLmFyZ3MpOiBzYWdhIGFyZ3VtZW50IG11c3QgYmUgYSBHZW5lcmF0b3IgZnVuY3Rpb24hJyk7XG4gICAgcmV0dXJuIHJ1blNhZ2FEeW5hbWljYWxseS5hcHBseSh1bmRlZmluZWQsIFtzYWdhXS5jb25jYXQoYXJncykpO1xuICB9O1xuXG4gIHJldHVybiBzYWdhTWlkZGxld2FyZTtcbn1cbn0pOyIsInJlcXVpcmUoJy9yb290L2FwcC9ub2RlX21vZHVsZXMvYXN5bmMtZGVmaW5lL2xpYi9hc3luY0RlZmluZS5qcycpKFtcInJlYWN0LTE1LjNcIixcInJlYWN0ZG9tLTE1LjNcIixcInJlZHV4LTMuNlwiLFwicmVhY3RyZWR1eC00LjRcIl0sZnVuY3Rpb24oX19yZWFjdCxfX3JlYWN0X2RvbSxfX3JlZHV4LF9fcmVhY3RfcmVkdXgpe1xuJ3VzZSBzdHJpY3QnO1xuXG5PYmplY3QuZGVmaW5lUHJvcGVydHkoZXhwb3J0cywgXCJfX2VzTW9kdWxlXCIsIHtcbiAgdmFsdWU6IHRydWVcbn0pO1xuZXhwb3J0cy5UQVNLX0NBTkNFTCA9IGV4cG9ydHMuQ0hBTk5FTF9FTkQgPSBleHBvcnRzLk5PVF9JVEVSQVRPUl9FUlJPUiA9IHVuZGVmaW5lZDtcbmV4cG9ydHMuZGVmYXVsdCA9IHByb2M7XG5cbnZhciBfdXRpbHMgPSByZXF1aXJlKCcuL3V0aWxzJyk7XG5cbnZhciBfYXNhcCA9IHJlcXVpcmUoJy4vYXNhcCcpO1xuXG52YXIgX2FzYXAyID0gX2ludGVyb3BSZXF1aXJlRGVmYXVsdChfYXNhcCk7XG5cbnZhciBfaW8gPSByZXF1aXJlKCcuL2lvJyk7XG5cbnZhciBfY2hhbm5lbCA9IHJlcXVpcmUoJy4vY2hhbm5lbCcpO1xuXG52YXIgX2J1ZmZlcnMgPSByZXF1aXJlKCcuL2J1ZmZlcnMnKTtcblxuZnVuY3Rpb24gX2ludGVyb3BSZXF1aXJlRGVmYXVsdChvYmopIHsgcmV0dXJuIG9iaiAmJiBvYmouX19lc01vZHVsZSA/IG9iaiA6IHsgZGVmYXVsdDogb2JqIH07IH1cblxuZnVuY3Rpb24gX2RlZmluZUVudW1lcmFibGVQcm9wZXJ0aWVzKG9iaiwgZGVzY3MpIHsgZm9yICh2YXIga2V5IGluIGRlc2NzKSB7IHZhciBkZXNjID0gZGVzY3Nba2V5XTsgZGVzYy5jb25maWd1cmFibGUgPSBkZXNjLmVudW1lcmFibGUgPSB0cnVlOyBpZiAoXCJ2YWx1ZVwiIGluIGRlc2MpIGRlc2Mud3JpdGFibGUgPSB0cnVlOyBPYmplY3QuZGVmaW5lUHJvcGVydHkob2JqLCBrZXksIGRlc2MpOyB9IHJldHVybiBvYmo7IH1cblxuZnVuY3Rpb24gX3RvQ29uc3VtYWJsZUFycmF5KGFycikgeyBpZiAoQXJyYXkuaXNBcnJheShhcnIpKSB7IGZvciAodmFyIGkgPSAwLCBhcnIyID0gQXJyYXkoYXJyLmxlbmd0aCk7IGkgPCBhcnIubGVuZ3RoOyBpKyspIHsgYXJyMltpXSA9IGFycltpXTsgfSByZXR1cm4gYXJyMjsgfSBlbHNlIHsgcmV0dXJuIEFycmF5LmZyb20oYXJyKTsgfSB9XG5cbmZ1bmN0aW9uIF9kZWZpbmVQcm9wZXJ0eShvYmosIGtleSwgdmFsdWUpIHsgaWYgKGtleSBpbiBvYmopIHsgT2JqZWN0LmRlZmluZVByb3BlcnR5KG9iaiwga2V5LCB7IHZhbHVlOiB2YWx1ZSwgZW51bWVyYWJsZTogdHJ1ZSwgY29uZmlndXJhYmxlOiB0cnVlLCB3cml0YWJsZTogdHJ1ZSB9KTsgfSBlbHNlIHsgb2JqW2tleV0gPSB2YWx1ZTsgfSByZXR1cm4gb2JqOyB9XG5cbnZhciBpc0RldiA9IHByb2Nlc3MuZW52Lk5PREVfRU5WID09PSAnZGV2ZWxvcG1lbnQnO1xuXG52YXIgTk9UX0lURVJBVE9SX0VSUk9SID0gZXhwb3J0cy5OT1RfSVRFUkFUT1JfRVJST1IgPSAncHJvYyBmaXJzdCBhcmd1bWVudCAoU2FnYSBmdW5jdGlvbiByZXN1bHQpIG11c3QgYmUgYW4gaXRlcmF0b3InO1xuXG52YXIgbmV4dEVmZmVjdElkID0gKDAsIF91dGlscy5hdXRvSW5jKSgpO1xudmFyIENIQU5ORUxfRU5EID0gZXhwb3J0cy5DSEFOTkVMX0VORCA9IHtcbiAgdG9TdHJpbmc6IGZ1bmN0aW9uIHRvU3RyaW5nKCkge1xuICAgIHJldHVybiAnQEByZWR1eC1zYWdhL0NIQU5ORUxfRU5EJztcbiAgfVxufTtcbnZhciBUQVNLX0NBTkNFTCA9IGV4cG9ydHMuVEFTS19DQU5DRUwgPSB7XG4gIHRvU3RyaW5nOiBmdW5jdGlvbiB0b1N0cmluZygpIHtcbiAgICByZXR1cm4gJ0BAcmVkdXgtc2FnYS9UQVNLX0NBTkNFTCc7XG4gIH1cbn07XG5cbnZhciBtYXRjaGVycyA9IHtcbiAgd2lsZGNhcmQ6IGZ1bmN0aW9uIHdpbGRjYXJkKCkge1xuICAgIHJldHVybiBfdXRpbHMua1RydWU7XG4gIH0sXG4gIGRlZmF1bHQ6IGZ1bmN0aW9uIF9kZWZhdWx0KHBhdHRlcm4pIHtcbiAgICByZXR1cm4gZnVuY3Rpb24gKGlucHV0KSB7XG4gICAgICByZXR1cm4gaW5wdXQudHlwZSA9PT0gcGF0dGVybjtcbiAgICB9O1xuICB9LFxuICBhcnJheTogZnVuY3Rpb24gYXJyYXkocGF0dGVybnMpIHtcbiAgICByZXR1cm4gZnVuY3Rpb24gKGlucHV0KSB7XG4gICAgICByZXR1cm4gcGF0dGVybnMuc29tZShmdW5jdGlvbiAocCkge1xuICAgICAgICByZXR1cm4gcCA9PT0gaW5wdXQudHlwZTtcbiAgICAgIH0pO1xuICAgIH07XG4gIH0sXG4gIHByZWRpY2F0ZTogZnVuY3Rpb24gcHJlZGljYXRlKF9wcmVkaWNhdGUpIHtcbiAgICByZXR1cm4gZnVuY3Rpb24gKGlucHV0KSB7XG4gICAgICByZXR1cm4gX3ByZWRpY2F0ZShpbnB1dCk7XG4gICAgfTtcbiAgfVxufTtcblxuZnVuY3Rpb24gbWF0Y2hlcihwYXR0ZXJuKSB7XG4gIHJldHVybiAocGF0dGVybiA9PT0gJyonID8gbWF0Y2hlcnMud2lsZGNhcmQgOiBfdXRpbHMuaXMuYXJyYXkocGF0dGVybikgPyBtYXRjaGVycy5hcnJheSA6IF91dGlscy5pcy5mdW5jKHBhdHRlcm4pID8gbWF0Y2hlcnMucHJlZGljYXRlIDogbWF0Y2hlcnMuZGVmYXVsdCkocGF0dGVybik7XG59XG5cbi8qKlxuICBVc2VkIHRvIHRyYWNrIGEgcGFyZW50IHRhc2sgYW5kIGl0cyBmb3Jrc1xuICBJbiB0aGUgbmV3IGZvcmsgbW9kZWwsIGZvcmtlZCB0YXNrcyBhcmUgYXR0YWNoZWQgYnkgZGVmYXVsdCB0byB0aGVpciBwYXJlbnRcbiAgV2UgbW9kZWwgdGhpcyB1c2luZyB0aGUgY29uY2VwdCBvZiBQYXJlbnQgdGFzayAmJiBtYWluIFRhc2tcbiAgbWFpbiB0YXNrIGlzIHRoZSBtYWluIGZsb3cgb2YgdGhlIGN1cnJlbnQgR2VuZXJhdG9yLCB0aGUgcGFyZW50IHRhc2tzIGlzIHRoZVxuICBhZ2dyZWdhdGlvbiBvZiB0aGUgbWFpbiB0YXNrcyArIGFsbCBpdHMgZm9ya2VkIHRhc2tzLlxuICBUaHVzIHRoZSB3aG9sZSBtb2RlbCByZXByZXNlbnRzIGFuIGV4ZWN1dGlvbiB0cmVlIHdpdGggbXVsdGlwbGUgYnJhbmNoZXMgKHZzIHRoZVxuICBsaW5lYXIgZXhlY3V0aW9uIHRyZWUgaW4gc2VxdWVudGlhbCAobm9uIHBhcmFsbGVsKSBwcm9ncmFtbWluZylcblxuICBBIHBhcmVudCB0YXNrcyBoYXMgdGhlIGZvbGxvd2luZyBzZW1hbnRpY3NcbiAgLSBJdCBjb21wbGV0ZXMgaWZmIGFsbCBpdHMgZm9ya3MgZWl0aGVyIGNvbXBsZXRlIG9yIGFsbCBjYW5jZWxsZWRcbiAgLSBJZiBpdCdzIGNhbmNlbGxlZCwgYWxsIGZvcmtzIGFyZSBjYW5jZWxsZWQgYXMgd2VsbFxuICAtIEl0IGFib3J0cyBpZiBhbnkgdW5jYXVnaHQgZXJyb3IgYnViYmxlcyB1cCBmcm9tIGZvcmtzXG4gIC0gSWYgaXQgY29tcGxldGVzLCB0aGUgcmV0dXJuIHZhbHVlIGlzIHRoZSBvbmUgcmV0dXJuZWQgYnkgdGhlIG1haW4gdGFza1xuKiovXG5mdW5jdGlvbiBmb3JrUXVldWUobmFtZSwgbWFpblRhc2ssIGNiKSB7XG4gIHZhciB0YXNrcyA9IFtdLFxuICAgICAgcmVzdWx0ID0gdm9pZCAwLFxuICAgICAgY29tcGxldGVkID0gZmFsc2U7XG4gIGFkZFRhc2sobWFpblRhc2spO1xuXG4gIGZ1bmN0aW9uIGFib3J0KGVycikge1xuICAgIGNhbmNlbEFsbCgpO1xuICAgIGNiKGVyciwgdHJ1ZSk7XG4gIH1cblxuICBmdW5jdGlvbiBhZGRUYXNrKHRhc2spIHtcbiAgICB0YXNrcy5wdXNoKHRhc2spO1xuICAgIHRhc2suY29udCA9IGZ1bmN0aW9uIChyZXMsIGlzRXJyKSB7XG4gICAgICBpZiAoY29tcGxldGVkKSB7XG4gICAgICAgIHJldHVybjtcbiAgICAgIH1cblxuICAgICAgKDAsIF91dGlscy5yZW1vdmUpKHRhc2tzLCB0YXNrKTtcbiAgICAgIHRhc2suY29udCA9IF91dGlscy5ub29wO1xuICAgICAgaWYgKGlzRXJyKSB7XG4gICAgICAgIGFib3J0KHJlcyk7XG4gICAgICB9IGVsc2Uge1xuICAgICAgICBpZiAodGFzayA9PT0gbWFpblRhc2spIHtcbiAgICAgICAgICByZXN1bHQgPSByZXM7XG4gICAgICAgIH1cbiAgICAgICAgaWYgKCF0YXNrcy5sZW5ndGgpIHtcbiAgICAgICAgICBjb21wbGV0ZWQgPSB0cnVlO1xuICAgICAgICAgIGNiKHJlc3VsdCk7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9O1xuICAgIC8vIHRhc2suY29udC5jYW5jZWwgPSB0YXNrLmNhbmNlbFxuICB9XG5cbiAgZnVuY3Rpb24gY2FuY2VsQWxsKCkge1xuICAgIGlmIChjb21wbGV0ZWQpIHtcbiAgICAgIHJldHVybjtcbiAgICB9XG4gICAgY29tcGxldGVkID0gdHJ1ZTtcbiAgICB0YXNrcy5mb3JFYWNoKGZ1bmN0aW9uICh0KSB7XG4gICAgICB0LmNvbnQgPSBfdXRpbHMubm9vcDtcbiAgICAgIHQuY2FuY2VsKCk7XG4gICAgfSk7XG4gICAgdGFza3MgPSBbXTtcbiAgfVxuXG4gIHJldHVybiB7XG4gICAgYWRkVGFzazogYWRkVGFzayxcbiAgICBjYW5jZWxBbGw6IGNhbmNlbEFsbCxcbiAgICBhYm9ydDogYWJvcnQsXG4gICAgZ2V0VGFza3M6IGZ1bmN0aW9uIGdldFRhc2tzKCkge1xuICAgICAgcmV0dXJuIHRhc2tzO1xuICAgIH0sXG4gICAgdGFza05hbWVzOiBmdW5jdGlvbiB0YXNrTmFtZXMoKSB7XG4gICAgICByZXR1cm4gdGFza3MubWFwKGZ1bmN0aW9uICh0KSB7XG4gICAgICAgIHJldHVybiB0Lm5hbWU7XG4gICAgICB9KTtcbiAgICB9XG4gIH07XG59XG5cbmZ1bmN0aW9uIGNyZWF0ZVRhc2tJdGVyYXRvcihfcmVmKSB7XG4gIHZhciBjb250ZXh0ID0gX3JlZi5jb250ZXh0O1xuICB2YXIgZm4gPSBfcmVmLmZuO1xuICB2YXIgYXJncyA9IF9yZWYuYXJncztcblxuICBpZiAoX3V0aWxzLmlzLml0ZXJhdG9yKGZuKSkge1xuICAgIHJldHVybiBmbjtcbiAgfVxuXG4gIC8vIGNhdGNoIHN5bmNocm9ub3VzIGZhaWx1cmVzOyBzZWUgIzE1MiBhbmQgIzQ0MVxuICB2YXIgcmVzdWx0ID0gdm9pZCAwLFxuICAgICAgZXJyb3IgPSB2b2lkIDA7XG4gIHRyeSB7XG4gICAgcmVzdWx0ID0gZm4uYXBwbHkoY29udGV4dCwgYXJncyk7XG4gIH0gY2F0Y2ggKGVycikge1xuICAgIGVycm9yID0gZXJyO1xuICB9XG5cbiAgLy8gaS5lLiBhIGdlbmVyYXRvciBmdW5jdGlvbiByZXR1cm5zIGFuIGl0ZXJhdG9yXG4gIGlmIChfdXRpbHMuaXMuaXRlcmF0b3IocmVzdWx0KSkge1xuICAgIHJldHVybiByZXN1bHQ7XG4gIH1cblxuICAvLyBkbyBub3QgYnViYmxlIHVwIHN5bmNocm9ub3VzIGZhaWx1cmVzIGZvciBkZXRhY2hlZCBmb3Jrc1xuICAvLyBpbnN0ZWFkIGNyZWF0ZSBhIGZhaWxlZCB0YXNrLiBTZWUgIzE1MiBhbmQgIzQ0MVxuICByZXR1cm4gZXJyb3IgPyAoMCwgX3V0aWxzLm1ha2VJdGVyYXRvcikoZnVuY3Rpb24gKCkge1xuICAgIHRocm93IGVycm9yO1xuICB9KSA6ICgwLCBfdXRpbHMubWFrZUl0ZXJhdG9yKShmdW5jdGlvbiAoKSB7XG4gICAgdmFyIHBjID0gdm9pZCAwO1xuICAgIHZhciBlZmYgPSB7IGRvbmU6IGZhbHNlLCB2YWx1ZTogcmVzdWx0IH07XG4gICAgdmFyIHJldCA9IGZ1bmN0aW9uIHJldCh2YWx1ZSkge1xuICAgICAgcmV0dXJuIHsgZG9uZTogdHJ1ZSwgdmFsdWU6IHZhbHVlIH07XG4gICAgfTtcbiAgICByZXR1cm4gZnVuY3Rpb24gKGFyZykge1xuICAgICAgaWYgKCFwYykge1xuICAgICAgICBwYyA9IHRydWU7XG4gICAgICAgIHJldHVybiBlZmY7XG4gICAgICB9IGVsc2Uge1xuICAgICAgICByZXR1cm4gcmV0KGFyZyk7XG4gICAgICB9XG4gICAgfTtcbiAgfSgpKTtcbn1cblxuZnVuY3Rpb24gd3JhcEhlbHBlcihoZWxwZXIpIHtcbiAgcmV0dXJuIHtcbiAgICBmbjogaGVscGVyXG4gIH07XG59XG5cbmZ1bmN0aW9uIHByb2MoaXRlcmF0b3IpIHtcbiAgdmFyIHN1YnNjcmliZSA9IGFyZ3VtZW50cy5sZW5ndGggPD0gMSB8fCBhcmd1bWVudHNbMV0gPT09IHVuZGVmaW5lZCA/IGZ1bmN0aW9uICgpIHtcbiAgICByZXR1cm4gX3V0aWxzLm5vb3A7XG4gIH0gOiBhcmd1bWVudHNbMV07XG4gIHZhciBkaXNwYXRjaCA9IGFyZ3VtZW50cy5sZW5ndGggPD0gMiB8fCBhcmd1bWVudHNbMl0gPT09IHVuZGVmaW5lZCA/IF91dGlscy5ub29wIDogYXJndW1lbnRzWzJdO1xuICB2YXIgZ2V0U3RhdGUgPSBhcmd1bWVudHMubGVuZ3RoIDw9IDMgfHwgYXJndW1lbnRzWzNdID09PSB1bmRlZmluZWQgPyBfdXRpbHMubm9vcCA6IGFyZ3VtZW50c1szXTtcbiAgdmFyIG9wdGlvbnMgPSBhcmd1bWVudHMubGVuZ3RoIDw9IDQgfHwgYXJndW1lbnRzWzRdID09PSB1bmRlZmluZWQgPyB7fSA6IGFyZ3VtZW50c1s0XTtcbiAgdmFyIHBhcmVudEVmZmVjdElkID0gYXJndW1lbnRzLmxlbmd0aCA8PSA1IHx8IGFyZ3VtZW50c1s1XSA9PT0gdW5kZWZpbmVkID8gMCA6IGFyZ3VtZW50c1s1XTtcbiAgdmFyIG5hbWUgPSBhcmd1bWVudHMubGVuZ3RoIDw9IDYgfHwgYXJndW1lbnRzWzZdID09PSB1bmRlZmluZWQgPyAnYW5vbnltb3VzJyA6IGFyZ3VtZW50c1s2XTtcbiAgdmFyIGNvbnQgPSBhcmd1bWVudHNbN107XG5cbiAgKDAsIF91dGlscy5jaGVjaykoaXRlcmF0b3IsIF91dGlscy5pcy5pdGVyYXRvciwgTk9UX0lURVJBVE9SX0VSUk9SKTtcblxuICB2YXIgc2FnYU1vbml0b3IgPSBvcHRpb25zLnNhZ2FNb25pdG9yO1xuICB2YXIgbG9nZ2VyID0gb3B0aW9ucy5sb2dnZXI7XG4gIHZhciBvbkVycm9yID0gb3B0aW9ucy5vbkVycm9yO1xuXG4gIHZhciBsb2cgPSBsb2dnZXIgfHwgX3V0aWxzLmxvZztcbiAgdmFyIHN0ZENoYW5uZWwgPSAoMCwgX2NoYW5uZWwuc3RkQ2hhbm5lbCkoc3Vic2NyaWJlKTtcbiAgLyoqXG4gICAgVHJhY2tzIHRoZSBjdXJyZW50IGVmZmVjdCBjYW5jZWxsYXRpb25cbiAgICBFYWNoIHRpbWUgdGhlIGdlbmVyYXRvciBwcm9ncmVzc2VzLiBjYWxsaW5nIHJ1bkVmZmVjdCB3aWxsIHNldCBhIG5ldyB2YWx1ZVxuICAgIG9uIGl0LiBJdCBhbGxvd3MgcHJvcGFnYXRpbmcgY2FuY2VsbGF0aW9uIHRvIGNoaWxkIGVmZmVjdHNcbiAgKiovXG4gIG5leHQuY2FuY2VsID0gX3V0aWxzLm5vb3A7XG5cbiAgLyoqXG4gICAgQ3JlYXRlcyBhIG5ldyB0YXNrIGRlc2NyaXB0b3IgZm9yIHRoaXMgZ2VuZXJhdG9yLCBXZSdsbCBhbHNvIGNyZWF0ZSBhIG1haW4gdGFza1xuICAgIHRvIHRyYWNrIHRoZSBtYWluIGZsb3cgKGJlc2lkZXMgb3RoZXIgZm9ya2VkIHRhc2tzKVxuICAqKi9cbiAgdmFyIHRhc2sgPSBuZXdUYXNrKHBhcmVudEVmZmVjdElkLCBuYW1lLCBpdGVyYXRvciwgY29udCk7XG4gIHZhciBtYWluVGFzayA9IHsgbmFtZTogbmFtZSwgY2FuY2VsOiBjYW5jZWxNYWluLCBpc1J1bm5pbmc6IHRydWUgfTtcbiAgdmFyIHRhc2tRdWV1ZSA9IGZvcmtRdWV1ZShuYW1lLCBtYWluVGFzaywgZW5kKTtcblxuICAvKipcbiAgICBjYW5jZWxsYXRpb24gb2YgdGhlIG1haW4gdGFzay4gV2UnbGwgc2ltcGx5IHJlc3VtZSB0aGUgR2VuZXJhdG9yIHdpdGggYSBDYW5jZWxcbiAgKiovXG4gIGZ1bmN0aW9uIGNhbmNlbE1haW4oKSB7XG4gICAgaWYgKG1haW5UYXNrLmlzUnVubmluZyAmJiAhbWFpblRhc2suaXNDYW5jZWxsZWQpIHtcbiAgICAgIG1haW5UYXNrLmlzQ2FuY2VsbGVkID0gdHJ1ZTtcbiAgICAgIG5leHQoVEFTS19DQU5DRUwpO1xuICAgIH1cbiAgfVxuXG4gIC8qKlxuICAgIFRoaXMgbWF5IGJlIGNhbGxlZCBieSBhIHBhcmVudCBnZW5lcmF0b3IgdG8gdHJpZ2dlci9wcm9wYWdhdGUgY2FuY2VsbGF0aW9uXG4gICAgY2FuY2VsIGFsbCBwZW5kaW5nIHRhc2tzIChpbmNsdWRpbmcgdGhlIG1haW4gdGFzayksIHRoZW4gZW5kIHRoZSBjdXJyZW50IHRhc2suXG4gICAgIENhbmNlbGxhdGlvbiBwcm9wYWdhdGVzIGRvd24gdG8gdGhlIHdob2xlIGV4ZWN1dGlvbiB0cmVlIGhvbGRlZCBieSB0aGlzIFBhcmVudCB0YXNrXG4gICAgSXQncyBhbHNvIHByb3BhZ2F0ZWQgdG8gYWxsIGpvaW5lcnMgb2YgdGhpcyB0YXNrIGFuZCB0aGVpciBleGVjdXRpb24gdHJlZS9qb2luZXJzXG4gICAgIENhbmNlbGxhdGlvbiBpcyBub29wIGZvciB0ZXJtaW5hdGVkL0NhbmNlbGxlZCB0YXNrcyB0YXNrc1xuICAqKi9cbiAgZnVuY3Rpb24gY2FuY2VsKCkge1xuICAgIC8qKlxuICAgICAgV2UgbmVlZCB0byBjaGVjayBib3RoIFJ1bm5pbmcgYW5kIENhbmNlbGxlZCBzdGF0dXNcbiAgICAgIFRhc2tzIGNhbiBiZSBDYW5jZWxsZWQgYnV0IHN0aWxsIFJ1bm5pbmdcbiAgICAqKi9cbiAgICBpZiAoaXRlcmF0b3IuX2lzUnVubmluZyAmJiAhaXRlcmF0b3IuX2lzQ2FuY2VsbGVkKSB7XG4gICAgICBpdGVyYXRvci5faXNDYW5jZWxsZWQgPSB0cnVlO1xuICAgICAgdGFza1F1ZXVlLmNhbmNlbEFsbCgpO1xuICAgICAgLyoqXG4gICAgICAgIEVuZGluZyB3aXRoIGEgTmV2ZXIgcmVzdWx0IHdpbGwgcHJvcGFnYXRlIHRoZSBDYW5jZWxsYXRpb24gdG8gYWxsIGpvaW5lcnNcbiAgICAgICoqL1xuICAgICAgZW5kKFRBU0tfQ0FOQ0VMKTtcbiAgICB9XG4gIH1cbiAgLyoqXG4gICAgYXR0YWNoZXMgY2FuY2VsbGF0aW9uIGxvZ2ljIHRvIHRoaXMgdGFzaydzIGNvbnRpbnVhdGlvblxuICAgIHRoaXMgd2lsbCBwZXJtaXQgY2FuY2VsbGF0aW9uIHRvIHByb3BhZ2F0ZSBkb3duIHRoZSBjYWxsIGNoYWluXG4gICoqL1xuICBjb250ICYmIChjb250LmNhbmNlbCA9IGNhbmNlbCk7XG5cbiAgLy8gdHJhY2tzIHRoZSBydW5uaW5nIHN0YXR1c1xuICBpdGVyYXRvci5faXNSdW5uaW5nID0gdHJ1ZTtcblxuICAvLyBraWNrcyB1cCB0aGUgZ2VuZXJhdG9yXG4gIG5leHQoKTtcblxuICAvLyB0aGVuIHJldHVybiB0aGUgdGFzayBkZXNjcmlwdG9yIHRvIHRoZSBjYWxsZXJcbiAgcmV0dXJuIHRhc2s7XG5cbiAgLyoqXG4gICAgVGhpcyBpcyB0aGUgZ2VuZXJhdG9yIGRyaXZlclxuICAgIEl0J3MgYSByZWN1cnNpdmUgYXN5bmMvY29udGludWF0aW9uIGZ1bmN0aW9uIHdoaWNoIGNhbGxzIGl0c2VsZlxuICAgIHVudGlsIHRoZSBnZW5lcmF0b3IgdGVybWluYXRlcyBvciB0aHJvd3NcbiAgKiovXG4gIGZ1bmN0aW9uIG5leHQoYXJnLCBpc0Vycikge1xuICAgIC8vIFByZXZlbnRpdmUgbWVhc3VyZS4gSWYgd2UgZW5kIHVwIGhlcmUsIHRoZW4gdGhlcmUgaXMgcmVhbGx5IHNvbWV0aGluZyB3cm9uZ1xuICAgIGlmICghbWFpblRhc2suaXNSdW5uaW5nKSB7XG4gICAgICB0aHJvdyBuZXcgRXJyb3IoJ1RyeWluZyB0byByZXN1bWUgYW4gYWxyZWFkeSBmaW5pc2hlZCBnZW5lcmF0b3InKTtcbiAgICB9XG5cbiAgICB0cnkge1xuICAgICAgdmFyIHJlc3VsdCA9IHZvaWQgMDtcbiAgICAgIGlmIChpc0Vycikge1xuICAgICAgICByZXN1bHQgPSBpdGVyYXRvci50aHJvdyhhcmcpO1xuICAgICAgfSBlbHNlIGlmIChhcmcgPT09IFRBU0tfQ0FOQ0VMKSB7XG4gICAgICAgIC8qKlxuICAgICAgICAgIGdldHRpbmcgVEFTS19DQU5DRUwgYXV0b2FtdGljYWxseSBjYW5jZWxzIHRoZSBtYWluIHRhc2tcbiAgICAgICAgICBXZSBjYW4gZ2V0IHRoaXMgdmFsdWUgaGVyZVxuICAgICAgICAgICAtIEJ5IGNhbmNlbGxpbmcgdGhlIHBhcmVudCB0YXNrIG1hbnVhbGx5XG4gICAgICAgICAgLSBCeSBqb2luaW5nIGEgQ2FuY2VsbGVkIHRhc2tcbiAgICAgICAgKiovXG4gICAgICAgIG1haW5UYXNrLmlzQ2FuY2VsbGVkID0gdHJ1ZTtcbiAgICAgICAgLyoqXG4gICAgICAgICAgQ2FuY2VscyB0aGUgY3VycmVudCBlZmZlY3Q7IHRoaXMgd2lsbCBwcm9wYWdhdGUgdGhlIGNhbmNlbGxhdGlvbiBkb3duIHRvIGFueSBjYWxsZWQgdGFza3NcbiAgICAgICAgKiovXG4gICAgICAgIG5leHQuY2FuY2VsKCk7XG4gICAgICAgIC8qKlxuICAgICAgICAgIElmIHRoaXMgR2VuZXJhdG9yIGhhcyBhIGByZXR1cm5gIG1ldGhvZCB0aGVuIGludm9rZXMgaXRcbiAgICAgICAgICBUaGlsbCB3aWxsIGp1bXAgdG8gdGhlIGZpbmFsbHkgYmxvY2tcbiAgICAgICAgKiovXG4gICAgICAgIHJlc3VsdCA9IF91dGlscy5pcy5mdW5jKGl0ZXJhdG9yLnJldHVybikgPyBpdGVyYXRvci5yZXR1cm4oVEFTS19DQU5DRUwpIDogeyBkb25lOiB0cnVlLCB2YWx1ZTogVEFTS19DQU5DRUwgfTtcbiAgICAgIH0gZWxzZSBpZiAoYXJnID09PSBDSEFOTkVMX0VORCkge1xuICAgICAgICAvLyBXZSBnZXQgQ0hBTk5FTF9FTkQgYnkgdGFraW5nIGZyb20gYSBjaGFubmVsIHRoYXQgZW5kZWQgdXNpbmcgYHRha2VgIChhbmQgbm90IGB0YWtlbWAgdXNlZCB0byB0cmFwIEVuZCBvZiBjaGFubmVscylcbiAgICAgICAgcmVzdWx0ID0gX3V0aWxzLmlzLmZ1bmMoaXRlcmF0b3IucmV0dXJuKSA/IGl0ZXJhdG9yLnJldHVybigpIDogeyBkb25lOiB0cnVlIH07XG4gICAgICB9IGVsc2Uge1xuICAgICAgICByZXN1bHQgPSBpdGVyYXRvci5uZXh0KGFyZyk7XG4gICAgICB9XG5cbiAgICAgIGlmICghcmVzdWx0LmRvbmUpIHtcbiAgICAgICAgcnVuRWZmZWN0KHJlc3VsdC52YWx1ZSwgcGFyZW50RWZmZWN0SWQsICcnLCBuZXh0KTtcbiAgICAgIH0gZWxzZSB7XG4gICAgICAgIC8qKlxuICAgICAgICAgIFRoaXMgR2VuZXJhdG9yIGhhcyBlbmRlZCwgdGVybWluYXRlIHRoZSBtYWluIHRhc2sgYW5kIG5vdGlmeSB0aGUgZm9yayBxdWV1ZVxuICAgICAgICAqKi9cbiAgICAgICAgbWFpblRhc2suaXNNYWluUnVubmluZyA9IGZhbHNlO1xuICAgICAgICBtYWluVGFzay5jb250ICYmIG1haW5UYXNrLmNvbnQocmVzdWx0LnZhbHVlKTtcbiAgICAgIH1cbiAgICB9IGNhdGNoIChlcnJvcikge1xuICAgICAgaWYgKG1haW5UYXNrLmlzQ2FuY2VsbGVkKSB7XG4gICAgICAgIGxvZygnZXJyb3InLCAndW5jYXVnaHQgYXQgJyArIG5hbWUsIGVycm9yLm1lc3NhZ2UpO1xuICAgICAgfVxuICAgICAgbWFpblRhc2suaXNNYWluUnVubmluZyA9IGZhbHNlO1xuICAgICAgbWFpblRhc2suY29udChlcnJvciwgdHJ1ZSk7XG4gICAgfVxuICB9XG5cbiAgZnVuY3Rpb24gZW5kKHJlc3VsdCwgaXNFcnIpIHtcbiAgICBpdGVyYXRvci5faXNSdW5uaW5nID0gZmFsc2U7XG4gICAgc3RkQ2hhbm5lbC5jbG9zZSgpO1xuICAgIGlmICghaXNFcnIpIHtcbiAgICAgIGlmIChyZXN1bHQgPT09IFRBU0tfQ0FOQ0VMICYmIGlzRGV2KSB7XG4gICAgICAgIGxvZygnaW5mbycsIG5hbWUgKyAnIGhhcyBiZWVuIGNhbmNlbGxlZCcsICcnKTtcbiAgICAgIH1cbiAgICAgIGl0ZXJhdG9yLl9yZXN1bHQgPSByZXN1bHQ7XG4gICAgICBpdGVyYXRvci5fZGVmZXJyZWRFbmQgJiYgaXRlcmF0b3IuX2RlZmVycmVkRW5kLnJlc29sdmUocmVzdWx0KTtcbiAgICB9IGVsc2Uge1xuICAgICAgaWYgKHJlc3VsdCBpbnN0YW5jZW9mIEVycm9yKSB7XG4gICAgICAgIHJlc3VsdC5zYWdhU3RhY2sgPSAnYXQgJyArIG5hbWUgKyAnIFxcbiAnICsgKHJlc3VsdC5zYWdhU3RhY2sgfHwgcmVzdWx0LnN0YWNrKTtcbiAgICAgIH1cbiAgICAgIGlmICghdGFzay5jb250KSB7XG4gICAgICAgIGxvZygnZXJyb3InLCAndW5jYXVnaHQnLCByZXN1bHQuc2FnYVN0YWNrIHx8IHJlc3VsdC5zdGFjayk7XG4gICAgICAgIGlmIChyZXN1bHQgaW5zdGFuY2VvZiBFcnJvciAmJiBvbkVycm9yKSB7XG4gICAgICAgICAgb25FcnJvcihyZXN1bHQpO1xuICAgICAgICB9XG4gICAgICB9XG4gICAgICBpdGVyYXRvci5fZXJyb3IgPSByZXN1bHQ7XG4gICAgICBpdGVyYXRvci5faXNBYm9ydGVkID0gdHJ1ZTtcbiAgICAgIGl0ZXJhdG9yLl9kZWZlcnJlZEVuZCAmJiBpdGVyYXRvci5fZGVmZXJyZWRFbmQucmVqZWN0KHJlc3VsdCk7XG4gICAgfVxuICAgIHRhc2suY29udCAmJiB0YXNrLmNvbnQocmVzdWx0LCBpc0Vycik7XG4gICAgdGFzay5qb2luZXJzLmZvckVhY2goZnVuY3Rpb24gKGopIHtcbiAgICAgIHJldHVybiBqLmNiKHJlc3VsdCwgaXNFcnIpO1xuICAgIH0pO1xuICAgIHRhc2suam9pbmVycyA9IG51bGw7XG4gIH1cblxuICBmdW5jdGlvbiBydW5FZmZlY3QoZWZmZWN0LCBwYXJlbnRFZmZlY3RJZCkge1xuICAgIHZhciBsYWJlbCA9IGFyZ3VtZW50cy5sZW5ndGggPD0gMiB8fCBhcmd1bWVudHNbMl0gPT09IHVuZGVmaW5lZCA/ICcnIDogYXJndW1lbnRzWzJdO1xuICAgIHZhciBjYiA9IGFyZ3VtZW50c1szXTtcblxuICAgIHZhciBlZmZlY3RJZCA9IG5leHRFZmZlY3RJZCgpO1xuICAgIHNhZ2FNb25pdG9yICYmIHNhZ2FNb25pdG9yLmVmZmVjdFRyaWdnZXJlZCh7IGVmZmVjdElkOiBlZmZlY3RJZCwgcGFyZW50RWZmZWN0SWQ6IHBhcmVudEVmZmVjdElkLCBsYWJlbDogbGFiZWwsIGVmZmVjdDogZWZmZWN0IH0pO1xuXG4gICAgLyoqXG4gICAgICBjb21wbGV0aW9uIGNhbGxiYWNrIGFuZCBjYW5jZWwgY2FsbGJhY2sgYXJlIG11dHVhbGx5IGV4Y2x1c2l2ZVxuICAgICAgV2UgY2FuJ3QgY2FuY2VsIGFuIGFscmVhZHkgY29tcGxldGVkIGVmZmVjdFxuICAgICAgQW5kIFdlIGNhbid0IGNvbXBsZXRlIGFuIGFscmVhZHkgY2FuY2VsbGVkIGVmZmVjdElkXG4gICAgKiovXG4gICAgdmFyIGVmZmVjdFNldHRsZWQgPSB2b2lkIDA7XG5cbiAgICAvLyBDb21wbGV0aW9uIGNhbGxiYWNrIHBhc3NlZCB0byB0aGUgYXBwcm9wcmlhdGUgZWZmZWN0IHJ1bm5lclxuICAgIGZ1bmN0aW9uIGN1cnJDYihyZXMsIGlzRXJyKSB7XG4gICAgICBpZiAoZWZmZWN0U2V0dGxlZCkge1xuICAgICAgICByZXR1cm47XG4gICAgICB9XG5cbiAgICAgIGVmZmVjdFNldHRsZWQgPSB0cnVlO1xuICAgICAgY2IuY2FuY2VsID0gX3V0aWxzLm5vb3A7IC8vIGRlZmVuc2l2ZSBtZWFzdXJlXG4gICAgICBpZiAoc2FnYU1vbml0b3IpIHtcbiAgICAgICAgaXNFcnIgPyBzYWdhTW9uaXRvci5lZmZlY3RSZWplY3RlZChlZmZlY3RJZCwgcmVzKSA6IHNhZ2FNb25pdG9yLmVmZmVjdFJlc29sdmVkKGVmZmVjdElkLCByZXMpO1xuICAgICAgfVxuXG4gICAgICBjYihyZXMsIGlzRXJyKTtcbiAgICB9XG4gICAgLy8gdHJhY2tzIGRvd24gdGhlIGN1cnJlbnQgY2FuY2VsXG4gICAgY3VyckNiLmNhbmNlbCA9IF91dGlscy5ub29wO1xuXG4gICAgLy8gc2V0dXAgY2FuY2VsbGF0aW9uIGxvZ2ljIG9uIHRoZSBwYXJlbnQgY2JcbiAgICBjYi5jYW5jZWwgPSBmdW5jdGlvbiAoKSB7XG4gICAgICAvLyBwcmV2ZW50cyBjYW5jZWxsaW5nIGFuIGFscmVhZHkgY29tcGxldGVkIGVmZmVjdFxuICAgICAgaWYgKGVmZmVjdFNldHRsZWQpIHtcbiAgICAgICAgcmV0dXJuO1xuICAgICAgfVxuXG4gICAgICBlZmZlY3RTZXR0bGVkID0gdHJ1ZTtcbiAgICAgIC8qKlxuICAgICAgICBwcm9wYWdhdGVzIGNhbmNlbCBkb3dud2FyZFxuICAgICAgICBjYXRjaCB1bmNhdWdodCBjYW5jZWxsYXRpb25zIGVycm9yczsgc2luY2Ugd2UgY2FuIG5vIGxvbmdlciBjYWxsIHRoZSBjb21wbGV0aW9uXG4gICAgICAgIGNhbGxiYWNrLCBsb2cgZXJyb3JzIHJhaXNlZCBkdXJpbmcgY2FuY2VsbGF0aW9ucyBpbnRvIHRoZSBjb25zb2xlXG4gICAgICAqKi9cbiAgICAgIHRyeSB7XG4gICAgICAgIGN1cnJDYi5jYW5jZWwoKTtcbiAgICAgIH0gY2F0Y2ggKGVycikge1xuICAgICAgICBsb2coJ2Vycm9yJywgJ3VuY2F1Z2h0IGF0ICcgKyBuYW1lLCBlcnIubWVzc2FnZSk7XG4gICAgICB9XG4gICAgICBjdXJyQ2IuY2FuY2VsID0gX3V0aWxzLm5vb3A7IC8vIGRlZmVuc2l2ZSBtZWFzdXJlXG5cbiAgICAgIHNhZ2FNb25pdG9yICYmIHNhZ2FNb25pdG9yLmVmZmVjdENhbmNlbGxlZChlZmZlY3RJZCk7XG4gICAgfTtcblxuICAgIC8qKlxuICAgICAgZWFjaCBlZmZlY3QgcnVubmVyIG11c3QgYXR0YWNoIGl0cyBvd24gbG9naWMgb2YgY2FuY2VsbGF0aW9uIHRvIHRoZSBwcm92aWRlZCBjYWxsYmFja1xuICAgICAgaXQgYWxsb3dzIHRoaXMgZ2VuZXJhdG9yIHRvIHByb3BhZ2F0ZSBjYW5jZWxsYXRpb24gZG93bndhcmQuXG4gICAgICAgQVRURU5USU9OISBlZmZlY3QgcnVubmVycyBtdXN0IHNldHVwIHRoZSBjYW5jZWwgbG9naWMgYnkgc2V0dGluZyBjYi5jYW5jZWwgPSBbY2FuY2VsTWV0aG9kXVxuICAgICAgQW5kIHRoZSBzZXR1cCBtdXN0IG9jY3VyIGJlZm9yZSBjYWxsaW5nIHRoZSBjYWxsYmFja1xuICAgICAgIFRoaXMgaXMgYSBzb3J0IG9mIGludmVyc2lvbiBvZiBjb250cm9sOiBjYWxsZWQgYXN5bmMgZnVuY3Rpb25zIGFyZSByZXNwb25zaWJsZVxuICAgICAgb2YgY29tcGxldGluZyB0aGUgZmxvdyBieSBjYWxsaW5nIHRoZSBwcm92aWRlZCBjb250aW51YXRpb247IHdoaWxlIGNhbGxlciBmdW5jdGlvbnNcbiAgICAgIGFyZSByZXNwb25zaWJsZSBmb3IgYWJvcnRpbmcgdGhlIGN1cnJlbnQgZmxvdyBieSBjYWxsaW5nIHRoZSBhdHRhY2hlZCBjYW5jZWwgZnVuY3Rpb25cbiAgICAgICBMaWJyYXJ5IHVzZXJzIGNhbiBhdHRhY2ggdGhlaXIgb3duIGNhbmNlbGxhdGlvbiBsb2dpYyB0byBwcm9taXNlcyBieSBkZWZpbmluZyBhXG4gICAgICBwcm9taXNlW0NBTkNFTF0gbWV0aG9kIGluIHRoZWlyIHJldHVybmVkIHByb21pc2VzXG4gICAgICBBVFRFTlRJT04hIGNhbGxpbmcgY2FuY2VsIG11c3QgaGF2ZSBubyBlZmZlY3Qgb24gYW4gYWxyZWFkeSBjb21wbGV0ZWQgb3IgY2FuY2VsbGVkIGVmZmVjdFxuICAgICoqL1xuICAgIHZhciBkYXRhID0gdm9pZCAwO1xuICAgIHJldHVybiAoXG4gICAgICAvLyBOb24gZGVjbGFyYXRpdmUgZWZmZWN0XG4gICAgICBfdXRpbHMuaXMucHJvbWlzZShlZmZlY3QpID8gcmVzb2x2ZVByb21pc2UoZWZmZWN0LCBjdXJyQ2IpIDogX3V0aWxzLmlzLmhlbHBlcihlZmZlY3QpID8gcnVuRm9ya0VmZmVjdCh3cmFwSGVscGVyKGVmZmVjdCksIGVmZmVjdElkLCBjdXJyQ2IpIDogX3V0aWxzLmlzLml0ZXJhdG9yKGVmZmVjdCkgPyByZXNvbHZlSXRlcmF0b3IoZWZmZWN0LCBlZmZlY3RJZCwgbmFtZSwgY3VyckNiKVxuXG4gICAgICAvLyBkZWNsYXJhdGl2ZSBlZmZlY3RzXG4gICAgICA6IF91dGlscy5pcy5hcnJheShlZmZlY3QpID8gcnVuUGFyYWxsZWxFZmZlY3QoZWZmZWN0LCBlZmZlY3RJZCwgY3VyckNiKSA6IF91dGlscy5pcy5ub3RVbmRlZihkYXRhID0gX2lvLmFzRWZmZWN0LnRha2UoZWZmZWN0KSkgPyBydW5UYWtlRWZmZWN0KGRhdGEsIGN1cnJDYikgOiBfdXRpbHMuaXMubm90VW5kZWYoZGF0YSA9IF9pby5hc0VmZmVjdC5wdXQoZWZmZWN0KSkgPyBydW5QdXRFZmZlY3QoZGF0YSwgY3VyckNiKSA6IF91dGlscy5pcy5ub3RVbmRlZihkYXRhID0gX2lvLmFzRWZmZWN0LnJhY2UoZWZmZWN0KSkgPyBydW5SYWNlRWZmZWN0KGRhdGEsIGVmZmVjdElkLCBjdXJyQ2IpIDogX3V0aWxzLmlzLm5vdFVuZGVmKGRhdGEgPSBfaW8uYXNFZmZlY3QuY2FsbChlZmZlY3QpKSA/IHJ1bkNhbGxFZmZlY3QoZGF0YSwgZWZmZWN0SWQsIGN1cnJDYikgOiBfdXRpbHMuaXMubm90VW5kZWYoZGF0YSA9IF9pby5hc0VmZmVjdC5jcHMoZWZmZWN0KSkgPyBydW5DUFNFZmZlY3QoZGF0YSwgY3VyckNiKSA6IF91dGlscy5pcy5ub3RVbmRlZihkYXRhID0gX2lvLmFzRWZmZWN0LmZvcmsoZWZmZWN0KSkgPyBydW5Gb3JrRWZmZWN0KGRhdGEsIGVmZmVjdElkLCBjdXJyQ2IpIDogX3V0aWxzLmlzLm5vdFVuZGVmKGRhdGEgPSBfaW8uYXNFZmZlY3Quam9pbihlZmZlY3QpKSA/IHJ1bkpvaW5FZmZlY3QoZGF0YSwgY3VyckNiKSA6IF91dGlscy5pcy5ub3RVbmRlZihkYXRhID0gX2lvLmFzRWZmZWN0LmNhbmNlbChlZmZlY3QpKSA/IHJ1bkNhbmNlbEVmZmVjdChkYXRhLCBjdXJyQ2IpIDogX3V0aWxzLmlzLm5vdFVuZGVmKGRhdGEgPSBfaW8uYXNFZmZlY3Quc2VsZWN0KGVmZmVjdCkpID8gcnVuU2VsZWN0RWZmZWN0KGRhdGEsIGN1cnJDYikgOiBfdXRpbHMuaXMubm90VW5kZWYoZGF0YSA9IF9pby5hc0VmZmVjdC5hY3Rpb25DaGFubmVsKGVmZmVjdCkpID8gcnVuQ2hhbm5lbEVmZmVjdChkYXRhLCBjdXJyQ2IpIDogX3V0aWxzLmlzLm5vdFVuZGVmKGRhdGEgPSBfaW8uYXNFZmZlY3QuZmx1c2goZWZmZWN0KSkgPyBydW5GbHVzaEVmZmVjdChkYXRhLCBjdXJyQ2IpIDogX3V0aWxzLmlzLm5vdFVuZGVmKGRhdGEgPSBfaW8uYXNFZmZlY3QuY2FuY2VsbGVkKGVmZmVjdCkpID8gcnVuQ2FuY2VsbGVkRWZmZWN0KGRhdGEsIGN1cnJDYikgOiAvKiBhbnl0aGluZyBlbHNlIHJldHVybmVkIGFzIGlzICAgICAgICAqL2N1cnJDYihlZmZlY3QpXG4gICAgKTtcbiAgfVxuXG4gIGZ1bmN0aW9uIHJlc29sdmVQcm9taXNlKHByb21pc2UsIGNiKSB7XG4gICAgdmFyIGNhbmNlbFByb21pc2UgPSBwcm9taXNlW191dGlscy5DQU5DRUxdO1xuICAgIGlmICh0eXBlb2YgY2FuY2VsUHJvbWlzZSA9PT0gJ2Z1bmN0aW9uJykge1xuICAgICAgY2IuY2FuY2VsID0gY2FuY2VsUHJvbWlzZTtcbiAgICB9XG4gICAgcHJvbWlzZS50aGVuKGNiLCBmdW5jdGlvbiAoZXJyb3IpIHtcbiAgICAgIHJldHVybiBjYihlcnJvciwgdHJ1ZSk7XG4gICAgfSk7XG4gIH1cblxuICBmdW5jdGlvbiByZXNvbHZlSXRlcmF0b3IoaXRlcmF0b3IsIGVmZmVjdElkLCBuYW1lLCBjYikge1xuICAgIHByb2MoaXRlcmF0b3IsIHN1YnNjcmliZSwgZGlzcGF0Y2gsIGdldFN0YXRlLCBvcHRpb25zLCBlZmZlY3RJZCwgbmFtZSwgY2IpO1xuICB9XG5cbiAgZnVuY3Rpb24gcnVuVGFrZUVmZmVjdChfcmVmMiwgY2IpIHtcbiAgICB2YXIgY2hhbm5lbCA9IF9yZWYyLmNoYW5uZWw7XG4gICAgdmFyIHBhdHRlcm4gPSBfcmVmMi5wYXR0ZXJuO1xuICAgIHZhciBtYXliZSA9IF9yZWYyLm1heWJlO1xuXG4gICAgY2hhbm5lbCA9IGNoYW5uZWwgfHwgc3RkQ2hhbm5lbDtcbiAgICB2YXIgdGFrZUNiID0gZnVuY3Rpb24gdGFrZUNiKGlucCkge1xuICAgICAgcmV0dXJuIGlucCBpbnN0YW5jZW9mIEVycm9yID8gY2IoaW5wLCB0cnVlKSA6ICgwLCBfY2hhbm5lbC5pc0VuZCkoaW5wKSAmJiAhbWF5YmUgPyBjYihDSEFOTkVMX0VORCkgOiBjYihpbnApO1xuICAgIH07XG4gICAgdHJ5IHtcbiAgICAgIGNoYW5uZWwudGFrZSh0YWtlQ2IsIG1hdGNoZXIocGF0dGVybikpO1xuICAgIH0gY2F0Y2ggKGVycikge1xuICAgICAgcmV0dXJuIGNiKGVyciwgdHJ1ZSk7XG4gICAgfVxuICAgIGNiLmNhbmNlbCA9IHRha2VDYi5jYW5jZWw7XG4gIH1cblxuICBmdW5jdGlvbiBydW5QdXRFZmZlY3QoX3JlZjMsIGNiKSB7XG4gICAgdmFyIGNoYW5uZWwgPSBfcmVmMy5jaGFubmVsO1xuICAgIHZhciBhY3Rpb24gPSBfcmVmMy5hY3Rpb247XG4gICAgdmFyIHN5bmMgPSBfcmVmMy5zeW5jO1xuXG4gICAgLypcbiAgICAgIFVzZSBhIHJlZW50cmFudCBsb2NrIGBhc2FwYCB0byBmbGF0dGVuIGFsbCBuZXN0ZWQgZGlzcGF0Y2hlc1xuICAgICAgSWYgdGhpcyBwdXQgY2F1c2UgYW5vdGhlciBTYWdhIHRvIHRha2UgdGhpcyBhY3Rpb24gYW4gdGhlbiBpbW1lZGlhdGVseVxuICAgICAgcHV0IGFuIGFjdGlvbiB0aGF0IHdpbGwgYmUgdGFrZW4gYnkgdGhpcyBTYWdhLiBUaGVuIHRoZSBvdXRlciBTYWdhIHdpbGwgbWlzc1xuICAgICAgdGhlIGFjdGlvbiBmcm9tIHRoZSBpbm5lciBTYWdhIGIvYyB0aGlzIHB1dCBoYXMgbm90IHlldCByZXR1cm5lZC5cbiAgICAqL1xuICAgICgwLCBfYXNhcDIuZGVmYXVsdCkoZnVuY3Rpb24gKCkge1xuICAgICAgdmFyIHJlc3VsdCA9IHZvaWQgMDtcbiAgICAgIHRyeSB7XG4gICAgICAgIHJlc3VsdCA9IChjaGFubmVsID8gY2hhbm5lbC5wdXQgOiBkaXNwYXRjaCkoYWN0aW9uKTtcbiAgICAgIH0gY2F0Y2ggKGVycm9yKSB7XG4gICAgICAgIC8vIElmIHdlIGhhdmUgYSBjaGFubmVsIG9yIGBwdXQuc3luY2Agd2FzIHVzZWQgdGhlbiBidWJibGUgdXAgdGhlIGVycm9yLlxuICAgICAgICBpZiAoY2hhbm5lbCB8fCBzeW5jKSByZXR1cm4gY2IoZXJyb3IsIHRydWUpO1xuICAgICAgICBsb2coJ2Vycm9yJywgJ3VuY2F1Z2h0IGF0ICcgKyBuYW1lLCBlcnJvci5zdGFjayB8fCBlcnJvci5tZXNzYWdlIHx8IGVycm9yKTtcbiAgICAgIH1cblxuICAgICAgaWYgKHN5bmMgJiYgX3V0aWxzLmlzLnByb21pc2UocmVzdWx0KSkge1xuICAgICAgICByZXNvbHZlUHJvbWlzZShyZXN1bHQsIGNiKTtcbiAgICAgIH0gZWxzZSB7XG4gICAgICAgIHJldHVybiBjYihyZXN1bHQpO1xuICAgICAgfVxuICAgIH0pO1xuICAgIC8vIFB1dCBlZmZlY3RzIGFyZSBub24gY2FuY2VsbGFibGVzXG4gIH1cblxuICBmdW5jdGlvbiBydW5DYWxsRWZmZWN0KF9yZWY0LCBlZmZlY3RJZCwgY2IpIHtcbiAgICB2YXIgY29udGV4dCA9IF9yZWY0LmNvbnRleHQ7XG4gICAgdmFyIGZuID0gX3JlZjQuZm47XG4gICAgdmFyIGFyZ3MgPSBfcmVmNC5hcmdzO1xuXG4gICAgdmFyIHJlc3VsdCA9IHZvaWQgMDtcbiAgICAvLyBjYXRjaCBzeW5jaHJvbm91cyBmYWlsdXJlczsgc2VlICMxNTJcbiAgICB0cnkge1xuICAgICAgcmVzdWx0ID0gZm4uYXBwbHkoY29udGV4dCwgYXJncyk7XG4gICAgfSBjYXRjaCAoZXJyb3IpIHtcbiAgICAgIHJldHVybiBjYihlcnJvciwgdHJ1ZSk7XG4gICAgfVxuICAgIHJldHVybiBfdXRpbHMuaXMucHJvbWlzZShyZXN1bHQpID8gcmVzb2x2ZVByb21pc2UocmVzdWx0LCBjYikgOiBfdXRpbHMuaXMuaXRlcmF0b3IocmVzdWx0KSA/IHJlc29sdmVJdGVyYXRvcihyZXN1bHQsIGVmZmVjdElkLCBmbi5uYW1lLCBjYikgOiBjYihyZXN1bHQpO1xuICB9XG5cbiAgZnVuY3Rpb24gcnVuQ1BTRWZmZWN0KF9yZWY1LCBjYikge1xuICAgIHZhciBjb250ZXh0ID0gX3JlZjUuY29udGV4dDtcbiAgICB2YXIgZm4gPSBfcmVmNS5mbjtcbiAgICB2YXIgYXJncyA9IF9yZWY1LmFyZ3M7XG5cbiAgICAvLyBDUFMgKGllIG5vZGUgc3R5bGUgZnVuY3Rpb25zKSBjYW4gZGVmaW5lIHRoZWlyIG93biBjYW5jZWxsYXRpb24gbG9naWNcbiAgICAvLyBieSBzZXR0aW5nIGNhbmNlbCBmaWVsZCBvbiB0aGUgY2JcblxuICAgIC8vIGNhdGNoIHN5bmNocm9ub3VzIGZhaWx1cmVzOyBzZWUgIzE1MlxuICAgIHRyeSB7XG4gICAgICAoZnVuY3Rpb24gKCkge1xuICAgICAgICB2YXIgY3BzQ2IgPSBmdW5jdGlvbiBjcHNDYihlcnIsIHJlcykge1xuICAgICAgICAgIHJldHVybiBfdXRpbHMuaXMudW5kZWYoZXJyKSA/IGNiKHJlcykgOiBjYihlcnIsIHRydWUpO1xuICAgICAgICB9O1xuICAgICAgICBmbi5hcHBseShjb250ZXh0LCBhcmdzLmNvbmNhdChjcHNDYikpO1xuICAgICAgICBpZiAoY3BzQ2IuY2FuY2VsKSB7XG4gICAgICAgICAgY2IuY2FuY2VsID0gZnVuY3Rpb24gKCkge1xuICAgICAgICAgICAgcmV0dXJuIGNwc0NiLmNhbmNlbCgpO1xuICAgICAgICAgIH07XG4gICAgICAgIH1cbiAgICAgIH0pKCk7XG4gICAgfSBjYXRjaCAoZXJyb3IpIHtcbiAgICAgIHJldHVybiBjYihlcnJvciwgdHJ1ZSk7XG4gICAgfVxuICB9XG5cbiAgZnVuY3Rpb24gcnVuRm9ya0VmZmVjdChfcmVmNiwgZWZmZWN0SWQsIGNiKSB7XG4gICAgdmFyIGNvbnRleHQgPSBfcmVmNi5jb250ZXh0O1xuICAgIHZhciBmbiA9IF9yZWY2LmZuO1xuICAgIHZhciBhcmdzID0gX3JlZjYuYXJncztcbiAgICB2YXIgZGV0YWNoZWQgPSBfcmVmNi5kZXRhY2hlZDtcblxuICAgIHZhciB0YXNrSXRlcmF0b3IgPSBjcmVhdGVUYXNrSXRlcmF0b3IoeyBjb250ZXh0OiBjb250ZXh0LCBmbjogZm4sIGFyZ3M6IGFyZ3MgfSk7XG5cbiAgICBfYXNhcDIuZGVmYXVsdC5zdXNwZW5kKCk7XG4gICAgdmFyIHRhc2sgPSBwcm9jKHRhc2tJdGVyYXRvciwgc3Vic2NyaWJlLCBkaXNwYXRjaCwgZ2V0U3RhdGUsIG9wdGlvbnMsIGVmZmVjdElkLCBmbi5uYW1lLCBkZXRhY2hlZCA/IG51bGwgOiBfdXRpbHMubm9vcCk7XG5cbiAgICBpZiAoZGV0YWNoZWQpIHtcbiAgICAgIGNiKHRhc2spO1xuICAgIH0gZWxzZSB7XG4gICAgICBpZiAodGFza0l0ZXJhdG9yLl9pc1J1bm5pbmcpIHtcbiAgICAgICAgdGFza1F1ZXVlLmFkZFRhc2sodGFzayk7XG4gICAgICAgIGNiKHRhc2spO1xuICAgICAgfSBlbHNlIGlmICh0YXNrSXRlcmF0b3IuX2Vycm9yKSB7XG4gICAgICAgIHRhc2tRdWV1ZS5hYm9ydCh0YXNrSXRlcmF0b3IuX2Vycm9yKTtcbiAgICAgIH0gZWxzZSB7XG4gICAgICAgIGNiKHRhc2spO1xuICAgICAgfVxuICAgIH1cbiAgICBfYXNhcDIuZGVmYXVsdC5mbHVzaCgpO1xuICAgIC8vIEZvcmsgZWZmZWN0cyBhcmUgbm9uIGNhbmNlbGxhYmxlc1xuICB9XG5cbiAgZnVuY3Rpb24gcnVuSm9pbkVmZmVjdCh0LCBjYikge1xuICAgIGlmICh0LmlzUnVubmluZygpKSB7XG4gICAgICAoZnVuY3Rpb24gKCkge1xuICAgICAgICB2YXIgam9pbmVyID0geyB0YXNrOiB0YXNrLCBjYjogY2IgfTtcbiAgICAgICAgY2IuY2FuY2VsID0gZnVuY3Rpb24gKCkge1xuICAgICAgICAgIHJldHVybiAoMCwgX3V0aWxzLnJlbW92ZSkodC5qb2luZXJzLCBqb2luZXIpO1xuICAgICAgICB9O1xuICAgICAgICB0LmpvaW5lcnMucHVzaChqb2luZXIpO1xuICAgICAgfSkoKTtcbiAgICB9IGVsc2Uge1xuICAgICAgdC5pc0Fib3J0ZWQoKSA/IGNiKHQuZXJyb3IoKSwgdHJ1ZSkgOiBjYih0LnJlc3VsdCgpKTtcbiAgICB9XG4gIH1cblxuICBmdW5jdGlvbiBydW5DYW5jZWxFZmZlY3QodGFzaywgY2IpIHtcbiAgICBpZiAodGFzay5pc1J1bm5pbmcoKSkge1xuICAgICAgdGFzay5jYW5jZWwoKTtcbiAgICB9XG4gICAgY2IoKTtcbiAgICAvLyBjYW5jZWwgZWZmZWN0cyBhcmUgbm9uIGNhbmNlbGxhYmxlc1xuICB9XG5cbiAgZnVuY3Rpb24gcnVuUGFyYWxsZWxFZmZlY3QoZWZmZWN0cywgZWZmZWN0SWQsIGNiKSB7XG4gICAgaWYgKCFlZmZlY3RzLmxlbmd0aCkge1xuICAgICAgcmV0dXJuIGNiKFtdKTtcbiAgICB9XG5cbiAgICB2YXIgY29tcGxldGVkQ291bnQgPSAwO1xuICAgIHZhciBjb21wbGV0ZWQgPSB2b2lkIDA7XG4gICAgdmFyIHJlc3VsdHMgPSBBcnJheShlZmZlY3RzLmxlbmd0aCk7XG5cbiAgICBmdW5jdGlvbiBjaGVja0VmZmVjdEVuZCgpIHtcbiAgICAgIGlmIChjb21wbGV0ZWRDb3VudCA9PT0gcmVzdWx0cy5sZW5ndGgpIHtcbiAgICAgICAgY29tcGxldGVkID0gdHJ1ZTtcbiAgICAgICAgY2IocmVzdWx0cyk7XG4gICAgICB9XG4gICAgfVxuXG4gICAgdmFyIGNoaWxkQ2JzID0gZWZmZWN0cy5tYXAoZnVuY3Rpb24gKGVmZiwgaWR4KSB7XG4gICAgICB2YXIgY2hDYkF0SWR4ID0gZnVuY3Rpb24gY2hDYkF0SWR4KHJlcywgaXNFcnIpIHtcbiAgICAgICAgaWYgKGNvbXBsZXRlZCkge1xuICAgICAgICAgIHJldHVybjtcbiAgICAgICAgfVxuICAgICAgICBpZiAoaXNFcnIgfHwgKDAsIF9jaGFubmVsLmlzRW5kKShyZXMpIHx8IHJlcyA9PT0gQ0hBTk5FTF9FTkQgfHwgcmVzID09PSBUQVNLX0NBTkNFTCkge1xuICAgICAgICAgIGNiLmNhbmNlbCgpO1xuICAgICAgICAgIGNiKHJlcywgaXNFcnIpO1xuICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgIHJlc3VsdHNbaWR4XSA9IHJlcztcbiAgICAgICAgICBjb21wbGV0ZWRDb3VudCsrO1xuICAgICAgICAgIGNoZWNrRWZmZWN0RW5kKCk7XG4gICAgICAgIH1cbiAgICAgIH07XG4gICAgICBjaENiQXRJZHguY2FuY2VsID0gX3V0aWxzLm5vb3A7XG4gICAgICByZXR1cm4gY2hDYkF0SWR4O1xuICAgIH0pO1xuXG4gICAgY2IuY2FuY2VsID0gZnVuY3Rpb24gKCkge1xuICAgICAgaWYgKCFjb21wbGV0ZWQpIHtcbiAgICAgICAgY29tcGxldGVkID0gdHJ1ZTtcbiAgICAgICAgY2hpbGRDYnMuZm9yRWFjaChmdW5jdGlvbiAoY2hDYikge1xuICAgICAgICAgIHJldHVybiBjaENiLmNhbmNlbCgpO1xuICAgICAgICB9KTtcbiAgICAgIH1cbiAgICB9O1xuXG4gICAgZWZmZWN0cy5mb3JFYWNoKGZ1bmN0aW9uIChlZmYsIGlkeCkge1xuICAgICAgcmV0dXJuIHJ1bkVmZmVjdChlZmYsIGVmZmVjdElkLCBpZHgsIGNoaWxkQ2JzW2lkeF0pO1xuICAgIH0pO1xuICB9XG5cbiAgZnVuY3Rpb24gcnVuUmFjZUVmZmVjdChlZmZlY3RzLCBlZmZlY3RJZCwgY2IpIHtcbiAgICB2YXIgY29tcGxldGVkID0gdm9pZCAwO1xuICAgIHZhciBrZXlzID0gT2JqZWN0LmtleXMoZWZmZWN0cyk7XG4gICAgdmFyIGNoaWxkQ2JzID0ge307XG5cbiAgICBrZXlzLmZvckVhY2goZnVuY3Rpb24gKGtleSkge1xuICAgICAgdmFyIGNoQ2JBdEtleSA9IGZ1bmN0aW9uIGNoQ2JBdEtleShyZXMsIGlzRXJyKSB7XG4gICAgICAgIGlmIChjb21wbGV0ZWQpIHtcbiAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cblxuICAgICAgICBpZiAoaXNFcnIpIHtcbiAgICAgICAgICAvLyBSYWNlIEF1dG8gY2FuY2VsbGF0aW9uXG4gICAgICAgICAgY2IuY2FuY2VsKCk7XG4gICAgICAgICAgY2IocmVzLCB0cnVlKTtcbiAgICAgICAgfSBlbHNlIGlmICghKDAsIF9jaGFubmVsLmlzRW5kKShyZXMpICYmIHJlcyAhPT0gQ0hBTk5FTF9FTkQgJiYgcmVzICE9PSBUQVNLX0NBTkNFTCkge1xuICAgICAgICAgIGNiLmNhbmNlbCgpO1xuICAgICAgICAgIGNvbXBsZXRlZCA9IHRydWU7XG4gICAgICAgICAgY2IoX2RlZmluZVByb3BlcnR5KHt9LCBrZXksIHJlcykpO1xuICAgICAgICB9XG4gICAgICB9O1xuICAgICAgY2hDYkF0S2V5LmNhbmNlbCA9IF91dGlscy5ub29wO1xuICAgICAgY2hpbGRDYnNba2V5XSA9IGNoQ2JBdEtleTtcbiAgICB9KTtcblxuICAgIGNiLmNhbmNlbCA9IGZ1bmN0aW9uICgpIHtcbiAgICAgIC8vIHByZXZlbnRzIHVubmVjZXNzYXJ5IGNhbmNlbGxhdGlvblxuICAgICAgaWYgKCFjb21wbGV0ZWQpIHtcbiAgICAgICAgY29tcGxldGVkID0gdHJ1ZTtcbiAgICAgICAga2V5cy5mb3JFYWNoKGZ1bmN0aW9uIChrZXkpIHtcbiAgICAgICAgICByZXR1cm4gY2hpbGRDYnNba2V5XS5jYW5jZWwoKTtcbiAgICAgICAgfSk7XG4gICAgICB9XG4gICAgfTtcbiAgICBrZXlzLmZvckVhY2goZnVuY3Rpb24gKGtleSkge1xuICAgICAgaWYgKGNvbXBsZXRlZCkge1xuICAgICAgICByZXR1cm47XG4gICAgICB9XG4gICAgICBydW5FZmZlY3QoZWZmZWN0c1trZXldLCBlZmZlY3RJZCwga2V5LCBjaGlsZENic1trZXldKTtcbiAgICB9KTtcbiAgfVxuXG4gIGZ1bmN0aW9uIHJ1blNlbGVjdEVmZmVjdChfcmVmNywgY2IpIHtcbiAgICB2YXIgc2VsZWN0b3IgPSBfcmVmNy5zZWxlY3RvcjtcbiAgICB2YXIgYXJncyA9IF9yZWY3LmFyZ3M7XG5cbiAgICB0cnkge1xuICAgICAgdmFyIHN0YXRlID0gc2VsZWN0b3IuYXBwbHkodW5kZWZpbmVkLCBbZ2V0U3RhdGUoKV0uY29uY2F0KF90b0NvbnN1bWFibGVBcnJheShhcmdzKSkpO1xuICAgICAgY2Ioc3RhdGUpO1xuICAgIH0gY2F0Y2ggKGVycm9yKSB7XG4gICAgICBjYihlcnJvciwgdHJ1ZSk7XG4gICAgfVxuICB9XG5cbiAgZnVuY3Rpb24gcnVuQ2hhbm5lbEVmZmVjdChfcmVmOCwgY2IpIHtcbiAgICB2YXIgcGF0dGVybiA9IF9yZWY4LnBhdHRlcm47XG4gICAgdmFyIGJ1ZmZlciA9IF9yZWY4LmJ1ZmZlcjtcblxuICAgIHZhciBtYXRjaCA9IG1hdGNoZXIocGF0dGVybik7XG4gICAgbWF0Y2gucGF0dGVybiA9IHBhdHRlcm47XG4gICAgY2IoKDAsIF9jaGFubmVsLmV2ZW50Q2hhbm5lbCkoc3Vic2NyaWJlLCBidWZmZXIgfHwgX2J1ZmZlcnMuYnVmZmVycy5maXhlZCgpLCBtYXRjaCkpO1xuICB9XG5cbiAgZnVuY3Rpb24gcnVuQ2FuY2VsbGVkRWZmZWN0KGRhdGEsIGNiKSB7XG4gICAgY2IoISFtYWluVGFzay5pc0NhbmNlbGxlZCk7XG4gIH1cblxuICBmdW5jdGlvbiBydW5GbHVzaEVmZmVjdChjaGFubmVsLCBjYikge1xuICAgIGNoYW5uZWwuZmx1c2goY2IpO1xuICB9XG5cbiAgZnVuY3Rpb24gbmV3VGFzayhpZCwgbmFtZSwgaXRlcmF0b3IsIGNvbnQpIHtcbiAgICB2YXIgX2RvbmUsIF9yZWY5LCBfbXV0YXRvck1hcDtcblxuICAgIGl0ZXJhdG9yLl9kZWZlcnJlZEVuZCA9IG51bGw7XG4gICAgcmV0dXJuIF9yZWY5ID0ge30sIF9kZWZpbmVQcm9wZXJ0eShfcmVmOSwgX3V0aWxzLlRBU0ssIHRydWUpLCBfZGVmaW5lUHJvcGVydHkoX3JlZjksICdpZCcsIGlkKSwgX2RlZmluZVByb3BlcnR5KF9yZWY5LCAnbmFtZScsIG5hbWUpLCBfZG9uZSA9ICdkb25lJywgX211dGF0b3JNYXAgPSB7fSwgX211dGF0b3JNYXBbX2RvbmVdID0gX211dGF0b3JNYXBbX2RvbmVdIHx8IHt9LCBfbXV0YXRvck1hcFtfZG9uZV0uZ2V0ID0gZnVuY3Rpb24gKCkge1xuICAgICAgaWYgKGl0ZXJhdG9yLl9kZWZlcnJlZEVuZCkge1xuICAgICAgICByZXR1cm4gaXRlcmF0b3IuX2RlZmVycmVkRW5kLnByb21pc2U7XG4gICAgICB9IGVsc2Uge1xuICAgICAgICB2YXIgZGVmID0gKDAsIF91dGlscy5kZWZlcnJlZCkoKTtcbiAgICAgICAgaXRlcmF0b3IuX2RlZmVycmVkRW5kID0gZGVmO1xuICAgICAgICBpZiAoIWl0ZXJhdG9yLl9pc1J1bm5pbmcpIHtcbiAgICAgICAgICBpdGVyYXRvci5fZXJyb3IgPyBkZWYucmVqZWN0KGl0ZXJhdG9yLl9lcnJvcikgOiBkZWYucmVzb2x2ZShpdGVyYXRvci5fcmVzdWx0KTtcbiAgICAgICAgfVxuICAgICAgICByZXR1cm4gZGVmLnByb21pc2U7XG4gICAgICB9XG4gICAgfSwgX2RlZmluZVByb3BlcnR5KF9yZWY5LCAnY29udCcsIGNvbnQpLCBfZGVmaW5lUHJvcGVydHkoX3JlZjksICdqb2luZXJzJywgW10pLCBfZGVmaW5lUHJvcGVydHkoX3JlZjksICdjYW5jZWwnLCBjYW5jZWwpLCBfZGVmaW5lUHJvcGVydHkoX3JlZjksICdpc1J1bm5pbmcnLCBmdW5jdGlvbiBpc1J1bm5pbmcoKSB7XG4gICAgICByZXR1cm4gaXRlcmF0b3IuX2lzUnVubmluZztcbiAgICB9KSwgX2RlZmluZVByb3BlcnR5KF9yZWY5LCAnaXNDYW5jZWxsZWQnLCBmdW5jdGlvbiBpc0NhbmNlbGxlZCgpIHtcbiAgICAgIHJldHVybiBpdGVyYXRvci5faXNDYW5jZWxsZWQ7XG4gICAgfSksIF9kZWZpbmVQcm9wZXJ0eShfcmVmOSwgJ2lzQWJvcnRlZCcsIGZ1bmN0aW9uIGlzQWJvcnRlZCgpIHtcbiAgICAgIHJldHVybiBpdGVyYXRvci5faXNBYm9ydGVkO1xuICAgIH0pLCBfZGVmaW5lUHJvcGVydHkoX3JlZjksICdyZXN1bHQnLCBmdW5jdGlvbiByZXN1bHQoKSB7XG4gICAgICByZXR1cm4gaXRlcmF0b3IuX3Jlc3VsdDtcbiAgICB9KSwgX2RlZmluZVByb3BlcnR5KF9yZWY5LCAnZXJyb3InLCBmdW5jdGlvbiBlcnJvcigpIHtcbiAgICAgIHJldHVybiBpdGVyYXRvci5fZXJyb3I7XG4gICAgfSksIF9kZWZpbmVFbnVtZXJhYmxlUHJvcGVydGllcyhfcmVmOSwgX211dGF0b3JNYXApLCBfcmVmOTtcbiAgfVxufVxufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbid1c2Ugc3RyaWN0JztcblxuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsIFwiX19lc01vZHVsZVwiLCB7XG4gIHZhbHVlOiB0cnVlXG59KTtcbmV4cG9ydHMucnVuU2FnYSA9IHJ1blNhZ2E7XG5cbnZhciBfdXRpbHMgPSByZXF1aXJlKDE1Myk7XG5cbnZhciBfcHJvYyA9IHJlcXVpcmUoMTUwKTtcblxudmFyIF9wcm9jMiA9IF9pbnRlcm9wUmVxdWlyZURlZmF1bHQoX3Byb2MpO1xuXG5mdW5jdGlvbiBfaW50ZXJvcFJlcXVpcmVEZWZhdWx0KG9iaikgeyByZXR1cm4gb2JqICYmIG9iai5fX2VzTW9kdWxlID8gb2JqIDogeyBkZWZhdWx0OiBvYmogfTsgfVxuXG5mdW5jdGlvbiBydW5TYWdhKGl0ZXJhdG9yLCBfcmVmKSB7XG4gIHZhciBzdWJzY3JpYmUgPSBfcmVmLnN1YnNjcmliZTtcbiAgdmFyIGRpc3BhdGNoID0gX3JlZi5kaXNwYXRjaDtcbiAgdmFyIGdldFN0YXRlID0gX3JlZi5nZXRTdGF0ZTtcbiAgdmFyIHNhZ2FNb25pdG9yID0gX3JlZi5zYWdhTW9uaXRvcjtcbiAgdmFyIGxvZ2dlciA9IF9yZWYubG9nZ2VyO1xuXG5cbiAgKDAsIF91dGlscy5jaGVjaykoaXRlcmF0b3IsIF91dGlscy5pcy5pdGVyYXRvciwgXCJydW5TYWdhIG11c3QgYmUgY2FsbGVkIG9uIGFuIGl0ZXJhdG9yXCIpO1xuXG4gIHJldHVybiAoMCwgX3Byb2MyLmRlZmF1bHQpKGl0ZXJhdG9yLCBzdWJzY3JpYmUsIGRpc3BhdGNoLCBnZXRTdGF0ZSwgeyBzYWdhTW9uaXRvcjogc2FnYU1vbml0b3IsIGxvZ2dlcjogbG9nZ2VyIH0pO1xufVxufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbid1c2Ugc3RyaWN0JztcblxuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsIFwiX19lc01vZHVsZVwiLCB7XG4gIHZhbHVlOiB0cnVlXG59KTtcblxudmFyIF9zbGljZWRUb0FycmF5ID0gZnVuY3Rpb24gKCkgeyBmdW5jdGlvbiBzbGljZUl0ZXJhdG9yKGFyciwgaSkgeyB2YXIgX2FyciA9IFtdOyB2YXIgX24gPSB0cnVlOyB2YXIgX2QgPSBmYWxzZTsgdmFyIF9lID0gdW5kZWZpbmVkOyB0cnkgeyBmb3IgKHZhciBfaSA9IGFycltTeW1ib2wuaXRlcmF0b3JdKCksIF9zOyAhKF9uID0gKF9zID0gX2kubmV4dCgpKS5kb25lKTsgX24gPSB0cnVlKSB7IF9hcnIucHVzaChfcy52YWx1ZSk7IGlmIChpICYmIF9hcnIubGVuZ3RoID09PSBpKSBicmVhazsgfSB9IGNhdGNoIChlcnIpIHsgX2QgPSB0cnVlOyBfZSA9IGVycjsgfSBmaW5hbGx5IHsgdHJ5IHsgaWYgKCFfbiAmJiBfaVtcInJldHVyblwiXSkgX2lbXCJyZXR1cm5cIl0oKTsgfSBmaW5hbGx5IHsgaWYgKF9kKSB0aHJvdyBfZTsgfSB9IHJldHVybiBfYXJyOyB9IHJldHVybiBmdW5jdGlvbiAoYXJyLCBpKSB7IGlmIChBcnJheS5pc0FycmF5KGFycikpIHsgcmV0dXJuIGFycjsgfSBlbHNlIGlmIChTeW1ib2wuaXRlcmF0b3IgaW4gT2JqZWN0KGFycikpIHsgcmV0dXJuIHNsaWNlSXRlcmF0b3IoYXJyLCBpKTsgfSBlbHNlIHsgdGhyb3cgbmV3IFR5cGVFcnJvcihcIkludmFsaWQgYXR0ZW1wdCB0byBkZXN0cnVjdHVyZSBub24taXRlcmFibGUgaW5zdGFuY2VcIik7IH0gfTsgfSgpO1xuXG5leHBvcnRzLnRha2VFdmVyeSA9IHRha2VFdmVyeTtcbmV4cG9ydHMudGFrZUxhdGVzdCA9IHRha2VMYXRlc3Q7XG5leHBvcnRzLnRocm90dGxlID0gdGhyb3R0bGU7XG5cbnZhciBfY2hhbm5lbCA9IHJlcXVpcmUoMTQ3KTtcblxudmFyIF91dGlscyA9IHJlcXVpcmUoMTUzKTtcblxudmFyIF9pbyA9IHJlcXVpcmUoMTQ4KTtcblxudmFyIF9idWZmZXJzID0gcmVxdWlyZSgxNDYpO1xuXG52YXIgZG9uZSA9IHsgZG9uZTogdHJ1ZSwgdmFsdWU6IHVuZGVmaW5lZCB9O1xudmFyIHFFbmQgPSB7fTtcblxuZnVuY3Rpb24gZnNtSXRlcmF0b3IoZnNtLCBxMCkge1xuICB2YXIgbmFtZSA9IGFyZ3VtZW50cy5sZW5ndGggPD0gMiB8fCBhcmd1bWVudHNbMl0gPT09IHVuZGVmaW5lZCA/ICdpdGVyYXRvcicgOiBhcmd1bWVudHNbMl07XG5cbiAgdmFyIHVwZGF0ZVN0YXRlID0gdm9pZCAwLFxuICAgICAgcU5leHQgPSBxMDtcblxuICBmdW5jdGlvbiBuZXh0KGFyZywgZXJyb3IpIHtcbiAgICBpZiAocU5leHQgPT09IHFFbmQpIHtcbiAgICAgIHJldHVybiBkb25lO1xuICAgIH1cblxuICAgIGlmIChlcnJvcikge1xuICAgICAgcU5leHQgPSBxRW5kO1xuICAgICAgdGhyb3cgZXJyb3I7XG4gICAgfSBlbHNlIHtcbiAgICAgIHVwZGF0ZVN0YXRlICYmIHVwZGF0ZVN0YXRlKGFyZyk7XG5cbiAgICAgIHZhciBfZnNtJHFOZXh0ID0gZnNtW3FOZXh0XSgpO1xuXG4gICAgICB2YXIgX2ZzbSRxTmV4dDIgPSBfc2xpY2VkVG9BcnJheShfZnNtJHFOZXh0LCAzKTtcblxuICAgICAgdmFyIHEgPSBfZnNtJHFOZXh0MlswXTtcbiAgICAgIHZhciBvdXRwdXQgPSBfZnNtJHFOZXh0MlsxXTtcbiAgICAgIHZhciBfdXBkYXRlU3RhdGUgPSBfZnNtJHFOZXh0MlsyXTtcblxuICAgICAgcU5leHQgPSBxO1xuICAgICAgdXBkYXRlU3RhdGUgPSBfdXBkYXRlU3RhdGU7XG4gICAgICByZXR1cm4gcU5leHQgPT09IHFFbmQgPyBkb25lIDogb3V0cHV0O1xuICAgIH1cbiAgfVxuXG4gIHJldHVybiAoMCwgX3V0aWxzLm1ha2VJdGVyYXRvcikobmV4dCwgZnVuY3Rpb24gKGVycm9yKSB7XG4gICAgcmV0dXJuIG5leHQobnVsbCwgZXJyb3IpO1xuICB9LCBuYW1lLCB0cnVlKTtcbn1cblxuZnVuY3Rpb24gc2FmZU5hbWUocGF0dGVybikge1xuICBpZiAoQXJyYXkuaXNBcnJheShwYXR0ZXJuKSkge1xuICAgIHJldHVybiBTdHJpbmcocGF0dGVybi5tYXAoZnVuY3Rpb24gKGVudHJ5KSB7XG4gICAgICByZXR1cm4gU3RyaW5nKGVudHJ5KTtcbiAgICB9KSk7XG4gIH0gZWxzZSB7XG4gICAgcmV0dXJuIFN0cmluZyhwYXR0ZXJuKTtcbiAgfVxufVxuXG5mdW5jdGlvbiB0YWtlRXZlcnkocGF0dGVybiwgd29ya2VyKSB7XG4gIGZvciAodmFyIF9sZW4gPSBhcmd1bWVudHMubGVuZ3RoLCBhcmdzID0gQXJyYXkoX2xlbiA+IDIgPyBfbGVuIC0gMiA6IDApLCBfa2V5ID0gMjsgX2tleSA8IF9sZW47IF9rZXkrKykge1xuICAgIGFyZ3NbX2tleSAtIDJdID0gYXJndW1lbnRzW19rZXldO1xuICB9XG5cbiAgdmFyIHlUYWtlID0geyBkb25lOiBmYWxzZSwgdmFsdWU6ICgwLCBfaW8udGFrZSkocGF0dGVybikgfTtcbiAgdmFyIHlGb3JrID0gZnVuY3Rpb24geUZvcmsoYWMpIHtcbiAgICByZXR1cm4geyBkb25lOiBmYWxzZSwgdmFsdWU6IF9pby5mb3JrLmFwcGx5KHVuZGVmaW5lZCwgW3dvcmtlcl0uY29uY2F0KGFyZ3MsIFthY10pKSB9O1xuICB9O1xuXG4gIHZhciBhY3Rpb24gPSB2b2lkIDAsXG4gICAgICBzZXRBY3Rpb24gPSBmdW5jdGlvbiBzZXRBY3Rpb24oYWMpIHtcbiAgICByZXR1cm4gYWN0aW9uID0gYWM7XG4gIH07XG5cbiAgcmV0dXJuIGZzbUl0ZXJhdG9yKHtcbiAgICBxMTogZnVuY3Rpb24gcTEoKSB7XG4gICAgICByZXR1cm4gWydxMicsIHlUYWtlLCBzZXRBY3Rpb25dO1xuICAgIH0sXG4gICAgcTI6IGZ1bmN0aW9uIHEyKCkge1xuICAgICAgcmV0dXJuIGFjdGlvbiA9PT0gX2NoYW5uZWwuRU5EID8gW3FFbmRdIDogWydxMScsIHlGb3JrKGFjdGlvbildO1xuICAgIH1cbiAgfSwgJ3ExJywgJ3Rha2VFdmVyeSgnICsgc2FmZU5hbWUocGF0dGVybikgKyAnLCAnICsgd29ya2VyLm5hbWUgKyAnKScpO1xufVxuXG5mdW5jdGlvbiB0YWtlTGF0ZXN0KHBhdHRlcm4sIHdvcmtlcikge1xuICBmb3IgKHZhciBfbGVuMiA9IGFyZ3VtZW50cy5sZW5ndGgsIGFyZ3MgPSBBcnJheShfbGVuMiA+IDIgPyBfbGVuMiAtIDIgOiAwKSwgX2tleTIgPSAyOyBfa2V5MiA8IF9sZW4yOyBfa2V5MisrKSB7XG4gICAgYXJnc1tfa2V5MiAtIDJdID0gYXJndW1lbnRzW19rZXkyXTtcbiAgfVxuXG4gIHZhciB5VGFrZSA9IHsgZG9uZTogZmFsc2UsIHZhbHVlOiAoMCwgX2lvLnRha2UpKHBhdHRlcm4pIH07XG4gIHZhciB5Rm9yayA9IGZ1bmN0aW9uIHlGb3JrKGFjKSB7XG4gICAgcmV0dXJuIHsgZG9uZTogZmFsc2UsIHZhbHVlOiBfaW8uZm9yay5hcHBseSh1bmRlZmluZWQsIFt3b3JrZXJdLmNvbmNhdChhcmdzLCBbYWNdKSkgfTtcbiAgfTtcbiAgdmFyIHlDYW5jZWwgPSBmdW5jdGlvbiB5Q2FuY2VsKHRhc2spIHtcbiAgICByZXR1cm4geyBkb25lOiBmYWxzZSwgdmFsdWU6ICgwLCBfaW8uY2FuY2VsKSh0YXNrKSB9O1xuICB9O1xuXG4gIHZhciB0YXNrID0gdm9pZCAwLFxuICAgICAgYWN0aW9uID0gdm9pZCAwO1xuICB2YXIgc2V0VGFzayA9IGZ1bmN0aW9uIHNldFRhc2sodCkge1xuICAgIHJldHVybiB0YXNrID0gdDtcbiAgfTtcbiAgdmFyIHNldEFjdGlvbiA9IGZ1bmN0aW9uIHNldEFjdGlvbihhYykge1xuICAgIHJldHVybiBhY3Rpb24gPSBhYztcbiAgfTtcblxuICByZXR1cm4gZnNtSXRlcmF0b3Ioe1xuICAgIHExOiBmdW5jdGlvbiBxMSgpIHtcbiAgICAgIHJldHVybiBbJ3EyJywgeVRha2UsIHNldEFjdGlvbl07XG4gICAgfSxcbiAgICBxMjogZnVuY3Rpb24gcTIoKSB7XG4gICAgICByZXR1cm4gYWN0aW9uID09PSBfY2hhbm5lbC5FTkQgPyBbcUVuZF0gOiB0YXNrID8gWydxMycsIHlDYW5jZWwodGFzayldIDogWydxMScsIHlGb3JrKGFjdGlvbiksIHNldFRhc2tdO1xuICAgIH0sXG4gICAgcTM6IGZ1bmN0aW9uIHEzKCkge1xuICAgICAgcmV0dXJuIFsncTEnLCB5Rm9yayhhY3Rpb24pLCBzZXRUYXNrXTtcbiAgICB9XG4gIH0sICdxMScsICd0YWtlTGF0ZXN0KCcgKyBzYWZlTmFtZShwYXR0ZXJuKSArICcsICcgKyB3b3JrZXIubmFtZSArICcpJyk7XG59XG5cbmZ1bmN0aW9uIHRocm90dGxlKGRlbGF5TGVuZ3RoLCBwYXR0ZXJuLCB3b3JrZXIpIHtcbiAgZm9yICh2YXIgX2xlbjMgPSBhcmd1bWVudHMubGVuZ3RoLCBhcmdzID0gQXJyYXkoX2xlbjMgPiAzID8gX2xlbjMgLSAzIDogMCksIF9rZXkzID0gMzsgX2tleTMgPCBfbGVuMzsgX2tleTMrKykge1xuICAgIGFyZ3NbX2tleTMgLSAzXSA9IGFyZ3VtZW50c1tfa2V5M107XG4gIH1cblxuICB2YXIgYWN0aW9uID0gdm9pZCAwLFxuICAgICAgY2hhbm5lbCA9IHZvaWQgMDtcblxuICB2YXIgeUFjdGlvbkNoYW5uZWwgPSB7IGRvbmU6IGZhbHNlLCB2YWx1ZTogKDAsIF9pby5hY3Rpb25DaGFubmVsKShwYXR0ZXJuLCBfYnVmZmVycy5idWZmZXJzLnNsaWRpbmcoMSkpIH07XG4gIHZhciB5VGFrZSA9IGZ1bmN0aW9uIHlUYWtlKCkge1xuICAgIHJldHVybiB7IGRvbmU6IGZhbHNlLCB2YWx1ZTogKDAsIF9pby50YWtlKShjaGFubmVsLCBwYXR0ZXJuKSB9O1xuICB9O1xuICB2YXIgeUZvcmsgPSBmdW5jdGlvbiB5Rm9yayhhYykge1xuICAgIHJldHVybiB7IGRvbmU6IGZhbHNlLCB2YWx1ZTogX2lvLmZvcmsuYXBwbHkodW5kZWZpbmVkLCBbd29ya2VyXS5jb25jYXQoYXJncywgW2FjXSkpIH07XG4gIH07XG4gIHZhciB5RGVsYXkgPSB7IGRvbmU6IGZhbHNlLCB2YWx1ZTogKDAsIF9pby5jYWxsKShfdXRpbHMuZGVsYXksIGRlbGF5TGVuZ3RoKSB9O1xuXG4gIHZhciBzZXRBY3Rpb24gPSBmdW5jdGlvbiBzZXRBY3Rpb24oYWMpIHtcbiAgICByZXR1cm4gYWN0aW9uID0gYWM7XG4gIH07XG4gIHZhciBzZXRDaGFubmVsID0gZnVuY3Rpb24gc2V0Q2hhbm5lbChjaCkge1xuICAgIHJldHVybiBjaGFubmVsID0gY2g7XG4gIH07XG5cbiAgcmV0dXJuIGZzbUl0ZXJhdG9yKHtcbiAgICBxMTogZnVuY3Rpb24gcTEoKSB7XG4gICAgICByZXR1cm4gWydxMicsIHlBY3Rpb25DaGFubmVsLCBzZXRDaGFubmVsXTtcbiAgICB9LFxuICAgIHEyOiBmdW5jdGlvbiBxMigpIHtcbiAgICAgIHJldHVybiBbJ3EzJywgeVRha2UoKSwgc2V0QWN0aW9uXTtcbiAgICB9LFxuICAgIHEzOiBmdW5jdGlvbiBxMygpIHtcbiAgICAgIHJldHVybiBhY3Rpb24gPT09IF9jaGFubmVsLkVORCA/IFtxRW5kXSA6IFsncTQnLCB5Rm9yayhhY3Rpb24pXTtcbiAgICB9LFxuICAgIHE0OiBmdW5jdGlvbiBxNCgpIHtcbiAgICAgIHJldHVybiBbJ3EyJywgeURlbGF5XTtcbiAgICB9XG4gIH0sICdxMScsICd0aHJvdHRsZSgnICsgc2FmZU5hbWUocGF0dGVybikgKyAnLCAnICsgd29ya2VyLm5hbWUgKyAnKScpO1xufVxufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbid1c2Ugc3RyaWN0JztcblxuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsIFwiX19lc01vZHVsZVwiLCB7XG4gIHZhbHVlOiB0cnVlXG59KTtcblxudmFyIF9leHRlbmRzID0gT2JqZWN0LmFzc2lnbiB8fCBmdW5jdGlvbiAodGFyZ2V0KSB7IGZvciAodmFyIGkgPSAxOyBpIDwgYXJndW1lbnRzLmxlbmd0aDsgaSsrKSB7IHZhciBzb3VyY2UgPSBhcmd1bWVudHNbaV07IGZvciAodmFyIGtleSBpbiBzb3VyY2UpIHsgaWYgKE9iamVjdC5wcm90b3R5cGUuaGFzT3duUHJvcGVydHkuY2FsbChzb3VyY2UsIGtleSkpIHsgdGFyZ2V0W2tleV0gPSBzb3VyY2Vba2V5XTsgfSB9IH0gcmV0dXJuIHRhcmdldDsgfTtcblxudmFyIF90eXBlb2YgPSB0eXBlb2YgU3ltYm9sID09PSBcImZ1bmN0aW9uXCIgJiYgdHlwZW9mIFN5bWJvbC5pdGVyYXRvciA9PT0gXCJzeW1ib2xcIiA/IGZ1bmN0aW9uIChvYmopIHsgcmV0dXJuIHR5cGVvZiBvYmo7IH0gOiBmdW5jdGlvbiAob2JqKSB7IHJldHVybiBvYmogJiYgdHlwZW9mIFN5bWJvbCA9PT0gXCJmdW5jdGlvblwiICYmIG9iai5jb25zdHJ1Y3RvciA9PT0gU3ltYm9sID8gXCJzeW1ib2xcIiA6IHR5cGVvZiBvYmo7IH07XG5cbmV4cG9ydHMuY2hlY2sgPSBjaGVjaztcbmV4cG9ydHMucmVtb3ZlID0gcmVtb3ZlO1xuZXhwb3J0cy5kZWZlcnJlZCA9IGRlZmVycmVkO1xuZXhwb3J0cy5hcnJheU9mRGVmZmVyZWQgPSBhcnJheU9mRGVmZmVyZWQ7XG5leHBvcnRzLmRlbGF5ID0gZGVsYXk7XG5leHBvcnRzLmNyZWF0ZU1vY2tUYXNrID0gY3JlYXRlTW9ja1Rhc2s7XG5leHBvcnRzLmF1dG9JbmMgPSBhdXRvSW5jO1xuZXhwb3J0cy5tYWtlSXRlcmF0b3IgPSBtYWtlSXRlcmF0b3I7XG5leHBvcnRzLmxvZyA9IGxvZztcblxuZnVuY3Rpb24gX2RlZmluZVByb3BlcnR5KG9iaiwga2V5LCB2YWx1ZSkgeyBpZiAoa2V5IGluIG9iaikgeyBPYmplY3QuZGVmaW5lUHJvcGVydHkob2JqLCBrZXksIHsgdmFsdWU6IHZhbHVlLCBlbnVtZXJhYmxlOiB0cnVlLCBjb25maWd1cmFibGU6IHRydWUsIHdyaXRhYmxlOiB0cnVlIH0pOyB9IGVsc2UgeyBvYmpba2V5XSA9IHZhbHVlOyB9IHJldHVybiBvYmo7IH1cblxudmFyIHN5bSA9IGV4cG9ydHMuc3ltID0gZnVuY3Rpb24gc3ltKGlkKSB7XG4gIHJldHVybiAnQEByZWR1eC1zYWdhLycgKyBpZDtcbn07XG52YXIgVEFTSyA9IGV4cG9ydHMuVEFTSyA9IHN5bSgnVEFTSycpO1xudmFyIEhFTFBFUiA9IGV4cG9ydHMuSEVMUEVSID0gc3ltKCdIRUxQRVInKTtcbnZhciBNQVRDSCA9IGV4cG9ydHMuTUFUQ0ggPSBzeW0oJ01BVENIJyk7XG52YXIgQ0FOQ0VMID0gZXhwb3J0cy5DQU5DRUwgPSBzeW0oJ2NhbmNlbFByb21pc2UnKTtcbnZhciBrb25zdCA9IGV4cG9ydHMua29uc3QgPSBmdW5jdGlvbiBrb25zdCh2KSB7XG4gIHJldHVybiBmdW5jdGlvbiAoKSB7XG4gICAgcmV0dXJuIHY7XG4gIH07XG59O1xudmFyIGtUcnVlID0gZXhwb3J0cy5rVHJ1ZSA9IGtvbnN0KHRydWUpO1xudmFyIGtGYWxzZSA9IGV4cG9ydHMua0ZhbHNlID0ga29uc3QoZmFsc2UpO1xudmFyIG5vb3AgPSBleHBvcnRzLm5vb3AgPSBmdW5jdGlvbiBub29wKCkge307XG52YXIgaWRlbnQgPSBleHBvcnRzLmlkZW50ID0gZnVuY3Rpb24gaWRlbnQodikge1xuICByZXR1cm4gdjtcbn07XG5cbmZ1bmN0aW9uIGNoZWNrKHZhbHVlLCBwcmVkaWNhdGUsIGVycm9yKSB7XG4gIGlmICghcHJlZGljYXRlKHZhbHVlKSkge1xuICAgIGxvZygnZXJyb3InLCAndW5jYXVnaHQgYXQgY2hlY2snLCBlcnJvcik7XG4gICAgdGhyb3cgbmV3IEVycm9yKGVycm9yKTtcbiAgfVxufVxuXG52YXIgaXMgPSBleHBvcnRzLmlzID0ge1xuICB1bmRlZjogZnVuY3Rpb24gdW5kZWYodikge1xuICAgIHJldHVybiB2ID09PSBudWxsIHx8IHYgPT09IHVuZGVmaW5lZDtcbiAgfSxcbiAgbm90VW5kZWY6IGZ1bmN0aW9uIG5vdFVuZGVmKHYpIHtcbiAgICByZXR1cm4gdiAhPT0gbnVsbCAmJiB2ICE9PSB1bmRlZmluZWQ7XG4gIH0sXG4gIGZ1bmM6IGZ1bmN0aW9uIGZ1bmMoZikge1xuICAgIHJldHVybiB0eXBlb2YgZiA9PT0gJ2Z1bmN0aW9uJztcbiAgfSxcbiAgbnVtYmVyOiBmdW5jdGlvbiBudW1iZXIobikge1xuICAgIHJldHVybiB0eXBlb2YgbiA9PT0gJ251bWJlcic7XG4gIH0sXG4gIGFycmF5OiBBcnJheS5pc0FycmF5LFxuICBwcm9taXNlOiBmdW5jdGlvbiBwcm9taXNlKHApIHtcbiAgICByZXR1cm4gcCAmJiBpcy5mdW5jKHAudGhlbik7XG4gIH0sXG4gIGl0ZXJhdG9yOiBmdW5jdGlvbiBpdGVyYXRvcihpdCkge1xuICAgIHJldHVybiBpdCAmJiBpcy5mdW5jKGl0Lm5leHQpICYmIGlzLmZ1bmMoaXQudGhyb3cpO1xuICB9LFxuICB0YXNrOiBmdW5jdGlvbiB0YXNrKHQpIHtcbiAgICByZXR1cm4gdCAmJiB0W1RBU0tdO1xuICB9LFxuICBvYnNlcnZhYmxlOiBmdW5jdGlvbiBvYnNlcnZhYmxlKG9iKSB7XG4gICAgcmV0dXJuIG9iICYmIGlzLmZ1bmMob2Iuc3Vic2NyaWJlKTtcbiAgfSxcbiAgYnVmZmVyOiBmdW5jdGlvbiBidWZmZXIoYnVmKSB7XG4gICAgcmV0dXJuIGJ1ZiAmJiBpcy5mdW5jKGJ1Zi5pc0VtcHR5KSAmJiBpcy5mdW5jKGJ1Zi50YWtlKSAmJiBpcy5mdW5jKGJ1Zi5wdXQpO1xuICB9LFxuICBwYXR0ZXJuOiBmdW5jdGlvbiBwYXR0ZXJuKHBhdCkge1xuICAgIHJldHVybiBwYXQgJiYgKHR5cGVvZiBwYXQgPT09ICdzdHJpbmcnIHx8ICh0eXBlb2YgcGF0ID09PSAndW5kZWZpbmVkJyA/ICd1bmRlZmluZWQnIDogX3R5cGVvZihwYXQpKSA9PT0gJ3N5bWJvbCcgfHwgaXMuZnVuYyhwYXQpIHx8IGlzLmFycmF5KHBhdCkpO1xuICB9LFxuICBjaGFubmVsOiBmdW5jdGlvbiBjaGFubmVsKGNoKSB7XG4gICAgcmV0dXJuIGNoICYmIGlzLmZ1bmMoY2gudGFrZSkgJiYgaXMuZnVuYyhjaC5jbG9zZSk7XG4gIH0sXG4gIGhlbHBlcjogZnVuY3Rpb24gaGVscGVyKGl0KSB7XG4gICAgcmV0dXJuIGl0ICYmIGl0W0hFTFBFUl07XG4gIH1cbn07XG5cbmZ1bmN0aW9uIHJlbW92ZShhcnJheSwgaXRlbSkge1xuICB2YXIgaW5kZXggPSBhcnJheS5pbmRleE9mKGl0ZW0pO1xuICBpZiAoaW5kZXggPj0gMCkge1xuICAgIGFycmF5LnNwbGljZShpbmRleCwgMSk7XG4gIH1cbn1cblxuZnVuY3Rpb24gZGVmZXJyZWQoKSB7XG4gIHZhciBwcm9wcyA9IGFyZ3VtZW50cy5sZW5ndGggPD0gMCB8fCBhcmd1bWVudHNbMF0gPT09IHVuZGVmaW5lZCA/IHt9IDogYXJndW1lbnRzWzBdO1xuXG4gIHZhciBkZWYgPSBfZXh0ZW5kcyh7fSwgcHJvcHMpO1xuICB2YXIgcHJvbWlzZSA9IG5ldyBQcm9taXNlKGZ1bmN0aW9uIChyZXNvbHZlLCByZWplY3QpIHtcbiAgICBkZWYucmVzb2x2ZSA9IHJlc29sdmU7XG4gICAgZGVmLnJlamVjdCA9IHJlamVjdDtcbiAgfSk7XG4gIGRlZi5wcm9taXNlID0gcHJvbWlzZTtcbiAgcmV0dXJuIGRlZjtcbn1cblxuZnVuY3Rpb24gYXJyYXlPZkRlZmZlcmVkKGxlbmd0aCkge1xuICB2YXIgYXJyID0gW107XG4gIGZvciAodmFyIGkgPSAwOyBpIDwgbGVuZ3RoOyBpKyspIHtcbiAgICBhcnIucHVzaChkZWZlcnJlZCgpKTtcbiAgfVxuICByZXR1cm4gYXJyO1xufVxuXG5mdW5jdGlvbiBkZWxheShtcykge1xuICB2YXIgdmFsID0gYXJndW1lbnRzLmxlbmd0aCA8PSAxIHx8IGFyZ3VtZW50c1sxXSA9PT0gdW5kZWZpbmVkID8gdHJ1ZSA6IGFyZ3VtZW50c1sxXTtcblxuICB2YXIgdGltZW91dElkID0gdm9pZCAwO1xuICB2YXIgcHJvbWlzZSA9IG5ldyBQcm9taXNlKGZ1bmN0aW9uIChyZXNvbHZlKSB7XG4gICAgdGltZW91dElkID0gc2V0VGltZW91dChmdW5jdGlvbiAoKSB7XG4gICAgICByZXR1cm4gcmVzb2x2ZSh2YWwpO1xuICAgIH0sIG1zKTtcbiAgfSk7XG5cbiAgcHJvbWlzZVtDQU5DRUxdID0gZnVuY3Rpb24gKCkge1xuICAgIHJldHVybiBjbGVhclRpbWVvdXQodGltZW91dElkKTtcbiAgfTtcblxuICByZXR1cm4gcHJvbWlzZTtcbn1cblxuZnVuY3Rpb24gY3JlYXRlTW9ja1Rhc2soKSB7XG4gIHZhciBfcmVmO1xuXG4gIHZhciBydW5uaW5nID0gdHJ1ZTtcbiAgdmFyIF9yZXN1bHQgPSB2b2lkIDAsXG4gICAgICBfZXJyb3IgPSB2b2lkIDA7XG5cbiAgcmV0dXJuIF9yZWYgPSB7fSwgX2RlZmluZVByb3BlcnR5KF9yZWYsIFRBU0ssIHRydWUpLCBfZGVmaW5lUHJvcGVydHkoX3JlZiwgJ2lzUnVubmluZycsIGZ1bmN0aW9uIGlzUnVubmluZygpIHtcbiAgICByZXR1cm4gcnVubmluZztcbiAgfSksIF9kZWZpbmVQcm9wZXJ0eShfcmVmLCAncmVzdWx0JywgZnVuY3Rpb24gcmVzdWx0KCkge1xuICAgIHJldHVybiBfcmVzdWx0O1xuICB9KSwgX2RlZmluZVByb3BlcnR5KF9yZWYsICdlcnJvcicsIGZ1bmN0aW9uIGVycm9yKCkge1xuICAgIHJldHVybiBfZXJyb3I7XG4gIH0pLCBfZGVmaW5lUHJvcGVydHkoX3JlZiwgJ3NldFJ1bm5pbmcnLCBmdW5jdGlvbiBzZXRSdW5uaW5nKGIpIHtcbiAgICByZXR1cm4gcnVubmluZyA9IGI7XG4gIH0pLCBfZGVmaW5lUHJvcGVydHkoX3JlZiwgJ3NldFJlc3VsdCcsIGZ1bmN0aW9uIHNldFJlc3VsdChyKSB7XG4gICAgcmV0dXJuIF9yZXN1bHQgPSByO1xuICB9KSwgX2RlZmluZVByb3BlcnR5KF9yZWYsICdzZXRFcnJvcicsIGZ1bmN0aW9uIHNldEVycm9yKGUpIHtcbiAgICByZXR1cm4gX2Vycm9yID0gZTtcbiAgfSksIF9yZWY7XG59XG5cbmZ1bmN0aW9uIGF1dG9JbmMoKSB7XG4gIHZhciBzZWVkID0gYXJndW1lbnRzLmxlbmd0aCA8PSAwIHx8IGFyZ3VtZW50c1swXSA9PT0gdW5kZWZpbmVkID8gMCA6IGFyZ3VtZW50c1swXTtcblxuICByZXR1cm4gZnVuY3Rpb24gKCkge1xuICAgIHJldHVybiArK3NlZWQ7XG4gIH07XG59XG5cbnZhciBrVGhyb3cgPSBmdW5jdGlvbiBrVGhyb3coZXJyKSB7XG4gIHRocm93IGVycjtcbn07XG52YXIga1JldHVybiA9IGZ1bmN0aW9uIGtSZXR1cm4odmFsdWUpIHtcbiAgcmV0dXJuIHsgdmFsdWU6IHZhbHVlLCBkb25lOiB0cnVlIH07XG59O1xuZnVuY3Rpb24gbWFrZUl0ZXJhdG9yKG5leHQpIHtcbiAgdmFyIHRocm8gPSBhcmd1bWVudHMubGVuZ3RoIDw9IDEgfHwgYXJndW1lbnRzWzFdID09PSB1bmRlZmluZWQgPyBrVGhyb3cgOiBhcmd1bWVudHNbMV07XG4gIHZhciBuYW1lID0gYXJndW1lbnRzLmxlbmd0aCA8PSAyIHx8IGFyZ3VtZW50c1syXSA9PT0gdW5kZWZpbmVkID8gJycgOiBhcmd1bWVudHNbMl07XG4gIHZhciBpc0hlbHBlciA9IGFyZ3VtZW50c1szXTtcblxuICB2YXIgaXRlcmF0b3IgPSB7IG5hbWU6IG5hbWUsIG5leHQ6IG5leHQsIHRocm93OiB0aHJvLCByZXR1cm46IGtSZXR1cm4gfTtcblxuICBpZiAoaXNIZWxwZXIpIHtcbiAgICBpdGVyYXRvcltIRUxQRVJdID0gdHJ1ZTtcbiAgfVxuICBpZiAodHlwZW9mIFN5bWJvbCAhPT0gJ3VuZGVmaW5lZCcpIHtcbiAgICBpdGVyYXRvcltTeW1ib2wuaXRlcmF0b3JdID0gZnVuY3Rpb24gKCkge1xuICAgICAgcmV0dXJuIGl0ZXJhdG9yO1xuICAgIH07XG4gIH1cbiAgcmV0dXJuIGl0ZXJhdG9yO1xufVxuXG4vKipcbiAgUHJpbnQgZXJyb3IgaW4gYSB1c2VmdWwgd2F5IHdoZXRoZXIgaW4gYSBicm93c2VyIGVudmlyb25tZW50XG4gICh3aXRoIGV4cGFuZGFibGUgZXJyb3Igc3RhY2sgdHJhY2VzKSwgb3IgaW4gYSBub2RlLmpzIGVudmlyb25tZW50XG4gICh0ZXh0LW9ubHkgbG9nIG91dHB1dClcbiAqKi9cbmZ1bmN0aW9uIGxvZyhsZXZlbCwgbWVzc2FnZSwgZXJyb3IpIHtcbiAgLyplc2xpbnQtZGlzYWJsZSBuby1jb25zb2xlKi9cbiAgaWYgKHR5cGVvZiB3aW5kb3cgPT09ICd1bmRlZmluZWQnKSB7XG4gICAgY29uc29sZS5sb2coJ3JlZHV4LXNhZ2EgJyArIGxldmVsICsgJzogJyArIG1lc3NhZ2UgKyAnXFxuJyArIChlcnJvciAmJiBlcnJvci5zdGFjayB8fCBlcnJvcikpO1xuICB9IGVsc2Uge1xuICAgIGNvbnNvbGVbbGV2ZWxdKG1lc3NhZ2UsIGVycm9yKTtcbiAgfVxufVxuXG52YXIgaW50ZXJuYWxFcnIgPSBleHBvcnRzLmludGVybmFsRXJyID0gZnVuY3Rpb24gaW50ZXJuYWxFcnIoZXJyKSB7XG4gIHJldHVybiBuZXcgRXJyb3IoJ1xcbiAgcmVkdXgtc2FnYTogRXJyb3IgY2hlY2tpbmcgaG9va3MgZGV0ZWN0ZWQgYW4gaW5jb25zaXN0ZW50IHN0YXRlLiBUaGlzIGlzIGxpa2VseSBhIGJ1Z1xcbiAgaW4gcmVkdXgtc2FnYSBjb2RlIGFuZCBub3QgeW91cnMuIFRoYW5rcyBmb3IgcmVwb3J0aW5nIHRoaXMgaW4gdGhlIHByb2plY3RcXCdzIGdpdGh1YiByZXBvLlxcbiAgRXJyb3I6ICcgKyBlcnIgKyAnXFxuJyk7XG59O1xufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbid1c2Ugc3RyaWN0JztcblxuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsIFwiX19lc01vZHVsZVwiLCB7XG4gIHZhbHVlOiB0cnVlXG59KTtcblxudmFyIF91dGlscyA9IHJlcXVpcmUoMTUzKTtcblxuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsICdUQVNLJywge1xuICBlbnVtZXJhYmxlOiB0cnVlLFxuICBnZXQ6IGZ1bmN0aW9uIGdldCgpIHtcbiAgICByZXR1cm4gX3V0aWxzLlRBU0s7XG4gIH1cbn0pO1xuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsICdub29wJywge1xuICBlbnVtZXJhYmxlOiB0cnVlLFxuICBnZXQ6IGZ1bmN0aW9uIGdldCgpIHtcbiAgICByZXR1cm4gX3V0aWxzLm5vb3A7XG4gIH1cbn0pO1xuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsICdpcycsIHtcbiAgZW51bWVyYWJsZTogdHJ1ZSxcbiAgZ2V0OiBmdW5jdGlvbiBnZXQoKSB7XG4gICAgcmV0dXJuIF91dGlscy5pcztcbiAgfVxufSk7XG5PYmplY3QuZGVmaW5lUHJvcGVydHkoZXhwb3J0cywgJ2RlZmVycmVkJywge1xuICBlbnVtZXJhYmxlOiB0cnVlLFxuICBnZXQ6IGZ1bmN0aW9uIGdldCgpIHtcbiAgICByZXR1cm4gX3V0aWxzLmRlZmVycmVkO1xuICB9XG59KTtcbk9iamVjdC5kZWZpbmVQcm9wZXJ0eShleHBvcnRzLCAnYXJyYXlPZkRlZmZlcmVkJywge1xuICBlbnVtZXJhYmxlOiB0cnVlLFxuICBnZXQ6IGZ1bmN0aW9uIGdldCgpIHtcbiAgICByZXR1cm4gX3V0aWxzLmFycmF5T2ZEZWZmZXJlZDtcbiAgfVxufSk7XG5PYmplY3QuZGVmaW5lUHJvcGVydHkoZXhwb3J0cywgJ2NyZWF0ZU1vY2tUYXNrJywge1xuICBlbnVtZXJhYmxlOiB0cnVlLFxuICBnZXQ6IGZ1bmN0aW9uIGdldCgpIHtcbiAgICByZXR1cm4gX3V0aWxzLmNyZWF0ZU1vY2tUYXNrO1xuICB9XG59KTtcblxudmFyIF9pbyA9IHJlcXVpcmUoMTQ4KTtcblxuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsICdhc0VmZmVjdCcsIHtcbiAgZW51bWVyYWJsZTogdHJ1ZSxcbiAgZ2V0OiBmdW5jdGlvbiBnZXQoKSB7XG4gICAgcmV0dXJuIF9pby5hc0VmZmVjdDtcbiAgfVxufSk7XG59KTsiLCJyZXF1aXJlKCcvcm9vdC9hcHAvbm9kZV9tb2R1bGVzL2FzeW5jLWRlZmluZS9saWIvYXN5bmNEZWZpbmUuanMnKShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbi8vIFRoaXMgbWV0aG9kIG9mIG9idGFpbmluZyBhIHJlZmVyZW5jZSB0byB0aGUgZ2xvYmFsIG9iamVjdCBuZWVkcyB0byBiZVxuLy8ga2VwdCBpZGVudGljYWwgdG8gdGhlIHdheSBpdCBpcyBvYnRhaW5lZCBpbiBydW50aW1lLmpzXG52YXIgZyA9XG4gIHR5cGVvZiBnbG9iYWwgPT09IFwib2JqZWN0XCIgPyBnbG9iYWwgOlxuICB0eXBlb2Ygd2luZG93ID09PSBcIm9iamVjdFwiID8gd2luZG93IDpcbiAgdHlwZW9mIHNlbGYgPT09IFwib2JqZWN0XCIgPyBzZWxmIDogdGhpcztcblxuLy8gVXNlIGBnZXRPd25Qcm9wZXJ0eU5hbWVzYCBiZWNhdXNlIG5vdCBhbGwgYnJvd3NlcnMgc3VwcG9ydCBjYWxsaW5nXG4vLyBgaGFzT3duUHJvcGVydHlgIG9uIHRoZSBnbG9iYWwgYHNlbGZgIG9iamVjdCBpbiBhIHdvcmtlci4gU2VlICMxODMuXG52YXIgaGFkUnVudGltZSA9IGcucmVnZW5lcmF0b3JSdW50aW1lICYmXG4gIE9iamVjdC5nZXRPd25Qcm9wZXJ0eU5hbWVzKGcpLmluZGV4T2YoXCJyZWdlbmVyYXRvclJ1bnRpbWVcIikgPj0gMDtcblxuLy8gU2F2ZSB0aGUgb2xkIHJlZ2VuZXJhdG9yUnVudGltZSBpbiBjYXNlIGl0IG5lZWRzIHRvIGJlIHJlc3RvcmVkIGxhdGVyLlxudmFyIG9sZFJ1bnRpbWUgPSBoYWRSdW50aW1lICYmIGcucmVnZW5lcmF0b3JSdW50aW1lO1xuXG4vLyBGb3JjZSByZWV2YWx1dGF0aW9uIG9mIHJ1bnRpbWUuanMuXG5nLnJlZ2VuZXJhdG9yUnVudGltZSA9IHVuZGVmaW5lZDtcblxubW9kdWxlLmV4cG9ydHMgPSByZXF1aXJlKFwiLi9ydW50aW1lXCIpO1xuXG5pZiAoaGFkUnVudGltZSkge1xuICAvLyBSZXN0b3JlIHRoZSBvcmlnaW5hbCBydW50aW1lLlxuICBnLnJlZ2VuZXJhdG9yUnVudGltZSA9IG9sZFJ1bnRpbWU7XG59IGVsc2Uge1xuICAvLyBSZW1vdmUgdGhlIGdsb2JhbCBwcm9wZXJ0eSBhZGRlZCBieSBydW50aW1lLmpzLlxuICB0cnkge1xuICAgIGRlbGV0ZSBnLnJlZ2VuZXJhdG9yUnVudGltZTtcbiAgfSBjYXRjaChlKSB7XG4gICAgZy5yZWdlbmVyYXRvclJ1bnRpbWUgPSB1bmRlZmluZWQ7XG4gIH1cbn1cblxufSk7IiwicmVxdWlyZSgnL3Jvb3QvYXBwL25vZGVfbW9kdWxlcy9hc3luYy1kZWZpbmUvbGliL2FzeW5jRGVmaW5lLmpzJykoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4vKipcbiAqIENvcHlyaWdodCAoYykgMjAxNCwgRmFjZWJvb2ssIEluYy5cbiAqIEFsbCByaWdodHMgcmVzZXJ2ZWQuXG4gKlxuICogVGhpcyBzb3VyY2UgY29kZSBpcyBsaWNlbnNlZCB1bmRlciB0aGUgQlNELXN0eWxlIGxpY2Vuc2UgZm91bmQgaW4gdGhlXG4gKiBodHRwczovL3Jhdy5naXRodWIuY29tL2ZhY2Vib29rL3JlZ2VuZXJhdG9yL21hc3Rlci9MSUNFTlNFIGZpbGUuIEFuXG4gKiBhZGRpdGlvbmFsIGdyYW50IG9mIHBhdGVudCByaWdodHMgY2FuIGJlIGZvdW5kIGluIHRoZSBQQVRFTlRTIGZpbGUgaW5cbiAqIHRoZSBzYW1lIGRpcmVjdG9yeS5cbiAqL1xuXG4hKGZ1bmN0aW9uKGdsb2JhbCkge1xuICBcInVzZSBzdHJpY3RcIjtcblxuICB2YXIgT3AgPSBPYmplY3QucHJvdG90eXBlO1xuICB2YXIgaGFzT3duID0gT3AuaGFzT3duUHJvcGVydHk7XG4gIHZhciB1bmRlZmluZWQ7IC8vIE1vcmUgY29tcHJlc3NpYmxlIHRoYW4gdm9pZCAwLlxuICB2YXIgJFN5bWJvbCA9IHR5cGVvZiBTeW1ib2wgPT09IFwiZnVuY3Rpb25cIiA/IFN5bWJvbCA6IHt9O1xuICB2YXIgaXRlcmF0b3JTeW1ib2wgPSAkU3ltYm9sLml0ZXJhdG9yIHx8IFwiQEBpdGVyYXRvclwiO1xuICB2YXIgYXN5bmNJdGVyYXRvclN5bWJvbCA9ICRTeW1ib2wuYXN5bmNJdGVyYXRvciB8fCBcIkBAYXN5bmNJdGVyYXRvclwiO1xuICB2YXIgdG9TdHJpbmdUYWdTeW1ib2wgPSAkU3ltYm9sLnRvU3RyaW5nVGFnIHx8IFwiQEB0b1N0cmluZ1RhZ1wiO1xuXG4gIHZhciBpbk1vZHVsZSA9IHR5cGVvZiBtb2R1bGUgPT09IFwib2JqZWN0XCI7XG4gIHZhciBydW50aW1lID0gZ2xvYmFsLnJlZ2VuZXJhdG9yUnVudGltZTtcbiAgaWYgKHJ1bnRpbWUpIHtcbiAgICBpZiAoaW5Nb2R1bGUpIHtcbiAgICAgIC8vIElmIHJlZ2VuZXJhdG9yUnVudGltZSBpcyBkZWZpbmVkIGdsb2JhbGx5IGFuZCB3ZSdyZSBpbiBhIG1vZHVsZSxcbiAgICAgIC8vIG1ha2UgdGhlIGV4cG9ydHMgb2JqZWN0IGlkZW50aWNhbCB0byByZWdlbmVyYXRvclJ1bnRpbWUuXG4gICAgICBtb2R1bGUuZXhwb3J0cyA9IHJ1bnRpbWU7XG4gICAgfVxuICAgIC8vIERvbid0IGJvdGhlciBldmFsdWF0aW5nIHRoZSByZXN0IG9mIHRoaXMgZmlsZSBpZiB0aGUgcnVudGltZSB3YXNcbiAgICAvLyBhbHJlYWR5IGRlZmluZWQgZ2xvYmFsbHkuXG4gICAgcmV0dXJuO1xuICB9XG5cbiAgLy8gRGVmaW5lIHRoZSBydW50aW1lIGdsb2JhbGx5IChhcyBleHBlY3RlZCBieSBnZW5lcmF0ZWQgY29kZSkgYXMgZWl0aGVyXG4gIC8vIG1vZHVsZS5leHBvcnRzIChpZiB3ZSdyZSBpbiBhIG1vZHVsZSkgb3IgYSBuZXcsIGVtcHR5IG9iamVjdC5cbiAgcnVudGltZSA9IGdsb2JhbC5yZWdlbmVyYXRvclJ1bnRpbWUgPSBpbk1vZHVsZSA/IG1vZHVsZS5leHBvcnRzIDoge307XG5cbiAgZnVuY3Rpb24gd3JhcChpbm5lckZuLCBvdXRlckZuLCBzZWxmLCB0cnlMb2NzTGlzdCkge1xuICAgIC8vIElmIG91dGVyRm4gcHJvdmlkZWQgYW5kIG91dGVyRm4ucHJvdG90eXBlIGlzIGEgR2VuZXJhdG9yLCB0aGVuIG91dGVyRm4ucHJvdG90eXBlIGluc3RhbmNlb2YgR2VuZXJhdG9yLlxuICAgIHZhciBwcm90b0dlbmVyYXRvciA9IG91dGVyRm4gJiYgb3V0ZXJGbi5wcm90b3R5cGUgaW5zdGFuY2VvZiBHZW5lcmF0b3IgPyBvdXRlckZuIDogR2VuZXJhdG9yO1xuICAgIHZhciBnZW5lcmF0b3IgPSBPYmplY3QuY3JlYXRlKHByb3RvR2VuZXJhdG9yLnByb3RvdHlwZSk7XG4gICAgdmFyIGNvbnRleHQgPSBuZXcgQ29udGV4dCh0cnlMb2NzTGlzdCB8fCBbXSk7XG5cbiAgICAvLyBUaGUgLl9pbnZva2UgbWV0aG9kIHVuaWZpZXMgdGhlIGltcGxlbWVudGF0aW9ucyBvZiB0aGUgLm5leHQsXG4gICAgLy8gLnRocm93LCBhbmQgLnJldHVybiBtZXRob2RzLlxuICAgIGdlbmVyYXRvci5faW52b2tlID0gbWFrZUludm9rZU1ldGhvZChpbm5lckZuLCBzZWxmLCBjb250ZXh0KTtcblxuICAgIHJldHVybiBnZW5lcmF0b3I7XG4gIH1cbiAgcnVudGltZS53cmFwID0gd3JhcDtcblxuICAvLyBUcnkvY2F0Y2ggaGVscGVyIHRvIG1pbmltaXplIGRlb3B0aW1pemF0aW9ucy4gUmV0dXJucyBhIGNvbXBsZXRpb25cbiAgLy8gcmVjb3JkIGxpa2UgY29udGV4dC50cnlFbnRyaWVzW2ldLmNvbXBsZXRpb24uIFRoaXMgaW50ZXJmYWNlIGNvdWxkXG4gIC8vIGhhdmUgYmVlbiAoYW5kIHdhcyBwcmV2aW91c2x5KSBkZXNpZ25lZCB0byB0YWtlIGEgY2xvc3VyZSB0byBiZVxuICAvLyBpbnZva2VkIHdpdGhvdXQgYXJndW1lbnRzLCBidXQgaW4gYWxsIHRoZSBjYXNlcyB3ZSBjYXJlIGFib3V0IHdlXG4gIC8vIGFscmVhZHkgaGF2ZSBhbiBleGlzdGluZyBtZXRob2Qgd2Ugd2FudCB0byBjYWxsLCBzbyB0aGVyZSdzIG5vIG5lZWRcbiAgLy8gdG8gY3JlYXRlIGEgbmV3IGZ1bmN0aW9uIG9iamVjdC4gV2UgY2FuIGV2ZW4gZ2V0IGF3YXkgd2l0aCBhc3N1bWluZ1xuICAvLyB0aGUgbWV0aG9kIHRha2VzIGV4YWN0bHkgb25lIGFyZ3VtZW50LCBzaW5jZSB0aGF0IGhhcHBlbnMgdG8gYmUgdHJ1ZVxuICAvLyBpbiBldmVyeSBjYXNlLCBzbyB3ZSBkb24ndCBoYXZlIHRvIHRvdWNoIHRoZSBhcmd1bWVudHMgb2JqZWN0LiBUaGVcbiAgLy8gb25seSBhZGRpdGlvbmFsIGFsbG9jYXRpb24gcmVxdWlyZWQgaXMgdGhlIGNvbXBsZXRpb24gcmVjb3JkLCB3aGljaFxuICAvLyBoYXMgYSBzdGFibGUgc2hhcGUgYW5kIHNvIGhvcGVmdWxseSBzaG91bGQgYmUgY2hlYXAgdG8gYWxsb2NhdGUuXG4gIGZ1bmN0aW9uIHRyeUNhdGNoKGZuLCBvYmosIGFyZykge1xuICAgIHRyeSB7XG4gICAgICByZXR1cm4geyB0eXBlOiBcIm5vcm1hbFwiLCBhcmc6IGZuLmNhbGwob2JqLCBhcmcpIH07XG4gICAgfSBjYXRjaCAoZXJyKSB7XG4gICAgICByZXR1cm4geyB0eXBlOiBcInRocm93XCIsIGFyZzogZXJyIH07XG4gICAgfVxuICB9XG5cbiAgdmFyIEdlblN0YXRlU3VzcGVuZGVkU3RhcnQgPSBcInN1c3BlbmRlZFN0YXJ0XCI7XG4gIHZhciBHZW5TdGF0ZVN1c3BlbmRlZFlpZWxkID0gXCJzdXNwZW5kZWRZaWVsZFwiO1xuICB2YXIgR2VuU3RhdGVFeGVjdXRpbmcgPSBcImV4ZWN1dGluZ1wiO1xuICB2YXIgR2VuU3RhdGVDb21wbGV0ZWQgPSBcImNvbXBsZXRlZFwiO1xuXG4gIC8vIFJldHVybmluZyB0aGlzIG9iamVjdCBmcm9tIHRoZSBpbm5lckZuIGhhcyB0aGUgc2FtZSBlZmZlY3QgYXNcbiAgLy8gYnJlYWtpbmcgb3V0IG9mIHRoZSBkaXNwYXRjaCBzd2l0Y2ggc3RhdGVtZW50LlxuICB2YXIgQ29udGludWVTZW50aW5lbCA9IHt9O1xuXG4gIC8vIER1bW15IGNvbnN0cnVjdG9yIGZ1bmN0aW9ucyB0aGF0IHdlIHVzZSBhcyB0aGUgLmNvbnN0cnVjdG9yIGFuZFxuICAvLyAuY29uc3RydWN0b3IucHJvdG90eXBlIHByb3BlcnRpZXMgZm9yIGZ1bmN0aW9ucyB0aGF0IHJldHVybiBHZW5lcmF0b3JcbiAgLy8gb2JqZWN0cy4gRm9yIGZ1bGwgc3BlYyBjb21wbGlhbmNlLCB5b3UgbWF5IHdpc2ggdG8gY29uZmlndXJlIHlvdXJcbiAgLy8gbWluaWZpZXIgbm90IHRvIG1hbmdsZSB0aGUgbmFtZXMgb2YgdGhlc2UgdHdvIGZ1bmN0aW9ucy5cbiAgZnVuY3Rpb24gR2VuZXJhdG9yKCkge31cbiAgZnVuY3Rpb24gR2VuZXJhdG9yRnVuY3Rpb24oKSB7fVxuICBmdW5jdGlvbiBHZW5lcmF0b3JGdW5jdGlvblByb3RvdHlwZSgpIHt9XG5cbiAgLy8gVGhpcyBpcyBhIHBvbHlmaWxsIGZvciAlSXRlcmF0b3JQcm90b3R5cGUlIGZvciBlbnZpcm9ubWVudHMgdGhhdFxuICAvLyBkb24ndCBuYXRpdmVseSBzdXBwb3J0IGl0LlxuICB2YXIgSXRlcmF0b3JQcm90b3R5cGUgPSB7fTtcbiAgSXRlcmF0b3JQcm90b3R5cGVbaXRlcmF0b3JTeW1ib2xdID0gZnVuY3Rpb24gKCkge1xuICAgIHJldHVybiB0aGlzO1xuICB9O1xuXG4gIHZhciBnZXRQcm90byA9IE9iamVjdC5nZXRQcm90b3R5cGVPZjtcbiAgdmFyIE5hdGl2ZUl0ZXJhdG9yUHJvdG90eXBlID0gZ2V0UHJvdG8gJiYgZ2V0UHJvdG8oZ2V0UHJvdG8odmFsdWVzKFtdKSkpO1xuICBpZiAoTmF0aXZlSXRlcmF0b3JQcm90b3R5cGUgJiZcbiAgICAgIE5hdGl2ZUl0ZXJhdG9yUHJvdG90eXBlICE9PSBPcCAmJlxuICAgICAgaGFzT3duLmNhbGwoTmF0aXZlSXRlcmF0b3JQcm90b3R5cGUsIGl0ZXJhdG9yU3ltYm9sKSkge1xuICAgIC8vIFRoaXMgZW52aXJvbm1lbnQgaGFzIGEgbmF0aXZlICVJdGVyYXRvclByb3RvdHlwZSU7IHVzZSBpdCBpbnN0ZWFkXG4gICAgLy8gb2YgdGhlIHBvbHlmaWxsLlxuICAgIEl0ZXJhdG9yUHJvdG90eXBlID0gTmF0aXZlSXRlcmF0b3JQcm90b3R5cGU7XG4gIH1cblxuICB2YXIgR3AgPSBHZW5lcmF0b3JGdW5jdGlvblByb3RvdHlwZS5wcm90b3R5cGUgPVxuICAgIEdlbmVyYXRvci5wcm90b3R5cGUgPSBPYmplY3QuY3JlYXRlKEl0ZXJhdG9yUHJvdG90eXBlKTtcbiAgR2VuZXJhdG9yRnVuY3Rpb24ucHJvdG90eXBlID0gR3AuY29uc3RydWN0b3IgPSBHZW5lcmF0b3JGdW5jdGlvblByb3RvdHlwZTtcbiAgR2VuZXJhdG9yRnVuY3Rpb25Qcm90b3R5cGUuY29uc3RydWN0b3IgPSBHZW5lcmF0b3JGdW5jdGlvbjtcbiAgR2VuZXJhdG9yRnVuY3Rpb25Qcm90b3R5cGVbdG9TdHJpbmdUYWdTeW1ib2xdID1cbiAgICBHZW5lcmF0b3JGdW5jdGlvbi5kaXNwbGF5TmFtZSA9IFwiR2VuZXJhdG9yRnVuY3Rpb25cIjtcblxuICAvLyBIZWxwZXIgZm9yIGRlZmluaW5nIHRoZSAubmV4dCwgLnRocm93LCBhbmQgLnJldHVybiBtZXRob2RzIG9mIHRoZVxuICAvLyBJdGVyYXRvciBpbnRlcmZhY2UgaW4gdGVybXMgb2YgYSBzaW5nbGUgLl9pbnZva2UgbWV0aG9kLlxuICBmdW5jdGlvbiBkZWZpbmVJdGVyYXRvck1ldGhvZHMocHJvdG90eXBlKSB7XG4gICAgW1wibmV4dFwiLCBcInRocm93XCIsIFwicmV0dXJuXCJdLmZvckVhY2goZnVuY3Rpb24obWV0aG9kKSB7XG4gICAgICBwcm90b3R5cGVbbWV0aG9kXSA9IGZ1bmN0aW9uKGFyZykge1xuICAgICAgICByZXR1cm4gdGhpcy5faW52b2tlKG1ldGhvZCwgYXJnKTtcbiAgICAgIH07XG4gICAgfSk7XG4gIH1cblxuICBydW50aW1lLmlzR2VuZXJhdG9yRnVuY3Rpb24gPSBmdW5jdGlvbihnZW5GdW4pIHtcbiAgICB2YXIgY3RvciA9IHR5cGVvZiBnZW5GdW4gPT09IFwiZnVuY3Rpb25cIiAmJiBnZW5GdW4uY29uc3RydWN0b3I7XG4gICAgcmV0dXJuIGN0b3JcbiAgICAgID8gY3RvciA9PT0gR2VuZXJhdG9yRnVuY3Rpb24gfHxcbiAgICAgICAgLy8gRm9yIHRoZSBuYXRpdmUgR2VuZXJhdG9yRnVuY3Rpb24gY29uc3RydWN0b3IsIHRoZSBiZXN0IHdlIGNhblxuICAgICAgICAvLyBkbyBpcyB0byBjaGVjayBpdHMgLm5hbWUgcHJvcGVydHkuXG4gICAgICAgIChjdG9yLmRpc3BsYXlOYW1lIHx8IGN0b3IubmFtZSkgPT09IFwiR2VuZXJhdG9yRnVuY3Rpb25cIlxuICAgICAgOiBmYWxzZTtcbiAgfTtcblxuICBydW50aW1lLm1hcmsgPSBmdW5jdGlvbihnZW5GdW4pIHtcbiAgICBpZiAoT2JqZWN0LnNldFByb3RvdHlwZU9mKSB7XG4gICAgICBPYmplY3Quc2V0UHJvdG90eXBlT2YoZ2VuRnVuLCBHZW5lcmF0b3JGdW5jdGlvblByb3RvdHlwZSk7XG4gICAgfSBlbHNlIHtcbiAgICAgIGdlbkZ1bi5fX3Byb3RvX18gPSBHZW5lcmF0b3JGdW5jdGlvblByb3RvdHlwZTtcbiAgICAgIGlmICghKHRvU3RyaW5nVGFnU3ltYm9sIGluIGdlbkZ1bikpIHtcbiAgICAgICAgZ2VuRnVuW3RvU3RyaW5nVGFnU3ltYm9sXSA9IFwiR2VuZXJhdG9yRnVuY3Rpb25cIjtcbiAgICAgIH1cbiAgICB9XG4gICAgZ2VuRnVuLnByb3RvdHlwZSA9IE9iamVjdC5jcmVhdGUoR3ApO1xuICAgIHJldHVybiBnZW5GdW47XG4gIH07XG5cbiAgLy8gV2l0aGluIHRoZSBib2R5IG9mIGFueSBhc3luYyBmdW5jdGlvbiwgYGF3YWl0IHhgIGlzIHRyYW5zZm9ybWVkIHRvXG4gIC8vIGB5aWVsZCByZWdlbmVyYXRvclJ1bnRpbWUuYXdyYXAoeClgLCBzbyB0aGF0IHRoZSBydW50aW1lIGNhbiB0ZXN0XG4gIC8vIGBoYXNPd24uY2FsbCh2YWx1ZSwgXCJfX2F3YWl0XCIpYCB0byBkZXRlcm1pbmUgaWYgdGhlIHlpZWxkZWQgdmFsdWUgaXNcbiAgLy8gbWVhbnQgdG8gYmUgYXdhaXRlZC5cbiAgcnVudGltZS5hd3JhcCA9IGZ1bmN0aW9uKGFyZykge1xuICAgIHJldHVybiB7IF9fYXdhaXQ6IGFyZyB9O1xuICB9O1xuXG4gIGZ1bmN0aW9uIEFzeW5jSXRlcmF0b3IoZ2VuZXJhdG9yKSB7XG4gICAgZnVuY3Rpb24gaW52b2tlKG1ldGhvZCwgYXJnLCByZXNvbHZlLCByZWplY3QpIHtcbiAgICAgIHZhciByZWNvcmQgPSB0cnlDYXRjaChnZW5lcmF0b3JbbWV0aG9kXSwgZ2VuZXJhdG9yLCBhcmcpO1xuICAgICAgaWYgKHJlY29yZC50eXBlID09PSBcInRocm93XCIpIHtcbiAgICAgICAgcmVqZWN0KHJlY29yZC5hcmcpO1xuICAgICAgfSBlbHNlIHtcbiAgICAgICAgdmFyIHJlc3VsdCA9IHJlY29yZC5hcmc7XG4gICAgICAgIHZhciB2YWx1ZSA9IHJlc3VsdC52YWx1ZTtcbiAgICAgICAgaWYgKHZhbHVlICYmXG4gICAgICAgICAgICB0eXBlb2YgdmFsdWUgPT09IFwib2JqZWN0XCIgJiZcbiAgICAgICAgICAgIGhhc093bi5jYWxsKHZhbHVlLCBcIl9fYXdhaXRcIikpIHtcbiAgICAgICAgICByZXR1cm4gUHJvbWlzZS5yZXNvbHZlKHZhbHVlLl9fYXdhaXQpLnRoZW4oZnVuY3Rpb24odmFsdWUpIHtcbiAgICAgICAgICAgIGludm9rZShcIm5leHRcIiwgdmFsdWUsIHJlc29sdmUsIHJlamVjdCk7XG4gICAgICAgICAgfSwgZnVuY3Rpb24oZXJyKSB7XG4gICAgICAgICAgICBpbnZva2UoXCJ0aHJvd1wiLCBlcnIsIHJlc29sdmUsIHJlamVjdCk7XG4gICAgICAgICAgfSk7XG4gICAgICAgIH1cblxuICAgICAgICByZXR1cm4gUHJvbWlzZS5yZXNvbHZlKHZhbHVlKS50aGVuKGZ1bmN0aW9uKHVud3JhcHBlZCkge1xuICAgICAgICAgIC8vIFdoZW4gYSB5aWVsZGVkIFByb21pc2UgaXMgcmVzb2x2ZWQsIGl0cyBmaW5hbCB2YWx1ZSBiZWNvbWVzXG4gICAgICAgICAgLy8gdGhlIC52YWx1ZSBvZiB0aGUgUHJvbWlzZTx7dmFsdWUsZG9uZX0+IHJlc3VsdCBmb3IgdGhlXG4gICAgICAgICAgLy8gY3VycmVudCBpdGVyYXRpb24uIElmIHRoZSBQcm9taXNlIGlzIHJlamVjdGVkLCBob3dldmVyLCB0aGVcbiAgICAgICAgICAvLyByZXN1bHQgZm9yIHRoaXMgaXRlcmF0aW9uIHdpbGwgYmUgcmVqZWN0ZWQgd2l0aCB0aGUgc2FtZVxuICAgICAgICAgIC8vIHJlYXNvbi4gTm90ZSB0aGF0IHJlamVjdGlvbnMgb2YgeWllbGRlZCBQcm9taXNlcyBhcmUgbm90XG4gICAgICAgICAgLy8gdGhyb3duIGJhY2sgaW50byB0aGUgZ2VuZXJhdG9yIGZ1bmN0aW9uLCBhcyBpcyB0aGUgY2FzZVxuICAgICAgICAgIC8vIHdoZW4gYW4gYXdhaXRlZCBQcm9taXNlIGlzIHJlamVjdGVkLiBUaGlzIGRpZmZlcmVuY2UgaW5cbiAgICAgICAgICAvLyBiZWhhdmlvciBiZXR3ZWVuIHlpZWxkIGFuZCBhd2FpdCBpcyBpbXBvcnRhbnQsIGJlY2F1c2UgaXRcbiAgICAgICAgICAvLyBhbGxvd3MgdGhlIGNvbnN1bWVyIHRvIGRlY2lkZSB3aGF0IHRvIGRvIHdpdGggdGhlIHlpZWxkZWRcbiAgICAgICAgICAvLyByZWplY3Rpb24gKHN3YWxsb3cgaXQgYW5kIGNvbnRpbnVlLCBtYW51YWxseSAudGhyb3cgaXQgYmFja1xuICAgICAgICAgIC8vIGludG8gdGhlIGdlbmVyYXRvciwgYWJhbmRvbiBpdGVyYXRpb24sIHdoYXRldmVyKS4gV2l0aFxuICAgICAgICAgIC8vIGF3YWl0LCBieSBjb250cmFzdCwgdGhlcmUgaXMgbm8gb3Bwb3J0dW5pdHkgdG8gZXhhbWluZSB0aGVcbiAgICAgICAgICAvLyByZWplY3Rpb24gcmVhc29uIG91dHNpZGUgdGhlIGdlbmVyYXRvciBmdW5jdGlvbiwgc28gdGhlXG4gICAgICAgICAgLy8gb25seSBvcHRpb24gaXMgdG8gdGhyb3cgaXQgZnJvbSB0aGUgYXdhaXQgZXhwcmVzc2lvbiwgYW5kXG4gICAgICAgICAgLy8gbGV0IHRoZSBnZW5lcmF0b3IgZnVuY3Rpb24gaGFuZGxlIHRoZSBleGNlcHRpb24uXG4gICAgICAgICAgcmVzdWx0LnZhbHVlID0gdW53cmFwcGVkO1xuICAgICAgICAgIHJlc29sdmUocmVzdWx0KTtcbiAgICAgICAgfSwgcmVqZWN0KTtcbiAgICAgIH1cbiAgICB9XG5cbiAgICBpZiAodHlwZW9mIGdsb2JhbC5wcm9jZXNzID09PSBcIm9iamVjdFwiICYmIGdsb2JhbC5wcm9jZXNzLmRvbWFpbikge1xuICAgICAgaW52b2tlID0gZ2xvYmFsLnByb2Nlc3MuZG9tYWluLmJpbmQoaW52b2tlKTtcbiAgICB9XG5cbiAgICB2YXIgcHJldmlvdXNQcm9taXNlO1xuXG4gICAgZnVuY3Rpb24gZW5xdWV1ZShtZXRob2QsIGFyZykge1xuICAgICAgZnVuY3Rpb24gY2FsbEludm9rZVdpdGhNZXRob2RBbmRBcmcoKSB7XG4gICAgICAgIHJldHVybiBuZXcgUHJvbWlzZShmdW5jdGlvbihyZXNvbHZlLCByZWplY3QpIHtcbiAgICAgICAgICBpbnZva2UobWV0aG9kLCBhcmcsIHJlc29sdmUsIHJlamVjdCk7XG4gICAgICAgIH0pO1xuICAgICAgfVxuXG4gICAgICByZXR1cm4gcHJldmlvdXNQcm9taXNlID1cbiAgICAgICAgLy8gSWYgZW5xdWV1ZSBoYXMgYmVlbiBjYWxsZWQgYmVmb3JlLCB0aGVuIHdlIHdhbnQgdG8gd2FpdCB1bnRpbFxuICAgICAgICAvLyBhbGwgcHJldmlvdXMgUHJvbWlzZXMgaGF2ZSBiZWVuIHJlc29sdmVkIGJlZm9yZSBjYWxsaW5nIGludm9rZSxcbiAgICAgICAgLy8gc28gdGhhdCByZXN1bHRzIGFyZSBhbHdheXMgZGVsaXZlcmVkIGluIHRoZSBjb3JyZWN0IG9yZGVyLiBJZlxuICAgICAgICAvLyBlbnF1ZXVlIGhhcyBub3QgYmVlbiBjYWxsZWQgYmVmb3JlLCB0aGVuIGl0IGlzIGltcG9ydGFudCB0b1xuICAgICAgICAvLyBjYWxsIGludm9rZSBpbW1lZGlhdGVseSwgd2l0aG91dCB3YWl0aW5nIG9uIGEgY2FsbGJhY2sgdG8gZmlyZSxcbiAgICAgICAgLy8gc28gdGhhdCB0aGUgYXN5bmMgZ2VuZXJhdG9yIGZ1bmN0aW9uIGhhcyB0aGUgb3Bwb3J0dW5pdHkgdG8gZG9cbiAgICAgICAgLy8gYW55IG5lY2Vzc2FyeSBzZXR1cCBpbiBhIHByZWRpY3RhYmxlIHdheS4gVGhpcyBwcmVkaWN0YWJpbGl0eVxuICAgICAgICAvLyBpcyB3aHkgdGhlIFByb21pc2UgY29uc3RydWN0b3Igc3luY2hyb25vdXNseSBpbnZva2VzIGl0c1xuICAgICAgICAvLyBleGVjdXRvciBjYWxsYmFjaywgYW5kIHdoeSBhc3luYyBmdW5jdGlvbnMgc3luY2hyb25vdXNseVxuICAgICAgICAvLyBleGVjdXRlIGNvZGUgYmVmb3JlIHRoZSBmaXJzdCBhd2FpdC4gU2luY2Ugd2UgaW1wbGVtZW50IHNpbXBsZVxuICAgICAgICAvLyBhc3luYyBmdW5jdGlvbnMgaW4gdGVybXMgb2YgYXN5bmMgZ2VuZXJhdG9ycywgaXQgaXMgZXNwZWNpYWxseVxuICAgICAgICAvLyBpbXBvcnRhbnQgdG8gZ2V0IHRoaXMgcmlnaHQsIGV2ZW4gdGhvdWdoIGl0IHJlcXVpcmVzIGNhcmUuXG4gICAgICAgIHByZXZpb3VzUHJvbWlzZSA/IHByZXZpb3VzUHJvbWlzZS50aGVuKFxuICAgICAgICAgIGNhbGxJbnZva2VXaXRoTWV0aG9kQW5kQXJnLFxuICAgICAgICAgIC8vIEF2b2lkIHByb3BhZ2F0aW5nIGZhaWx1cmVzIHRvIFByb21pc2VzIHJldHVybmVkIGJ5IGxhdGVyXG4gICAgICAgICAgLy8gaW52b2NhdGlvbnMgb2YgdGhlIGl0ZXJhdG9yLlxuICAgICAgICAgIGNhbGxJbnZva2VXaXRoTWV0aG9kQW5kQXJnXG4gICAgICAgICkgOiBjYWxsSW52b2tlV2l0aE1ldGhvZEFuZEFyZygpO1xuICAgIH1cblxuICAgIC8vIERlZmluZSB0aGUgdW5pZmllZCBoZWxwZXIgbWV0aG9kIHRoYXQgaXMgdXNlZCB0byBpbXBsZW1lbnQgLm5leHQsXG4gICAgLy8gLnRocm93LCBhbmQgLnJldHVybiAoc2VlIGRlZmluZUl0ZXJhdG9yTWV0aG9kcykuXG4gICAgdGhpcy5faW52b2tlID0gZW5xdWV1ZTtcbiAgfVxuXG4gIGRlZmluZUl0ZXJhdG9yTWV0aG9kcyhBc3luY0l0ZXJhdG9yLnByb3RvdHlwZSk7XG4gIEFzeW5jSXRlcmF0b3IucHJvdG90eXBlW2FzeW5jSXRlcmF0b3JTeW1ib2xdID0gZnVuY3Rpb24gKCkge1xuICAgIHJldHVybiB0aGlzO1xuICB9O1xuICBydW50aW1lLkFzeW5jSXRlcmF0b3IgPSBBc3luY0l0ZXJhdG9yO1xuXG4gIC8vIE5vdGUgdGhhdCBzaW1wbGUgYXN5bmMgZnVuY3Rpb25zIGFyZSBpbXBsZW1lbnRlZCBvbiB0b3Agb2ZcbiAgLy8gQXN5bmNJdGVyYXRvciBvYmplY3RzOyB0aGV5IGp1c3QgcmV0dXJuIGEgUHJvbWlzZSBmb3IgdGhlIHZhbHVlIG9mXG4gIC8vIHRoZSBmaW5hbCByZXN1bHQgcHJvZHVjZWQgYnkgdGhlIGl0ZXJhdG9yLlxuICBydW50aW1lLmFzeW5jID0gZnVuY3Rpb24oaW5uZXJGbiwgb3V0ZXJGbiwgc2VsZiwgdHJ5TG9jc0xpc3QpIHtcbiAgICB2YXIgaXRlciA9IG5ldyBBc3luY0l0ZXJhdG9yKFxuICAgICAgd3JhcChpbm5lckZuLCBvdXRlckZuLCBzZWxmLCB0cnlMb2NzTGlzdClcbiAgICApO1xuXG4gICAgcmV0dXJuIHJ1bnRpbWUuaXNHZW5lcmF0b3JGdW5jdGlvbihvdXRlckZuKVxuICAgICAgPyBpdGVyIC8vIElmIG91dGVyRm4gaXMgYSBnZW5lcmF0b3IsIHJldHVybiB0aGUgZnVsbCBpdGVyYXRvci5cbiAgICAgIDogaXRlci5uZXh0KCkudGhlbihmdW5jdGlvbihyZXN1bHQpIHtcbiAgICAgICAgICByZXR1cm4gcmVzdWx0LmRvbmUgPyByZXN1bHQudmFsdWUgOiBpdGVyLm5leHQoKTtcbiAgICAgICAgfSk7XG4gIH07XG5cbiAgZnVuY3Rpb24gbWFrZUludm9rZU1ldGhvZChpbm5lckZuLCBzZWxmLCBjb250ZXh0KSB7XG4gICAgdmFyIHN0YXRlID0gR2VuU3RhdGVTdXNwZW5kZWRTdGFydDtcblxuICAgIHJldHVybiBmdW5jdGlvbiBpbnZva2UobWV0aG9kLCBhcmcpIHtcbiAgICAgIGlmIChzdGF0ZSA9PT0gR2VuU3RhdGVFeGVjdXRpbmcpIHtcbiAgICAgICAgdGhyb3cgbmV3IEVycm9yKFwiR2VuZXJhdG9yIGlzIGFscmVhZHkgcnVubmluZ1wiKTtcbiAgICAgIH1cblxuICAgICAgaWYgKHN0YXRlID09PSBHZW5TdGF0ZUNvbXBsZXRlZCkge1xuICAgICAgICBpZiAobWV0aG9kID09PSBcInRocm93XCIpIHtcbiAgICAgICAgICB0aHJvdyBhcmc7XG4gICAgICAgIH1cblxuICAgICAgICAvLyBCZSBmb3JnaXZpbmcsIHBlciAyNS4zLjMuMy4zIG9mIHRoZSBzcGVjOlxuICAgICAgICAvLyBodHRwczovL3Blb3BsZS5tb3ppbGxhLm9yZy9+am9yZW5kb3JmZi9lczYtZHJhZnQuaHRtbCNzZWMtZ2VuZXJhdG9ycmVzdW1lXG4gICAgICAgIHJldHVybiBkb25lUmVzdWx0KCk7XG4gICAgICB9XG5cbiAgICAgIGNvbnRleHQubWV0aG9kID0gbWV0aG9kO1xuICAgICAgY29udGV4dC5hcmcgPSBhcmc7XG5cbiAgICAgIHdoaWxlICh0cnVlKSB7XG4gICAgICAgIHZhciBkZWxlZ2F0ZSA9IGNvbnRleHQuZGVsZWdhdGU7XG4gICAgICAgIGlmIChkZWxlZ2F0ZSkge1xuICAgICAgICAgIHZhciBkZWxlZ2F0ZVJlc3VsdCA9IG1heWJlSW52b2tlRGVsZWdhdGUoZGVsZWdhdGUsIGNvbnRleHQpO1xuICAgICAgICAgIGlmIChkZWxlZ2F0ZVJlc3VsdCkge1xuICAgICAgICAgICAgaWYgKGRlbGVnYXRlUmVzdWx0ID09PSBDb250aW51ZVNlbnRpbmVsKSBjb250aW51ZTtcbiAgICAgICAgICAgIHJldHVybiBkZWxlZ2F0ZVJlc3VsdDtcbiAgICAgICAgICB9XG4gICAgICAgIH1cblxuICAgICAgICBpZiAoY29udGV4dC5tZXRob2QgPT09IFwibmV4dFwiKSB7XG4gICAgICAgICAgLy8gU2V0dGluZyBjb250ZXh0Ll9zZW50IGZvciBsZWdhY3kgc3VwcG9ydCBvZiBCYWJlbCdzXG4gICAgICAgICAgLy8gZnVuY3Rpb24uc2VudCBpbXBsZW1lbnRhdGlvbi5cbiAgICAgICAgICBjb250ZXh0LnNlbnQgPSBjb250ZXh0Ll9zZW50ID0gY29udGV4dC5hcmc7XG5cbiAgICAgICAgfSBlbHNlIGlmIChjb250ZXh0Lm1ldGhvZCA9PT0gXCJ0aHJvd1wiKSB7XG4gICAgICAgICAgaWYgKHN0YXRlID09PSBHZW5TdGF0ZVN1c3BlbmRlZFN0YXJ0KSB7XG4gICAgICAgICAgICBzdGF0ZSA9IEdlblN0YXRlQ29tcGxldGVkO1xuICAgICAgICAgICAgdGhyb3cgY29udGV4dC5hcmc7XG4gICAgICAgICAgfVxuXG4gICAgICAgICAgY29udGV4dC5kaXNwYXRjaEV4Y2VwdGlvbihjb250ZXh0LmFyZyk7XG5cbiAgICAgICAgfSBlbHNlIGlmIChjb250ZXh0Lm1ldGhvZCA9PT0gXCJyZXR1cm5cIikge1xuICAgICAgICAgIGNvbnRleHQuYWJydXB0KFwicmV0dXJuXCIsIGNvbnRleHQuYXJnKTtcbiAgICAgICAgfVxuXG4gICAgICAgIHN0YXRlID0gR2VuU3RhdGVFeGVjdXRpbmc7XG5cbiAgICAgICAgdmFyIHJlY29yZCA9IHRyeUNhdGNoKGlubmVyRm4sIHNlbGYsIGNvbnRleHQpO1xuICAgICAgICBpZiAocmVjb3JkLnR5cGUgPT09IFwibm9ybWFsXCIpIHtcbiAgICAgICAgICAvLyBJZiBhbiBleGNlcHRpb24gaXMgdGhyb3duIGZyb20gaW5uZXJGbiwgd2UgbGVhdmUgc3RhdGUgPT09XG4gICAgICAgICAgLy8gR2VuU3RhdGVFeGVjdXRpbmcgYW5kIGxvb3AgYmFjayBmb3IgYW5vdGhlciBpbnZvY2F0aW9uLlxuICAgICAgICAgIHN0YXRlID0gY29udGV4dC5kb25lXG4gICAgICAgICAgICA/IEdlblN0YXRlQ29tcGxldGVkXG4gICAgICAgICAgICA6IEdlblN0YXRlU3VzcGVuZGVkWWllbGQ7XG5cbiAgICAgICAgICBpZiAocmVjb3JkLmFyZyA9PT0gQ29udGludWVTZW50aW5lbCkge1xuICAgICAgICAgICAgY29udGludWU7XG4gICAgICAgICAgfVxuXG4gICAgICAgICAgcmV0dXJuIHtcbiAgICAgICAgICAgIHZhbHVlOiByZWNvcmQuYXJnLFxuICAgICAgICAgICAgZG9uZTogY29udGV4dC5kb25lXG4gICAgICAgICAgfTtcblxuICAgICAgICB9IGVsc2UgaWYgKHJlY29yZC50eXBlID09PSBcInRocm93XCIpIHtcbiAgICAgICAgICBzdGF0ZSA9IEdlblN0YXRlQ29tcGxldGVkO1xuICAgICAgICAgIC8vIERpc3BhdGNoIHRoZSBleGNlcHRpb24gYnkgbG9vcGluZyBiYWNrIGFyb3VuZCB0byB0aGVcbiAgICAgICAgICAvLyBjb250ZXh0LmRpc3BhdGNoRXhjZXB0aW9uKGNvbnRleHQuYXJnKSBjYWxsIGFib3ZlLlxuICAgICAgICAgIGNvbnRleHQubWV0aG9kID0gXCJ0aHJvd1wiO1xuICAgICAgICAgIGNvbnRleHQuYXJnID0gcmVjb3JkLmFyZztcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH07XG4gIH1cblxuICAvLyBDYWxsIGRlbGVnYXRlLml0ZXJhdG9yW2NvbnRleHQubWV0aG9kXShjb250ZXh0LmFyZykgYW5kIGhhbmRsZSB0aGVcbiAgLy8gcmVzdWx0LCBlaXRoZXIgYnkgcmV0dXJuaW5nIGEgeyB2YWx1ZSwgZG9uZSB9IHJlc3VsdCBmcm9tIHRoZVxuICAvLyBkZWxlZ2F0ZSBpdGVyYXRvciwgb3IgYnkgbW9kaWZ5aW5nIGNvbnRleHQubWV0aG9kIGFuZCBjb250ZXh0LmFyZyxcbiAgLy8gc2V0dGluZyBjb250ZXh0LmRlbGVnYXRlIHRvIG51bGwsIGFuZCByZXR1cm5pbmcgdGhlIENvbnRpbnVlU2VudGluZWwuXG4gIGZ1bmN0aW9uIG1heWJlSW52b2tlRGVsZWdhdGUoZGVsZWdhdGUsIGNvbnRleHQpIHtcbiAgICB2YXIgbWV0aG9kID0gZGVsZWdhdGUuaXRlcmF0b3JbY29udGV4dC5tZXRob2RdO1xuICAgIGlmIChtZXRob2QgPT09IHVuZGVmaW5lZCkge1xuICAgICAgLy8gQSAudGhyb3cgb3IgLnJldHVybiB3aGVuIHRoZSBkZWxlZ2F0ZSBpdGVyYXRvciBoYXMgbm8gLnRocm93XG4gICAgICAvLyBtZXRob2QgYWx3YXlzIHRlcm1pbmF0ZXMgdGhlIHlpZWxkKiBsb29wLlxuICAgICAgY29udGV4dC5kZWxlZ2F0ZSA9IG51bGw7XG5cbiAgICAgIGlmIChjb250ZXh0Lm1ldGhvZCA9PT0gXCJ0aHJvd1wiKSB7XG4gICAgICAgIGlmIChkZWxlZ2F0ZS5pdGVyYXRvci5yZXR1cm4pIHtcbiAgICAgICAgICAvLyBJZiB0aGUgZGVsZWdhdGUgaXRlcmF0b3IgaGFzIGEgcmV0dXJuIG1ldGhvZCwgZ2l2ZSBpdCBhXG4gICAgICAgICAgLy8gY2hhbmNlIHRvIGNsZWFuIHVwLlxuICAgICAgICAgIGNvbnRleHQubWV0aG9kID0gXCJyZXR1cm5cIjtcbiAgICAgICAgICBjb250ZXh0LmFyZyA9IHVuZGVmaW5lZDtcbiAgICAgICAgICBtYXliZUludm9rZURlbGVnYXRlKGRlbGVnYXRlLCBjb250ZXh0KTtcblxuICAgICAgICAgIGlmIChjb250ZXh0Lm1ldGhvZCA9PT0gXCJ0aHJvd1wiKSB7XG4gICAgICAgICAgICAvLyBJZiBtYXliZUludm9rZURlbGVnYXRlKGNvbnRleHQpIGNoYW5nZWQgY29udGV4dC5tZXRob2QgZnJvbVxuICAgICAgICAgICAgLy8gXCJyZXR1cm5cIiB0byBcInRocm93XCIsIGxldCB0aGF0IG92ZXJyaWRlIHRoZSBUeXBlRXJyb3IgYmVsb3cuXG4gICAgICAgICAgICByZXR1cm4gQ29udGludWVTZW50aW5lbDtcbiAgICAgICAgICB9XG4gICAgICAgIH1cblxuICAgICAgICBjb250ZXh0Lm1ldGhvZCA9IFwidGhyb3dcIjtcbiAgICAgICAgY29udGV4dC5hcmcgPSBuZXcgVHlwZUVycm9yKFxuICAgICAgICAgIFwiVGhlIGl0ZXJhdG9yIGRvZXMgbm90IHByb3ZpZGUgYSAndGhyb3cnIG1ldGhvZFwiKTtcbiAgICAgIH1cblxuICAgICAgcmV0dXJuIENvbnRpbnVlU2VudGluZWw7XG4gICAgfVxuXG4gICAgdmFyIHJlY29yZCA9IHRyeUNhdGNoKG1ldGhvZCwgZGVsZWdhdGUuaXRlcmF0b3IsIGNvbnRleHQuYXJnKTtcblxuICAgIGlmIChyZWNvcmQudHlwZSA9PT0gXCJ0aHJvd1wiKSB7XG4gICAgICBjb250ZXh0Lm1ldGhvZCA9IFwidGhyb3dcIjtcbiAgICAgIGNvbnRleHQuYXJnID0gcmVjb3JkLmFyZztcbiAgICAgIGNvbnRleHQuZGVsZWdhdGUgPSBudWxsO1xuICAgICAgcmV0dXJuIENvbnRpbnVlU2VudGluZWw7XG4gICAgfVxuXG4gICAgdmFyIGluZm8gPSByZWNvcmQuYXJnO1xuXG4gICAgaWYgKCEgaW5mbykge1xuICAgICAgY29udGV4dC5tZXRob2QgPSBcInRocm93XCI7XG4gICAgICBjb250ZXh0LmFyZyA9IG5ldyBUeXBlRXJyb3IoXCJpdGVyYXRvciByZXN1bHQgaXMgbm90IGFuIG9iamVjdFwiKTtcbiAgICAgIGNvbnRleHQuZGVsZWdhdGUgPSBudWxsO1xuICAgICAgcmV0dXJuIENvbnRpbnVlU2VudGluZWw7XG4gICAgfVxuXG4gICAgaWYgKGluZm8uZG9uZSkge1xuICAgICAgLy8gQXNzaWduIHRoZSByZXN1bHQgb2YgdGhlIGZpbmlzaGVkIGRlbGVnYXRlIHRvIHRoZSB0ZW1wb3JhcnlcbiAgICAgIC8vIHZhcmlhYmxlIHNwZWNpZmllZCBieSBkZWxlZ2F0ZS5yZXN1bHROYW1lIChzZWUgZGVsZWdhdGVZaWVsZCkuXG4gICAgICBjb250ZXh0W2RlbGVnYXRlLnJlc3VsdE5hbWVdID0gaW5mby52YWx1ZTtcblxuICAgICAgLy8gUmVzdW1lIGV4ZWN1dGlvbiBhdCB0aGUgZGVzaXJlZCBsb2NhdGlvbiAoc2VlIGRlbGVnYXRlWWllbGQpLlxuICAgICAgY29udGV4dC5uZXh0ID0gZGVsZWdhdGUubmV4dExvYztcblxuICAgICAgLy8gSWYgY29udGV4dC5tZXRob2Qgd2FzIFwidGhyb3dcIiBidXQgdGhlIGRlbGVnYXRlIGhhbmRsZWQgdGhlXG4gICAgICAvLyBleGNlcHRpb24sIGxldCB0aGUgb3V0ZXIgZ2VuZXJhdG9yIHByb2NlZWQgbm9ybWFsbHkuIElmXG4gICAgICAvLyBjb250ZXh0Lm1ldGhvZCB3YXMgXCJuZXh0XCIsIGZvcmdldCBjb250ZXh0LmFyZyBzaW5jZSBpdCBoYXMgYmVlblxuICAgICAgLy8gXCJjb25zdW1lZFwiIGJ5IHRoZSBkZWxlZ2F0ZSBpdGVyYXRvci4gSWYgY29udGV4dC5tZXRob2Qgd2FzXG4gICAgICAvLyBcInJldHVyblwiLCBhbGxvdyB0aGUgb3JpZ2luYWwgLnJldHVybiBjYWxsIHRvIGNvbnRpbnVlIGluIHRoZVxuICAgICAgLy8gb3V0ZXIgZ2VuZXJhdG9yLlxuICAgICAgaWYgKGNvbnRleHQubWV0aG9kICE9PSBcInJldHVyblwiKSB7XG4gICAgICAgIGNvbnRleHQubWV0aG9kID0gXCJuZXh0XCI7XG4gICAgICAgIGNvbnRleHQuYXJnID0gdW5kZWZpbmVkO1xuICAgICAgfVxuXG4gICAgfSBlbHNlIHtcbiAgICAgIC8vIFJlLXlpZWxkIHRoZSByZXN1bHQgcmV0dXJuZWQgYnkgdGhlIGRlbGVnYXRlIG1ldGhvZC5cbiAgICAgIHJldHVybiBpbmZvO1xuICAgIH1cblxuICAgIC8vIFRoZSBkZWxlZ2F0ZSBpdGVyYXRvciBpcyBmaW5pc2hlZCwgc28gZm9yZ2V0IGl0IGFuZCBjb250aW51ZSB3aXRoXG4gICAgLy8gdGhlIG91dGVyIGdlbmVyYXRvci5cbiAgICBjb250ZXh0LmRlbGVnYXRlID0gbnVsbDtcbiAgICByZXR1cm4gQ29udGludWVTZW50aW5lbDtcbiAgfVxuXG4gIC8vIERlZmluZSBHZW5lcmF0b3IucHJvdG90eXBlLntuZXh0LHRocm93LHJldHVybn0gaW4gdGVybXMgb2YgdGhlXG4gIC8vIHVuaWZpZWQgLl9pbnZva2UgaGVscGVyIG1ldGhvZC5cbiAgZGVmaW5lSXRlcmF0b3JNZXRob2RzKEdwKTtcblxuICBHcFt0b1N0cmluZ1RhZ1N5bWJvbF0gPSBcIkdlbmVyYXRvclwiO1xuXG4gIC8vIEEgR2VuZXJhdG9yIHNob3VsZCBhbHdheXMgcmV0dXJuIGl0c2VsZiBhcyB0aGUgaXRlcmF0b3Igb2JqZWN0IHdoZW4gdGhlXG4gIC8vIEBAaXRlcmF0b3IgZnVuY3Rpb24gaXMgY2FsbGVkIG9uIGl0LiBTb21lIGJyb3dzZXJzJyBpbXBsZW1lbnRhdGlvbnMgb2YgdGhlXG4gIC8vIGl0ZXJhdG9yIHByb3RvdHlwZSBjaGFpbiBpbmNvcnJlY3RseSBpbXBsZW1lbnQgdGhpcywgY2F1c2luZyB0aGUgR2VuZXJhdG9yXG4gIC8vIG9iamVjdCB0byBub3QgYmUgcmV0dXJuZWQgZnJvbSB0aGlzIGNhbGwuIFRoaXMgZW5zdXJlcyB0aGF0IGRvZXNuJ3QgaGFwcGVuLlxuICAvLyBTZWUgaHR0cHM6Ly9naXRodWIuY29tL2ZhY2Vib29rL3JlZ2VuZXJhdG9yL2lzc3Vlcy8yNzQgZm9yIG1vcmUgZGV0YWlscy5cbiAgR3BbaXRlcmF0b3JTeW1ib2xdID0gZnVuY3Rpb24oKSB7XG4gICAgcmV0dXJuIHRoaXM7XG4gIH07XG5cbiAgR3AudG9TdHJpbmcgPSBmdW5jdGlvbigpIHtcbiAgICByZXR1cm4gXCJbb2JqZWN0IEdlbmVyYXRvcl1cIjtcbiAgfTtcblxuICBmdW5jdGlvbiBwdXNoVHJ5RW50cnkobG9jcykge1xuICAgIHZhciBlbnRyeSA9IHsgdHJ5TG9jOiBsb2NzWzBdIH07XG5cbiAgICBpZiAoMSBpbiBsb2NzKSB7XG4gICAgICBlbnRyeS5jYXRjaExvYyA9IGxvY3NbMV07XG4gICAgfVxuXG4gICAgaWYgKDIgaW4gbG9jcykge1xuICAgICAgZW50cnkuZmluYWxseUxvYyA9IGxvY3NbMl07XG4gICAgICBlbnRyeS5hZnRlckxvYyA9IGxvY3NbM107XG4gICAgfVxuXG4gICAgdGhpcy50cnlFbnRyaWVzLnB1c2goZW50cnkpO1xuICB9XG5cbiAgZnVuY3Rpb24gcmVzZXRUcnlFbnRyeShlbnRyeSkge1xuICAgIHZhciByZWNvcmQgPSBlbnRyeS5jb21wbGV0aW9uIHx8IHt9O1xuICAgIHJlY29yZC50eXBlID0gXCJub3JtYWxcIjtcbiAgICBkZWxldGUgcmVjb3JkLmFyZztcbiAgICBlbnRyeS5jb21wbGV0aW9uID0gcmVjb3JkO1xuICB9XG5cbiAgZnVuY3Rpb24gQ29udGV4dCh0cnlMb2NzTGlzdCkge1xuICAgIC8vIFRoZSByb290IGVudHJ5IG9iamVjdCAoZWZmZWN0aXZlbHkgYSB0cnkgc3RhdGVtZW50IHdpdGhvdXQgYSBjYXRjaFxuICAgIC8vIG9yIGEgZmluYWxseSBibG9jaykgZ2l2ZXMgdXMgYSBwbGFjZSB0byBzdG9yZSB2YWx1ZXMgdGhyb3duIGZyb21cbiAgICAvLyBsb2NhdGlvbnMgd2hlcmUgdGhlcmUgaXMgbm8gZW5jbG9zaW5nIHRyeSBzdGF0ZW1lbnQuXG4gICAgdGhpcy50cnlFbnRyaWVzID0gW3sgdHJ5TG9jOiBcInJvb3RcIiB9XTtcbiAgICB0cnlMb2NzTGlzdC5mb3JFYWNoKHB1c2hUcnlFbnRyeSwgdGhpcyk7XG4gICAgdGhpcy5yZXNldCh0cnVlKTtcbiAgfVxuXG4gIHJ1bnRpbWUua2V5cyA9IGZ1bmN0aW9uKG9iamVjdCkge1xuICAgIHZhciBrZXlzID0gW107XG4gICAgZm9yICh2YXIga2V5IGluIG9iamVjdCkge1xuICAgICAga2V5cy5wdXNoKGtleSk7XG4gICAgfVxuICAgIGtleXMucmV2ZXJzZSgpO1xuXG4gICAgLy8gUmF0aGVyIHRoYW4gcmV0dXJuaW5nIGFuIG9iamVjdCB3aXRoIGEgbmV4dCBtZXRob2QsIHdlIGtlZXBcbiAgICAvLyB0aGluZ3Mgc2ltcGxlIGFuZCByZXR1cm4gdGhlIG5leHQgZnVuY3Rpb24gaXRzZWxmLlxuICAgIHJldHVybiBmdW5jdGlvbiBuZXh0KCkge1xuICAgICAgd2hpbGUgKGtleXMubGVuZ3RoKSB7XG4gICAgICAgIHZhciBrZXkgPSBrZXlzLnBvcCgpO1xuICAgICAgICBpZiAoa2V5IGluIG9iamVjdCkge1xuICAgICAgICAgIG5leHQudmFsdWUgPSBrZXk7XG4gICAgICAgICAgbmV4dC5kb25lID0gZmFsc2U7XG4gICAgICAgICAgcmV0dXJuIG5leHQ7XG4gICAgICAgIH1cbiAgICAgIH1cblxuICAgICAgLy8gVG8gYXZvaWQgY3JlYXRpbmcgYW4gYWRkaXRpb25hbCBvYmplY3QsIHdlIGp1c3QgaGFuZyB0aGUgLnZhbHVlXG4gICAgICAvLyBhbmQgLmRvbmUgcHJvcGVydGllcyBvZmYgdGhlIG5leHQgZnVuY3Rpb24gb2JqZWN0IGl0c2VsZi4gVGhpc1xuICAgICAgLy8gYWxzbyBlbnN1cmVzIHRoYXQgdGhlIG1pbmlmaWVyIHdpbGwgbm90IGFub255bWl6ZSB0aGUgZnVuY3Rpb24uXG4gICAgICBuZXh0LmRvbmUgPSB0cnVlO1xuICAgICAgcmV0dXJuIG5leHQ7XG4gICAgfTtcbiAgfTtcblxuICBmdW5jdGlvbiB2YWx1ZXMoaXRlcmFibGUpIHtcbiAgICBpZiAoaXRlcmFibGUpIHtcbiAgICAgIHZhciBpdGVyYXRvck1ldGhvZCA9IGl0ZXJhYmxlW2l0ZXJhdG9yU3ltYm9sXTtcbiAgICAgIGlmIChpdGVyYXRvck1ldGhvZCkge1xuICAgICAgICByZXR1cm4gaXRlcmF0b3JNZXRob2QuY2FsbChpdGVyYWJsZSk7XG4gICAgICB9XG5cbiAgICAgIGlmICh0eXBlb2YgaXRlcmFibGUubmV4dCA9PT0gXCJmdW5jdGlvblwiKSB7XG4gICAgICAgIHJldHVybiBpdGVyYWJsZTtcbiAgICAgIH1cblxuICAgICAgaWYgKCFpc05hTihpdGVyYWJsZS5sZW5ndGgpKSB7XG4gICAgICAgIHZhciBpID0gLTEsIG5leHQgPSBmdW5jdGlvbiBuZXh0KCkge1xuICAgICAgICAgIHdoaWxlICgrK2kgPCBpdGVyYWJsZS5sZW5ndGgpIHtcbiAgICAgICAgICAgIGlmIChoYXNPd24uY2FsbChpdGVyYWJsZSwgaSkpIHtcbiAgICAgICAgICAgICAgbmV4dC52YWx1ZSA9IGl0ZXJhYmxlW2ldO1xuICAgICAgICAgICAgICBuZXh0LmRvbmUgPSBmYWxzZTtcbiAgICAgICAgICAgICAgcmV0dXJuIG5leHQ7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgfVxuXG4gICAgICAgICAgbmV4dC52YWx1ZSA9IHVuZGVmaW5lZDtcbiAgICAgICAgICBuZXh0LmRvbmUgPSB0cnVlO1xuXG4gICAgICAgICAgcmV0dXJuIG5leHQ7XG4gICAgICAgIH07XG5cbiAgICAgICAgcmV0dXJuIG5leHQubmV4dCA9IG5leHQ7XG4gICAgICB9XG4gICAgfVxuXG4gICAgLy8gUmV0dXJuIGFuIGl0ZXJhdG9yIHdpdGggbm8gdmFsdWVzLlxuICAgIHJldHVybiB7IG5leHQ6IGRvbmVSZXN1bHQgfTtcbiAgfVxuICBydW50aW1lLnZhbHVlcyA9IHZhbHVlcztcblxuICBmdW5jdGlvbiBkb25lUmVzdWx0KCkge1xuICAgIHJldHVybiB7IHZhbHVlOiB1bmRlZmluZWQsIGRvbmU6IHRydWUgfTtcbiAgfVxuXG4gIENvbnRleHQucHJvdG90eXBlID0ge1xuICAgIGNvbnN0cnVjdG9yOiBDb250ZXh0LFxuXG4gICAgcmVzZXQ6IGZ1bmN0aW9uKHNraXBUZW1wUmVzZXQpIHtcbiAgICAgIHRoaXMucHJldiA9IDA7XG4gICAgICB0aGlzLm5leHQgPSAwO1xuICAgICAgLy8gUmVzZXR0aW5nIGNvbnRleHQuX3NlbnQgZm9yIGxlZ2FjeSBzdXBwb3J0IG9mIEJhYmVsJ3NcbiAgICAgIC8vIGZ1bmN0aW9uLnNlbnQgaW1wbGVtZW50YXRpb24uXG4gICAgICB0aGlzLnNlbnQgPSB0aGlzLl9zZW50ID0gdW5kZWZpbmVkO1xuICAgICAgdGhpcy5kb25lID0gZmFsc2U7XG4gICAgICB0aGlzLmRlbGVnYXRlID0gbnVsbDtcblxuICAgICAgdGhpcy5tZXRob2QgPSBcIm5leHRcIjtcbiAgICAgIHRoaXMuYXJnID0gdW5kZWZpbmVkO1xuXG4gICAgICB0aGlzLnRyeUVudHJpZXMuZm9yRWFjaChyZXNldFRyeUVudHJ5KTtcblxuICAgICAgaWYgKCFza2lwVGVtcFJlc2V0KSB7XG4gICAgICAgIGZvciAodmFyIG5hbWUgaW4gdGhpcykge1xuICAgICAgICAgIC8vIE5vdCBzdXJlIGFib3V0IHRoZSBvcHRpbWFsIG9yZGVyIG9mIHRoZXNlIGNvbmRpdGlvbnM6XG4gICAgICAgICAgaWYgKG5hbWUuY2hhckF0KDApID09PSBcInRcIiAmJlxuICAgICAgICAgICAgICBoYXNPd24uY2FsbCh0aGlzLCBuYW1lKSAmJlxuICAgICAgICAgICAgICAhaXNOYU4oK25hbWUuc2xpY2UoMSkpKSB7XG4gICAgICAgICAgICB0aGlzW25hbWVdID0gdW5kZWZpbmVkO1xuICAgICAgICAgIH1cbiAgICAgICAgfVxuICAgICAgfVxuICAgIH0sXG5cbiAgICBzdG9wOiBmdW5jdGlvbigpIHtcbiAgICAgIHRoaXMuZG9uZSA9IHRydWU7XG5cbiAgICAgIHZhciByb290RW50cnkgPSB0aGlzLnRyeUVudHJpZXNbMF07XG4gICAgICB2YXIgcm9vdFJlY29yZCA9IHJvb3RFbnRyeS5jb21wbGV0aW9uO1xuICAgICAgaWYgKHJvb3RSZWNvcmQudHlwZSA9PT0gXCJ0aHJvd1wiKSB7XG4gICAgICAgIHRocm93IHJvb3RSZWNvcmQuYXJnO1xuICAgICAgfVxuXG4gICAgICByZXR1cm4gdGhpcy5ydmFsO1xuICAgIH0sXG5cbiAgICBkaXNwYXRjaEV4Y2VwdGlvbjogZnVuY3Rpb24oZXhjZXB0aW9uKSB7XG4gICAgICBpZiAodGhpcy5kb25lKSB7XG4gICAgICAgIHRocm93IGV4Y2VwdGlvbjtcbiAgICAgIH1cblxuICAgICAgdmFyIGNvbnRleHQgPSB0aGlzO1xuICAgICAgZnVuY3Rpb24gaGFuZGxlKGxvYywgY2F1Z2h0KSB7XG4gICAgICAgIHJlY29yZC50eXBlID0gXCJ0aHJvd1wiO1xuICAgICAgICByZWNvcmQuYXJnID0gZXhjZXB0aW9uO1xuICAgICAgICBjb250ZXh0Lm5leHQgPSBsb2M7XG5cbiAgICAgICAgaWYgKGNhdWdodCkge1xuICAgICAgICAgIC8vIElmIHRoZSBkaXNwYXRjaGVkIGV4Y2VwdGlvbiB3YXMgY2F1Z2h0IGJ5IGEgY2F0Y2ggYmxvY2ssXG4gICAgICAgICAgLy8gdGhlbiBsZXQgdGhhdCBjYXRjaCBibG9jayBoYW5kbGUgdGhlIGV4Y2VwdGlvbiBub3JtYWxseS5cbiAgICAgICAgICBjb250ZXh0Lm1ldGhvZCA9IFwibmV4dFwiO1xuICAgICAgICAgIGNvbnRleHQuYXJnID0gdW5kZWZpbmVkO1xuICAgICAgICB9XG5cbiAgICAgICAgcmV0dXJuICEhIGNhdWdodDtcbiAgICAgIH1cblxuICAgICAgZm9yICh2YXIgaSA9IHRoaXMudHJ5RW50cmllcy5sZW5ndGggLSAxOyBpID49IDA7IC0taSkge1xuICAgICAgICB2YXIgZW50cnkgPSB0aGlzLnRyeUVudHJpZXNbaV07XG4gICAgICAgIHZhciByZWNvcmQgPSBlbnRyeS5jb21wbGV0aW9uO1xuXG4gICAgICAgIGlmIChlbnRyeS50cnlMb2MgPT09IFwicm9vdFwiKSB7XG4gICAgICAgICAgLy8gRXhjZXB0aW9uIHRocm93biBvdXRzaWRlIG9mIGFueSB0cnkgYmxvY2sgdGhhdCBjb3VsZCBoYW5kbGVcbiAgICAgICAgICAvLyBpdCwgc28gc2V0IHRoZSBjb21wbGV0aW9uIHZhbHVlIG9mIHRoZSBlbnRpcmUgZnVuY3Rpb24gdG9cbiAgICAgICAgICAvLyB0aHJvdyB0aGUgZXhjZXB0aW9uLlxuICAgICAgICAgIHJldHVybiBoYW5kbGUoXCJlbmRcIik7XG4gICAgICAgIH1cblxuICAgICAgICBpZiAoZW50cnkudHJ5TG9jIDw9IHRoaXMucHJldikge1xuICAgICAgICAgIHZhciBoYXNDYXRjaCA9IGhhc093bi5jYWxsKGVudHJ5LCBcImNhdGNoTG9jXCIpO1xuICAgICAgICAgIHZhciBoYXNGaW5hbGx5ID0gaGFzT3duLmNhbGwoZW50cnksIFwiZmluYWxseUxvY1wiKTtcblxuICAgICAgICAgIGlmIChoYXNDYXRjaCAmJiBoYXNGaW5hbGx5KSB7XG4gICAgICAgICAgICBpZiAodGhpcy5wcmV2IDwgZW50cnkuY2F0Y2hMb2MpIHtcbiAgICAgICAgICAgICAgcmV0dXJuIGhhbmRsZShlbnRyeS5jYXRjaExvYywgdHJ1ZSk7XG4gICAgICAgICAgICB9IGVsc2UgaWYgKHRoaXMucHJldiA8IGVudHJ5LmZpbmFsbHlMb2MpIHtcbiAgICAgICAgICAgICAgcmV0dXJuIGhhbmRsZShlbnRyeS5maW5hbGx5TG9jKTtcbiAgICAgICAgICAgIH1cblxuICAgICAgICAgIH0gZWxzZSBpZiAoaGFzQ2F0Y2gpIHtcbiAgICAgICAgICAgIGlmICh0aGlzLnByZXYgPCBlbnRyeS5jYXRjaExvYykge1xuICAgICAgICAgICAgICByZXR1cm4gaGFuZGxlKGVudHJ5LmNhdGNoTG9jLCB0cnVlKTtcbiAgICAgICAgICAgIH1cblxuICAgICAgICAgIH0gZWxzZSBpZiAoaGFzRmluYWxseSkge1xuICAgICAgICAgICAgaWYgKHRoaXMucHJldiA8IGVudHJ5LmZpbmFsbHlMb2MpIHtcbiAgICAgICAgICAgICAgcmV0dXJuIGhhbmRsZShlbnRyeS5maW5hbGx5TG9jKTtcbiAgICAgICAgICAgIH1cblxuICAgICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgICB0aHJvdyBuZXcgRXJyb3IoXCJ0cnkgc3RhdGVtZW50IHdpdGhvdXQgY2F0Y2ggb3IgZmluYWxseVwiKTtcbiAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9LFxuXG4gICAgYWJydXB0OiBmdW5jdGlvbih0eXBlLCBhcmcpIHtcbiAgICAgIGZvciAodmFyIGkgPSB0aGlzLnRyeUVudHJpZXMubGVuZ3RoIC0gMTsgaSA+PSAwOyAtLWkpIHtcbiAgICAgICAgdmFyIGVudHJ5ID0gdGhpcy50cnlFbnRyaWVzW2ldO1xuICAgICAgICBpZiAoZW50cnkudHJ5TG9jIDw9IHRoaXMucHJldiAmJlxuICAgICAgICAgICAgaGFzT3duLmNhbGwoZW50cnksIFwiZmluYWxseUxvY1wiKSAmJlxuICAgICAgICAgICAgdGhpcy5wcmV2IDwgZW50cnkuZmluYWxseUxvYykge1xuICAgICAgICAgIHZhciBmaW5hbGx5RW50cnkgPSBlbnRyeTtcbiAgICAgICAgICBicmVhaztcbiAgICAgICAgfVxuICAgICAgfVxuXG4gICAgICBpZiAoZmluYWxseUVudHJ5ICYmXG4gICAgICAgICAgKHR5cGUgPT09IFwiYnJlYWtcIiB8fFxuICAgICAgICAgICB0eXBlID09PSBcImNvbnRpbnVlXCIpICYmXG4gICAgICAgICAgZmluYWxseUVudHJ5LnRyeUxvYyA8PSBhcmcgJiZcbiAgICAgICAgICBhcmcgPD0gZmluYWxseUVudHJ5LmZpbmFsbHlMb2MpIHtcbiAgICAgICAgLy8gSWdub3JlIHRoZSBmaW5hbGx5IGVudHJ5IGlmIGNvbnRyb2wgaXMgbm90IGp1bXBpbmcgdG8gYVxuICAgICAgICAvLyBsb2NhdGlvbiBvdXRzaWRlIHRoZSB0cnkvY2F0Y2ggYmxvY2suXG4gICAgICAgIGZpbmFsbHlFbnRyeSA9IG51bGw7XG4gICAgICB9XG5cbiAgICAgIHZhciByZWNvcmQgPSBmaW5hbGx5RW50cnkgPyBmaW5hbGx5RW50cnkuY29tcGxldGlvbiA6IHt9O1xuICAgICAgcmVjb3JkLnR5cGUgPSB0eXBlO1xuICAgICAgcmVjb3JkLmFyZyA9IGFyZztcblxuICAgICAgaWYgKGZpbmFsbHlFbnRyeSkge1xuICAgICAgICB0aGlzLm1ldGhvZCA9IFwibmV4dFwiO1xuICAgICAgICB0aGlzLm5leHQgPSBmaW5hbGx5RW50cnkuZmluYWxseUxvYztcbiAgICAgICAgcmV0dXJuIENvbnRpbnVlU2VudGluZWw7XG4gICAgICB9XG5cbiAgICAgIHJldHVybiB0aGlzLmNvbXBsZXRlKHJlY29yZCk7XG4gICAgfSxcblxuICAgIGNvbXBsZXRlOiBmdW5jdGlvbihyZWNvcmQsIGFmdGVyTG9jKSB7XG4gICAgICBpZiAocmVjb3JkLnR5cGUgPT09IFwidGhyb3dcIikge1xuICAgICAgICB0aHJvdyByZWNvcmQuYXJnO1xuICAgICAgfVxuXG4gICAgICBpZiAocmVjb3JkLnR5cGUgPT09IFwiYnJlYWtcIiB8fFxuICAgICAgICAgIHJlY29yZC50eXBlID09PSBcImNvbnRpbnVlXCIpIHtcbiAgICAgICAgdGhpcy5uZXh0ID0gcmVjb3JkLmFyZztcbiAgICAgIH0gZWxzZSBpZiAocmVjb3JkLnR5cGUgPT09IFwicmV0dXJuXCIpIHtcbiAgICAgICAgdGhpcy5ydmFsID0gdGhpcy5hcmcgPSByZWNvcmQuYXJnO1xuICAgICAgICB0aGlzLm1ldGhvZCA9IFwicmV0dXJuXCI7XG4gICAgICAgIHRoaXMubmV4dCA9IFwiZW5kXCI7XG4gICAgICB9IGVsc2UgaWYgKHJlY29yZC50eXBlID09PSBcIm5vcm1hbFwiICYmIGFmdGVyTG9jKSB7XG4gICAgICAgIHRoaXMubmV4dCA9IGFmdGVyTG9jO1xuICAgICAgfVxuXG4gICAgICByZXR1cm4gQ29udGludWVTZW50aW5lbDtcbiAgICB9LFxuXG4gICAgZmluaXNoOiBmdW5jdGlvbihmaW5hbGx5TG9jKSB7XG4gICAgICBmb3IgKHZhciBpID0gdGhpcy50cnlFbnRyaWVzLmxlbmd0aCAtIDE7IGkgPj0gMDsgLS1pKSB7XG4gICAgICAgIHZhciBlbnRyeSA9IHRoaXMudHJ5RW50cmllc1tpXTtcbiAgICAgICAgaWYgKGVudHJ5LmZpbmFsbHlMb2MgPT09IGZpbmFsbHlMb2MpIHtcbiAgICAgICAgICB0aGlzLmNvbXBsZXRlKGVudHJ5LmNvbXBsZXRpb24sIGVudHJ5LmFmdGVyTG9jKTtcbiAgICAgICAgICByZXNldFRyeUVudHJ5KGVudHJ5KTtcbiAgICAgICAgICByZXR1cm4gQ29udGludWVTZW50aW5lbDtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH0sXG5cbiAgICBcImNhdGNoXCI6IGZ1bmN0aW9uKHRyeUxvYykge1xuICAgICAgZm9yICh2YXIgaSA9IHRoaXMudHJ5RW50cmllcy5sZW5ndGggLSAxOyBpID49IDA7IC0taSkge1xuICAgICAgICB2YXIgZW50cnkgPSB0aGlzLnRyeUVudHJpZXNbaV07XG4gICAgICAgIGlmIChlbnRyeS50cnlMb2MgPT09IHRyeUxvYykge1xuICAgICAgICAgIHZhciByZWNvcmQgPSBlbnRyeS5jb21wbGV0aW9uO1xuICAgICAgICAgIGlmIChyZWNvcmQudHlwZSA9PT0gXCJ0aHJvd1wiKSB7XG4gICAgICAgICAgICB2YXIgdGhyb3duID0gcmVjb3JkLmFyZztcbiAgICAgICAgICAgIHJlc2V0VHJ5RW50cnkoZW50cnkpO1xuICAgICAgICAgIH1cbiAgICAgICAgICByZXR1cm4gdGhyb3duO1xuICAgICAgICB9XG4gICAgICB9XG5cbiAgICAgIC8vIFRoZSBjb250ZXh0LmNhdGNoIG1ldGhvZCBtdXN0IG9ubHkgYmUgY2FsbGVkIHdpdGggYSBsb2NhdGlvblxuICAgICAgLy8gYXJndW1lbnQgdGhhdCBjb3JyZXNwb25kcyB0byBhIGtub3duIGNhdGNoIGJsb2NrLlxuICAgICAgdGhyb3cgbmV3IEVycm9yKFwiaWxsZWdhbCBjYXRjaCBhdHRlbXB0XCIpO1xuICAgIH0sXG5cbiAgICBkZWxlZ2F0ZVlpZWxkOiBmdW5jdGlvbihpdGVyYWJsZSwgcmVzdWx0TmFtZSwgbmV4dExvYykge1xuICAgICAgdGhpcy5kZWxlZ2F0ZSA9IHtcbiAgICAgICAgaXRlcmF0b3I6IHZhbHVlcyhpdGVyYWJsZSksXG4gICAgICAgIHJlc3VsdE5hbWU6IHJlc3VsdE5hbWUsXG4gICAgICAgIG5leHRMb2M6IG5leHRMb2NcbiAgICAgIH07XG5cbiAgICAgIGlmICh0aGlzLm1ldGhvZCA9PT0gXCJuZXh0XCIpIHtcbiAgICAgICAgLy8gRGVsaWJlcmF0ZWx5IGZvcmdldCB0aGUgbGFzdCBzZW50IHZhbHVlIHNvIHRoYXQgd2UgZG9uJ3RcbiAgICAgICAgLy8gYWNjaWRlbnRhbGx5IHBhc3MgaXQgb24gdG8gdGhlIGRlbGVnYXRlLlxuICAgICAgICB0aGlzLmFyZyA9IHVuZGVmaW5lZDtcbiAgICAgIH1cblxuICAgICAgcmV0dXJuIENvbnRpbnVlU2VudGluZWw7XG4gICAgfVxuICB9O1xufSkoXG4gIC8vIEFtb25nIHRoZSB2YXJpb3VzIHRyaWNrcyBmb3Igb2J0YWluaW5nIGEgcmVmZXJlbmNlIHRvIHRoZSBnbG9iYWxcbiAgLy8gb2JqZWN0LCB0aGlzIHNlZW1zIHRvIGJlIHRoZSBtb3N0IHJlbGlhYmxlIHRlY2huaXF1ZSB0aGF0IGRvZXMgbm90XG4gIC8vIHVzZSBpbmRpcmVjdCBldmFsICh3aGljaCB2aW9sYXRlcyBDb250ZW50IFNlY3VyaXR5IFBvbGljeSkuXG4gIHR5cGVvZiBnbG9iYWwgPT09IFwib2JqZWN0XCIgPyBnbG9iYWwgOlxuICB0eXBlb2Ygd2luZG93ID09PSBcIm9iamVjdFwiID8gd2luZG93IDpcbiAgdHlwZW9mIHNlbGYgPT09IFwib2JqZWN0XCIgPyBzZWxmIDogdGhpc1xuKTtcblxufSk7IiwicmVxdWlyZSg4KShbXCJyZWFjdC0xNS4zXCIsXCJyZWFjdGRvbS0xNS4zXCIsXCJyZWR1eC0zLjZcIixcInJlYWN0cmVkdXgtNC40XCJdLGZ1bmN0aW9uKF9fcmVhY3QsX19yZWFjdF9kb20sX19yZWR1eCxfX3JlYWN0X3JlZHV4KXtcbi8qIVxuICAqIFJlcXdlc3QhIEEgZ2VuZXJhbCBwdXJwb3NlIFhIUiBjb25uZWN0aW9uIG1hbmFnZXJcbiAgKiBsaWNlbnNlIE1JVCAoYykgRHVzdGluIERpYXogMjAxNVxuICAqIGh0dHBzOi8vZ2l0aHViLmNvbS9kZWQvcmVxd2VzdFxuICAqL1xuXG4hZnVuY3Rpb24gKG5hbWUsIGNvbnRleHQsIGRlZmluaXRpb24pIHtcbiAgaWYgKHR5cGVvZiBtb2R1bGUgIT0gJ3VuZGVmaW5lZCcgJiYgbW9kdWxlLmV4cG9ydHMpIG1vZHVsZS5leHBvcnRzID0gZGVmaW5pdGlvbigpXG4gIGVsc2UgaWYgKHR5cGVvZiBkZWZpbmUgPT0gJ2Z1bmN0aW9uJyAmJiBkZWZpbmUuYW1kKSBkZWZpbmUoZGVmaW5pdGlvbilcbiAgZWxzZSBjb250ZXh0W25hbWVdID0gZGVmaW5pdGlvbigpXG59KCdyZXF3ZXN0JywgdGhpcywgZnVuY3Rpb24gKCkge1xuXG4gIHZhciBjb250ZXh0ID0gdGhpc1xuXG4gIGlmICgnd2luZG93JyBpbiBjb250ZXh0KSB7XG4gICAgdmFyIGRvYyA9IGRvY3VtZW50XG4gICAgICAsIGJ5VGFnID0gJ2dldEVsZW1lbnRzQnlUYWdOYW1lJ1xuICAgICAgLCBoZWFkID0gZG9jW2J5VGFnXSgnaGVhZCcpWzBdXG4gIH0gZWxzZSB7XG4gICAgdmFyIFhIUjJcbiAgICB0cnkge1xuICAgICAgWEhSMiA9IHJlcXVpcmUoMzApXG4gICAgfSBjYXRjaCAoZXgpIHtcbiAgICAgIHRocm93IG5ldyBFcnJvcignUGVlciBkZXBlbmRlbmN5IGB4aHIyYCByZXF1aXJlZCEgUGxlYXNlIG5wbSBpbnN0YWxsIHhocjInKVxuICAgIH1cbiAgfVxuXG5cbiAgdmFyIGh0dHBzUmUgPSAvXmh0dHAvXG4gICAgLCBwcm90b2NvbFJlID0gLyheXFx3Kyk6XFwvXFwvL1xuICAgICwgdHdvSHVuZG8gPSAvXigyMFxcZHwxMjIzKSQvIC8vaHR0cDovL3N0YWNrb3ZlcmZsb3cuY29tL3F1ZXN0aW9ucy8xMDA0Njk3Mi9tc2llLXJldHVybnMtc3RhdHVzLWNvZGUtb2YtMTIyMy1mb3ItYWpheC1yZXF1ZXN0XG4gICAgLCByZWFkeVN0YXRlID0gJ3JlYWR5U3RhdGUnXG4gICAgLCBjb250ZW50VHlwZSA9ICdDb250ZW50LVR5cGUnXG4gICAgLCByZXF1ZXN0ZWRXaXRoID0gJ1gtUmVxdWVzdGVkLVdpdGgnXG4gICAgLCB1bmlxaWQgPSAwXG4gICAgLCBjYWxsYmFja1ByZWZpeCA9ICdyZXF3ZXN0XycgKyAoK25ldyBEYXRlKCkpXG4gICAgLCBsYXN0VmFsdWUgLy8gZGF0YSBzdG9yZWQgYnkgdGhlIG1vc3QgcmVjZW50IEpTT05QIGNhbGxiYWNrXG4gICAgLCB4bWxIdHRwUmVxdWVzdCA9ICdYTUxIdHRwUmVxdWVzdCdcbiAgICAsIHhEb21haW5SZXF1ZXN0ID0gJ1hEb21haW5SZXF1ZXN0J1xuICAgICwgbm9vcCA9IGZ1bmN0aW9uICgpIHt9XG5cbiAgICAsIGlzQXJyYXkgPSB0eXBlb2YgQXJyYXkuaXNBcnJheSA9PSAnZnVuY3Rpb24nXG4gICAgICAgID8gQXJyYXkuaXNBcnJheVxuICAgICAgICA6IGZ1bmN0aW9uIChhKSB7XG4gICAgICAgICAgICByZXR1cm4gYSBpbnN0YW5jZW9mIEFycmF5XG4gICAgICAgICAgfVxuXG4gICAgLCBkZWZhdWx0SGVhZGVycyA9IHtcbiAgICAgICAgICAnY29udGVudFR5cGUnOiAnYXBwbGljYXRpb24veC13d3ctZm9ybS11cmxlbmNvZGVkJ1xuICAgICAgICAsICdyZXF1ZXN0ZWRXaXRoJzogeG1sSHR0cFJlcXVlc3RcbiAgICAgICAgLCAnYWNjZXB0Jzoge1xuICAgICAgICAgICAgICAnKic6ICAndGV4dC9qYXZhc2NyaXB0LCB0ZXh0L2h0bWwsIGFwcGxpY2F0aW9uL3htbCwgdGV4dC94bWwsICovKidcbiAgICAgICAgICAgICwgJ3htbCc6ICAnYXBwbGljYXRpb24veG1sLCB0ZXh0L3htbCdcbiAgICAgICAgICAgICwgJ2h0bWwnOiAndGV4dC9odG1sJ1xuICAgICAgICAgICAgLCAndGV4dCc6ICd0ZXh0L3BsYWluJ1xuICAgICAgICAgICAgLCAnanNvbic6ICdhcHBsaWNhdGlvbi9qc29uLCB0ZXh0L2phdmFzY3JpcHQnXG4gICAgICAgICAgICAsICdqcyc6ICAgJ2FwcGxpY2F0aW9uL2phdmFzY3JpcHQsIHRleHQvamF2YXNjcmlwdCdcbiAgICAgICAgICB9XG4gICAgICB9XG5cbiAgICAsIHhociA9IGZ1bmN0aW9uKG8pIHtcbiAgICAgICAgLy8gaXMgaXQgeC1kb21haW5cbiAgICAgICAgaWYgKG9bJ2Nyb3NzT3JpZ2luJ10gPT09IHRydWUpIHtcbiAgICAgICAgICB2YXIgeGhyID0gY29udGV4dFt4bWxIdHRwUmVxdWVzdF0gPyBuZXcgWE1MSHR0cFJlcXVlc3QoKSA6IG51bGxcbiAgICAgICAgICBpZiAoeGhyICYmICd3aXRoQ3JlZGVudGlhbHMnIGluIHhocikge1xuICAgICAgICAgICAgcmV0dXJuIHhoclxuICAgICAgICAgIH0gZWxzZSBpZiAoY29udGV4dFt4RG9tYWluUmVxdWVzdF0pIHtcbiAgICAgICAgICAgIHJldHVybiBuZXcgWERvbWFpblJlcXVlc3QoKVxuICAgICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgICB0aHJvdyBuZXcgRXJyb3IoJ0Jyb3dzZXIgZG9lcyBub3Qgc3VwcG9ydCBjcm9zcy1vcmlnaW4gcmVxdWVzdHMnKVxuICAgICAgICAgIH1cbiAgICAgICAgfSBlbHNlIGlmIChjb250ZXh0W3htbEh0dHBSZXF1ZXN0XSkge1xuICAgICAgICAgIHJldHVybiBuZXcgWE1MSHR0cFJlcXVlc3QoKVxuICAgICAgICB9IGVsc2UgaWYgKFhIUjIpIHtcbiAgICAgICAgICByZXR1cm4gbmV3IFhIUjIoKVxuICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgIHJldHVybiBuZXcgQWN0aXZlWE9iamVjdCgnTWljcm9zb2Z0LlhNTEhUVFAnKVxuICAgICAgICB9XG4gICAgICB9XG4gICAgLCBnbG9iYWxTZXR1cE9wdGlvbnMgPSB7XG4gICAgICAgIGRhdGFGaWx0ZXI6IGZ1bmN0aW9uIChkYXRhKSB7XG4gICAgICAgICAgcmV0dXJuIGRhdGFcbiAgICAgICAgfVxuICAgICAgfVxuXG4gIGZ1bmN0aW9uIHN1Y2NlZWQocikge1xuICAgIHZhciBwcm90b2NvbCA9IHByb3RvY29sUmUuZXhlYyhyLnVybClcbiAgICBwcm90b2NvbCA9IChwcm90b2NvbCAmJiBwcm90b2NvbFsxXSkgfHwgY29udGV4dC5sb2NhdGlvbi5wcm90b2NvbFxuICAgIHJldHVybiBodHRwc1JlLnRlc3QocHJvdG9jb2wpID8gdHdvSHVuZG8udGVzdChyLnJlcXVlc3Quc3RhdHVzKSA6ICEhci5yZXF1ZXN0LnJlc3BvbnNlXG4gIH1cblxuICBmdW5jdGlvbiBoYW5kbGVSZWFkeVN0YXRlKHIsIHN1Y2Nlc3MsIGVycm9yKSB7XG4gICAgcmV0dXJuIGZ1bmN0aW9uICgpIHtcbiAgICAgIC8vIHVzZSBfYWJvcnRlZCB0byBtaXRpZ2F0ZSBhZ2FpbnN0IElFIGVyciBjMDBjMDIzZlxuICAgICAgLy8gKGNhbid0IHJlYWQgcHJvcHMgb24gYWJvcnRlZCByZXF1ZXN0IG9iamVjdHMpXG4gICAgICBpZiAoci5fYWJvcnRlZCkgcmV0dXJuIGVycm9yKHIucmVxdWVzdClcbiAgICAgIGlmIChyLl90aW1lZE91dCkgcmV0dXJuIGVycm9yKHIucmVxdWVzdCwgJ1JlcXVlc3QgaXMgYWJvcnRlZDogdGltZW91dCcpXG4gICAgICBpZiAoci5yZXF1ZXN0ICYmIHIucmVxdWVzdFtyZWFkeVN0YXRlXSA9PSA0KSB7XG4gICAgICAgIHIucmVxdWVzdC5vbnJlYWR5c3RhdGVjaGFuZ2UgPSBub29wXG4gICAgICAgIGlmIChzdWNjZWVkKHIpKSBzdWNjZXNzKHIucmVxdWVzdClcbiAgICAgICAgZWxzZVxuICAgICAgICAgIGVycm9yKHIucmVxdWVzdClcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICBmdW5jdGlvbiBzZXRIZWFkZXJzKGh0dHAsIG8pIHtcbiAgICB2YXIgaGVhZGVycyA9IG9bJ2hlYWRlcnMnXSB8fCB7fVxuICAgICAgLCBoXG5cbiAgICBoZWFkZXJzWydBY2NlcHQnXSA9IGhlYWRlcnNbJ0FjY2VwdCddXG4gICAgICB8fCBkZWZhdWx0SGVhZGVyc1snYWNjZXB0J11bb1sndHlwZSddXVxuICAgICAgfHwgZGVmYXVsdEhlYWRlcnNbJ2FjY2VwdCddWycqJ11cblxuICAgIHZhciBpc0FGb3JtRGF0YSA9IHR5cGVvZiBGb3JtRGF0YSAhPT0gJ3VuZGVmaW5lZCcgJiYgKG9bJ2RhdGEnXSBpbnN0YW5jZW9mIEZvcm1EYXRhKTtcbiAgICAvLyBicmVha3MgY3Jvc3Mtb3JpZ2luIHJlcXVlc3RzIHdpdGggbGVnYWN5IGJyb3dzZXJzXG4gICAgaWYgKCFvWydjcm9zc09yaWdpbiddICYmICFoZWFkZXJzW3JlcXVlc3RlZFdpdGhdKSBoZWFkZXJzW3JlcXVlc3RlZFdpdGhdID0gZGVmYXVsdEhlYWRlcnNbJ3JlcXVlc3RlZFdpdGgnXVxuICAgIGlmICghaGVhZGVyc1tjb250ZW50VHlwZV0gJiYgIWlzQUZvcm1EYXRhKSBoZWFkZXJzW2NvbnRlbnRUeXBlXSA9IG9bJ2NvbnRlbnRUeXBlJ10gfHwgZGVmYXVsdEhlYWRlcnNbJ2NvbnRlbnRUeXBlJ11cbiAgICBmb3IgKGggaW4gaGVhZGVycylcbiAgICAgIGhlYWRlcnMuaGFzT3duUHJvcGVydHkoaCkgJiYgJ3NldFJlcXVlc3RIZWFkZXInIGluIGh0dHAgJiYgaHR0cC5zZXRSZXF1ZXN0SGVhZGVyKGgsIGhlYWRlcnNbaF0pXG4gIH1cblxuICBmdW5jdGlvbiBzZXRDcmVkZW50aWFscyhodHRwLCBvKSB7XG4gICAgaWYgKHR5cGVvZiBvWyd3aXRoQ3JlZGVudGlhbHMnXSAhPT0gJ3VuZGVmaW5lZCcgJiYgdHlwZW9mIGh0dHAud2l0aENyZWRlbnRpYWxzICE9PSAndW5kZWZpbmVkJykge1xuICAgICAgaHR0cC53aXRoQ3JlZGVudGlhbHMgPSAhIW9bJ3dpdGhDcmVkZW50aWFscyddXG4gICAgfVxuICB9XG5cbiAgZnVuY3Rpb24gZ2VuZXJhbENhbGxiYWNrKGRhdGEpIHtcbiAgICBsYXN0VmFsdWUgPSBkYXRhXG4gIH1cblxuICBmdW5jdGlvbiB1cmxhcHBlbmQgKHVybCwgcykge1xuICAgIHJldHVybiB1cmwgKyAoL1xcPy8udGVzdCh1cmwpID8gJyYnIDogJz8nKSArIHNcbiAgfVxuXG4gIGZ1bmN0aW9uIGhhbmRsZUpzb25wKG8sIGZuLCBlcnIsIHVybCkge1xuICAgIHZhciByZXFJZCA9IHVuaXFpZCsrXG4gICAgICAsIGNia2V5ID0gb1snanNvbnBDYWxsYmFjayddIHx8ICdjYWxsYmFjaycgLy8gdGhlICdjYWxsYmFjaycga2V5XG4gICAgICAsIGNidmFsID0gb1snanNvbnBDYWxsYmFja05hbWUnXSB8fCByZXF3ZXN0LmdldGNhbGxiYWNrUHJlZml4KHJlcUlkKVxuICAgICAgLCBjYnJlZyA9IG5ldyBSZWdFeHAoJygoXnxcXFxcP3wmKScgKyBjYmtleSArICcpPShbXiZdKyknKVxuICAgICAgLCBtYXRjaCA9IHVybC5tYXRjaChjYnJlZylcbiAgICAgICwgc2NyaXB0ID0gZG9jLmNyZWF0ZUVsZW1lbnQoJ3NjcmlwdCcpXG4gICAgICAsIGxvYWRlZCA9IDBcbiAgICAgICwgaXNJRTEwID0gbmF2aWdhdG9yLnVzZXJBZ2VudC5pbmRleE9mKCdNU0lFIDEwLjAnKSAhPT0gLTFcblxuICAgIGlmIChtYXRjaCkge1xuICAgICAgaWYgKG1hdGNoWzNdID09PSAnPycpIHtcbiAgICAgICAgdXJsID0gdXJsLnJlcGxhY2UoY2JyZWcsICckMT0nICsgY2J2YWwpIC8vIHdpbGRjYXJkIGNhbGxiYWNrIGZ1bmMgbmFtZVxuICAgICAgfSBlbHNlIHtcbiAgICAgICAgY2J2YWwgPSBtYXRjaFszXSAvLyBwcm92aWRlZCBjYWxsYmFjayBmdW5jIG5hbWVcbiAgICAgIH1cbiAgICB9IGVsc2Uge1xuICAgICAgdXJsID0gdXJsYXBwZW5kKHVybCwgY2JrZXkgKyAnPScgKyBjYnZhbCkgLy8gbm8gY2FsbGJhY2sgZGV0YWlscywgYWRkICdlbVxuICAgIH1cblxuICAgIGNvbnRleHRbY2J2YWxdID0gZ2VuZXJhbENhbGxiYWNrXG5cbiAgICBzY3JpcHQudHlwZSA9ICd0ZXh0L2phdmFzY3JpcHQnXG4gICAgc2NyaXB0LnNyYyA9IHVybFxuICAgIHNjcmlwdC5hc3luYyA9IHRydWVcbiAgICBpZiAodHlwZW9mIHNjcmlwdC5vbnJlYWR5c3RhdGVjaGFuZ2UgIT09ICd1bmRlZmluZWQnICYmICFpc0lFMTApIHtcbiAgICAgIC8vIG5lZWQgdGhpcyBmb3IgSUUgZHVlIHRvIG91dC1vZi1vcmRlciBvbnJlYWR5c3RhdGVjaGFuZ2UoKSwgYmluZGluZyBzY3JpcHRcbiAgICAgIC8vIGV4ZWN1dGlvbiB0byBhbiBldmVudCBsaXN0ZW5lciBnaXZlcyB1cyBjb250cm9sIG92ZXIgd2hlbiB0aGUgc2NyaXB0XG4gICAgICAvLyBpcyBleGVjdXRlZC4gU2VlIGh0dHA6Ly9qYXVib3VyZy5uZXQvMjAxMC8wNy9sb2FkaW5nLXNjcmlwdC1hcy1vbmNsaWNrLWhhbmRsZXItb2YuaHRtbFxuICAgICAgc2NyaXB0Lmh0bWxGb3IgPSBzY3JpcHQuaWQgPSAnX3JlcXdlc3RfJyArIHJlcUlkXG4gICAgfVxuXG4gICAgc2NyaXB0Lm9ubG9hZCA9IHNjcmlwdC5vbnJlYWR5c3RhdGVjaGFuZ2UgPSBmdW5jdGlvbiAoKSB7XG4gICAgICBpZiAoKHNjcmlwdFtyZWFkeVN0YXRlXSAmJiBzY3JpcHRbcmVhZHlTdGF0ZV0gIT09ICdjb21wbGV0ZScgJiYgc2NyaXB0W3JlYWR5U3RhdGVdICE9PSAnbG9hZGVkJykgfHwgbG9hZGVkKSB7XG4gICAgICAgIHJldHVybiBmYWxzZVxuICAgICAgfVxuICAgICAgc2NyaXB0Lm9ubG9hZCA9IHNjcmlwdC5vbnJlYWR5c3RhdGVjaGFuZ2UgPSBudWxsXG4gICAgICBzY3JpcHQub25jbGljayAmJiBzY3JpcHQub25jbGljaygpXG4gICAgICAvLyBDYWxsIHRoZSB1c2VyIGNhbGxiYWNrIHdpdGggdGhlIGxhc3QgdmFsdWUgc3RvcmVkIGFuZCBjbGVhbiB1cCB2YWx1ZXMgYW5kIHNjcmlwdHMuXG4gICAgICBmbihsYXN0VmFsdWUpXG4gICAgICBsYXN0VmFsdWUgPSB1bmRlZmluZWRcbiAgICAgIGhlYWQucmVtb3ZlQ2hpbGQoc2NyaXB0KVxuICAgICAgbG9hZGVkID0gMVxuICAgIH1cblxuICAgIC8vIEFkZCB0aGUgc2NyaXB0IHRvIHRoZSBET00gaGVhZFxuICAgIGhlYWQuYXBwZW5kQ2hpbGQoc2NyaXB0KVxuXG4gICAgLy8gRW5hYmxlIEpTT05QIHRpbWVvdXRcbiAgICByZXR1cm4ge1xuICAgICAgYWJvcnQ6IGZ1bmN0aW9uICgpIHtcbiAgICAgICAgc2NyaXB0Lm9ubG9hZCA9IHNjcmlwdC5vbnJlYWR5c3RhdGVjaGFuZ2UgPSBudWxsXG4gICAgICAgIGVycih7fSwgJ1JlcXVlc3QgaXMgYWJvcnRlZDogdGltZW91dCcsIHt9KVxuICAgICAgICBsYXN0VmFsdWUgPSB1bmRlZmluZWRcbiAgICAgICAgaGVhZC5yZW1vdmVDaGlsZChzY3JpcHQpXG4gICAgICAgIGxvYWRlZCA9IDFcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICBmdW5jdGlvbiBnZXRSZXF1ZXN0KGZuLCBlcnIpIHtcbiAgICB2YXIgbyA9IHRoaXMub1xuICAgICAgLCBtZXRob2QgPSAob1snbWV0aG9kJ10gfHwgJ0dFVCcpLnRvVXBwZXJDYXNlKClcbiAgICAgICwgdXJsID0gdHlwZW9mIG8gPT09ICdzdHJpbmcnID8gbyA6IG9bJ3VybCddXG4gICAgICAvLyBjb252ZXJ0IG5vbi1zdHJpbmcgb2JqZWN0cyB0byBxdWVyeS1zdHJpbmcgZm9ybSB1bmxlc3Mgb1sncHJvY2Vzc0RhdGEnXSBpcyBmYWxzZVxuICAgICAgLCBkYXRhID0gKG9bJ3Byb2Nlc3NEYXRhJ10gIT09IGZhbHNlICYmIG9bJ2RhdGEnXSAmJiB0eXBlb2Ygb1snZGF0YSddICE9PSAnc3RyaW5nJylcbiAgICAgICAgPyByZXF3ZXN0LnRvUXVlcnlTdHJpbmcob1snZGF0YSddKVxuICAgICAgICA6IChvWydkYXRhJ10gfHwgbnVsbClcbiAgICAgICwgaHR0cFxuICAgICAgLCBzZW5kV2FpdCA9IGZhbHNlXG5cbiAgICAvLyBpZiB3ZSdyZSB3b3JraW5nIG9uIGEgR0VUIHJlcXVlc3QgYW5kIHdlIGhhdmUgZGF0YSB0aGVuIHdlIHNob3VsZCBhcHBlbmRcbiAgICAvLyBxdWVyeSBzdHJpbmcgdG8gZW5kIG9mIFVSTCBhbmQgbm90IHBvc3QgZGF0YVxuICAgIGlmICgob1sndHlwZSddID09ICdqc29ucCcgfHwgbWV0aG9kID09ICdHRVQnKSAmJiBkYXRhKSB7XG4gICAgICB1cmwgPSB1cmxhcHBlbmQodXJsLCBkYXRhKVxuICAgICAgZGF0YSA9IG51bGxcbiAgICB9XG5cbiAgICBpZiAob1sndHlwZSddID09ICdqc29ucCcpIHJldHVybiBoYW5kbGVKc29ucChvLCBmbiwgZXJyLCB1cmwpXG5cbiAgICAvLyBnZXQgdGhlIHhociBmcm9tIHRoZSBmYWN0b3J5IGlmIHBhc3NlZFxuICAgIC8vIGlmIHRoZSBmYWN0b3J5IHJldHVybnMgbnVsbCwgZmFsbC1iYWNrIHRvIG91cnNcbiAgICBodHRwID0gKG8ueGhyICYmIG8ueGhyKG8pKSB8fCB4aHIobylcblxuICAgIGh0dHAub3BlbihtZXRob2QsIHVybCwgb1snYXN5bmMnXSA9PT0gZmFsc2UgPyBmYWxzZSA6IHRydWUpXG4gICAgc2V0SGVhZGVycyhodHRwLCBvKVxuICAgIHNldENyZWRlbnRpYWxzKGh0dHAsIG8pXG4gICAgaWYgKGNvbnRleHRbeERvbWFpblJlcXVlc3RdICYmIGh0dHAgaW5zdGFuY2VvZiBjb250ZXh0W3hEb21haW5SZXF1ZXN0XSkge1xuICAgICAgICBodHRwLm9ubG9hZCA9IGZuXG4gICAgICAgIGh0dHAub25lcnJvciA9IGVyclxuICAgICAgICAvLyBOT1RFOiBzZWVcbiAgICAgICAgLy8gaHR0cDovL3NvY2lhbC5tc2RuLm1pY3Jvc29mdC5jb20vRm9ydW1zL2VuLVVTL2lld2ViZGV2ZWxvcG1lbnQvdGhyZWFkLzMwZWYzYWRkLTc2N2MtNDQzNi1iOGE5LWYxY2ExOWI0ODEyZVxuICAgICAgICBodHRwLm9ucHJvZ3Jlc3MgPSBmdW5jdGlvbigpIHt9XG4gICAgICAgIHNlbmRXYWl0ID0gdHJ1ZVxuICAgIH0gZWxzZSB7XG4gICAgICBodHRwLm9ucmVhZHlzdGF0ZWNoYW5nZSA9IGhhbmRsZVJlYWR5U3RhdGUodGhpcywgZm4sIGVycilcbiAgICB9XG4gICAgb1snYmVmb3JlJ10gJiYgb1snYmVmb3JlJ10oaHR0cClcbiAgICBpZiAoc2VuZFdhaXQpIHtcbiAgICAgIHNldFRpbWVvdXQoZnVuY3Rpb24gKCkge1xuICAgICAgICBodHRwLnNlbmQoZGF0YSlcbiAgICAgIH0sIDIwMClcbiAgICB9IGVsc2Uge1xuICAgICAgaHR0cC5zZW5kKGRhdGEpXG4gICAgfVxuICAgIHJldHVybiBodHRwXG4gIH1cblxuICBmdW5jdGlvbiBSZXF3ZXN0KG8sIGZuKSB7XG4gICAgdGhpcy5vID0gb1xuICAgIHRoaXMuZm4gPSBmblxuXG4gICAgaW5pdC5hcHBseSh0aGlzLCBhcmd1bWVudHMpXG4gIH1cblxuICBmdW5jdGlvbiBzZXRUeXBlKGhlYWRlcikge1xuICAgIC8vIGpzb24sIGphdmFzY3JpcHQsIHRleHQvcGxhaW4sIHRleHQvaHRtbCwgeG1sXG4gICAgaWYgKGhlYWRlciA9PT0gbnVsbCkgcmV0dXJuIHVuZGVmaW5lZDsgLy9JbiBjYXNlIG9mIG5vIGNvbnRlbnQtdHlwZS5cbiAgICBpZiAoaGVhZGVyLm1hdGNoKCdqc29uJykpIHJldHVybiAnanNvbidcbiAgICBpZiAoaGVhZGVyLm1hdGNoKCdqYXZhc2NyaXB0JykpIHJldHVybiAnanMnXG4gICAgaWYgKGhlYWRlci5tYXRjaCgndGV4dCcpKSByZXR1cm4gJ2h0bWwnXG4gICAgaWYgKGhlYWRlci5tYXRjaCgneG1sJykpIHJldHVybiAneG1sJ1xuICB9XG5cbiAgZnVuY3Rpb24gaW5pdChvLCBmbikge1xuXG4gICAgdGhpcy51cmwgPSB0eXBlb2YgbyA9PSAnc3RyaW5nJyA/IG8gOiBvWyd1cmwnXVxuICAgIHRoaXMudGltZW91dCA9IG51bGxcblxuICAgIC8vIHdoZXRoZXIgcmVxdWVzdCBoYXMgYmVlbiBmdWxmaWxsZWQgZm9yIHB1cnBvc2VcbiAgICAvLyBvZiB0cmFja2luZyB0aGUgUHJvbWlzZXNcbiAgICB0aGlzLl9mdWxmaWxsZWQgPSBmYWxzZVxuICAgIC8vIHN1Y2Nlc3MgaGFuZGxlcnNcbiAgICB0aGlzLl9zdWNjZXNzSGFuZGxlciA9IGZ1bmN0aW9uKCl7fVxuICAgIHRoaXMuX2Z1bGZpbGxtZW50SGFuZGxlcnMgPSBbXVxuICAgIC8vIGVycm9yIGhhbmRsZXJzXG4gICAgdGhpcy5fZXJyb3JIYW5kbGVycyA9IFtdXG4gICAgLy8gY29tcGxldGUgKGJvdGggc3VjY2VzcyBhbmQgZmFpbCkgaGFuZGxlcnNcbiAgICB0aGlzLl9jb21wbGV0ZUhhbmRsZXJzID0gW11cbiAgICB0aGlzLl9lcnJlZCA9IGZhbHNlXG4gICAgdGhpcy5fcmVzcG9uc2VBcmdzID0ge31cblxuICAgIHZhciBzZWxmID0gdGhpc1xuXG4gICAgZm4gPSBmbiB8fCBmdW5jdGlvbiAoKSB7fVxuXG4gICAgaWYgKG9bJ3RpbWVvdXQnXSkge1xuICAgICAgdGhpcy50aW1lb3V0ID0gc2V0VGltZW91dChmdW5jdGlvbiAoKSB7XG4gICAgICAgIHRpbWVkT3V0KClcbiAgICAgIH0sIG9bJ3RpbWVvdXQnXSlcbiAgICB9XG5cbiAgICBpZiAob1snc3VjY2VzcyddKSB7XG4gICAgICB0aGlzLl9zdWNjZXNzSGFuZGxlciA9IGZ1bmN0aW9uICgpIHtcbiAgICAgICAgb1snc3VjY2VzcyddLmFwcGx5KG8sIGFyZ3VtZW50cylcbiAgICAgIH1cbiAgICB9XG5cbiAgICBpZiAob1snZXJyb3InXSkge1xuICAgICAgdGhpcy5fZXJyb3JIYW5kbGVycy5wdXNoKGZ1bmN0aW9uICgpIHtcbiAgICAgICAgb1snZXJyb3InXS5hcHBseShvLCBhcmd1bWVudHMpXG4gICAgICB9KVxuICAgIH1cblxuICAgIGlmIChvWydjb21wbGV0ZSddKSB7XG4gICAgICB0aGlzLl9jb21wbGV0ZUhhbmRsZXJzLnB1c2goZnVuY3Rpb24gKCkge1xuICAgICAgICBvWydjb21wbGV0ZSddLmFwcGx5KG8sIGFyZ3VtZW50cylcbiAgICAgIH0pXG4gICAgfVxuXG4gICAgZnVuY3Rpb24gY29tcGxldGUgKHJlc3ApIHtcbiAgICAgIG9bJ3RpbWVvdXQnXSAmJiBjbGVhclRpbWVvdXQoc2VsZi50aW1lb3V0KVxuICAgICAgc2VsZi50aW1lb3V0ID0gbnVsbFxuICAgICAgd2hpbGUgKHNlbGYuX2NvbXBsZXRlSGFuZGxlcnMubGVuZ3RoID4gMCkge1xuICAgICAgICBzZWxmLl9jb21wbGV0ZUhhbmRsZXJzLnNoaWZ0KCkocmVzcClcbiAgICAgIH1cbiAgICB9XG5cbiAgICBmdW5jdGlvbiBzdWNjZXNzIChyZXNwKSB7XG4gICAgICB2YXIgdHlwZSA9IG9bJ3R5cGUnXSB8fCByZXNwICYmIHNldFR5cGUocmVzcC5nZXRSZXNwb25zZUhlYWRlcignQ29udGVudC1UeXBlJykpIC8vIHJlc3AgY2FuIGJlIHVuZGVmaW5lZCBpbiBJRVxuICAgICAgcmVzcCA9ICh0eXBlICE9PSAnanNvbnAnKSA/IHNlbGYucmVxdWVzdCA6IHJlc3BcbiAgICAgIC8vIHVzZSBnbG9iYWwgZGF0YSBmaWx0ZXIgb24gcmVzcG9uc2UgdGV4dFxuICAgICAgdmFyIGZpbHRlcmVkUmVzcG9uc2UgPSBnbG9iYWxTZXR1cE9wdGlvbnMuZGF0YUZpbHRlcihyZXNwLnJlc3BvbnNlVGV4dCwgdHlwZSlcbiAgICAgICAgLCByID0gZmlsdGVyZWRSZXNwb25zZVxuICAgICAgdHJ5IHtcbiAgICAgICAgcmVzcC5yZXNwb25zZVRleHQgPSByXG4gICAgICB9IGNhdGNoIChlKSB7XG4gICAgICAgIC8vIGNhbid0IGFzc2lnbiB0aGlzIGluIElFPD04LCBqdXN0IGlnbm9yZVxuICAgICAgfVxuICAgICAgaWYgKHIpIHtcbiAgICAgICAgc3dpdGNoICh0eXBlKSB7XG4gICAgICAgIGNhc2UgJ2pzb24nOlxuICAgICAgICAgIHRyeSB7XG4gICAgICAgICAgICByZXNwID0gY29udGV4dC5KU09OID8gY29udGV4dC5KU09OLnBhcnNlKHIpIDogZXZhbCgnKCcgKyByICsgJyknKVxuICAgICAgICAgIH0gY2F0Y2ggKGVycikge1xuICAgICAgICAgICAgcmV0dXJuIGVycm9yKHJlc3AsICdDb3VsZCBub3QgcGFyc2UgSlNPTiBpbiByZXNwb25zZScsIGVycilcbiAgICAgICAgICB9XG4gICAgICAgICAgYnJlYWtcbiAgICAgICAgY2FzZSAnanMnOlxuICAgICAgICAgIHJlc3AgPSBldmFsKHIpXG4gICAgICAgICAgYnJlYWtcbiAgICAgICAgY2FzZSAnaHRtbCc6XG4gICAgICAgICAgcmVzcCA9IHJcbiAgICAgICAgICBicmVha1xuICAgICAgICBjYXNlICd4bWwnOlxuICAgICAgICAgIHJlc3AgPSByZXNwLnJlc3BvbnNlWE1MXG4gICAgICAgICAgICAgICYmIHJlc3AucmVzcG9uc2VYTUwucGFyc2VFcnJvciAvLyBJRSB0cm9sb2xvXG4gICAgICAgICAgICAgICYmIHJlc3AucmVzcG9uc2VYTUwucGFyc2VFcnJvci5lcnJvckNvZGVcbiAgICAgICAgICAgICAgJiYgcmVzcC5yZXNwb25zZVhNTC5wYXJzZUVycm9yLnJlYXNvblxuICAgICAgICAgICAgPyBudWxsXG4gICAgICAgICAgICA6IHJlc3AucmVzcG9uc2VYTUxcbiAgICAgICAgICBicmVha1xuICAgICAgICB9XG4gICAgICB9XG5cbiAgICAgIHNlbGYuX3Jlc3BvbnNlQXJncy5yZXNwID0gcmVzcFxuICAgICAgc2VsZi5fZnVsZmlsbGVkID0gdHJ1ZVxuICAgICAgZm4ocmVzcClcbiAgICAgIHNlbGYuX3N1Y2Nlc3NIYW5kbGVyKHJlc3ApXG4gICAgICB3aGlsZSAoc2VsZi5fZnVsZmlsbG1lbnRIYW5kbGVycy5sZW5ndGggPiAwKSB7XG4gICAgICAgIHJlc3AgPSBzZWxmLl9mdWxmaWxsbWVudEhhbmRsZXJzLnNoaWZ0KCkocmVzcClcbiAgICAgIH1cblxuICAgICAgY29tcGxldGUocmVzcClcbiAgICB9XG5cbiAgICBmdW5jdGlvbiB0aW1lZE91dCgpIHtcbiAgICAgIHNlbGYuX3RpbWVkT3V0ID0gdHJ1ZVxuICAgICAgc2VsZi5yZXF1ZXN0LmFib3J0KClcbiAgICB9XG5cbiAgICBmdW5jdGlvbiBlcnJvcihyZXNwLCBtc2csIHQpIHtcbiAgICAgIHJlc3AgPSBzZWxmLnJlcXVlc3RcbiAgICAgIHNlbGYuX3Jlc3BvbnNlQXJncy5yZXNwID0gcmVzcFxuICAgICAgc2VsZi5fcmVzcG9uc2VBcmdzLm1zZyA9IG1zZ1xuICAgICAgc2VsZi5fcmVzcG9uc2VBcmdzLnQgPSB0XG4gICAgICBzZWxmLl9lcnJlZCA9IHRydWVcbiAgICAgIHdoaWxlIChzZWxmLl9lcnJvckhhbmRsZXJzLmxlbmd0aCA+IDApIHtcbiAgICAgICAgc2VsZi5fZXJyb3JIYW5kbGVycy5zaGlmdCgpKHJlc3AsIG1zZywgdClcbiAgICAgIH1cbiAgICAgIGNvbXBsZXRlKHJlc3ApXG4gICAgfVxuXG4gICAgdGhpcy5yZXF1ZXN0ID0gZ2V0UmVxdWVzdC5jYWxsKHRoaXMsIHN1Y2Nlc3MsIGVycm9yKVxuICB9XG5cbiAgUmVxd2VzdC5wcm90b3R5cGUgPSB7XG4gICAgYWJvcnQ6IGZ1bmN0aW9uICgpIHtcbiAgICAgIHRoaXMuX2Fib3J0ZWQgPSB0cnVlXG4gICAgICB0aGlzLnJlcXVlc3QuYWJvcnQoKVxuICAgIH1cblxuICAsIHJldHJ5OiBmdW5jdGlvbiAoKSB7XG4gICAgICBpbml0LmNhbGwodGhpcywgdGhpcy5vLCB0aGlzLmZuKVxuICAgIH1cblxuICAgIC8qKlxuICAgICAqIFNtYWxsIGRldmlhdGlvbiBmcm9tIHRoZSBQcm9taXNlcyBBIENvbW1vbkpzIHNwZWNpZmljYXRpb25cbiAgICAgKiBodHRwOi8vd2lraS5jb21tb25qcy5vcmcvd2lraS9Qcm9taXNlcy9BXG4gICAgICovXG5cbiAgICAvKipcbiAgICAgKiBgdGhlbmAgd2lsbCBleGVjdXRlIHVwb24gc3VjY2Vzc2Z1bCByZXF1ZXN0c1xuICAgICAqL1xuICAsIHRoZW46IGZ1bmN0aW9uIChzdWNjZXNzLCBmYWlsKSB7XG4gICAgICBzdWNjZXNzID0gc3VjY2VzcyB8fCBmdW5jdGlvbiAoKSB7fVxuICAgICAgZmFpbCA9IGZhaWwgfHwgZnVuY3Rpb24gKCkge31cbiAgICAgIGlmICh0aGlzLl9mdWxmaWxsZWQpIHtcbiAgICAgICAgdGhpcy5fcmVzcG9uc2VBcmdzLnJlc3AgPSBzdWNjZXNzKHRoaXMuX3Jlc3BvbnNlQXJncy5yZXNwKVxuICAgICAgfSBlbHNlIGlmICh0aGlzLl9lcnJlZCkge1xuICAgICAgICBmYWlsKHRoaXMuX3Jlc3BvbnNlQXJncy5yZXNwLCB0aGlzLl9yZXNwb25zZUFyZ3MubXNnLCB0aGlzLl9yZXNwb25zZUFyZ3MudClcbiAgICAgIH0gZWxzZSB7XG4gICAgICAgIHRoaXMuX2Z1bGZpbGxtZW50SGFuZGxlcnMucHVzaChzdWNjZXNzKVxuICAgICAgICB0aGlzLl9lcnJvckhhbmRsZXJzLnB1c2goZmFpbClcbiAgICAgIH1cbiAgICAgIHJldHVybiB0aGlzXG4gICAgfVxuXG4gICAgLyoqXG4gICAgICogYGFsd2F5c2Agd2lsbCBleGVjdXRlIHdoZXRoZXIgdGhlIHJlcXVlc3Qgc3VjY2VlZHMgb3IgZmFpbHNcbiAgICAgKi9cbiAgLCBhbHdheXM6IGZ1bmN0aW9uIChmbikge1xuICAgICAgaWYgKHRoaXMuX2Z1bGZpbGxlZCB8fCB0aGlzLl9lcnJlZCkge1xuICAgICAgICBmbih0aGlzLl9yZXNwb25zZUFyZ3MucmVzcClcbiAgICAgIH0gZWxzZSB7XG4gICAgICAgIHRoaXMuX2NvbXBsZXRlSGFuZGxlcnMucHVzaChmbilcbiAgICAgIH1cbiAgICAgIHJldHVybiB0aGlzXG4gICAgfVxuXG4gICAgLyoqXG4gICAgICogYGZhaWxgIHdpbGwgZXhlY3V0ZSB3aGVuIHRoZSByZXF1ZXN0IGZhaWxzXG4gICAgICovXG4gICwgZmFpbDogZnVuY3Rpb24gKGZuKSB7XG4gICAgICBpZiAodGhpcy5fZXJyZWQpIHtcbiAgICAgICAgZm4odGhpcy5fcmVzcG9uc2VBcmdzLnJlc3AsIHRoaXMuX3Jlc3BvbnNlQXJncy5tc2csIHRoaXMuX3Jlc3BvbnNlQXJncy50KVxuICAgICAgfSBlbHNlIHtcbiAgICAgICAgdGhpcy5fZXJyb3JIYW5kbGVycy5wdXNoKGZuKVxuICAgICAgfVxuICAgICAgcmV0dXJuIHRoaXNcbiAgICB9XG4gICwgJ2NhdGNoJzogZnVuY3Rpb24gKGZuKSB7XG4gICAgICByZXR1cm4gdGhpcy5mYWlsKGZuKVxuICAgIH1cbiAgfVxuXG4gIGZ1bmN0aW9uIHJlcXdlc3QobywgZm4pIHtcbiAgICByZXR1cm4gbmV3IFJlcXdlc3QobywgZm4pXG4gIH1cblxuICAvLyBub3JtYWxpemUgbmV3bGluZSB2YXJpYW50cyBhY2NvcmRpbmcgdG8gc3BlYyAtPiBDUkxGXG4gIGZ1bmN0aW9uIG5vcm1hbGl6ZShzKSB7XG4gICAgcmV0dXJuIHMgPyBzLnJlcGxhY2UoL1xccj9cXG4vZywgJ1xcclxcbicpIDogJydcbiAgfVxuXG4gIGZ1bmN0aW9uIHNlcmlhbChlbCwgY2IpIHtcbiAgICB2YXIgbiA9IGVsLm5hbWVcbiAgICAgICwgdCA9IGVsLnRhZ05hbWUudG9Mb3dlckNhc2UoKVxuICAgICAgLCBvcHRDYiA9IGZ1bmN0aW9uIChvKSB7XG4gICAgICAgICAgLy8gSUUgZ2l2ZXMgdmFsdWU9XCJcIiBldmVuIHdoZXJlIHRoZXJlIGlzIG5vIHZhbHVlIGF0dHJpYnV0ZVxuICAgICAgICAgIC8vICdzcGVjaWZpZWQnIHJlZjogaHR0cDovL3d3dy53My5vcmcvVFIvRE9NLUxldmVsLTMtQ29yZS9jb3JlLmh0bWwjSUQtODYyNTI5MjczXG4gICAgICAgICAgaWYgKG8gJiYgIW9bJ2Rpc2FibGVkJ10pXG4gICAgICAgICAgICBjYihuLCBub3JtYWxpemUob1snYXR0cmlidXRlcyddWyd2YWx1ZSddICYmIG9bJ2F0dHJpYnV0ZXMnXVsndmFsdWUnXVsnc3BlY2lmaWVkJ10gPyBvWyd2YWx1ZSddIDogb1sndGV4dCddKSlcbiAgICAgICAgfVxuICAgICAgLCBjaCwgcmEsIHZhbCwgaVxuXG4gICAgLy8gZG9uJ3Qgc2VyaWFsaXplIGVsZW1lbnRzIHRoYXQgYXJlIGRpc2FibGVkIG9yIHdpdGhvdXQgYSBuYW1lXG4gICAgaWYgKGVsLmRpc2FibGVkIHx8ICFuKSByZXR1cm5cblxuICAgIHN3aXRjaCAodCkge1xuICAgIGNhc2UgJ2lucHV0JzpcbiAgICAgIGlmICghL3Jlc2V0fGJ1dHRvbnxpbWFnZXxmaWxlL2kudGVzdChlbC50eXBlKSkge1xuICAgICAgICBjaCA9IC9jaGVja2JveC9pLnRlc3QoZWwudHlwZSlcbiAgICAgICAgcmEgPSAvcmFkaW8vaS50ZXN0KGVsLnR5cGUpXG4gICAgICAgIHZhbCA9IGVsLnZhbHVlXG4gICAgICAgIC8vIFdlYktpdCBnaXZlcyB1cyBcIlwiIGluc3RlYWQgb2YgXCJvblwiIGlmIGEgY2hlY2tib3ggaGFzIG5vIHZhbHVlLCBzbyBjb3JyZWN0IGl0IGhlcmVcbiAgICAgICAgOyghKGNoIHx8IHJhKSB8fCBlbC5jaGVja2VkKSAmJiBjYihuLCBub3JtYWxpemUoY2ggJiYgdmFsID09PSAnJyA/ICdvbicgOiB2YWwpKVxuICAgICAgfVxuICAgICAgYnJlYWtcbiAgICBjYXNlICd0ZXh0YXJlYSc6XG4gICAgICBjYihuLCBub3JtYWxpemUoZWwudmFsdWUpKVxuICAgICAgYnJlYWtcbiAgICBjYXNlICdzZWxlY3QnOlxuICAgICAgaWYgKGVsLnR5cGUudG9Mb3dlckNhc2UoKSA9PT0gJ3NlbGVjdC1vbmUnKSB7XG4gICAgICAgIG9wdENiKGVsLnNlbGVjdGVkSW5kZXggPj0gMCA/IGVsLm9wdGlvbnNbZWwuc2VsZWN0ZWRJbmRleF0gOiBudWxsKVxuICAgICAgfSBlbHNlIHtcbiAgICAgICAgZm9yIChpID0gMDsgZWwubGVuZ3RoICYmIGkgPCBlbC5sZW5ndGg7IGkrKykge1xuICAgICAgICAgIGVsLm9wdGlvbnNbaV0uc2VsZWN0ZWQgJiYgb3B0Q2IoZWwub3B0aW9uc1tpXSlcbiAgICAgICAgfVxuICAgICAgfVxuICAgICAgYnJlYWtcbiAgICB9XG4gIH1cblxuICAvLyBjb2xsZWN0IHVwIGFsbCBmb3JtIGVsZW1lbnRzIGZvdW5kIGZyb20gdGhlIHBhc3NlZCBhcmd1bWVudCBlbGVtZW50cyBhbGxcbiAgLy8gdGhlIHdheSBkb3duIHRvIGNoaWxkIGVsZW1lbnRzOyBwYXNzIGEgJzxmb3JtPicgb3IgZm9ybSBmaWVsZHMuXG4gIC8vIGNhbGxlZCB3aXRoICd0aGlzJz1jYWxsYmFjayB0byB1c2UgZm9yIHNlcmlhbCgpIG9uIGVhY2ggZWxlbWVudFxuICBmdW5jdGlvbiBlYWNoRm9ybUVsZW1lbnQoKSB7XG4gICAgdmFyIGNiID0gdGhpc1xuICAgICAgLCBlLCBpXG4gICAgICAsIHNlcmlhbGl6ZVN1YnRhZ3MgPSBmdW5jdGlvbiAoZSwgdGFncykge1xuICAgICAgICAgIHZhciBpLCBqLCBmYVxuICAgICAgICAgIGZvciAoaSA9IDA7IGkgPCB0YWdzLmxlbmd0aDsgaSsrKSB7XG4gICAgICAgICAgICBmYSA9IGVbYnlUYWddKHRhZ3NbaV0pXG4gICAgICAgICAgICBmb3IgKGogPSAwOyBqIDwgZmEubGVuZ3RoOyBqKyspIHNlcmlhbChmYVtqXSwgY2IpXG4gICAgICAgICAgfVxuICAgICAgICB9XG5cbiAgICBmb3IgKGkgPSAwOyBpIDwgYXJndW1lbnRzLmxlbmd0aDsgaSsrKSB7XG4gICAgICBlID0gYXJndW1lbnRzW2ldXG4gICAgICBpZiAoL2lucHV0fHNlbGVjdHx0ZXh0YXJlYS9pLnRlc3QoZS50YWdOYW1lKSkgc2VyaWFsKGUsIGNiKVxuICAgICAgc2VyaWFsaXplU3VidGFncyhlLCBbICdpbnB1dCcsICdzZWxlY3QnLCAndGV4dGFyZWEnIF0pXG4gICAgfVxuICB9XG5cbiAgLy8gc3RhbmRhcmQgcXVlcnkgc3RyaW5nIHN0eWxlIHNlcmlhbGl6YXRpb25cbiAgZnVuY3Rpb24gc2VyaWFsaXplUXVlcnlTdHJpbmcoKSB7XG4gICAgcmV0dXJuIHJlcXdlc3QudG9RdWVyeVN0cmluZyhyZXF3ZXN0LnNlcmlhbGl6ZUFycmF5LmFwcGx5KG51bGwsIGFyZ3VtZW50cykpXG4gIH1cblxuICAvLyB7ICduYW1lJzogJ3ZhbHVlJywgLi4uIH0gc3R5bGUgc2VyaWFsaXphdGlvblxuICBmdW5jdGlvbiBzZXJpYWxpemVIYXNoKCkge1xuICAgIHZhciBoYXNoID0ge31cbiAgICBlYWNoRm9ybUVsZW1lbnQuYXBwbHkoZnVuY3Rpb24gKG5hbWUsIHZhbHVlKSB7XG4gICAgICBpZiAobmFtZSBpbiBoYXNoKSB7XG4gICAgICAgIGhhc2hbbmFtZV0gJiYgIWlzQXJyYXkoaGFzaFtuYW1lXSkgJiYgKGhhc2hbbmFtZV0gPSBbaGFzaFtuYW1lXV0pXG4gICAgICAgIGhhc2hbbmFtZV0ucHVzaCh2YWx1ZSlcbiAgICAgIH0gZWxzZSBoYXNoW25hbWVdID0gdmFsdWVcbiAgICB9LCBhcmd1bWVudHMpXG4gICAgcmV0dXJuIGhhc2hcbiAgfVxuXG4gIC8vIFsgeyBuYW1lOiAnbmFtZScsIHZhbHVlOiAndmFsdWUnIH0sIC4uLiBdIHN0eWxlIHNlcmlhbGl6YXRpb25cbiAgcmVxd2VzdC5zZXJpYWxpemVBcnJheSA9IGZ1bmN0aW9uICgpIHtcbiAgICB2YXIgYXJyID0gW11cbiAgICBlYWNoRm9ybUVsZW1lbnQuYXBwbHkoZnVuY3Rpb24gKG5hbWUsIHZhbHVlKSB7XG4gICAgICBhcnIucHVzaCh7bmFtZTogbmFtZSwgdmFsdWU6IHZhbHVlfSlcbiAgICB9LCBhcmd1bWVudHMpXG4gICAgcmV0dXJuIGFyclxuICB9XG5cbiAgcmVxd2VzdC5zZXJpYWxpemUgPSBmdW5jdGlvbiAoKSB7XG4gICAgaWYgKGFyZ3VtZW50cy5sZW5ndGggPT09IDApIHJldHVybiAnJ1xuICAgIHZhciBvcHQsIGZuXG4gICAgICAsIGFyZ3MgPSBBcnJheS5wcm90b3R5cGUuc2xpY2UuY2FsbChhcmd1bWVudHMsIDApXG5cbiAgICBvcHQgPSBhcmdzLnBvcCgpXG4gICAgb3B0ICYmIG9wdC5ub2RlVHlwZSAmJiBhcmdzLnB1c2gob3B0KSAmJiAob3B0ID0gbnVsbClcbiAgICBvcHQgJiYgKG9wdCA9IG9wdC50eXBlKVxuXG4gICAgaWYgKG9wdCA9PSAnbWFwJykgZm4gPSBzZXJpYWxpemVIYXNoXG4gICAgZWxzZSBpZiAob3B0ID09ICdhcnJheScpIGZuID0gcmVxd2VzdC5zZXJpYWxpemVBcnJheVxuICAgIGVsc2UgZm4gPSBzZXJpYWxpemVRdWVyeVN0cmluZ1xuXG4gICAgcmV0dXJuIGZuLmFwcGx5KG51bGwsIGFyZ3MpXG4gIH1cblxuICByZXF3ZXN0LnRvUXVlcnlTdHJpbmcgPSBmdW5jdGlvbiAobywgdHJhZCkge1xuICAgIHZhciBwcmVmaXgsIGlcbiAgICAgICwgdHJhZGl0aW9uYWwgPSB0cmFkIHx8IGZhbHNlXG4gICAgICAsIHMgPSBbXVxuICAgICAgLCBlbmMgPSBlbmNvZGVVUklDb21wb25lbnRcbiAgICAgICwgYWRkID0gZnVuY3Rpb24gKGtleSwgdmFsdWUpIHtcbiAgICAgICAgICAvLyBJZiB2YWx1ZSBpcyBhIGZ1bmN0aW9uLCBpbnZva2UgaXQgYW5kIHJldHVybiBpdHMgdmFsdWVcbiAgICAgICAgICB2YWx1ZSA9ICgnZnVuY3Rpb24nID09PSB0eXBlb2YgdmFsdWUpID8gdmFsdWUoKSA6ICh2YWx1ZSA9PSBudWxsID8gJycgOiB2YWx1ZSlcbiAgICAgICAgICBzW3MubGVuZ3RoXSA9IGVuYyhrZXkpICsgJz0nICsgZW5jKHZhbHVlKVxuICAgICAgICB9XG4gICAgLy8gSWYgYW4gYXJyYXkgd2FzIHBhc3NlZCBpbiwgYXNzdW1lIHRoYXQgaXQgaXMgYW4gYXJyYXkgb2YgZm9ybSBlbGVtZW50cy5cbiAgICBpZiAoaXNBcnJheShvKSkge1xuICAgICAgZm9yIChpID0gMDsgbyAmJiBpIDwgby5sZW5ndGg7IGkrKykgYWRkKG9baV1bJ25hbWUnXSwgb1tpXVsndmFsdWUnXSlcbiAgICB9IGVsc2Uge1xuICAgICAgLy8gSWYgdHJhZGl0aW9uYWwsIGVuY29kZSB0aGUgXCJvbGRcIiB3YXkgKHRoZSB3YXkgMS4zLjIgb3Igb2xkZXJcbiAgICAgIC8vIGRpZCBpdCksIG90aGVyd2lzZSBlbmNvZGUgcGFyYW1zIHJlY3Vyc2l2ZWx5LlxuICAgICAgZm9yIChwcmVmaXggaW4gbykge1xuICAgICAgICBpZiAoby5oYXNPd25Qcm9wZXJ0eShwcmVmaXgpKSBidWlsZFBhcmFtcyhwcmVmaXgsIG9bcHJlZml4XSwgdHJhZGl0aW9uYWwsIGFkZClcbiAgICAgIH1cbiAgICB9XG5cbiAgICAvLyBzcGFjZXMgc2hvdWxkIGJlICsgYWNjb3JkaW5nIHRvIHNwZWNcbiAgICByZXR1cm4gcy5qb2luKCcmJykucmVwbGFjZSgvJTIwL2csICcrJylcbiAgfVxuXG4gIGZ1bmN0aW9uIGJ1aWxkUGFyYW1zKHByZWZpeCwgb2JqLCB0cmFkaXRpb25hbCwgYWRkKSB7XG4gICAgdmFyIG5hbWUsIGksIHZcbiAgICAgICwgcmJyYWNrZXQgPSAvXFxbXFxdJC9cblxuICAgIGlmIChpc0FycmF5KG9iaikpIHtcbiAgICAgIC8vIFNlcmlhbGl6ZSBhcnJheSBpdGVtLlxuICAgICAgZm9yIChpID0gMDsgb2JqICYmIGkgPCBvYmoubGVuZ3RoOyBpKyspIHtcbiAgICAgICAgdiA9IG9ialtpXVxuICAgICAgICBpZiAodHJhZGl0aW9uYWwgfHwgcmJyYWNrZXQudGVzdChwcmVmaXgpKSB7XG4gICAgICAgICAgLy8gVHJlYXQgZWFjaCBhcnJheSBpdGVtIGFzIGEgc2NhbGFyLlxuICAgICAgICAgIGFkZChwcmVmaXgsIHYpXG4gICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgYnVpbGRQYXJhbXMocHJlZml4ICsgJ1snICsgKHR5cGVvZiB2ID09PSAnb2JqZWN0JyA/IGkgOiAnJykgKyAnXScsIHYsIHRyYWRpdGlvbmFsLCBhZGQpXG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9IGVsc2UgaWYgKG9iaiAmJiBvYmoudG9TdHJpbmcoKSA9PT0gJ1tvYmplY3QgT2JqZWN0XScpIHtcbiAgICAgIC8vIFNlcmlhbGl6ZSBvYmplY3QgaXRlbS5cbiAgICAgIGZvciAobmFtZSBpbiBvYmopIHtcbiAgICAgICAgYnVpbGRQYXJhbXMocHJlZml4ICsgJ1snICsgbmFtZSArICddJywgb2JqW25hbWVdLCB0cmFkaXRpb25hbCwgYWRkKVxuICAgICAgfVxuXG4gICAgfSBlbHNlIHtcbiAgICAgIC8vIFNlcmlhbGl6ZSBzY2FsYXIgaXRlbS5cbiAgICAgIGFkZChwcmVmaXgsIG9iailcbiAgICB9XG4gIH1cblxuICByZXF3ZXN0LmdldGNhbGxiYWNrUHJlZml4ID0gZnVuY3Rpb24gKCkge1xuICAgIHJldHVybiBjYWxsYmFja1ByZWZpeFxuICB9XG5cbiAgLy8galF1ZXJ5IGFuZCBaZXB0byBjb21wYXRpYmlsaXR5LCBkaWZmZXJlbmNlcyBjYW4gYmUgcmVtYXBwZWQgaGVyZSBzbyB5b3UgY2FuIGNhbGxcbiAgLy8gLmFqYXguY29tcGF0KG9wdGlvbnMsIGNhbGxiYWNrKVxuICByZXF3ZXN0LmNvbXBhdCA9IGZ1bmN0aW9uIChvLCBmbikge1xuICAgIGlmIChvKSB7XG4gICAgICBvWyd0eXBlJ10gJiYgKG9bJ21ldGhvZCddID0gb1sndHlwZSddKSAmJiBkZWxldGUgb1sndHlwZSddXG4gICAgICBvWydkYXRhVHlwZSddICYmIChvWyd0eXBlJ10gPSBvWydkYXRhVHlwZSddKVxuICAgICAgb1snanNvbnBDYWxsYmFjayddICYmIChvWydqc29ucENhbGxiYWNrTmFtZSddID0gb1snanNvbnBDYWxsYmFjayddKSAmJiBkZWxldGUgb1snanNvbnBDYWxsYmFjayddXG4gICAgICBvWydqc29ucCddICYmIChvWydqc29ucENhbGxiYWNrJ10gPSBvWydqc29ucCddKVxuICAgIH1cbiAgICByZXR1cm4gbmV3IFJlcXdlc3QobywgZm4pXG4gIH1cblxuICByZXF3ZXN0LmFqYXhTZXR1cCA9IGZ1bmN0aW9uIChvcHRpb25zKSB7XG4gICAgb3B0aW9ucyA9IG9wdGlvbnMgfHwge31cbiAgICBmb3IgKHZhciBrIGluIG9wdGlvbnMpIHtcbiAgICAgIGdsb2JhbFNldHVwT3B0aW9uc1trXSA9IG9wdGlvbnNba11cbiAgICB9XG4gIH1cblxuICByZXR1cm4gcmVxd2VzdFxufSk7XG5cbn0pOyIsInJlcXVpcmUoOCkoW1wicmVhY3QtMTUuM1wiLFwicmVhY3Rkb20tMTUuM1wiLFwicmVkdXgtMy42XCIsXCJyZWFjdHJlZHV4LTQuNFwiXSxmdW5jdGlvbihfX3JlYWN0LF9fcmVhY3RfZG9tLF9fcmVkdXgsX19yZWFjdF9yZWR1eCl7XG4vKiEgaHR0cDovL210aHMuYmUvc3RhcnRzd2l0aCB2MC4yLjAgYnkgQG1hdGhpYXMgKi9cbmlmICghU3RyaW5nLnByb3RvdHlwZS5zdGFydHNXaXRoKSB7XG5cdChmdW5jdGlvbigpIHtcblx0XHQndXNlIHN0cmljdCc7IC8vIG5lZWRlZCB0byBzdXBwb3J0IGBhcHBseWAvYGNhbGxgIHdpdGggYHVuZGVmaW5lZGAvYG51bGxgXG5cdFx0dmFyIGRlZmluZVByb3BlcnR5ID0gKGZ1bmN0aW9uKCkge1xuXHRcdFx0Ly8gSUUgOCBvbmx5IHN1cHBvcnRzIGBPYmplY3QuZGVmaW5lUHJvcGVydHlgIG9uIERPTSBlbGVtZW50c1xuXHRcdFx0dHJ5IHtcblx0XHRcdFx0dmFyIG9iamVjdCA9IHt9O1xuXHRcdFx0XHR2YXIgJGRlZmluZVByb3BlcnR5ID0gT2JqZWN0LmRlZmluZVByb3BlcnR5O1xuXHRcdFx0XHR2YXIgcmVzdWx0ID0gJGRlZmluZVByb3BlcnR5KG9iamVjdCwgb2JqZWN0LCBvYmplY3QpICYmICRkZWZpbmVQcm9wZXJ0eTtcblx0XHRcdH0gY2F0Y2goZXJyb3IpIHt9XG5cdFx0XHRyZXR1cm4gcmVzdWx0O1xuXHRcdH0oKSk7XG5cdFx0dmFyIHRvU3RyaW5nID0ge30udG9TdHJpbmc7XG5cdFx0dmFyIHN0YXJ0c1dpdGggPSBmdW5jdGlvbihzZWFyY2gpIHtcblx0XHRcdGlmICh0aGlzID09IG51bGwpIHtcblx0XHRcdFx0dGhyb3cgVHlwZUVycm9yKCk7XG5cdFx0XHR9XG5cdFx0XHR2YXIgc3RyaW5nID0gU3RyaW5nKHRoaXMpO1xuXHRcdFx0aWYgKHNlYXJjaCAmJiB0b1N0cmluZy5jYWxsKHNlYXJjaCkgPT0gJ1tvYmplY3QgUmVnRXhwXScpIHtcblx0XHRcdFx0dGhyb3cgVHlwZUVycm9yKCk7XG5cdFx0XHR9XG5cdFx0XHR2YXIgc3RyaW5nTGVuZ3RoID0gc3RyaW5nLmxlbmd0aDtcblx0XHRcdHZhciBzZWFyY2hTdHJpbmcgPSBTdHJpbmcoc2VhcmNoKTtcblx0XHRcdHZhciBzZWFyY2hMZW5ndGggPSBzZWFyY2hTdHJpbmcubGVuZ3RoO1xuXHRcdFx0dmFyIHBvc2l0aW9uID0gYXJndW1lbnRzLmxlbmd0aCA+IDEgPyBhcmd1bWVudHNbMV0gOiB1bmRlZmluZWQ7XG5cdFx0XHQvLyBgVG9JbnRlZ2VyYFxuXHRcdFx0dmFyIHBvcyA9IHBvc2l0aW9uID8gTnVtYmVyKHBvc2l0aW9uKSA6IDA7XG5cdFx0XHRpZiAocG9zICE9IHBvcykgeyAvLyBiZXR0ZXIgYGlzTmFOYFxuXHRcdFx0XHRwb3MgPSAwO1xuXHRcdFx0fVxuXHRcdFx0dmFyIHN0YXJ0ID0gTWF0aC5taW4oTWF0aC5tYXgocG9zLCAwKSwgc3RyaW5nTGVuZ3RoKTtcblx0XHRcdC8vIEF2b2lkIHRoZSBgaW5kZXhPZmAgY2FsbCBpZiBubyBtYXRjaCBpcyBwb3NzaWJsZVxuXHRcdFx0aWYgKHNlYXJjaExlbmd0aCArIHN0YXJ0ID4gc3RyaW5nTGVuZ3RoKSB7XG5cdFx0XHRcdHJldHVybiBmYWxzZTtcblx0XHRcdH1cblx0XHRcdHZhciBpbmRleCA9IC0xO1xuXHRcdFx0d2hpbGUgKCsraW5kZXggPCBzZWFyY2hMZW5ndGgpIHtcblx0XHRcdFx0aWYgKHN0cmluZy5jaGFyQ29kZUF0KHN0YXJ0ICsgaW5kZXgpICE9IHNlYXJjaFN0cmluZy5jaGFyQ29kZUF0KGluZGV4KSkge1xuXHRcdFx0XHRcdHJldHVybiBmYWxzZTtcblx0XHRcdFx0fVxuXHRcdFx0fVxuXHRcdFx0cmV0dXJuIHRydWU7XG5cdFx0fTtcblx0XHRpZiAoZGVmaW5lUHJvcGVydHkpIHtcblx0XHRcdGRlZmluZVByb3BlcnR5KFN0cmluZy5wcm90b3R5cGUsICdzdGFydHNXaXRoJywge1xuXHRcdFx0XHQndmFsdWUnOiBzdGFydHNXaXRoLFxuXHRcdFx0XHQnY29uZmlndXJhYmxlJzogdHJ1ZSxcblx0XHRcdFx0J3dyaXRhYmxlJzogdHJ1ZVxuXHRcdFx0fSk7XG5cdFx0fSBlbHNlIHtcblx0XHRcdFN0cmluZy5wcm90b3R5cGUuc3RhcnRzV2l0aCA9IHN0YXJ0c1dpdGg7XG5cdFx0fVxuXHR9KCkpO1xufVxuXG59KTsiLCJjb25zdCBlcnJvcnMgPSB7XG4gIC8qIHNpZ25pbiAqL1xuICAnc2lnbmluLmdlbmVyaWMuZXJyb3InOiB7XG4gICAgJ3NpZ25pbi5wYXNzd29yZCc6IHtcbiAgICAgIG1zZzogJ1NlcnZlciBlcnJvci4gUGxlYXNlIHRyeSBhZ2FpbiBsYXRlci4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgICAnc2lnbmluLnVzZXJOYW1lJzoge1xuICAgICAgbXNnOiAnJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdzaWduaW4uZGVuaWVkLmVycm9yJzoge1xuICAgICdzaWduaW4ucGFzc3dvcmQnOiB7XG4gICAgICBtc2c6ICdTZXJ2ZXIgZXJyb3IuIFBsZWFzZSB0cnkgYWdhaW4gbGF0ZXIuJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gICAgJ3NpZ25pbi51c2VyTmFtZSc6IHtcbiAgICAgIG1zZzogJycsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAnc2lnbmluLnVuYXV0aG9yaXplZCc6IHtcbiAgICAnc2lnbmluLnBhc3N3b3JkJzoge1xuICAgICAgbXNnOiAnU29ycnksIHdlIGRvblxcJ3QgcmVjb2duaXNlIHlvdXIgdXNlcm5hbWUgb3IgcGFzc3dvcmQuJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gICAgJ3NpZ25pbi51c2VyTmFtZSc6IHtcbiAgICAgIG1zZzogJycsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAnc2lnbmluLmdlbmVyaWMuYmFubmVkJzoge1xuICAgICdzaWduaW4ucGFzc3dvcmQnOiB7XG4gICAgICBtc2c6ICdUaGlzIHVzZXIgaGFzIGJlZW4gYmFubmVkIGZvciBhbiB1bnNwZWNpZmllZCByZWFzb24uJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gICAgJ3NpZ25pbi51c2VyTmFtZSc6IHtcbiAgICAgIG1zZzogJycsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAnc2lnbmluLmJhbm5lZCc6IHtcbiAgICAnc2lnbmluLnBhc3N3b3JkJzoge1xuICAgICAgbXNnOiAnVGhpcyB1c2VyIGhhcyBiZWVuIGJhbm5lZC4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgICAnc2lnbmluLnVzZXJOYW1lJzoge1xuICAgICAgbXNnOiAnJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdzaWduaW4uZGlzYXBwcm92ZWQnOiB7XG4gICAgJ3NpZ25pbi5wYXNzd29yZCc6IHtcbiAgICAgIG1zZzogJ1RoaXMgdXNlciBoYXMgYmVlbiBkaXNhcHByb3ZlZC4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgICAnc2lnbmluLnVzZXJOYW1lJzoge1xuICAgICAgbXNnOiAnJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdzaWduaW4ucG9zc2libGUgc3BhbSBhY3Rpdml0eSc6IHtcbiAgICAnc2lnbmluLnBhc3N3b3JkJzoge1xuICAgICAgbXNnOiAnVGhpcyB1c2VyIGhhcyBiZWVuIGlkZW50aWZpZWQgYXMgcG9zc2libGUgc3BhbW1lci4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgICAnc2lnbmluLnVzZXJOYW1lJzoge1xuICAgICAgbXNnOiAnJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdzaWduaW4ubG9ja2VkIG91dCc6IHtcbiAgICAnc2lnbmluLnBhc3N3b3JkJzoge1xuICAgICAgbXNnOiAnVGhpcyB1c2VyIGhhcyBiZWVuIGxvY2tlZCBvdXQuJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gICAgJ3NpZ25pbi51c2VyTmFtZSc6IHtcbiAgICAgIG1zZzogJycsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAnc2lnbmluLmlkZW50aWZpY2F0aW9uLmFueS5lbXB0eSc6IHtcbiAgICAnc2lnbmluLnVzZXJOYW1lJzoge1xuICAgICAgbXNnOiAnUGxlYXNlIGVudGVyIHlvdXIgdXNlcm5hbWUuJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdzaWduaW4ucGFzc3dvcmQuYW55LmVtcHR5Jzoge1xuICAgICdzaWduaW4ucGFzc3dvcmQnOiB7XG4gICAgICBtc2c6ICdQbGVhc2UgZW50ZXIgeW91ciBwYXNzd29yZC4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgJ3NpZ25pbi5ndWFyZGlhbkVtYWlsLm5vdFlldEdyYW50ZWQnOiB7XG4gICAgJ3NpZ25pbi5wYXNzd29yZCc6IHtcbiAgICAgIG1zZzogJ1lvdXIgcGFyZW50IC8gZ3VhcmRpYW4gaGFzIG5vdCB5ZXQgZ3JhbnRlZCB5b3UgYWNjZXNzLicsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAnc2lnbmluLmd1YXJkaWFuRW1haWwuZGVuaWVkJzoge1xuICAgICdzaWduaW4ucGFzc3dvcmQnOiB7XG4gICAgICBtc2c6ICdZb3VyIHBhcmVudCAvIGd1YXJkaWFuIGhhcyBkZW5pZWQgeW91IGFjY2Vzcy4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgLyogcmVnaXN0cmF0aW9uICovXG4gICdyZWdpc3RyYXRpb24uZ2VuZXJpYy5lcnJvcic6IHtcbiAgICAncmVnaXN0cmF0aW9uLnBhc3N3b3JkJzoge1xuICAgICAgbXNnOiAnU2VydmVyIGVycm9yLiBQbGVhc2UgdHJ5IGFnYWluIGxhdGVyLicsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAncmVnaXN0cmF0aW9uLmRlbmllZC5lcnJvcic6IHtcbiAgICAncmVnaXN0cmF0aW9uLnBhc3N3b3JkJzoge1xuICAgICAgbXNnOiAnVGhpcyB1c2VyIGlzIG5vdCBhbGxvd2VkIHRvIHJlZ2lzdGVyLiBQbGVhc2UgY29udGFjdCBjdXN0b21lciBzdXBwb3J0LicsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAncmVnaXN0cmF0aW9uLi5zcGFtJzoge1xuICAgICdyZWdpc3RyYXRpb24ucGFzc3dvcmQnOiB7XG4gICAgICBtc2c6ICdDb250YWN0IGN1c3RvbWVyIHN1cHBvcnQnLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgJ3JlZ2lzdHJhdGlvbi51c2VybmFtZS5hbnkuZW1wdHknOiB7XG4gICAgJ3JlZ2lzdHJhdGlvbi51c2VybmFtZSc6IHtcbiAgICAgIG1zZzogJ1BsZWFzZSBjaG9vc2UgYSB1c2VybmFtZS4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgJ3JlZ2lzdHJhdGlvbi51c2VybmFtZS5zdHJpbmcubWluJzoge1xuICAgICdyZWdpc3RyYXRpb24udXNlcm5hbWUnOiB7XG4gICAgICBtc2c6ICdVc2VybmFtZXMgbXVzdCBiZSBhdCBsZWFzdCB0aHJlZSBjaGFyYWN0ZXJzIGxvbmcuJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdyZWdpc3RyYXRpb24udXNlcm5hbWUuc3RyaW5nLm1heCc6IHtcbiAgICAncmVnaXN0cmF0aW9uLnVzZXJuYW1lJzoge1xuICAgICAgbXNnOiAnVXNlcm5hbWVzIG11c3QgYmUgbm8gbW9yZSB0aGFuIDMwIGNoYXJhY3RlcnMgbG9uZy4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgJ3JlZ2lzdHJhdGlvbi5lbWFpbC5kdXBsaWNhdGUnOiB7XG4gICAgJ3JlZ2lzdHJhdGlvbi5lbWFpbCc6IHtcbiAgICAgIG1zZzogJ1RoaXMgZW1haWwgYWRkcmVzcyBoYXMgYWxyZWFkeSBiZWVuIHJlZ2lzdGVyZWQuJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdyZWdpc3RyYXRpb24uZW1haWwuc3RyaW5nLmVtYWlsJzoge1xuICAgICdyZWdpc3RyYXRpb24uZW1haWwnOiB7XG4gICAgICBtc2c6ICdQbGVhc2UgZW50ZXIgYSB2YWxpZCBlbWFpbCBhZGRyZXNzLicsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAncmVnaXN0cmF0aW9uLmVtYWlsLmFueS5lbXB0eSc6IHtcbiAgICAncmVnaXN0cmF0aW9uLmVtYWlsJzoge1xuICAgICAgbXNnOiAnUGxlYXNlIGVudGVyIGFuIGVtYWlsIGFkZHJlc3MuJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdyZWdpc3RyYXRpb24udXNlcm5hbWUuc3RyaW5nLnJlZ2V4LmJhc2UnOiB7XG4gICAgJ3JlZ2lzdHJhdGlvbi51c2VybmFtZSc6IHtcbiAgICAgIG1zZzogJ1VzZXJuYW1lcyBjYW4gb25seSBjb250YWluIGxldHRlcnMsIG51bWJlcnMgYW5kIHRoZSBjaGFyYWN0ZXJzIF8gb3IgLS4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgJ3JlZ2lzdHJhdGlvbi51c2VybmFtZS5kdXBsaWNhdGUnOiB7XG4gICAgJ3JlZ2lzdHJhdGlvbi51c2VybmFtZSc6IHtcbiAgICAgIG1zZzogJ1RoaXMgdXNlcm5hbWUgaGFzIGFscmVhZHkgYmVlbiB0YWtlbi4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgJ3JlZ2lzdHJhdGlvbi5wYXNzd29yZC5hbnkuZW1wdHknOiB7XG4gICAgJ3JlZ2lzdHJhdGlvbi5wYXNzd29yZCc6IHtcbiAgICAgIG1zZzogJ1BsZWFzZSBjaG9vc2UgYSBwYXNzd29yZC4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgJ3JlZ2lzdHJhdGlvbi5wYXNzd29yZC5zdHJpbmcubWluJzoge1xuICAgICdyZWdpc3RyYXRpb24ucGFzc3dvcmQnOiB7XG4gICAgICBtc2c6ICdZb3VyIHBhc3N3b3JkIG11c3QgYmUgYXQgbGVhc3Qgc2l4IGNoYXJhY3RlcnMgbG9uZy4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgJ3JlZ2lzdHJhdGlvbi5maXJzdE5hbWUuYW55LmVtcHR5Jzoge1xuICAgICdyZWdpc3RyYXRpb24uZmlyc3ROYW1lJzoge1xuICAgICAgbXNnOiAnUGxlYXNlIHRlbGwgdXMgeW91ciBmaXJzdCBuYW1lLicsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAncmVnaXN0cmF0aW9uLmxhc3ROYW1lLmFueS5lbXB0eSc6IHtcbiAgICAncmVnaXN0cmF0aW9uLmxhc3ROYW1lJzoge1xuICAgICAgbXNnOiAnUGxlYXNlIHRlbGwgdXMgeW91ciBsYXN0IG5hbWUuJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdyZWdpc3RyYXRpb24uZGF0ZU9mQmlydGguaW5jb21wbGV0ZSc6IHtcbiAgICAvLyBuZWNlc3NhcnkgZm9yIGEgaW52YWxpZCBkYXRlXG4gIH0sXG4gICdyZWdpc3RyYXRpb24uZGF0ZU9mQmlydGguaW52YWxpZCc6IHtcbiAgICAncmVnaXN0cmF0aW9uLmRhdGVPZkJpcnRoJzoge1xuICAgICAgbXNnOiAnVGhlIGRhdGUgaXMgbm90IHZhbGlkLicsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAncmVnaXN0cmF0aW9uLmRhdGVPZkJpcnRoLmZ1dHVyZSc6IHtcbiAgICAncmVnaXN0cmF0aW9uLmRhdGVPZkJpcnRoJzoge1xuICAgICAgbXNnOiAnVGhlIGRhdGUgb2YgYmlydGggc2hvdWxkIGJlIHNldCBpbiB0aGUgcGFzdC4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgJ3JlZ2lzdHJhdGlvbi5kYXRlT2ZCaXJ0aC50b29Zb3VuZyc6IHtcbiAgICAncmVnaXN0cmF0aW9uLmRhdGVPZkJpcnRoJzoge1xuICAgICAgbXNnOiAnWW91IHNob3VsZCBiZSBhdCBsZWFzdCAyIHllYXJzIG9sZC4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgJ3JlZ2lzdHJhdGlvbi5kYXRlT2ZCaXJ0aC50b29PbGQnOiB7XG4gICAgJ3JlZ2lzdHJhdGlvbi5kYXRlT2ZCaXJ0aCc6IHtcbiAgICAgIG1zZzogJ0FyZSB5b3UgcmVhbGx5IG9sZGVyIHRoYW4gMTIwIHllYXJzIG9sZD8nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgJ3JlZ2lzdHJhdGlvbi5ndWFyZGlhbkVtYWlsLnN0cmluZy5lbWFpbCc6IHtcbiAgICAncmVnaXN0cmF0aW9uLmd1YXJkaWFuRW1haWwnOiB7XG4gICAgICBtc2c6ICdUaGUgZ3VhcmRpYW4gZW1haWwgc2hvdWxkIGJlIGEgdmFsaWQgZW1haWwuJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdyZWdpc3RyYXRpb24uZ3VhcmRpYW5FbWFpbC5hbnkuZW1wdHknOiB7XG4gICAgJ3JlZ2lzdHJhdGlvbi5ndWFyZGlhbkVtYWlsJzoge1xuICAgICAgbXNnOiAnVGhlIGd1YXJkaWFuIGVtYWlsIG9yIFRlcyBUZWFjaCBjbGFzcyBjb2RlIHNob3VsZCBub3QgYmUgZW1wdHkuJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdyZWdpc3RyYXRpb24uY2xhc3NDb2RlLmFueS5lbXB0eSc6IHtcbiAgICAncmVnaXN0cmF0aW9uLmNsYXNzQ29kZSc6IHtcbiAgICAgIG1zZzogJ0VpdGhlciB0aGUgVGVzIFRlYWNoIGNsYXNzIGNvZGUgb3IgZ3VhcmRpYW4gZW1haWwgbXVzdCBiZSBmaWxsZWQgaW4uJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdyZWdpc3RyYXRpb24uY2xhc3NDb2RlLmludmFsaWQnOiB7XG4gICAgJ3JlZ2lzdHJhdGlvbi5jbGFzc0NvZGUnOiB7XG4gICAgICBtc2c6ICdUaGUgVGVzIFRlYWNoIGNsYXNzIGNvZGUgaXMgbm90IHZhbGlkLicsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAvKiBnb29nbGUgKi9cbiAgJ2dvb2dsZS5nZW5lcmljLmVycm9yJzoge1xuICAgICdnZW5lcmljLmdvb2dsZWJ1dHRvbic6IHtcbiAgICAgIG1zZzogJ0dvb2dsZSBlcnJvci4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgJ2dvb2dsZS51bmF1dGhvcml6ZWQnOiB7XG4gICAgJ2dlbmVyaWMuZ29vZ2xlYnV0dG9uJzoge1xuICAgICAgbXNnOiAnU29ycnksIEdvb2dsZSBjb3VsZG5cXCd0IGF1dGhvcmlzZSB0aGlzIHVzZXIuJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdmYWNlYm9vay51bmF1dGhvcml6ZWQnOiB7XG4gICAgJ2dlbmVyaWMuZ29vZ2xlYnV0dG9uJzoge1xuICAgICAgbXNnOiAnU29ycnksIEZhY2Vib29rIGNvdWxkblxcJ3QgYXV0aG9yaXNlIHRoaXMgdXNlci4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgJ2dvb2dsZS5wb3B1cC5jbG9zZWQnOiB7XG4gICAgJ2dlbmVyaWMuZ29vZ2xlYnV0dG9uJzoge1xuICAgICAgbXNnOiAnVGhlIEdvb2dsZSBwb3B1cCBoYXMgYmVlbiBjbG9zZWQuJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdmYWNlYm9vay5wb3B1cC5jbG9zZWQnOiB7XG4gICAgJ2dlbmVyaWMuZ29vZ2xlYnV0dG9uJzoge1xuICAgICAgbXNnOiAnVGhlIEZhY2Vib29rIHBvcHVwIGhhcyBiZWVuIGNsb3NlZC4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgJ2dvb2dsZS5wb3B1cC5ibG9ja2VkJzoge1xuICAgICdnZW5lcmljLmdvb2dsZWJ1dHRvbic6IHtcbiAgICAgIG1zZzogJ1RoZSBHb29nbGUgcG9wdXAgbWF5IGhhdmUgYmVlbiBibG9ja2VkIGJ5IHlvdXIgYnJvd3Nlci4gUGxlYXNlIGNoZWNrIHlvdXIgc2V0dGluZ3MuJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdmYWNlYm9vay5wb3B1cC5ibG9ja2VkJzoge1xuICAgICdnZW5lcmljLmdvb2dsZWJ1dHRvbic6IHtcbiAgICAgIG1zZzogJ1RoZSBGYWNlYm9vayBwb3B1cCBtYXkgaGF2ZSBiZWVuIGJsb2NrZWQgYnkgeW91ciBicm93c2VyLiBQbGVhc2UgY2hlY2sgeW91ciBzZXR0aW5ncy4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgJ2dvb2dsZS51c2VyZXJyb3InOiB7XG4gICAgJ2dlbmVyaWMuZ29vZ2xlYnV0dG9uJzoge1xuICAgICAgbXNnOiAnU29ycnksIEdvb2dsZSBjb3VsZG5cXCd0IHJlZ2lzdGVyIG9yIGxvZyBpbiB0aGlzIHVzZXIuJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdmYWNlYm9vay51c2VyZXJyb3InOiB7XG4gICAgJ2dlbmVyaWMuZ29vZ2xlYnV0dG9uJzoge1xuICAgICAgbXNnOiAnU29ycnksIEZhY2Vib29rIGNvdWxkblxcJ3QgcmVnaXN0ZXIgb3IgbG9nIGluIHRoaXMgdXNlci4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgLyogZm9yZ290LXBhc3N3b3JkICovXG4gICdmb3Jnb3QtcGFzc3dvcmQuZ2VuZXJpYy5lcnJvcic6IHtcbiAgICAnZm9yZ290LXBhc3N3b3JkLmlkZW50aWZpY2F0aW9uJzoge1xuICAgICAgbXNnOiAnU2VydmVyIGVycm9yLiBQbGVhc2UgdHJ5IGFnYWluIGxhdGVyLicsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAnZm9yZ290LXBhc3N3b3JkLmRlbmllZC5lcnJvcic6IHtcbiAgICAnZm9yZ290LXBhc3N3b3JkLmlkZW50aWZpY2F0aW9uJzoge1xuICAgICAgbXNnOiAnVGhpcyB1c2VyIGlzIG5vdCBhbGxvd2VkIHRvIHJlc2V0IHRoZSBwYXNzd29yZC4gUGxlYXNlIGNvbnRhY3QgY3VzdG9tZXIgc3VwcG9ydC4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgJ2ZvcmdvdC1wYXNzd29yZC5lbWFpbC5zdHJpbmcuZW1haWwnOiB7XG4gICAgJ2ZvcmdvdC1wYXNzd29yZC5pZGVudGlmaWNhdGlvbic6IHtcbiAgICAgIG1zZzogJ1BsZWFzZSBlbnRlciB5b3VyIGVtYWlsIGFkZHJlc3MuJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdmb3Jnb3QtcGFzc3dvcmQuZW1haWwuYW55LmVtcHR5Jzoge1xuICAgICdmb3Jnb3QtcGFzc3dvcmQuaWRlbnRpZmljYXRpb24nOiB7XG4gICAgICBtc2c6ICdQbGVhc2UgZW50ZXIgeW91ciBlbWFpbCBhZGRyZXNzLicsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAnZm9yZ290LXBhc3N3b3JkLnVzZXIubm90LWZvdW5kJzoge1xuICAgICdmb3Jnb3QtcGFzc3dvcmQuaWRlbnRpZmljYXRpb24nOiB7XG4gICAgICBtc2c6ICdTb3JyeSwgd2UgZG9uXFwndCByZWNvZ25pc2UgdGhhdCBlbWFpbCBhZGRyZXNzLicsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAnZm9yZ290LXBhc3N3b3JkLmdlbmVyaWMuYmFubmVkJzoge1xuICAgICdmb3Jnb3QtcGFzc3dvcmQuaWRlbnRpZmljYXRpb24nOiB7XG4gICAgICBtc2c6ICdUaGlzIHVzZXIgaGFzIGJlZW4gYmFubmVkIGZvciBhbiB1bnNwZWNpZmllZCByZWFzb24uJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdmb3Jnb3QtcGFzc3dvcmQuYmFubmVkJzoge1xuICAgICdmb3Jnb3QtcGFzc3dvcmQuaWRlbnRpZmljYXRpb24nOiB7XG4gICAgICBtc2c6ICdUaGlzIHVzZXIgaGFzIGJlZW4gYmFubmVkLicsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAnZm9yZ290LXBhc3N3b3JkLmRpc2FwcHJvdmVkJzoge1xuICAgICdmb3Jnb3QtcGFzc3dvcmQuaWRlbnRpZmljYXRpb24nOiB7XG4gICAgICBtc2c6ICdUaGlzIHVzZXIgaGFzIGJlZW4gZGlzYXBwcm92ZWQuJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdmb3Jnb3QtcGFzc3dvcmQucG9zc2libGUgc3BhbSBhY3Rpdml0eSc6IHtcbiAgICAnZm9yZ290LXBhc3N3b3JkLmlkZW50aWZpY2F0aW9uJzoge1xuICAgICAgbXNnOiAnVGhpcyB1c2VyIGhhcyBiZWVuIGlkZW50aWZpZWQgYXMgcG9zc2libGUgc3BhbW1lci4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgJ2ZvcmdvdC1wYXNzd29yZC5sb2NrZWQgb3V0Jzoge1xuICAgICdmb3Jnb3QtcGFzc3dvcmQuaWRlbnRpZmljYXRpb24nOiB7XG4gICAgICBtc2c6ICdUaGlzIHVzZXIgaGFzIGJlZW4gbG9ja2VkIG91dC4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgLyogcmVzZW5kLWNvbmZpcm1hdGlvbi1lbWFpbCAqL1xuICAncmVzZW5kLWNvbmZpcm1hdGlvbi1lbWFpbC5nZW5lcmljLmVycm9yJzoge1xuICAgIHN1Ym1pdHRlZDogdHJ1ZSxcbiAgICAncmVzZW5kLWNvbmZpcm1hdGlvbi1lbWFpbCc6IHtcbiAgICAgIG1zZzogJ1NlcnZlciBlcnJvci4gUGxlYXNlIHRyeSBhZ2FpbiBsYXRlci4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgJ3Jlc2VuZC1jb25maXJtYXRpb24tZW1haWwuZW1haWwuYW55LmVtcHR5Jzoge1xuICAgIHN1Ym1pdHRlZDogdHJ1ZSxcbiAgICAncmVzZW5kLWNvbmZpcm1hdGlvbi1lbWFpbCc6IHtcbiAgICAgIG1zZzogJ1BsZWFzZSBlbnRlciBhbiBlbWFpbCBhZGRyZXNzLicsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAncmVzZW5kLWNvbmZpcm1hdGlvbi1lbWFpbC5lbWFpbC5zdHJpbmcuZW1haWwnOiB7XG4gICAgc3VibWl0dGVkOiB0cnVlLFxuICAgICdyZXNlbmQtY29uZmlybWF0aW9uLWVtYWlsJzoge1xuICAgICAgbXNnOiAnUGxlYXNlIGVudGVyIGEgdmFsaWQgZW1haWwgYWRkcmVzcy4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgJ3Jlc2VuZC1jb25maXJtYXRpb24tZW1haWwuZ2VuZXJpYy1zdWNjZXNzJzoge1xuICAgIHN1Ym1pdHRlZDogdHJ1ZSxcbiAgICBzdWNjZXNzOiB0cnVlLFxuICB9LFxuICAncmVzZXQtcGFzc3dvcmQuaW52YWxpZC10b2tlbic6IHtcbiAgICBzdWJtaXR0ZWQ6IHRydWUsXG4gICAgJ3Jlc2V0LXBhc3N3b3JkJzoge1xuICAgICAgbXNnOiAnU29ycnksIHRoYXQgcmVzZXQgbGluayBkaWRuXFwndCB3b3JrLiBQbGVhc2UgdHJ5IGEgbmV3IG9uZS4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgLyogcmVzZXQtcGFzc3dvcmQgKi9cbiAgJ3Jlc2V0LXBhc3N3b3JkLmdlbmVyaWMuZXJyb3InOiB7XG4gICAgc3VibWl0dGVkOiB0cnVlLFxuICAgICdyZXNldC1wYXNzd29yZCc6IHtcbiAgICAgIG1zZzogJ1NvcnJ5LCB3ZSB3ZXJlblxcJ3QgYWJsZSB0byBjaGFuZ2UgeW91ciBwYXNzd29yZC4gUGxlYXNlIHRyeSBhZ2FpbiBsYXRlci4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgJ3Jlc2V0LXBhc3N3b3JkLnNlcnZlci1lcnJvcic6IHtcbiAgICBzdWJtaXR0ZWQ6IHRydWUsXG4gICAgJ3Jlc2V0LXBhc3N3b3JkJzoge1xuICAgICAgbXNnOiAnU29ycnksIHdlIHdlcmVuXFwndCBhYmxlIHRvIGNoYW5nZSB5b3VyIHBhc3N3b3JkLiBQbGVhc2UgdHJ5IGFnYWluIGxhdGVyLicsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAncmVzZXQtcGFzc3dvcmQudG9rZW4tZXJyb3InOiB7XG4gICAgc3VibWl0dGVkOiB0cnVlLFxuICAgICdyZXNldC1wYXNzd29yZCc6IHtcbiAgICAgIG1zZzogJ1NvcnJ5LCB0aGlzIGxpbmsgaXMgbm90IHZhbGlkIGFueSBtb3JlLiBDYW4geW91IGFzayBmb3IgYSBuZXcgb25lPycsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAncmVzZXQtcGFzc3dvcmQudW5hYmxlJzoge1xuICAgIHN1Ym1pdHRlZDogdHJ1ZSxcbiAgICAncmVzZXQtcGFzc3dvcmQnOiB7XG4gICAgICBtc2c6ICdTb3JyeSwgV2UgYXJlIHVuYWJsZSB0byBjaGFuZ2UgdGhlIHBhc3N3b3JkLCBoYXZlIHlvdSBhbHJlYWR5IGNoYW5nZWQgaXQ/JyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdyZXNldC1wYXNzd29yZC5ibG9ja2VkJzoge1xuICAgIHN1Ym1pdHRlZDogdHJ1ZSxcbiAgICAncmVzZXQtcGFzc3dvcmQnOiB7XG4gICAgICBtc2c6ICdTb3JyeSwgVGhpcyB1c2VyIGlzIGJsb2NrZWQvYmFubmVkLiBDb250YWN0IGN1c3RvbWVyIHN1cHBvcnQuJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdyZXNldC1wYXNzd29yZC5nZW5lcmljLXN1Y2Nlc3MnOiB7XG4gICAgc3VibWl0dGVkOiB0cnVlLFxuICAgIHN1Y2Nlc3M6IHRydWUsXG4gIH0sXG4gICdlZGl0LWFjY291bnQuZ2VuZXJpYy5lcnJvcic6IHtcbiAgICAnZWRpdC1hY2NvdW50LnVzZXJUeXBlJzoge1xuICAgICAgbXNnOiAnU29ycnksIHdlIHdlcmVuXFwndCBhYmxlIHRvIHVwZGF0ZSB5b3VyIGFjY291bnQuIFBsZWFzZSB0cnkgYWdhaW4gbGF0ZXIuJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gICAgJ2VkaXQtYWNjb3VudC5tZXNzYWdlJzoge1xuICAgICAgbXNnOiAnU29ycnksIHdlIHdlcmVuXFwndCBhYmxlIHRvIHVwZGF0ZSB5b3VyIGFjY291bnQuIFBsZWFzZSB0cnkgYWdhaW4gbGF0ZXIuJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdlZGl0LWFjY291bnQudXNlclR5cGUuYW55LmFsbG93T25seSc6IHtcbiAgICAnZWRpdC1hY2NvdW50LnVzZXJUeXBlJzoge1xuICAgICAgbXNnOiAnVGhlIHVzZXIgdHlwZSBpcyBub3QgY29ycmVjdCwgcGxlYXNlIHBpY2sgb25lJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdlZGl0LWFjY291bnQuZmlyc3ROYW1lLmFueS5lbXB0eSc6IHtcbiAgICAnZWRpdC1hY2NvdW50LmZpcnN0TmFtZSc6IHtcbiAgICAgIG1zZzogJ1BsZWFzZSB0ZWxsIHVzIHlvdXIgZmlyc3QgbmFtZS4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgJ2VkaXQtYWNjb3VudC5sYXN0TmFtZS5hbnkuZW1wdHknOiB7XG4gICAgJ2VkaXQtYWNjb3VudC5sYXN0TmFtZSc6IHtcbiAgICAgIG1zZzogJ1BsZWFzZSB0ZWxsIHVzIHlvdXIgbGFzdCBuYW1lLicsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAnZWRpdC1hY2NvdW50LmVtYWlsLmR1cGxpY2F0ZSc6IHtcbiAgICAnZWRpdC1hY2NvdW50LmVtYWlsJzoge1xuICAgICAgbXNnOiAnVGhpcyBlbWFpbCBhZGRyZXNzIGhhcyBhbHJlYWR5IGJlZW4gcmVnaXN0ZXJlZC4nLFxuICAgICAgc3RhdGU6ICdlcnJvcicsXG4gICAgfSxcbiAgfSxcbiAgJ2VkaXQtYWNjb3VudC5lbWFpbC5zdHJpbmcuZW1haWwnOiB7XG4gICAgJ2VkaXQtYWNjb3VudC5lbWFpbCc6IHtcbiAgICAgIG1zZzogJ1BsZWFzZSBlbnRlciBhIHZhbGlkIGVtYWlsIGFkZHJlc3MuJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdlZGl0LWFjY291bnQuZW1haWwuYW55LmVtcHR5Jzoge1xuICAgICdlZGl0LWFjY291bnQuZW1haWwnOiB7XG4gICAgICBtc2c6ICdQbGVhc2UgZW50ZXIgeW91ciBlbWFpbCBhZGRyZXNzLicsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAnY2hhbmdlLXBhc3N3b3JkLmdlbmVyaWMuZXJyb3InOiB7XG4gICAgJ2NoYW5nZS1wYXNzd29yZC5wYXNzd29yZCc6IHtcbiAgICAgIG1zZzogJ1NvcnJ5LCB3ZSB3ZXJlblxcJ3QgYWJsZSB0byB1cGRhdGUgeW91ciBhY2NvdW50LiBQbGVhc2UgdHJ5IGFnYWluIGxhdGVyLicsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAnY2hhbmdlLXBhc3N3b3JkLnBhc3N3b3JkLnN0cmluZy5taW4nOiB7XG4gICAgJ2NoYW5nZS1wYXNzd29yZC5wYXNzd29yZCc6IHtcbiAgICAgIG1zZzogJ1lvdXIgcGFzc3dvcmQgbXVzdCBiZSBhdCBsZWFzdCBzaXggY2hhcmFjdGVycyBsb25nLicsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAnY2hhbmdlLXBhc3N3b3JkLm9sZHBhc3N3b3JkLndyb25nJzoge1xuICAgICdjaGFuZ2UtcGFzc3dvcmQub2xkUGFzc3dvcmQnOiB7XG4gICAgICBtc2c6ICdZb3VyIHBhc3N3b3JkIGlzIG5vdCBjb3JyZWN0LCBwbGVhc2UgdHJ5IGVudGVyaW5nIGl0IGFnYWluLicsXG4gICAgICBzdGF0ZTogJ2Vycm9yJyxcbiAgICB9LFxuICB9LFxuICAnY2hhbmdlLXBhc3N3b3JkLnNhbWVwYXNzd29yZCc6IHtcbiAgICAnY2hhbmdlLXBhc3N3b3JkLnBhc3N3b3JkJzoge1xuICAgICAgbXNnOiAnVGhlIG5ldyBwYXNzd29yZCBpcyB0aGUgc2FtZSBhcyB0aGUgcHJldmlvdXMgcGFzc3dvcmQuJyxcbiAgICAgIHN0YXRlOiAnZXJyb3InLFxuICAgIH0sXG4gIH0sXG4gICdjaGFuZ2UtcGFzc3dvcmQub2snOiB7XG4gICAgJ2NoYW5nZS1wYXNzd29yZC5tZXNzYWdlJzoge1xuICAgICAgbXNnOiAnWW91IGhhdmUgc3VjY2VzZnVsbHkgY2hhbmdlZCB5b3VyIHBhc3N3b3JkLicsXG4gICAgICBzdGF0ZTogJ3N1Y2Nlc3MnLFxuICAgIH0sXG4gIH0sXG59O1xuXG5leHBvcnQgZGVmYXVsdCAoY29kZXMpID0+IHtcbiAgaWYgKCFjb2RlcykgcmV0dXJuIHt9O1xuICBjb25zdCBlcnJvckNvZGVzID0gY29kZXMuc3BsaXQoJywnKTtcbiAgY29uc3QgdmFsaWRFcnJvckNvZGVzID0gZXJyb3JDb2Rlc1xuICAgIC5maWx0ZXIoY29kZSA9PiBjb2RlIGluIGVycm9ycyk7XG5cbiAgaWYgKHZhbGlkRXJyb3JDb2Rlcy5sZW5ndGggPT09IDApIHtcbiAgICBjb25zdCBwcmVmaXggPSBlcnJvckNvZGVzWzBdLnNwbGl0KCcuJywgMSk7XG4gICAgdmFsaWRFcnJvckNvZGVzLnB1c2goYCR7cHJlZml4fS5nZW5lcmljLmVycm9yYCk7XG4gIH1cblxuICByZXR1cm4gdmFsaWRFcnJvckNvZGVzXG4gICAgLm1hcChjb2RlID0+IGVycm9yc1tjb2RlXSlcbiAgICAucmVkdWNlKChwcmV2aW91cywgY3VycmVudCkgPT4gT2JqZWN0LmFzc2lnbih7fSwgcHJldmlvdXMsIGN1cnJlbnQpLCB7fSk7XG59O1xuIiwiaW1wb3J0IFJlYWN0LCB7IFByb3BUeXBlcywgQ29tcG9uZW50IH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IFNpZ25pbiBmcm9tICcuL1NpZ25pbic7XG5pbXBvcnQgRm9yZ290UGFzc3dvcmQgZnJvbSAnLi9Gb3Jnb3RQYXNzd29yZCc7XG5pbXBvcnQgU2VsZWN0UG9zaXRpb24gZnJvbSAnLi9TZWxlY3RQb3NpdGlvbic7XG5pbXBvcnQgTG9nZ2VkSW5VcGRhdGUgZnJvbSAnLi9Mb2dnZWRJblVwZGF0ZSc7XG5pbXBvcnQgTG9nZ2VkSW5TZWxlY3QgZnJvbSAnLi9Mb2dnZWRJblNlbGVjdFBvc2l0aW9uJztcbmltcG9ydCBSZWdpc3RlciBmcm9tICcuL1JlZ2lzdGVyJztcbmltcG9ydCB7IGNvbm5lY3QgfSBmcm9tICdyZWFjdC1yZWR1eCc7XG5pbXBvcnQgeyBiaW5kQWN0aW9uQ3JlYXRvcnMgfSBmcm9tICdyZWR1eCc7XG5pbXBvcnQgKiBhcyBhY3Rpb25DcmVhdG9ycyBmcm9tICcuLi9yZWR1Y2Vycy9hY3Rpb25zJztcblxuZnVuY3Rpb24gVGVzTW9kYWxDb250YWluZXIoeyBoYXNXcmFwcGVyLCBub1dyYXBwZXJTdHlsZSwgY2hpbGRyZW4gfSkge1xuICBpZiAoIWhhc1dyYXBwZXIpIHJldHVybiA8ZGl2IHN0eWxlPXtub1dyYXBwZXJTdHlsZX0+e2NoaWxkcmVufTwvZGl2PjtcbiAgcmV0dXJuIChcbiAgICA8ZGl2IGNsYXNzTmFtZT1cInRlcy1tb2RhbF9fYm9keVwiPlxuICAgICAge2NoaWxkcmVufVxuICAgIDwvZGl2PlxuICApO1xufVxuXG5UZXNNb2RhbENvbnRhaW5lci5wcm9wVHlwZXMgPSB7XG4gIGhhc1dyYXBwZXI6IFByb3BUeXBlcy5ib29sLFxuICBub1dyYXBwZXJTdHlsZTogUHJvcFR5cGVzLm9iamVjdCxcbn07XG5cbmV4cG9ydCBjbGFzcyBBcHAgZXh0ZW5kcyBDb21wb25lbnQge1xuICBjb21wb25lbnREaWRNb3VudCgpIHtcbiAgICB0aGlzLnByb3BzLmFjdGlvbnMudHJhY2tEaXNwbGF5KHRoaXMucHJvcHMuY29tbW9uLmZvcm1UeXBlKTtcbiAgICBpZiAoIXRoaXMucHJvcHMuY29tbW9uLmlzTW9kYWwgJiYgIXRoaXMucHJvcHMuY29tbW9uLmlzSW5saW5lKSB7XG4gICAgICB0aGlzLnByb3BzLmFjdGlvbnMuZmFpbFJlZ2lzdGVyKHRoaXMucHJvcHMuZXJyb3JzKTtcbiAgICAgIHRoaXMucHJvcHMuYWN0aW9ucy5mYWlsU2lnbkluKHRoaXMucHJvcHMuZXJyb3JzKTtcbiAgICB9XG4gIH1cblxuICByZW5kZXIoKSB7XG4gICAgY29uc3QgeyBpc01vZGFsIH0gPSB0aGlzLnByb3BzLmNvbW1vbjtcbiAgICBjb25zdCBib3JkZXJTdHlsZSA9IHt9O1xuICAgIGNvbnN0IGNvbXBvbmVudHMgPSB7XG4gICAgICAnc2lnbi1pbic6IDxUZXNNb2RhbENvbnRhaW5lciBoYXNXcmFwcGVyPXtpc01vZGFsfT48U2lnbmluIC8+PC9UZXNNb2RhbENvbnRhaW5lcj4sXG4gICAgICByZWdpc3RlcjogPFRlc01vZGFsQ29udGFpbmVyIGhhc1dyYXBwZXI9e2lzTW9kYWx9PjxSZWdpc3RlciAvPjwvVGVzTW9kYWxDb250YWluZXI+LFxuICAgICAgJ2ZvcmdvdC1wYXNzd29yZCc6IDxUZXNNb2RhbENvbnRhaW5lciBoYXNXcmFwcGVyPXtpc01vZGFsfT48Rm9yZ290UGFzc3dvcmQgLz48L1Rlc01vZGFsQ29udGFpbmVyPixcbiAgICAgIHNlbGVjdDogPFRlc01vZGFsQ29udGFpbmVyIGhhc1dyYXBwZXI9e2ZhbHNlfSBub1dyYXBwZXJTdHlsZT17aXNNb2RhbCA/IHt9IDogYm9yZGVyU3R5bGV9PjxTZWxlY3RQb3NpdGlvbiBvbkNsaWNrPXsoKSA9PiB7fX0gYWN0aW9uPScnIG1ldGhvZD0nJyAvPjwvVGVzTW9kYWxDb250YWluZXI+LFxuICAgICAgJ2xvZ2dlZC1pbi1zZWxlY3QnOiA8VGVzTW9kYWxDb250YWluZXIgaGFzV3JhcHBlcj17ZmFsc2V9PjxMb2dnZWRJblNlbGVjdCAvPjwvVGVzTW9kYWxDb250YWluZXI+LFxuICAgICAgJ2xvZ2dlZC1pbi11cGRhdGUnOiA8VGVzTW9kYWxDb250YWluZXIgaGFzV3JhcHBlcj17aXNNb2RhbH0+PExvZ2dlZEluVXBkYXRlIC8+PC9UZXNNb2RhbENvbnRhaW5lcj4sXG4gICAgfTtcbiAgICBjb25zdCBjb21wb25lbnQgPSBjb21wb25lbnRzW3RoaXMucHJvcHMuY29tbW9uLmZvcm1UeXBlXTtcbiAgICByZXR1cm4gKGNvbXBvbmVudCk7XG4gIH1cbn1cblxuQXBwLnByb3BUeXBlcyA9IHtcbiAgY29tbW9uOiBQcm9wVHlwZXMub2JqZWN0LmlzUmVxdWlyZWQsXG4gIGVycm9yczogUHJvcFR5cGVzLm9iamVjdC5pc1JlcXVpcmVkLFxuICBzaWduSW46IFByb3BUeXBlcy5vYmplY3QuaXNSZXF1aXJlZCxcbiAgcmVnaXN0ZXI6IFByb3BUeXBlcy5vYmplY3QuaXNSZXF1aXJlZCxcbiAgZm9yZ290UGFzc3dvcmQ6IFByb3BUeXBlcy5vYmplY3QuaXNSZXF1aXJlZCxcbn07XG5cbmNvbnN0IG1hcERpc3BhdGNoVG9Qcm9wcyA9IChkaXNwYXRjaCkgPT4gKHtcbiAgYWN0aW9uczogYmluZEFjdGlvbkNyZWF0b3JzKGFjdGlvbkNyZWF0b3JzLCBkaXNwYXRjaCksXG59KTtcblxuZXhwb3J0IGRlZmF1bHQgY29ubmVjdChcbiBzdGF0ZSA9PiAoe1xuICAgY29tbW9uOiBzdGF0ZS5jb21tb24sXG4gICBlcnJvcnM6IHN0YXRlLmVycm9ycyxcbiAgIHNpZ25Jbjogc3RhdGUuc2lnbkluLFxuICAgcmVnaXN0ZXI6IHN0YXRlLnJlZ2lzdGVyLFxuICAgZm9yZ290UGFzc3dvcmQ6IHN0YXRlLmZvcmdvdFBhc3N3b3JkLFxuIH0pLFxuIG1hcERpc3BhdGNoVG9Qcm9wc1xuKShBcHApO1xuIiwiaW1wb3J0IFJlYWN0LCB7IFByb3BUeXBlcywgQ29tcG9uZW50IH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgZ2V0RXJyb3JNc2dGcm9tUHJlZml4LCBnZXRFcnJvckNsc0Zyb21QcmVmaXggfSBmcm9tICcuLi9saWIvZ2V0RXJyb3JGcm9tUHJlZml4JztcbmltcG9ydCB7IGNvbm5lY3QgfSBmcm9tICdyZWFjdC1yZWR1eCc7XG5pbXBvcnQgeyBiaW5kQWN0aW9uQ3JlYXRvcnMgfSBmcm9tICdyZWR1eCc7XG5pbXBvcnQgKiBhcyBhY3Rpb25DcmVhdG9ycyBmcm9tICcuLi9yZWR1Y2Vycy9hY3Rpb25zJztcbmltcG9ydCBXaWRnZXRMaW5rIGZyb20gJy4vbGliL1dpZGdldExpbmsnO1xuaW1wb3J0IEhpZGRlbklucHV0cyBmcm9tICcuL2xpYi9IaWRkZW5JbnB1dHMnO1xuXG5jb25zdCBnZXRFcnJvck1zZyA9IGdldEVycm9yTXNnRnJvbVByZWZpeCgnZm9yZ290LXBhc3N3b3JkJyk7XG5jb25zdCBnZXRFcnJvckNscyA9IGdldEVycm9yQ2xzRnJvbVByZWZpeCgnZm9yZ290LXBhc3N3b3JkJyk7XG5cbmV4cG9ydCBjbGFzcyBGb3Jnb3RQYXNzd29yZCBleHRlbmRzIENvbXBvbmVudCB7XG5cbiAgaGFuZGxlU3VibWl0KGUpIHtcbiAgICBlLnByZXZlbnREZWZhdWx0KCk7XG4gICAgdGhpcy5wcm9wcy5hY3Rpb25zLmluaXRGb3Jnb3RQYXNzd29yZCgpO1xuICB9XG5cbiAgaGFuZGxlQ29udGludWUoZSkge1xuICAgIGUucHJldmVudERlZmF1bHQoKTtcbiAgICB0aGlzLnByb3BzLmFjdGlvbnMuc3VjY2Vzc0ZvcmdvdFBhc3N3b3JkKCk7XG4gIH1cblxuICBoYXNFcnJvcigpIHtcbiAgICByZXR1cm4gdGhpcy5wcm9wcy5lcnJvcnMgPyBPYmplY3Qua2V5cyh0aGlzLnByb3BzLmVycm9ycykuZmlsdGVyKChuKSA9PiBuLnN0YXJ0c1dpdGgoJ2ZvcmdvdC1wYXNzd29yZC4nKSkubGVuZ3RoID4gMCA6IGZhbHNlO1xuICB9XG5cbiAgY2hhbmdlRmllbGQobmFtZXBhciwgZGVwc3Bhcikge1xuICAgIGNvbnN0IG5hbWUgPSBgZm9yZ290LXBhc3N3b3JkLiR7bmFtZXBhcn1gO1xuICAgIGNvbnN0IGRlcHMgPSBkZXBzcGFyLm1hcChuID0+IGBmb3Jnb3RwYXNzd29yZC4ke259YCkgfHwgW107XG4gICAgcmV0dXJuIChlKSA9PiB7XG4gICAgICBjb25zdCB0YXJnZXQgPSBlLnRhcmdldDtcbiAgICAgIHRoaXMucHJvcHMuYWN0aW9ucy5zZXRGaWVsZCgnZm9yZ290UGFzc3dvcmQnLCB0YXJnZXQubmFtZSwgdGFyZ2V0LnZhbHVlKTtcbiAgICAgIHRoaXMucHJvcHMuYWN0aW9ucy5jaGFuZ2VGaWVsZChuYW1lLCBkZXBzKTtcbiAgICB9O1xuICB9XG5cbiAgcmVuZGVyKCkge1xuICAgIGNvbnN0IGVyciA9IHRoaXMucHJvcHMuZXJyb3JzO1xuXG4gICAgbGV0IGNvbnRlbnQ7XG4gICAgaWYgKHRoaXMucHJvcHMuZm9yZ290UGFzc3dvcmQuc3RhdGUgPT09ICdzZW50Jykge1xuICAgICAgY29udGVudCA9IChcbiAgICAgICAgPGRpdj5cbiAgICAgICAgICA8cD48c3Ryb25nPkVtYWlsIHNlbnQhIFBsZWFzZSBub3cgY2hlY2sgeW91ciBpbmJveDwvc3Ryb25nPjwvcD5cbiAgICAgICAgICA8cD5UaGVzZSBlbWFpbHMgY2FuIGdldCBjYXVnaHQgaW4gc3BhbSAtIHBsZWFzZSBhbHNvIGNoZWNrIHlvdXIgc3BhbSBmb2xkZXIuPC9wPlxuICAgICAgICAgIDxidXR0b24gb25DbGljaz17KGUpID0+IHRoaXMuaGFuZGxlQ29udGludWUoZSl9IGNsYXNzTmFtZT1cInRlcy1idG4gdGVzLWJ0bi0tbGcgdGVzLWJ0bi0taWNvbiB0ZXMtYnRuLS1ibG9jayB0ZXMtYnRuLS1wcmltYXJ5XCI+Q29udGludWU8c3BhbiBhcmlhLWhpZGRlbj1cInRydWVcIj48L3NwYW4+PC9idXR0b24+XG4gICAgICAgIDwvZGl2PlxuICAgICAgKTtcbiAgICB9IGVsc2Uge1xuICAgICAgY29udGVudCA9IChcbiAgICAgICAgPGZvcm0gb25TdWJtaXQ9eyhlKSA9PiB0aGlzLmhhbmRsZVN1Ym1pdChlKX0gcm9sZT1cImZvcm1cIiBtZXRob2Q9XCJwb3N0XCIgY2xhc3NOYW1lPVwidC1mb3Jnb3QtcGFzc3dvcmQtZm9ybVwiPlxuICAgICAgICAgIDxIaWRkZW5JbnB1dHMgLz5cbiAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT17Z2V0RXJyb3JDbHMoJ2lkZW50aWZpY2F0aW9uJykoZXJyKX0+XG4gICAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cInRlcy1pbnB1dC1ncm91cFwiPlxuICAgICAgICAgICAgICA8c3BhbiBjbGFzc05hbWU9XCJ0ZXMtaW5wdXQtZ3JvdXBfX2FkZG9uXCI+PGkgY2xhc3NOYW1lPVwiaWNvbiBpY29uLXVzZXJcIj48L2k+PC9zcGFuPlxuICAgICAgICAgICAgICA8aW5wdXQgdHlwZT1cInRleHRcIiBvbkNoYW5nZT17dGhpcy5jaGFuZ2VGaWVsZCgnaWRlbnRpZmljYXRpb24nLCBbXSl9XG4gICAgICAgICAgICAgICAgbmFtZT1cImlkZW50aWZpY2F0aW9uXCJcbiAgICAgICAgICAgICAgICBhdXRvRm9jdXM9XCJ0cnVlXCJcbiAgICAgICAgICAgICAgICBwbGFjZWhvbGRlcj1cImVtYWlsXCJcbiAgICAgICAgICAgICAgICB2YWx1ZT17dGhpcy5wcm9wcy5mb3Jnb3RQYXNzd29yZC5pZGVudGlmaWNhdGlvbn1cbiAgICAgICAgICAgICAgICBjbGFzc05hbWU9XCJ0ZXMtY29udHJvbCB0ZXMtY29udHJvbC0tZ3JvdXAgaWRlbnRpZmljYXRpb24tZmllbGQgdC1pZGVudGlmaWNhdGlvblwiXG4gICAgICAgICAgICAgIC8+XG4gICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPVwidGVzLWhlbHAtYmxvY2tcIj57Z2V0RXJyb3JNc2coJ2lkZW50aWZpY2F0aW9uJykoZXJyKX08L2Rpdj5cbiAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cIm1hcmdpbi10b3AtbWQgbWFyZ2luLWJvdHRvbS1zbVwiPlxuICAgICAgICAgICAgPGJ1dHRvbiBkaXNhYmxlZD17dGhpcy5wcm9wcy5mb3Jnb3RQYXNzd29yZC5zdGF0ZSA9PT0gJ3dhaXQnID8gJ2Rpc2FibGVkJyA6IG51bGx9IHR5cGU9XCJzdWJtaXRcIiBjbGFzc05hbWU9XCJ0ZXMtYnRuIHRlcy1idG4tLWxnIHRlcy1idG4tLWljb24gdGVzLWJ0bi0tYmxvY2sgdGVzLWJ0bi0tcHJpbWFyeSBmb3Jnb3QtcGFzc3dvcmQtc3VibWl0XCI+XG4gICAgICAgICAgICAgIHt0aGlzLnByb3BzLmZvcmdvdFBhc3N3b3JkLnN0YXRlID09PSAnd2FpdCcgP1xuICAgICAgICAgICAgICAgIDxpIGNsYXNzTmFtZT1cImljb24tc3BpbiBpY29uLXNwaW5uZXIgaWNvbi13aGl0ZVwiPjwvaT5cbiAgICAgICAgICAgICAgOiAnU2VuZCd9XG4gICAgICAgICAgICA8L2J1dHRvbj5cbiAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgPC9mb3JtPlxuICAgICAgKTtcbiAgICB9XG4gICAgcmV0dXJuIChcbiAgICA8ZGl2IGlkPVwic2lnbi1pblwiIGNsYXNzTmFtZT1cInBhZGRpbmctbGVmdC1tZCBwYWRkaW5nLXJpZ2h0LW1kIHBhZGRpbmctYm90dG9tLXhzIG1hcmdpbi1ib3R0b20teHNcIj5cbiAgICAgIDxkaXYgY2xhc3NOYW1lPVwiaGVhZGluZy1tYWluIG1hcmdpbi1ib3R0b20tbWQgdGV4dC1jZW50ZXJcIj5cbiAgICAgICAgPGgzIGNsYXNzTmFtZT1cInRlcy1tb2RhbF9faGVhZGluZyBtYXJnaW4tYm90dG9tLXNtXCI+UmVjb3ZlciB5b3VyIHBhc3N3b3JkPC9oMz5cbiAgICAgICAgPHA+U2VuZCB1cyB5b3VyIGVtYWlsIGFuZCB3ZSB3aWxsIHNlbmQgeW91IGluc3RydWN0aW9ucyB0byByZXNldCB5b3VyIHBhc3N3b3JkLjwvcD5cbiAgICAgIDwvZGl2PlxuICAgICAge2NvbnRlbnR9XG4gICAgICA8ZGl2IGNsYXNzTmFtZT1cImNsZWFyZml4XCI+XG4gICAgICAgIDxkaXYgY2xhc3NOYW1lPVwibW9yZS1pbmZvIHRleHQtY2VudGVyIHRleHQtLXNtIHBhZGRpbmctdG9wLXNtIGJvcmRlci10b3BcIj5cbiAgICAgICAgICAgIDxzcGFuPlJlbWVtYmVyIHlvdXIgcGFzc3dvcmQ/PC9zcGFuPjxzcGFuPiA8L3NwYW4+XG4gICAgICAgICAgICA8V2lkZ2V0TGluayBmb3JtVHlwZT1cInNpZ25JblwiPkxvZyBpbiBub3chPC9XaWRnZXRMaW5rPlxuICAgICAgICA8L2Rpdj5cbiAgICAgIDwvZGl2PlxuICAgIDwvZGl2PlxuICAgICk7XG4gIH1cbn1cblxuRm9yZ290UGFzc3dvcmQucHJvcFR5cGVzID0ge1xuICBjb21tb246IFByb3BUeXBlcy5vYmplY3QuaXNSZXF1aXJlZCxcbiAgZXJyb3JzOiBQcm9wVHlwZXMub2JqZWN0LmlzUmVxdWlyZWQsXG4gIHNpZ25JbjogUHJvcFR5cGVzLm9iamVjdC5pc1JlcXVpcmVkLFxuICByZWdpc3RlcjogUHJvcFR5cGVzLm9iamVjdC5pc1JlcXVpcmVkLFxuICBmb3Jnb3RQYXNzd29yZDogUHJvcFR5cGVzLm9iamVjdC5pc1JlcXVpcmVkLFxufTtcblxuY29uc3QgbWFwRGlzcGF0Y2hUb1Byb3BzID0gKGRpc3BhdGNoKSA9PiAoe1xuICBhY3Rpb25zOiBiaW5kQWN0aW9uQ3JlYXRvcnMoYWN0aW9uQ3JlYXRvcnMsIGRpc3BhdGNoKSxcbn0pO1xuXG5leHBvcnQgZGVmYXVsdCBjb25uZWN0KFxuIHN0YXRlID0+ICh7XG4gICBjb21tb246IHN0YXRlLmNvbW1vbixcbiAgIGVycm9yczogc3RhdGUuZXJyb3JzLFxuICAgc2lnbkluOiBzdGF0ZS5zaWduSW4sXG4gICByZWdpc3Rlcjogc3RhdGUucmVnaXN0ZXIsXG4gICBmb3Jnb3RQYXNzd29yZDogc3RhdGUuZm9yZ290UGFzc3dvcmQsXG4gfSksXG4gbWFwRGlzcGF0Y2hUb1Byb3BzXG4pKEZvcmdvdFBhc3N3b3JkKTtcbiIsImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgU2VsZWN0Rm9ybVBvc2l0aW9uIGZyb20gJy4vU2VsZWN0Rm9ybVBvc2l0aW9uJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gTG9nZ2VkSW5TZWxlY3RQb3NpdGlvbigpIHtcbiAgcmV0dXJuICg8U2VsZWN0Rm9ybVBvc2l0aW9uXG4gICAgaXNTdGFuZEFsb25lXG4gICAgYWN0aW9uPVwiL2FwaS9hdXRobi9lZGl0LWFjY291bnRcIlxuICAgIG1ldGhvZD1cInBvc3RcIlxuICAvPik7XG59XG4iLCJpbXBvcnQgUmVhY3QsIHsgUHJvcFR5cGVzLCBDb21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBnZXRFcnJvck1zZ0Zyb21QcmVmaXgsIGdldEVycm9yQ2xzRnJvbVByZWZpeCB9IGZyb20gJy4uL2xpYi9nZXRFcnJvckZyb21QcmVmaXgnO1xuaW1wb3J0IHsgY29ubmVjdCB9IGZyb20gJ3JlYWN0LXJlZHV4JztcbmltcG9ydCB7IGJpbmRBY3Rpb25DcmVhdG9ycyB9IGZyb20gJ3JlZHV4JztcbmltcG9ydCAqIGFzIGFjdGlvbkNyZWF0b3JzIGZyb20gJy4uL3JlZHVjZXJzL2FjdGlvbnMnO1xuaW1wb3J0IElucHV0RmllbGQgZnJvbSAnLi9saWIvSW5wdXRGaWVsZCc7XG5cbmNvbnN0IGdldEVycm9yTXNnID0gZ2V0RXJyb3JNc2dGcm9tUHJlZml4KCdlZGl0LWFjY291bnQnKTtcbmNvbnN0IGdldEVycm9yQ2xzID0gZ2V0RXJyb3JDbHNGcm9tUHJlZml4KCdlZGl0LWFjY291bnQnKTtcblxuZXhwb3J0IGNsYXNzIExvZ2dlZEluVXBkYXRlIGV4dGVuZHMgQ29tcG9uZW50IHtcblxuICBjb25zdHJ1Y3Rvcihwcm9wcykge1xuICAgIHN1cGVyKHByb3BzKTtcbiAgICB0aGlzLnN0YXRlID0ge1xuICAgICAgZmlyc3ROYW1lOiAnJyxcbiAgICAgIGxhc3ROYW1lOiAnJyxcbiAgICAgIGVtYWlsOiAnJyxcbiAgICAgIHVzZXJUeXBlOiB0aGlzLnByb3BzLmNvbW1vbi51c2VyVHlwZSxcbiAgICB9O1xuICB9XG5cbiAgb25DaGFuZ2UoZSwgbmFtZSkge1xuICAgIGNvbnN0IGRhdGEgPSB7fTtcbiAgICBkYXRhW25hbWVdID0gZS50YXJnZXQudmFsdWU7XG4gICAgdGhpcy5zZXRTdGF0ZShkYXRhKTtcbiAgfVxuXG4gIGdldEFjdGl2ZUZpZWxkcygpIHtcbiAgICBjb25zdCB2YXJpYW50cyA9IHtcbiAgICAgIGZ1bGxuYW1lOiB7XG4gICAgICAgIHRpdGxlOiAnUGxlYXNlIGFkZCB5b3VyIGZ1bGwgbmFtZScsXG4gICAgICAgIGhlbHBMaW5rOiAnV2h5IGFyZSB5b3UgYmVpbmcgYXNrZWQgZm9yIHlvdXIgbmFtZT8nLFxuICAgICAgICBoZWxwVGV4dDogJ1RoaXMgc2VjdGlvbiBvZiBvdXIgc2l0ZSByZXF1aXJlcyB5b3VyIG5hbWUgYXMgeW91IHdpbGwgYmUgaW50ZXJhY3Rpbmcgd2l0aCBzY2hvb2xzLCBpbnN0aXR1dGlvbnMgb3Igb3RoZXIgbWVtYmVycyBvZiBURVMgaW4gYSBwcm9mZXNzaW9uYWwgY29udGV4dC4gVXNpbmcgeW91ciBhY3R1YWwgbmFtZSBoZXJlIGltcHJvdmVzIHRoZSBzZXJ2aWNlIGFuZCB3aWxsIGFsbG93IHlvdSB0byBpbnRlcmFjdCB3aXRoIG90aGVycyB3aXRoIGdyZWF0ZXIgdHJhbnNwYXJlbmN5IGFuZCB0cnVzdC4nLFxuICAgICAgICB2YWxpZEZpZWxkczogWydmaXJzdE5hbWUnLCAnbGFzdE5hbWUnXSxcbiAgICAgIH0sXG4gICAgICBlbWFpbDoge1xuICAgICAgICB0aXRsZTogJ1BsZWFzZSBhZGQgeW91ciBlbWFpbCcsXG4gICAgICAgIHZhbGlkRmllbGRzOiBbJ2VtYWlsJywgJ3VzZXJUeXBlJ10sXG4gICAgICB9LFxuICAgIH07XG5cbiAgICBpZiAoIXZhcmlhbnRzW3RoaXMucHJvcHMuY29tbW9uLnZhcmlhbnRdKSB7XG4gICAgICByZXR1cm4gdmFyaWFudHMuZnVsbG5hbWU7XG4gICAgfVxuICAgIHJldHVybiB2YXJpYW50c1t0aGlzLnByb3BzLmNvbW1vbi52YXJpYW50XTtcbiAgfVxuXG4gIGhhbmRsZVN1Ym1pdChlKSB7XG4gICAgaWYgKCF0aGlzLnByb3BzLmNvbW1vbi5pc01vZGFsICYmICF0aGlzLnByb3BzLmNvbW1vbi5pc0lubGluZSkgcmV0dXJuO1xuICAgIGUucHJldmVudERlZmF1bHQoKTtcblxuICAgIGNvbnN0IGFjdGl2ZUZpZWxkcyA9IHRoaXMuZ2V0QWN0aXZlRmllbGRzKCk7XG4gICAgY29uc3QgaGFzRmllbGQgPSAobmFtZSkgPT4gYWN0aXZlRmllbGRzLnZhbGlkRmllbGRzLmluZGV4T2YobmFtZSkgIT09IC0xO1xuXG4gICAgY29uc3QgZGF0YSA9IHt9O1xuICAgIGlmIChoYXNGaWVsZCgnZmlyc3ROYW1lJykpIHtcbiAgICAgIGRhdGEuZmlyc3ROYW1lID0gdGhpcy5zdGF0ZS5maXJzdE5hbWU7XG4gICAgfVxuICAgIGlmIChoYXNGaWVsZCgnbGFzdE5hbWUnKSkge1xuICAgICAgZGF0YS5sYXN0TmFtZSA9IHRoaXMuc3RhdGUubGFzdE5hbWU7XG4gICAgfVxuICAgIGlmIChoYXNGaWVsZCgnZW1haWwnKSkge1xuICAgICAgZGF0YS5lbWFpbCA9IHRoaXMuc3RhdGUuZW1haWw7XG4gICAgfVxuICAgIGlmIChoYXNGaWVsZCgndXNlclR5cGUnKSkge1xuICAgICAgZGF0YS51c2VyVHlwZSA9IHRoaXMuc3RhdGUudXNlclR5cGU7XG4gICAgfVxuICAgIHRoaXMucHJvcHMuYWN0aW9ucy5yZXNldEVycm9ycygpO1xuICAgIHRoaXMucHJvcHMuYWN0aW9ucy51cGRhdGVVc2VyRGF0YShkYXRhKTtcbiAgfVxuXG4gIHJlbmRlcigpIHtcbiAgICBjb25zdCBlcnIgPSB0aGlzLnByb3BzLmVycm9ycztcbiAgICBjb25zdCBhY3RpdmVGaWVsZHMgPSB0aGlzLmdldEFjdGl2ZUZpZWxkcygpO1xuICAgIGNvbnN0IGhhc0ZpZWxkID0gKG5hbWUpID0+IGFjdGl2ZUZpZWxkcy52YWxpZEZpZWxkcy5pbmRleE9mKG5hbWUpICE9PSAtMTtcblxuICAgIHJldHVybiAoXG4gICAgPGRpdiBpZD1cImxvZ2dlZC1pbi11cGRhdGVcIiBjbGFzc05hbWU9XCJwYWRkaW5nLWxlZnQtbWQgcGFkZGluZy1yaWdodC1tZCBwYWRkaW5nLWJvdHRvbS14cyBtYXJnaW4tYm90dG9tLXhzXCI+XG4gICAgICA8ZGl2IGNsYXNzTmFtZT1cImhlYWRpbmctbWFpbiBtYXJnaW4tYm90dG9tLW1kIHRleHQtY2VudGVyXCI+XG4gICAgICAgIDxoMyBjbGFzc05hbWU9XCJ0ZXMtbW9kYWxfX2hlYWRpbmcgbWFyZ2luLWJvdHRvbS1zbVwiPnthY3RpdmVGaWVsZHMudGl0bGV9PC9oMz5cbiAgICAgIDwvZGl2PlxuICAgICAgPGRpdj5cbiAgICAgICAgPGZvcm0gYXV0b0NvbXBsZXRlPVwib2ZmXCIgcm9sZT1cImZvcm1cIiBvblN1Ym1pdD17KGUpID0+IHRoaXMuaGFuZGxlU3VibWl0KGUpfSBjbGFzc05hbWU9XCJ0LWxvZ2dlZC1pbi11cGRhdGUgbWFyZ2luLWJvdHRvbS1tZFwiIG1ldGhvZD1cInBvc3RcIiBhY3Rpb249XCIvYXBpL2F1dGhuL2VkaXQtYWNjb3VudFwiPlxuICAgICAgICAgIHt0aGlzLnByb3BzLmNvbW1vbi5ydG4gPyA8aW5wdXQgdHlwZT1cImhpZGRlblwiIG5hbWU9XCJydG5cIiB2YWx1ZT17ZW5jb2RlVVJJQ29tcG9uZW50KHRoaXMucHJvcHMuY29tbW9uLnJ0bil9IC8+IDogbnVsbH1cbiAgICAgICAgICB7aGFzRmllbGQoJ3VzZXJUeXBlJykgJiYgdGhpcy5wcm9wcy5jb21tb24udXNlclR5cGUgPyA8aW5wdXQgY2xhc3NOYW1lPVwidC11c2VyLXR5cGVcIiB0eXBlPVwiaGlkZGVuXCIgbmFtZT1cInVzZXJUeXBlXCIgcmVmPVwidXNlclR5cGVcIiB2YWx1ZT17dGhpcy5wcm9wcy5jb21tb24udXNlclR5cGV9IC8+IDogbnVsbH1cbiAgICAgICAgICA8aW5wdXQgdHlwZT1cImhpZGRlblwiIG5hbWU9XCJhcHBJZFwiIHZhbHVlPXt0aGlzLnByb3BzLmNvbW1vbi5hcHBJZH0gLz5cbiAgICAgICAgICA8aW5wdXQgdHlwZT1cImhpZGRlblwiIG5hbWU9XCJfQ1NSRl9UT0tFTlwiIHZhbHVlPXt0aGlzLnByb3BzLmNvbW1vbi5jc3JmVG9rZW59IC8+XG5cbiAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cInJvd1wiPlxuICAgICAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJjb2wteHMtMTIgY29sLXNtLTZcIj5cbiAgICAgICAgICAgICAge2hhc0ZpZWxkKCdmaXJzdE5hbWUnKSA/XG4gICAgICAgICAgICAgICAgPElucHV0RmllbGRcbiAgICAgICAgICAgICAgICAgIG5hbWU9XCJmaXJzdE5hbWVcIiBsYWJlbD1cIkZpcnN0IG5hbWVcIiB2YWx1ZT17dGhpcy5zdGF0ZS5maXJzdE5hbWV9XG4gICAgICAgICAgICAgICAgICBlcnJvckNsYXNzPXtnZXRFcnJvckNscygnZmlyc3ROYW1lJykoZXJyKX1cbiAgICAgICAgICAgICAgICAgIGVycm9yTWVzc2FnZT17Z2V0RXJyb3JNc2coJ2ZpcnN0TmFtZScpKGVycil9XG4gICAgICAgICAgICAgICAgICBvbkNoYW5nZT17KGUpID0+IHRoaXMub25DaGFuZ2UoZSwgJ2ZpcnN0TmFtZScpfVxuICAgICAgICAgICAgICAgICAgYXV0b0ZvY3VzPVwidHJ1ZVwiXG4gICAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgICAgOiBudWxsfVxuICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cImNvbC14cy0xMiBjb2wtc20tNlwiPlxuICAgICAgICAgICAgICB7aGFzRmllbGQoJ2xhc3ROYW1lJykgP1xuICAgICAgICAgICAgICAgIDxJbnB1dEZpZWxkXG4gICAgICAgICAgICAgICAgICBuYW1lPVwiZmlyc3ROYW1lXCIgbGFiZWw9XCJMYXN0IG5hbWVcIiB2YWx1ZT17dGhpcy5zdGF0ZS5sYXN0TmFtZX1cbiAgICAgICAgICAgICAgICAgIGVycm9yQ2xhc3M9e2dldEVycm9yQ2xzKCdsYXN0TmFtZScpKGVycil9XG4gICAgICAgICAgICAgICAgICBlcnJvck1lc3NhZ2U9e2dldEVycm9yTXNnKCdsYXN0TmFtZScpKGVycil9XG4gICAgICAgICAgICAgICAgICBvbkNoYW5nZT17KGUpID0+IHRoaXMub25DaGFuZ2UoZSwgJ2xhc3ROYW1lJyl9XG4gICAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgICAgOiBudWxsfVxuICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgPC9kaXY+XG5cbiAgICAgICAgICB7aGFzRmllbGQoJ2VtYWlsJykgP1xuICAgICAgICAgICAgPElucHV0RmllbGRcbiAgICAgICAgICAgICAgbmFtZT1cImVtYWlsXCJcbiAgICAgICAgICAgICAgbGFiZWw9e3RoaXMucHJvcHMuY29tbW9uLnVzZXJUeXBlID09PSAnc3R1ZGVudCcgPyAnRW1haWwgKG9wdGlvbmFsKScgOiAnRW1haWwnfVxuICAgICAgICAgICAgICB2YWx1ZT17dGhpcy5zdGF0ZS5lbWFpbH1cbiAgICAgICAgICAgICAgZXJyb3JDbGFzcz17Z2V0RXJyb3JDbHMoJ2VtYWlsJykoZXJyKX1cbiAgICAgICAgICAgICAgZXJyb3JNZXNzYWdlPXtnZXRFcnJvck1zZygnZW1haWwnKShlcnIpfVxuICAgICAgICAgICAgICBvbkNoYW5nZT17KGUpID0+IHRoaXMub25DaGFuZ2UoZSwgJ2VtYWlsJyl9XG4gICAgICAgICAgICAvPlxuICAgICAgICAgIDogbnVsbH1cbiAgICAgICAgICB7YWN0aXZlRmllbGRzLmhlbHBMaW5rID9cbiAgICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPVwibWFyZ2luLWJvdHRvbS14c1wiPlxuICAgICAgICAgICAgICA8c3BhbiBjbGFzc05hbWU9XCJsaW5rIGxpbmstLWNvbG9yZWQgdGV4dC0teHNcIiB0aXRsZT17YWN0aXZlRmllbGRzLmhlbHBUZXh0fT57YWN0aXZlRmllbGRzLmhlbHBMaW5rfTwvc3Bhbj5cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgIDogbnVsbH1cbiAgICAgICAgICA8ZGl2PlxuICAgICAgICAgICAgPGJ1dHRvbiB0eXBlPVwic3VibWl0XCIgY2xhc3NOYW1lPVwidGVzLWJ0biB0ZXMtYnRuLS1pY29uIHRlcy1idG4tLWxnIHRlcy1idG4tLWJsb2NrIHRlcy1idG4tLXByaW1hcnlcIj5cbiAgICAgICAgICAgICAgQ29uZmlybVxuICAgICAgICAgICAgPC9idXR0b24+XG4gICAgICAgICAgPC9kaXY+XG4gICAgICAgIDwvZm9ybT5cbiAgICAgIDwvZGl2PlxuICAgIDwvZGl2PlxuICAgICk7XG4gIH1cbn1cblxuTG9nZ2VkSW5VcGRhdGUucHJvcFR5cGVzID0ge1xuICBjb21tb246IFByb3BUeXBlcy5vYmplY3QuaXNSZXF1aXJlZCxcbiAgZXJyb3JzOiBQcm9wVHlwZXMub2JqZWN0LmlzUmVxdWlyZWQsXG59O1xuXG5jb25zdCBtYXBEaXNwYXRjaFRvUHJvcHMgPSAoZGlzcGF0Y2gpID0+ICh7XG4gIGFjdGlvbnM6IGJpbmRBY3Rpb25DcmVhdG9ycyhhY3Rpb25DcmVhdG9ycywgZGlzcGF0Y2gpLFxufSk7XG5cbmV4cG9ydCBkZWZhdWx0IGNvbm5lY3QoXG4gc3RhdGUgPT4gKHtcbiAgIGNvbW1vbjogc3RhdGUuY29tbW9uLFxuICAgZXJyb3JzOiBzdGF0ZS5lcnJvcnMsXG4gfSksXG4gbWFwRGlzcGF0Y2hUb1Byb3BzXG4pKExvZ2dlZEluVXBkYXRlKTtcbiIsImltcG9ydCBSZWFjdCwgeyBQcm9wVHlwZXMsIENvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGdldEVycm9yTXNnRnJvbVByZWZpeCwgZ2V0RXJyb3JDbHNGcm9tUHJlZml4IH0gZnJvbSAnLi4vbGliL2dldEVycm9yRnJvbVByZWZpeCc7XG5pbXBvcnQgeyBjb25uZWN0IH0gZnJvbSAncmVhY3QtcmVkdXgnO1xuaW1wb3J0IHsgYmluZEFjdGlvbkNyZWF0b3JzIH0gZnJvbSAncmVkdXgnO1xuaW1wb3J0ICogYXMgYWN0aW9uQ3JlYXRvcnMgZnJvbSAnLi4vcmVkdWNlcnMvYWN0aW9ucyc7XG5pbXBvcnQgV2lkZ2V0TGluayBmcm9tICcuL2xpYi9XaWRnZXRMaW5rJztcbmltcG9ydCBIaWRkZW5JbnB1dHMgZnJvbSAnLi9saWIvSGlkZGVuSW5wdXRzJztcbmltcG9ydCBJbnB1dEZpZWxkIGZyb20gJy4vbGliL0lucHV0RmllbGQnO1xuaW1wb3J0IHsgaXNJbnZhbGlkRGF0ZU9mQmlydGgsIGlzVW5kZXIxOCwgaXNVbmRlcjEzIH0gZnJvbSAnLi4vbGliL2RhdGUtaGVscGVyJztcbmltcG9ydCBTaW1wbGVEYXRlIGZyb20gJ21vZHVsZS10c2wtdWktY29tcG9uZW50cy9lczUvY29tcG9uZW50cy9zaW1wbGUtZGF0ZS9TaW1wbGVEYXRlJztcbmltcG9ydCBlcnJvck1lc3NhZ2VzIGZyb20gJy4uLy4uL2FwcC9kb21haW4vZXJyb3JNZXNzYWdlcyc7XG5pbXBvcnQgQnJhbmRpbmcgZnJvbSAnLi9saWIvQnJhbmRpbmcnO1xuXG5jb25zdCBnZXRFcnJvck1zZyA9IGdldEVycm9yTXNnRnJvbVByZWZpeCgncmVnaXN0cmF0aW9uJyk7XG5jb25zdCBnZXRFcnJvckNscyA9IGdldEVycm9yQ2xzRnJvbVByZWZpeCgncmVnaXN0cmF0aW9uJyk7XG5jb25zdCBnZXRHZW5lcmljRXJyb3JNc2cgPSBnZXRFcnJvck1zZ0Zyb21QcmVmaXgoJ2dlbmVyaWMnKTtcbmNvbnN0IGdldEdlbmVyaWNFcnJvckNscyA9IGdldEVycm9yQ2xzRnJvbVByZWZpeCgnZ2VuZXJpYycpO1xuXG5leHBvcnQgY2xhc3MgUmVnaXN0ZXIgZXh0ZW5kcyBDb21wb25lbnQge1xuICBjb25zdHJ1Y3Rvcihwcm9wcykge1xuICAgIHN1cGVyKHByb3BzKTtcbiAgICBjb25zdCBpc1N0dWRlbnQgPSBwcm9wcy5jb21tb24udXNlclR5cGUgPT09ICdzdHVkZW50JztcbiAgICB0aGlzLnN0YXRlID0geyBleHBhbmRQYW5lbDogIWlzU3R1ZGVudCB9O1xuICB9XG5cbiAgb25DaGFuZ2VEb0IoZCkge1xuICAgIGNvbnN0IGVycm9yTWVzc2FnZSA9IGlzSW52YWxpZERhdGVPZkJpcnRoKGQpO1xuICAgIGlmIChlcnJvck1lc3NhZ2UpIHtcbiAgICAgIHRoaXMuc2V0RGF0ZURvQihudWxsKTtcbiAgICAgIHRoaXMucHJvcHMuYWN0aW9ucy52YWxpZGF0aW9uRXJyb3JzKGVycm9yTWVzc2FnZXMoZXJyb3JNZXNzYWdlKSk7XG4gICAgfSBlbHNlIHtcbiAgICAgIHRoaXMucHJvcHMuYWN0aW9ucy5jaGFuZ2VGaWVsZCgncmVnaXN0cmF0aW9uLmRhdGVPZkJpcnRoJywgW10pO1xuICAgICAgdGhpcy5zZXREYXRlRG9CKGQpO1xuICAgIH1cbiAgfVxuXG4gIHNldERhdGVEb0IoZG9iKSB7XG4gICAgdGhpcy5zZXRTdGF0ZSh7IGV4cGFuZFBhbmVsOiBCb29sZWFuKGRvYikgfSk7XG4gICAgdGhpcy5wcm9wcy5hY3Rpb25zLnNldEZpZWxkKCdyZWdpc3RlcicsICdkYXRlT2ZCaXJ0aCcsIGRvYik7XG4gIH1cblxuICBnZXRHb29nbGVMb2dvVVJMKCkge1xuICAgIHJldHVybiBgJHt0aGlzLnByb3BzLmNvbW1vbi5jZG5Vcmx9aW1nL2dvb2dsZS1sb2dvLWcucG5nYDtcbiAgfVxuXG4gIGdldEZhY2Vib29rTG9nb1VSTCgpIHtcbiAgICByZXR1cm4gYCR7dGhpcy5wcm9wcy5jb21tb24uY2RuVXJsfWltZy9mYWNlYm9vay1sb2dvLnBuZ2A7XG4gIH1cblxuICBjaGFuZ2VGaWVsZChuYW1lcGFyLCBkZXBzcGFyKSB7XG4gICAgY29uc3QgbmFtZSA9IGByZWdpc3RyYXRpb24uJHtuYW1lcGFyfWA7XG4gICAgY29uc3QgZGVwcyA9IGRlcHNwYXIubWFwKG4gPT4gYHJlZ2lzdHJhdGlvbi4ke259YCkgfHwgW107XG4gICAgcmV0dXJuIChlKSA9PiB7XG4gICAgICBjb25zdCB0YXJnZXQgPSBlLnRhcmdldDtcbiAgICAgIHRoaXMucHJvcHMuYWN0aW9ucy5zZXRGaWVsZCgncmVnaXN0ZXInLCB0YXJnZXQubmFtZSwgdGFyZ2V0LnR5cGUgPT09ICdjaGVja2JveCcgfHwgdGFyZ2V0LnR5cGUgPT09ICdyYWRpbycgPyB0YXJnZXQuY2hlY2tlZCA6IHRhcmdldC52YWx1ZSk7XG4gICAgICB0aGlzLnByb3BzLmFjdGlvbnMuY2hhbmdlRmllbGQobmFtZSwgZGVwcyk7XG4gICAgICB0aGlzLnByb3BzLmFjdGlvbnMudmFsaWRhdGVGaWVsZChuYW1lKTtcbiAgICB9O1xuICB9XG5cbiAgaGFzRXJyb3IoKSB7XG4gICAgcmV0dXJuIHRoaXMucHJvcHMuZXJyb3JzID8gT2JqZWN0LmtleXModGhpcy5wcm9wcy5lcnJvcnMpLmZpbHRlcigobikgPT4gbi5zdGFydHNXaXRoKCdyZWdpc3RyYXRpb24uJykpLmxlbmd0aCA+IDAgOiBmYWxzZTtcbiAgfVxuXG4gIGhhbmRsZUdvb2dsZSgpIHtcbiAgICB0aGlzLnByb3BzLmFjdGlvbnMuaW5pdE9hdXRoU2lnbkluKCdnb29nbGUnKTtcbiAgfVxuXG4gIGhhbmRsZUZhY2Vib29rKCkge1xuICAgIHRoaXMucHJvcHMuYWN0aW9ucy5pbml0T2F1dGhTaWduSW4oJ2ZhY2Vib29rJyk7XG4gIH1cblxuICBoYW5kbGVTdWJtaXQoZSkge1xuICAgIGUucHJldmVudERlZmF1bHQoKTtcbiAgICBjb25zdCB0YXJnZXQgPSBlLnRhcmdldDtcbiAgICB0aGlzLnByb3BzLmFjdGlvbnMuaW5pdFJlZ2lzdGVyKCgpID0+IHtcbiAgICAgIHRhcmdldC5zdWJtaXQoKTsgLy8gb25seSBjYWxsZWQgZm9yIHBhZ2VzXG4gICAgfSk7XG4gIH1cblxuICByZW5kZXIoKSB7XG4gICAgY29uc3QgeyBkYXRlT2ZCaXJ0aCB9ID0gdGhpcy5wcm9wcy5yZWdpc3RlcjtcbiAgICBjb25zdCBlcnIgPSB0aGlzLnByb3BzLmVycm9ycztcbiAgICBjb25zdCBoYXNOYW1lID0gIXRoaXMucHJvcHMuY29tbW9uLm9taXROYW1lO1xuICAgIGNvbnN0IGlzU3R1ZGVudCA9IHRoaXMucHJvcHMuY29tbW9uLnVzZXJUeXBlID09PSAnc3R1ZGVudCc7XG4gICAgY29uc3QgdW5kZXIxMyA9IGlzVW5kZXIxMyhkYXRlT2ZCaXJ0aCk7XG4gICAgY29uc3QgdW5kZXIxOCA9IHVuZGVyMTMgfHwgaXNVbmRlcjE4KGRhdGVPZkJpcnRoKTtcbiAgICBjb25zdCBleHBhbmRQYW5lbCA9IHRoaXMuc3RhdGUuZXhwYW5kUGFuZWw7XG5cbiAgICBjb25zdCB3cmFwcGVyU3R5bGUgPSB7XG4gICAgICBvdmVyZmxvdzogJ2hpZGRlbicsXG4gICAgICB0cmFuc2l0aW9uOiBleHBhbmRQYW5lbCA/ICdtYXgtaGVpZ2h0IDI4MG1zIGxpbmVhciwgdHJhbnNmb3JtIDIwMG1zIGN1YmljLWJlemllcigwLjcsIDAuNTQsIDAuNjYsIDEuMjApLCBvcGFjaXR5IDIwMG1zIGVhc2Utb3V0JyA6ICdub25lJyxcbiAgICAgIG1heEhlaWdodDogZXhwYW5kUGFuZWwgPyAnNTIwcHgnIDogJzAnLFxuICAgICAgdHJhbnNmb3JtOiBleHBhbmRQYW5lbCA/ICdzY2FsZSgxLDEpJyA6ICdzY2FsZSgxLjE1LDApJyxcbiAgICAgIG9wYWNpdHk6IGV4cGFuZFBhbmVsID8gJzEnIDogJzAnLFxuICAgIH07XG5cbiAgICByZXR1cm4gKFxuICAgIDxkaXYgaWQ9XCJzaWduLWluXCIgY2xhc3NOYW1lPVwicGFkZGluZy1sZWZ0LW1kIHBhZGRpbmctcmlnaHQtbWQgcGFkZGluZy1ib3R0b20teHMgbWFyZ2luLWJvdHRvbS14c1wiPlxuICAgICAgeyB0aGlzLnByb3BzLmNvbW1vbi5icmFuZGluZyA/XG4gICAgICAgIDxCcmFuZGluZyB7Li4udGhpcy5wcm9wcy5jb21tb24uYnJhbmRpbmd9IGNkblVybD17dGhpcy5wcm9wcy5jb21tb24uY2RuVXJsfSAvPlxuICAgICAgICA6XG4gICAgICAgIDxkaXYgY2xhc3NOYW1lPVwiaGVhZGluZy1tYWluIG1hcmdpbi1ib3R0b20tbWQgdGV4dC1jZW50ZXJcIj5cbiAgICAgICAgICA8aDMgY2xhc3NOYW1lPVwidGVzLW1vZGFsX19oZWFkaW5nIG1hcmdpbi1ib3R0b20tc21cIj5Kb2luIFRlcyBmb3IgZnJlZTwvaDM+XG4gICAgICAgIDwvZGl2PlxuICAgICAgfVxuXG4gICAgICB7aXNTdHVkZW50ID9cbiAgICAgICAgPGRpdiBjbGFzc05hbWU9e2dldEVycm9yQ2xzKCdkYXRlT2ZCaXJ0aCcpKGVycil9PlxuICAgICAgICAgIDxsYWJlbCBjbGFzc05hbWU9XCJwYWRkaW5nLXJpZ2h0LXhzXCIgaHRtbEZvcj1cImRhdGVPZkJpcnRoLW1vbnRoXCI+V2hhdCBpcyB5b3VyIGRhdGUgb2YgYmlydGg/PC9sYWJlbD5cbiAgICAgICAgICA8U2ltcGxlRGF0ZVxuICAgICAgICAgICAgbmFtZT1cImRhdGVPZkJpcnRoXCJcbiAgICAgICAgICAgIHZhbHVlPXt0aGlzLnByb3BzLnJlZ2lzdGVyLmRhdGVPZkJpcnRofVxuICAgICAgICAgICAgb25DaGFuZ2U9eyhkKSA9PiB0aGlzLm9uQ2hhbmdlRG9CKGQpfVxuICAgICAgICAgICAgbGFiZWw9XCJEYXRlIG9mIGJpcnRoXCJcbiAgICAgICAgICAgIHNlcXVlbmNlPXt0aGlzLnByb3BzLmNvbW1vbi5kYXRlTG9jYWxlfVxuICAgICAgICAgIC8+XG4gICAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJ0ZXMtaGVscC1ibG9ja1wiPntnZXRFcnJvck1zZygnZGF0ZU9mQmlydGgnKShlcnIpfTwvZGl2PlxuICAgICAgICA8L2Rpdj5cbiAgICAgIDogbnVsbH1cblxuICAgICAgPGRpdiBzdHlsZT17d3JhcHBlclN0eWxlfT5cbiAgICAgICAgPGRpdj5cblxuICAgICAgICAgIHshaXNTdHVkZW50IHx8ICF1bmRlcjE4ID9cbiAgICAgICAgICAgIDxkaXY+XG4gICAgICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPVwicm93XCI+XG4gICAgICAgICAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJjb2wteHMtMTJcIj5cbiAgICAgICAgICAgICAgICAgIDxidXR0b25cbiAgICAgICAgICAgICAgICAgICAgZGlzYWJsZWQ9e3RoaXMucHJvcHMucmVnaXN0ZXIuc3RhdGUgPT09ICd3YWl0JyB8fCB0aGlzLnByb3BzLmNvbW1vbi5vYXV0aFN0YXRlID8gJ2Rpc2FibGVkJyA6IG51bGx9XG4gICAgICAgICAgICAgICAgICAgIG9uQ2xpY2s9eyhlKSA9PiB0aGlzLmhhbmRsZUdvb2dsZShlKX1cbiAgICAgICAgICAgICAgICAgICAgY2xhc3NOYW1lPVwidGVzLWJ0biB0ZXMtYnRuLS1zZWNvbmRhcnkgdGVzLWJ0bi0taWNvbiB0ZXMtYnRuLS1ibG9jayB0ZXMtYnRuLS1zb2NpYWxcIlxuICAgICAgICAgICAgICAgICAgPlxuICAgICAgICAgICAgICAgICAgICB7dGhpcy5wcm9wcy5jb21tb24ub2F1dGhTdGF0ZSA9PT0gJ2dvb2dsZScgP1xuICAgICAgICAgICAgICAgICAgICAgIDxpIGNsYXNzTmFtZT1cImljb24tc3BpbiBpY29uLXNwaW5uZXIgdGVzLWJ0bl9faWNvblwiPjwvaT5cbiAgICAgICAgICAgICAgICAgICAgOiA8c3BhbiBjbGFzc05hbWU9XCJ0ZXh0LS1zbVwiPjxpbWcgc3R5bGU9e3sgcGFkZGluZzogJzAgNnB4IDJweCAwJywgdmVydGljYWxBbGlnbjogJ21pZGRsZScgfX0gc3JjPXt0aGlzLmdldEdvb2dsZUxvZ29VUkwoKX0gLz4gUmVnaXN0ZXIgd2l0aCBHb29nbGU8L3NwYW4+fVxuICAgICAgICAgICAgICAgICAgPC9idXR0b24+XG4gICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgIDwvZGl2PlxuXG4gICAgICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPVwicm93IG1hcmdpbi10b3Atc21cIj5cbiAgICAgICAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cImNvbC14cy0xMlwiPlxuICAgICAgICAgICAgICAgICAgPGJ1dHRvblxuICAgICAgICAgICAgICAgICAgICBkaXNhYmxlZD17dGhpcy5wcm9wcy5yZWdpc3Rlci5zdGF0ZSA9PT0gJ3dhaXQnIHx8IHRoaXMucHJvcHMuY29tbW9uLm9hdXRoU3RhdGUgPyAnZGlzYWJsZWQnIDogbnVsbH1cbiAgICAgICAgICAgICAgICAgICAgb25DbGljaz17KGUpID0+IHRoaXMuaGFuZGxlRmFjZWJvb2soZSl9XG4gICAgICAgICAgICAgICAgICAgIGNsYXNzTmFtZT1cInRlcy1idG4gdGVzLWJ0bi0tc2Vjb25kYXJ5IHRlcy1idG4tLWljb24gdGVzLWJ0bi0tYmxvY2sgdGVzLWJ0bi0tc29jaWFsXCJcbiAgICAgICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICAgICAge3RoaXMucHJvcHMuY29tbW9uLm9hdXRoU3RhdGUgPT09ICdmYWNlYm9vaycgP1xuICAgICAgICAgICAgICAgICAgICAgIDxpIGNsYXNzTmFtZT1cImljb24tc3BpbiBpY29uLXNwaW5uZXIgdGVzLWJ0bl9faWNvblwiPjwvaT5cbiAgICAgICAgICAgICAgICAgICAgOiA8c3BhbiBjbGFzc05hbWU9XCJ0ZXh0LS1zbVwiPjxpbWcgc3R5bGU9e3sgcGFkZGluZzogJzAgNnB4IDJweCAwJywgdmVydGljYWxBbGlnbjogJ21pZGRsZScgfX0gc3JjPXt0aGlzLmdldEZhY2Vib29rTG9nb1VSTCgpfSAvPiBSZWdpc3RlciB3aXRoIEZhY2Vib29rPC9zcGFuPn1cbiAgICAgICAgICAgICAgICAgIDwvYnV0dG9uPlxuICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICA8L2Rpdj5cblxuICAgICAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cInNlcGFyYXRvclwiPlxuICAgICAgICAgICAgICAgIDxzcGFuIGNsYXNzTmFtZT1cInNlcGFyYXRvci0tdGV4dCBiZy13aGl0ZVwiPm9yPC9zcGFuPlxuICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgIDogbnVsbH1cblxuICAgICAgICAgIDxmb3JtIGF1dG9Db21wbGV0ZT1cIm9mZlwiIHJvbGU9XCJmb3JtXCIgb25TdWJtaXQ9eyhlKSA9PiB0aGlzLmhhbmRsZVN1Ym1pdChlKX0gY2xhc3NOYW1lPVwidC1yZWdpc3Rlci1mb3JtIG1hcmdpbi1ib3R0b20tbWRcIiBtZXRob2Q9XCJwb3N0XCIgYWN0aW9uPVwiL2FwaS9hdXRobi9yZWdpc3Rlci1yZWRpcmVjdFwiPlxuICAgICAgICAgICAgPEhpZGRlbklucHV0cyAvPlxuXG4gICAgICAgICAgICB7aXNTdHVkZW50ID8gPGlucHV0IHR5cGU9XCJoaWRkZW5cIiBuYW1lPVwiZGF0ZU9mQmlydGhcIiB2YWx1ZT17dGhpcy5wcm9wcy5yZWdpc3Rlci5kYXRlT2ZCaXJ0aH0gLz4gOiBudWxsfVxuXG4gICAgICAgICAgICB7aGFzTmFtZSA/XG4gICAgICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPVwicm93XCI+XG4gICAgICAgICAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJjb2wteHMtMTIgY29sLXNtLTZcIj5cbiAgICAgICAgICAgICAgICAgIDxJbnB1dEZpZWxkXG4gICAgICAgICAgICAgICAgICAgIG5hbWU9XCJmaXJzdE5hbWVcIiBsYWJlbD1cIkZpcnN0IG5hbWVcIiB2YWx1ZT17dGhpcy5wcm9wcy5yZWdpc3Rlci5maXJzdE5hbWV9XG4gICAgICAgICAgICAgICAgICAgIGVycm9yQ2xhc3M9e2dldEVycm9yQ2xzKCdmaXJzdE5hbWUnKShlcnIpfVxuICAgICAgICAgICAgICAgICAgICBlcnJvck1lc3NhZ2U9e2dldEVycm9yTXNnKCdmaXJzdE5hbWUnKShlcnIpfVxuICAgICAgICAgICAgICAgICAgICBvbkNoYW5nZT17dGhpcy5jaGFuZ2VGaWVsZCgnZmlyc3ROYW1lJywgW10pfVxuICAgICAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cImNvbC14cy0xMiBjb2wtc20tNlwiPlxuICAgICAgICAgICAgICAgICAgPElucHV0RmllbGRcbiAgICAgICAgICAgICAgICAgICAgbmFtZT1cImxhc3ROYW1lXCIgbGFiZWw9XCJMYXN0IG5hbWVcIiB2YWx1ZT17dGhpcy5wcm9wcy5yZWdpc3Rlci5sYXN0TmFtZX1cbiAgICAgICAgICAgICAgICAgICAgZXJyb3JDbGFzcz17Z2V0RXJyb3JDbHMoJ2xhc3ROYW1lJykoZXJyKX1cbiAgICAgICAgICAgICAgICAgICAgZXJyb3JNZXNzYWdlPXtnZXRFcnJvck1zZygnbGFzdE5hbWUnKShlcnIpfVxuICAgICAgICAgICAgICAgICAgICBvbkNoYW5nZT17dGhpcy5jaGFuZ2VGaWVsZCgnbGFzdE5hbWUnLCBbXSl9XG4gICAgICAgICAgICAgICAgICAvPlxuICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgIDogbnVsbH1cblxuICAgICAgICAgICAgeyFpc1N0dWRlbnQgfHwgIXVuZGVyMTMgP1xuICAgICAgICAgICAgICA8SW5wdXRGaWVsZFxuICAgICAgICAgICAgICAgIG5hbWU9XCJlbWFpbFwiXG4gICAgICAgICAgICAgICAgbGFiZWw9eyh0aGlzLnByb3BzLmNvbW1vbi51c2VyVHlwZSA9PT0gJ3N0dWRlbnQnICYmIHVuZGVyMTgpID8gJ0VtYWlsIChvcHRpb25hbCknIDogJ0VtYWlsJ31cbiAgICAgICAgICAgICAgICB2YWx1ZT17dGhpcy5wcm9wcy5yZWdpc3Rlci5lbWFpbH1cbiAgICAgICAgICAgICAgICBlcnJvckNsYXNzPXtnZXRFcnJvckNscygnZW1haWwnKShlcnIpfVxuICAgICAgICAgICAgICAgIGVycm9yTWVzc2FnZT17Z2V0RXJyb3JNc2coJ2VtYWlsJykoZXJyKX1cbiAgICAgICAgICAgICAgICBvbkNoYW5nZT17dGhpcy5jaGFuZ2VGaWVsZCgnZW1haWwnLCBbXSl9XG4gICAgICAgICAgICAgICAgdHlwZT1cImVtYWlsXCJcbiAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgIDogbnVsbH1cbiAgICAgICAgICAgIDxJbnB1dEZpZWxkXG4gICAgICAgICAgICAgIG5hbWU9XCJ1c2VybmFtZVwiXG4gICAgICAgICAgICAgIGxhYmVsPVwiVXNlcm5hbWVcIlxuICAgICAgICAgICAgICB2YWx1ZT17dGhpcy5wcm9wcy5yZWdpc3Rlci51c2VybmFtZX1cbiAgICAgICAgICAgICAgZXJyb3JDbGFzcz17Z2V0RXJyb3JDbHMoJ3VzZXJuYW1lJykoZXJyKX1cbiAgICAgICAgICAgICAgZXJyb3JNZXNzYWdlPXtnZXRFcnJvck1zZygndXNlcm5hbWUnKShlcnIpfVxuICAgICAgICAgICAgICBvbkNoYW5nZT17dGhpcy5jaGFuZ2VGaWVsZCgndXNlcm5hbWUnLCBbXSl9XG4gICAgICAgICAgICAvPlxuICAgICAgICAgICAgPElucHV0RmllbGRcbiAgICAgICAgICAgICAgbmFtZT1cInBhc3N3b3JkXCJcbiAgICAgICAgICAgICAgbGFiZWw9XCJwYXNzd29yZFwiXG4gICAgICAgICAgICAgIHZhbHVlPXt0aGlzLnByb3BzLnJlZ2lzdGVyLnBhc3N3b3JkfVxuICAgICAgICAgICAgICBlcnJvckNsYXNzPXtnZXRFcnJvckNscygncGFzc3dvcmQnKShlcnIpfVxuICAgICAgICAgICAgICBlcnJvck1lc3NhZ2U9e2dldEVycm9yTXNnKCdwYXNzd29yZCcpKGVycil9XG4gICAgICAgICAgICAgIG9uQ2hhbmdlPXt0aGlzLmNoYW5nZUZpZWxkKCdwYXNzd29yZCcsIFtdKX1cbiAgICAgICAgICAgICAgdHlwZT1cInBhc3N3b3JkXCJcbiAgICAgICAgICAgIC8+XG5cbiAgICAgICAgICAgIHtpc1N0dWRlbnQgJiYgdW5kZXIxMyA/XG4gICAgICAgICAgICAgIDxkaXY+XG4gICAgICAgICAgICAgICAgPElucHV0RmllbGRcbiAgICAgICAgICAgICAgICAgIG5hbWU9XCJjbGFzc0NvZGVcIlxuICAgICAgICAgICAgICAgICAgbGFiZWw9XCJDbGFzcyBjb2RlIGZyb20gVGVzIFRlYWNoXCJcbiAgICAgICAgICAgICAgICAgIHZhbHVlPXt0aGlzLnByb3BzLnJlZ2lzdGVyLmNsYXNzQ29kZX1cbiAgICAgICAgICAgICAgICAgIGVycm9yQ2xhc3M9e2dldEVycm9yQ2xzKCdjbGFzc0NvZGUnKShlcnIpfVxuICAgICAgICAgICAgICAgICAgZXJyb3JNZXNzYWdlPXtnZXRFcnJvck1zZygnY2xhc3NDb2RlJykoZXJyKX1cbiAgICAgICAgICAgICAgICAgIG9uQ2hhbmdlPXt0aGlzLmNoYW5nZUZpZWxkKCdjbGFzc0NvZGUnLCBbXSl9XG4gICAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cInNlcGFyYXRvclwiPlxuICAgICAgICAgICAgICAgICAgPHNwYW4gY2xhc3NOYW1lPVwic2VwYXJhdG9yLS10ZXh0IGJnLXdoaXRlXCI+b3I8L3NwYW4+XG4gICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgICAgPElucHV0RmllbGRcbiAgICAgICAgICAgICAgICAgIG5hbWU9XCJndWFyZGlhbkVtYWlsXCJcbiAgICAgICAgICAgICAgICAgIGxhYmVsPVwiUGFyZW50IC8gR3VhcmRpYW4ncyBlbWFpbCBhZGRyZXNzXCJcbiAgICAgICAgICAgICAgICAgIHZhbHVlPXt0aGlzLnByb3BzLnJlZ2lzdGVyLmd1YXJkaWFuRW1haWx9XG4gICAgICAgICAgICAgICAgICBlcnJvckNsYXNzPXtnZXRFcnJvckNscygnZ3VhcmRpYW5FbWFpbCcpKGVycil9XG4gICAgICAgICAgICAgICAgICBlcnJvck1lc3NhZ2U9e2dldEVycm9yTXNnKCdndWFyZGlhbkVtYWlsJykoZXJyKX1cbiAgICAgICAgICAgICAgICAgIG9uQ2hhbmdlPXt0aGlzLmNoYW5nZUZpZWxkKCdndWFyZGlhbkVtYWlsJywgW10pfVxuICAgICAgICAgICAgICAgICAgdHlwZT1cImVtYWlsXCJcbiAgICAgICAgICAgICAgICAvPlxuICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgIDogbnVsbH1cblxuICAgICAgICAgICAge3RoaXMucHJvcHMuY29tbW9uLnVzZXJUeXBlICE9PSAnc3R1ZGVudCcgP1xuICAgICAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJ0ZXMtY2hlY2tib3ggdGVzLWNoZWNrYm94LS1pbmxpbmUgdGV4dC0tc20gbWFyZ2luLWJvdHRvbS1zbVwiPlxuICAgICAgICAgICAgICA8bGFiZWwgY2xhc3NOYW1lPVwidGVzLWNvbnRyb2wtbGFiZWwgdGV4dC0teHNcIj48aW5wdXQgb25DaGFuZ2U9e3RoaXMuY2hhbmdlRmllbGQoJ25ld3NsZXR0ZXInLCBbXSl9XG4gICAgICAgICAgICAgICAgdHlwZT1cImNoZWNrYm94XCIgbmFtZT1cIm5ld3NsZXR0ZXJcIlxuICAgICAgICAgICAgICAgIGNsYXNzTmFtZT1cInQtbmV3c2xldHRlclwiXG4gICAgICAgICAgICAgICAgdmFsdWU9XCJ0cnVlXCJcbiAgICAgICAgICAgICAgICBjaGVja2VkPXt0aGlzLnByb3BzLnJlZ2lzdGVyLm5ld3NsZXR0ZXJ9XG4gICAgICAgICAgICAgIC8+XG4gICAgICAgICAgICAgICAgPHNwYW4gY2xhc3NOYW1lPVwidGV4dC0teHNcIj4gUmVjZWl2ZSBuZXdzIGFuZCB1cGRhdGVzIGZyb20gVEVTPC9zcGFuPlxuICAgICAgICAgICAgICA8L2xhYmVsPlxuICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICA6IG51bGx9XG5cbiAgICAgICAgICAgIDxkaXY+XG4gICAgICAgICAgICAgIDxidXR0b24gZGlzYWJsZWQ9e3RoaXMucHJvcHMucmVnaXN0ZXIuc3RhdGUgPT09ICd3YWl0JyB8fCB0aGlzLnByb3BzLmNvbW1vbi5nb29nbGVTdGF0ZSA9PT0gJ3dhaXQnID8gJ2Rpc2FibGVkJyA6IG51bGx9XG4gICAgICAgICAgICAgICAgdHlwZT1cInN1Ym1pdFwiIGNsYXNzTmFtZT1cInRlcy1idG4gdGVzLWJ0bi0taWNvbiB0ZXMtYnRuLS1sZyBzaWduLXVwLXN1Ym1pdCB0ZXMtYnRuLS1ibG9jayB0ZXMtYnRuLS1wcmltYXJ5XCJcbiAgICAgICAgICAgICAgPlxuICAgICAgICAgICAgICAgIHt0aGlzLnByb3BzLnJlZ2lzdGVyLnN0YXRlID09PSAnd2FpdCcgP1xuICAgICAgICAgICAgICAgICAgPGkgY2xhc3NOYW1lPVwiaWNvbi1zcGluIGljb24tc3Bpbm5lciBpY29uLXdoaXRlIHRlcy1idG5fX2ljb25cIj48L2k+XG4gICAgICAgICAgICAgICAgOiAnUmVnaXN0ZXInfVxuICAgICAgICAgICAgICA8L2J1dHRvbj5cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgIDwvZm9ybT5cblxuICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPVwicm93XCI+XG4gICAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cInRleHQtLXNlY29uZGFyeSBjb2wteHMtMTJcIiBzdHlsZT17eyBwYWRkaW5nUmlnaHQ6IDAgfX0+XG4gICAgICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPVwibWFyZ2luLWJvdHRvbS1tZFwiPkJ5IHJlZ2lzdGVyaW5nLCB5b3UgYXJlIGFncmVlaW5nIHRvIG91ciA8YSB0YXJnZXQ9XCJfYmxhbmtcIiBjbGFzc05hbWU9XCJsaW5rIGxpbmstLWNvbG9yZWRcIiBocmVmPVwiaHR0cHM6Ly93d3cudGVzLmNvbS9jb250ZW50L3Rlcm1zLWFuZC1jb25kaXRpb25zXCI+dGVybXMgYW5kIGNvbmRpdGlvbnM8L2E+IGFuZCA8YSB0YXJnZXQ9XCJfYmxhbmtcIiBjbGFzc05hbWU9XCJsaW5rIGxpbmstLWNvbG9yZWRcIiBocmVmPVwiaHR0cHM6Ly93d3cudGVzLmNvbS91cy9wcml2YWN5LXBvbGljeVwiPnByaXZhY3kgcG9saWN5PC9hPjwvZGl2PlxuICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgPC9kaXY+XG5cbiAgICAgICAgICB7Z2V0R2VuZXJpY0Vycm9yQ2xzKCdnb29nbGVidXR0b24nKShlcnIpID9cbiAgICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPVwicm93XCI+XG4gICAgICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPVwidGVzLWhhcy1lcnJvciBjb2wteHMtMTJcIj5cbiAgICAgICAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cInRlcy1oZWxwLWJsb2NrXCI+e2dldEdlbmVyaWNFcnJvck1zZygnZ29vZ2xlYnV0dG9uJykoZXJyKX08L2Rpdj5cbiAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICA6IG51bGx9XG4gICAgICAgIDwvZGl2PlxuICAgICAgPC9kaXY+XG5cbiAgICAgIDxkaXYgY2xhc3NOYW1lPVwiY2xlYXJmaXhcIj5cbiAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJtb3JlLWluZm8gdGV4dC1jZW50ZXIgdGV4dC0tc20gcGFkZGluZy10b3AtbWQgYm9yZGVyLXRvcFwiPlxuICAgICAgICAgICAgPHNwYW4+QWxyZWFkeSBoYXZlIGEgVGVzIGFjY291bnQ/PC9zcGFuPjxzcGFuPiA8L3NwYW4+XG4gICAgICAgICAgICA8V2lkZ2V0TGluayBmb3JtVHlwZT1cInNpZ25JblwiPkxvZyBpbiBub3chPC9XaWRnZXRMaW5rPlxuICAgICAgICA8L2Rpdj5cbiAgICAgIDwvZGl2PlxuICAgIDwvZGl2PlxuICAgICk7XG4gIH1cbn1cblxuUmVnaXN0ZXIucHJvcFR5cGVzID0ge1xuICBjb21tb246IFByb3BUeXBlcy5vYmplY3QuaXNSZXF1aXJlZCxcbiAgZXJyb3JzOiBQcm9wVHlwZXMub2JqZWN0LmlzUmVxdWlyZWQsXG4gIHJlZ2lzdGVyOiBQcm9wVHlwZXMub2JqZWN0LmlzUmVxdWlyZWQsXG59O1xuXG5jb25zdCBtYXBEaXNwYXRjaFRvUHJvcHMgPSAoZGlzcGF0Y2gpID0+ICh7XG4gIGFjdGlvbnM6IGJpbmRBY3Rpb25DcmVhdG9ycyhhY3Rpb25DcmVhdG9ycywgZGlzcGF0Y2gpLFxufSk7XG5cbmV4cG9ydCBkZWZhdWx0IGNvbm5lY3QoXG4gc3RhdGUgPT4gKHtcbiAgIGNvbW1vbjogc3RhdGUuY29tbW9uLFxuICAgZXJyb3JzOiBzdGF0ZS5lcnJvcnMsXG4gICByZWdpc3Rlcjogc3RhdGUucmVnaXN0ZXIsXG4gfSksXG4gbWFwRGlzcGF0Y2hUb1Byb3BzXG4pKFJlZ2lzdGVyKTtcbiIsImltcG9ydCBSZWFjdCwgeyBQcm9wVHlwZXMsIENvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGNvbm5lY3QgfSBmcm9tICdyZWFjdC1yZWR1eCc7XG5pbXBvcnQgeyBiaW5kQWN0aW9uQ3JlYXRvcnMgfSBmcm9tICdyZWR1eCc7XG5pbXBvcnQgKiBhcyBhY3Rpb25DcmVhdG9ycyBmcm9tICcuLi9yZWR1Y2Vycy9hY3Rpb25zJztcbmltcG9ydCBIaWRkZW5JbnB1dHMgZnJvbSAnLi9saWIvSGlkZGVuSW5wdXRzJztcbmltcG9ydCBXaWRnZXRMaW5rIGZyb20gJy4vbGliL1dpZGdldExpbmsnO1xuaW1wb3J0IEN1c3RvbVNlbGVjdCBmcm9tICcuL2xpYi9DdXN0b21TZWxlY3QnO1xuaW1wb3J0IEJ1dHRvblNlbGVjdCBmcm9tICcuL2xpYi9CdXR0b25TZWxlY3QnO1xuaW1wb3J0IHsgY2FyZWVyRmluZGVyLCBmaWx0ZXJQb3NpdGlvbiwgZ2V0VXNlclR5cGVQb3NpdGlvbiB9IGZyb20gJy4uL2xpYi9wb3NpdGlvbi1maWx0ZXInO1xuaW1wb3J0IEJyYW5kaW5nIGZyb20gJy4vbGliL0JyYW5kaW5nJztcblxuZXhwb3J0IGNsYXNzIFNlbGVjdEZvcm1Qb3NpdGlvbiBleHRlbmRzIENvbXBvbmVudCB7XG4gIGNvbnN0cnVjdG9yKHByb3BzKSB7XG4gICAgc3VwZXIocHJvcHMpO1xuICAgIGNvbnN0IHBvc2l0aW9ucyA9IHByb3BzLnJlZmRhdGEucG9zaXRpb25zO1xuICAgIGNvbnN0IGNhcmVlcnMgPSBwcm9wcy5yZWZkYXRhLmNhcmVlcnM7XG4gICAgY29uc3QgY3VycmVudFBvc2l0aW9uID0gcHJvcHMuY29tbW9uLnBvc2l0aW9uO1xuICAgIGNvbnN0IGN1cnJlbnRDYXJlZXJPYmogPSBjYXJlZXJGaW5kZXIocG9zaXRpb25zLCBjYXJlZXJzLCBjdXJyZW50UG9zaXRpb24pO1xuXG4gICAgdGhpcy5zdGF0ZSA9IHsgY3VycmVudENhcmVlck9iaiB9O1xuICB9XG5cbiAgb25DaGFuZ2VDYXJlZXIoY3VycmVudENhcmVlcikge1xuICAgIGNvbnN0IGZpbHRlcmVkQ2FyZWVycyA9IHRoaXMucHJvcHMucmVmZGF0YS5jYXJlZXJzXG4gICAgLmZpbHRlcigoaXRlbSkgPT4gY3VycmVudENhcmVlciA9PT0gaXRlbS5uYW1lKTtcbiAgICBjb25zdCBjdXJyZW50Q2FyZWVyT2JqID0gZmlsdGVyZWRDYXJlZXJzLmxlbmd0aCA/IGZpbHRlcmVkQ2FyZWVyc1swXSA6IHsgbmFtZTogJycsIGdyb3VwTGFiZWw6IG51bGwgfTtcblxuICAgIHRoaXMuc2V0U3RhdGUoeyBjdXJyZW50Q2FyZWVyT2JqIH0pO1xuXG4gICAgY29uc3QgcG9zaXRpb25zID0gdGhpcy5wcm9wcy5yZWZkYXRhLnBvc2l0aW9ucztcbiAgICBjb25zdCB2YWxpZFBvc2l0aW9uID0gZmlsdGVyUG9zaXRpb24ocG9zaXRpb25zLCBjdXJyZW50Q2FyZWVyT2JqKTtcblxuICAgIGNvbnN0IG5ld1Bvc2l0aW9uID0gdmFsaWRQb3NpdGlvbi5sZW5ndGggPT09IDEgPyB2YWxpZFBvc2l0aW9uWzBdLm5hbWUgOiAnJztcbiAgICBjb25zdCBuZXdVc2VyVHlwZSA9IHZhbGlkUG9zaXRpb24ubGVuZ3RoID09PSAxID8gdmFsaWRQb3NpdGlvblswXS51c2VyVHlwZSA6ICdvdGhlcic7XG4gICAgdGhpcy5wcm9wcy5hY3Rpb25zLnNldFBvc2l0aW9uKG5ld1Bvc2l0aW9uLCBuZXdVc2VyVHlwZSk7XG4gICAgaWYgKCFjdXJyZW50Q2FyZWVyT2JqLmdyb3VwTGFiZWwpIHtcbiAgICAgIHNldFRpbWVvdXQoKCkgPT4gdGhpcy5yZWZzLnN1Ym1pdC5jbGljaygpLCA1MCk7IC8vIHdhaXQgdG8gcmVuZGVyIHRoZSBpbnRlcmZhY2Ugd2l0aCB0aGUgY29ycmVjdCBmaWVsZFxuICAgIH1cbiAgfVxuXG4gIG9uQ2hhbmdlUG9zaXRpb24obmV3UG9zaXRpb24pIHtcbiAgICBjb25zdCBwb3NpdGlvbnMgPSB0aGlzLnByb3BzLnJlZmRhdGEucG9zaXRpb25zO1xuICAgIGNvbnN0IGZpbHRlcmVkUG9zaXRpb25zID0gcG9zaXRpb25zXG4gICAgLmZpbHRlcigocCkgPT4gbmV3UG9zaXRpb24gPT09IHAubmFtZSk7XG5cbiAgICBjb25zdCBuZXdVc2VyVHlwZSA9IGZpbHRlcmVkUG9zaXRpb25zLmxlbmd0aCA/IGZpbHRlcmVkUG9zaXRpb25zWzBdLnVzZXJUeXBlIDogJ290aGVyJztcbiAgICB0aGlzLnByb3BzLmFjdGlvbnMuc2V0UG9zaXRpb24obmV3UG9zaXRpb24sIG5ld1VzZXJUeXBlKTtcbiAgICBzZXRUaW1lb3V0KCgpID0+IHRoaXMucmVmcy5zdWJtaXQuY2xpY2soKSwgNTApOyAvLyB3YWl0IHRvIHJlbmRlciB0aGUgaW50ZXJmYWNlIHdpdGggdGhlIGNvcnJlY3QgZmllbGRcbiAgfVxuXG4gIG9uU3VibWl0KGUpIHtcbiAgICBpZiAoIXRoaXMucHJvcHMuY29tbW9uLmlzTW9kYWwgJiYgIXRoaXMucHJvcHMuY29tbW9uLmlzSW5saW5lKSByZXR1cm47XG4gICAgZS5wcmV2ZW50RGVmYXVsdCgpO1xuICAgIGNvbnN0IHBvc2l0aW9uID0gdGhpcy5wcm9wcy5jb21tb24ucG9zaXRpb247XG4gICAgY29uc3QgdXNlclR5cGUgPSBnZXRVc2VyVHlwZVBvc2l0aW9uKHRoaXMucHJvcHMucmVmZGF0YS5wb3NpdGlvbnMsIHBvc2l0aW9uKTtcblxuICAgIHRoaXMucHJvcHMuYWN0aW9ucy5zZXRVc2VyVHlwZSh1c2VyVHlwZSk7XG5cbiAgICBpZiAodGhpcy5wcm9wcy5pc1N0YW5kQWxvbmUpIHtcbiAgICAgIHRoaXMucHJvcHMuYWN0aW9ucy51cGRhdGVVc2VyRGF0YSh7IHVzZXJUeXBlLCBwb3NpdGlvbiB9KTtcbiAgICB9IGVsc2Uge1xuICAgICAgdGhpcy5wcm9wcy5hY3Rpb25zLmluaXRTZXRGb3JtVHlwZSgncmVnaXN0ZXInKTtcbiAgICB9XG4gIH1cblxuICByZW5kZXIoKSB7XG4gICAgY29uc3QgeyBwb3NpdGlvbnMsIGNhcmVlcnMgfSA9IHRoaXMucHJvcHMucmVmZGF0YTtcbiAgICBjb25zdCBjdXJyZW50UG9zaXRpb24gPSB0aGlzLnByb3BzLmNvbW1vbi5wb3NpdGlvbjtcbiAgICBjb25zdCBjdXJyZW50Q2FyZWVyT2JqID0gdGhpcy5zdGF0ZS5jdXJyZW50Q2FyZWVyT2JqO1xuXG4gICAgY29uc3QgcG9zaXRpb25PcHRpb25zID0gZmlsdGVyUG9zaXRpb24ocG9zaXRpb25zLCBjdXJyZW50Q2FyZWVyT2JqKVxuICAgIC5tYXAoKHBvcykgPT4gKHtcbiAgICAgIGxhYmVsOiBwb3MubmFtZSxcbiAgICAgIHZhbHVlOiBwb3MubmFtZSxcbiAgICB9KSk7XG5cbiAgICBjb25zdCBjYXJlZXJPcHRpb25zID0gY2FyZWVyc1xuICAgIC5tYXAoKHBvcykgPT4gKHtcbiAgICAgIGxhYmVsOiBwb3MubmFtZSxcbiAgICAgIHZhbHVlOiBwb3MubmFtZSxcbiAgICB9KSk7XG5cbiAgICByZXR1cm4gKFxuICAgICAgPGRpdiBpZD1cInNlbGVjdC1wb3NpdGlvblwiID5cbiAgICAgICAgeyB0aGlzLnByb3BzLmNvbW1vbi5icmFuZGluZyA/XG4gICAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJwYWRkaW5nLWxlZnQtbWQgcGFkZGluZy1yaWdodC1tZFwiPlxuICAgICAgICAgICAgPEJyYW5kaW5nIHsuLi50aGlzLnByb3BzLmNvbW1vbi5icmFuZGluZ30gY2RuVXJsPXt0aGlzLnByb3BzLmNvbW1vbi5jZG5Vcmx9IG1hcmdpbj17ZmFsc2V9IC8+XG4gICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgOlxuICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPVwidGVzLW1vZGFsX19ib2R5X3RvcFwiPlxuICAgICAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJwYWRkaW5nLWxlZnQtbWQgcGFkZGluZy1yaWdodC1tZCBwYWRkaW5nLWJvdHRvbS14cyBtYXJnaW4tYm90dG9tLXhzXCI+XG4gICAgICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPVwiaGVhZGluZy1tYWluIHRleHQtY2VudGVyXCI+XG4gICAgICAgICAgICAgICAgPGgzIGNsYXNzTmFtZT1cInRlcy1tb2RhbF9faGVhZGluZyBtYXJnaW4tYm90dG9tLXNtXCI+Sm9pbiBUZXMgZm9yIGZyZWU8L2gzPlxuICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgIDwvZGl2PlxuICAgICAgICB9XG4gICAgICAgIDxkaXYgY2xhc3NOYW1lPVwidGVzLW1vZGFsX19ib2R5X21pZGRsZVwiPlxuICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPVwicGFkZGluZy1tZFwiPlxuICAgICAgICAgICAgPGRpdj5cbiAgICAgICAgICAgICAgPGg0IGNsYXNzTmFtZT1cInRlcy1tb2RhbF9faGVhZGluZyB0ZXh0LS13aGl0ZSB0ZXh0LXdoaXRlIG1hcmdpbi1ib3R0b20tc21cIj48c3Ryb25nPkkgYW0gYSAuLi48L3N0cm9uZz48L2g0PlxuICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICA8Zm9ybSBhdXRvQ29tcGxldGU9XCJvZmZcIiBjbGFzc05hbWU9XCJ0LXN0dWRlbnQtZm9ybSBhcHAtYXV0aGVudGljYXRpb24tc2VsZWN0LWZvcm1cIlxuICAgICAgICAgICAgICBhY3Rpb249e3RoaXMucHJvcHMuYWN0aW9ufSBtZXRob2Q9e3RoaXMucHJvcHMubWV0aG9kfVxuICAgICAgICAgICAgICBvblN1Ym1pdD17dGhpcy5wcm9wcy5vblN1Ym1pdH1cbiAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgPEhpZGRlbklucHV0cyBpc0dldFJlcXVlc3Q9e3RoaXMucHJvcHMubWV0aG9kLnRvTG93ZXJDYXNlKCkgPT09ICdnZXQnfSBub1Bvc2l0aW9uIC8+XG4gICAgICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPVwicGFkZGluZy1ib3R0b20tbWRcIj5cbiAgICAgICAgICAgICAgICA8QnV0dG9uU2VsZWN0XG4gICAgICAgICAgICAgICAgICBpZD1cImNhcmVlci1zZWxlY3RvclwiXG4gICAgICAgICAgICAgICAgICBvbkNoYW5nZT17KHYpID0+IHRoaXMub25DaGFuZ2VDYXJlZXIodil9XG4gICAgICAgICAgICAgICAgICB2YWx1ZT17Y3VycmVudENhcmVlck9iai5uYW1lfVxuICAgICAgICAgICAgICAgICAgb3B0aW9ucz17Y2FyZWVyT3B0aW9uc31cbiAgICAgICAgICAgICAgICAgIGVtcHR5T3B0aW9uTGFiZWw9XCJDaG9vc2UgeW91ciByb2xlXCJcbiAgICAgICAgICAgICAgICAvPlxuICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgICAge2N1cnJlbnRDYXJlZXJPYmouZ3JvdXBMYWJlbCA/XG4gICAgICAgICAgICAgIDxkaXY+XG4gICAgICAgICAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJwYWRkaW5nLWJvdHRvbS1tZFwiPlxuICAgICAgICAgICAgICAgICAgPEN1c3RvbVNlbGVjdFxuICAgICAgICAgICAgICAgICAgICBpZD1cInBvc2l0aW9uLXNlbGVjdG9yXCJcbiAgICAgICAgICAgICAgICAgICAgY2xhc3NOYW1lPVwidGVzLWNvbnRyb2wgdGVzLXNlbGVjdFwiXG4gICAgICAgICAgICAgICAgICAgIG5hbWU9XCJwb3NpdGlvblwiXG4gICAgICAgICAgICAgICAgICAgIG9uQ2hhbmdlPXsodikgPT4gdGhpcy5vbkNoYW5nZVBvc2l0aW9uKHYpfVxuICAgICAgICAgICAgICAgICAgICB2YWx1ZT17Y3VycmVudFBvc2l0aW9ufVxuICAgICAgICAgICAgICAgICAgICBvcHRpb25zPXtwb3NpdGlvbk9wdGlvbnN9XG4gICAgICAgICAgICAgICAgICAgIGVtcHR5T3B0aW9uTGFiZWw9XCJDaG9vc2UgYSBwb3NpdGlvblwiXG4gICAgICAgICAgICAgICAgICAvPlxuICAgICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgIDogPGlucHV0IHR5cGU9XCJoaWRkZW5cIiBuYW1lPVwicG9zaXRpb25cIiB2YWx1ZT17Y3VycmVudFBvc2l0aW9ufSAvPlxuICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgIDxidXR0b24gcmVmPVwic3VibWl0XCIgb25DbGljaz17KGUpID0+IHRoaXMub25TdWJtaXQoZSl9IHR5cGU9XCJzdWJtaXRcIiBjbGFzc05hbWU9XCJ0ZXMtYnRuIHRlcy1idG4tLWxnIHRlcy1idG4tLWljb24gdGVzLWJ0bi0tYmxvY2sgdGVzLWJ0bi0tcHJpbWFyeSBoaWRkZW5cIj5PazwvYnV0dG9uPlxuICAgICAgICAgICAgPC9mb3JtPlxuICAgICAgICAgIDwvZGl2PlxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgeyAhdGhpcy5wcm9wcy5pc1N0YW5kQWxvbmUgP1xuICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cInRlcy1tb2RhbF9fYm9keV9ib3R0b21cIj5cbiAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cIm1vcmUtaW5mbyB0ZXh0LWNlbnRlciB0ZXh0LS1zbSBwYWRkaW5nLXRvcC1tZCBib3JkZXItdG9wXCI+XG4gICAgICAgICAgICAgIDxzcGFuPkFscmVhZHkgaGF2ZSBhIFRlcyBhY2NvdW50Pzwvc3Bhbj48c3Bhbj4gPC9zcGFuPlxuICAgICAgICAgICAgICA8V2lkZ2V0TGluayBmb3JtVHlwZT1cInNpZ25JblwiPkxvZyBpbiBub3chPC9XaWRnZXRMaW5rPlxuICAgICAgICAgIDwvZGl2PlxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgOiBudWxsIH1cbiAgICAgIDwvZGl2PlxuICAgICk7XG4gIH1cbn1cblxuU2VsZWN0Rm9ybVBvc2l0aW9uLnByb3BUeXBlcyA9IHtcbiAgY29tbW9uOiBQcm9wVHlwZXMub2JqZWN0LmlzUmVxdWlyZWQsXG4gIGVycm9yczogUHJvcFR5cGVzLm9iamVjdC5pc1JlcXVpcmVkLFxuICByZWZkYXRhOiBQcm9wVHlwZXMub2JqZWN0LmlzUmVxdWlyZWQsXG4gIGlzU3RhbmRBbG9uZTogUHJvcFR5cGVzLmJvb2wsXG4gIGFjdGlvbjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBtZXRob2Q6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbn07XG5cbmNvbnN0IG1hcERpc3BhdGNoVG9Qcm9wcyA9IChkaXNwYXRjaCkgPT4gKHtcbiAgYWN0aW9uczogYmluZEFjdGlvbkNyZWF0b3JzKGFjdGlvbkNyZWF0b3JzLCBkaXNwYXRjaCksXG59KTtcblxuZXhwb3J0IGRlZmF1bHQgY29ubmVjdChcbiBzdGF0ZSA9PiAoe1xuICAgY29tbW9uOiBzdGF0ZS5jb21tb24sXG4gICBlcnJvcnM6IHN0YXRlLmVycm9ycyxcbiAgIHJlZmRhdGE6IHN0YXRlLnJlZmRhdGEsXG4gfSksXG4gbWFwRGlzcGF0Y2hUb1Byb3BzXG4pKFNlbGVjdEZvcm1Qb3NpdGlvbik7XG4iLCJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IFNlbGVjdEZvcm1Qb3NpdGlvbiBmcm9tICcuL1NlbGVjdEZvcm1Qb3NpdGlvbic7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIFNlbGVjdFBvc2l0aW9uKCkge1xuICByZXR1cm4gKDxTZWxlY3RGb3JtUG9zaXRpb25cbiAgICBhY3Rpb249XCIvYXV0aG4vcmVnaXN0ZXJcIlxuICAgIG1ldGhvZD1cImdldFwiXG4gIC8+KTtcbn1cbiIsImltcG9ydCBSZWFjdCwgeyBQcm9wVHlwZXMsIENvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGdldEVycm9yTXNnRnJvbVByZWZpeCwgZ2V0RXJyb3JDbHNGcm9tUHJlZml4IH0gZnJvbSAnLi4vbGliL2dldEVycm9yRnJvbVByZWZpeCc7XG5pbXBvcnQgeyBjb25uZWN0IH0gZnJvbSAncmVhY3QtcmVkdXgnO1xuaW1wb3J0IHsgYmluZEFjdGlvbkNyZWF0b3JzIH0gZnJvbSAncmVkdXgnO1xuaW1wb3J0ICogYXMgYWN0aW9uQ3JlYXRvcnMgZnJvbSAnLi4vcmVkdWNlcnMvYWN0aW9ucyc7XG5pbXBvcnQgV2lkZ2V0TGluayBmcm9tICcuL2xpYi9XaWRnZXRMaW5rJztcbmltcG9ydCBIaWRkZW5JbnB1dHMgZnJvbSAnLi9saWIvSGlkZGVuSW5wdXRzJztcbmltcG9ydCBJbnB1dEZpZWxkIGZyb20gJy4vbGliL0lucHV0RmllbGQnO1xuaW1wb3J0IEJyYW5kaW5nIGZyb20gJy4vbGliL0JyYW5kaW5nJztcblxuY29uc3QgZ2V0RXJyb3JNc2cgPSBnZXRFcnJvck1zZ0Zyb21QcmVmaXgoJ3NpZ25pbicpO1xuY29uc3QgZ2V0RXJyb3JDbHMgPSBnZXRFcnJvckNsc0Zyb21QcmVmaXgoJ3NpZ25pbicpO1xuY29uc3QgZ2V0R2VuZXJpY0Vycm9yTXNnID0gZ2V0RXJyb3JNc2dGcm9tUHJlZml4KCdnZW5lcmljJyk7XG5jb25zdCBnZXRHZW5lcmljRXJyb3JDbHMgPSBnZXRFcnJvckNsc0Zyb21QcmVmaXgoJ2dlbmVyaWMnKTtcblxuZXhwb3J0IGNsYXNzIFNpZ25pbiBleHRlbmRzIENvbXBvbmVudCB7XG5cbiAgZ2V0R29vZ2xlTG9nb1VSTCgpIHtcbiAgICByZXR1cm4gYCR7dGhpcy5wcm9wcy5jb21tb24uY2RuVXJsfWltZy9nb29nbGUtbG9nby1nLnBuZ2A7XG4gIH1cblxuICBnZXRGYWNlYm9va0xvZ29VUkwoKSB7XG4gICAgcmV0dXJuIGAke3RoaXMucHJvcHMuY29tbW9uLmNkblVybH1pbWcvZmFjZWJvb2stbG9nby5wbmdgO1xuICB9XG5cbiAgaGFuZGxlR29vZ2xlKCkge1xuICAgIHRoaXMucHJvcHMuYWN0aW9ucy5pbml0T2F1dGhTaWduSW4oJ2dvb2dsZScpO1xuICB9XG5cbiAgaGFuZGxlRmFjZWJvb2soKSB7XG4gICAgdGhpcy5wcm9wcy5hY3Rpb25zLmluaXRPYXV0aFNpZ25JbignZmFjZWJvb2snKTtcbiAgfVxuXG4gIGhhbmRsZVN1Ym1pdChlKSB7XG4gICAgZS5wcmV2ZW50RGVmYXVsdCgpO1xuICAgIGNvbnN0IHRhcmdldCA9IGUudGFyZ2V0O1xuXG4gICAgdGhpcy5wcm9wcy5hY3Rpb25zLmluaXRTaWduSW4oKCkgPT4ge1xuICAgICAgdGFyZ2V0LnN1Ym1pdCgpO1xuICAgIH0pO1xuICB9XG5cbiAgaGFzRXJyb3IoKSB7XG4gICAgcmV0dXJuIHRoaXMucHJvcHMuZXJyb3JzID8gT2JqZWN0LmtleXModGhpcy5wcm9wcy5lcnJvcnMpLmZpbHRlcigobikgPT4gbi5zdGFydHNXaXRoKCdzaWduaW4uJykpLmxlbmd0aCA+IDAgOiBmYWxzZTtcbiAgfVxuXG4gIGNoYW5nZUZpZWxkKG5hbWVwYXIsIGRlcHNwYXIpIHtcbiAgICBjb25zdCBuYW1lID0gYHNpZ25pbi4ke25hbWVwYXJ9YDtcbiAgICBjb25zdCBkZXBzID0gZGVwc3Bhci5tYXAobiA9PiBgc2lnbmluLiR7bn1gKSB8fCBbXTtcbiAgICByZXR1cm4gKGUpID0+IHtcbiAgICAgIGNvbnN0IHRhcmdldCA9IGUudGFyZ2V0O1xuICAgICAgdGhpcy5wcm9wcy5hY3Rpb25zLnNldEZpZWxkKCdzaWduSW4nLCB0YXJnZXQubmFtZSwgdGFyZ2V0LnR5cGUgPT09ICdjaGVja2JveCcgfHwgdGFyZ2V0LnR5cGUgPT09ICdyYWRpbycgPyB0YXJnZXQuY2hlY2tlZCA6IHRhcmdldC52YWx1ZSk7XG4gICAgICB0aGlzLnByb3BzLmFjdGlvbnMuY2hhbmdlRmllbGQobmFtZSwgZGVwcyk7XG4gICAgfTtcbiAgfVxuXG4gIHJlbmRlcigpIHtcbiAgICBjb25zdCBlcnIgPSB0aGlzLnByb3BzLmVycm9ycztcblxuICAgIHJldHVybiAoXG4gICAgPGRpdiBpZD1cInNpZ24taW5cIiBjbGFzc05hbWU9XCJwYWRkaW5nLWxlZnQtbWQgcGFkZGluZy1yaWdodC1tZCBwYWRkaW5nLWJvdHRvbS14cyBtYXJnaW4tYm90dG9tLXhzXCI+XG4gICAgICB7IHRoaXMucHJvcHMuY29tbW9uLmJyYW5kaW5nID9cbiAgICAgICAgPEJyYW5kaW5nIHsuLi50aGlzLnByb3BzLmNvbW1vbi5icmFuZGluZ30gY2RuVXJsPXt0aGlzLnByb3BzLmNvbW1vbi5jZG5Vcmx9IC8+XG4gICAgICAgIDpcbiAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJoZWFkaW5nLW1haW4gbWFyZ2luLWJvdHRvbS1tZCB0ZXh0LWNlbnRlclwiPlxuICAgICAgICAgIDxoMyBjbGFzc05hbWU9XCJ0ZXMtbW9kYWxfX2hlYWRpbmcgbWFyZ2luLWJvdHRvbS1zbVwiPlBsZWFzZSBsb2cgaW48L2gzPlxuICAgICAgICA8L2Rpdj5cbiAgICAgIH1cbiAgICAgIDxkaXY+XG4gICAgICAgIDxkaXYgY2xhc3NOYW1lPVwicm93XCI+XG4gICAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJjb2wteHMtMTJcIj5cbiAgICAgICAgICAgIDxidXR0b25cbiAgICAgICAgICAgICAgZGlzYWJsZWQ9e3RoaXMucHJvcHMuc2lnbkluLnN0YXRlID09PSAnd2FpdCcgfHwgdGhpcy5wcm9wcy5jb21tb24ub2F1dGhTdGF0ZSA/ICdkaXNhYmxlZCcgOiBudWxsfVxuICAgICAgICAgICAgICBvbkNsaWNrPXsoZSkgPT4gdGhpcy5oYW5kbGVHb29nbGUoZSl9XG4gICAgICAgICAgICAgIGNsYXNzTmFtZT1cInRlcy1idG4gdGVzLWJ0bi0tc2Vjb25kYXJ5IHRlcy1idG4tLWljb24gdGVzLWJ0bi0tYmxvY2sgdGVzLWJ0bi0tc29jaWFsXCJcbiAgICAgICAgICAgID5cbiAgICAgICAgICAgICAge3RoaXMucHJvcHMuY29tbW9uLm9hdXRoU3RhdGUgPT09ICdnb29nbGUnID9cbiAgICAgICAgICAgICAgICA8aSBjbGFzc05hbWU9XCJpY29uLXNwaW4gaWNvbi1zcGlubmVyIHRlcy1idG5fX2ljb25cIj48L2k+XG4gICAgICAgICAgICAgIDogPHNwYW4gY2xhc3NOYW1lPVwidGV4dC0tc21cIj48aW1nIHN0eWxlPXt7IHBhZGRpbmc6ICcwIDZweCAycHggMCcsIHZlcnRpY2FsQWxpZ246ICdtaWRkbGUnIH19IHNyYz17dGhpcy5nZXRHb29nbGVMb2dvVVJMKCl9IC8+IExvZyBpbiB3aXRoIEdvb2dsZTwvc3Bhbj59XG4gICAgICAgICAgICAgIDwvYnV0dG9uPlxuICAgICAgICAgIDwvZGl2PlxuICAgICAgICA8L2Rpdj5cbiAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJyb3cgbWFyZ2luLXRvcC1zbVwiPlxuICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPVwiY29sLXhzLTEyXCI+XG4gICAgICAgICAgICA8YnV0dG9uXG4gICAgICAgICAgICAgIGRpc2FibGVkPXt0aGlzLnByb3BzLnNpZ25Jbi5zdGF0ZSA9PT0gJ3dhaXQnIHx8IHRoaXMucHJvcHMuY29tbW9uLm9hdXRoU3RhdGUgPyAnZGlzYWJsZWQnIDogbnVsbH1cbiAgICAgICAgICAgICAgb25DbGljaz17KGUpID0+IHRoaXMuaGFuZGxlRmFjZWJvb2soZSl9XG4gICAgICAgICAgICAgIGNsYXNzTmFtZT1cInRlcy1idG4gdGVzLWJ0bi0tc2Vjb25kYXJ5IHRlcy1idG4tLWljb24gdGVzLWJ0bi0tYmxvY2sgdGVzLWJ0bi0tc29jaWFsXCJcbiAgICAgICAgICAgID5cbiAgICAgICAgICAgICAge3RoaXMucHJvcHMuY29tbW9uLm9hdXRoU3RhdGUgPT09ICdmYWNlYm9vaycgP1xuICAgICAgICAgICAgICAgIDxpIGNsYXNzTmFtZT1cImljb24tc3BpbiBpY29uLXNwaW5uZXIgdGVzLWJ0bl9faWNvblwiPjwvaT5cbiAgICAgICAgICAgICAgOiA8c3BhbiBjbGFzc05hbWU9XCJ0ZXh0LS1zbVwiPjxpbWcgc3R5bGU9e3sgcGFkZGluZzogJzAgNnB4IDJweCAwJywgdmVydGljYWxBbGlnbjogJ21pZGRsZScgfX0gc3JjPXt0aGlzLmdldEZhY2Vib29rTG9nb1VSTCgpfSAvPiBMb2cgaW4gd2l0aCBGYWNlYm9vazwvc3Bhbj59XG4gICAgICAgICAgICA8L2J1dHRvbj5cbiAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgPC9kaXY+XG5cbiAgICAgICAgPGZvcm0gYXV0b0NvbXBsZXRlPVwib2ZmXCIgb25TdWJtaXQ9eyhlKSA9PiB0aGlzLmhhbmRsZVN1Ym1pdChlKX0gcm9sZT1cImZvcm1cIiBjbGFzc05hbWU9XCJ0LXNpZ24taW4tZm9ybSBtYXJnaW4tYm90dG9tLXNtXCIgbWV0aG9kPVwicG9zdFwiIGFjdGlvbj1cIi9hcGkvYXV0aG4vc2lnbi1pbi1yZWRpcmVjdFwiID5cbiAgICAgICAgICA8SGlkZGVuSW5wdXRzIC8+XG4gICAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJzZXBhcmF0b3JcIj5cbiAgICAgICAgICAgIDxzcGFuIGNsYXNzTmFtZT1cInNlcGFyYXRvci0tdGV4dCBiZy13aGl0ZVwiPm9yPC9zcGFuPlxuICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgIDxJbnB1dEZpZWxkXG4gICAgICAgICAgICBuYW1lPVwiaWRlbnRpZmljYXRpb25cIlxuICAgICAgICAgICAgbGFiZWw9XCJVc2VybmFtZSBvciBlbWFpbFwiXG4gICAgICAgICAgICBpY29uPVwidXNlclwiXG4gICAgICAgICAgICB2YWx1ZT17dGhpcy5wcm9wcy5zaWduSW4uaWRlbnRpZmljYXRpb259XG4gICAgICAgICAgICBlcnJvckNsYXNzPXtnZXRFcnJvckNscygndXNlck5hbWUnKShlcnIpfVxuICAgICAgICAgICAgZXJyb3JNZXNzYWdlPXtnZXRFcnJvck1zZygndXNlck5hbWUnKShlcnIpfVxuICAgICAgICAgICAgb25DaGFuZ2U9e3RoaXMuY2hhbmdlRmllbGQoJ3VzZXJOYW1lJywgWydwYXNzd29yZCddKX1cbiAgICAgICAgICAgIGF1dG9Gb2N1cz1cInRydWVcIlxuICAgICAgICAgICAgYXV0b0NvbXBsZXRlPVwib2ZmXCJcbiAgICAgICAgICAvPlxuICAgICAgICAgIDxJbnB1dEZpZWxkXG4gICAgICAgICAgICBuYW1lPVwicGFzc3dvcmRcIlxuICAgICAgICAgICAgbGFiZWw9XCJQYXNzd29yZFwiXG4gICAgICAgICAgICBpY29uPVwibG9ja1wiXG4gICAgICAgICAgICB2YWx1ZT17dGhpcy5wcm9wcy5zaWduSW4ucGFzc3dvcmR9XG4gICAgICAgICAgICBlcnJvckNsYXNzPXtnZXRFcnJvckNscygncGFzc3dvcmQnKShlcnIpfVxuICAgICAgICAgICAgZXJyb3JNZXNzYWdlPXtnZXRFcnJvck1zZygncGFzc3dvcmQnKShlcnIpfVxuICAgICAgICAgICAgb25DaGFuZ2U9e3RoaXMuY2hhbmdlRmllbGQoJ3Bhc3N3b3JkJywgWyd1c2VyTmFtZSddKX1cbiAgICAgICAgICAgIHR5cGU9XCJwYXNzd29yZFwiXG4gICAgICAgICAgICBhdXRvQ29tcGxldGU9XCJvZmZcIlxuICAgICAgICAgIC8+XG4gICAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJ0ZXh0LS1zbSBtYXJnaW4tYm90dG9tLW1kIG1hcmdpbi10b3AtbWRcIj5cbiAgICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPVwidGVzLWNoZWNrYm94IHRlcy1jaGVja2JveC0taW5saW5lXCI+XG4gICAgICAgICAgICAgIDxsYWJlbCBjbGFzc05hbWU9XCJ0ZXMtY29udHJvbC1sYWJlbFwiIHRpdGxlPVwiVGhpcyBzaG91bGRuJ3QgYmUgdXNlZCBvbiBhIHNoYXJlZCBjb21wdXRlclwiPlxuICAgICAgICAgICAgICAgIDxpbnB1dCB0eXBlPVwiY2hlY2tib3hcIlxuICAgICAgICAgICAgICAgICAgbmFtZT1cInRydXN0ZWRDb21wdXRlclwiXG4gICAgICAgICAgICAgICAgICB2YWx1ZT1cInRydWVcIlxuICAgICAgICAgICAgICAgICAgY2hlY2tlZD17dGhpcy5wcm9wcy5zaWduSW4udHJ1c3RlZENvbXB1dGVyfVxuICAgICAgICAgICAgICAgICAgb25DaGFuZ2U9e3RoaXMuY2hhbmdlRmllbGQoJ3RydXN0ZWRDb21wdXRlcicsIFtdKX1cbiAgICAgICAgICAgICAgICAvPlxuICAgICAgICAgICAgICAgIDxzcGFuIGNsYXNzTmFtZT1cInRleHQtLXNtXCI+U3RheSBsb2dnZWQgaW48L3NwYW4+XG4gICAgICAgICAgICAgIDwvbGFiZWw+XG4gICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgIDxXaWRnZXRMaW5rIGZvcm1UeXBlPVwiZm9yZ290UGFzc3dvcmRcIj5Gb3Jnb3QgcGFzc3dvcmQ/PC9XaWRnZXRMaW5rPlxuICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgIDxkaXY+XG4gICAgICAgICAgICA8YnV0dG9uXG4gICAgICAgICAgICAgIGRpc2FibGVkPXt0aGlzLnByb3BzLnNpZ25Jbi5zdGF0ZSA9PT0gJ3dhaXQnIHx8IHRoaXMucHJvcHMuY29tbW9uLmdvb2dsZVN0YXRlID09PSAnd2FpdCcgPyAnZGlzYWJsZWQnIDogbnVsbH1cbiAgICAgICAgICAgICAgdHlwZT1cInN1Ym1pdFwiIGNsYXNzTmFtZT1cInRlcy1idG4gdGVzLWJ0bi0tbGcgc2lnbi1pbi1zdWJtaXQgdGVzLWJ0bi0taWNvbiB0ZXMtYnRuLS1ibG9jayB0ZXMtYnRuLS1wcmltYXJ5XCJcbiAgICAgICAgICAgID5cbiAgICAgICAgICAgIHt0aGlzLnByb3BzLnNpZ25JbnN0YXRlID09PSAnd2FpdCcgP1xuICAgICAgICAgICAgICA8aSBjbGFzc05hbWU9XCJpY29uLXNwaW4gaWNvbi1zcGlubmVyIGljb24td2hpdGUgdGVzLWJ0bl9faWNvblwiPjwvaT5cbiAgICAgICAgICAgIDogJ0xvZyBpbid9XG4gICAgICAgICAgICA8L2J1dHRvbj5cbiAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgPC9mb3JtPlxuICAgICAgICB7Z2V0R2VuZXJpY0Vycm9yQ2xzKCdnb29nbGVidXR0b24nKShlcnIpID9cbiAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cInJvd1wiPlxuICAgICAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJjb2wteHMtMTIgdGVzLWhhcy1lcnJvclwiPlxuICAgICAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT1cInRlcy1oZWxwLWJsb2NrXCI+e2dldEdlbmVyaWNFcnJvck1zZygnZ29vZ2xlYnV0dG9uJykoZXJyKX08L2Rpdj5cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgIDwvZGl2PlxuICAgICAgICA6IG51bGx9XG4gICAgICA8L2Rpdj5cbiAgICAgIDxkaXYgY2xhc3NOYW1lPVwiY2xlYXJmaXhcIj5cbiAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJtb3JlLWluZm8gdGV4dC1jZW50ZXIgdGV4dC0tc20gcGFkZGluZy10b3Atc21cIj5cbiAgICAgICAgICAgIDxzcGFuPk5vdCBhIG1lbWJlciB5ZXQ/PC9zcGFuPjxzcGFuPiA8L3NwYW4+XG4gICAgICAgICAgICA8V2lkZ2V0TGluayBmb3JtVHlwZT1cInJlZ2lzdGVyXCI+Sm9pbiB1cyBmb3IgZnJlZTwvV2lkZ2V0TGluaz5cbiAgICAgICAgPC9kaXY+XG4gICAgICA8L2Rpdj5cbiAgICA8L2Rpdj5cbiAgICApO1xuICB9XG59XG5cblNpZ25pbi5wcm9wVHlwZXMgPSB7XG4gIGNvbW1vbjogUHJvcFR5cGVzLm9iamVjdC5pc1JlcXVpcmVkLFxuICBlcnJvcnM6IFByb3BUeXBlcy5vYmplY3QuaXNSZXF1aXJlZCxcbiAgc2lnbkluOiBQcm9wVHlwZXMub2JqZWN0LmlzUmVxdWlyZWQsXG59O1xuXG5jb25zdCBtYXBEaXNwYXRjaFRvUHJvcHMgPSAoZGlzcGF0Y2gpID0+ICh7XG4gIGFjdGlvbnM6IGJpbmRBY3Rpb25DcmVhdG9ycyhhY3Rpb25DcmVhdG9ycywgZGlzcGF0Y2gpLFxufSk7XG5cbmV4cG9ydCBkZWZhdWx0IGNvbm5lY3QoXG4gc3RhdGUgPT4gKHtcbiAgIGNvbW1vbjogc3RhdGUuY29tbW9uLFxuICAgZXJyb3JzOiBzdGF0ZS5lcnJvcnMsXG4gICBzaWduSW46IHN0YXRlLnNpZ25JbixcbiB9KSxcbiBtYXBEaXNwYXRjaFRvUHJvcHNcbikoU2lnbmluKTtcbiIsImltcG9ydCBSZWFjdCwgeyBQcm9wVHlwZXMgfSBmcm9tICdyZWFjdCc7XG5cbmZ1bmN0aW9uIEJyYW5kaW5nKHsgbG9nbywgbmFtZSwgdGV4dCwgY2RuVXJsLCBtYXJnaW4gPSB0cnVlIH0pIHtcbiAgY29uc3QgY2xhc3NlcyA9IFtcbiAgICAndGV4dC1jZW50ZXInLFxuICAgIG1hcmdpbiA/ICdtYXJnaW4tYm90dG9tLWxnJyA6ICcnLFxuICAgIGBhdXRoLWJyYW5kLSR7bmFtZX1gLFxuICAgICdoZWFkaW5nLS1zbScsXG4gICAgJ2hlYWRpbmctLWJvbGQnLFxuICAgICd0ZXh0LS13aGl0ZScsXG4gICAgJ3BhZGRpbmctc20nLFxuICBdO1xuXG4gIHJldHVybiAoXG4gICAgPGRpdiBjbGFzc05hbWU9e2NsYXNzZXMuam9pbignICcpfT5cbiAgICAgIDxpbWcgc3JjPXtgJHtjZG5Vcmx9aW1nLyR7bG9nb31gfSBoZWlnaHQ9XCIzOVwiIC8+XG4gICAgICA8cD57dGV4dH08L3A+XG4gICAgPC9kaXY+XG4gICk7XG59XG5cbkJyYW5kaW5nLnByb3BUeXBlcyA9IHtcbiAgbG9nbzogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBuYW1lOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHRleHQ6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgY2RuVXJsOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIG1hcmdpbjogUHJvcFR5cGVzLmJvb2wsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBCcmFuZGluZztcbiIsImltcG9ydCBSZWFjdCwgeyBQcm9wVHlwZXMsIENvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgQnV0dG9uU2VsZWN0IGV4dGVuZHMgQ29tcG9uZW50IHtcbiAgY29uc3RydWN0b3IocHJvcHMpIHtcbiAgICBzdXBlcihwcm9wcyk7XG4gICAgdGhpcy5zdGF0ZSA9IHsgdmFsdWU6IHByb3BzLnZhbHVlIHx8ICcnIH07XG4gIH1cblxuICBvbkNsaWNrKGUsIHZhbHVlKSB7XG4gICAgZS5wcmV2ZW50RGVmYXVsdCgpO1xuICAgIGNvbnN0IG5ld1ZhbHVlID0gdmFsdWU7XG4gICAgaWYgKG5ld1ZhbHVlICE9PSB0aGlzLnN0YXRlLnZhbHVlKSB7XG4gICAgICB0aGlzLnNldFN0YXRlKHsgdmFsdWU6IG5ld1ZhbHVlIH0pO1xuICAgICAgdGhpcy5wcm9wcy5vbkNoYW5nZShuZXdWYWx1ZSk7XG4gICAgfVxuICB9XG5cbiAgcmVuZGVyKCkge1xuICAgIGNvbnN0IG9wdGlvbnMgPSB0aGlzLnByb3BzLm9wdGlvbnM7XG5cbiAgICByZXR1cm4gKDxkaXZcbiAgICAgIGlkPXt0aGlzLnByb3BzLmlkfVxuICAgICAgY2xhc3NOYW1lPXt0aGlzLnByb3BzLmNsYXNzTmFtZX1cbiAgICA+XG4gICAgICB7dGhpcy5wcm9wcy5uYW1lID8gPGlucHV0IHR5cGU9XCJoaWRkZW5cIiB2YWx1ZT17dGhpcy5zdGF0ZS52YWx1ZX0gbmFtZT17dGhpcy5wcm9wcy5uYW1lfSAvPiA6IG51bGx9XG4gICAgICB7b3B0aW9ucy5tYXAoKHAsIGluZGV4KSA9PlxuICAgICAgICAocC52YWx1ZSA9PT0gdGhpcy5zdGF0ZS52YWx1ZSA/XG4gICAgICAgIDxkaXYga2V5PXtgc2VsZWN0LWJ1dHRvbi0ke2luZGV4fWB9IGNsYXNzTmFtZT1cIm1hcmdpbi10b3Atc20gbWFyZ2luLWJvdHRvbS1zbVwiPjxidXR0b24gY2xhc3NOYW1lPVwidGVzLWJ0biB0ZXMtYnRuLS1zZWNvbmRhcnktZ3JheS10ZXh0IHRlcy1idG4tLWJsb2NrXCIgZGlzYWJsZWQ+e3AubGFiZWx9PC9idXR0b24+PC9kaXY+XG4gICAgICAgIDpcbiAgICAgICAgPGRpdiBrZXk9e2BzZWxlY3QtYnV0dG9uLSR7aW5kZXh9YH0gY2xhc3NOYW1lPVwibWFyZ2luLXRvcC1zbSBtYXJnaW4tYm90dG9tLXNtXCI+PGJ1dHRvbiBjbGFzc05hbWU9XCJ0ZXMtYnRuIHRlcy1idG4tLXByaW1hcnkgdGVzLWJ0bi0tYmxvY2tcIiBvbkNsaWNrPXsoZSkgPT4gdGhpcy5vbkNsaWNrKGUsIHAudmFsdWUpfT57cC5sYWJlbH08L2J1dHRvbj48L2Rpdj4pKVxuICAgICAgfVxuICAgIDwvZGl2Pik7XG4gIH1cbn1cblxuQnV0dG9uU2VsZWN0LnByb3BUeXBlcyA9IHtcbiAgaWQ6IFByb3BUeXBlcy5zdHJpbmcsXG4gIGNsYXNzTmFtZTogUHJvcFR5cGVzLnN0cmluZyxcbiAgb3B0aW9uczogUHJvcFR5cGVzLmFycmF5LmlzUmVxdWlyZWQsXG4gIG9uQ2hhbmdlOiBQcm9wVHlwZXMuZnVuYyxcbiAgdmFsdWU6IFByb3BUeXBlcy5zdHJpbmcsXG4gIG5hbWU6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuIiwiaW1wb3J0IFJlYWN0LCB7IFByb3BUeXBlcywgQ29tcG9uZW50IH0gZnJvbSAncmVhY3QnO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBDdXN0b21TZWxlY3QgZXh0ZW5kcyBDb21wb25lbnQge1xuICBjb25zdHJ1Y3Rvcihwcm9wcykge1xuICAgIHN1cGVyKHByb3BzKTtcbiAgICB0aGlzLnN0YXRlID0geyB2YWx1ZTogcHJvcHMudmFsdWUgfHwgJycgfTtcbiAgfVxuXG4gIG9uQ2hhbmdlKGUpIHtcbiAgICBjb25zdCBuZXdWYWx1ZSA9IGUudGFyZ2V0LnZhbHVlO1xuICAgIGlmIChuZXdWYWx1ZSAhPT0gdGhpcy5zdGF0ZS52YWx1ZSkge1xuICAgICAgdGhpcy5zZXRTdGF0ZSh7IHZhbHVlOiBuZXdWYWx1ZSB9KTtcbiAgICAgIHRoaXMucHJvcHMub25DaGFuZ2UobmV3VmFsdWUpO1xuICAgIH1cbiAgfVxuXG4gIHJlbmRlcigpIHtcbiAgICBsZXQgb3B0aW9ucyA9IFtdO1xuICAgIGlmICh0aGlzLnByb3BzLmVtcHR5T3B0aW9uTGFiZWwpIHtcbiAgICAgIG9wdGlvbnMucHVzaCh7XG4gICAgICAgIGxhYmVsOiB0aGlzLnByb3BzLmVtcHR5T3B0aW9uTGFiZWwsXG4gICAgICAgIHZhbHVlOiAnJyxcbiAgICAgIH0pO1xuICAgIH1cbiAgICBvcHRpb25zID0gb3B0aW9ucy5jb25jYXQodGhpcy5wcm9wcy5vcHRpb25zKTtcblxuICAgIHJldHVybiAoPHNlbGVjdFxuICAgICAgYXV0b0NvbXBsZXRlPVwib2ZmXCJcbiAgICAgIGlkPXt0aGlzLnByb3BzLmlkfVxuICAgICAgY2xhc3NOYW1lPXt0aGlzLnByb3BzLmNsYXNzTmFtZX1cbiAgICAgIG9uQ2hhbmdlPXsoZSkgPT4gdGhpcy5vbkNoYW5nZShlKX1cbiAgICAgIHZhbHVlPXt0aGlzLnN0YXRlLnZhbHVlfVxuICAgICAgbmFtZT17dGhpcy5wcm9wcy5uYW1lfVxuICAgID5cbiAgICAgIHtvcHRpb25zLm1hcCgocCwgaW5kZXgpID0+XG4gICAgICAgIDxvcHRpb24ga2V5PXtgc2VsZWN0LSR7aW5kZXh9YH0gdmFsdWU9e3AudmFsdWV9PntwLmxhYmVsfTwvb3B0aW9uPilcbiAgICAgIH1cbiAgICA8L3NlbGVjdD4pO1xuICB9XG59XG5cbkN1c3RvbVNlbGVjdC5wcm9wVHlwZXMgPSB7XG4gIGlkOiBQcm9wVHlwZXMuc3RyaW5nLFxuICBjbGFzc05hbWU6IFByb3BUeXBlcy5zdHJpbmcsXG4gIG9wdGlvbnM6IFByb3BUeXBlcy5hcnJheS5pc1JlcXVpcmVkLFxuICBlbXB0eU9wdGlvbkxhYmVsOiBQcm9wVHlwZXMuc3RyaW5nLFxuICBvbkNoYW5nZTogUHJvcFR5cGVzLmZ1bmMsXG4gIHZhbHVlOiBQcm9wVHlwZXMuc3RyaW5nLFxuICBuYW1lOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcbiIsImltcG9ydCBSZWFjdCwgeyBQcm9wVHlwZXMgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBjb25uZWN0IH0gZnJvbSAncmVhY3QtcmVkdXgnO1xuaW1wb3J0IHsgZ2V0UGFnZUNvbnRleHQgfSBmcm9tICcuLi8uLi9saWIvdHJhY2tpbmcnO1xuXG5leHBvcnQgZnVuY3Rpb24gSGlkZGVuSW5wdXRzKHsgY29tbW9uLCBpc0dldFJlcXVlc3QsIG5vVXNlclR5cGUsIG5vUG9zaXRpb24gfSkge1xuICBjb25zdCBwYWdlQ29udGV4dCA9IGdldFBhZ2VDb250ZXh0KGNvbW1vbi5wYWdlTXosIGNvbW1vbi5vdmVycmlkZU16KTtcblxuICBjb25zdCBwYWdlQ29udGV4dElucHV0cyA9IFsncGFnZUlkJywgJ3BhZ2VUeXBlJywgJ3BhZ2VTZWN0aW9uJywgJ3BhZ2VTdWJTZWN0aW9uJ11cbiAgICAuZmlsdGVyKChuYW1lKSA9PiBwYWdlQ29udGV4dCAmJiBwYWdlQ29udGV4dFtuYW1lXSlcbiAgICAubWFwKChuYW1lKSA9PiA8aW5wdXQgdHlwZT1cImhpZGRlblwiIGtleT17bmFtZX0gbmFtZT17bmFtZX0gdmFsdWU9e3BhZ2VDb250ZXh0W25hbWVdfSAvPik7XG5cbiAgcmV0dXJuICg8c3Bhbj5cbiAgICB7cGFnZUNvbnRleHRJbnB1dHN9XG4gICAge2NvbW1vbi5ydG4gPyA8aW5wdXQgdHlwZT1cImhpZGRlblwiIG5hbWU9XCJydG5cIiB2YWx1ZT17Y29tbW9uLnJ0bn0gLz4gOiBudWxsfVxuICAgIHshbm9Vc2VyVHlwZSA/IDxpbnB1dCBjbGFzc05hbWU9XCJ0LXVzZXItdHlwZVwiIHR5cGU9XCJoaWRkZW5cIiBuYW1lPVwidXNlclR5cGVcIiB2YWx1ZT17Y29tbW9uLnVzZXJUeXBlIHx8ICdvdGhlcid9IC8+IDogbnVsbH1cbiAgICB7IW5vUG9zaXRpb24gJiYgY29tbW9uLnBvc2l0aW9uID8gPGlucHV0IGNsYXNzTmFtZT1cInQtcG9zaXRpb25cIiB0eXBlPVwiaGlkZGVuXCIgbmFtZT1cInBvc2l0aW9uXCIgdmFsdWU9e2NvbW1vbi5wb3NpdGlvbn0gLz4gOiBudWxsfVxuICAgIHtjb21tb24ucmVnVXJsID8gPGlucHV0IGNsYXNzTmFtZT1cInQtcmVnLXVybFwiIHR5cGU9XCJoaWRkZW5cIiBuYW1lPVwicmVnVXJsXCIgdmFsdWU9e2NvbW1vbi5yZWdVcmx9IC8+IDogbnVsbH1cbiAgICA8aW5wdXQgdHlwZT1cImhpZGRlblwiIG5hbWU9XCJhcHBJZFwiIHZhbHVlPXtjb21tb24uYXBwSWR9IC8+XG4gICAgeyFpc0dldFJlcXVlc3QgPyA8aW5wdXQgdHlwZT1cImhpZGRlblwiIG5hbWU9XCJfQ1NSRl9UT0tFTlwiIHZhbHVlPXtjb21tb24uY3NyZlRva2VufSAvPiA6IG51bGx9XG4gICAge2NvbW1vbi5kb1NlbGVjdFVzZXJUeXBlID8gPGlucHV0IGNsYXNzTmFtZT1cInQtc2VsZWN0XCIgdHlwZT1cImhpZGRlblwiIG5hbWU9XCJzZWxlY3RcIiB2YWx1ZT1cInRydWVcIiAvPiA6IG51bGx9XG4gICAge2NvbW1vbi5oYXNPd25Qcm9wZXJ0eSgnb21pdE5hbWUnKSA/IDxpbnB1dCB0eXBlPVwiaGlkZGVuXCIgbmFtZT1cIm9taXROYW1lXCIgdmFsdWU9e2NvbW1vbi5vbWl0TmFtZX0gLz4gOiBudWxsfVxuICA8L3NwYW4+KTtcbn1cblxuSGlkZGVuSW5wdXRzLnByb3BUeXBlcyA9IHtcbiAgY29tbW9uOiBQcm9wVHlwZXMub2JqZWN0LmlzUmVxdWlyZWQsXG4gIGlzR2V0UmVxdWVzdDogUHJvcFR5cGVzLmJvb2wsXG4gIG5vVXNlclR5cGU6IFByb3BUeXBlcy5ib29sLFxuICBub1Bvc2l0aW9uOiBQcm9wVHlwZXMuYm9vbCxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IGNvbm5lY3QoXG4gc3RhdGUgPT4gKHtcbiAgIGNvbW1vbjogc3RhdGUuY29tbW9uLFxuIH0pXG4pKEhpZGRlbklucHV0cyk7XG4iLCJpbXBvcnQgUmVhY3QsIHsgUHJvcFR5cGVzIH0gZnJvbSAncmVhY3QnO1xuXG5mdW5jdGlvbiBJbnB1dEdyb3VwKHsgaWNvbiwgY2hpbGRyZW4gfSkge1xuICBpZiAoIWljb24pIHJldHVybiA8ZGl2PntjaGlsZHJlbn08L2Rpdj47XG4gIHJldHVybiAoXG4gICAgPGRpdiBjbGFzc05hbWU9XCJ0ZXMtaW5wdXQtZ3JvdXBcIj5cbiAgICAgIDxzcGFuIGNsYXNzTmFtZT1cInRlcy1pbnB1dC1ncm91cF9fYWRkb25cIj48aSBjbGFzc05hbWU9e2BpY29uIGljb24tJHtpY29ufWB9PjwvaT48L3NwYW4+XG4gICAgICB7Y2hpbGRyZW59XG4gICAgPC9kaXY+XG4gICk7XG59XG5cbklucHV0R3JvdXAucHJvcFR5cGVzID0ge1xuICBpY29uOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZnVuY3Rpb24gSW5wdXRGaWVsZCh7IGVycm9yQ2xhc3MsIGVycm9yTWVzc2FnZSwgbGFiZWwsIHZhbHVlLCBuYW1lLCBvbkNoYW5nZSwgdHlwZSwgaWNvbiwgYXV0b0ZvY3VzLCBhdXRvQ29tcGxldGUgfSkge1xuICBjb25zdCBpZCA9IGBhdXRoLSR7bmFtZX1gO1xuICBjb25zdCB3aWRnZXRUeXBlID0gdHlwZSB8fCAndGV4dCc7XG4gIHJldHVybiAoXG4gICAgPGRpdiBjbGFzc05hbWU9e2Vycm9yQ2xhc3N9PlxuICAgICAgPElucHV0R3JvdXAgaWNvbj17aWNvbn0+XG4gICAgICAgIDxsYWJlbCBjbGFzc05hbWU9XCJ0ZXMtY29udHJvbC1sYWJlbCB0ZXMtY29udHJvbC1sYWJlbC0taGlkZGVuXCIgaHRtbEZvcj17aWR9PntsYWJlbH08L2xhYmVsPlxuICAgICAgICA8aW5wdXQgb25DaGFuZ2U9e29uQ2hhbmdlfSBpZD17aWR9IHR5cGU9e3dpZGdldFR5cGV9XG4gICAgICAgICAgbmFtZT17bmFtZX1cbiAgICAgICAgICBwbGFjZWhvbGRlcj17bGFiZWx9XG4gICAgICAgICAgY2xhc3NOYW1lPVwidGVzLWNvbnRyb2wgdGVzLWlucHV0LWdyb3VwX19jb250cm9sLWxhc3RcIlxuICAgICAgICAgIHZhbHVlPXt2YWx1ZX1cbiAgICAgICAgICBhdXRvRm9jdXM9e2F1dG9Gb2N1c31cbiAgICAgICAgICBhdXRvQ29tcGxldGU9e2F1dG9Db21wbGV0ZX1cbiAgICAgICAgLz5cbiAgICAgIDwvSW5wdXRHcm91cD5cbiAgICA8ZGl2IGNsYXNzTmFtZT1cInRlcy1oZWxwLWJsb2NrXCI+e2Vycm9yTWVzc2FnZX08L2Rpdj5cbiAgICA8L2Rpdj5cbiAgKTtcbn1cblxuSW5wdXRGaWVsZC5wcm9wVHlwZXMgPSB7XG4gIGVycm9yQ2xhc3M6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgZXJyb3JNZXNzYWdlOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIGxhYmVsOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIGljb246IFByb3BUeXBlcy5zdHJpbmcsXG4gIHZhbHVlOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIG5hbWU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdHlwZTogUHJvcFR5cGVzLnN0cmluZyxcbiAgb25DaGFuZ2U6IFByb3BUeXBlcy5mdW5jLmlzUmVxdWlyZWQsXG4gIGF1dG9Gb2N1czogUHJvcFR5cGVzLnN0cmluZyxcbiAgYXV0b0NvbXBsZXRlOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgSW5wdXRGaWVsZDtcbiIsImltcG9ydCBSZWFjdCwgeyBQcm9wVHlwZXMgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBjb25uZWN0IH0gZnJvbSAncmVhY3QtcmVkdXgnO1xuaW1wb3J0IHsgYmluZEFjdGlvbkNyZWF0b3JzIH0gZnJvbSAncmVkdXgnO1xuaW1wb3J0ICogYXMgYWN0aW9uQ3JlYXRvcnMgZnJvbSAnLi4vLi4vcmVkdWNlcnMvYWN0aW9ucyc7XG5cbmV4cG9ydCBmdW5jdGlvbiBXaWRnZXRMaW5rKHsgY29tbW9uLCBmb3JtVHlwZSwgY2hpbGRyZW4sIGFjdGlvbnMgfSkge1xuICBjb25zdCByZWdpc3RlclBhZ2VzID0ge1xuICAgIHNpZ25JbjogJ3NpZ24taW4nLFxuICAgIGZvcmdvdFBhc3N3b3JkOiAnZm9yZ290LXBhc3N3b3JkJyxcbiAgICByZWdpc3RlcjogY29tbW9uLmRvU2VsZWN0VXNlclR5cGUgPyAnc2VsZWN0JyA6ICdyZWdpc3RlcicsXG4gIH07XG5cbiAgY29uc3QgcmVnaXN0ZXJQYWdlID0gcmVnaXN0ZXJQYWdlc1tmb3JtVHlwZV07XG5cbiAgY29uc3Qgc3dpdGNoVG8gPSAoZSkgPT4ge1xuICAgIGlmICghY29tbW9uLmlzTW9kYWwgJiYgIWNvbW1vbi5pc0lubGluZSkgcmV0dXJuO1xuICAgIGUucHJldmVudERlZmF1bHQoKTtcbiAgICBhY3Rpb25zLmluaXRTZXRGb3JtVHlwZShyZWdpc3RlclBhZ2UpO1xuICB9O1xuXG4gIGNvbnN0IGVuY29kZWRSdG4gPSBlbmNvZGVVUklDb21wb25lbnQoY29tbW9uLnJ0bik7XG4gIGNvbnN0IGVuY29kZWRSZWdVcmwgPSBlbmNvZGVVUklDb21wb25lbnQoY29tbW9uLnJlZ1VybCk7XG5cbiAgY29uc3QgcXMgPSBbXTtcbiAgaWYgKGNvbW1vbi5ydG4pIHtcbiAgICBxcy5wdXNoKGBydG49JHtlbmNvZGVkUnRufWApO1xuICB9XG4gIGlmIChjb21tb24uZG9TZWxlY3RVc2VyVHlwZSkge1xuICAgIHFzLnB1c2goJ3NlbGVjdD10cnVlJyk7XG4gIH1cbiAgaWYgKCdpZCcgaW4gY29tbW9uLm92ZXJyaWRlTXopIHtcbiAgICBxcy5wdXNoKGBwYWdlSWQ9JHtjb21tb24ub3ZlcnJpZGVNei5pZH1gKTtcbiAgfVxuICBpZiAoJ3R5cGUnIGluIGNvbW1vbi5vdmVycmlkZU16KSB7XG4gICAgcXMucHVzaChgcGFnZVR5cGU9JHtjb21tb24ub3ZlcnJpZGVNei50eXBlfWApO1xuICB9XG4gIGlmICgnc2VjdGlvbicgaW4gY29tbW9uLm92ZXJyaWRlTXopIHtcbiAgICBxcy5wdXNoKGBwYWdlU2VjdGlvbj0ke2NvbW1vbi5vdmVycmlkZU16LnNlY3Rpb259YCk7XG4gIH1cbiAgaWYgKCdzdWJzZWN0aW9uJyBpbiBjb21tb24ub3ZlcnJpZGVNeikge1xuICAgIHFzLnB1c2goYHBhZ2VTdWJTZWN0aW9uPSR7Y29tbW9uLm92ZXJyaWRlTXouc3Vic2VjdGlvbn1gKTtcbiAgfVxuICBpZiAoY29tbW9uLnJlZ1VybCkge1xuICAgIHFzLnB1c2goYHJlZ1VybD0ke2VuY29kZWRSZWdVcmx9YCk7XG4gIH1cbiAgaWYgKGNvbW1vbi5oYXNPd25Qcm9wZXJ0eSgnb21pdE5hbWUnKSkge1xuICAgIHFzLnB1c2goYG9taXROYW1lPSR7Y29tbW9uLm9taXROYW1lfWApO1xuICB9XG4gIGlmIChjb21tb24uYXBwSWQpIHtcbiAgICBxcy5wdXNoKGBhcHBJZD0ke2NvbW1vbi5hcHBJZH1gKTtcbiAgfVxuXG4gIGNvbnN0IGJhc2VVUkxzID0ge1xuICAgIHNpZ25JbjogJy9hdXRobi9zaWduLWluJyxcbiAgICBmb3Jnb3RQYXNzd29yZDogJy9hdXRobi9mb3Jnb3QtcGFzc3dvcmQnLFxuICAgIHJlZ2lzdGVyOiBgL2F1dGhuLyR7cmVnaXN0ZXJQYWdlfWAsXG4gIH07XG5cbiAgY29uc3QgYmFzZVVSTCA9IGJhc2VVUkxzW2Zvcm1UeXBlXTtcbiAgY29uc3QgdXJsID0gcXMubGVuZ3RoID8gYCR7YmFzZVVSTH0/JHtxcy5qb2luKCcmJyl9YCA6IGJhc2VVUkw7XG4gIGNvbnN0IGV4dHJhQ2xhc3MgPSBmb3JtVHlwZSA9PT0gJ2ZvcmdvdFBhc3N3b3JkJyA/ICcgcHVsbC1yaWdodCcgOiAnJztcbiAgcmV0dXJuIChcbiAgICA8YSBvbkNsaWNrPXtzd2l0Y2hUb30gaHJlZj17dXJsfSBjbGFzc05hbWU9e2B0LXN3aXRjaC1mb3JtIGxpbmsgbGluay0tY29sb3JlZCR7ZXh0cmFDbGFzc31gfT57Y2hpbGRyZW59PC9hPik7XG59XG5cbldpZGdldExpbmsucHJvcFR5cGVzID0ge1xuICBjb21tb246IFByb3BUeXBlcy5vYmplY3QuaXNSZXF1aXJlZCxcbiAgYWN0aW9uczogUHJvcFR5cGVzLm9iamVjdC5pc1JlcXVpcmVkLFxuICBmb3JtVHlwZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxufTtcblxuY29uc3QgbWFwRGlzcGF0Y2hUb1Byb3BzID0gKGRpc3BhdGNoKSA9PiAoe1xuICBhY3Rpb25zOiBiaW5kQWN0aW9uQ3JlYXRvcnMoYWN0aW9uQ3JlYXRvcnMsIGRpc3BhdGNoKSxcbn0pO1xuXG5leHBvcnQgZGVmYXVsdCBjb25uZWN0KFxuIHN0YXRlID0+ICh7XG4gICBjb21tb246IHN0YXRlLmNvbW1vbixcbiB9KSxcbiBtYXBEaXNwYXRjaFRvUHJvcHNcbikoV2lkZ2V0TGluayk7XG4iLCIvKiBlc2xpbnQtZGlzYWJsZSBuby1jb25zb2xlICovXG5pbXBvcnQgcmVxd2VzdCBmcm9tICdyZXF3ZXN0JztcbmltcG9ydCByZXRyeURlY29yYXRvciBmcm9tICdhc3luYy1kZWNvL3Byb21pc2UvcmV0cnknO1xuaW1wb3J0IG1lbW9pemVEZWNvcmF0b3IgZnJvbSAnYXN5bmMtZGVjby9wcm9taXNlL21lbW9pemUnO1xuaW1wb3J0IFByb21pc2VQb2x5ZmlsbCBmcm9tICdlczYtcHJvbWlzZS1wb2x5ZmlsbCc7XG5cbnRyeSB7XG4gIHdpbmRvdy5Qcm9taXNlID0gUHJvbWlzZVBvbHlmaWxsLlByb21pc2U7XG59IGNhdGNoIChlKSB7XG4gIC8vIG5vdGhpbmdcbn1cblxuY29uc3QgZ2V0T3JpZ2luID0gKCkgPT4ge1xuICBpZiAod2luZG93LmxvY2F0aW9uLm9yaWdpbikge1xuICAgIHJldHVybiB3aW5kb3cubG9jYXRpb24ub3JpZ2luO1xuICB9XG4gIGNvbnN0IHBvcnQgPSB3aW5kb3cubG9jYXRpb24ucG9ydCA/IGA6JHt3aW5kb3cubG9jYXRpb24ucG9ydH1gIDogJyc7XG4gIGNvbnN0IHByb3RvY29sID0gd2luZG93LmxvY2F0aW9uLnByb3RvY29sO1xuICBjb25zdCBob3N0bmFtZSA9IHdpbmRvdy5sb2NhdGlvbi5ob3N0bmFtZTtcbiAgcmV0dXJuIGAke3Byb3RvY29sfS8vJHtob3N0bmFtZX0ke3BvcnR9YDtcbn07XG5cbmNvbnN0IFhIUlRJTUVPVVRfV0lUSF9SRVRSWSA9IDkwMDA7XG5jb25zdCBYSFJUSU1FT1VUX1dJVEhPVVRfUkVUUlkgPSAyMDAwMDtcblxuY29uc3QgZGVmYXVsdFBhcmFtcyA9IHtcbiAgdHlwZTogJ2pzb24nLFxuICBjb250ZW50VHlwZTogJ2FwcGxpY2F0aW9uL2pzb24nLFxuICBoZWFkZXJzOiB7XG4gICAgYWNjZXB0OiAnYXBwbGljYXRpb24vanNvbicsXG4gICAgJ3gtYXV0aC1hcGktdmVyc2lvbic6ICcyJyxcbiAgfSxcbn07XG5cbmZ1bmN0aW9uIHBvc3RSZXF1ZXN0KGVuZHBvaW50LCBkYXRhLCB0aW1lcykge1xuICBsZXQgcmVxdWVzdEZ1bmN0aW9uO1xuICBsZXQgdGltZW91dDtcbiAgaWYgKHRpbWVzKSB7XG4gICAgY29uc3QgdDAgPSBuZXcgRGF0ZSgpO1xuICAgIGNvbnN0IHJldHJ5ID0gcmV0cnlEZWNvcmF0b3IodGltZXMsIDEwMCwgKGVycikgPT4gZXJyICYmIGVyci5zdGF0dXMgPT09IDAsICgpID0+XG4gICAgICAodCwgbykgPT4ge1xuICAgICAgICBjb25zdCB0MSA9IG5ldyBEYXRlKCk7XG4gICAgICAgIGNvbnNvbGUubG9nKGBhcHAtYXV0aGVudGljYXRpb246IGFwaSB0cnlpbmcgJHtvLnRpbWVzfSBhZnRlciAke3QxIC0gdDB9IG1zYCk7XG4gICAgICB9XG4gICAgKTtcbiAgICByZXF1ZXN0RnVuY3Rpb24gPSByZXRyeShyZXF3ZXN0KTtcbiAgICB0aW1lb3V0ID0gWEhSVElNRU9VVF9XSVRIX1JFVFJZO1xuICB9IGVsc2Uge1xuICAgIHJlcXVlc3RGdW5jdGlvbiA9IHJlcXdlc3Q7XG4gICAgdGltZW91dCA9IFhIUlRJTUVPVVRfV0lUSE9VVF9SRVRSWTtcbiAgfVxuXG4gIGNvbnN0IFttYXRjaCwgY3NyZlRva2VuXSA9IGRvY3VtZW50LmNvb2tpZS5tYXRjaCgvY3NyZj0oW147XSopLykgfHwgW107XG5cbiAgcmV0dXJuIHJlcXVlc3RGdW5jdGlvbihPYmplY3QuYXNzaWduKHt9LCBkZWZhdWx0UGFyYW1zLCB7XG4gICAgdXJsOiBlbmRwb2ludCxcbiAgICBtZXRob2Q6ICdQT1NUJyxcbiAgICB0aW1lb3V0LFxuICAgIGRhdGE6IEpTT04uc3RyaW5naWZ5KGRhdGEpLFxuICAgIGhlYWRlcnM6IE9iamVjdC5hc3NpZ24oe30sIGRlZmF1bHRQYXJhbXMuaGVhZGVycywgbWF0Y2ggJiYgY3NyZlRva2VuID8ge1xuICAgICAgJ3gtY3NyZi10b2tlbic6IG1hdGNoICYmIGNzcmZUb2tlbixcbiAgICB9IDoge30pLFxuICB9KSk7XG59XG5cbmNvbnN0IG1lbW9pemUgPSBtZW1vaXplRGVjb3JhdG9yKChkKSA9PiB7XG4gIHRyeSB7XG4gICAgcmV0dXJuIGQuZGF0YS5lbWFpbCA/IGQuZGF0YS5lbWFpbCA6IG51bGw7XG4gIH0gY2F0Y2ggKGUpIHtcbiAgICByZXR1cm4gbnVsbDtcbiAgfVxufSk7XG5jb25zdCBjYWNoZWRSZXF3ZXN0ID0gbWVtb2l6ZShyZXF3ZXN0KTtcblxuZnVuY3Rpb24gZ2V0UmVxdWVzdChlbmRwb2ludCwgZGF0YSkge1xuICBjb25zdCB0aW1lb3V0ID0gWEhSVElNRU9VVF9XSVRIT1VUX1JFVFJZO1xuXG4gIHJldHVybiBjYWNoZWRSZXF3ZXN0KE9iamVjdC5hc3NpZ24oe30sIGRlZmF1bHRQYXJhbXMsIHtcbiAgICB1cmw6IGVuZHBvaW50LFxuICAgIG1ldGhvZDogJ0dFVCcsXG4gICAgdGltZW91dCxcbiAgICBkYXRhLFxuICB9KSk7XG59XG5cbmNvbnN0IGV2ZW50cyA9IChmdW5jdGlvbiBnZXRFdmVudHMoKSB7XG4gIHRyeSB7XG4gICAgcmV0dXJuIHdpbmRvdy5URVMuZXZlbnRzO1xuICB9IGNhdGNoIChlKSB7XG4gICAgcmV0dXJuIHtcbiAgICAgIG9uOiAoKSA9PiB7fSxcbiAgICAgIHRyaWdnZXI6ICgpID0+IHt9LFxuICAgIH07XG4gIH1cbn0oKSk7XG5cbmNvbnN0IGFwaSA9IHtcbiAgdmVyaWZ5VXNlcm5hbWUodXNlcm5hbWUpIHtcbiAgICByZXR1cm4gZ2V0UmVxdWVzdCgnL2FwaS9hdXRobi9maW5kLXVzZXInLCB7IHVzZXJuYW1lIH0pO1xuICB9LFxuXG4gIHZlcmlmeUVtYWlsKGVtYWlsKSB7XG4gICAgcmV0dXJuIGdldFJlcXVlc3QoJy9hcGkvYXV0aG4vZmluZC11c2VyJywgeyBlbWFpbCB9KTtcbiAgfSxcblxuICBzaWduSW4oZGF0YSkge1xuICAgIHJldHVybiBwb3N0UmVxdWVzdCgnL2FwaS9hdXRobi9zaWduLWluLXJlZGlyZWN0JywgZGF0YSwgNCk7XG4gIH0sXG5cbiAgcmVnaXN0ZXIoZGF0YSkge1xuICAgIHJldHVybiBwb3N0UmVxdWVzdCgnL2FwaS9hdXRobi9yZWdpc3Rlci1yZWRpcmVjdCcsIGRhdGEpO1xuICB9LFxuXG4gIG9hdXRoU2lnbkluKHByb3ZpZGVyLCBkYXRhKSB7XG4gICAgcmV0dXJuIG5ldyBQcm9taXNlKChyZXNvbHZlLCByZWplY3QpID0+IHtcbiAgICAgIGNvbnN0IHBhcmFtcyA9IE9iamVjdC5rZXlzKGRhdGEpXG4gICAgICAgIC5maWx0ZXIoayA9PiAhIWRhdGFba10pXG4gICAgICAgIC5tYXAoayA9PiBbaywgZW5jb2RlVVJJQ29tcG9uZW50KGRhdGFba10pXSlcbiAgICAgICAgLm1hcCgodCkgPT4gYCR7dFswXX09JHt0WzFdfWApXG4gICAgICAgIC5qb2luKCcmJyk7XG5cbiAgICAgIGNvbnN0IHBhdGggPSBgL29hdXRoLyR7cHJvdmlkZXJ9PyR7cGFyYW1zfWA7XG5cbiAgICAgIGlmICghZGF0YS5pc01vZGFsKSB7XG4gICAgICAgIHJldHVybiB3aW5kb3cubG9jYXRpb24uYXNzaWduKHBhdGgpO1xuICAgICAgfVxuXG4gICAgICBsZXQgZG9uZSA9IGZhbHNlO1xuXG4gICAgICBjb25zdCBnb29nbGVQb3B1cCA9IHdpbmRvdy5vcGVuKHBhdGgsICcnLCAnbG9jYXRpb249MCxzdGF0dXM9MCx3aWR0aD02MDAsaGVpZ2h0PTUwMCcpO1xuXG4gICAgICBmdW5jdGlvbiBvbk1lc3NhZ2UoZXZ0KSB7XG4gICAgICAgIGxldCBtc2c7XG4gICAgICAgIGlmIChldnQub3JpZ2luICE9PSBnZXRPcmlnaW4oKSkgcmV0dXJuO1xuICAgICAgICB0cnkge1xuICAgICAgICAgIG1zZyA9IHR5cGVvZiBldnQuZGF0YSA9PT0gJ29iamVjdCcgPyBldnQuZGF0YSA6IEpTT04ucGFyc2UoZXZ0LmRhdGEpO1xuICAgICAgICB9IGNhdGNoIChlKSB7XG4gICAgICAgICAgLy8gaWU5IHJldHVybnMgZXZ0LmRhdGEgPT09IHVuZGVmaW5lZCwgYnV0IEkgd29uJ3QgY2FyZSEhISFcbiAgICAgICAgICAvLyB0aGlzIGlzIGFsc28gdGhlIGNhc2Ugb2Ygbm9uIEpTT04gbWVzc2FnZXNcbiAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgaWYgKG1zZy5zZW5kZXIgIT09ICdnb29nbGVwb3B1cCcpIHtcbiAgICAgICAgICByZXR1cm47XG4gICAgICAgIH1cbiAgICAgICAgaWYgKG1zZy5zdGF0dXMgPT09ICdvaycgfHwgbXNnLnN0YXR1cyA9PT0gJ2Vycm9yJykge1xuICAgICAgICAgIGRvbmUgPSB0cnVlO1xuICAgICAgICAgIHdpbmRvdy5yZW1vdmVFdmVudExpc3RlbmVyKCdtZXNzYWdlJywgb25NZXNzYWdlKTtcbiAgICAgICAgICBnb29nbGVQb3B1cC5jbG9zZSgpO1xuICAgICAgICB9XG4gICAgICAgIGlmIChtc2cuc3RhdHVzID09PSAnb2snKSB7XG4gICAgICAgICAgLyogQ29tZXMgZnJvbSBjbG9zZS1tb2RhbCBwYWdlICovXG4gICAgICAgICAgaWYgKG1zZy5uZWVkc1Bvc2l0aW9uKSB7XG4gICAgICAgICAgICBjb25zdCBlcnIgPSBuZXcgRXJyb3IoJ05lZWRzIHBvc2l0aW9uIGRhdGEnKTtcbiAgICAgICAgICAgIGVyci5uZWVkc1Bvc2l0aW9uID0gdHJ1ZTtcbiAgICAgICAgICAgIHJldHVybiByZWplY3QoZXJyKTtcbiAgICAgICAgICB9XG4gICAgICAgICAgcmVzb2x2ZSgpO1xuICAgICAgICB9XG4gICAgICAgIGlmIChtc2cuc3RhdHVzID09PSAnZXJyb3InKSB7XG4gICAgICAgICAgcmVqZWN0KG5ldyBFcnJvcihtc2cuZXJyb3JDb2RlKSk7XG4gICAgICAgIH1cbiAgICAgIH1cblxuICAgICAgd2luZG93LmFkZEV2ZW50TGlzdGVuZXIoJ21lc3NhZ2UnLCBvbk1lc3NhZ2UpO1xuXG4gICAgICBjb25zdCBfb2F1dGhJbnRlcnZhbCA9IHdpbmRvdy5zZXRJbnRlcnZhbCgoKSA9PiB7XG4gICAgICAgIGNvbnN0IGZpcmVFcnJvciA9IChlcnJvckNvZGUpID0+IHtcbiAgICAgICAgICBpZiAoIWRvbmUpIHtcbiAgICAgICAgICAgIHJlamVjdChuZXcgRXJyb3IoZXJyb3JDb2RlKSk7XG4gICAgICAgICAgfVxuICAgICAgICAgIHdpbmRvdy5yZW1vdmVFdmVudExpc3RlbmVyKCdtZXNzYWdlJywgb25NZXNzYWdlKTtcbiAgICAgICAgICB3aW5kb3cuY2xlYXJJbnRlcnZhbChfb2F1dGhJbnRlcnZhbCk7XG4gICAgICAgIH07XG4gICAgICAgIHRyeSB7XG4gICAgICAgICAgaWYgKCFnb29nbGVQb3B1cCkge1xuICAgICAgICAgICAgZmlyZUVycm9yKGAke3Byb3ZpZGVyfS5wb3B1cC5ibG9ja2VkYCk7XG4gICAgICAgICAgfSBlbHNlIGlmIChnb29nbGVQb3B1cC5jbG9zZWQpIHtcbiAgICAgICAgICAgIGZpcmVFcnJvcihgJHtwcm92aWRlcn0ucG9wdXAuY2xvc2VkYCk7XG4gICAgICAgICAgfVxuICAgICAgICB9IGNhdGNoIChlKSB7XG4gICAgICAgICAgLy8gaWUgZmlyZXMgZXJyb3IgaGVyZVxuICAgICAgICB9XG4gICAgICB9LCAxMDAwKTtcbiAgICB9KTtcbiAgfSxcblxuICBmb3Jnb3RQYXNzd29yZChkYXRhKSB7XG4gICAgcmV0dXJuIHBvc3RSZXF1ZXN0KCcvYXBpL2F1dGhuL2ZvcmdvdC1wYXNzd29yZCcsIGRhdGEpO1xuICB9LFxuXG4gIHVwZGF0ZVVzZXJEYXRhKGRhdGEpIHtcbiAgICByZXR1cm4gcG9zdFJlcXVlc3QoJy9hcGkvYXV0aG4vZWRpdC1hY2NvdW50JywgZGF0YSk7XG4gIH0sXG5cbiAgcmVsb2FkKHVybCkge1xuICAgIGlmICh1cmwpIHtcbiAgICAgIHdpbmRvdy5sb2NhdGlvbi5hc3NpZ24odXJsKTtcbiAgICB9IGVsc2Uge1xuICAgICAgd2luZG93LmxvY2F0aW9uLnJlbG9hZCh0cnVlKTtcbiAgICB9XG4gIH0sXG5cbiAgbG9nZ2VkSW5FdmVudCgpIHtcbiAgICBldmVudHMudHJpZ2dlcignbG9nZ2VkLWluJyk7XG4gIH0sXG5cbiAgY2xvc2VNb2RhbEV2ZW50KCkge1xuICAgIGV2ZW50cy50cmlnZ2VyKCdtb2RhbC1jbG9zZScsICdhdXRoYXBwJyk7XG4gIH0sXG59O1xuXG5leHBvcnQgZGVmYXVsdCBhcGk7XG4iLCJmdW5jdGlvbiBkZWx0YXllYXJzKGRlbHRhLCB0b2RheSkge1xuICBjb25zdCBkID0gdG9kYXkgPyBuZXcgRGF0ZSh0b2RheSkgOiBuZXcgRGF0ZSgpO1xuICBkLnNldEZ1bGxZZWFyKGQuZ2V0RnVsbFllYXIoKSArIGRlbHRhKTtcbiAgcmV0dXJuIGQ7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBpc0ludmFsaWREYXRlT2ZCaXJ0aChkLCB0b2RheSkge1xuICBpZiAoIWQpIHJldHVybiB0cnVlO1xuICBjb25zdCBbeWVhciwgbW9udGgsIGRheV0gPSBkLnNwbGl0KCctJykubWFwKHMgPT4gcGFyc2VJbnQocywgMTApKTtcbiAgY29uc3QgZGF0ZSA9IG5ldyBEYXRlKHllYXIsIG1vbnRoIC0gMSwgZGF5KTtcbiAgY29uc3QgdHdveWVhcnNhZ28gPSBkZWx0YXllYXJzKC0yLCB0b2RheSk7XG4gIGNvbnN0IG9uZWh1bmRyZWRhbmR0d2VudHl5ZWFyc2FnbyA9IGRlbHRheWVhcnMoLTEyMCwgdG9kYXkpO1xuICBjb25zdCBub3cgPSBkZWx0YXllYXJzKDAsIHRvZGF5KTtcblxuICBpZiAoeWVhciA8IDEwMDAgfHwgaXNOYU4oZGF0ZS5nZXRNb250aCgpKSkge1xuICAgIHJldHVybiAncmVnaXN0cmF0aW9uLmRhdGVPZkJpcnRoLmluY29tcGxldGUnO1xuICB9IGVsc2UgaWYgKCEoZGF0ZS5nZXRNb250aCgpID09PSBtb250aCAtIDEgJiYgZGF0ZS5nZXREYXRlKCkgPT09IGRheSAmJiBkYXRlLmdldEZ1bGxZZWFyKCkgPT09IHllYXIpKSB7XG4gICAgcmV0dXJuICdyZWdpc3RyYXRpb24uZGF0ZU9mQmlydGguaW52YWxpZCc7XG4gIH0gZWxzZSBpZiAobm93IDwgZGF0ZSkge1xuICAgIHJldHVybiAncmVnaXN0cmF0aW9uLmRhdGVPZkJpcnRoLmZ1dHVyZSc7XG4gIH0gZWxzZSBpZiAodHdveWVhcnNhZ28gPCBkYXRlKSB7XG4gICAgcmV0dXJuICdyZWdpc3RyYXRpb24uZGF0ZU9mQmlydGgudG9vWW91bmcnO1xuICB9IGVsc2UgaWYgKG9uZWh1bmRyZWRhbmR0d2VudHl5ZWFyc2FnbyA+IGRhdGUpIHtcbiAgICByZXR1cm4gJ3JlZ2lzdHJhdGlvbi5kYXRlT2ZCaXJ0aC50b29PbGQnO1xuICB9XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBkYXRlRGlmZihkYXRlLCB0b2RheSkge1xuICBjb25zdCBbeWVhciwgbW9udGgsIGRheV0gPSBkYXRlLnNwbGl0KCctJykubWFwKChpdGVtKSA9PiBwYXJzZUludChpdGVtLCAxMCkpO1xuICBjb25zdCBkID0gdG9kYXkgPyBuZXcgRGF0ZSh0b2RheSkgOiBuZXcgRGF0ZSgpO1xuICBsZXQgZGVsdGFZZWFyID0gZC5nZXRGdWxsWWVhcigpIC0geWVhcjtcbiAgbGV0IGRlbHRhTW9udGggPSAoZC5nZXRNb250aCgpICsgMSkgLSBtb250aDtcbiAgbGV0IGRlbHRhRGF5ID0gZC5nZXREYXRlKCkgLSBkYXk7XG4gIGlmIChkZWx0YURheSA8IDApIHtcbiAgICBkZWx0YU1vbnRoIC09IDE7XG4gICAgZGVsdGFEYXkgKz0gMzA7XG4gIH1cbiAgaWYgKGRlbHRhTW9udGggPCAwKSB7XG4gICAgZGVsdGFZZWFyIC09IDE7XG4gICAgZGVsdGFNb250aCArPSAxMjtcbiAgfVxuICByZXR1cm4geyBkZWx0YVllYXIsIGRlbHRhTW9udGgsIGRlbHRhRGF5IH07XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBpc1VuZGVyMTgoZG9iKSB7XG4gIHJldHVybiAoIWlzSW52YWxpZERhdGVPZkJpcnRoKGRvYikgJiYgZGF0ZURpZmYoZG9iKS5kZWx0YVllYXIgPCAxOCk7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBpc1VuZGVyMTMoZG9iKSB7XG4gIHJldHVybiAoIWlzSW52YWxpZERhdGVPZkJpcnRoKGRvYikgJiYgZGF0ZURpZmYoZG9iKS5kZWx0YVllYXIgPCAxMyk7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBsb2NhbGUoc2l0ZUNvdW50cnkpIHtcbiAgc3dpdGNoIChzaXRlQ291bnRyeSkge1xuICAgIGNhc2UgJ0NBJzpcbiAgICBjYXNlICdVUyc6IHJldHVybiBbJ21vbnRoJywgJ2RheScsICd5ZWFyJ107XG4gICAgZGVmYXVsdDogcmV0dXJuIFsnZGF5JywgJ21vbnRoJywgJ3llYXInXTtcbiAgfVxufVxuIiwiY29uc3QgYmFubmVkU3RhdGVzID0ge1xuICAyOiAnYmFubmVkJyxcbiAgMzogJ2Rpc2FwcHJvdmVkJyxcbiAgNDogJ3Bvc3NpYmxlIHNwYW0gYWN0aXZpdHknLFxuICA1OiAnbG9ja2VkIG91dCcsXG59O1xuXG5jb25zdCBndWFyZGlhbkVtYWlsRGVueVN0YXRlcyA9IHtcbiAgQ1JFQVRFRDogJ25vdFlldEdyYW50ZWQnLFxuICBERU5JRUQ6ICdkZW5pZWQnLFxufTtcblxuZnVuY3Rpb24gZ2V0UmVzcG9uc2UoZXJyKSB7XG4gIGlmICgncmVzcG9uc2UnIGluIGVyciB8fCAncmVzcG9uc2VUZXh0JyBpbiBlcnIpIHtcbiAgICB0cnkge1xuICAgICAgcmV0dXJuIEpTT04ucGFyc2UoZXJyLnJlc3BvbnNlIHx8IGVyci5yZXNwb25zZVRleHQpO1xuICAgIH0gY2F0Y2ggKGUpIHtcbiAgICAgIHJldHVybiB1bmRlZmluZWQ7XG4gICAgfVxuICB9IGVsc2Uge1xuICAgIHJldHVybiBlcnI7XG4gIH1cbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGF1dGhEZW5pZWQoZXJyKSB7XG4gIGlmIChlcnIuc3RhdHVzID09PSA0MDEpIHtcbiAgICByZXR1cm4gJ3NpZ25pbi51bmF1dGhvcml6ZWQnO1xuICB9XG4gIGlmIChlcnIuc3RhdHVzID09PSA0MDMpIHtcbiAgICBjb25zdCByZXNwb25zZSA9IGdldFJlc3BvbnNlKGVycik7XG4gICAgaWYgKHJlc3BvbnNlICYmICgnZGF0YScgaW4gcmVzcG9uc2UpICYmIHJlc3BvbnNlLmRhdGEuY29kZSkge1xuICAgICAgaWYgKHJlc3BvbnNlLmRhdGEuY29kZSBpbiBiYW5uZWRTdGF0ZXMpIHtcbiAgICAgICAgcmV0dXJuIGBzaWduaW4uJHtiYW5uZWRTdGF0ZXNbcmVzcG9uc2UuZGF0YS5jb2RlXX1gO1xuICAgICAgfSBlbHNlIGlmIChyZXNwb25zZS5kYXRhLmNvZGUgaW4gZ3VhcmRpYW5FbWFpbERlbnlTdGF0ZXMpIHtcbiAgICAgICAgcmV0dXJuIGBzaWduaW4uZ3VhcmRpYW5FbWFpbC4ke2d1YXJkaWFuRW1haWxEZW55U3RhdGVzW3Jlc3BvbnNlLmRhdGEuY29kZV19YDtcbiAgICAgIH1cbiAgICB9XG4gICAgcmV0dXJuICdzaWduaW4uZ2VuZXJpYy5iYW5uZWQnO1xuICB9XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBmb3Jnb3RQYXNzd29yZERlbmllZChlcnIpIHtcbiAgaWYgKGVyci5zdGF0dXMgPT09IDQwNCkge1xuICAgIHJldHVybiAnZm9yZ290LXBhc3N3b3JkLnVzZXIubm90LWZvdW5kJztcbiAgfVxuICBpZiAoZXJyLnN0YXR1cyA9PT0gNDAzKSB7XG4gICAgY29uc3QgcmVzcG9uc2UgPSBnZXRSZXNwb25zZShlcnIpO1xuICAgIGlmIChyZXNwb25zZSAmJiAoJ2RhdGEnIGluIHJlc3BvbnNlKSAmJiByZXNwb25zZS5kYXRhLmNvZGUgJiYgKHJlc3BvbnNlLmRhdGEuY29kZSBpbiBiYW5uZWRTdGF0ZXMpKSB7XG4gICAgICByZXR1cm4gYGZvcmdvdC1wYXNzd29yZC4ke2Jhbm5lZFN0YXRlc1tyZXNwb25zZS5kYXRhLmNvZGVdfWA7XG4gICAgfVxuICAgIHJldHVybiAnZm9yZ290LXBhc3N3b3JkLmdlbmVyaWMuYmFubmVkJztcbiAgfVxufVxuIiwiZXhwb3J0IGZ1bmN0aW9uIGdldEVycm9yTXNnRnJvbVByZWZpeChwcmVmaXgpIHtcbiAgcmV0dXJuIChfZmllbGQpID0+IHtcbiAgICBjb25zdCBmaWVsZCA9IGAke3ByZWZpeH0uJHtfZmllbGR9YDtcbiAgICByZXR1cm4gKGVycikgPT4gKGVyciAmJiBmaWVsZCBpbiBlcnIgPyBlcnJbZmllbGRdLm1zZyA6ICcnKTtcbiAgfTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGdldEVycm9yQ2xzRnJvbVByZWZpeChwcmVmaXgpIHtcbiAgcmV0dXJuIChfZmllbGQpID0+IHtcbiAgICBjb25zdCBmaWVsZCA9IGAke3ByZWZpeH0uJHtfZmllbGR9YDtcbiAgICByZXR1cm4gKGVycikgPT4gKGVyciAmJiBmaWVsZCBpbiBlcnIgJiYgZXJyW2ZpZWxkXS5zdGF0ZSA9PT0gJ2Vycm9yJyA/ICcgdGVzLWhhcy1lcnJvcicgOiAnJyk7XG4gIH07XG59XG4iLCJleHBvcnQgZnVuY3Rpb24gY2FyZWVyRmluZGVyKHBvc2l0aW9ucywgY2FyZWVycywgY3VycmVudFBvc2l0aW9uKSB7XG4gIGNvbnN0IGNhcmVlck1hdGNoID0gY2FyZWVycy5maWx0ZXIoKGl0ZW0pID0+IGl0ZW0ubmFtZSA9PT0gY3VycmVudFBvc2l0aW9uKTtcbiAgaWYgKGNhcmVlck1hdGNoLmxlbmd0aCkge1xuICAgIHJldHVybiB7IG5hbWU6IGNhcmVlck1hdGNoWzBdLm5hbWUsIGdyb3VwTGFiZWw6IG51bGwgfTtcbiAgfVxuICBjb25zdCBwb3NpdGlvbk1hdGNoID0gcG9zaXRpb25zLmZpbHRlcigoaXRlbSkgPT4gaXRlbS5uYW1lID09PSBjdXJyZW50UG9zaXRpb24pO1xuICBpZiAocG9zaXRpb25NYXRjaC5sZW5ndGgpIHtcbiAgICBjb25zdCBncm91cExhYmVsID0gcG9zaXRpb25NYXRjaFswXS5ncm91cExhYmVsO1xuICAgIGNvbnN0IGdyb3VwTWF0Y2ggPSBjYXJlZXJzLmZpbHRlcigoaXRlbSkgPT4gaXRlbS5ncm91cExhYmVsID09PSBncm91cExhYmVsKTtcbiAgICBpZiAoZ3JvdXBNYXRjaC5sZW5ndGgpIHtcbiAgICAgIHJldHVybiB7IG5hbWU6IGdyb3VwTWF0Y2hbMF0ubmFtZSwgZ3JvdXBMYWJlbCB9O1xuICAgIH1cbiAgfVxuICByZXR1cm4geyBuYW1lOiAnJywgZ3JvdXBMYWJlbDogbnVsbCB9O1xufVxuXG5leHBvcnQgZnVuY3Rpb24gZmlsdGVyUG9zaXRpb24ocG9zaXRpb25zLCBjdXJyZW50Q2FyZWVyT2JqKSB7XG4gIHJldHVybiBwb3NpdGlvbnNcbiAgLmZpbHRlcigocG9zKSA9PiB7XG4gICAgaWYgKGN1cnJlbnRDYXJlZXJPYmouZ3JvdXBMYWJlbCkge1xuICAgICAgcmV0dXJuIHBvcy5ncm91cExhYmVsID09PSBjdXJyZW50Q2FyZWVyT2JqLmdyb3VwTGFiZWw7XG4gICAgfVxuICAgIHJldHVybiBwb3MubmFtZSA9PT0gY3VycmVudENhcmVlck9iai5uYW1lO1xuICB9KTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGdldFVzZXJUeXBlUG9zaXRpb24ocG9zaXRpb25zLCBjdXJyZW50UG9zaXRpb24pIHtcbiAgLy8gY29uc3QgcG9zT2JqID0gcG9zaXRpb25zLmZpbmQoKHBvcykgPT4gcG9zLm5hbWUgPT09IGN1cnJlbnRQb3NpdGlvbik7XG4gIGNvbnN0IHBvc0luZGV4ID0gcG9zaXRpb25zLm1hcCgocG9zKSA9PiBwb3MubmFtZSA9PT0gY3VycmVudFBvc2l0aW9uKS5pbmRleE9mKHRydWUpO1xuICBjb25zdCBwb3NPYmogPSBwb3NpdGlvbnNbcG9zSW5kZXhdO1xuICByZXR1cm4gcG9zT2JqID8gcG9zT2JqLnVzZXJUeXBlIDogJ290aGVyJztcbn1cbiIsIi8qIGdsb2JhbCBfbXo6ZmFsc2UsIF9temU6ZmFsc2UgKi9cblxuZnVuY3Rpb24gaGFzTXooKSB7XG4gIHRyeSB7XG4gICAgcmV0dXJuICEhX216O1xuICB9IGNhdGNoIChlKSB7XG4gICAgcmV0dXJuIGZhbHNlO1xuICB9XG59XG5cbmV4cG9ydCBmdW5jdGlvbiB0cmFja0NsaWNrKGZvcm1UeXBlKSB7XG4gIGlmICghIGhhc016KCkpIHJldHVybjtcbiAgbGV0IGV2ZW50VGl0bGU7XG4gIGlmIChmb3JtVHlwZSA9PT0gJ3NpZ24taW4nKSB7XG4gICAgZXZlbnRUaXRsZSA9ICdsb2dpbic7XG4gIH0gZWxzZSBpZiAoZm9ybVR5cGUgPT09ICdyZWdpc3RlcicgfHwgZm9ybVR5cGUgPT09ICdzZWxlY3QnKSB7XG4gICAgZXZlbnRUaXRsZSA9ICdyZWdpc3Rlcic7XG4gIH1cbiAgaWYgKGV2ZW50VGl0bGUpIHtcbiAgICBfbXouZW1pdChfbXplLkNMSUNLLCB7XG4gICAgICBtb2R1bGU6IHtcbiAgICAgICAgdHlwZTogJ2F1dGgtbGlua3MnLFxuICAgICAgfSxcbiAgICAgIGV2ZW50VGl0bGUsXG4gICAgfSk7XG4gIH1cbn1cblxuZXhwb3J0IGZ1bmN0aW9uIHRyYWNrRGlzcGxheShmb3JtVHlwZSwgdHlwZSwgdXNlclR5cGUsIGRvU2VsZWN0VXNlclR5cGUpIHtcbiAgaWYgKCEgaGFzTXooKSkgcmV0dXJuO1xuICBjb25zdCBldmVudFRpdGxlID0ge1xuICAgICdzaWduLWluJzogJ3Rlcy1sb2dpbicsXG4gICAgcmVnaXN0ZXI6ICdyZWdpc3RlcicsXG4gICAgJ2ZvcmdvdC1wYXNzd29yZCc6ICdmb3Jnb3QtcGFzc3dvcmQnLFxuICAgIHNlbGVjdDogJ3Rlcy1hY2NvdW50LXR5cGUnLFxuICB9O1xuICBjb25zdCBldmVudCA9IHtcbiAgICBpZDogZXZlbnRUaXRsZVtmb3JtVHlwZV0gfHwgJ3Rlcy1sb2dpbicsXG4gICAgbW9kdWxlOiB7XG4gICAgICBpZDogZG9TZWxlY3RVc2VyVHlwZSA/ICd1c2VTZWxlY3QnIDogbnVsbCxcbiAgICAgIHR5cGUsXG4gICAgfSxcbiAgfTtcblxuICBpZiAoZm9ybVR5cGUgPT09ICdzZWxlY3QnKSB7XG4gICAgZXZlbnQudmFyaWFudCA9ICdwb3NpdGlvbi1zZWxlY3Rvcic7XG4gIH0gZWxzZSBpZiAodXNlclR5cGUpIHtcbiAgICBldmVudC52YXJpYW50ID0gdXNlclR5cGU7XG4gIH1cblxuICBfbXouZW1pdChfbXplLkRJU1BMQVksIGV2ZW50KTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIHRyYWNrRXJyb3IoaWQsIG1zZywgdHlwZSkge1xuICBpZiAoISBoYXNNeigpKSByZXR1cm47XG4gIGNvbnN0IGV2dCA9IGlkID09PSAncmVnaXN0ZXItZmFpbCcgPyBfbXplLlJFR0lTVEVSX0ZBSUwgOiBfbXplLkxPR0lOX0ZBSUw7XG4gIF9tei5lbWl0KGV2dCwge1xuICAgIGlkLFxuICAgIHBheWxvYWQ6IHtcbiAgICAgIG1lc3NhZ2U6IG1zZyxcbiAgICB9LFxuICAgIG1vZHVsZToge1xuICAgICAgdHlwZSxcbiAgICB9LFxuICB9KTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIHRyYWNrRm9yZ290UGFzc3dvcmQodHlwZSwgY2IpIHtcbiAgaWYgKCEgaGFzTXooKSkgcmV0dXJuIGNiICYmIGNiKCk7XG4gIF9tei5lbWl0KF9temUuU1VCTUlULCB7XG4gICAgaWQ6ICdmb3Jnb3QtcGFzc3dvcmQnLFxuICAgIG1vZHVsZToge1xuICAgICAgdHlwZSxcbiAgICB9LFxuICB9LCBjYik7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiB0cmFja0xvZ2luKGlkLCB0eXBlLCBjYikge1xuICBpZiAoISBoYXNNeigpKSByZXR1cm4gY2IgJiYgY2IoKTtcbiAgX216LmVtaXQoX216ZS5MT0dJTiwge1xuICAgIGlkLFxuICAgIG1vZHVsZToge1xuICAgICAgdHlwZSxcbiAgICB9LFxuICB9LCBjYik7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiB0cmFja1JlZ2lzdGVyKHR5cGUsIGNiKSB7XG4gIGlmICghIGhhc016KCkpIHJldHVybiBjYiAmJiBjYigpO1xuICBfbXouZW1pdChfbXplLlJFR0lTVEVSLCB7XG4gICAgaWQ6ICdyZWdpc3RlcicsXG4gICAgbW9kdWxlOiB7XG4gICAgICB0eXBlLFxuICAgIH0sXG4gICAgdGFnczogWydmdW5uZWwnXSxcbiAgfSwgY2IpO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gZ2V0VHJhY2tpbmdUeXBlKGlzTW9kYWwsIGlzSW5saW5lKSB7XG4gIGlmIChpc01vZGFsKSB7XG4gICAgcmV0dXJuICdtb2RhbCc7XG4gIH0gZWxzZSBpZiAoaXNJbmxpbmUpIHtcbiAgICByZXR1cm4gJ2VtYmVkJztcbiAgfVxuICByZXR1cm4gJ3N0YW5kYWxvbmUnO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gZ2V0UGFnZUNvbnRleHQocGFnZU1ldGFkYXRhLCBvdmVycmlkZVBhZ2VNZXRhZGF0YSkge1xuICBjb25zdCBtZXRhID0ge307XG5cbiAgaWYgKCdpZCcgaW4gb3ZlcnJpZGVQYWdlTWV0YWRhdGEgfHwgJ2lkJyBpbiBwYWdlTWV0YWRhdGEpIHtcbiAgICBtZXRhLnBhZ2VJZCA9IG92ZXJyaWRlUGFnZU1ldGFkYXRhLmlkIHx8IHBhZ2VNZXRhZGF0YS5pZDtcbiAgfVxuXG4gIGlmICgndHlwZScgaW4gb3ZlcnJpZGVQYWdlTWV0YWRhdGEgfHwgJ3R5cGUnIGluIHBhZ2VNZXRhZGF0YSkge1xuICAgIG1ldGEucGFnZVR5cGUgPSBvdmVycmlkZVBhZ2VNZXRhZGF0YS50eXBlIHx8IHBhZ2VNZXRhZGF0YS50eXBlO1xuICB9XG5cbiAgaWYgKCdzZWN0aW9uJyBpbiBvdmVycmlkZVBhZ2VNZXRhZGF0YSB8fCAnc2VjdGlvbicgaW4gcGFnZU1ldGFkYXRhKSB7XG4gICAgbWV0YS5wYWdlU2VjdGlvbiA9IG92ZXJyaWRlUGFnZU1ldGFkYXRhLnNlY3Rpb24gfHwgcGFnZU1ldGFkYXRhLnNlY3Rpb247XG4gIH1cblxuICBpZiAoJ3N1YnNlY3Rpb24nIGluIG92ZXJyaWRlUGFnZU1ldGFkYXRhIHx8ICdzdWJzZWN0aW9uJyBpbiBwYWdlTWV0YWRhdGEpIHtcbiAgICBtZXRhLnBhZ2VTdWJTZWN0aW9uID0gb3ZlcnJpZGVQYWdlTWV0YWRhdGEuc3Vic2VjdGlvbiB8fCBwYWdlTWV0YWRhdGEuc3Vic2VjdGlvbjtcbiAgfVxuXG4gIHJldHVybiBtZXRhO1xufVxuIiwiXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB0cmF2ZXJzZU9iamVjdChvYmosIGtleSkge1xuICBpZiAodHlwZW9mIG9iaiAhPT0gJ29iamVjdCcpIHtcbiAgICByZXR1cm4gdW5kZWZpbmVkO1xuICB9XG4gIGZvciAoY29uc3QgayBpbiBvYmopIHtcbiAgICBpZiAoa2V5ID09PSBrKSB7XG4gICAgICByZXR1cm4gb2JqW2tleV07XG4gICAgfVxuICAgIGNvbnN0IHZhbHVlID0gdHJhdmVyc2VPYmplY3Qob2JqW2tdLCBrZXkpO1xuICAgIGlmICh2YWx1ZSkge1xuICAgICAgcmV0dXJuIHZhbHVlO1xuICAgIH1cbiAgfVxuICByZXR1cm4gdW5kZWZpbmVkO1xufVxuIiwiaW1wb3J0ICogYXMgY29uc3RhbnQgZnJvbSAnLi9jb25zdGFudHMnO1xuXG4vLyBBY3Rpb24gQ3JlYXRvcnNcbmV4cG9ydCBmdW5jdGlvbiByZXNldCgpIHtcbiAgcmV0dXJuIHsgdHlwZTogY29uc3RhbnQuUkVTRVQgfTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGluaXRTZXRGb3JtVHlwZShmb3JtVHlwZSkge1xuICByZXR1cm4geyB0eXBlOiBjb25zdGFudC5JTklUX1NFVF9GT1JNX1RZUEUsIGZvcm1UeXBlIH07XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBzZXRGb3JtVHlwZShmb3JtVHlwZSkge1xuICByZXR1cm4geyB0eXBlOiBjb25zdGFudC5TRVRfRk9STV9UWVBFLCBmb3JtVHlwZSB9O1xufVxuXG5leHBvcnQgZnVuY3Rpb24gc2V0UG9zaXRpb24ocG9zaXRpb24sIHVzZXJUeXBlKSB7XG4gIHJldHVybiB7IHR5cGU6IGNvbnN0YW50LlNFVF9QT1NJVElPTiwgcG9zaXRpb24sIHVzZXJUeXBlIH07XG59XG5cbmV4cG9ydCBmdW5jdGlvbiB1cGRhdGVVc2VyRGF0YShkYXRhKSB7XG4gIHJldHVybiB7IHR5cGU6IGNvbnN0YW50LlVQREFURV9VU0VSX0RBVEEsIGRhdGEgfTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIHZhbGlkYXRpb25FcnJvcnMoZXJyb3JzKSB7XG4gIHJldHVybiB7IHR5cGU6IGNvbnN0YW50LlZBTElEQVRJT05fRVJST1JTLCBlcnJvcnMgfTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIHNldFVzZXJUeXBlKHVzZXJUeXBlKSB7XG4gIHJldHVybiB7IHR5cGU6IGNvbnN0YW50LlNFVF9VU0VSX1RZUEUsIHVzZXJUeXBlIH07XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBzdWNjZXNzT2F1dGhTaWduSW4oKSB7XG4gIHJldHVybiB7IHR5cGU6IGNvbnN0YW50LlNVQ0NFU1NfT0FVVEhfU0lHTl9JTiB9O1xufVxuXG5leHBvcnQgZnVuY3Rpb24gc3VjY2Vzc1NpZ25JbigpIHtcbiAgcmV0dXJuIHsgdHlwZTogY29uc3RhbnQuU1VDQ0VTU19TSUdOX0lOIH07XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBzdWNjZXNzUmVnaXN0ZXIoKSB7XG4gIHJldHVybiB7IHR5cGU6IGNvbnN0YW50LlNVQ0NFU1NfUkVHSVNURVIgfTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGZhaWxTaWduSW4oZXJyb3JzKSB7XG4gIHJldHVybiB7IHR5cGU6IGNvbnN0YW50LkZBSUxfU0lHTl9JTiwgZXJyb3JzIH07XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBmYWlsUmVnaXN0ZXIoZXJyb3JzKSB7XG4gIHJldHVybiB7IHR5cGU6IGNvbnN0YW50LkZBSUxfUkVHSVNURVIsIGVycm9ycyB9O1xufVxuXG5leHBvcnQgZnVuY3Rpb24gZmFpbEZvcmdvdFBhc3N3b3JkKGVycm9ycykge1xuICByZXR1cm4geyB0eXBlOiBjb25zdGFudC5GQUlMX0ZPUkdPVF9QQVNTV09SRCwgZXJyb3JzIH07XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBmYWlsT2F1dGhTaWduSW4oZXJyb3JzKSB7XG4gIHJldHVybiB7IHR5cGU6IGNvbnN0YW50LkZBSUxfT0FVVEhfU0lHTl9JTiwgZXJyb3JzIH07XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBpbml0U2lnbkluKGNhbGxiYWNrKSB7XG4gIHJldHVybiB7IHR5cGU6IGNvbnN0YW50LklOSVRfU0lHTl9JTiwgY2FsbGJhY2sgfTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGluaXRSZWdpc3RlcihjYWxsYmFjaykge1xuICByZXR1cm4geyB0eXBlOiBjb25zdGFudC5JTklUX1JFR0lTVEVSLCBjYWxsYmFjayB9O1xufVxuXG5leHBvcnQgZnVuY3Rpb24gaW5pdE9hdXRoU2lnbkluKHByb3ZpZGVyKSB7XG4gIHJldHVybiB7IHR5cGU6IGNvbnN0YW50LklOSVRfT0FVVEhfU0lHTl9JTiwgcHJvdmlkZXIgfTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGluaXRGb3Jnb3RQYXNzd29yZCgpIHtcbiAgcmV0dXJuIHsgdHlwZTogY29uc3RhbnQuSU5JVF9GT1JHT1RfUEFTU1dPUkQgfTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIHNlbnRGb3Jnb3RQYXNzd29yZCgpIHtcbiAgcmV0dXJuIHsgdHlwZTogY29uc3RhbnQuU0VOVF9GT1JHT1RfUEFTU1dPUkQgfTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIHN1Y2Nlc3NGb3Jnb3RQYXNzd29yZCgpIHtcbiAgcmV0dXJuIHsgdHlwZTogY29uc3RhbnQuU1VDQ0VTU19GT1JHT1RfUEFTU1dPUkQgfTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIHZhbGlkYXRlRmllbGQobmFtZSkge1xuICByZXR1cm4geyB0eXBlOiBjb25zdGFudC5WQUxJREFURV9GSUVMRCwgbmFtZSB9O1xufVxuXG5leHBvcnQgZnVuY3Rpb24gY2hhbmdlRmllbGQobmFtZSwgZGVwcykge1xuICByZXR1cm4geyB0eXBlOiBjb25zdGFudC5DSEFOR0VfRklFTEQsIG5hbWUsIGRlcHMgfTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIHNldEZpZWxkKGZvcm0sIG5hbWUsIHZhbHVlKSB7XG4gIHJldHVybiB7IHR5cGU6IGNvbnN0YW50LlNFVF9GSUVMRCwgZm9ybSwgbmFtZSwgdmFsdWUgfTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIHJlc2V0RXJyb3JzKCkge1xuICByZXR1cm4geyB0eXBlOiBjb25zdGFudC5SRVNFVF9FUlJPUlMgfTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIHN1Z2dlc3RVc2VyTmFtZSh1c2VybmFtZSkge1xuICByZXR1cm4geyB0eXBlOiBjb25zdGFudC5TVUdHRVNUX1VTRVJfTkFNRSwgdXNlcm5hbWUgfTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIHRyYWNrQ2xpY2soZm9ybVR5cGUpIHtcbiAgcmV0dXJuIHsgdHlwZTogY29uc3RhbnQuVFJBQ0tfQ0xJQ0ssIGZvcm1UeXBlIH07XG59XG5cbmV4cG9ydCBmdW5jdGlvbiB0cmFja0Rpc3BsYXkoZm9ybVR5cGUpIHtcbiAgcmV0dXJuIHsgdHlwZTogY29uc3RhbnQuVFJBQ0tfRElTUExBWSwgZm9ybVR5cGUgfTtcbn1cbiIsImV4cG9ydCBjb25zdCBSRVNFVCA9ICdSRVNFVCc7XG5leHBvcnQgY29uc3QgSU5JVF9TRVRfRk9STV9UWVBFID0gJ0lOSVRfU0VUX0ZPUk1fVFlQRSc7XG5leHBvcnQgY29uc3QgU0VUX0ZPUk1fVFlQRSA9ICdTRVRfRk9STV9UWVBFJztcbmV4cG9ydCBjb25zdCBTRVRfVVNFUl9UWVBFID0gJ1NFVF9VU0VSX1RZUEUnO1xuZXhwb3J0IGNvbnN0IFNFVF9QT1NJVElPTiA9ICdTRVRfUE9TSVRJT04nO1xuZXhwb3J0IGNvbnN0IFVQREFURV9VU0VSX0RBVEEgPSAnVVBEQVRFX1VTRVJfREFUQSc7XG5cbmV4cG9ydCBjb25zdCBWQUxJREFUSU9OX0VSUk9SUyA9ICdWQUxJREFUSU9OX0VSUk9SUyc7XG5cbmV4cG9ydCBjb25zdCBTVUNDRVNTX09BVVRIX1NJR05fSU4gPSAnU1VDQ0VTU19PQVVUSF9TSUdOX0lOJztcbmV4cG9ydCBjb25zdCBTVUNDRVNTX1NJR05fSU4gPSAnU1VDQ0VTU19TSUdOX0lOJztcbmV4cG9ydCBjb25zdCBTVUNDRVNTX1JFR0lTVEVSID0gJ1NVQ0NFU1NfUkVHSVNURVInO1xuZXhwb3J0IGNvbnN0IFNVQ0NFU1NfRk9SR09UX1BBU1NXT1JEID0gJ1NVQ0NFU1NfRk9SR09UX1BBU1NXT1JEJztcblxuZXhwb3J0IGNvbnN0IElOSVRfU0lHTl9JTiA9ICdJTklUX1NJR05fSU4nO1xuZXhwb3J0IGNvbnN0IElOSVRfUkVHSVNURVIgPSAnSU5JVF9SRUdJU1RFUic7XG5leHBvcnQgY29uc3QgSU5JVF9PQVVUSF9TSUdOX0lOID0gJ0lOSVRfT0FVVEhfU0lHTl9JTic7XG5cbmV4cG9ydCBjb25zdCBGQUlMX1NJR05fSU4gPSAnRkFJTF9TSUdOX0lOJztcbmV4cG9ydCBjb25zdCBGQUlMX1JFR0lTVEVSID0gJ0ZBSUxfUkVHSVNURVInO1xuZXhwb3J0IGNvbnN0IEZBSUxfRk9SR09UX1BBU1NXT1JEID0gJ0ZBSUxfRk9SR09UX1BBU1NXT1JEJztcbmV4cG9ydCBjb25zdCBGQUlMX09BVVRIX1NJR05fSU4gPSAnRkFJTF9PQVVUSF9TSUdOX0lOJztcblxuZXhwb3J0IGNvbnN0IElOSVRfRk9SR09UX1BBU1NXT1JEID0gJ0lOSVRfRk9SR09UX1BBU1NXT1JEJztcbmV4cG9ydCBjb25zdCBTRU5UX0ZPUkdPVF9QQVNTV09SRCA9ICdTRU5UX0ZPUkdPVF9QQVNTV09SRCc7XG5cbmV4cG9ydCBjb25zdCBWQUxJREFURV9GSUVMRCA9ICdWQUxJREFURV9GSUVMRCc7XG5leHBvcnQgY29uc3QgQ0hBTkdFX0ZJRUxEID0gJ0NIQU5HRV9GSUVMRCc7XG5leHBvcnQgY29uc3QgU0VUX0ZJRUxEID0gJ1NFVF9GSUVMRCc7XG5cbmV4cG9ydCBjb25zdCBSRVNFVF9FUlJPUlMgPSAnUkVTRVRfRVJST1JTJztcbmV4cG9ydCBjb25zdCBTVUdHRVNUX1VTRVJfTkFNRSA9ICdTVUdHRVNUX1VTRVJfTkFNRSc7XG5cbmV4cG9ydCBjb25zdCBUUkFDS19ESVNQTEFZID0gJ1RSQUNLX0RJU1BMQVknO1xuZXhwb3J0IGNvbnN0IFRSQUNLX0NMSUNLID0gJ1RSQUNLX0NMSUNLJztcbiIsImltcG9ydCAqIGFzIGNvbnN0YW50IGZyb20gJy4vY29uc3RhbnRzJztcblxuY29uc3QgaW5pdGlhbFN0YXRlID0ge1xuICBjb21tb246IHt9LFxuICByZWdpc3Rlcjoge1xuICAgIGZpcnN0TmFtZTogJycsXG4gICAgbGFzdE5hbWU6ICcnLFxuICAgIGVtYWlsOiAnJyxcbiAgICB1c2VybmFtZTogJycsXG4gICAgcGFzc3dvcmQ6ICcnLFxuICAgIG5ld3NsZXR0ZXI6IGZhbHNlLFxuICAgIGF1dG9GaWxsVXNlcm5hbWU6IHRydWUsXG4gICAgc3RhdGU6IG51bGwsXG4gIH0sXG4gIHNpZ25Jbjoge1xuICAgIGlkZW50aWZpY2F0aW9uOiAnJyxcbiAgICBwYXNzd29yZDogJycsXG4gICAgdHJ1c3RlZENvbXB1dGVyOiBmYWxzZSxcbiAgICBzdGF0ZTogbnVsbCxcbiAgfSxcbiAgZm9yZ290UGFzc3dvcmQ6IHtcbiAgICBpZGVudGlmaWNhdGlvbjogJycsXG4gICAgc3RhdGU6IG51bGwsXG4gIH0sXG4gIGVycm9yczoge30sXG59O1xuXG5mdW5jdGlvbiBleHRlbmQoc3RhdGUsIG9iaikge1xuICBjb25zdCBzID0ge307XG4gIE9iamVjdC5rZXlzKG9iaikuZm9yRWFjaCgoYXR0cikgPT4ge1xuICAgIHNbYXR0cl0gPSBPYmplY3QuYXNzaWduKHt9LCBzdGF0ZVthdHRyXSwgb2JqW2F0dHJdKTtcbiAgfSk7XG4gIHJldHVybiBPYmplY3QuYXNzaWduKHt9LCBzdGF0ZSwgcyk7XG59XG5cbi8vIFJlZHVjZXJcbmZ1bmN0aW9uIHJlc2V0KHN0YXRlKSB7XG4gIGNvbnN0IG5ld1N0YXRlID0ge1xuICAgIGVycm9yczoge30sXG4gICAgY29tbW9uOiBPYmplY3QuYXNzaWduKHt9LCBzdGF0ZS5jb21tb24sIHsgb2F1dGhTdGF0ZTogbnVsbCB9KSxcbiAgICByZWdpc3RlcjogaW5pdGlhbFN0YXRlLnJlZ2lzdGVyLFxuICAgIHNpZ25JbjogaW5pdGlhbFN0YXRlLnNpZ25JbixcbiAgICBmb3Jnb3RQYXNzd29yZDogaW5pdGlhbFN0YXRlLmZvcmdvdFBhc3N3b3JkLFxuICB9O1xuICBuZXdTdGF0ZS5zaWduSW4udHJ1c3RlZENvbXB1dGVyID0gc3RhdGUuY29tbW9uLmlzTW9iaWxlO1xuICByZXR1cm4gT2JqZWN0LmFzc2lnbih7fSwgc3RhdGUsIG5ld1N0YXRlKTtcbn1cblxuZnVuY3Rpb24gcmVzZXRFcnJvcnMoc3RhdGUpIHtcbiAgcmV0dXJuIE9iamVjdC5hc3NpZ24oe30sIHN0YXRlLCB7IGVycm9yczoge30gfSk7XG59XG5cbmZ1bmN0aW9uIHNldEZvcm1UeXBlKHN0YXRlLCBhY3Rpb24pIHtcbiAgcmV0dXJuIGV4dGVuZChzdGF0ZSwgeyBjb21tb246IHsgZm9ybVR5cGU6IGFjdGlvbi5mb3JtVHlwZSB9IH0pO1xufVxuXG5mdW5jdGlvbiBzZXRVc2VyVHlwZShzdGF0ZSwgYWN0aW9uKSB7XG4gIHJldHVybiBleHRlbmQoc3RhdGUsIHsgY29tbW9uOiB7IHVzZXJUeXBlOiBhY3Rpb24udXNlclR5cGUgfSB9KTtcbn1cblxuZnVuY3Rpb24gc2V0UG9zaXRpb24oc3RhdGUsIGFjdGlvbikge1xuICByZXR1cm4gZXh0ZW5kKHN0YXRlLCB7IGNvbW1vbjogeyB1c2VyVHlwZTogYWN0aW9uLnVzZXJUeXBlLCBwb3NpdGlvbjogYWN0aW9uLnBvc2l0aW9uIH0gfSk7XG59XG5cbmZ1bmN0aW9uIHZhbGlkYXRpb25FcnJvcnMoc3RhdGUsIGFjdGlvbikge1xuICByZXR1cm4gZXh0ZW5kKHN0YXRlLCB7IGVycm9yczogYWN0aW9uLmVycm9ycyB9KTtcbn1cblxuZnVuY3Rpb24gaW5pdFNpZ25JbihzdGF0ZSkge1xuICByZXR1cm4gZXh0ZW5kKHJlc2V0RXJyb3JzKHN0YXRlKSwgeyBzaWduSW46IHsgc3RhdGU6ICd3YWl0JyB9IH0pO1xufVxuXG5mdW5jdGlvbiBpbml0UmVnaXN0ZXIoc3RhdGUpIHtcbiAgcmV0dXJuIGV4dGVuZChyZXNldEVycm9ycyhzdGF0ZSksIHsgcmVnaXN0ZXI6IHsgc3RhdGU6ICd3YWl0JyB9IH0pO1xufVxuXG5mdW5jdGlvbiBpbml0T2F1dGhTaWduSW4oc3RhdGUsIGFjdGlvbikge1xuICByZXR1cm4gZXh0ZW5kKHJlc2V0RXJyb3JzKHN0YXRlKSwgeyBjb21tb246IHsgb2F1dGhTdGF0ZTogYWN0aW9uLnByb3ZpZGVyIH0gfSk7XG59XG5cbmZ1bmN0aW9uIGluaXRGb3Jnb3RQYXNzd29yZChzdGF0ZSkge1xuICByZXR1cm4gZXh0ZW5kKHJlc2V0RXJyb3JzKHN0YXRlKSwgeyBmb3Jnb3RQYXNzd29yZDogeyBzdGF0ZTogJ3dhaXQnIH0gfSk7XG59XG5cbmZ1bmN0aW9uIGZhaWxTaWduSW4oc3RhdGUpIHtcbiAgcmV0dXJuIGV4dGVuZChzdGF0ZSwgeyBzaWduSW46IHsgc3RhdGU6IG51bGwgfSB9KTtcbn1cblxuZnVuY3Rpb24gZmFpbFJlZ2lzdGVyKHN0YXRlKSB7XG4gIHJldHVybiBleHRlbmQoc3RhdGUsIHsgcmVnaXN0ZXI6IHsgc3RhdGU6IG51bGwgfSB9KTtcbn1cblxuZnVuY3Rpb24gZmFpbE9hdXRoU2lnbkluKHN0YXRlKSB7XG4gIHJldHVybiBleHRlbmQoc3RhdGUsIHsgY29tbW9uOiB7IG9hdXRoU3RhdGU6IG51bGwgfSB9KTtcbn1cblxuZnVuY3Rpb24gZmFpbEZvcmdvdFBhc3N3b3JkKHN0YXRlKSB7XG4gIHJldHVybiBleHRlbmQoc3RhdGUsIHsgZm9yZ290UGFzc3dvcmQ6IHsgc3RhdGU6IG51bGwgfSB9KTtcbn1cblxuZnVuY3Rpb24gc2VudEZvcmdvdFBhc3N3b3JkKHN0YXRlKSB7XG4gIHJldHVybiBleHRlbmQocmVzZXRFcnJvcnMoc3RhdGUpLCB7IGZvcmdvdFBhc3N3b3JkOiB7IHN0YXRlOiAnc2VudCcgfSB9KTtcbn1cblxuZnVuY3Rpb24gdmFsaWRhdGVGaWVsZChzdGF0ZSwgYWN0aW9uKSB7XG4gIGlmIChhY3Rpb24ubmFtZSA9PT0gJ3JlZ2lzdHJhdGlvbi5lbWFpbCcgJiYgc3RhdGUucmVnaXN0ZXIudXNlcm5hbWUgPT09ICcnKSB7XG4gICAgcmV0dXJuIGV4dGVuZChzdGF0ZSwgeyByZWdpc3RlcjogeyBhdXRvRmlsbFVzZXJuYW1lOiB0cnVlIH0gfSk7XG4gIH1cbiAgaWYgKGFjdGlvbi5uYW1lID09PSAncmVnaXN0cmF0aW9uLnVzZXJuYW1lJykge1xuICAgIHJldHVybiBleHRlbmQoc3RhdGUsIHsgcmVnaXN0ZXI6IHsgYXV0b0ZpbGxVc2VybmFtZTogZmFsc2UgfSB9KTtcbiAgfVxuICByZXR1cm4gc3RhdGU7XG59XG5cbmZ1bmN0aW9uIGNoYW5nZUZpZWxkKHN0YXRlLCBhY3Rpb24pIHtcbiAgY29uc3QgbmV3RXJyb3JzID0gT2JqZWN0LmFzc2lnbih7fSwgc3RhdGUuZXJyb3JzKTtcbiAgZGVsZXRlIG5ld0Vycm9yc1thY3Rpb24ubmFtZV07XG4gIGFjdGlvbi5kZXBzLmZvckVhY2goZCA9PiBkZWxldGUgbmV3RXJyb3JzW2RdKTtcbiAgcmV0dXJuIE9iamVjdC5hc3NpZ24oe30sIHN0YXRlLCB7IGVycm9yczogbmV3RXJyb3JzIH0pO1xufVxuXG5mdW5jdGlvbiBzZXRGaWVsZChzdGF0ZSwgYWN0aW9uKSB7XG4gIGNvbnN0IG9iaiA9IHt9O1xuICBvYmpbYWN0aW9uLmZvcm1dID0ge307XG4gIG9ialthY3Rpb24uZm9ybV1bYWN0aW9uLm5hbWVdID0gYWN0aW9uLnZhbHVlO1xuICBpZiAoYWN0aW9uLmZvcm0gPT09ICdzaWduSW4nICYmIGFjdGlvbi5uYW1lID09PSAnaWRlbnRpZmljYXRpb24nKSB7XG4gICAgT2JqZWN0LmFzc2lnbihvYmosIHsgZm9yZ290UGFzc3dvcmQ6IHsgaWRlbnRpZmljYXRpb246IGFjdGlvbi52YWx1ZSB9IH0pO1xuICB9XG4gIHJldHVybiBleHRlbmQoc3RhdGUsIG9iaik7XG59XG5cbmZ1bmN0aW9uIHN1Z2dlc3RVc2VyTmFtZShzdGF0ZSwgYWN0aW9uKSB7XG4gIGlmICghc3RhdGUucmVnaXN0ZXIuYXV0b0ZpbGxVc2VybmFtZSkge1xuICAgIHJldHVybiBzdGF0ZTtcbiAgfVxuICBjb25zdCBuZXdFcnJvcnMgPSBPYmplY3QuYXNzaWduKHt9LCBzdGF0ZS5lcnJvcnMpO1xuICBkZWxldGUgbmV3RXJyb3JzWydyZWdpc3RyYXRpb24udXNlcm5hbWUnXTtcbiAgY29uc3QgbmV3U3RhdGUgPSBPYmplY3QuYXNzaWduKHt9LCBzdGF0ZSwgeyBlcnJvcnM6IG5ld0Vycm9ycyB9KTtcbiAgcmV0dXJuIGV4dGVuZChuZXdTdGF0ZSwgeyByZWdpc3RlcjogeyB1c2VybmFtZTogYWN0aW9uLnVzZXJuYW1lIH0gfSk7XG59XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHJlZHVjZXIoc3RhdGUgPSBpbml0aWFsU3RhdGUsIGFjdGlvbiA9IHt9KSB7XG4gIHN3aXRjaCAoYWN0aW9uLnR5cGUpIHtcbiAgICBjYXNlIGNvbnN0YW50LlJFU0VUOlxuICAgICAgcmV0dXJuIHJlc2V0KHN0YXRlLCBhY3Rpb24pO1xuICAgIGNhc2UgY29uc3RhbnQuU0VUX0ZPUk1fVFlQRTpcbiAgICAgIHJldHVybiBzZXRGb3JtVHlwZShzdGF0ZSwgYWN0aW9uKTtcbiAgICBjYXNlIGNvbnN0YW50LlNFVF9VU0VSX1RZUEU6XG4gICAgICByZXR1cm4gc2V0VXNlclR5cGUoc3RhdGUsIGFjdGlvbik7XG4gICAgY2FzZSBjb25zdGFudC5TRVRfUE9TSVRJT046XG4gICAgICByZXR1cm4gc2V0UG9zaXRpb24oc3RhdGUsIGFjdGlvbik7XG4gICAgY2FzZSBjb25zdGFudC5WQUxJREFUSU9OX0VSUk9SUzpcbiAgICAgIHJldHVybiB2YWxpZGF0aW9uRXJyb3JzKHN0YXRlLCBhY3Rpb24pO1xuICAgIGNhc2UgY29uc3RhbnQuSU5JVF9TSUdOX0lOOlxuICAgICAgcmV0dXJuIGluaXRTaWduSW4oc3RhdGUsIGFjdGlvbik7XG4gICAgY2FzZSBjb25zdGFudC5JTklUX1JFR0lTVEVSOlxuICAgICAgcmV0dXJuIGluaXRSZWdpc3RlcihzdGF0ZSwgYWN0aW9uKTtcbiAgICBjYXNlIGNvbnN0YW50LklOSVRfT0FVVEhfU0lHTl9JTjpcbiAgICAgIHJldHVybiBpbml0T2F1dGhTaWduSW4oc3RhdGUsIGFjdGlvbik7XG4gICAgY2FzZSBjb25zdGFudC5JTklUX0ZPUkdPVF9QQVNTV09SRDpcbiAgICAgIHJldHVybiBpbml0Rm9yZ290UGFzc3dvcmQoc3RhdGUsIGFjdGlvbik7XG4gICAgY2FzZSBjb25zdGFudC5GQUlMX1NJR05fSU46XG4gICAgICByZXR1cm4gZmFpbFNpZ25JbihzdGF0ZSwgYWN0aW9uKTtcbiAgICBjYXNlIGNvbnN0YW50LkZBSUxfUkVHSVNURVI6XG4gICAgICByZXR1cm4gZmFpbFJlZ2lzdGVyKHN0YXRlLCBhY3Rpb24pO1xuICAgIGNhc2UgY29uc3RhbnQuRkFJTF9PQVVUSF9TSUdOX0lOOlxuICAgICAgcmV0dXJuIGZhaWxPYXV0aFNpZ25JbihzdGF0ZSwgYWN0aW9uKTtcbiAgICBjYXNlIGNvbnN0YW50LkZBSUxfRk9SR09UX1BBU1NXT1JEOlxuICAgICAgcmV0dXJuIGZhaWxGb3Jnb3RQYXNzd29yZChzdGF0ZSwgYWN0aW9uKTtcbiAgICBjYXNlIGNvbnN0YW50LlNFTlRfRk9SR09UX1BBU1NXT1JEOlxuICAgICAgcmV0dXJuIHNlbnRGb3Jnb3RQYXNzd29yZChzdGF0ZSwgYWN0aW9uKTtcbiAgICBjYXNlIGNvbnN0YW50LlZBTElEQVRFX0ZJRUxEOlxuICAgICAgcmV0dXJuIHZhbGlkYXRlRmllbGQoc3RhdGUsIGFjdGlvbik7XG4gICAgY2FzZSBjb25zdGFudC5DSEFOR0VfRklFTEQ6XG4gICAgICByZXR1cm4gY2hhbmdlRmllbGQoc3RhdGUsIGFjdGlvbik7XG4gICAgY2FzZSBjb25zdGFudC5TRVRfRklFTEQ6XG4gICAgICByZXR1cm4gc2V0RmllbGQoc3RhdGUsIGFjdGlvbik7XG4gICAgY2FzZSBjb25zdGFudC5SRVNFVF9FUlJPUlM6XG4gICAgICByZXR1cm4gcmVzZXRFcnJvcnMoc3RhdGUsIGFjdGlvbik7XG4gICAgY2FzZSBjb25zdGFudC5TVUdHRVNUX1VTRVJfTkFNRTpcbiAgICAgIHJldHVybiBzdWdnZXN0VXNlck5hbWUoc3RhdGUsIGFjdGlvbik7XG5cbiAgICBkZWZhdWx0OiByZXR1cm4gc3RhdGU7XG4gIH1cbn1cbiIsImltcG9ydCB7IHRha2VFdmVyeSwgZGVsYXksIHRocm90dGxlIH0gZnJvbSAncmVkdXgtc2FnYSc7XG5pbXBvcnQgeyBjcHMsIHRha2UsIGNhbmNlbCwgZm9yaywgY2FsbCwgcHV0LCBzZWxlY3QgfSBmcm9tICdyZWR1eC1zYWdhL2VmZmVjdHMnO1xuXG5pbXBvcnQgSm9pIGZyb20gJ21vZHVsZS10c2wtZXJyb3ItbWlkZGxld2FyZXMvc3JjL21pbmlqb2knO1xuaW1wb3J0IHsgYXV0aERlbmllZCwgZm9yZ290UGFzc3dvcmREZW5pZWQgfSBmcm9tICcuLi9saWIvZGVuaWVkLWVycm9yY29kZSc7XG5pbXBvcnQgKiBhcyBhY3Rpb25zIGZyb20gJy4uL3JlZHVjZXJzL2FjdGlvbnMnO1xuaW1wb3J0IHsgZ2V0VHJhY2tpbmdUeXBlLCB0cmFja0ZvcmdvdFBhc3N3b3JkLCB0cmFja0NsaWNrLCB0cmFja0Rpc3BsYXksIHRyYWNrRXJyb3IsIHRyYWNrTG9naW4sIHRyYWNrUmVnaXN0ZXIgfSBmcm9tICcuLi9saWIvdHJhY2tpbmcnO1xuaW1wb3J0IHRyYXZlcnNlT2JqZWN0IGZyb20gJy4uL2xpYi90cmF2ZXJzZS1vYmplY3QnO1xuaW1wb3J0IGVycm9yTWVzc2FnZXMgZnJvbSAnLi4vLi4vYXBwL2RvbWFpbi9lcnJvck1lc3NhZ2VzJztcblxuaW1wb3J0ICogYXMgY29uc3RhbnQgZnJvbSAnLi4vcmVkdWNlcnMvY29uc3RhbnRzJztcbmltcG9ydCBhcGkgZnJvbSAnLi4vbGliL2FwaSc7XG5pbXBvcnQge1xuICBnZXRSZWxvYWRVUkwsXG4gIGdldERvU2VsZWN0VXNlclR5cGUsXG4gIGdldE9uU3VjY2VzcyxcbiAgZ2V0Rm9ybVR5cGUsXG4gIGdldElzSW5saW5lLFxuICBnZXRJc01vZGFsLFxuICBnZXRVc2VyVHlwZSxcbiAgZ2V0Rm9yZ290UGFzc3dvcmREYXRhLFxuICBnZXRTaWduSW5EYXRhLFxuICBnZXRSZWdpc3RyYXRpb25EYXRhLFxuICBnZXRHb29nbGVTaWduSW5EYXRhIH0gZnJvbSAnLi91dGlscyc7XG5cbi8qXG4gIHV0aWxpdGllc1xuKi9cbmZ1bmN0aW9uIGdldFdpbmRvdygpIHtcbiAgdHJ5IHtcbiAgICByZXR1cm4gd2luZG93O1xuICB9IGNhdGNoIChlKSB7XG4gICAgcmV0dXJuIHt9O1xuICB9XG59XG5cbmZ1bmN0aW9uIGdldEVycm9yQ29kZSh4aHIsIHByZWZpeCkge1xuICBjb25zdCBnZW5lcmljRXJyb3JDb2RlID0geGhyLnN0YXR1cyA+PSA0MDAgJiYgeGhyLnN0YXR1cyA8IDUwMCA/ICdkZW5pZWQnIDogJ2dlbmVyaWMnO1xuICB0cnkge1xuICAgIGNvbnN0IHJlc3BvbnNlID0gSlNPTi5wYXJzZSh4aHIucmVzcG9uc2UgfHwgeGhyLnJlc3BvbnNlVGV4dCk7XG4gICAgLy8gYXNzZW1ibGluZyB0aGUgZXJyb3IgY29kZVxuICAgIGNvbnN0IGVycm9yQ29kZXMgPSByZXNwb25zZS5lcnJvcnMubWFwKGUgPT4gYCR7cHJlZml4fS4ke2UuZmllbGR9LiR7ZS50eXBlc1swXX1gKTtcbiAgICByZXR1cm4gZXJyb3JDb2Rlcy5sZW5ndGggPyBlcnJvckNvZGVzLmpvaW4oJywnKSA6IGAke3ByZWZpeH0uJHtnZW5lcmljRXJyb3JDb2RlfS5lcnJvcmA7XG4gIH0gY2F0Y2ggKGUpIHtcbiAgICBpZiAoZ2V0V2luZG93KCkuX2FpcmJyYWtlKSB7XG4gICAgICBsZXQgZXJyb3JPYmo7XG4gICAgICBpZiAoeGhyLnN0YXR1cyA9PT0gMCkge1xuICAgICAgICBlcnJvck9iaiA9IHsgZXJyb3I6IHsgbWVzc2FnZTogYGFwcC1hdXRoZW50aWNhdGlvbjogYXBpIHRpbWluZyBvdXQgKCR7cHJlZml4fSkgcmVhZHlzdGF0ZSAke3hoci5yZWFkeVN0YXRlfWAsIGZpbGVOYW1lOiAncmVzdGFwaS5qcycsIGxpbmVOdW1iZXI6IDAsIGNvbHVtbk51bWJlcjogMCB9IH07XG4gICAgICB9IGVsc2Uge1xuICAgICAgICBlcnJvck9iaiA9IHsgZXJyb3I6IHsgbWVzc2FnZTogYGFwcC1hdXRoZW50aWNhdGlvbjogYXBpIHJldHVybmluZyB1bmV4cGVjdGVkICR7Z2VuZXJpY0Vycm9yQ29kZX0gKCR7cHJlZml4fSk6ICR7eGhyLnN0YXR1c30gLSAke3hoci5yZXNwb25zZX1gLCBmaWxlTmFtZTogJ2FwaS5qcycsIGxpbmVOdW1iZXI6IDAsIGNvbHVtbk51bWJlcjogMCB9IH07XG4gICAgICB9XG4gICAgICBnZXRXaW5kb3coKS5fYWlyYnJha2UucHVzaChlcnJvck9iaik7XG4gICAgfVxuICAgIHJldHVybiBgJHtwcmVmaXh9LiR7Z2VuZXJpY0Vycm9yQ29kZX0uZXJyb3JgO1xuICB9XG59XG5cbmNvbnN0IHVzZXJOYW1lVmFsaWRhdGlvbiA9IEpvaS5zdHJpbmcoKS5taW4oMykubWF4KDMwKS5yZWdleCgvXltBLVphLXowLTlfXFwtXSokLykucmVxdWlyZWQoKTtcbmNvbnN0IGVtYWlsVmFsaWRhdGlvbiA9IEpvaS5zdHJpbmcoKS5lbWFpbCgpO1xuXG4vLyBjb25zdCBzY2hlbWFzID0ge1xuLy8gICByZWdpc3RyYXRpb246IEpvaS5vYmplY3QoKS5rZXlzKHtcbi8vICAgICB1c2VybmFtZTogdXNlck5hbWVWYWxpZGF0aW9uLFxuLy8gICAgIGVtYWlsOiBlbWFpbFZhbGlkYXRpb24sXG4vLyAgICAgcGFzc3dvcmQ6IEpvaS5zdHJpbmcoKS5taW4oNikucmVxdWlyZWQoKSxcbi8vICAgICBmaXJzdE5hbWU6IEpvaS5zdHJpbmcoKSxcbi8vICAgICBsYXN0TmFtZTogSm9pLnN0cmluZygpLFxuLy8gICAgIG5ld3NsZXR0ZXI6IEpvaS5ib29sZWFuKCksXG4vLyAgIH0pLFxuLy8gfTtcblxuLypcbiAgc2FnYXNcbiovXG5leHBvcnQgZnVuY3Rpb24qIGluaXRTaWduSW4oYWN0aW9uKSB7XG4gIHlpZWxkIHB1dChhY3Rpb25zLnJlc2V0RXJyb3JzKCkpO1xuICBjb25zdCBpc0lubGluZSA9IHlpZWxkIHNlbGVjdChnZXRJc0lubGluZSk7XG4gIGNvbnN0IGlzTW9kYWwgPSB5aWVsZCBzZWxlY3QoZ2V0SXNNb2RhbCk7XG4gIGlmICghaXNJbmxpbmUgJiYgIWlzTW9kYWwpIHtcbiAgICB0cnkge1xuICAgICAgeWllbGQgY3BzKHRyYWNrTG9naW4sICd0ZXMtbG9naW4nLCBnZXRUcmFja2luZ1R5cGUoaXNNb2RhbCwgaXNJbmxpbmUpKTtcbiAgICB9IGNhdGNoIChlKSB7XG4gICAgICBjb25zb2xlLmxvZygnVHJhY2tpbmcgTG9naW4gZXJyb3InLCBlLm1lc3NhZ2UpOyAvLyBlc2xpbnQtZGlzYWJsZS1saW5lIG5vLWNvbnNvbGVcbiAgICB9XG4gICAgeWllbGQgY2FsbChhY3Rpb24uY2FsbGJhY2spOyAvLyB1c2luZyBwbGFpbiBodG1sIGZvcm0gc3VibWlzc2lvblxuICAgIHJldHVybjtcbiAgfVxuICB0cnkge1xuICAgIHlpZWxkIGNhbGwodHJhY2tMb2dpbiwgJ3Rlcy1sb2dpbicsIGdldFRyYWNraW5nVHlwZShpc01vZGFsLCBpc0lubGluZSkpO1xuICAgIGNvbnN0IGNyZWRlbnRpYWxzID0geWllbGQgc2VsZWN0KGdldFNpZ25JbkRhdGEpO1xuICAgIHlpZWxkIGNhbGwoYXBpLnNpZ25JbiwgY3JlZGVudGlhbHMpO1xuICAgIHlpZWxkIHB1dChhY3Rpb25zLnN1Y2Nlc3NTaWduSW4oKSk7XG4gIH0gY2F0Y2ggKGUpIHtcbiAgICBjb25zdCBlcnJvckNvZGUgPSBhdXRoRGVuaWVkKGUpIHx8IGdldEVycm9yQ29kZShlLCAnc2lnbmluJyk7XG4gICAgY29uc3QgZXJyb3JzID0gZXJyb3JNZXNzYWdlcyhlcnJvckNvZGUpO1xuICAgIHlpZWxkIHB1dChhY3Rpb25zLnZhbGlkYXRpb25FcnJvcnMoZXJyb3JzKSk7XG4gICAgeWllbGQgcHV0KGFjdGlvbnMuZmFpbFNpZ25JbihlcnJvcnMpKTtcbiAgfVxufVxuXG5leHBvcnQgZnVuY3Rpb24qIGluaXRSZWdpc3RlcihhY3Rpb24pIHtcbiAgeWllbGQgcHV0KGFjdGlvbnMucmVzZXRFcnJvcnMoKSk7XG4gIGNvbnN0IGlzSW5saW5lID0geWllbGQgc2VsZWN0KGdldElzSW5saW5lKTtcbiAgY29uc3QgaXNNb2RhbCA9IHlpZWxkIHNlbGVjdChnZXRJc01vZGFsKTtcbiAgaWYgKCFpc0lubGluZSAmJiAhaXNNb2RhbCkge1xuICAgIHRyeSB7XG4gICAgICB5aWVsZCBjcHModHJhY2tSZWdpc3RlciwgZ2V0VHJhY2tpbmdUeXBlKGlzTW9kYWwsIGlzSW5saW5lKSk7XG4gICAgfSBjYXRjaCAoZSkge1xuICAgICAgY29uc29sZS5sb2coJ1RyYWNraW5nIFJlZ2lzdHJhdGlvbiBlcnJvcicsIGUubWVzc2FnZSk7IC8vIGVzbGludC1kaXNhYmxlLWxpbmUgbm8tY29uc29sZVxuICAgIH1cbiAgICB5aWVsZCBjYWxsKGFjdGlvbi5jYWxsYmFjayk7IC8vIHVzaW5nIHBsYWluIGh0bWwgZm9ybSBzdWJtaXNzaW9uXG4gICAgcmV0dXJuO1xuICB9XG4gIHRyeSB7XG4gICAgeWllbGQgY2FsbCh0cmFja1JlZ2lzdGVyLCBnZXRUcmFja2luZ1R5cGUoaXNNb2RhbCwgaXNJbmxpbmUpKTtcbiAgICBjb25zdCBpbmZvID0geWllbGQgc2VsZWN0KGdldFJlZ2lzdHJhdGlvbkRhdGEpO1xuICAgIHlpZWxkIGNhbGwoYXBpLnJlZ2lzdGVyLCBpbmZvKTtcbiAgICB5aWVsZCBwdXQoYWN0aW9ucy5zdWNjZXNzUmVnaXN0ZXIoKSk7XG4gIH0gY2F0Y2ggKGUpIHtcbiAgICBjb25zdCBlcnJvckNvZGUgPSBnZXRFcnJvckNvZGUoZSwgJ3JlZ2lzdHJhdGlvbicpO1xuICAgIGNvbnN0IGVycm9ycyA9IGVycm9yTWVzc2FnZXMoZXJyb3JDb2RlKTtcbiAgICB5aWVsZCBwdXQoYWN0aW9ucy52YWxpZGF0aW9uRXJyb3JzKGVycm9ycykpO1xuICAgIHlpZWxkIHB1dChhY3Rpb25zLmZhaWxSZWdpc3RlcihlcnJvcnMpKTtcbiAgfVxufVxuXG5leHBvcnQgZnVuY3Rpb24qIGluaXRPYXV0aFNpZ25Jbih7IHByb3ZpZGVyIH0pIHtcbiAgdHJ5IHtcbiAgICB5aWVsZCBwdXQoYWN0aW9ucy5yZXNldEVycm9ycygpKTtcbiAgICBjb25zdCBpc0lubGluZSA9IHlpZWxkIHNlbGVjdChnZXRJc0lubGluZSk7XG4gICAgY29uc3QgaXNNb2RhbCA9IHlpZWxkIHNlbGVjdChnZXRJc01vZGFsKTtcbiAgICBjb25zdCBpbmZvID0geWllbGQgc2VsZWN0KGdldEdvb2dsZVNpZ25JbkRhdGEpO1xuICAgIGlmICghaXNNb2RhbCAmJiAhaXNJbmxpbmUpIHtcbiAgICAgIHRyeSB7XG4gICAgICAgIHlpZWxkIGNwcyh0cmFja0xvZ2luLCBgJHtwcm92aWRlcn0tbG9naW5gLCBnZXRUcmFja2luZ1R5cGUoaXNNb2RhbCwgaXNJbmxpbmUpKTtcbiAgICAgIH0gY2F0Y2ggKGUpIHtcbiAgICAgICAgY29uc29sZS5sb2coYFRyYWNraW5nICR7cHJvdmlkZXJ9IExvZ2luIGVycm9yYCwgZS5tZXNzYWdlKTsgLy8gZXNsaW50LWRpc2FibGUtbGluZSBuby1jb25zb2xlXG4gICAgICB9XG4gICAgICB5aWVsZCBjYWxsKGFwaS5vYXV0aFNpZ25JbiwgcHJvdmlkZXIsIGluZm8pO1xuICAgICAgcmV0dXJuO1xuICAgIH1cblxuICAgIHlpZWxkIGNhbGwodHJhY2tMb2dpbiwgYCR7cHJvdmlkZXJ9LWxvZ2luYCwgZ2V0VHJhY2tpbmdUeXBlKGlzTW9kYWwsIGlzSW5saW5lKSk7XG4gICAgeWllbGQgY2FsbChhcGkub2F1dGhTaWduSW4sIHByb3ZpZGVyLCBpbmZvKTtcbiAgICB5aWVsZCBwdXQoYWN0aW9ucy5zdWNjZXNzT2F1dGhTaWduSW4oKSk7XG4gIH0gY2F0Y2ggKGUpIHtcbiAgICBpZiAoZS5uZWVkc1Bvc2l0aW9uKSB7XG4gICAgICAvKiBDb21lcyBvdXQgb2YgdGhlIGNsb3NlLW1vZGFsIG1lc3NhZ2UgaWYgd2UgJ3JlZ2lzdGVyJyBpbiB0aGUgc2lnbi1pbiBtb2RhbCAqL1xuICAgICAgeWllbGQgcHV0KGFjdGlvbnMuc2V0Rm9ybVR5cGUoJ2xvZ2dlZC1pbi1zZWxlY3QnKSk7XG4gICAgICByZXR1cm47XG4gICAgfVxuXG4gICAgY29uc3QgZXJyb3JDb2RlID0gZS5tZXNzYWdlO1xuICAgIGNvbnN0IGVycm9ycyA9IGVycm9yTWVzc2FnZXMoZXJyb3JDb2RlKTtcbiAgICB5aWVsZCBwdXQoYWN0aW9ucy52YWxpZGF0aW9uRXJyb3JzKGVycm9ycykpO1xuICAgIHlpZWxkIHB1dChhY3Rpb25zLmZhaWxPYXV0aFNpZ25JbihlcnJvcnMpKTtcbiAgfVxufVxuXG5leHBvcnQgZnVuY3Rpb24qIGluaXRGb3Jnb3RQYXNzd29yZCgpIHtcbiAgeWllbGQgcHV0KGFjdGlvbnMucmVzZXRFcnJvcnMoKSk7XG4gIGNvbnN0IGlzSW5saW5lID0geWllbGQgc2VsZWN0KGdldElzSW5saW5lKTtcbiAgY29uc3QgaXNNb2RhbCA9IHlpZWxkIHNlbGVjdChnZXRJc01vZGFsKTtcblxuICB0cnkge1xuICAgIHlpZWxkIGNwcyh0cmFja0ZvcmdvdFBhc3N3b3JkLCBnZXRUcmFja2luZ1R5cGUoaXNNb2RhbCwgaXNJbmxpbmUpKTtcbiAgfSBjYXRjaCAoZSkge1xuICAgIGNvbnNvbGUubG9nKCdUcmFja2luZyBmb3Jnb3QgcGFzc3dvcmQgZXJyb3InLCBlLm1lc3NhZ2UpOyAvLyBlc2xpbnQtZGlzYWJsZS1saW5lIG5vLWNvbnNvbGVcbiAgfVxuXG4gIHRyeSB7XG4gICAgY29uc3QgaW5mbyA9IHlpZWxkIHNlbGVjdChnZXRGb3Jnb3RQYXNzd29yZERhdGEpO1xuICAgIHlpZWxkIGNhbGwoYXBpLmZvcmdvdFBhc3N3b3JkLCBpbmZvKTtcbiAgICB5aWVsZCBwdXQoYWN0aW9ucy5zZW50Rm9yZ290UGFzc3dvcmQoKSk7XG4gICAgeWllbGQgcHV0KGFjdGlvbnMuc2V0RmllbGQoJ2ZvcmdvdFBhc3N3b3JkJywgJ2lkZW50aWZpY2F0aW9uJywgJycpKTtcbiAgfSBjYXRjaCAoZSkge1xuICAgIGNvbnN0IGVycm9yQ29kZSA9IGZvcmdvdFBhc3N3b3JkRGVuaWVkKGUpIHx8IGdldEVycm9yQ29kZShlLCAnZm9yZ290LXBhc3N3b3JkJyk7XG4gICAgY29uc3QgZXJyb3JzID0gZXJyb3JNZXNzYWdlcyhlcnJvckNvZGUpO1xuICAgIHlpZWxkIHB1dChhY3Rpb25zLnZhbGlkYXRpb25FcnJvcnMoZXJyb3JzKSk7XG4gICAgeWllbGQgcHV0KGFjdGlvbnMuZmFpbEZvcmdvdFBhc3N3b3JkKGVycm9ycykpO1xuICB9XG59XG5cbmV4cG9ydCBmdW5jdGlvbiogc3VjY2Vzc1NpZ25JbigpIHtcbiAgY29uc3Qgb25TdWNjZXNzID0geWllbGQgc2VsZWN0KGdldE9uU3VjY2Vzcyk7XG4gIGlmIChvblN1Y2Nlc3MgPT09ICdyZWxvYWQnKSB7XG4gICAgY29uc3QgcmVnSW5mbyA9IHlpZWxkIHNlbGVjdChnZXRSZWdpc3RyYXRpb25EYXRhKTtcbiAgICBjb25zdCByZWxvYWRVUkwgPSB5aWVsZCBzZWxlY3QoZ2V0UmVsb2FkVVJMLCByZWdJbmZvKTtcbiAgICB5aWVsZCBjYWxsKGFwaS5yZWxvYWQsIHJlbG9hZFVSTCk7XG4gIH0gZWxzZSB7XG4gICAgeWllbGQgY2FsbChhcGkuY2xvc2VNb2RhbEV2ZW50KTtcbiAgICB5aWVsZCBjYWxsKGFwaS5sb2dnZWRJbkV2ZW50KTtcbiAgICB5aWVsZCBjYWxsKGRlbGF5LCAyMDApO1xuICAgIHlpZWxkIHB1dChhY3Rpb25zLnJlc2V0KCkpO1xuICB9XG59XG5cbmV4cG9ydCBmdW5jdGlvbiogc3VjY2Vzc0ZvcmdvdFBhc3N3b3JkKCkge1xuICB5aWVsZCBwdXQoYWN0aW9ucy5zZXRGaWVsZCgnZm9yZ290UGFzc3dvcmQnLCAnaWRlbnRpZmljYXRpb24nLCAnJykpO1xuICB5aWVsZCBjYWxsKGFwaS5jbG9zZU1vZGFsRXZlbnQpO1xuICB5aWVsZCBjYWxsKGRlbGF5LCAyMDApO1xuICB5aWVsZCBwdXQoYWN0aW9ucy5yZXNldCgpKTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uKiB1cGRhdGVVc2VyRGF0YShhY3Rpb24pIHtcbiAgdHJ5IHtcbiAgICB5aWVsZCBjYWxsKGFwaS51cGRhdGVVc2VyRGF0YSwgYWN0aW9uLmRhdGEpO1xuICAgIHlpZWxkIHB1dChhY3Rpb25zLnN1Y2Nlc3NTaWduSW4oKSk7XG4gIH0gY2F0Y2ggKGUpIHtcbiAgICBjb25zdCBlcnJvckNvZGUgPSBnZXRFcnJvckNvZGUoZSwgJ2VkaXQtYWNjb3VudCcpO1xuICAgIHlpZWxkIHB1dChhY3Rpb25zLnZhbGlkYXRpb25FcnJvcnMoZXJyb3JNZXNzYWdlcyhlcnJvckNvZGUpKSk7XG4gIH1cbn1cblxuZXhwb3J0IGZ1bmN0aW9uKiB2YWxpZGF0ZUZpZWxkKGFjdGlvbikge1xuICB5aWVsZCBjYWxsKGRlbGF5LCAxMjAwKTtcbiAgY29uc3QgdXNlckRhdGEgPSB5aWVsZCBzZWxlY3QoZ2V0UmVnaXN0cmF0aW9uRGF0YSk7XG4gIHRyeSB7XG4gICAgaWYgKGFjdGlvbi5uYW1lID09PSAncmVnaXN0cmF0aW9uLnVzZXJuYW1lJyAmJiB1c2VyRGF0YS51c2VybmFtZSAmJiAhSm9pLnZhbGlkYXRlKHVzZXJEYXRhLnVzZXJuYW1lLCB1c2VyTmFtZVZhbGlkYXRpb24pLmVycm9yKSB7XG4gICAgICBjb25zdCByZXNwb25zZSA9IHlpZWxkIGNhbGwoYXBpLnZlcmlmeVVzZXJuYW1lLCB1c2VyRGF0YS51c2VybmFtZSk7XG4gICAgICBpZiAocmVzcG9uc2UubGVuZ3RoKSB7XG4gICAgICAgIHlpZWxkIHB1dChhY3Rpb25zLnZhbGlkYXRpb25FcnJvcnMoZXJyb3JNZXNzYWdlcygncmVnaXN0cmF0aW9uLnVzZXJuYW1lLmR1cGxpY2F0ZScpKSk7XG4gICAgICB9XG4gICAgfSBlbHNlIGlmIChhY3Rpb24ubmFtZSA9PT0gJ3JlZ2lzdHJhdGlvbi5lbWFpbCcgJiYgdXNlckRhdGEuZW1haWwgJiYgIUpvaS52YWxpZGF0ZSh1c2VyRGF0YS5lbWFpbCwgZW1haWxWYWxpZGF0aW9uKS5lcnJvcikge1xuICAgICAgY29uc3QgcmVzcG9uc2UgPSB5aWVsZCBjYWxsKGFwaS52ZXJpZnlFbWFpbCwgdXNlckRhdGEuZW1haWwpO1xuICAgICAgaWYgKHJlc3BvbnNlLmxlbmd0aCkge1xuICAgICAgICB5aWVsZCBwdXQoYWN0aW9ucy52YWxpZGF0aW9uRXJyb3JzKGVycm9yTWVzc2FnZXMoJ3JlZ2lzdHJhdGlvbi5lbWFpbC5kdXBsaWNhdGUnKSkpO1xuICAgICAgfVxuICAgICAgaWYgKHJlc3BvbnNlLnN1Z2dlc3RlZFVzZXJuYW1lKSB7XG4gICAgICAgIHlpZWxkIHB1dChhY3Rpb25zLnN1Z2dlc3RVc2VyTmFtZShyZXNwb25zZS5zdWdnZXN0ZWRVc2VybmFtZSkpO1xuICAgICAgfVxuICAgIH1cbiAgfSBjYXRjaCAoZSkge1xuICAgIGNvbnNvbGUubG9nKCdFcnJvciB2YWxpZGF0ZSBmaWVsZCcsIGFjdGlvbi5uYW1lLCBlLm1lc3NhZ2UpOyAgLy8gZXNsaW50LWRpc2FibGUtbGluZSBuby1jb25zb2xlXG4gIH1cbn1cblxuZXhwb3J0IGZ1bmN0aW9uKiBzdWdnZXN0VXNlck5hbWUoKSB7XG4gIGNvbnN0IHVzZXJEYXRhID0geWllbGQgc2VsZWN0KGdldFJlZ2lzdHJhdGlvbkRhdGEpO1xuICB0cnkge1xuICAgIGlmICh1c2VyRGF0YS5lbWFpbCAmJiAhSm9pLnZhbGlkYXRlKHVzZXJEYXRhLmVtYWlsLCBlbWFpbFZhbGlkYXRpb24pLmVycm9yKSB7XG4gICAgICBjb25zdCByZXNwb25zZSA9IHlpZWxkIGNhbGwoYXBpLnZlcmlmeUVtYWlsLCB1c2VyRGF0YS5lbWFpbCk7XG4gICAgICBpZiAocmVzcG9uc2Uuc3VnZ2VzdGVkVXNlcm5hbWUpIHtcbiAgICAgICAgeWllbGQgcHV0KGFjdGlvbnMuc3VnZ2VzdFVzZXJOYW1lKHJlc3BvbnNlLnN1Z2dlc3RlZFVzZXJuYW1lKSk7XG4gICAgICB9XG4gICAgfVxuICB9IGNhdGNoIChlKSB7XG4gICAgY29uc29sZS5sb2coJ0Vycm9yIHN1Z2dlc3QgdXNlcm5hbWUnLCBlLm1lc3NhZ2UpOyAgLy8gZXNsaW50LWRpc2FibGUtbGluZSBuby1jb25zb2xlXG4gIH1cbn1cblxuZXhwb3J0IGZ1bmN0aW9uKiBpbml0U2V0Rm9ybVR5cGUoYWN0aW9uKSB7XG4gIGNvbnN0IGlzSW5saW5lID0geWllbGQgc2VsZWN0KGdldElzSW5saW5lKTtcbiAgY29uc3QgaXNNb2RhbCA9IHlpZWxkIHNlbGVjdChnZXRJc01vZGFsKTtcbiAgaWYgKCFpc01vZGFsICYmICFpc0lubGluZSkgcmV0dXJuO1xuXG4gIGNvbnN0IG9sZEZvcm1UeXBlID0geWllbGQgc2VsZWN0KGdldEZvcm1UeXBlKTtcbiAgaWYgKG9sZEZvcm1UeXBlID09PSBhY3Rpb24uZm9ybVR5cGUpIHtcbiAgICByZXR1cm47XG4gIH1cbiAgeWllbGQgcHV0KGFjdGlvbnMuc2V0Rm9ybVR5cGUoYWN0aW9uLmZvcm1UeXBlKSk7XG4gIHlpZWxkIHB1dChhY3Rpb25zLnRyYWNrQ2xpY2soYWN0aW9uLmZvcm1UeXBlKSk7XG4gIHlpZWxkIHB1dChhY3Rpb25zLnRyYWNrRGlzcGxheShhY3Rpb24uZm9ybVR5cGUpKTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uKiBmYWlsU2lnbkluKGFjdGlvbikge1xuICBpZiAoIWFjdGlvbi5lcnJvcnMpIHsgcmV0dXJuOyB9XG4gIGNvbnN0IGZpbHRlcmVkRXJyb3JzID0gT2JqZWN0LmtleXMoYWN0aW9uLmVycm9ycykuZmlsdGVyKChlKSA9PiBlLnN0YXJ0c1dpdGgoJ3NpZ25pbi4nKSB8fCBlLnN0YXJ0c1dpdGgoJ2dlbmVyaWMuZ29vZ2xlYnV0dG9uJykpO1xuXG4gIGlmIChmaWx0ZXJlZEVycm9ycy5sZW5ndGgpIHtcbiAgICBjb25zdCBtc2cgPSB0cmF2ZXJzZU9iamVjdChhY3Rpb24uZXJyb3JzW2ZpbHRlcmVkRXJyb3JzWzBdXSwgJ21zZycpIHx8ICd1bmtub3duIGVycm9yJztcbiAgICBjb25zdCBpZCA9IGZpbHRlcmVkRXJyb3JzWzBdID09PSAnZ2VuZXJpYy5nb29nbGVidXR0b24nID8gJ2dvb2dsZS1sb2dpbi1mYWlsJyA6ICdsb2dpbi1mYWlsJztcbiAgICBjb25zdCBpc0lubGluZSA9IHlpZWxkIHNlbGVjdChnZXRJc0lubGluZSk7XG4gICAgY29uc3QgaXNNb2RhbCA9IHlpZWxkIHNlbGVjdChnZXRJc01vZGFsKTtcbiAgICB5aWVsZCBjYWxsKHRyYWNrRXJyb3IsIGlkLCBtc2csIGdldFRyYWNraW5nVHlwZShpc01vZGFsLCBpc0lubGluZSkpO1xuICB9XG59XG5cbmV4cG9ydCBmdW5jdGlvbiogZmFpbFJlZ2lzdGVyKGFjdGlvbikge1xuICBpZiAoIWFjdGlvbi5lcnJvcnMpIHsgcmV0dXJuOyB9XG4gIGNvbnN0IGZpbHRlcmVkRXJyb3JzID0gT2JqZWN0LmtleXMoYWN0aW9uLmVycm9ycykuZmlsdGVyKChlKSA9PiBlLnN0YXJ0c1dpdGgoJ3JlZ2lzdHJhdGlvbi4nKSk7XG4gIGlmIChmaWx0ZXJlZEVycm9ycy5sZW5ndGgpIHtcbiAgICBjb25zdCBtc2cgPSB0cmF2ZXJzZU9iamVjdChhY3Rpb24uZXJyb3JzW2ZpbHRlcmVkRXJyb3JzWzBdXSwgJ21zZycpIHx8ICd1bmtub3duIGVycm9yJztcbiAgICBjb25zdCBpc0lubGluZSA9IHlpZWxkIHNlbGVjdChnZXRJc0lubGluZSk7XG4gICAgY29uc3QgaXNNb2RhbCA9IHlpZWxkIHNlbGVjdChnZXRJc01vZGFsKTtcbiAgICB5aWVsZCBjYWxsKHRyYWNrRXJyb3IsICdyZWdpc3Rlci1mYWlsJywgbXNnLCBnZXRUcmFja2luZ1R5cGUoaXNNb2RhbCwgaXNJbmxpbmUpKTtcbiAgfVxufVxuXG5leHBvcnQgZnVuY3Rpb24qIHRyYWNrQ2xpY2tTYWdhKGFjdGlvbikge1xuICB5aWVsZCBjYWxsKHRyYWNrQ2xpY2ssIGFjdGlvbi5mb3JtVHlwZSk7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiogdHJhY2tEaXNwbGF5U2FnYShhY3Rpb24pIHtcbiAgY29uc3QgaXNJbmxpbmUgPSB5aWVsZCBzZWxlY3QoZ2V0SXNJbmxpbmUpO1xuICBjb25zdCBpc01vZGFsID0geWllbGQgc2VsZWN0KGdldElzTW9kYWwpO1xuICBjb25zdCB1c2VyVHlwZSA9IHlpZWxkIHNlbGVjdChnZXRVc2VyVHlwZSk7XG5cbiAgY29uc3QgZG9TZWxlY3RVc2VyVHlwZSA9IHlpZWxkIHNlbGVjdChnZXREb1NlbGVjdFVzZXJUeXBlKTtcbiAgaWYgKCFpc0lubGluZSkge1xuICAgIHlpZWxkIGNhbGwodHJhY2tEaXNwbGF5LCBhY3Rpb24uZm9ybVR5cGUsIGdldFRyYWNraW5nVHlwZShpc01vZGFsLCBpc0lubGluZSksIHVzZXJUeXBlLCBkb1NlbGVjdFVzZXJUeXBlKTtcbiAgfVxufVxuXG5mdW5jdGlvbiogdGFrZUxhdGVzdFdpdGhOYW1lKHBhdHRlcm4sIHNhZ2EpIHtcbiAgY29uc3QgdGFzayA9IHlpZWxkIGZvcmsoZnVuY3Rpb24qIG5ld1NhZ2EoKSB7XG4gICAgY29uc3QgbGFzdFRhc2sgPSB7fTtcbiAgICB3aGlsZSAodHJ1ZSkgeyAvLyBlc2xpbnQtZGlzYWJsZS1saW5lIG5vLWNvbnN0YW50LWNvbmRpdGlvblxuICAgICAgY29uc3QgYWN0aW9uID0geWllbGQgdGFrZShwYXR0ZXJuKTtcbiAgICAgIGlmIChhY3Rpb24ubmFtZSBpbiBsYXN0VGFzaykge1xuICAgICAgICAvLyBjYW5jZWwgaXMgbm8tb3AgaWYgdGhlIHRhc2sgaGFzIGFscmVhZHkgdGVybWluYXRlZFxuICAgICAgICB5aWVsZCBjYW5jZWwobGFzdFRhc2tbYWN0aW9uLm5hbWVdKTtcbiAgICAgIH1cbiAgICAgIGxhc3RUYXNrW2FjdGlvbi5uYW1lXSA9IHlpZWxkIGZvcmsoc2FnYSwgYWN0aW9uKTtcbiAgICB9XG4gIH0pO1xuICByZXR1cm4gdGFzaztcbn1cblxuZnVuY3Rpb24gaXNFbWFpbChhY3Rpb24pIHtcbiAgcmV0dXJuIGFjdGlvbi50eXBlID09PSBjb25zdGFudC5WQUxJREFURV9GSUVMRCAmJiBhY3Rpb24ubmFtZSA9PT0gJ3JlZ2lzdHJhdGlvbi5lbWFpbCc7XG59XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uKiByb290U2FnYSgpIHtcbiAgeWllbGQgW1xuICAgIHRha2VFdmVyeShjb25zdGFudC5JTklUX1NJR05fSU4sIGluaXRTaWduSW4pLFxuICAgIHRha2VFdmVyeShjb25zdGFudC5JTklUX1JFR0lTVEVSLCBpbml0UmVnaXN0ZXIpLFxuICAgIHRha2VFdmVyeShjb25zdGFudC5JTklUX09BVVRIX1NJR05fSU4sIGluaXRPYXV0aFNpZ25JbiksXG4gICAgdGFrZUV2ZXJ5KGNvbnN0YW50LklOSVRfRk9SR09UX1BBU1NXT1JELCBpbml0Rm9yZ290UGFzc3dvcmQpLFxuICAgIHRha2VFdmVyeShjb25zdGFudC5TVUNDRVNTX09BVVRIX1NJR05fSU4sIHN1Y2Nlc3NTaWduSW4pLFxuICAgIHRha2VFdmVyeShjb25zdGFudC5TVUNDRVNTX1NJR05fSU4sIHN1Y2Nlc3NTaWduSW4pLFxuICAgIHRha2VFdmVyeShjb25zdGFudC5TVUNDRVNTX1JFR0lTVEVSLCBzdWNjZXNzU2lnbkluKSxcbiAgICB0YWtlRXZlcnkoY29uc3RhbnQuU1VDQ0VTU19GT1JHT1RfUEFTU1dPUkQsIHN1Y2Nlc3NGb3Jnb3RQYXNzd29yZCksXG4gICAgdGFrZUV2ZXJ5KGNvbnN0YW50LlVQREFURV9VU0VSX0RBVEEsIHVwZGF0ZVVzZXJEYXRhKSxcbiAgICB0YWtlRXZlcnkoY29uc3RhbnQuSU5JVF9TRVRfRk9STV9UWVBFLCBpbml0U2V0Rm9ybVR5cGUpLFxuICAgIHRha2VFdmVyeShjb25zdGFudC5GQUlMX1NJR05fSU4sIGZhaWxTaWduSW4pLFxuICAgIHRha2VFdmVyeShjb25zdGFudC5GQUlMX09BVVRIX1NJR05fSU4sIGZhaWxTaWduSW4pLFxuICAgIHRha2VFdmVyeShjb25zdGFudC5GQUlMX1JFR0lTVEVSLCBmYWlsUmVnaXN0ZXIpLFxuICAgIHRha2VFdmVyeShjb25zdGFudC5UUkFDS19DTElDSywgdHJhY2tDbGlja1NhZ2EpLFxuICAgIHRha2VFdmVyeShjb25zdGFudC5UUkFDS19ESVNQTEFZLCB0cmFja0Rpc3BsYXlTYWdhKSxcbiAgICB0YWtlTGF0ZXN0V2l0aE5hbWUoY29uc3RhbnQuVkFMSURBVEVfRklFTEQsIHZhbGlkYXRlRmllbGQpLFxuICAgIHRocm90dGxlKDgwMCwgaXNFbWFpbCwgc3VnZ2VzdFVzZXJOYW1lKSxcbiAgXTtcbn1cbiIsImltcG9ydCB7IGdldFBhZ2VDb250ZXh0IH0gZnJvbSAnLi4vbGliL3RyYWNraW5nJztcbmltcG9ydCB7IGlzVW5kZXIxMyB9IGZyb20gJy4uL2xpYi9kYXRlLWhlbHBlcic7XG5cbmV4cG9ydCBmdW5jdGlvbiBnZXREb1NlbGVjdFVzZXJUeXBlKHN0YXRlKSB7XG4gIHJldHVybiBzdGF0ZS5jb21tb24uZG9TZWxlY3RVc2VyVHlwZTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGdldE9uU3VjY2VzcyhzdGF0ZSkge1xuICByZXR1cm4gc3RhdGUuY29tbW9uLm9uU3VjY2Vzcztcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGdldEZvcm1UeXBlKHN0YXRlKSB7XG4gIHJldHVybiBzdGF0ZS5jb21tb24uZm9ybVR5cGU7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBnZXRJc0lubGluZShzdGF0ZSkge1xuICByZXR1cm4gc3RhdGUuY29tbW9uLmlzSW5saW5lO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gZ2V0SXNNb2RhbChzdGF0ZSkge1xuICByZXR1cm4gc3RhdGUuY29tbW9uLmlzTW9kYWw7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBnZXRVc2VyVHlwZShzdGF0ZSkge1xuICByZXR1cm4gc3RhdGUuY29tbW9uLnVzZXJUeXBlO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gZ2V0Rm9yZ290UGFzc3dvcmREYXRhKHN0YXRlKSB7XG4gIHJldHVybiB7IGVtYWlsOiBzdGF0ZS5mb3Jnb3RQYXNzd29yZC5pZGVudGlmaWNhdGlvbiB9O1xufVxuXG5leHBvcnQgZnVuY3Rpb24gZ2V0UmVsb2FkVVJMKHN0YXRlLCByZWdJbmZvKSB7XG4gIGlmIChyZWdJbmZvLnVzZXJUeXBlID09PSAnc3R1ZGVudCcgJiYgIXJlZ0luZm8uY2xhc3NDb2RlICYmIHJlZ0luZm8uZ3VhcmRpYW5FbWFpbCkge1xuICAgIHJldHVybiBzdGF0ZS5jb21tb24uZ3VhcmRpYW5FbWFpbFJlbG9hZDtcbiAgfVxuICByZXR1cm4gc3RhdGUuY29tbW9uLnJlbG9hZFVSTDtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGdldFNpZ25JbkRhdGEoc3RhdGUpIHtcbiAgY29uc3QgY29tbW9uID0gc3RhdGUuY29tbW9uO1xuICBjb25zdCBzaWduSW4gPSBzdGF0ZS5zaWduSW47XG4gIGNvbnN0IHBhZ2VDb250ZXh0ID0gZ2V0UGFnZUNvbnRleHQoY29tbW9uLnBhZ2VNeiwgY29tbW9uLm92ZXJyaWRlTXopO1xuXG4gIGNvbnN0IGlkZW50aWZpY2F0aW9uID0gc2lnbkluLmlkZW50aWZpY2F0aW9uO1xuICBjb25zdCBwYXNzd29yZCA9IHNpZ25Jbi5wYXNzd29yZDtcbiAgY29uc3QgdHJ1c3RlZENvbXB1dGVyID0gc2lnbkluLnRydXN0ZWRDb21wdXRlcjtcbiAgY29uc3QgYXBwSWQgPSBjb21tb24uYXBwSWQ7XG5cbiAgY29uc3QgcGFnZUlkID0gcGFnZUNvbnRleHQucGFnZUlkO1xuICBjb25zdCBwYWdlVHlwZSA9IHBhZ2VDb250ZXh0LnBhZ2VUeXBlO1xuICBjb25zdCBwYWdlU2VjdGlvbiA9IHBhZ2VDb250ZXh0LnBhZ2VTZWN0aW9uO1xuICBjb25zdCBwYWdlU3ViU2VjdGlvbiA9IHBhZ2VDb250ZXh0LnBhZ2VTdWJTZWN0aW9uO1xuXG4gIGNvbnN0IGRhdGEgPSB7XG4gICAgYXBwSWQsXG4gICAgaWRlbnRpZmljYXRpb24sXG4gICAgcGFzc3dvcmQsXG4gICAgdHJ1c3RlZENvbXB1dGVyLFxuICAgIHBhZ2VJZCxcbiAgICBwYWdlVHlwZSxcbiAgICBwYWdlU2VjdGlvbixcbiAgICBwYWdlU3ViU2VjdGlvbixcbiAgfTtcblxuICByZXR1cm4gZGF0YTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGdldFJlZ2lzdHJhdGlvbkRhdGEoc3RhdGUpIHtcbiAgY29uc3QgY29tbW9uID0gc3RhdGUuY29tbW9uO1xuICBjb25zdCByZWdpc3RlciA9IHN0YXRlLnJlZ2lzdGVyO1xuICBjb25zdCBwYWdlQ29udGV4dCA9IGdldFBhZ2VDb250ZXh0KGNvbW1vbi5wYWdlTXosIGNvbW1vbi5vdmVycmlkZU16KTtcblxuICBjb25zdCBpc01vZGFsID0gY29tbW9uLmlzTW9kYWw7XG4gIGNvbnN0IGlzSW5saW5lID0gY29tbW9uLmlzSW5saW5lO1xuICBjb25zdCBpc1N0dWRlbnQgPSBjb21tb24udXNlclR5cGUgPT09ICdzdHVkZW50JztcblxuICBjb25zdCBoYXNEb0IgPSAhIXJlZ2lzdGVyLmRhdGVPZkJpcnRoO1xuICBjb25zdCB1bmRlcjEzID0gaXNVbmRlcjEzKHJlZ2lzdGVyLmRhdGVPZkJpcnRoKTtcblxuICBjb25zdCBwYWdlSWQgPSBwYWdlQ29udGV4dC5wYWdlSWQ7XG4gIGNvbnN0IHBhZ2VUeXBlID0gcGFnZUNvbnRleHQucGFnZVR5cGU7XG4gIGNvbnN0IHBhZ2VTZWN0aW9uID0gcGFnZUNvbnRleHQucGFnZVNlY3Rpb247XG4gIGNvbnN0IHBhZ2VTdWJTZWN0aW9uID0gcGFnZUNvbnRleHQucGFnZVN1YlNlY3Rpb247XG5cbiAgY29uc3QgZGF0YSA9IHtcbiAgICB1c2VybmFtZTogcmVnaXN0ZXIudXNlcm5hbWUsXG4gICAgZW1haWw6IHJlZ2lzdGVyLmVtYWlsIHx8ICcnLFxuICAgIHBhc3N3b3JkOiByZWdpc3Rlci5wYXNzd29yZCxcbiAgICB1c2VyVHlwZTogY29tbW9uLnVzZXJUeXBlIHx8IG51bGwsXG4gICAgbmV3c2xldHRlcjogaXNTdHVkZW50ID8gZmFsc2UgOiByZWdpc3Rlci5uZXdzbGV0dGVyLFxuICAgIHJlZ1VybDogKCFpc01vZGFsICYmICFpc0lubGluZSkgPyBjb21tb24ucnRuIDogd2luZG93ICYmIHdpbmRvdy5sb2NhdGlvbi5ocmVmLFxuICAgIHBhZ2VJZCxcbiAgICBwYWdlVHlwZSxcbiAgICBwYWdlU2VjdGlvbixcbiAgICBwYWdlU3ViU2VjdGlvbixcbiAgICBhcHBJZDogY29tbW9uLmFwcElkLFxuICB9O1xuXG4gIGRhdGEucG9zaXRpb24gPSBjb21tb24ucG9zaXRpb24gfHwgJyc7XG5cbiAgaWYgKCFjb21tb24ub21pdE5hbWUpIHtcbiAgICBkYXRhLmZpcnN0TmFtZSA9IHJlZ2lzdGVyLmZpcnN0TmFtZTtcbiAgICBkYXRhLmxhc3ROYW1lID0gcmVnaXN0ZXIubGFzdE5hbWU7XG4gIH1cblxuICBpZiAoaXNTdHVkZW50ICYmIGhhc0RvQikge1xuICAgIGRhdGEuZGF0ZU9mQmlydGggPSByZWdpc3Rlci5kYXRlT2ZCaXJ0aDtcbiAgfVxuXG4gIGlmIChpc1N0dWRlbnQgJiYgdW5kZXIxMykge1xuICAgIGRhdGEuY2xhc3NDb2RlID0gcmVnaXN0ZXIuY2xhc3NDb2RlO1xuICAgIGRhdGEuZ3VhcmRpYW5FbWFpbCA9IHJlZ2lzdGVyLmd1YXJkaWFuRW1haWw7XG4gIH1cblxuICByZXR1cm4gZGF0YTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGdldEdvb2dsZVNpZ25JbkRhdGEoc3RhdGUpIHtcbiAgY29uc3QgY29tbW9uID0gc3RhdGUuY29tbW9uO1xuICBjb25zdCByZWdpc3RlciA9IHN0YXRlLnJlZ2lzdGVyO1xuICBjb25zdCBwYWdlQ29udGV4dCA9IGdldFBhZ2VDb250ZXh0KGNvbW1vbi5wYWdlTXosIGNvbW1vbi5vdmVycmlkZU16KTtcblxuICBjb25zdCBpc1N0dWRlbnQgPSBjb21tb24udXNlclR5cGUgPT09ICdzdHVkZW50JztcbiAgY29uc3QgaXNNb2RhbCA9IGNvbW1vbi5pc01vZGFsO1xuICBjb25zdCBpc0lubGluZSA9IGNvbW1vbi5pc0lubGluZTtcblxuICBjb25zdCBwYWdlSWQgPSBwYWdlQ29udGV4dC5wYWdlSWQ7XG4gIGNvbnN0IHBhZ2VUeXBlID0gcGFnZUNvbnRleHQucGFnZVR5cGU7XG4gIGNvbnN0IHBhZ2VTZWN0aW9uID0gcGFnZUNvbnRleHQucGFnZVNlY3Rpb247XG4gIGNvbnN0IHBhZ2VTdWJTZWN0aW9uID0gcGFnZUNvbnRleHQucGFnZVN1YlNlY3Rpb247XG4gIGxldCByZWdVcmw7XG4gIGlmIChjb21tb24ucmVnVXJsKSB7XG4gICAgcmVnVXJsID0gY29tbW9uLnJlZ1VybDtcbiAgfSBlbHNlIGlmICghaXNNb2RhbCAmJiAhaXNJbmxpbmUpIHtcbiAgICByZWdVcmwgPSBjb21tb24ucnRuO1xuICB9IGVsc2Uge1xuICAgIHJlZ1VybCA9IHdpbmRvdyAmJiB3aW5kb3cubG9jYXRpb24uaHJlZjtcbiAgfVxuXG4gIGNvbnN0IGRhdGEgPSB7XG4gICAgaXNNb2RhbDogaXNNb2RhbCB8fCBpc0lubGluZSxcbiAgICB1c2VyVHlwZTogY29tbW9uLnVzZXJUeXBlLFxuICAgIG5ld3NsZXR0ZXI6IGlzU3R1ZGVudCA/IGZhbHNlIDogcmVnaXN0ZXIubmV3c2xldHRlcixcbiAgICByZWdVcmwsXG4gICAgYXBwSWQ6IGNvbW1vbi5hcHBJZCxcbiAgICBwYWdlSWQsXG4gICAgcGFnZVR5cGUsXG4gICAgcGFnZVNlY3Rpb24sXG4gICAgcGFnZVN1YlNlY3Rpb24sXG4gICAgdHJ1c3RlZENvbXB1dGVyOiBzdGF0ZS5zaWduSW4udHJ1c3RlZENvbXB1dGVyLFxuICAgIHJ0bjogKGlzTW9kYWwgfHwgaXNJbmxpbmUpID8gJy9vYXV0aC9jbG9zZS1tb2RhbCcgOiBjb21tb24ucnRuIHx8IHdpbmRvdy5sb2NhdGlvbi5ocmVmLFxuICB9O1xuXG4gIGRhdGEucG9zaXRpb24gPSBjb21tb24ucG9zaXRpb24gfHwgJyc7XG5cbiAgcmV0dXJuIGRhdGE7XG59XG4iLCIvLyBwb2x5ZmlsbHNcbmltcG9ydCAnaW1hLmpzLWJhYmVsNi1wb2x5ZmlsbCc7XG5pbXBvcnQgYXNzaWduUG9seWZpbGwgZnJvbSAnZXM2LW9iamVjdC1hc3NpZ24nO1xuaW1wb3J0ICdzdHJpbmcucHJvdG90eXBlLnN0YXJ0c3dpdGgnO1xuXG5pbXBvcnQgY3JlYXRlU2FnYU1pZGRsZXdhcmUgZnJvbSAncmVkdXgtc2FnYSc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IFJlYWN0RE9NIGZyb20gJ3JlYWN0LWRvbSc7XG5pbXBvcnQgeyBQcm92aWRlciB9IGZyb20gJ3JlYWN0LXJlZHV4JztcbmltcG9ydCB7IGNyZWF0ZVN0b3JlLCBhcHBseU1pZGRsZXdhcmUsIGNvbXBvc2UgfSBmcm9tICdyZWR1eCc7XG5pbXBvcnQgcmVkdWNlciBmcm9tICcuLi9yZWR1Y2Vycyc7XG5pbXBvcnQgQXBwIGZyb20gJy4uL2NvbXBvbmVudHMvQXBwJztcbmltcG9ydCBzYWdhcyBmcm9tICcuLi9zYWdhcyc7XG5pbXBvcnQgKiBhcyBhY3Rpb25zIGZyb20gJy4uL3JlZHVjZXJzL2FjdGlvbnMnO1xuaW1wb3J0IHsgZ2V0Rm9ybVR5cGUgfSBmcm9tICcuLi9zYWdhcy91dGlscyc7XG5cbmNvbnN0IGV2ZW50cyA9IHdpbmRvdy5URVMuZXZlbnRzO1xuXG5hc3NpZ25Qb2x5ZmlsbC5wb2x5ZmlsbCgpO1xuXG5jb25zdCBtb3VudFBvaW50Q2xzID0gJ2FwcC1hdXRoLW1vdW50cG9pbnQnO1xuY29uc3QgbW91bnRQb2ludCA9IGAuJHttb3VudFBvaW50Q2xzfWA7XG5cbmNvbnN0IGJvb3RzdHJhcCA9ICgpID0+IHtcbiAgY29uc3Qgc2FnYU1pZGRsZXdhcmUgPSBjcmVhdGVTYWdhTWlkZGxld2FyZSgpO1xuXG4gIGNvbnN0IG1vdW50RWxlbWVudCA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IobW91bnRQb2ludCk7XG4gIG1vdW50RWxlbWVudC5jbGFzc05hbWUgPSBgJHttb3VudFBvaW50Q2xzfS1sb2FkZWRgO1xuICBjb25zdCBpbml0aWFsU3RhdGUgPSBKU09OLnBhcnNlKG1vdW50RWxlbWVudC5nZXRBdHRyaWJ1dGUoJ2RhdGEtaW5pdC1zdGF0ZScpKTtcblxuICBjb25zdCBlbmhhbmNlciA9IGNvbXBvc2UoXG4gICAgYXBwbHlNaWRkbGV3YXJlKHNhZ2FNaWRkbGV3YXJlKVxuICApO1xuXG4gIGNvbnN0IHN0b3JlID0gY3JlYXRlU3RvcmUoXG4gICAgcmVkdWNlcixcbiAgICBpbml0aWFsU3RhdGUsXG4gICAgZW5oYW5jZXJcbiAgKTtcbiAgLy8gdGhlbiBydW4gdGhlIHNhZ2FcbiAgc2FnYU1pZGRsZXdhcmUucnVuKHNhZ2FzKTtcblxuICBjb25zdCBhcHAgPSBSZWFjdC5jcmVhdGVFbGVtZW50KEFwcCk7XG4gIGNvbnN0IHByb3ZpZGVyID0gUmVhY3QuY3JlYXRlRWxlbWVudChQcm92aWRlciwgeyBzdG9yZSB9LCBhcHApO1xuXG4gIFJlYWN0RE9NLnJlbmRlcihwcm92aWRlciwgbW91bnRFbGVtZW50KTtcblxuICBldmVudHMub24oJ21vZGFsLXN3aXRjaCcsIChldmVudFR5cGUsIGRhdGEpID0+IHtcbiAgICBpZiAoZGF0YS5hcHBJZCA9PT0gJ2F1dGhhcHAnKSB7XG4gICAgICBzdG9yZS5kaXNwYXRjaChhY3Rpb25zLmluaXRTZXRGb3JtVHlwZShkYXRhLm1zZykpO1xuICAgIH1cbiAgfSk7XG4gIC8vIC8vIHRoaXMgc2VuZHMgYW4gZXZlbnQgb25seSB3aGVuIEkgYW0gTk9UIGNoYW5naW5nIHRoZSBmb3JtIHR5cGVcbiAgZXZlbnRzLm9uKC9tb2RhbC0oc3dpdGNofGluaXQpLywgKGV2ZW50VHlwZSwgZGF0YSkgPT4ge1xuICAgIGNvbnN0IGZvcm0gPSBkYXRhLm1zZztcbiAgICBpZiAoZGF0YS5hcHBJZCA9PT0gJ2F1dGhhcHAnICYmIGZvcm0gPT09IGdldEZvcm1UeXBlKHN0b3JlLmdldFN0YXRlKCkpKSB7XG4gICAgICBzdG9yZS5kaXNwYXRjaChhY3Rpb25zLnRyYWNrQ2xpY2soZm9ybSkpO1xuICAgIH1cbiAgfSk7XG59O1xuXG5pZiAoZG9jdW1lbnQucXVlcnlTZWxlY3Rvcihtb3VudFBvaW50KSkge1xuICBib290c3RyYXAoKTsgLy8gcGFnZSBpbml0XG59IGVsc2Uge1xuICBldmVudHMub25lKCdtb2RhbC1pbml0JywgYm9vdHN0cmFwKTsgLy8gbW9kYWwgaW5pdFxufVxuIl19
